// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23212529%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAASABIAAD/4QBMRXhpZgAATU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAKqADAAQAAAABAAAAKgAAAAD/7QA4UGhvdG9zaG9wIDMuMAA4QklNBAQAAAAAAAA4QklNBCUAAAAAABDUHYzZjwCyBOmACZjs+EJ+/8AAEQgAKgAqAwEiAAIRAQMRAf/EAB8AAAEFAQEBAQEBAAAAAAAAAAABAgMEBQYHCAkKC//EALUQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+v/EAB8BAAMBAQEBAQEBAQEAAAAAAAABAgMEBQYHCAkKC//EALURAAIBAgQEAwQHBQQEAAECdwABAgMRBAUhMQYSQVEHYXETIjKBCBRCkaGxwQkjM1LwFWJy0QoWJDThJfEXGBkaJicoKSo1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoKDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uLj5OXm5+jp6vLz9PX29/j5+v/bAEMAAQEBAQEBAgEBAgMCAgIDBAMDAwMEBQQEBAQEBQYFBQUFBQUGBgYGBgYGBgcHBwcHBwgICAgICQkJCQkJCQkJCf/bAEMBAQEBAgICBAICBAkGBQYJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCf/dAAQAA//aAAwDAQACEQMRAD8A/v4ooooAKKK8S+Lv7R/wO+A11pVj8XfElroc2ty+TZxzb2aQ5ALERqxSMEgNI+1Fzywruy7LMTjKyw+EpynN7Rim27auyV3otThzLNMNg6LxGMqRhBbyk1FK+iu3ZavQ9tooorhO4//Q/v4r83fi5/wUj8A/Av8Aatj/AGcvifodzpelSQ27/wDCRSygQB7lAyt5OzJt1J8t5hJ8rqwKYUmv0ir5A/bI/Y6+H37X/wAOW8NeIQtjrlirvpOqquZLaUjlW6F4XIAkTPPDDDAGvvfDetkMcyVPiSnKVCaceaLadNu1qiS+Ll/ld1Z3s7JP4HxJoZ/LLHV4aqRjiINS5ZJNVEr3ptv4ebpJWaatdJtqp+2D+2l8NP2S/hqvivVZY9U1nVIz/Y+mxSDddNjiQsM7YFyC8mPZcsQK/KT9jz9kH4m/tsfEz/hsv9sV5LjSbiRZtM06UFFvFQ5iAjP+rsY/4E6zck5Ukve/ZL/4JP8AxLvfiRH4v/bMdbvSfDQS10zTPtYvEvEgJ8rcwZvLs06rCdrMThkVch/6EoIILWBLW1RY4o1CoigBVUDAAA4AA6Cv2bPuKcn4KwVTJ+E66r4qqrVMStowe1Olq7Nq3NJPfre3J+LZBwrnHG+Np5xxbQdDC0nelhnvKa3qVdFdJ35YtbdLN88tFFFfy4f1Of/R/v4ooooAKKKKACiiigD/2Q==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 16 16%27 fill=%27none%27><path d=%27M8 2.00004H3.33333C2.97971 2.00004 2.64057 2.14052 2.39052 2.39056C2.14048 2.64061 2 2.97975 2 3.33337V12.6667C2 13.0203 2.14048 13.3595 2.39052 13.6095C2.64057 13.8596 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8596 13.6095 13.6095C13.8595 13.3595 14 13.0203 14 12.6667V8.00004M12.2501 1.75003C12.5153 1.48481 12.875 1.33582 13.2501 1.33582C13.6251 1.33582 13.9848 1.48481 14.2501 1.75003C14.5153 2.01525 14.6643 2.37496 14.6643 2.75003C14.6643 3.1251 14.5153 3.48481 14.2501 3.75003L8.2414 9.75936C8.0831 9.91753 7.88753 10.0333 7.67273 10.096L5.7574 10.656C5.70003 10.6728 5.63922 10.6738 5.58134 10.6589C5.52345 10.6441 5.47061 10.614 5.42836 10.5717C5.38611 10.5295 5.35599 10.4766 5.34116 10.4188C5.32633 10.3609 5.32733 10.3001 5.34406 10.2427L5.90406 8.32736C5.96708 8.11273 6.08309 7.9174 6.2414 7.75936L12.2501 1.75003Z%27 stroke=%27%2324252D%27 stroke-width=%271.2%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Montserrat", sans-serif;
  font-size: 13px;
  color: #000000;
  background: #fff;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body .btn-primary {
  min-width: 125px;
  padding: 0 20px;
  height: 38px;
  border-radius: 3px;
  border: none;
  color: #fff;
  font-weight: normal;
  font-size: 13px;
}

.form-control.input-item {
  background-color: #F3F5F7;
  border-radius: 8px;
  height: 39px;
  border: none;
  font-size: 12px;
}

.form-control.textarea-item {
  background-color: #F3F5F7;
  border-radius: 8px;
  border: none;
  font-size: 12px;
}

.form-select.select-item {
  background-color: #F3F5F7;
  border-radius: 8px;
  height: 39px;
  border: none;
  font-size: 12px;
}

.react-multi-select .react-select-2-option__control:not(.react-select-2-option__control--is-focused):not(.react-select-2-option__control--is-disabled) {
  background-color: #F3F5F7;
  border-radius: 8px;
  min-height: 39px;
  border: none;
  font-size: 12px;
}

.form-input-wrap .form-label {
  font-weight: 600;
  line-height: 15.5px;
  margin-bottom: 10px;
}

.form-input-wrap {
  margin-bottom: 15px;
}

.form-control.input-item:disabled {
  color: #000;
}

body .btn {
  border-radius: 7px;
  min-width: 110px;
  padding: 0 20px;
  font-size: 13px;
  height: 39px;
}
body .btn.btn-sm {
  border-radius: 5px;
}

body .btn-sm {
  height: 30px;
}

.link-btn {
  line-height: 39px;
}

.link-btn-sm {
  line-height: 30px;
}

.white-border-btn {
  color: #fff;
}

.white-border-btn:hover {
  color: #fff;
}

.border-btn {
  border: 1px solid #fff;
}

.border-btn:hover {
  border: 1px solid #fff;
}

.primary-text {
  color: #1A73E8 !important;
  font-weight: 600;
}

.grey-border-btn {
  border: 1px solid #cccdce;
  color: #000;
}

.grey-border-btn.btn:disabled {
  border: 1px solid #cccdce;
  opacity: 0.5;
}

.btn svg {
  margin-right: 5px;
  position: relative;
  top: -2px;
}

.grey-border-btn {
  border: 1px solid #d7e0e9;
}

.grey-border-btn:hover {
  border: 1px solid #d7e0e9;
  color: #000;
}

.white-btn {
  background: #fff;
  color: #000;
}

.white-btn:hover {
  background: #fff;
  color: #000;
}

.double-btn .btn {
  margin-left: 13px;
}

.double-btn .btn:first-child {
  margin-left: 0;
}

.form-control.input-item:focus {
  box-shadow: none;
}

.btn-check:focus + .btn-primary,
.btn-primary:focus {
  box-shadow: none;
}

label.btn {
  height: 39px;
  line-height: 39px;
}

.p-relative {
  position: relative;
}

.p-l-0 {
  padding-left: 0 !important;
}

.p-r-0 {
  padding-right: 0 !important;
}

.m-b-10 {
  margin-bottom: 10px;
}

.m-b-15 {
  margin-bottom: 15px;
}

.m-b-20 {
  margin-bottom: 20px;
}

.m-b-25 {
  margin-bottom: 25px;
}

.m-b-30 {
  margin-bottom: 30px;
}

.m-b-40 {
  margin-bottom: 40px;
}

.m-b-50 {
  margin-bottom: 50px;
}

.m-b-60 {
  margin-bottom: 60px;
}

.m-t-10 {
  margin-top: 10px;
}

.m-t-15 {
  margin-top: 15px;
}

.m-t-20 {
  margin-top: 20px;
}

.m-t-30 {
  margin-top: 30px;
}

.m-t-40 {
  margin-top: 40px;
}

.m-t-50 {
  margin-top: 50px;
}

.p-15 {
  padding: 15px;
}

.p-20 {
  padding: 20px;
}

.p-25 {
  padding: 25px;
}

.p-30 {
  padding: 30px;
}

.primary-color {
  color: #1A73E8;
}

.primary-bg {
  background: #1A73E8;
}

.btn-primary img {
  margin-right: 5px;
}

.sec-sub-head {
  font-weight: 600;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: -0.02em;
}

.right-border {
  border-right: 1px solid #d9d9d9;
}

.left-border {
  border-left: 1px solid #d9d9d9;
}

.top-border {
  border-top: 1px solid #d9d9d9;
}

.bottom-border {
  border-bottom: 1px solid #d9d9d9;
}

.m-b-25 {
  margin-bottom: 25px;
}

.whitebox {
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.09);
  border-radius: 15px;
}

.padding-box {
  padding: 15px;
}

body .btn-check:focus + .btn, body .btn:focus {
  outline: 0;
  box-shadow: none;
}

body .btn:hover {
  opacity: 0.8;
}

.text-left {
  text-align: left;
}

.loader-middle-align {
  display: flex;
  min-height: 20vh;
  align-items: center;
  justify-content: center;
}

.common-modal.header-no-text .modal-header {
  padding: 0 0 7px;
  border: none;
  padding: 0;
}

.results-tab-wrap .tab-content-wrap {
  min-height: calc(100vh - 120px);
}

.scrollarea-content {
  padding-right: 10px;
}

body .tooltip > div.tooltip-inner {
  background-color: #d2d5db !important;
  color: #333;
}

.bs-tooltip-bottom .tooltip-arrow::before {
  border-bottom-color: #d2d5db !important;
}

body .bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #d2d5db !important;
}

body .tippy-box {
  font-size: 12px;
}

.no-fixed-height {
  height: auto;
}

.p-10 {
  padding: 10px;
}

.column-title-link[href]:hover, .column-title:hover {
  color: #1A73E8 !important;
}

.file-uploaded-text {
  word-break: break-all;
}

.full-width-container {
  max-width: 100% !important;
  padding: 0 15px;
}

@media (max-width: 767px) {
  .container {
    padding-left: 15px;
    padding-right: 15px;
  }
  .tooltip-arrow {
    display: none !important;
  }
  .bs-tooltip-top {
    display: none !important;
  }
}
.page-main-wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

.page-contents {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.auth-page-wrap .container {
  max-width: 1140px;
}

.auth-left {
  width: 584px;
  background-color: #1a73e8;
  height: 612px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
  padding-bottom: 76px;
  position: relative;
  border-radius: 15px 0 0 15px;
}

.auth-page-wrap {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: #f3f5f7;
  padding: 38px;
}

.auth-container {
  background: #fff;
  border-radius: 15px;
}

.auth-right {
  flex: 1;
  padding: 50px 62px;
}

.sec-title {
  font-size: 28px;
  font-weight: 600;
  line-height: 26px;
}

.forgot-pwd-link a {
  color: #000000;
  font-weight: 600;
  text-decoration: none;
}

a.btn-primary {
  text-decoration: none;
}

.auth-logo-wrap {
  position: absolute;
  left: 45px;
  top: 45px;
}

.already-have-link {
  font-size: 12px;
}

.already-have-link a {
  font-weight: 700;
  text-decoration: none;
  font-size: 13px;
}

.auth-logo-wrap img, .signup-logo-wrap img {
  max-height: 30px;
}

@media (max-width: 1200px) {
  .auth-left {
    width: 50%;
  }
}
@media (max-width: 991px) {
  .auth-left {
    height: 500px;
  }
  .auth-right {
    padding: 20px;
  }
  .auth-signin-img {
    text-align: center;
  }
  .auth-signin-img img {
    max-width: 80%;
  }
  .auth-page-wrap {
    display: flex;
    align-items: center;
  }
  .auth-container {
    flex-wrap: wrap;
    border-radius: 20px;
  }
  .auth-right {
    width: 100%;
    flex: auto;
    padding: 20px;
  }
  .auth-signin-img {
    display: none;
  }
  .auth-left {
    width: 100%;
    border-radius: 20px 20px 0 0;
    background-image: none !important;
    background-color: #1A73E8;
    height: 60px;
    padding: 0;
  }
  .auth-logo-wrap {
    top: 15px;
    right: 45px;
    text-align: center;
  }
  .auth-logo-wrap img {
    max-height: 30px;
  }
  .auth-page-wrap {
    padding: 20px 10px;
  }
  .sec-title {
    font-size: 20px;
    margin-bottom: 20px;
  }
}
.auth-signup-left {
  width: 358px;
  background: #1A73E8;
  padding: 48px 40px;
  background-position: center;
  background-repeat: no-repeat;
}

.auth-signup-left .btn-outline-primary.upload-btn {
  color: white;
}

.auth-signup-right {
  flex: 1;
  padding: 48px 62px;
}

.auth-signup-right .form-input-wrap {
  margin-bottom: 25px;
}

.signup-page-wrap {
  position: inherit;
}

.btn-outline-primary.upload-btn {
  font-weight: 500;
  font-size: 12px;
  border: 2px solid #f3f5f7;
  border-radius: 3px;
  padding: 0 15px;
  height: 39px;
}

.btn-outline-primary.upload-btn img {
  margin-right: 8px;
}

.or-text {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 24px;
  padding: 15px 10px 0;
}

label.btn.upload-btn {
  line-height: 34px;
}

.box {
  display: inline-block;
  padding: 10px;
  box-sizing: border-box;
}

.img-preview {
  overflow: hidden;
}

button.btn.btn-white-outline.m-t-20 {
  border: 2px solid #e3e3e3;
  font-size: 13px;
  color: #fff;
  padding: 0 17px;
  line-height: 35px;
}

.profile-img {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  margin-top: 97px;
}

#fileUpload::-webkit-file-upload-button {
  display: none;
}

.upload-file-input {
  position: absolute;
  bottom: 6px;
  color: #1A73E8;
  font-size: 11px;
}

.btn-outline-primary.upload-btn:hover {
  border: 2px solid #cbcbcb;
  background: #f3f5f7;
  color: #1A73E8;
}

.croped-img-wrap img {
  width: 140px !important;
  height: 140px;
  border-radius: 50%;
  min-width: 140px;
  max-height: 140px;
  padding: 2px;
  margin-top: 20px;
}

.image-crop-area {
  min-height: 200px;
}

.success-content-wrap h3 {
  font-size: 18px;
  font-weight: 600;
  margin-top: 18px;
  margin-bottom: 25px;
}

.eye-show,
.eye-hidden {
  position: absolute;
  right: 13px;
  top: 35px;
  cursor: pointer;
}

.eye-show img,
.eye-hidden img {
  max-width: 20px;
}

.eye-hidden img {
  opacity: 0.6;
}

.eye-icon-inputwrap .form-control.input-item {
  padding-right: 40px;
}

.agree-checkbox-wrap a {
  text-decoration: none;
}

.agree-checkbox-wrap .form-check-input {
  margin-top: 0;
  width: 18px;
  height: 18px;
}

.agree-checkbox-wrap .form-check-label {
  margin-left: 8px;
}

span.supported-file-text {
  display: block;
  position: absolute;
  /* bottom: 0; */
  font-size: 12px;
  color: #555;
}

.infoicon svg {
  width: 16px;
  margin-left: 8px;
  position: relative;
  top: -1px;
}

.infoicon {
  display: inline-block;
}

.infoicon svg path {
  fill: #1A73E8;
}

.file-uploaded-text:empty {
  display: none;
}

.file-uploaded-text {
  font-size: 11px;
  color: green;
  font-weight: 500;
  margin: 0;
  position: relative;
  top: -11px;
}

.resume-remove-icon svg {
  margin-right: 0;
  width: 10px;
}

.resume-remove-icon {
  display: inline-block;
  width: 18px;
  line-height: 14px;
  border-radius: 50%;
  text-align: center;
  height: 18px;
  z-index: 100;
  cursor: pointer;
}

.resume-remove-icon:hover {
  opacity: 0.7;
}

@media (max-width: 991px) {
  .auth-signup-left {
    width: 100%;
    border-radius: 20px 20px 0 0;
    padding: 20px;
  }
  .auth-signup-left .signup-logo-wrap {
    text-align: center;
  }
  .auth-signup-right {
    padding: 20px 20px;
  }
  .profile-img {
    margin-top: 67px;
  }
}
@media (max-width: 767px) {
  .auth-signup-right .form-input-wrap {
    flex-wrap: wrap;
  }
  .or-text {
    width: auto;
    padding: 0;
    font-weight: bold;
    text-align: left;
    height: 20px;
    margin-top: 38px;
    margin-left: 10px;
  }
  .file-upload-container .form-input-wrap {
    flex-wrap: wrap;
  }
  .Linkedinurl {
    width: 100%;
    margin-top: 15px;
  }
  .file-uploaded-text {
    position: absolute;
    top: 68px;
    overflow: hidden;
    max-width: 80%;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.common-modal .modal-content {
  border: none;
  border-radius: 15px;
  outline: 0;
  box-shadow: 0px 50px 50px rgba(0, 0, 0, 0.04);
}

.common-modal .modal-sm.modal-dialog {
  max-width: 390px;
}

.common-modal .modal-dialog .modal-content {
  padding: 25px;
}

.modal.side-popup {
  left: inherit;
  width: auto;
  right: 0;
}

.side-popup .modal-dialog.modal-md {
  width: 540px;
  max-width: inherit;
  margin-top: 20px;
}

.side-popup .modal-dialog.modal-lg {
  width: 720px;
  max-width: inherit;
}

.side-popup .modal-dialog .modal-content {
  min-height: calc(100vh - 50px);
}

.side-popup .modal-header {
  border-bottom: 1px solid #cccdce;
  font-size: 14px;
  padding: 14px 7px 14px;
  justify-content: space-between;
}

.side-popup .modal-header .modal-title {
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  text-transform: capitalize;
}

.side-popup .modal-header .btn-close {
  padding: 0;
  opacity: 1;
  margin: 0;
}

.common-modal .btn-close {
  opacity: 1;
}

.common-modal .modal-body {
  padding: 0;
}

.common-modal .modal-header {
  padding: 0 0 7px;
}

.common-modal.cropModal .modal-header {
  border: none;
}

.common-modal .modal-title {
  font-weight: 600;
  font-size: 18px;
}

.reload-popup.common-modal .modal-sm.modal-dialog {
  max-width: 480px;
}

.reload-popup .upgrade-pop-wrap .upgrade-title {
  max-width: 420px;
}

.reload-popup .upgrade-pop-wrap.no-results .upgrade-title {
  font-size: 18px;
  line-height: 30px;
  margin-bottom: 20px;
}

.reload-popup.common-modal .modal-header {
  border: none;
  position: absolute;
  right: 10px;
  top: 10px;
}

.country-modal-inotext img {
  max-width: 16px;
}

.country-modal-inotext {
  margin-left: 10px;
}

.country-pop-with-toolitip .modal-header {
  position: absolute;
  top: 31px;
  right: 25px;
  z-index: 1000;
  border: none;
}

.country-pop-with-toolitip.common-modal .modal-title {
  border-bottom: 1px solid #cccdce;
  padding-bottom: 7px;
  line-height: 22px;
}

@media (max-width: 767px) {
  .side-popup .modal-dialog.modal-md {
    width: auto;
    max-width: 100%;
    margin-top: 20px;
  }
  .modal.side-popup {
    width: 100%;
  }
  .common-modal .modal-sm.modal-dialog {
    max-width: 100%;
  }
}
.react-select-2-option__option {
  display: flex !important;
  align-items: center;
  border-bottom: 1px solid #d4d7da;
  background: none !important;
  padding-top: 10px;
  padding-bottom: 10px;
}

.react-select-2-option__menu-list div:last-child .react-select-2-option__option {
  border: none;
}

.react-select-2-option__option label {
  margin-left: 10px;
}

.react-select-2-option__option--is-selected label,
.react-select-2-option__option:hover label {
  color: #1A73E8;
}

.header-wrap {
  background: #1A73E8;
  position: relative;
  z-index: 1000;
}

.header-bar {
  padding: 0;
}

.header-bar__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 64px;
  gap: 16px;
}

.header-bar__logo {
  margin: 0;
  flex-shrink: 0;
}
.header-bar__logo img {
  display: block;
  max-height: 28px;
  filter: brightness(0) invert(1);
}

.header-bar__menu {
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: flex-end;
}

.header-bar__links {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: nowrap;
}

.header-bar__link {
  position: relative;
  color: rgba(255, 255, 255, 0.88);
  background: transparent;
  border: none;
  font-family: "Montserrat", sans-serif;
  font-size: 15px;
  font-weight: 500;
  text-decoration: none;
  padding: 10px 12px;
  margin: 0;
  cursor: pointer;
  transition: color 0.15s ease;
}
.header-bar__link:hover {
  color: #FFFFFF;
}
.header-bar__link.is-active, .header-bar__link.active {
  color: #FFFFFF;
  font-weight: 600;
  text-shadow: none;
}
.header-bar__link.is-active::after, .header-bar__link.active::after {
  content: "";
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: 6px;
  height: 2px;
  background: #FFFFFF;
  border-radius: 2px;
}

.header-bar__divider {
  display: inline-block;
  width: 1px;
  height: 24px;
  background: rgba(255, 255, 255, 0.35);
  margin: 0 4px;
  flex-shrink: 0;
}

.header-bar__notif.notification-dropdown.dropdown {
  margin-right: 0;
}

.header-bar__notif .notification-button {
  background: transparent !important;
  border: none !important;
  padding: 6px !important;
  box-shadow: none !important;
  color: #FFFFFF !important;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 0 !important;
  width: auto !important;
  height: auto !important;
}
.header-bar__notif .notification-button::after {
  display: none;
}
.header-bar__notif .notification-button svg {
  stroke: #FFFFFF;
}
.header-bar__notif .noti-count {
  position: absolute;
  top: 0;
  right: 0;
  background: #E11D48;
  color: #FFFFFF;
  font-size: 10px;
  font-weight: 600;
  min-width: 16px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  border-radius: 10px;
  padding: 0 4px;
}

.header-bar__avatar {
  margin-left: 0;
}
.header-bar__avatar .avatar-toggle {
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  box-shadow: none !important;
  min-width: 0 !important;
  width: auto !important;
  height: auto !important;
  line-height: 1 !important;
}
.header-bar__avatar .avatar-toggle::after {
  display: none;
}
.header-bar__avatar .avatar-toggle .user-img {
  display: inline-block;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid rgba(255, 255, 255, 0.6);
  margin: 0;
}
.header-bar__avatar .avatar-toggle .user-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.header-bar__links .dropdown-menu,
.header-bar__avatar .dropdown-menu,
.header-bar__notif .dropdown-menu {
  border: none;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  padding: 8px;
  margin-top: 8px !important;
}

.header-bar__links .dropdown-item,
.header-bar__avatar .dropdown-item {
  font-size: 13px;
  line-height: 1.6;
  padding: 8px 12px;
  border-radius: 6px;
  color: #1A1A1A;
}
.header-bar__links .dropdown-item:hover, .header-bar__links .dropdown-item:focus,
.header-bar__avatar .dropdown-item:hover,
.header-bar__avatar .dropdown-item:focus {
  color: #1A73E8;
  background: #EEF4FF;
}

.header-bar__mobile-actions {
  display: none;
  align-items: center;
  gap: 8px;
}

@media (max-width: 1199.98px) {
  .header-bar__link {
    padding: 10px 10px;
    font-size: 14px;
  }
  .header-bar__inner {
    min-height: 64px;
  }
  .header-bar__logo img {
    max-height: 26px;
  }
  .header-bar__link.is-active::after,
  .header-bar__link.active::after {
    left: 10px;
    right: 10px;
  }
}
@media (min-width: 1025px) {
  .header-bar__links {
    gap: 10px;
  }
}
@media (max-width: 991.98px) and (min-width: 768px) {
  .header-bar__inner {
    gap: 8px;
  }
  .header-bar__links {
    gap: 2px;
  }
  .header-bar__link {
    padding: 8px 8px;
    font-size: 13px;
    white-space: nowrap;
  }
  .header-bar__link.is-active::after,
  .header-bar__link.active::after {
    left: 8px;
    right: 8px;
  }
  .header-bar__divider {
    height: 20px;
    margin: 0 2px;
  }
  .header-bar__notif .notification-button {
    padding: 4px !important;
  }
  .header-bar__avatar .avatar-toggle .user-img {
    width: 32px;
    height: 32px;
  }
  .header-bar__logo img {
    max-height: 22px;
  }
}
@media (min-width: 768px) {
  .header-bar__mobile-actions {
    display: none !important;
  }
  .mobile-menu, .notification-mobile-only {
    display: none !important;
  }
}
@media (max-width: 767.98px) {
  .header-bar__inner {
    min-height: 56px;
  }
  .header-bar__logo img {
    max-height: 24px;
  }
  .header-bar__menu {
    flex: 0 0 auto;
  }
  .mobilemenu-hidden {
    display: none;
  }
  .mobilemenu-active {
    position: absolute;
    top: 56px;
    left: 0;
    right: 0;
    width: 100%;
    background: #1A73E8;
    z-index: 99;
    border-top: 1px solid rgba(255, 255, 255, 0.18);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
    display: block;
    justify-content: flex-start;
    padding: 6px 0;
  }
  .mobilemenu-active .header-bar__links {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    padding: 6px 0;
    gap: 0;
  }
  .mobilemenu-active .header-bar__link {
    width: 100%;
    padding: 14px 20px;
    color: #FFFFFF;
    font-size: 15px;
    text-align: left;
    border-radius: 0;
  }
  .mobilemenu-active .header-bar__link.is-active::after {
    display: none;
  }
  .mobilemenu-active .header-bar__link.is-active {
    background: rgba(255, 255, 255, 0.14);
    font-weight: 600;
  }
  .mobilemenu-active .header-bar__link:hover {
    background: rgba(255, 255, 255, 0.08);
  }
  .mobilemenu-active .header-bar__divider {
    display: block;
    width: auto;
    height: 1px;
    margin: 6px 20px;
    background: rgba(255, 255, 255, 0.22);
  }
  .mobilemenu-active .header-bar__notif,
  .mobilemenu-active .header-bar__avatar {
    display: none;
  }
  .header-bar__mobile-actions {
    display: flex;
  }
  .header-bar__mobile-actions .notification-button {
    background: transparent !important;
    border: none !important;
    padding: 0 6px !important;
    box-shadow: none !important;
  }
  .header-bar__mobile-actions .notification-button::after {
    display: none;
  }
  .header-bar__mobile-actions .notification-button svg {
    stroke: #FFFFFF;
  }
  .header-bar__mobile-actions .mobile-menu {
    background: transparent;
    border: none;
    padding: 4px;
    color: #FFFFFF;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .header-bar__mobile-actions .mobile-menu img {
    max-height: 22px;
    filter: brightness(0) invert(1);
  }
}
@media (min-width: 768px) {
  .header-bar__mobile-profile-link {
    display: none !important;
  }
}

@media (min-width: 768px) {
  .header-bar__divider--mobile-only {
    display: none !important;
  }
}

.header-bar__mobile-logout {
  color: rgba(255, 200, 200, 0.9) !important;
}
.header-bar__mobile-logout:hover {
  color: #fff !important;
}

.footer-content {
  border-top: 1px solid #e3e3e3;
  padding: 30px;
  margin: 0;
}

.footer-content p {
  font-size: 11px;
  line-height: 18px;
  color: #5b5b5b;
}

.nav-tabs .nav-link {
  font-size: 18px;
  background: transparent;
  color: #fff;
  font-weight: 500;
  padding: 5px 15px;
  margin-bottom: 10px;
  border: none;
}

.nav-tabs .nav-link.active {
  color: #fff;
  background-color: transparent;
  border: none;
  position: relative;
  font-weight: 700;
}

.nav-tabs .nav-link.active::after {
  position: absolute;
  left: 0;
  right: 0;
  background: #fff;
  height: 4px;
  content: "";
  bottom: 0;
  border-radius: 20px;
}

.nav-tabs {
  border: none;
}

.nav-tabs .nav-link:hover,
.nav-tabs .nav-link:focus {
  border: none;
}

.results-tab-wrap .nav-tabs .nav-link {
  font-weight: 600;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: -0.02em;
  color: #000000;
}

.results-tab-wrap .nav-tabs {
  justify-content: space-between;
  margin: 0 -15px;
  position: relative;
  background: #fff;
  z-index: 99;
  padding-top: 15px;
}

.results-tab-wrap .nav-tabs::after {
  position: absolute;
  bottom: 0;
  height: 2px;
  background: #D7E0E9;
  content: "";
  left: 15px;
  right: 15px;
}

.results-tab-wrap .tab-content {
  padding-top: 25px;
}

.results-tab-wrap .nav-tabs .nav-link {
  position: relative;
  z-index: 100;
}

.results-tab-wrap .nav-tabs .nav-link.active {
  color: #1A73E8;
}

.results-tab-wrap .nav-tabs .nav-link.active::after {
  position: absolute;
  bottom: -10px;
  height: 2px;
  background: #1A73E8;
  content: "";
  left: 15px;
  right: 15px;
  z-index: 1;
}

#FixedTab.sticky .nav-tabs {
  position: sticky;
  top: 0px;
}

.nav-tabs .nav-link:focus {
  outline: none;
}

.faq-tab-wrap .nav-tabs .nav-link {
  font-weight: 600;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: -0.02em;
  color: #000000;
}

.faq-tab-wrap .nav-tabs {
  margin: 0 -15px;
  position: relative;
  background: #fff;
  z-index: 99;
  padding-top: 15px;
}

.faq-tab-wrap .nav-tabs::after {
  position: absolute;
  bottom: 0;
  height: 2px;
  background: #D7E0E9;
  content: "";
  left: 15px;
  right: 15px;
}

.faq-tab-wrap .tab-content {
  padding-top: 25px;
}

.faq-tab-wrap .nav-tabs .nav-link {
  position: relative;
  z-index: 100;
}

.faq-tab-wrap .nav-tabs .nav-link.active {
  color: #1A73E8;
}

.faq-tab-wrap .nav-tabs .nav-link.active::after {
  position: absolute;
  bottom: -10px;
  height: 2px;
  background: #1A73E8;
  content: "";
  left: 15px;
  right: 15px;
  z-index: 1;
}

@media (min-width: 768px) and (max-width: 991px) {
  .nav-tabs .nav-link {
    padding: 5px 11px;
  }
}
@media (max-width: 767px) {
  .nav-tabs .nav-link {
    font-size: 16px;
  }
  .result-content-area .results-tab-wrap .nav-tabs .nav-link.active::after {
    left: 10px;
    right: 10px;
  }
  .result-content-area .nav-tabs .nav-link {
    font-size: 16px;
    padding: 5px 10px;
  }
}
.datatable-wrap .rdt_TableRow {
  min-height: 60px;
  border-color: #e9e9e9;
}

.checkbox-table.datatable-wrap .rdt_TableRow .rdt_TableCell:first-child,
.checkbox-table.datatable-wrap .rdt_TableHeadRow .rdt_TableCol:first-child {
  min-width: 30px;
  flex: 0 0 30px;
  position: relative;
}

.datatable-wrap .rdt_TableHeadRow {
  background: #e6e9ec;
  font-weight: 600;
  font-size: 15px;
  border: none;
}

.datatable-wrap .rdt_TableCell {
  font-size: 13px;
  color: #000;
  flex-wrap: wrap;
}

.share-icon-cell img {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.datatable-wrap .rdt_TableCell a {
  text-decoration: none;
  color: #1A73E8;
}

.datatable-hedaer-right {
  flex: 1;
}

.table-buttons-wrap {
  padding-right: 150px;
}

.search-svg-wrap {
  position: absolute;
  left: 10px;
  top: 9px;
  pointer-events: none;
}

.search-input-wrap .input-item {
  padding-left: 30px;
}

.checkbox-table.datatable-wrap .rdt_TableHeadRow .rdt_TableCol:first-child input[type=checkbox] {
  width: 16px !important;
  height: 16px !important;
  margin-left: 3px;
}

.checkbox-table.datatable-wrap .rdt_TableRow .rdt_TableCell:first-child input[type=checkbox]::after {
  width: 18px;
  height: 18px;
  content: "";
  position: absolute;
  top: -3px;
  left: -1px;
  border: 2px solid #cccdce;
  pointer-events: none;
  background: #fff;
}

.checkbox-table.datatable-wrap .rdt_TableRow .rdt_TableCell:first-child input[type=checkbox],
.checkbox-table.datatable-wrap .rdt_TableHeadRow .rdt_TableCol:first-child input[type=checkbox] {
  position: relative;
}

.checkbox-table.datatable-wrap .rdt_TableRow .rdt_TableCell:first-child input[type=checkbox]:checked:before {
  content: "";
  display: block;
  position: absolute;
  width: 18px;
  height: 18px;
  top: -3px;
  left: -1px;
  background-color: #1A73E8;
  border-radius: 1px;
}

.checkbox-table.datatable-wrap .rdt_TableRow .rdt_TableCell:first-child input[type=checkbox]:checked:after {
  content: "";
  display: block;
  width: 7px;
  height: 11px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  top: -1px;
  left: 5px;
  background: transparent;
}

.selectall-wrap {
  display: none;
}

@media (max-width: 992px) {
  .table-buttons-wrap {
    padding-right: 30px;
  }
}
@media (max-width: 767px) {
  .datatable-header-area {
    flex-wrap: wrap;
  }
  .datatable-hedaer-right {
    width: 100%;
    flex: auto;
  }
  .table-buttons-wrap {
    margin-left: 0;
    padding-right: 0px;
  }
  .datatable-hedaer-left {
    margin-bottom: 15px;
    justify-content: flex-end;
    width: 100%;
  }
  .results-tab-wrap .tab-content {
    padding-top: 15px;
  }
  .checkbox-table.datatable-wrap .rdt_TableRow .rdt_TableCell:first-child input[type=checkbox]::after {
    top: -2px;
  }
  .checkbox-table.datatable-wrap .rdt_TableRow .rdt_TableCell:first-child input[type=checkbox]:checked:before {
    top: -2px;
  }
}
.datatable-wrap .rdt_Checkbox {
  display: contents;
}

.datatable-wrap .rdt_Checkbox::before,
.datatable-wrap .rdt_Checkbox::after {
  content: none;
}

.datatable-wrap .rdt_Checkbox > input[type=checkbox] {
  position: relative;
  inset: auto;
  width: auto;
  height: auto;
  opacity: 1;
}

.custom-pagination .page-item.active .page-link {
  background-color: #1A73E8;
  border: none;
  color: #fff;
}

.custom-pagination .page-item .page-link {
  border: none;
}

.custom-pagination .paginationStyle {
  border: none;
}

.custom-pagination.pagination-sm .page-link {
  padding: 0;
  font-size: 13px;
  line-height: 24px;
  width: 24px;
  height: 24px;
  text-align: center;
  border-radius: 4px;
  background-color: transparent;
  color: #000;
}

.pagination-sm .page-item:first-child .page-link {
  background-color: #e9e9e9;
  font-size: 20px;
}

.pagination-sm .page-item:last-child .page-link {
  background-color: #e9e9e9;
  font-size: 20px;
}

.pagination-sm .page-item:first-child .page-link span,
.pagination-sm .page-item:last-child .page-link span {
  position: relative;
  top: -1px;
}

.custom-pagination li.page-item {
  padding: 0 10px;
}

.custom-pagination {
  margin: 30px -10px 0;
}

.custom-pagination li.page-item.disabled .page-link,
.custom-pagination .paginationStyle .page-link {
  font-size: 22px;
  line-height: 22px;
  font-weight: bold;
}

.custom-pagination li.page-item.disabled .page-link {
  color: #9c9494;
}

.custom-pagination .page-link:focus {
  box-shadow: none;
}

.react-new-pagination .page-item .page-link {
  border: none;
  font-weight: 500;
  color: #878a8d;
  font-size: 14px;
  height: 32px;
  padding: 0 10px;
  line-height: 30px;
  min-width: 30px;
  text-align: center;
}

.react-new-pagination li.page-item {
  padding: 0 6px;
}

.react-new-pagination .page-item.active .page-link {
  background-color: #1A73E8;
  border: none;
  color: #fff !important;
  border-radius: 4px;
}

.react-new-pagination .page-item.page-item-arrow .page-link {
  font-size: 22px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
  background: #f0f0f0;
  border-radius: 4px !important;
  height: 32px;
  width: 32px;
  padding: 0;
  text-align: center;
  color: #333;
}

.react-new-pagination .page-item.page-item-arrow.disabled .page-link {
  color: #999;
}

.react-new-pagination .page-link:hover {
  border-radius: 4px;
}

.react-new-pagination .page-item:not(:first-child) .page-link {
  margin-left: 0;
}

.page-link:focus {
  box-shadow: none;
  opacity: 0.8;
}

@media (max-width: 767px) {
  .custom-pagination li.page-item {
    padding: 0 3px;
  }
}
.shared-name-wrap {
  flex-wrap: wrap;
}

.shared-name-box {
  border-bottom: 1px solid #ddd;
  width: 100%;
  margin-bottom: 12px;
  padding-bottom: 10px;
  padding-right: 20px;
}

.shared-name-box:last-child {
  margin: 0;
  border: none;
}

.manage-access-popup .country-header-search {
  margin: 0;
  margin-bottom: 20px;
}

.share-title {
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: -0.02em;
  color: #5b5b5b;
}

.b-t-0 {
  border-top: none !important;
}

.shared-remove-btn {
  display: flex;
  align-items: center;
}

.shared-remove-btn span {
  margin-left: 5px;
  color: #5b5b5b;
}

.status-searchontop .pop-checkboxscroll {
  height: 58vh;
}

.status-searchontop .react-select-2-option__menu-list {
  max-height: 162px;
}

.status-searchontop .react-select-2-option__option {
  padding-top: 6px;
  padding-bottom: 6px;
}

.status-searchontop .react-select-2-option__menu {
  margin-top: 2px;
}

@media (max-width: 767px) {
  .shared-remove-btn span {
    display: none;
  }
  .shared-name-box {
    padding-right: 0;
  }
}
.scrollarea > .ps > .ps__rail-y {
  width: 4px;
  right: 0;
  background: none;
  opacity: 0.1;
}

.scrollarea:hover > .ps > .ps__rail-y {
  opacity: 0.3;
}

.scrollarea > .ps > .ps__rail-y:hover,
.scrollarea > .ps > .ps__rail-y.ps--clicking {
  background: gray;
  opacity: 0.6;
}

.scrollarea > .ps > .ps__rail-y > .ps__thumb-y,
.scrollarea > .ps > .ps__rail-y:hover > .ps__thumb-y,
.scrollarea > .ps > .ps__rail-y.ps--clicking > .ps__thumb-y {
  width: 4px;
  right: 0;
  background: #000;
  border-radius: 20px;
}

.pagenot-found .whitebox {
  height: calc(100vh - 305px);
  min-height: 450px;
}

.error-title {
  font-weight: 700;
  font-size: 18px;
  line-height: 25px;
  margin-bottom: 10px;
}

.errorpages-content p {
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  text-align: center;
  color: #5b5b5b;
}

.positioned-backarrow {
  position: absolute;
  left: 30px;
  top: 30px;
}

.link-expired p {
  margin-left: auto;
  margin-right: auto;
  line-height: 24px;
}

.custom-accordian .accordion-item {
  border: none;
  border-bottom: 1px solid #d9d9d9;
  padding: 25px 0;
}

.custom-accordian .accordion-button {
  box-shadow: none;
  background: transparent;
  font-size: 16px;
  padding: 0;
}

.custom-accordian .accordion-button:not(.collapsed) {
  color: #1A73E8;
  background: transparent;
  padding: 0;
  font-size: 16px;
}

.custom-accordian .custom-accordian-header {
  display: flex;
  align-items: flex-start;
}

.custom-accordian h4 {
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  margin: 0;
}

.faq-index {
  margin-right: 0;
  font-weight: bold;
  min-width: 25px;
}

.custom-accordian .accordion-button:focus {
  box-shadow: none;
}

.custom-accordian .accordion {
  padding: 0 25px;
}

.custom-accordian .accordion-body {
  padding: 0 25px;
  margin-top: 15px;
}

.custom-accordian .accordion-button:not(.collapsed)::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.custom-accordian .accordion-item:last-of-type {
  border-radius: 0;
}

.filter-accordian-wrap .accordion-button:hover {
  z-index: 0;
}

@media (max-width: 767px) {
  .custom-accordian .accordion {
    padding: 0;
  }
  .custom-accordian h4 {
    font-size: 14px;
    line-height: 20px;
    padding-right: 5px;
  }
  .custom-accordian .accordion-item {
    padding: 15px 0;
  }
}
.loader {
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}

.loader-3 .dot {
  width: 10px;
  height: 10px;
  background: #1A73E8;
  border-radius: 50%;
  position: absolute;
  top: calc(50% - 5px);
}

.loader-3 .dot1 {
  left: 0px;
  -webkit-animation: dot-jump 0.5s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;
  animation: dot-jump 0.5s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;
}

.loader-3 .dot2 {
  left: 20px;
  -webkit-animation: dot-jump 0.5s 0.2s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;
  animation: dot-jump 0.5s 0.2s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;
}

.loader-3 .dot3 {
  left: 40px;
  -webkit-animation: dot-jump 0.5s 0.4s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;
  animation: dot-jump 0.5s 0.4s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;
}

@-webkit-keyframes dot-jump {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  100% {
    -webkit-transform: translateY(-15px);
    transform: translateY(-15px);
  }
}
@keyframes dot-jump {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  100% {
    -webkit-transform: translateY(-15px);
    transform: translateY(-15px);
  }
}
.homeslider .slick-prev,
.homeslider .slick-next {
  background: #ffffff;
  border: none;
  box-shadow: 0 1px 4px #c1c1c1;
  border-radius: 4px;
  width: 29px;
  height: 31px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0px;
  top: inherit;
  right: 15px;
  transform: none;
}

.homeslider .slick-prev {
  left: inherit;
  right: 55px;
}

.homeslider .slick-prev::before,
.homeslider .slick-next::before {
  display: none;
}

.homeslider .slick-prev.slick-disabled,
.homeslider .slick-next.slick-disabled {
  opacity: 0.5;
  cursor: default;
}

.homeslider {
  padding-bottom: 40px;
}

.hom-secs .multimedia-wrap .homeslider .slick-prev {
  right: 40px;
}

.hom-secs .multimedia-wrap .homeslider .slick-next {
  right: 0px;
}

@media (max-width: 767px) {
  .homeslider .slick-next {
    right: 0;
  }
  .homeslider .slick-prev {
    right: 40px;
  }
}
.notification-dropdown .dropdown-menu {
  width: 390px;
  background-color: #fff;
}

.notification-dropdown .dropdown-menu.show.dropdown-menu-end {
  padding: 10px 0 0;
}

.notification-wrap {
  position: relative;
}

.notification-dropdown .dropdown-menu .notification-wrap::after {
  position: absolute;
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-bottom: 15px solid #fff;
  top: -24px;
  right: 20px;
  content: "";
}

.notification-dropdown .dropdown-menu {
  transform: translate(30px, 61px) !important;
}

.notification-dropdown .dropdown-menu .notification-list {
  padding: 0;
}

.notification-dropdown .dropdown-menu .dropdown-item {
  list-style: none;
  padding: 0 5px;
}

.notification-list .dropdown-item h3 {
  font-size: 13px;
  margin-bottom: 5px;
  font-weight: 500;
  color: #212529;
}

.notification-list h3 .notify-user-name {
  font-weight: 600;
}

.notifi-img-left img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid #fff;
  box-shadow: 0 0 5px #aaa;
}

.notification-content-row {
  padding: 15px;
  border-bottom: 1px solid #ddd;
}

.notifi-content-right {
  padding-left: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.notification-time span {
  color: #5b5b5b;
  font-size: 13px;
  font-weight: 500;
}

.notification-footer {
  text-align: center;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: -0.02em;
  margin-bottom: 0;
  padding-top: 10px;
  box-shadow: 0px -4px 5px #f3f3f3;
  padding-bottom: 10px;
  cursor: pointer;
}

.notification-footer img {
  margin-left: 5px;
}

.notification-scroll {
  max-height: 60vh;
  min-height: 30vh;
}

.notification-dropdown .dropdown-toggle::after {
  display: none;
}

.notification-dropdown.dropdown {
  margin-right: 20px;
}

.unread-notif {
  background-color: #e9f2ff;
}

.read-notify {
  background-color: #fff;
}

.no-item {
  padding: 20px 10px;
  text-align: center;
  color: #777;
  margin-top: -10px;
}

.noti-count {
  background: #1A73E8;
  padding: 2px;
  top: 2px;
  left: 11px;
  position: absolute;
  height: 18px;
  line-height: 14px;
  font-weight: bold;
  color: #fff;
  border-radius: 3px;
  z-index: 9;
  font-size: 12px;
}

.menu-items .dropdown .notification-btn .btn {
  background-color: transparent;
  color: #1A73E8;
  padding: 0 10px;
  height: 20px;
  font-weight: 500;
}

.notification-dropdown .dropdown-menu ul .dropdown-item:last-child .notification-content-row {
  border: none;
}

.notification-btn {
  padding-right: 20px;
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
  text-align: right;
}

.notification-dropdown .dropdown-menu .dropdown-item:hover {
  cursor: pointer;
  background: #e2e8ef;
}

.view-less-arrow {
  transform: rotate(180deg);
  display: inline-block;
  position: relative;
  top: 2px;
  left: 5px;
}

.notification-dropdown .dropdown-menu .notification-scroll .notification-list {
  margin-right: -10px;
}

@media (max-width: 767px) {
  .notification-dropdown .dropdown-menu {
    width: 90%;
    margin: 0 auto 15px;
  }
  .notification-dropdown.dropdown {
    margin-right: 0;
    border: none;
    padding: 0;
  }
  .notification-dropdown .dropdown-menu {
    margin: 0 auto;
    transform: none !important;
    border: 1px solid #ddd !important;
  }
  .notification-dropdown .btn {
    margin-left: 25px;
    position: relative;
  }
  .noti-count {
    top: -10px;
    left: 13px;
    font-weight: 600;
  }
  .notification-mobile-only .notification-dropdown {
    position: inherit;
  }
  .notification-dropdown .dropdown-menu {
    width: 100%;
    box-shadow: 0 0 10px #ddd;
  }
  .notification-dropdown .dropdown-menu.show.dropdown-menu-end {
    top: 45px !important;
  }
  .notification-dropdown .dropdown-menu .notification-wrap::after {
    right: 67px;
  }
  .notification-list .dropdown-item {
    white-space: inherit;
  }
  .notification-mobile-only .notification-dropdown .notification-btn .btn {
    color: #1A73E8;
  }
}
.shimmer-card {
  position: relative;
  -webkit-box-shadow: 0 6px 8px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0px 8px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  border-radius: 6px;
  height: 240px;
  overflow: hidden;
  width: 100%;
  margin-bottom: 15px;
}
.shimmer-card .shimmerBG {
  animation-duration: 2.2s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: shimmer;
  animation-timing-function: linear;
  background: #ddd;
  background: linear-gradient(to right, #f2f2f2 8%, #fcfcfc 18%, #f2f2f2 33%);
  background-size: 1200px 100%;
}
@-webkit-keyframes shimmer {
  0% {
    background-position: -100% 0;
  }
  100% {
    background-position: 100% 0;
  }
}
@keyframes shimmer {
  0% {
    background-position: -1200px 0;
  }
  100% {
    background-position: 1200px 0;
  }
}
.shimmer-card .media {
  height: 200px;
}
.shimmer-card .p-32 {
  padding: 32px;
}
.shimmer-card .title-line {
  height: 24px;
  width: 100%;
  margin-bottom: 12px;
  border-radius: 20px;
}
.shimmer-card .content-line {
  height: 8px;
  width: 100%;
  margin-bottom: 16px;
  border-radius: 8px;
}
.shimmer-card .end {
  width: 40%;
}

.m-t-24 {
  margin-top: 24px;
}

.no-other-reco {
  font-size: 13px;
  color: #727780;
  padding: 0 15px;
  display: block;
  line-height: 34px;
}

.shimmer-card .big-title-line.title-line {
  height: 34px;
}

.shimmerloadingtext .shimmerBG {
  animation: none;
}

.shimmerloadingtext .shimmer-card .shimmerBG {
  background: #e4e7ea;
}

.shimmerloadingtext .shimmer-card {
  border-left: 1px solid #e4e7ea;
  box-shadow: none;
  border-radius: 0;
  margin: 0;
  height: auto;
}

.shimmerloadingtext .shimmer-card .p-32 {
  padding: 0 0px 32px 20px;
}

.news-right-shimmer-box .shimmer-card {
  height: 140px;
  margin-bottom: 0;
}

.news-right-shimmer-box .shimmer-loading-box {
  width: 100%;
}

.multimedia-shimmer-loading-box .shimmer-card .content-line {
  margin-bottom: 25px;
}

.multimedia-shimmer-loading-box {
  height: 100%;
  padding-bottom: 40px;
}

.multimedia-shimmer-loading-box .shimmer-card {
  height: 100%;
}

@media (min-width: 992px) and (max-width: 1200px) {
  .shimmerloadingtext .shimmer-card .p-32 {
    padding: 0 0px 32px 20px;
  }
}
@media (max-width: 991px) {
  .rec-shimmer-row .shimmer-col-3 {
    display: none;
  }
  .no-other-reco {
    font-size: 13px;
  }
  .shimmerloadingtext-2 {
    display: none;
  }
  .shimmerloadingtext-single {
    display: none;
  }
}
@media (max-width: 767px) {
  .rec-shimmer-row .shimmer-col-2 {
    display: none;
  }
  .shimmerloadingtext {
    display: none;
  }
}
.home-content-area {
  padding: 23px 0;
}

.home-content-area .sub-head-margin {
  margin-bottom: 30px;
}

.view-similar-btn {
  font-weight: 600;
  font-size: 12px;
  color: #333;
  text-decoration: none;
  border-radius: 30px;
  border: 1px solid #d9d9d9;
  width: 36px;
  white-space: nowrap;
  height: 36px;
  overflow: hidden;
  text-align: center;
  align-items: center;
  padding: 0 7px;
  transition: width 0.5s;
}

.view-similar-btn:hover {
  width: 120px;
  transition: width 0.5s;
}

.view-similar-btn img {
  width: 22px !important;
}

.view-similar-btn span {
  margin-left: 6px;
}

.view-similar-btn span {
  color: #333;
  font-weight: 600;
}

.logo img {
  max-height: 30px;
}

.home-content-area .slider-item .sourcebox p {
  max-height: 60px;
  overflow: hidden;
}

.home-desc-scroll {
  max-height: 110px;
}

.upgrade-pop-wrap.no-results .upgrade-title {
  font-size: 20px;
  line-height: 24px;
}

.upgrade-pop-wrap.no-results .btn-sm {
  min-width: 60px;
}

.homeslider .slick-track {
  margin-left: 0;
}

.reco-date {
  line-height: 20px;
  font-weight: 500;
  font-size: 12px;
  color: #8a8b8c;
  flex-shrink: 0;
  padding-left: 15px;
}

@media (max-width: 767px) {
  .view-similar-btn {
    width: auto;
  }
  .home-content-area.result-content-area {
    padding: 23px 0 40px;
  }
}
.banner-wrap {
  padding: 20px;
  background: #f3f5f7;
  border-radius: 3px;
}

p.banner-info-text {
  position: absolute;
  bottom: 45px;
  left: 35px;
  margin: 0;
  color: #555;
  font-size: 12px;
  font-style: italic;
}

.banner-content-box {
  background: linear-gradient(180deg, #4991ef 0%, #1a73e8 100%);
  box-shadow: 0px 10px 10px rgba(133, 175, 214, 0.45);
  padding: 12px;
  border-radius: 15px;
  position: relative;
}

.banner-textarea-wrap textarea.form-control {
  min-height: 100px;
  border: none;
  background: #f0f0f0;
  font-size: 14px;
  color: #5b5b5b;
  padding: 10px 18px;
  box-sizing: border-box;
  max-height: 170px;
  border-radius: 15px;
}

.banner-textarea-wrap .form-control::placeholder {
  font-style: italic;
  color: #8c8c8c;
}

.dragand-drop-style {
  min-height: 99px;
  background: #f3f5f7;
  border: 2px dashed #d6d7d8;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  padding: 0;
  text-align: center;
  flex-direction: column;
  padding-bottom: 10px;
  padding-top: 10px;
}

.dragand-drop-style p {
  margin-bottom: 0;
  font-size: 13px;
  color: #808080;
  line-height: 22px;
}

.drop-upload-icon {
  display: block;
  margin-bottom: 7px;
}

.tab-content .banner-tab {
  background: #fff;
  padding: 10px;
  border-radius: 15px;
  padding-bottom: 60px;
}

.banner-btn-wrap .btn {
  position: absolute;
  bottom: 20px;
  right: 20px;
}

.dragand-drop-style div:empty {
  display: none !important;
}

.dragand-drop-style .filename-uploaded {
  color: #1A73E8;
  word-break: break-all;
}

.remove-uploaded-btn svg {
  width: 10px;
}

.remove-uploaded-btn svg path {
  fill: #fff;
}

.remove-uploaded-btn.btn {
  padding: 0;
  position: absolute;
  right: 20px;
  top: 7px;
  z-index: 100;
}

.length-exceeded {
  font-size: 10px;
  color: red;
}

@media (max-width: 767px) {
  .banner-wrap {
    padding: 10px 0;
  }
  .remove-uploaded-btn.btn {
    font-size: 10px;
    min-width: 80px;
  }
  .remove-uploaded-btn svg {
    width: 8px;
  }
  p.banner-info-text {
    display: none;
  }
}
.sourcebox h3 {
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  border-bottom: 1px solid #d9d9d9;
  padding-bottom: 15px;
  margin-bottom: 15px;
  letter-spacing: 0.5px;
}

.sourcebox p {
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.02em;
  color: #5b5b5b;
}

.icon-button {
  padding: 0;
  border: none;
  background: transparent;
  display: inline-flex;
  align-items: center;
  margin-right: 25px;
}

.icon-button:last-child {
  margin-right: 0;
}

.source-footer {
  display: flex;
  align-items: center;
}

.like-count {
  margin-right: 6px;
  font-size: 15px;
  font-weight: 500;
  line-height: normal;
  margin-top: 2px;
  min-width: 12px;
}

.liked svg {
  width: 22px;
}

.icon-button .liked-icon {
  display: none;
}

.icon-button.liked .normal-icon {
  display: none;
}

.icon-button.liked .liked-icon {
  display: inline-block;
}

.slick-slide .sourcebox {
  border-left: 1px solid #d9d9d9;
  padding-left: 15px;
  padding-right: 15px;
}

.slick-slide:first-child .sourcebox {
  border: none;
  padding-left: 0px;
}

.source-label {
  background: #eff0f2;
  border-radius: 13px;
  padding: 4px 10px;
  color: #5b5b5b;
  font-size: 12px;
}

.multi-label-wrap .source-label {
  margin-left: 10px;
}

.multi-label-wrap .source-label:first-child {
  margin-left: 0;
}

.hom-secs .slider-item .sourcebox {
  flex: 1;
}

.hom-secs .sourcebox h3 a:hover {
  color: #1A73E8 !important;
  display: block;
}

.source-content {
  min-height: 100px;
}

.showmore-button {
  font-size: 12px;
}

.hom-secs .sourcebox h3 {
  word-break: break-word;
}

@media (min-width: 768px) {
  .hom-secs .sourcebox h3 {
    height: 48px;
    overflow: hidden;
    padding-bottom: 0;
    line-height: 22px;
  }
}
@media (max-width: 767px) {
  .sourcebox h3 {
    margin-bottom: 5px;
  }
  .sourcebox {
    margin-right: 0;
  }
  .slick-slide .sourcebox {
    border-left: none;
    padding-left: 0;
    padding-right: 0;
  }
}
.news-img-sec img {
  width: 100%;
  border-radius: 10px;
}

.news-small-left {
  width: 40%;
}

.news-small-left img {
  max-width: 100%;
  border-radius: 3px;
}

.news-small-right {
  width: 60%;
  padding-left: 14px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.news-small-right h4 {
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
}

.news-small-wrap {
  margin-bottom: 30px;
}

.new-big-sec .sourcebox {
  margin-right: 0;
}

.news-right {
  padding-left: 15px;
  border-left: 1px solid #d9d9d9;
  height: 100%;
}

.news-right li h4 {
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  margin: 0;
  word-break: break-word;
}

.hom-secs .new-big-sec {
  padding-top: 0;
  margin-bottom: 40px;
}

.news-right ul {
  margin: 0;
  padding: 0;
}

.news-right li {
  list-style: none;
  min-height: 100px;
  display: flex;
  align-items: flex-start;
  border-bottom: 1px solid #d9d9d9;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  padding: 20px 0;
}

.news-right li:last-child {
  border: none;
  padding-bottom: 0;
}

.news-right li .authors-name {
  margin-top: 12px;
}

.news-small-box-wrap {
  padding-right: 10px;
}

.hom-secs .news-wrap .sourcebox h3,
.hom-secs .new-big-sec {
  border: none;
}

.hom-secs .news-wrap .sourcebox h3 {
  height: auto;
  word-break: break-word;
}

.new-right-wrap {
  margin-left: -4px;
}

.news-wrap .source-content {
  min-height: inherit;
}

.hom-secs .new-big-sec {
  padding-right: 12px;
}

@media (min-width: 1200px) {
  .news-big-repeat:nth-child(5) .new-big-sec, .news-big-repeat:nth-child(6) .new-big-sec {
    margin-bottom: 0;
  }
  .news-wrap {
    padding-bottom: 40px;
  }
}
@media (max-width: 991px) {
  .news-small-box-wrap.right-border {
    border: none;
  }
  .news-right li {
    padding: 20px 10px;
    min-height: inherit;
    border: 1px solid #d9d9d9 !important;
    margin-bottom: -1px;
  }
  .news-right {
    padding-left: 0;
    border: none;
  }
  .news-right li h4 {
    font-size: 14px;
  }
  .new-right-wrap {
    margin-left: 0;
    padding-left: 13px !important;
  }
  .hom-secs .new-big-sec {
    padding-right: 0;
  }
  li.news-right-shimmer-box {
    display: none;
  }
}
@media (max-width: 767px) {
  .new-big-sec {
    margin-bottom: 30px;
  }
  .news-small-left {
    width: 100px;
  }
  .news-small-right {
    width: auto;
  }
}
.video-frame-wrap {
  display: flex;
  height: 222px;
  background: #555;
  border: 1px solid #ddd;
  border-radius: 10px;
}

.video-frame-wrap iframe {
  flex: 1;
  max-height: 100%;
  max-width: 100%;
  border-radius: 10px;
}

.react-player__preview {
  border-radius: 10px;
}

.hom-secs .multimedia-wrap .sourcebox {
  margin-right: 0;
}

.hom-secs .multimedia-wrap .sourcebox h3 {
  border: none;
  padding-bottom: 0;
}

.multimedia-wrap .slick-slide .sourcebox {
  border: none;
  padding-left: 12px;
  padding-right: 12px;
}

.multimedia-wrap .slick-list {
  margin: 0 -12px;
}

.hom-secs .multimedia-wrap {
  padding-right: 15px;
}

@media (max-width: 1400px) {
  .video-frame-wrap {
    height: 160px;
  }
}
@media (max-width: 767px) {
  .video-frame-wrap {
    height: 200px;
  }
  .hom-secs .multimedia-wrap {
    padding-right: 0;
  }
}
.results-header .btn {
  padding: 0 10px;
}

.results-header {
  border-bottom: 1px solid #d7e0e9;
  padding-bottom: 15px;
}

.results-header h4 {
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: -0.02em;
  margin: 0;
}

.results-text {
  font-size: 18px;
  line-height: 22px;
  color: #252525;
  margin-bottom: 10px;
}

.savequery-wrap {
  margin: 30px 0;
}

.mobile-fliter-full {
  display: none;
}

.results-btns.double-btn {
  min-width: 372px;
  margin-left: 10px;
  margin-top: 3px;
}

.filter-button .btn {
  padding: 0 10px;
  min-width: inherit;
}

.filter-box-scroll {
  max-height: 25vh;
  margin-top: 10px;
}

.results-tab-wrap .nav-link:focus-visible {
  outline: none !important;
}

.result-content-area .results-tab-wrap .nav-item:nth-child(8) {
  position: relative;
}

.result-content-area .results-tab-wrap .nav-item:first-child {
  text-align: left;
}

.result-content-area .results-tab-wrap .nav-item:nth-child(8)::after {
  position: absolute;
  left: 0;
  width: 2px;
  background-color: #ddd;
  top: -6px;
  bottom: 6px;
  content: "";
}

.result-content-area .results-tab-wrap .nav-tabs .nav-link {
  display: inline-block;
}

.filter-box-scroll .ps__thumb-y {
  width: 4px;
}

.filter-box-scroll .ps__rail-y {
  width: 6px;
}

.ps__rail-y:hover > .ps__thumb-y {
  background-color: #999;
  width: 4px;
}

@media (min-width: 768px) {
  .result-content-area .results-tab-wrap .nav-item {
    flex: 1;
    text-align: center;
  }
}
@media (min-width: 768px) and (max-width: 1200px) {
  .filter-button .btn {
    padding: 0 10px;
    min-width: 100%;
    margin: 10px 0 0 0;
  }
}
@media (max-width: 991px) {
  .results-tab-wrap .nav-tabs {
    justify-content: flex-start;
  }
  .results-tab-wrap .nav-tabs .nav-link.active::after {
    bottom: -3px;
  }
  .results-tab-wrap .nav-tabs .nav-link {
    font-size: 13px;
    margin-bottom: 15px;
  }
  .results-tab-wrap {
    margin: 0;
  }
}
@media (max-width: 767px) {
  .results-header {
    flex-wrap: wrap;
  }
  .results-header h4 {
    margin-bottom: 15px;
    word-break: break-all;
  }
  .results-header .btn {
    padding: 0 5px;
    font-size: 12px;
    min-width: inherit;
  }
  .results-btns.double-btn {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .results-text {
    font-size: 15px;
  }
  .results-btns.double-btn {
    min-width: inherit;
    margin-left: 0;
    margin-top: 0;
  }
  .main-container {
    position: inherit !important;
  }
  .result-content-area .results-tab-wrap .nav-item:nth-child(8)::after {
    top: 0px;
    bottom: 15px;
  }
}
.result-filter-box {
  background: #ffffff;
  border: 1px solid #ffffff;
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  padding: 18px 18px 5px;
}

.result-filter-box .accordion-item {
  border: none;
}

.result-filter-box .accordion-button {
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: #000000;
  background: transparent;
  padding-left: 10px;
  padding-right: 10px;
}

.result-filter-box .accordion-button:not(.collapsed) {
  color: #000000;
}

.result-filter-box .accordion-button:not(.collapsed)::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.result-filter-box .accordion-button:focus {
  border-color: transparent;
  box-shadow: none;
}

.result-filter-box .accordion-header {
  margin-bottom: 0;
  border-bottom: 1px solid #d7e0e9;
}

.result-filter-box .accordion-item:last-child .accordion-header {
  border: none;
}

.result-filter-box .accordion-button:not(.collapsed) {
  box-shadow: none;
}

.result-filter-box h4 {
  font-weight: 600;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: -0.02em;
  color: #5b5b5b;
  border-bottom: 1px solid #d7e0e9;
  padding-bottom: 15px;
  margin-bottom: 5px;
  padding-left: 10px;
  text-indent: 2px;
}

.filter-sub-text {
  font-size: 11px;
  font-weight: normal;
  display: inline-block;
  margin-left: 2px;
  text-indent: 0;
}

.result-filter-box .accordion-button::after {
  width: 18px;
  height: 18px;
  background-size: 18px;
}

.result-filter-box .accordion-body {
  padding: 10px;
}

.country-header-search {
  margin: 0 -10px;
  position: relative;
}

.country-header-search .country-search {
  padding-left: 30px;
}

span.search-icon {
  position: absolute;
  left: 7px;
  top: 9px;
}

.view-more-check {
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: -0.02em;
  color: #1A73E8;
}

.calendar-icon {
  background: #1A73E8;
  position: absolute;
  right: 0;
  bottom: 0;
  height: 39px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 39px;
  cursor: pointer;
  pointer-events: none;
}

.calendar-modal .modal-dialog {
  max-width: 621px;
}

.calendar-modal .modal-dialog.modal-md {
  max-width: 500px;
}

.calendar-pop-header {
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: -0.02em;
  border-bottom: 1px solid #cccdce;
  margin-bottom: 12px;
  padding-bottom: 10px;
}

.calendaer-pop-footer {
  margin-top: 10px;
  border-top: 1px solid #d7e0e9;
}

.filter-accordian-wrap .btn-wrap {
  margin-top: 30px;
  margin-bottom: 20px;
}

.checkbox-wrapper {
  position: relative;
  padding-left: 30px;
  margin-bottom: 20px;
}

.checkbox-wrapper:last-child {
  margin-bottom: 0;
}

.checkbox-wrapper input {
  position: absolute;
  left: -9999px;
}

.checkbox-wrapper input + label {
  cursor: pointer;
  user-select: none;
}

.checkbox-wrapper input + label:before {
  content: "";
  position: absolute;
  left: 0px;
  top: 0;
  width: 18px;
  height: 18px;
  border: 2px solid #cccdce;
  border-radius: 1px;
}

.checkbox-wrapper input:checked + label:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: 18px;
  background-position: center;
}

.custom-date-picker .react-date-picker__wrapper {
  background-color: #f3f5f7;
  border-radius: 3px;
  height: 39px;
  border: none;
  font-size: 12px;
  width: 100%;
  padding-left: 10px;
}

.custom-date-picker .react-date-picker {
  display: block;
}

.custom-date-picker .react-date-picker__button svg {
  width: 15px;
  margin-right: 6px;
}

.custom-date-picker .react-date-picker__calendar .react-calendar {
  border: none;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.26);
  border-radius: 3px;
}

.custom-date-picker .react-calendar__navigation button {
  min-width: 44px;
  background: none;
  font-size: 20px;
}

.custom-date-picker .react-calendar__navigation {
  margin-bottom: 0;
}

.custom-date-picker .react-calendar__navigation__label {
  font-size: 14px !important;
  font-weight: bold;
  color: #1A73E8;
}

.custom-date-picker .react-calendar__tile {
  font-size: 11px;
  font-weight: 600;
  font-family: "Montserrat", sans-serif;
}

.custom-date-picker .react-calendar__tile--active {
  background: #1A73E8;
  border-radius: 3px;
}

.custom-date-picker .react-calendar button:enabled:hover {
  border-radius: 3px;
}

.custom-date-picker .react-calendar__month-view__weekdays {
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 0.75em;
  background: #ebf0f8;
  padding: 5px 0;
  margin-bottom: 10px;
}

.custom-date-picker .react-calendar__month-view__weekdays abbr[title] {
  border-bottom: none !important;
  cursor: inherit !important;
  text-decoration: none !important;
}

.custom-date-picker .react-date-picker__calendar {
  width: 300px;
  z-index: 50;
}

.custom-date-picker .react-date-picker__inputGroup__input:invalid {
  background: transparent;
}

.custom-date-picker .react-date-picker__inputGroup__input:focus {
  border: none;
  outline: none;
}

.mobile-fliter {
  display: none;
}

.filter-toggle-button-box h4 {
  display: flex;
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
}

.filter-toggle-button-box h4 img {
  max-width: 16px;
  margin-left: 10px;
}

.filter-toggle-button-box {
  padding: 20px;
  background: #eff0f2;
  margin-bottom: 20px;
  border-radius: 4px;
  box-shadow: 0 0 5px #c0c0c0;
}

.filter-toggle-button-box h4 {
  margin-bottom: 0;
}

.form-switch .form-check-input {
  width: 40px !important;
  height: 20px;
  border-color: #DFE1E7;
}

.form-switch .form-check-input:focus {
  box-shadow: none;
}

.experts-filter-head {
  position: relative;
}

.text-info-head {
  position: absolute;
  right: 0;
}

.experts-filter-head h4 {
  flex: 1;
}

.text-info-head img {
  max-width: 16px;
}

.react-date-picker__inputGroup__input, .react-date-picker__inputGroup {
  cursor: pointer;
}

.country-filter .react-multi-select {
  margin-bottom: 10px;
}

.country-filter .react-select-2-option__menu {
  z-index: 10;
}

@media (min-width: 768px) and (max-width: 991px) {
  .result-filter-box .accordion-body {
    padding: 10px 0;
  }
  .result-filter-box .accordion-button {
    font-size: 13px;
    padding-left: 0;
    padding-right: 0;
  }
}
@media (max-width: 991px) {
  .multi-label-wrap {
    flex-wrap: wrap;
    margin-bottom: 5px;
  }
  .source-label {
    margin-bottom: 10px;
    margin-left: 0 !important;
    margin-right: 10px;
  }
  .result-filter-box {
    margin-bottom: 20px;
  }
  .source-label:empty {
    display: none;
  }
}
@media (max-width: 767px) {
  .filter-active {
    display: block;
  }
  .mobile-fliter svg path {
    fill: #fff;
  }
  .filter-active .result-filter-box {
    margin-bottom: 20px;
    position: fixed;
    bottom: 70px;
    z-index: 110;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: 0;
  }
  .mobile-fliter-full {
    display: flex;
    justify-content: space-between;
    background: #1A73E8;
    position: fixed;
    z-index: 130;
    left: 0;
    right: 0;
    bottom: 0;
    color: #fff;
    padding: 10px 15px 10px 10px;
    align-items: center;
    box-shadow: 1px 0 6px rgba(0, 0, 0, 0.6196078431);
  }
  .mobile-fliter-full h4 {
    font-size: 14px;
    margin: 0;
    color: #fff;
  }
  .mobile-fliter-full svg path {
    fill: #fff;
  }
  .filter-hidden {
    display: none;
  }
  .econ-fixed-div .filter-active {
    position: fixed;
    background: #fff;
    z-index: 99;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .econ-fixed-div .filter-active .result-filter-box {
    position: relative;
    top: inherit;
  }
  .filter-toggle-button-box {
    margin-bottom: 0;
  }
}
.fin-result-contents {
  padding-left: 15px;
}

.fin-result-contents .sourcebox h3 {
  border: none;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  padding-bottom: 10px;
  word-break: break-word;
}

.fin-result-contents .sourcebox {
  margin-bottom: 50px;
}

.fin-result-contents .sourcebox p {
  margin-bottom: 25px;
}

.fin-result-contents .sourcebox {
  border: none;
  margin-right: 0;
  padding-right: 0;
}

.more-text-wrap {
  margin-bottom: 25px;
  font-size: 13px;
  line-height: 22px;
}

.showmore-button {
  white-space: nowrap;
  font-weight: 500;
  font-style: italic;
  color: #1A73E8;
  cursor: pointer;
}

.fin-result-contents .source-content {
  min-height: inherit;
}

.multi-label-wrap .source-label {
  cursor: default !important;
}

@media (max-width: 991px) {
  .fin-result-contents {
    padding-left: 0;
  }
}
@media (max-width: 767px) {
  .more-text-wrap {
    margin-bottom: 10px;
  }
  .fin-result-contents .sourcebox h3 {
    font-size: 15px;
  }
}
.multi-result-contents .sourcebox h3 {
  font-size: 14px;
  border-bottom: none;
}

.multi-result-contents .sourcebox {
  margin-bottom: 0;
  height: 100%;
}

.mutimedia-results-repeatbox {
  margin-bottom: 40px;
}

.sorce-footer-button-container {
  display: flex;
  align-items: center;
}

.news-result-contents .sourcebox h3 {
  border: none;
}

.news-result-contents .sourcebox p {
  margin-bottom: 20px;
}

.news-img-sec img {
  width: auto;
  border-radius: 10px;
  max-width: 100px;
  margin-right: 12px;
  border: 1px solid #f0f0f0;
}

.new-small-thumb {
  display: flex;
  margin-bottom: 10px;
  min-height: 100px;
}

.news-snippet:empty {
  display: none;
}

.new-small-thumb .sourcebox h3 {
  margin: 0;
  padding: 0;
}

.new-big-sec {
  border-top: 1px solid #d7e0e9;
  padding-top: 25px;
  margin-bottom: 25px;
}

.news-repeat-indetail:nth-child(1) .new-big-sec,
.news-repeat-indetail:nth-child(2) .new-big-sec,
.news-repeat-indetail:nth-child(3) .new-big-sec {
  border: none;
  padding-top: 0;
}

.news-repeat-indetail {
  padding: 0 18px;
}

.upgrade-pop-wrap {
  text-align: center;
  padding: 5px 0;
}

.upgrade-pop-wrap .upgrade-title {
  margin: 19px 0 10px;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  max-width: 280px;
  margin-left: auto;
  margin-right: auto;
}

.upgrade-pop-wrap p {
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 15px;
}

.news-repeat-indetail .source-content {
  min-height: 64px;
}

.date-text {
  line-height: 20px;
  font-weight: 500;
  font-size: 12px;
  color: #8A8B8C;
  padding-top: 4px;
}

.sourcebox.news-auther-box {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.authors-name {
  font-weight: 500;
  color: #000;
  font-size: 12px;
  margin-top: 5px;
}

.authors-name span {
  color: #666;
  margin-right: 5px;
  font-size: 12px;
}

@media (max-width: 991px) {
  .news-repeat-indetail:nth-child(3) .new-big-sec {
    border-top: 1px solid #d7e0e9;
    padding-top: 25px;
  }
}
@media (max-width: 767px) {
  .news-repeat-indetail:nth-child(2) .new-big-sec {
    border-top: 1px solid #d7e0e9;
    padding-top: 25px;
  }
  .new-small-thumb {
    min-height: inherit;
  }
}
.expert-left-img img {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 4px solid #ffffff;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
}

.experts-box {
  background: #ffffff;
  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.14);
  border-radius: 15px;
  margin-bottom: 24px;
  display: flex;
}

.experts-box-left {
  width: 84px;
  background: #f3f5f7;
  display: flex;
  align-items: center;
  padding-left: 17px;
  border-radius: 15px 0 0 15px;
}

.experts-right {
  flex: 1;
  min-height: 188px;
  display: flex;
  align-items: center;
  padding-left: 50px;
}

.experts-right-content {
  width: 100%;
  padding-right: 20px;
}

.experts-right-content h3 {
  font-weight: 600;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: -0.02em;
  margin-bottom: 12px;
}

.experts-pers-info-wrap {
  margin-bottom: 12px;
}

span.experts-pers-info-text {
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  margin-left: 10px;
  color: #5b5b5b;
}

.experts-footer {
  display: flex;
  align-items: center;
  border-top: 1px solid #ddd;
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
}

@media (max-width: 767px) {
  .experts-right {
    padding-left: 50px;
  }
}
.pop-checkboxscroll {
  height: 40vh;
}

.pop-selected-items-scroll {
  height: 20vh;
}

.selected-view-box {
  border-top: 1px solid #cccdce;
  border-left: none;
  border-right: none;
  padding-top: 20px;
}

.react-multi-select {
  cursor: pointer;
}

.selected-item-show-wrap {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -5px;
}

.selected-item-show {
  display: flex;
  background: #f3f5f7;
  margin: 0 5px 10px;
  padding: 10px;
  border-radius: 3px;
  font-size: 12px;
  position: relative;
}

.country-pop-items .checkbox-box {
  padding-top: 30px;
  padding-bottom: 20px;
}

.selected-close {
  margin-left: 10px;
  position: absolute;
  top: -3px;
  padding: 5px 7px;
  right: 0;
  cursor: pointer;
}

.selected-name {
  margin-right: 15px;
}

.country-pop-wraper {
  padding: 15px 0px;
}

@media (max-width: 767px) {
  .pop-checkboxscroll {
    max-height: 40vh;
    height: auto;
  }
}
.catogory-popup .modal-dialog {
  max-width: 616px;
}

.catogory-checkbox .checkbox-wrapper {
  margin-bottom: 25px;
  margin-top: 20px;
}

@media (max-width: 767px) {
  .catogory-checkbox .checkbox-wrapper {
    margin-bottom: 15px;
    margin-top: 10px;
  }
}
.innerwrapper {
  padding-top: 35px;
}

.innerwrapper .results-tab-wrap .nav-tabs {
  justify-content: flex-start;
}

.tooltip > div.tooltip-inner {
  background-color: #1A73E8 !important;
}

.tooltip.show {
  opacity: 1 !important;
}

.tooltip > div.tooltip-inner::before {
  border-color: #1A73E8 !important;
  color: #1A73E8 !important;
}

.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before,
.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #1A73E8 !important;
}

.tooltip-inner {
  font-size: 12px;
  text-align: center;
}

.action-icon-cell {
  cursor: pointer;
}

.delete-confirm-wrap {
  padding: 10px 0;
}

.innerwrapper .results-tab-wrap .nav-tabs::after {
  left: 0;
  right: 0;
}

.innerwrapper .results-tab-wrap .nav-tabs .nav-link {
  padding: 5px 30px;
}

.savedquery-wrap {
  min-height: calc(100vh - 120px);
}

.innerwrapper.profile-wrap {
  position: relative;
}

.innerwrapper.profile-wrap::before {
  position: absolute;
  left: 0;
  top: 0;
  height: 355px;
  right: 0;
  background: #f3f5f7;
  content: "";
  pointer-events: none;
  z-index: -1;
}

.prof-left {
  padding: 0 15px;
  width: 28%;
}

.prof-right {
  padding: 0 15px;
  width: 72%;
}

.profile-quick-details h3 {
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: -0.02em;
}

@media (max-width: 991px) {
  .prof-left {
    width: 100%;
    margin-bottom: 20px;
  }
  .prof-right {
    width: 100%;
  }
}
@media (max-width: 767px) {
  .members-wrap .inner-title {
    margin-bottom: 15px !important;
  }
}
.members-header-right-search {
  flex: 1;
}

.m-l-10 {
  margin-left: 10px;
}

.no-results-wraper {
  padding: 30px;
  color: #555;
  border-radius: 13px;
  text-align: center;
  font-weight: 500;
  font-size: 16px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1490196078);
}

span.transport-text {
  background: #EFF0F2;
  padding: 5px 10px;
  border-radius: 20px;
  display: inline-block;
  line-height: normal;
  color: #474747;
}

.members-wrap .experts-right {
  padding-left: 50px;
}

.members-wrap .experts-pers-info-text {
  word-break: break-all;
}

@media (min-width: 768px) and (max-width: 991px) {
  .expert-left-img img {
    width: 85px;
    height: 85px;
  }
  .experts-box-left {
    padding-left: 10px;
  }
  .members-wrap .experts-right {
    padding-left: 16px;
  }
}
.signup-content-profile {
  border: 1px solid #e9e9e9;
  border-radius: 15px;
}

.prof-sub-header {
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  color: #5b5b5b;
  letter-spacing: 0.2px;
  margin: 0;
}

.inner-title {
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.2px;
}

.my-profile-header .inner-title {
  margin: 0;
}

.profile-det-box p {
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: #5b5b5b;
  margin-bottom: 5px;
}

.profile-det-box h4 {
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  margin-bottom: 20px;
}

.profile-det-box {
  width: 50%;
  min-height: 130px;
  padding: 0 30px 20px;
  position: relative;
}

.border-detail {
  margin-bottom: 50px;
}

.border-detail::after {
  content: "";
  left: 30px;
  right: 30px;
  bottom: 0;
  height: 1px;
  background-color: #d9d9d9;
  position: absolute;
}

.profile-det-box-wrap {
  margin: 0 -30px;
}

.p-b-0 {
  padding-bottom: 0;
}

.box-bg {
  background: #f3f5f7;
  padding: 20px 20px 10px;
  margin-bottom: 20px;
  border-radius: 3px;
}

.box-bg .react-multi-select .react-select-2-option__control:not(.react-select-2-option__control--is-focused):not(.react-select-2-option__control--is-disabled) {
  background-color: #fff;
}

.box-bg .react-select-2-option__multi-value {
  background-color: #f3f5f7;
}

.box-bg-infotext {
  color: #1A73E8;
  font-size: 13px;
  font-style: italic;
  font-weight: 500;
}

.subheader-min-height {
  min-height: 39px;
}

@media (min-width: 768px) and (max-width: 991px) {
  .profile-det-box-wrap .border-detail {
    margin-bottom: 20px;
  }
  .profile-det-box {
    padding-bottom: 20px;
    min-height: inherit;
  }
}
@media (max-width: 767px) {
  .profile-det-box {
    width: 100%;
    min-height: inherit;
  }
  .border-detail, .profile-det-box {
    margin-bottom: 20px;
  }
  .border-detail::after {
    display: none;
  }
  .profile-det-box h4 {
    margin-bottom: 10px;
  }
  .profile-wrap .p-30 {
    padding: 15px;
  }
  .innerwrapper.profile-wrap::before {
    background: transparent;
  }
}
.profile-inner-box {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.11);
  border-radius: 15px;
  background: #fff;
  padding-bottom: 40px;
  height: 100%;
}

.profile-top-bg {
  height: 169px;
  background-color: #1A73E8;
  background-position: center 0;
  border-radius: 15px 15px 0 0;
}

.profile-stat-contentbox {
  margin-top: -80px;
}

.profile-quick-details {
  padding: 0 30px;
  text-align: left;
}

@media (max-width: 767px) {
  .profile-top-bg {
    height: 80px;
  }
}
.viewallmembers-wrap {
  position: absolute;
  top: 112px;
  bottom: 0;
  left: 0;
  right: 0;
  background: #f3f5f7;
  padding-top: 30px;
}

.viewallmembers-header .row {
  margin: 0 -8px;
}

.viewallmembers-header .row .col {
  padding: 0 8px;
}

.backarrow-wrap h4 {
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  margin: 0;
  margin-left: 15px;
}

.user-img img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid #ffffff;
}

.membername-cell h4 {
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: -0.02em;
  margin: 0 0 0 15px;
}

.sector-item {
  border: 1px solid #ddd;
  padding: 2px 5px;
  margin: 2px;
  border-radius: 3px;
  font-size: 12px;
}

@media (max-width: 991px) {
  .mebers-select-wrap {
    padding: 0 8px;
    margin-top: 10px;
  }
  .data-table-responsive .rdt_Table {
    width: 900px;
  }
  .user-img img {
    width: 30px;
    height: 30px;
    border: 1px solid #ffffff;
  }
}
@media (max-width: 767px) {
  .viewallmembers-wrap .p-30 {
    padding: 15px;
  }
  .membername-cell h4 {
    font-size: 13px;
    margin: 0;
  }
}
.recomendation-header {
  border-bottom: 1px solid #D7E0E9;
  padding-bottom: 20px;
}

.recomendation-main-outer {
  min-height: 100vh;
}

@media (max-width: 767px) {
  .recomendation-header .backarrow-wrap {
    align-items: flex-start !important;
  }
  .financerecomendation-wrap {
    padding-bottom: 40px;
  }
}
.faq-header {
  border-bottom: 1px solid #d9d9d9;
  padding-bottom: 24px;
  margin-bottom: 20px;
}

.faq-header h4 {
  font-weight: 600;
  font-size: 22px;
  line-height: 27px;
  letter-spacing: -0.02em;
  margin-bottom: 0;
}

.faq-header-right {
  flex: 1;
  padding-left: 45px;
}

.faq-footer-sec h3 {
  font-weight: 600;
  font-size: 22px;
  line-height: 27px;
  letter-spacing: -0.02em;
}

.faq-footer-sec p {
  font-size: 14px;
  line-height: 19px;
  letter-spacing: 0.02em;
  color: #5b5b5b;
}

.faq-footer-sec textarea.textarea-item {
  background: #f3f5f7;
  border: none;
  min-height: 114px;
  font-size: 13px;
  padding: 15px;
  max-height: 114px;
}

.faq-footer-sec textarea.textarea-item::placeholder {
  font-style: italic;
}

.faq-footer-sec .form-control:focus {
  background-color: #f3f5f7;
  border-color: inherit;
  outline: 0;
  box-shadow: none;
}

@media (max-width: 767px) {
  .faq-header .d-flex {
    flex-wrap: wrap;
  }
  .help-and-support-wrap .p-30 {
    padding: 0;
    box-shadow: none;
  }
  .faq-header h4 {
    width: 100%;
  }
  .faq-header-right {
    flex: 1;
    padding-left: 0;
    margin-top: 15px;
    width: 100%;
  }
  .faq-header {
    margin-bottom: 0;
  }
  .faq-header h4, .faq-footer-sec h3 {
    font-size: 20px;
    line-height: 24px;
  }
}
.change-password-wrap {
  margin-top: 38px;
}

.change-password-wrap .section-title {
  font-weight: 600;
  font-size: 22px;
  line-height: 30px;
  color: #000;
}

.change-password-wrap .section-title a {
  color: #000;
  text-decoration: none;
}

.changepassword-contents {
  padding: 0 36px;
}

.change-psw-img {
  padding-left: 50px;
}

.change-password-wrap .section-title span {
  margin-right: 18px;
  position: relative;
  top: -1px;
}

.changepassword-contents form {
  max-width: 80%;
}

.change-password-wrap .whitebox.p-30 {
  padding-bottom: 70px;
}

@media (min-width: 991px) {
  .change-psw-img {
    min-height: 320px;
  }
  .change-password-wrap .change-psw-img {
    margin-bottom: 0;
  }
  .change-psw-img img {
    max-width: 100%;
  }
}
@media (max-width: 1024px) {
  .change-psw-img {
    padding-left: 0;
  }
  .change-psw-img img {
    max-width: 100%;
  }
}
@media (max-width: 992px) {
  .changepassword-contents form {
    max-width: 100%;
  }
}
@media (max-width: 767px) {
  .change-psw-img {
    display: none;
  }
  .changepassword-contents {
    padding: 0;
    margin-top: 30px;
  }
  .change-password-wrap .whitebox.p-30 {
    padding-bottom: 40px;
  }
}
.landing-header {
  padding: 20px;
}

.user-img-landing img {
  max-height: 30px;
}

.landing-header .dropdown {
  margin-left: 10px;
}

.landing-menu-items .dropdown .btn {
  min-width: inherit;
  padding: 0;
  background: transparent;
  border: none;
  color: #5b5b5b;
}

.landing-menu-items .dropdown .dropdown-toggle:focus {
  box-shadow: none;
}

.landing-menu-items .dropdown a {
  margin: 0;
}

.landing-menu-items .dropdown-menu.show.dropdown-menu-end {
  border: none;
  box-shadow: 0 1px 4px #c1c1c1;
  padding: 10px;
}

.landing-menu-items .dropdown-item {
  font-size: 13px;
  line-height: 24px;
}

.landing-menu-items .dropdown a {
  font-size: 13px;
  line-height: 24px;
}

.landing-menu-items .dropdown-item:focus,
.landing-menu-items .dropdown-item:hover {
  color: #1A73E8;
  background-color: transparent;
  text-shadow: 0px 0px #1a73e8;
}

.landing-menu-items .dropdown-menu {
  min-width: 120px;
}

.landing-header .user-img img {
  height: 30px;
  width: 30px;
  border: none;
}

.landing-menu-items .dropdown a {
  padding: 0 5px;
  color: #5b5b5b;
}

@media (min-width: 768px) {
  .btn-primary.m-r-15 {
    margin-right: 15px;
  }
}
@media (max-width: 767px) {
  .landing-header .mobilemenu-active .double-btn {
    flex-wrap: wrap;
    padding: 15px;
  }
  .landing-header {
    padding: 10px 0;
  }
  .landing-header .double-btn .btn {
    width: 48%;
    margin: 0;
    flex: 1;
    max-width: 48%;
  }
  .landing-header .double-btn .dropdown .btn {
    width: 100%;
    max-width: 99%;
    text-align: left;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .landing-header .double-btn .dropdown {
    max-width: 60%;
  }
  .landing-header .mobilemenu-active {
    top: 50px;
    right: 0;
    left: 0;
  }
  .landing-header .dropdown {
    margin-left: 0;
    width: auto;
    margin: 0;
    flex: 1;
    border: none;
    padding: 0;
  }
  .landing-header .double-btn .btn:first-child {
    margin-right: 4%;
  }
  .landing-menu-items .dropdown-menu {
    min-width: 120px;
    position: inherit !important;
    transform: none !important;
  }
  .landing-menu-items .dropdown-menu {
    position: inherit !important;
    transform: none !important;
    border: none !important;
    box-shadow: none !important;
    padding: 0 !important;
    padding-top: 10px !important;
  }
  .landing-menu-items .mobilemenu-active .dropdown {
    padding-left: 0;
  }
  .landing-menu-items .dropdown a {
    padding-left: 0;
  }
}
.footer-left {
  flex: 1;
}

.land-footer-wrap {
  padding: 40px 0 80px;
}

h4.footer-title {
  font-weight: 700;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.05em;
  margin-bottom: 15px;
}

.footer-menu-list a {
  text-decoration: none;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.05em;
  color: #000;
  margin-bottom: 10px;
  display: inline-block;
  border-bottom: 1px solid transparent;
}

.footer-menu-list a:hover, .footer-menu-list a.active {
  color: #1A73E8;
  border-bottom: 1px solid #1A73E8;
}

.footer-menu-list {
  margin-top: 0;
  margin-bottom: 1rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.active-class {
  text-decoration: underline;
}

p.copyright-text {
  margin: 12px 0;
}

.social-icons a {
  margin-left: 10px;
}

.social-icons a:first-child {
  margin-left: 0;
}

@media (max-width: 767px) {
  .land-footer-content {
    flex-wrap: wrap;
  }
  .footer-left {
    flex: inherit;
    width: 100%;
  }
  .land-footer-wrap {
    padding: 30px 0;
  }
  .footer-right {
    text-align: center;
    margin-top: 20px;
    border-top: 1px solid #ddd;
    width: auto;
    margin: 20px -15px 0;
    flex: 1;
    padding-top: 20px;
  }
  .land-footer-wrap .container {
    padding: 0 15px;
  }
  .footer-left {
    text-align: center;
  }
}
.landing-section-bg-right {
  background-position: right;
  right: 0;
}

.landing-section-bg {
  background-size: cover;
  background-repeat: no-repeat;
  position: absolute;
  width: 50%;
  bottom: 0;
  pointer-events: none;
  z-index: 1;
  top: 0;
}

.landing-section-bg-left {
  background-position: left;
  left: 0;
}

.bg-over-text {
  position: relative;
  z-index: 2;
}

.landing-common-title {
  font-weight: 800;
  font-size: 30px;
  line-height: 37px;
  letter-spacing: 0.05em;
  color: #000000;
  margin-bottom: 26px;
  max-width: 80%;
  margin-left: auto;
  margin-right: auto;
}

.getresults-content h3 {
  font-weight: 800;
  font-size: 30px;
  line-height: 34px;
  letter-spacing: 0.05em;
  margin-bottom: 25px;
}

.landing-common-description {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.05em;
  color: #000000;
}

.landing-section-2 {
  padding: 90px 0;
}

.landing-section-4 {
  padding: 90px 0;
}

.landing-section-5 {
  padding: 90px 0;
}

.landing-section-6 {
  padding: 90px 0;
  background-color: #DDEAFC;
}

.landing-section-7 {
  padding: 90px 0 30px;
}

.landing-section-8 {
  padding: 70px 0;
}

.land-contact-section {
  background: #DDEAFC;
  padding: 50px 0 60px;
}

.contact-success .modal-dialog {
  max-width: 690px;
}

.contact-success .success-content-wrap h3 {
  font-weight: 700;
  font-size: 26px;
  line-height: 32px;
  text-align: center;
  letter-spacing: 0.05em;
}

.contact-success .success-content-wrap p {
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  margin-top: 30px;
}

@media (min-width: 768px) and (max-width: 991px) {
  .landing-section-bg {
    background-position: center;
  }
  .landing-section-2 {
    padding: 50px 0;
  }
  .landing-section-4 {
    padding: 50px 0;
  }
  .landing-section-5 {
    padding: 50px 0 30px;
  }
  .landing-section-7 {
    padding: 50px 0;
  }
  .landing-section-8 {
    padding: 50px 0;
  }
  .landing-common-title {
    font-size: 20px;
    line-height: 26px;
  }
  .getresults-content h3 {
    font-size: 20px;
    line-height: 26px;
  }
  .landing-common-title {
    max-width: 100%;
  }
}
@media (max-width: 767px) {
  .landing-section-bg {
    position: inherit;
    height: 260px;
    width: 100%;
  }
  .landing-section-2 {
    padding: 30px 0;
  }
  .landing-common-title {
    font-size: 20px;
    line-height: 28px;
    max-width: 100%;
    margin-bottom: 10px;
  }
  .landing-section-4 {
    padding: 30px 0 15px;
  }
  .getresults-content h3 {
    font-size: 20px;
    line-height: 28px;
    text-align: center;
  }
  .landing-common-description {
    text-align: center;
    font-size: 15px;
  }
  .landing-section-5 {
    padding: 30px 0;
  }
  .landing-section-6 {
    padding: 0 0 30px;
  }
  .landing-section-7 {
    padding: 30px 0;
  }
  .contact-success .success-content-wrap h3 {
    font-size: 21px;
    line-height: 24px;
    max-width: 75%;
    margin: 0 auto 20px;
  }
  .contact-success-img img {
    max-width: 70%;
  }
}
.land-section-1-row {
  height: 478px;
}

.landing-section-1 {
  background-color: #1A73E8;
}

.landing-section-1 h4 {
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: 0.05em;
  color: #ffffff;
  margin-bottom: 30px;
}

.landing-section-1 h2 {
  font-weight: 600;
  font-size: 40px;
  line-height: 48px;
  letter-spacing: 0.05em;
  color: #ffffff;
  margin-bottom: 30px;
}

.landing-section-1 h2 .Typewriter {
  margin-right: 10px;
}

.landing-section-1 h2 .Typewriter .Typewriter__wrapper {
  padding-right: 10px;
}

.landing-section-1 h2 .Typewriter .Typewriter__cursor {
  font-weight: 400;
}

.landing-section-1 h2 .Typewriter:last-of-type .Typewriter__cursor {
  display: none;
}

.landing-section-1 p {
  font-size: 15px;
  line-height: 22px;
  color: #fff;
  margin-bottom: 30px;
}

span.svg-down-arrow {
  margin-left: 6px;
  position: relative;
  top: 3px;
}

.sec1-content .btn {
  color: #fff;
  font-weight: 500;
  font-size: 13px;
  letter-spacing: -0.02em;
}

.sec1-content {
  padding-right: 50px;
}

@media (max-width: 1400px) {
  .landing-section-1 h4 {
    font-size: 20px;
    margin-bottom: 25px;
  }
  .landing-section-1 h2 {
    font-size: 30px;
    margin-bottom: 25px;
  }
  .landing-section-1 p {
    font-size: 13px;
  }
}
@media (max-width: 1200px) {
  .landing-section-1 h4 {
    font-size: 17px;
  }
  .landing-section-1 h2 {
    font-size: 26px;
    line-height: 30px;
  }
}
@media (max-width: 991px) {
  .landing-section-1 h4 {
    font-size: 15px;
    margin-bottom: 15px;
  }
  .landing-section-1 p {
    font-size: 12px;
    margin-bottom: 20px;
  }
  .sec1-content {
    padding-right: 10px;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .landing-section-1 h2 {
    font-size: 20px;
    line-height: 26px;
    margin-bottom: 15px;
  }
  .land-section-1-row {
    height: 290px;
  }
}
@media (max-width: 767px) {
  .land-section-1-row {
    height: auto;
    padding: 30px 0;
  }
  .sec1-content {
    padding-right: 0;
    text-align: center;
  }
  .landing-section-1 h2 {
    font-size: 22px;
    line-height: 28px;
    margin-bottom: 15px;
  }
}
.thumb-slider-with-animation {
  display: flex;
  text-align: left;
  align-items: center;
}
.thumb-slider-with-animation .mySwiper {
  width: 45%;
  padding-right: 45px;
  margin: auto;
}
.thumb-slider-with-animation .mySwiper .swiper-wrapper {
  flex-direction: column;
  height: auto;
  padding-left: 5px;
  padding-top: 25px;
}
.thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide {
  width: 100% !important;
  margin: 0 0 25px 0 !important;
  padding: 0 10px 0 10px;
}
.thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide .thumb-content-area {
  box-shadow: 0px 5px 10px 0px rgba(159, 171, 182, 0.2509803922);
  cursor: pointer;
  padding: 25px 15px;
  border-radius: 7px;
  display: flex;
  position: relative;
  overflow: hidden;
}
.thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide .thumb-content-area .thumb-line {
  width: 4px;
  background-color: #DEE3EA;
  display: block;
  margin-right: 24px;
  position: relative;
}
.thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide .thumb-content-area .thumb-line::after {
  content: "";
  width: 4px;
  height: 0;
  position: absolute;
  left: 0;
  background-color: #1A73E8;
}
.thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide .thumb-content-area .thumb-cont {
  flex: 1;
}
.thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide .thumb-content-area label {
  color: #5B5B5B;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.75px;
  margin: 0 0 16px;
}
.thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide .thumb-content-area p {
  color: #5B5B5B;
  font-weight: 300;
  line-height: 20px;
  letter-spacing: 0.65px;
}
.thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide.swiper-slide-thumb-active .thumb-line::after {
  height: 100%;
  transition: all 6s ease;
}
.thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide.swiper-slide-thumb-active label {
  color: #0338C0;
}
.thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide.swiper-slide-thumb-active p {
  font-size: 14px;
  font-weight: 400;
  color: #000;
}
.thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide.swiper-slide-thumb-active .thumb-content-area {
  box-shadow: 0px 10px 20px 0px rgba(85, 98, 111, 0.25);
}
.thumb-slider-with-animation .mySwiper2 {
  width: 55%;
  border-radius: 20px;
  background: #D5E4F9;
}
.thumb-slider-with-animation .mySwiper2 .swiper-wrapper {
  align-items: center;
}
.thumb-slider-with-animation .mySwiper2 .swiper-slide {
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.thumb-slider-with-animation .mySwiper2 .swiper-slide .left-slide {
  position: relative;
  left: -105%;
}
.thumb-slider-with-animation .mySwiper2 .swiper-slide .right-slide {
  position: relative;
  right: -105%;
}
.thumb-slider-with-animation .mySwiper2 .swiper-slide .top-slide {
  position: relative;
  top: -270px;
}
.thumb-slider-with-animation .mySwiper2 .swiper-slide.swiper-slide-active .top-slide {
  top: 0;
  transition: all 1.5s ease;
}
.thumb-slider-with-animation .mySwiper2 .swiper-slide.swiper-slide-active .left-slide {
  left: 0;
  transition: all 1.5s ease;
}
.thumb-slider-with-animation .mySwiper2 .swiper-slide.swiper-slide-active .right-slide {
  right: 0;
  transition: all 1.5s ease;
}
.thumb-slider-with-animation .chat-slide-left-img {
  border-radius: 10px;
  box-shadow: 0px 20px 30px 0px #A5C2EB;
}
.thumb-slider-with-animation .chat-slide-typer-area {
  border-radius: 7px;
  background: #FFF;
  box-shadow: 0px 20px 30px 0px #A5C2EB;
  padding: 15px;
  min-height: 200px;
}
.thumb-slider-with-animation .chat-slide-typer-area .Typewriter {
  padding: 0 15px;
  font-size: 12px;
  line-height: 20px;
}
.thumb-slider-with-animation .chat-slide-right-img1 {
  box-shadow: 0px 20px 30px 0px #A5C2EB;
  border-radius: 7px;
}
.thumb-slider-with-animation .chat-slide-right-img2 {
  box-shadow: 0px 10px 10px 0px rgba(182, 211, 239, 0.45);
  max-width: 350px;
  width: 100%;
}
.thumb-slider-with-animation .chat-slide-right-img3 {
  border-radius: 7px;
  margin-top: 32px;
}
.thumb-slider-with-animation .search-slide-top-img {
  box-shadow: 0px 10px 10px 0px #A3C0E8;
  border-radius: 11px;
  margin-bottom: 20px;
}
.thumb-slider-with-animation .search-slide-left-img {
  box-shadow: 0px 20px 30px 0px #A5C2EB;
  border-radius: 7px;
}
.thumb-slider-with-animation .search-slide-typer-area {
  border-radius: 7px;
  background: #FFF;
  box-shadow: 0px 20px 30px 0px #A5C2EB;
  height: 100%;
}
.thumb-slider-with-animation .search-slide-typer-area .Typewriter {
  padding: 15px 0;
  font-size: 12px;
  line-height: 20px;
}
.thumb-slider-with-animation .general-slide-left-area {
  border-radius: 10px;
  box-shadow: 0px 20px 30px 0px #A5C2EB;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 100%);
  height: 100%;
}
.thumb-slider-with-animation .general-slide-left-area img {
  width: 100%;
}

@media (max-width: 1199px) {
  .thumb-slider-with-animation .chat-slide-typer-area {
    min-height: auto;
  }
}
@media (max-width: 991px) {
  .thumb-slider-with-animation {
    flex-direction: column;
  }
  .thumb-slider-with-animation .mySwiper {
    width: 100%;
  }
  .thumb-slider-with-animation .mySwiper .swiper-wrapper {
    flex-direction: row;
  }
  .thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide {
    width: 33.3% !important;
  }
  .thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide .thumb-content-area p {
    display: none;
  }
  .thumb-slider-with-animation .mySwiper2 {
    width: 100%;
  }
  .thumb-slider-with-animation .mySwiper {
    padding: 0;
  }
  .thumb-slider-with-animation .mySwiper .swiper-wrapper {
    padding: 0;
  }
  .thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide .thumb-content-area {
    flex-direction: column;
    padding: 10px;
    text-align: center;
  }
  .thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide .thumb-content-area label {
    margin: 0;
  }
  .thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide .thumb-content-area .thumb-line {
    width: 100%;
    height: 4px;
    position: absolute;
    top: 0;
    left: 0;
  }
  .thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide .thumb-content-area .thumb-line::after {
    width: 0;
    height: 4px;
  }
  .thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide.swiper-slide-thumb-active .thumb-line::after {
    width: 100%;
  }
}
.landing-animation-section .container {
  max-width: 1179px;
}
.landing-animation-section .chat-slide-left-img {
  width: 100%;
}

@media (max-width: 767px) {
  .thumb-slider-with-animation .chat-slide-typer-area .Typewriter {
    font-size: 10px;
  }
}
@media (max-width: 575px) {
  .thumb-slider-with-animation .mySwiper2 .swiper-slide {
    padding: 20px 10px;
  }
  .thumb-slider-with-animation .chat-slide-typer-area .Typewriter {
    padding: 0;
    font-size: 8px;
    line-height: 14px;
  }
  .thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide .thumb-content-area label {
    font-size: 12px;
  }
  .thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide {
    padding: 0 5px;
  }
  .thumb-slider-with-animation .general-slide-left-area {
    border-radius: 7px;
  }
  .thumb-slider-with-animation .search-slide-top-img {
    margin-bottom: 15px;
  }
}
.landing-section-3 {
  background-color: #ddeafc;
}

.landing-section-3 {
  padding: 80px 0 110px;
}

.getresults-content {
  padding: 0 15px 0 45px;
}

.animation-box-content {
  background: #fff;
  padding: 30px 10px;
  box-shadow: 0px 20px 20px rgba(59, 89, 134, 0.25);
  border-radius: 10px;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.animation-box {
  padding: 0 11px;
  width: 20%;
}

.animation-box h4 {
  font-weight: 800;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.05em;
  margin-bottom: 20px;
}

.animation-box p {
  font-size: 13px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.05em;
  margin: 0;
}

.animation-box-row {
  margin: 40px -11px 0px;
}

.animation-section-big-row {
  margin: 0 -50px;
}

.landing-section-3 {
  overflow-x: hidden;
}

.animation-box:hover .animation-box-content::after {
  position: absolute;
  left: 0;
  right: 0;
  top: 0px;
  height: 7px;
  background: #1A73E8;
  content: "";
}

.transforming-animation-wrap .landing-section-bg {
  width: 41.66666667%;
}

@media (max-width: 1200px) {
  .animation-box-row {
    flex-wrap: wrap;
    justify-content: center;
  }
  .animation-box {
    width: 33.3333%;
    margin-top: 20px;
  }
  .animation-section-big-row {
    margin: 0;
  }
  .getresults-content p br {
    display: none;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .landing-section-3 {
    padding: 50px 0 60px;
  }
}
@media (max-width: 767px) {
  .animation-box {
    width: 100%;
  }
  .transforming-animation-wrap .landing-section-bg {
    width: 100%;
  }
  .landing-section-3 {
    padding: 0 0 30px;
  }
  .animation-box-content {
    padding: 20px;
    box-shadow: 0px 0px 7px rgba(59, 89, 134, 0.25);
  }
  .animation-box h4 {
    margin-bottom: 12px;
  }
  .animation-box-row {
    margin: 10px 0 0px;
  }
  .animation-box {
    padding: 0 20px;
  }
  .getresults-content {
    padding: 0 15px;
  }
}
.relevent-box h4 {
  font-weight: 800;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.05em;
  margin-bottom: 20px;
}

.relevent-box p {
  font-size: 13px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.05em;
  margin: 0;
}

.relevent-box {
  width: 25%;
  padding: 0 11px;
}

.relevent-box-content {
  background: #fff;
  box-shadow: 0px 10px 20px rgba(155, 163, 171, 0.25);
  padding: 40px 20px;
  height: 100%;
  border-radius: 10px;
}

.find-relevent-rwo {
  padding: 0 50px;
  margin-top: 55px;
}

.landing-section-4 .landing-common-description {
  max-width: 65%;
  margin-left: auto;
  margin-right: auto;
}

.landing-section-4 .landing-common-title {
  max-width: 85%;
}

@media (min-width: 768px) and (max-width: 991px) {
  .relevent-box {
    width: 50%;
    margin-bottom: 20px;
  }
  .find-relevent-rwo {
    flex-wrap: wrap;
  }
  .relevent-box-content {
    box-shadow: 0px 0px 5px rgba(155, 163, 171, 0.25);
  }
}
@media (max-width: 767px) {
  .relevent-box {
    width: 100%;
    margin-bottom: 20px;
  }
  .find-relevent-rwo {
    padding: 0;
    margin-top: 30px;
    flex-wrap: wrap;
  }
  .relevent-box-content {
    box-shadow: 0px 0px 5px rgba(155, 163, 171, 0.25);
    padding: 20px 30px;
    height: auto;
    background-color: #eaeff7;
  }
  .relevent-box h4 {
    font-size: 16px;
    margin-bottom: 15px;
  }
  .landing-section-4 .landing-common-description {
    max-width: 90%;
  }
  .technology-show-box-left, .technology-show-box-right {
    margin-top: 10px;
    margin-bottom: 10px;
  }
}
.technology-cont-icon {
  margin-right: 28px;
}

.technology-show-box-left,
.technology-show-box-right {
  margin-top: 30px;
  margin-bottom: 30px;
}

.technology-cont-text h4 {
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.05em;
  margin-bottom: 15px;
}

.technology-show-box-right {
  padding-left: 50px;
}

.technology-show-box-left {
  padding-right: 20px;
}

.landing-section-5 .landing-common-description {
  max-width: 75%;
  margin-left: auto;
  margin-right: auto;
}

.technology-show-row {
  margin-top: 40px;
}

@media (max-width: 991px) {
  .technology-show-row .technology-show-box {
    align-items: flex-start !important;
  }
}
@media (max-width: 767px) {
  .landing-section-5 .landing-common-description {
    max-width: 100%;
  }
  .technology-show-box-left {
    padding-right: 15px;
    padding-left: 15px;
  }
  .technology-show-box-right {
    padding-left: 15px;
  }
  .technology-cont-text {
    flex: 1;
  }
  .technology-cont-icon {
    margin-right: 0;
    width: 80px;
    padding-top: 3px;
    padding-right: 10px;
  }
  .technology-cont-icon img {
    max-width: 100%;
  }
  .technology-show-row {
    margin-top: 20px;
  }
  .technology-cont-text h4 {
    font-size: 16px;
  }
  .technology-show-box-left,
  .technology-show-box-right {
    margin-top: 10px;
    margin-bottom: 10px;
  }
}
.discoversec-content-box-wrap {
  margin: 0 -160px 0 -50px;
}

.discoversec-content-box {
  background: #ffffff;
  box-shadow: 0px 20px 20px rgba(59, 89, 134, 0.25);
  padding: 45px 30px;
  border-radius: 10px;
}

.discover-count-box h4 {
  font-weight: 700;
  font-size: 20px;
  line-height: 29px;
  letter-spacing: 0.05em;
}

.discover-count-box h6 {
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.05em;
}

.discover-count-box label {
  font-size: 11px;
  line-height: 20px;
  letter-spacing: 0.05em;
}

.discover-count-box {
  margin-top: 30px;
  margin-bottom: 30px;
}

.discoversec-content-box h3 {
  font-weight: 800;
  font-size: 30px;
  line-height: 34px;
  letter-spacing: 0.05em;
  margin-bottom: 25px;
}

@media (min-width: 992px) and (max-width: 1024px) {
  .discoversec-content-box-wrap {
    margin-left: -20px;
  }
  .discoversec-content-box h3 {
    font-size: 20px;
    line-height: 26px;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .discoversec-content-box-wrap {
    margin-left: 0;
  }
}
@media (max-width: 767px) {
  .discoversec-content-box-wrap {
    margin: 0;
  }
  .discoversec-content-box h3 {
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 15px;
  }
  .discover-count-box h4 {
    font-size: 20px;
    line-height: 24px;
  }
  .discover-count-box h6 {
    font-size: 13px;
  }
  .discoversec-content-box {
    box-shadow: 0px 0px 10px rgba(59, 89, 134, 0.25);
    padding: 20px 20px;
    text-align: center;
    margin-top: 20px;
  }
  .discover-count-box {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .discover-count-box label {
    font-size: 11px;
    line-height: 12px;
  }
}
.experience-slider-box h4 {
  font-weight: 800;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.05em;
  margin-bottom: 16px;
}

.experience-slider-box {
  padding: 40px 20px;
  background: #DDEAFC;
  min-height: 191px;
  box-shadow: 0px 2px 5px 0px #D5DFED;
  border-radius: 10px;
}

.land-owl-prev,
.land-owl-next {
  margin: 5px;
  border-radius: 3px;
  cursor: pointer;
  z-index: 1;
}

.land-owl-prev {
  position: absolute;
  left: -50px;
  top: 50%;
  margin-top: -35px !important;
  background: transparent !important;
  border: none;
  color: #1A73E8 !important;
  font-size: 50px !important;
  width: auto !important;
  height: auto !important;
  line-height: 50px !important;
  padding: 0 !important;
}

.land-owl-next {
  position: absolute;
  right: -50px;
  top: 50%;
  margin-top: -35px !important;
  background: transparent !important;
  border: none;
  color: #1A73E8 !important;
  font-size: 50px !important;
  width: auto !important;
  height: auto !important;
  line-height: 50px !important;
  padding: 0 !important;
}

.land-experience-slider-wrapper {
  margin-top: 50px;
}
.land-experience-slider-wrapper .slick-list {
  padding: 10px 0 30px;
  margin: 0 -5px;
}
.land-experience-slider-wrapper .slick-slide > div {
  padding: 0 5px;
}
.land-experience-slider-wrapper .land-carousel {
  margin-bottom: 10px;
}

.landing-section-7 .landing-common-description {
  max-width: 80%;
  margin-left: auto;
  margin-right: auto;
}

.land-owl-next span, .land-owl-prev span {
  position: relative;
  top: -1px;
}

@media (min-width: 768px) and (max-width: 991px) {
  .land-owl-next {
    right: -30px;
  }
  .land-owl-prev {
    left: -30px;
  }
  .experience-slider-box h4 {
    font-size: 16px;
  }
}
@media (max-width: 767px) {
  .landing-section-7 .landing-common-description {
    max-width: 100%;
  }
  .experience-slider-box {
    padding-bottom: 60px;
    min-height: 232px;
  }
  .land-owl-next {
    right: calc(50% - 40px);
  }
  .land-owl-prev {
    left: calc(50% - 40px);
  }
  .land-carousel .land-owl-next,
  .land-carousel .land-owl-prev {
    top: inherit;
    bottom: 15px !important;
    height: 30px !important;
    width: 30px !important;
    line-height: 20px !important;
    font-size: 22px !important;
    background: #ddeafc !important;
    color: #000 !important;
  }
}
.client-slider-section .slick-slide img {
  width: auto;
  max-height: 100%;
  max-width: 100%;
}

.client-logo-wrap {
  padding: 0 15px;
}

.landing-section-8 .land-carousel {
  padding-bottom: 5px;
}

.client-logo-wrap {
  padding: 0 15px;
  height: 100px;
  display: flex;
  align-items: center;
  width: 100%;
  flex: 1;
  justify-content: center;
}

.client-logo-text {
  font-weight: bold;
  color: #A4A4A4;
}

@media (max-width: 767px) {
  .landing-section-8 .landing-common-title {
    margin-bottom: 10px;
  }
  .landing-section-8 .land-carousel .land-owl-next, .landing-section-8 .land-carousel .land-owl-prev {
    bottom: -20px !important;
  }
}
.land-contact-section-bg {
  background-size: cover;
  background-repeat: no-repeat;
  position: absolute;
  width: 50%;
  bottom: 0;
  pointer-events: none;
  z-index: 1;
  top: 0;
  background-position: top;
}

.land-contact-section .textarea-item {
  height: 70px;
  border: none;
  max-height: 70px;
  min-height: 70px;
}

.contact-header label {
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.05em;
  margin-bottom: 15px;
}

.PhoneInputCountry {
  width: auto;
  position: relative;
  font-size: 12px;
  padding-left: 58px;
}

.input-item.PhoneInput {
  display: flex;
  width: 100%;
}

.PhoneInputCountryIcon.PhoneInputCountryIcon--border {
  position: absolute;
  width: 58px;
  height: auto;
  left: 0px;
  top: 0;
}

select.PhoneInputCountrySelect {
  background-color: #f3f5f7;
  border-radius: 8px;
  height: 39px;
  border: none;
  font-size: 12px;
  width: 200px;
  padding-left: 7px;
}

.PhoneInputInput {
  background-color: #f3f5f7;
  border-radius: 8px;
  height: 39px;
  border: none;
  font-size: 12px;
  width: 100%;
  margin-left: 15px;
  padding: 0 10px;
}

img.PhoneInputCountryIconImg {
  border-radius: 3px 0 0 3px;
}

input.PhoneInputInput:focus, select.PhoneInputCountrySelect:focus {
  border: none;
  outline: none;
}

.land-contact-formwrap {
  padding: 0 0 0 40px;
}

.land-contact-formwrap .landing-common-title {
  max-width: 100%;
}

@media (min-width: 768px) {
  .PhoneInputInput {
    width: calc(50% + 1px);
    margin-left: 24px;
  }
  .PhoneInputCountry {
    width: 50%;
  }
  select.PhoneInputCountrySelect {
    width: 100%;
  }
}
@media (min-width: 1400px) {
  .land-contact-section-bg {
    width: 46%;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .land-contact-section-bg {
    display: none;
  }
  .land-contact-space {
    display: none;
  }
  .land-contact-formwrap {
    padding: 0;
  }
}
@media (max-width: 767px) {
  .land-contact-formwrap {
    padding: 0;
  }
  .land-contact-section-bg {
    position: inherit;
    height: 300px;
    width: 100%;
    background-position: top;
  }
  .land-contact-section {
    padding: 0px 0 30px;
  }
  .input-item.PhoneInput {
    flex-wrap: wrap;
  }
  .PhoneInputInput {
    margin-left: 0;
    margin-top: 10px;
  }
  .PhoneInputCountry {
    width: 100%;
  }
  select.PhoneInputCountrySelect {
    width: 100%;
  }
  .contact-header {
    text-align: center;
  }
  .landing-section-8 {
    padding: 30px 0 40px;
  }
  .land-contact-section form .btn {
    width: 100%;
  }
}
.landing-section-ai {
  padding: 90px 0;
  background-color: #DDEAFC;
}
.landing-section-ai .landing-common-title {
  margin-left: 0;
  max-width: 100%;
}

.icon-cont-box {
  border-radius: 10px;
  background: #FFF;
  border-top: 7px solid transparent;
  min-height: 150px;
  height: 100%;
  box-shadow: 0px 20px 20px 0px rgba(35, 66, 112, 0.24);
  padding: 25px;
  display: flex;
  align-items: center;
}
.icon-cont-box .img-area {
  margin: 0 24px 0 0;
}
.icon-cont-box:hover {
  border-top: 7px solid #1A73E8;
}

@media (max-width: 767px) {
  .landing-section-ai .landing-common-title {
    text-align: center;
  }
  .landing-section-ai {
    padding: 30px 0;
  }
}
@media (max-width: 575px) {
  .icon-cont-box {
    min-height: 100%;
  }
}
.land-video-box {
  position: relative;
  width: 100%;
  max-width: 1000px;
  margin: auto;
  overflow: hidden;
}

.land-video-box::before {
  content: "";
  display: block;
  padding-top: 56.25%;
  /* 16:9 Aspect Ratio */
}

.land-video-box iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 15px;
}

.video-frame-section {
  padding: 71px 0 79px;
  background-color: #DDEAFC;
}

.land-videoframe-header-box {
  max-width: 687px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 40px;
}
.land-videoframe-header-box .landing-common-title {
  max-width: 100%;
}

@media (min-aspect-ratio: 16/9) {
  .land-video-box {
    max-height: 600px;
    height: 100vw;
    max-width: 1066.6666666667px;
  }
  .land-video-box::before {
    padding-top: 0;
  }
}
.banner-desc {
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.05em;
  color: #ffffff;
}

.about-content-sec {
  padding: 80px 0;
}

.about-content-sec-2 {
  background: #ddeafc;
}

.aboutus-head-wrap {
  padding-left: 50px;
}

.aboutus-title {
  font-weight: 800;
  font-size: 28px;
  line-height: 34px;
  letter-spacing: 0.05em;
  color: #000000;
}

.aboutus-desc-wrap p {
  font-size: 13px;
  line-height: 22px;
  letter-spacing: 0.05em;
  margin-bottom: 20px;
}

.aboutus-desc-wrap p:last-child {
  margin-bottom: 0;
}

.aboutus-desc-wrap {
  padding-right: 10%;
}

@media (min-width: 768px) and (max-width: 991px) {
  .aboutus-title {
    font-size: 20px;
    line-height: 26px;
  }
  .aboutus-head-wrap {
    padding-left: 30px;
  }
  .about-content-sec {
    padding: 40px 0;
  }
}
@media (max-width: 767px) {
  .aboutus-head-wrap {
    padding-left: 0px;
  }
  .about-content-sec {
    padding: 30px 0 34px;
    text-align: center;
  }
  .aboutus-desc-wrap {
    padding-right: 0;
  }
  .aboutus-title {
    font-size: 20px;
    line-height: 26px;
  }
}
.career-content-sec-2 {
  background: #ddeafc;
}

.career-content-sec {
  padding: 80px 0;
}

.career-content-sec-1 .landing-common-description {
  max-width: 82%;
}

.career-content-sec .technology-cont-text p {
  max-width: 80%;
  margin-bottom: 0;
}

.careers-show-box-left, .careers-show-box-right {
  margin: 30px 0;
}

.career-main-content {
  margin: 0 auto;
  max-width: 65%;
}

.career-main-content h6 {
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.05em;
  color: #000000;
  margin-top: 34px;
}

@media (min-width: 768px) and (max-width: 991px) {
  .career-content-sec {
    padding: 50px 0;
  }
  .career-main-content {
    max-width: 90%;
  }
}
@media (max-width: 767px) {
  .career-content-sec {
    padding: 30px 0;
  }
  .career-content-sec .technology-cont-text p {
    max-width: 100%;
  }
  .career-main-content {
    max-width: 100%;
  }
}
.sales-content-section-wrap {
  background-color: #ddeafc;
  padding: 77px 20px 60px;
}

.sales-enquiry-box {
  max-width: 690px;
  margin: 0 auto;
  background: #fff;
  padding: 50px 77px;
  border-radius: 3px;
}

.sales-mail-text {
  max-width: 690px;
  margin: 0 auto;
  text-align: center;
  padding-top: 50px;
}

.sales-mail-text p {
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.05em;
  color: #000000;
}

.sales-mail-text p a {
  color: #1A73E8;
}

.sales-content-section-wrap .landing-common-title {
  font-size: 28px;
  max-width: 100%;
}

.sales-enquiry-box .form-control.textarea-item {
  max-height: 66px;
}

@media (min-width: 768px) and (max-width: 991px) {
  .sales-content-section-wrap .landing-common-title {
    font-size: 20px;
  }
}
@media (max-width: 767px) {
  .sales-enquiry-box {
    padding: 30px 20px;
  }
  .sales-content-section-wrap .landing-common-title {
    font-size: 20px;
  }
  .sales-content-section-wrap {
    background-color: #ddeafc;
    padding: 30px 20px 20px;
  }
  .sales-mail-text {
    padding-top: 30px;
  }
}
.termsofuse-content p {
  font-size: 13px;
  line-height: 25px;
  letter-spacing: 0.05em;
  color: #000000;
  margin-bottom: 25px;
}

.terms-sections p:last-child {
  margin-bottom: 0;
}

.terms-sections {
  padding: 35px 0;
}

.terms-title {
  font-weight: 700;
  font-size: 25px;
  line-height: 30px;
  letter-spacing: 0.05em;
  margin-bottom: 0;
}

.terms-header p {
  font-weight: 400;
}

.terms-gray-sec {
  background: #ddeafc;
}

.terms-sub-header .terms-title {
  font-weight: 700;
  font-size: 18px;
  line-height: 25px;
  letter-spacing: 0.05em;
  color: #000000;
  margin-bottom: 20px;
}

span.terms-content-sticking {
  font-weight: bold;
}

.terms-title span {
  margin-right: 5px;
  display: inline-block;
}

.terms-header {
  margin-bottom: 30px;
}

.terms-contents ol {
  margin: 0;
  padding-left: 15px;
}

.terms-contents ol li {
  line-height: 24px;
  margin-bottom: 20px;
  padding-left: 15px;
  font-weight: 500;
  font-size: 13px;
  line-height: 25px;
  letter-spacing: 0.05em;
  color: #000000;
}

.terms-contents ol li:last-child {
  margin-bottom: 0;
}

@media (max-width: 767px) {
  .terms-contents ol li {
    margin-bottom: 10px;
    line-height: 22px;
  }
  .terms-sub-header .terms-title {
    font-size: 16px;
    line-height: 22px;
  }
  .terms-title {
    font-size: 20px;
  }
  .termsofuse-content p {
    line-height: 22px;
  }
  .terms-sections {
    padding: 30px 0;
  }
}
.unified-sidebar {
  width: 285px;
  flex-shrink: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 12px 16px;
  color: #1A1A1A;
  font-family: "Montserrat", sans-serif;
  background: #F4F6F7;
  overflow: hidden;
  transition: width 0.22s ease;
}
@media (min-width: 992px) {
  .unified-sidebar.is-collapsed {
    width: 64px;
  }
}
@media (max-width: 991.98px) {
  .unified-sidebar {
    position: fixed;
    top: 64px;
    left: 0;
    bottom: 0;
    width: 300px;
    max-width: 85vw;
    transform: translateX(-100%);
    transition: transform 0.25s ease;
    z-index: 50;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  }
  .unified-sidebar.is-open {
    transform: translateX(0);
  }
}
@media (max-width: 767.98px) {
  .unified-sidebar {
    top: 56px;
  }
}

.usb-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 14px;
  padding: 0 6px;
}
.usb-header .usb-logo-title,
.usb-header .usb-subtitle {
  display: none;
}

.usb-icon-btn {
  all: unset;
  box-sizing: border-box;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 8px;
  color: #24252D;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.usb-icon-btn svg {
  display: block;
  transition: transform 0.22s ease;
}
.usb-icon-btn:hover {
  background-color: #E8EAED;
  color: #1A1A1A;
}
.usb-icon-btn:focus-visible {
  outline: 2px solid #1A73E8;
  outline-offset: 2px;
}
@media (max-width: 991.98px) {
  .usb-icon-btn {
    width: 44px;
    height: 44px;
  }
}

.usb-section-label.usb-history-label {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0;
  padding: 0;
  font-size: 0;
  text-transform: none;
}
.usb-section-label.usb-history-label .usb-new-chat-btn {
  order: -1;
}

.usb-section-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  width: calc(100% - 16px);
  margin: 4px 8px 2px;
  padding: 6px 4px;
  background: transparent;
  border: 0;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #6B7280;
  letter-spacing: 0.1px;
  cursor: pointer;
  text-align: left;
}
.usb-section-toggle:hover {
  background: #E8EAED;
  color: #1A1A1A;
}

.usb-section-chevron {
  display: inline-block;
  width: 10px;
  transition: transform 0.15s ease;
}
.usb-section-chevron.is-open {
  transform: rotate(90deg);
}

.usb-show-more-btn {
  display: block;
  margin: 0 8px 4px;
  padding: 4px 12px;
  background: transparent;
  border: 0;
  border-radius: 6px;
  font-size: 12px;
  color: #A0A4AB;
  cursor: pointer;
}
.usb-show-more-btn:hover {
  background: #E8EAED;
  color: #1A1A1A;
}

.usb-new-chat-btn {
  all: unset;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 14px 16px;
  background: #FFFFFF;
  color: #1A1A1A;
  border: 1px solid #DADCEB;
  border-radius: 10px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  box-shadow: 2px 2px 4px 0px rgba(238, 238, 238, 0.25);
  transition: background-color 0.15s ease, box-shadow 0.15s ease;
  box-sizing: border-box;
  text-align: center;
  font-size: 0;
}
.usb-new-chat-btn::before {
  content: "";
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: contain;
  background-repeat: no-repeat;
}
.usb-new-chat-btn::after {
  content: "New Chat";
  font-size: 14px;
  font-weight: 500;
}
.usb-new-chat-btn:hover {
  background: #FAFBFC;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.08);
}

.usb-section-label {
  padding: 8px 12px 4px;
  font-size: 13px;
  font-weight: 500;
  color: #6B7280;
  letter-spacing: 0.1px;
  text-transform: none;
}

.usb-empty {
  padding: 12px 16px;
  font-size: 13px;
  color: #A0A4AB;
}

.usb-load-more-btn {
  display: block;
  width: calc(100% - 16px);
  margin: 4px 8px 8px;
  padding: 6px 12px;
  background: transparent;
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  font-size: 12px;
  color: #A0A4AB;
  cursor: pointer;
  text-align: center;
}
.usb-load-more-btn:hover {
  background: #E8EAED;
  color: #1A1A1A;
}
.usb-load-more-btn:disabled {
  cursor: default;
  opacity: 0.7;
}
.usb-load-more-btn:disabled:hover {
  background: transparent;
  color: #A0A4AB;
}

.usb-older {
  margin-top: 8px;
  border-top: 1px solid #E5E7EB;
  padding-top: 4px;
}

.usb-retry-btn {
  padding: 0;
  background: transparent;
  border: 0;
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
}

.usb-loading {
  pointer-events: none;
}

.usb-skeleton-item {
  cursor: default;
}
.usb-skeleton-item:hover {
  background: transparent;
}

.usb-skeleton-line {
  display: block;
  height: 10px;
  border-radius: 5px;
  background: linear-gradient(90deg, #E8EAED 0%, #f4f5f7 50%, #E8EAED 100%);
  background-size: 200% 100%;
  animation: usb-skeleton-shimmer 1.4s ease-in-out infinite;
}

@keyframes usb-skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  .usb-skeleton-line {
    animation: none;
  }
}
.usb-history-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: #D5D8DC transparent;
}
.usb-history-scroll::-webkit-scrollbar {
  width: 6px;
}
.usb-history-scroll::-webkit-scrollbar-thumb {
  background: #D5D8DC;
  border-radius: 3px;
}
.usb-history-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.usb-chat-list {
  list-style: none;
  padding: 0;
  margin: 0 0 4px;
}

.usb-chat-item {
  position: relative;
  display: flex;
  align-items: center;
  padding: 10px 12px;
  margin: 2px 0;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  color: #1A1A1A;
  cursor: pointer;
  transition: background-color 0.12s ease;
  gap: 8px;
}
.usb-chat-item .usb-item-menu-btn {
  width: 26px;
  height: 26px;
  border: none;
  background: transparent;
  color: #6B7280;
  border-radius: 6px;
  opacity: 0;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.15s ease, background-color 0.15s ease;
  flex-shrink: 0;
  margin-left: auto;
}
.usb-chat-item .usb-item-menu-btn:hover {
  background: rgba(0, 0, 0, 0.06);
  color: #1A1A1A;
}
@media (hover: none) {
  .usb-chat-item .usb-item-menu-btn {
    opacity: 1;
  }
}
.usb-chat-item:hover {
  background: #E8EAED;
}
.usb-chat-item:hover .usb-item-menu-btn {
  opacity: 1;
}
.usb-chat-item .usb-row-menu.show .usb-item-menu-btn {
  opacity: 1;
}
.usb-chat-item.active {
  background: #E1E5EA;
  color: #1A1A1A;
  font-weight: 500;
}
.usb-chat-item.is-dragging {
  z-index: 1;
  background: #E8EAED;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  cursor: grabbing;
}

.usb-chat-icon {
  display: none;
}

.usb-pin-mark {
  display: inline-flex;
  flex-shrink: 0;
  color: #1A73E8;
}
.usb-pin-mark svg {
  transform: rotate(45deg);
}

.usb-chat-title {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.usb-rename-input {
  flex: 1;
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  padding: 4px 8px;
  font-family: inherit;
  font-size: 13px;
  color: #1A1A1A;
  outline: none;
  min-width: 0;
}
.usb-rename-input:focus {
  border-color: #1A73E8;
}

.usb-rename-counter {
  margin-left: 6px;
  font-size: 11px;
  font-variant-numeric: tabular-nums;
  color: #A0A4AB;
  flex-shrink: 0;
}
.usb-rename-counter.is-warning {
  color: #B07A00;
}
.usb-rename-counter.is-danger {
  color: #C22;
  font-weight: 600;
}

.usb-rename-actions {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: 6px;
  flex-shrink: 0;
}
.usb-rename-actions button {
  all: unset;
  width: 22px;
  height: 22px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #6B7280;
  cursor: pointer;
}
.usb-rename-actions button:hover {
  background: rgba(0, 0, 0, 0.06);
  color: #1A1A1A;
}
.usb-rename-actions button:disabled, .usb-rename-actions button[disabled] {
  opacity: 0.4;
  cursor: not-allowed;
}
.usb-rename-actions button:disabled:hover, .usb-rename-actions button[disabled]:hover {
  background: transparent;
  color: #6B7280;
}

@media (min-width: 992px) {
  .unified-sidebar.is-collapsed {
    padding: 16px 10px;
  }
  .unified-sidebar.is-collapsed .usb-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 0;
    margin: 0 0 12px;
  }
  .unified-sidebar.is-collapsed .usb-panel-toggle {
    order: 0;
  }
  .unified-sidebar.is-collapsed .usb-search-trigger {
    order: 1;
  }
  .unified-sidebar.is-collapsed .usb-panel-toggle svg {
    transform: rotate(180deg);
  }
  .unified-sidebar.is-collapsed .usb-section-label,
  .unified-sidebar.is-collapsed .usb-chat-list,
  .unified-sidebar.is-collapsed .usb-history-scroll,
  .unified-sidebar.is-collapsed .usb-loading,
  .unified-sidebar.is-collapsed .usb-empty {
    display: none;
  }
  .unified-sidebar.is-collapsed .usb-section-label.usb-history-label {
    display: block;
    padding: 0;
  }
  .unified-sidebar.is-collapsed .usb-section-label.usb-history-label::after {
    display: none;
  }
  .unified-sidebar.is-collapsed .usb-new-chat-btn {
    all: unset;
    box-sizing: border-box;
    width: 32px;
    height: 32px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 8px;
    background: transparent;
    border: none;
    box-shadow: none;
    padding: 0;
    margin: 0;
    transition: background-color 0.15s ease;
  }
  .unified-sidebar.is-collapsed .usb-new-chat-btn::after {
    display: none;
  }
  .unified-sidebar.is-collapsed .usb-new-chat-btn::before {
    width: 18px;
    height: 18px;
    margin: 0;
  }
  .unified-sidebar.is-collapsed .usb-new-chat-btn:hover {
    background-color: #E8EAED;
  }
  .unified-sidebar.is-collapsed .usb-new-chat-btn:focus-visible {
    outline: 2px solid #1A73E8;
    outline-offset: 2px;
  }
}
.usb-row-menu {
  flex-shrink: 0;
  margin-left: auto;
  line-height: 1;
}

.usb-row-menu-list.dropdown-menu {
  min-width: 160px;
  padding: 6px;
  border: 1px solid #E5E7EB;
  border-radius: 10px;
  background: #FFFFFF;
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.12);
  font-size: 13px;
  z-index: 60;
}

.usb-row-menu-item.dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 6px;
  background: transparent;
  border: none;
  color: #1A1A1A;
  cursor: pointer;
  white-space: nowrap;
}
.usb-row-menu-item.dropdown-item .usb-row-menu-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: #6B7280;
  flex-shrink: 0;
}
.usb-row-menu-item.dropdown-item:hover, .usb-row-menu-item.dropdown-item:focus {
  background: #E8EAED;
  color: #1A1A1A;
}
.usb-row-menu-item.dropdown-item:hover .usb-row-menu-icon, .usb-row-menu-item.dropdown-item:focus .usb-row-menu-icon {
  color: #1A1A1A;
}
.usb-row-menu-item.dropdown-item:active {
  background: #E1E5EA;
}
.usb-row-menu-item.dropdown-item.usb-row-menu-item--danger {
  color: #D92D20;
}
.usb-row-menu-item.dropdown-item.usb-row-menu-item--danger .usb-row-menu-icon {
  color: #D92D20;
}
.usb-row-menu-item.dropdown-item.usb-row-menu-item--danger:hover, .usb-row-menu-item.dropdown-item.usb-row-menu-item--danger:focus {
  background: rgba(217, 45, 32, 0.08);
  color: #D92D20;
}
.usb-row-menu-item.dropdown-item.usb-row-menu-item--danger:hover .usb-row-menu-icon, .usb-row-menu-item.dropdown-item.usb-row-menu-item--danger:focus .usb-row-menu-icon {
  color: #D92D20;
}

.dcm-dialog {
  max-width: 380px;
}
.dcm-dialog .modal-content {
  border: none;
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.18);
}

.dcm-body {
  padding: 22px 22px 18px;
}

.dcm-title {
  font-size: 18px;
  font-weight: 600;
  color: #1A1A1A;
  margin: 0 0 8px;
}

.dcm-text {
  font-size: 14px;
  line-height: 1.5;
  color: #6B7280;
  margin: 0 0 18px;
}
.dcm-text strong {
  color: #1A1A1A;
  font-weight: 600;
  word-break: break-word;
}

.dcm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.dcm-btn {
  appearance: none;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid transparent;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}
.dcm-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.dcm-btn--cancel {
  background: #FFFFFF;
  border-color: #E5E7EB;
  color: #1A1A1A;
}
.dcm-btn--cancel:hover:not(:disabled) {
  background: #E8EAED;
}

.dcm-btn--danger {
  background: #D92D20;
  color: #fff;
  border-color: #D92D20;
}
.dcm-btn--danger:hover:not(:disabled) {
  background: #B42318;
  border-color: #B42318;
}

.chat-search-modal .chat-search-modal-dialog {
  max-width: 580px;
  width: calc(100% - 32px);
  margin: 0 auto;
}
.chat-search-modal .modal-content {
  border: none;
  border-radius: 14px;
  box-shadow: 0 24px 48px rgba(16, 24, 40, 0.14), 0 2px 6px rgba(16, 24, 40, 0.06);
  overflow: hidden;
  background: #FFFFFF;
}
.chat-search-modal .modal-body {
  padding: 0;
}

.csm-search {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 20px 24px;
  border-bottom: 1px solid #EEF0F2;
}

.csm-search-icon {
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #1A1A1A;
  flex-shrink: 0;
}
.csm-search-icon svg {
  width: 20px;
  height: 20px;
}

.csm-search-input {
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-family: "Montserrat", sans-serif;
  font-size: 15px;
  font-weight: 400;
  color: #1A1A1A;
  line-height: 1.4;
  padding: 0;
}
.csm-search-input::placeholder {
  color: #9CA3AF;
}

.csm-close {
  all: unset;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #1A1A1A;
  cursor: pointer;
  border-radius: 6px;
  flex-shrink: 0;
  transition: background-color 0.15s ease;
}
.csm-close svg {
  display: block;
}
@media (hover: hover) {
  .csm-close:hover {
    background: rgba(0, 0, 0, 0.04);
  }
}
.csm-close:focus-visible {
  outline: 2px solid #1A73E8;
  outline-offset: 2px;
}

.csm-section-label {
  padding: 18px 24px 10px;
  font-size: 14px;
  font-weight: 500;
  color: #1A1A1A;
  letter-spacing: 0;
  font-family: "Montserrat", sans-serif;
}

.csm-list {
  list-style: none;
  margin: 0;
  padding: 0 0 12px;
  max-height: min(420px, 60vh);
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #D5D8DC transparent;
}
.csm-list::-webkit-scrollbar {
  width: 6px;
}
.csm-list::-webkit-scrollbar-thumb {
  background: #D5D8DC;
  border-radius: 3px;
}
.csm-list::-webkit-scrollbar-track {
  background: transparent;
}

.csm-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 11px 24px;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #1A1A1A;
  cursor: pointer;
  transition: background-color 0.12s ease;
}
@media (hover: hover) {
  .csm-row:hover {
    background: #E8EAED;
  }
}

.csm-row-title {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.csm-row-pin {
  display: inline-flex;
  flex-shrink: 0;
  color: #6B7280;
}

.csm-row-date {
  flex-shrink: 0;
  color: #6B7280;
  font-size: 13px;
  font-weight: 400;
  white-space: nowrap;
}

.csm-empty {
  padding: 20px 24px;
  color: #A0A4AB;
  font-size: 14px;
  text-align: center;
  font-family: "Montserrat", sans-serif;
}

@media (max-width: 767px) {
  .chat-search-modal .chat-search-modal-dialog {
    max-width: 100%;
    width: calc(100% - 16px);
    margin: 8px auto;
  }
  .chat-search-modal .modal-content {
    border-radius: 12px;
  }
  .csm-search {
    padding: 16px 18px;
    gap: 12px;
  }
  .csm-search-input {
    font-size: 16px;
  }
  .csm-section-label {
    padding: 14px 18px 8px;
  }
  .csm-list {
    max-height: min(60vh, 100vh - 180px);
  }
  .csm-row {
    padding: 12px 18px;
    gap: 12px;
  }
  .csm-empty {
    padding: 18px 18px;
  }
}
@media (max-width: 480px) {
  .chat-search-modal .chat-search-modal-dialog {
    width: calc(100% - 12px);
    margin: 6px auto;
  }
}
.sources-panel {
  flex-shrink: 0;
  width: 360px;
  background: #FFFFFF;
  border-left: 1px solid #E5E7EB;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: sp-slide-in 180ms ease-out;
  z-index: 40;
}
@media (max-width: 1199.98px) {
  .sources-panel {
    width: 320px;
  }
}
@media (max-width: 991.98px) {
  .sources-panel {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: min(380px, 90%);
    box-shadow: -4px 0 20px rgba(16, 24, 40, 0.08);
    z-index: 60;
  }
}
@media (max-width: 767.98px) {
  .sources-panel {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    max-width: 100vw;
    box-shadow: none;
    z-index: 1080;
  }
}

@keyframes sp-slide-in {
  from {
    transform: translateX(12px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
.sources-panel-backdrop {
  display: none;
}
@media (max-width: 991.98px) {
  .sources-panel-backdrop {
    display: block;
    position: absolute;
    inset: 0;
    background: rgba(16, 24, 40, 0.25);
    z-index: 55;
  }
}
@media (max-width: 767.98px) {
  .sources-panel-backdrop {
    position: fixed;
    z-index: 1079;
    background: rgba(16, 24, 40, 0.4);
  }
}

.sp-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 20px;
  border-bottom: 1px solid #E5E7EB;
  flex-shrink: 0;
  position: relative;
  z-index: 1;
  background: #FFFFFF;
}

.sp-title {
  font-size: 18px;
  font-weight: 600;
  color: #1A1A1A;
}

.sp-close-btn {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  color: #6B7280;
  border-radius: 8px;
  cursor: pointer;
  padding: 0;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.sp-close-btn:hover {
  background: #E8EAED;
  color: #1A1A1A;
}

.sp-view-switch {
  display: flex;
  gap: 4px;
  margin: 12px 16px 0;
  padding: 3px;
  background: #E8EAED;
  border-radius: 8px;
  flex-shrink: 0;
}

.sp-view-btn {
  flex: 1;
  padding: 6px 10px;
  border: none;
  border-radius: 6px;
  background: transparent;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  color: #6B7280;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.sp-view-btn:hover {
  color: #1A1A1A;
}
.sp-view-btn:focus-visible {
  outline: 2px solid #1A73E8;
  outline-offset: 1px;
}
.sp-view-btn.is-active {
  background: #FFFFFF;
  color: #1A1A1A;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.08);
}

.sp-cards {
  flex: 1;
  overflow-y: auto;
  padding: 12px 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.sp-card {
  display: block;
  text-decoration: none;
  background: #FFFFFF;
  border: 1px solid #E5E7EB;
  border-radius: 10px;
  padding: 12px 14px;
  color: inherit;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease, transform 0.15s ease;
}
.sp-card:hover {
  border-color: #D1D5DB;
  box-shadow: 0 2px 8px rgba(16, 24, 40, 0.06);
}
.sp-card:focus-visible {
  outline: 2px solid #1A73E8;
  outline-offset: 2px;
}
.sp-card--highlight {
  animation: sp-flash 1.5s ease-out;
}

@keyframes sp-flash {
  0% {
    background: #E8F0FE;
    border-color: #1A73E8;
  }
  60% {
    background: #E8F0FE;
    border-color: #1A73E8;
  }
  100% {
    background: #FFFFFF;
    border-color: #E5E7EB;
  }
}
.sp-card-head {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.sp-card-index {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #E8EAED;
  color: #1A1A1A;
  font-size: 11px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  margin-top: 1px;
}

.sp-card-title {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  font-weight: 500;
  color: #1A1A1A;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}

.sp-card-type {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  color: #6B7280;
}

.sp-card-type-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #6B7280;
}

.sp-card-type-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.6px;
  color: #6B7280;
  text-transform: uppercase;
}

.unified-feed {
  display: flex;
  flex-direction: row;
  flex: 1;
  min-width: 0;
  height: 100%;
  background: #FFFFFF;
  color: #1A1A1A;
  font-family: "Montserrat", sans-serif;
  position: relative;
}

.uf-main {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  height: 100%;
  transition: width 180ms ease, flex-basis 180ms ease;
}

.uf-header {
  display: none;
}

.uf-title {
  font-size: 26px;
  font-weight: 700;
  color: #1A1A1A;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin: 0;
}

.uf-beta-badge {
  font-size: 11px;
  font-weight: 600;
  background: #e8e8e8;
  color: #6B7280;
  border-radius: 4px;
  padding: 2px 7px;
}

.uf-subtitle {
  font-size: 13px;
  color: #A0A4AB;
  margin: 6px 0 0;
}

.uf-messages {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 24px 60px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.uf-messages > * {
  width: 100%;
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
  min-width: 0;
  box-sizing: border-box;
}
@media (max-width: 1199.98px) {
  .uf-messages {
    padding: 24px 32px;
  }
}
@media (max-width: 991.98px) {
  .uf-messages {
    padding: 20px 24px;
  }
}
@media (max-width: 575.98px) {
  .uf-messages {
    padding: 16px 12px;
  }
}

.uf-empty-state {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  gap: 12px;
  text-align: center;
}
.uf-empty-state p {
  display: none;
}

.uf-empty-greeting {
  font-size: 18px;
  font-weight: 400;
  color: #1A1A1A;
  line-height: 1.4;
}
.uf-empty-greeting .uf-empty-name {
  color: #A0A4AB;
  font-weight: 400;
}

.uf-empty-heading {
  font-size: 36px;
  font-weight: 500;
  color: #1A1A1A;
  margin: 0 0 28px;
  line-height: 1.2;
}
@media (max-width: 767.98px) {
  .uf-empty-heading {
    font-size: 26px;
    margin-bottom: 20px;
  }
}
@media (max-width: 575.98px) {
  .uf-empty-heading {
    font-size: 22px;
  }
}

.uf-input-area {
  flex-shrink: 0;
  padding: 0 60px 16px;
  border-top: none;
}
.uf-input-area > * {
  width: 100%;
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
}
@media (max-width: 1199.98px) {
  .uf-input-area {
    padding: 0 32px 16px;
  }
}
@media (max-width: 991.98px) {
  .uf-input-area {
    padding: 0 24px 12px;
  }
}
@media (max-width: 575.98px) {
  .uf-input-area {
    padding: 0 12px 8px;
  }
}

.uf-empty-state .uf-input-area {
  width: 100%;
  max-width: 820px;
  padding: 0;
}
.uf-empty-state .uf-input-area > * {
  max-width: 820px;
}

.uf-mock-answer {
  font-size: 14px;
  color: #1A1A1A;
  line-height: 1.6;
  margin: 8px 0;
}

.uf-response-footer {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}
.uf-response-footer .fdc-strip {
  margin: 0;
  flex: 1 1 auto;
}
.uf-response-footer .uf-show-refs-btn {
  margin-top: 0;
  margin-left: auto;
  flex-shrink: 0;
}

.uf-show-refs-btn {
  margin-top: 10px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #FFFFFF;
  border: 1px solid #E5E7EB;
  border-radius: 20px;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 500;
  color: #1A1A1A;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}
.uf-show-refs-btn svg {
  color: #6B7280;
}
.uf-show-refs-btn:hover {
  background: #E8EAED;
  border-color: #D1D5DB;
}
.uf-show-refs-btn:hover svg {
  color: #1A1A1A;
}
.uf-show-refs-btn.is-active {
  background: #E8F0FC;
  border-color: #1A73E8;
  color: #1558B0;
}
.uf-show-refs-btn.is-active svg {
  color: #1A73E8;
}

.uf-streaming-cursor {
  display: inline-block;
  color: #A0A4AB;
  font-weight: 600;
  animation: uf-blink 1s steps(1) infinite;
}

@keyframes uf-blink {
  50% {
    opacity: 0;
  }
}
.uf-stream-skeleton {
  align-self: stretch;
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  animation: uf-stream-skeleton-breathe 3.6s ease-in-out infinite;
}
.uf-stream-skeleton__line {
  display: block;
  height: 12px;
  border-radius: 6px;
  background: linear-gradient(90deg, #E8EAED 0%, #F8F9FA 45%, #FFFFFF 50%, #F8F9FA 55%, #E8EAED 100%);
  background-size: 220% 100%;
  animation: uf-stream-shimmer 2.4s linear infinite;
}
.uf-stream-skeleton__line:nth-child(1) {
  width: 92%;
  animation-delay: 0s;
}
.uf-stream-skeleton__line:nth-child(2) {
  width: 58%;
  animation-delay: 0.3s;
}

@keyframes uf-stream-shimmer {
  0% {
    background-position: 220% 0;
  }
  100% {
    background-position: -120% 0;
  }
}
@keyframes uf-stream-skeleton-breathe {
  0%, 100% {
    opacity: 0.7;
  }
  50% {
    opacity: 1;
  }
}
@media (prefers-reduced-motion: reduce) {
  .uf-stream-skeleton,
  .uf-stream-skeleton__line {
    animation: none;
  }
}
.uf-error-row {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 6px;
}

.uf-error-text {
  font-size: 13px;
  color: #D92D20;
}

.uf-retry-btn {
  align-self: flex-start;
  background: rgba(26, 115, 232, 0.1);
  border: none;
  border-radius: 8px;
  padding: 7px 14px;
  font-size: 13px;
  font-weight: 500;
  color: #1A73E8;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.uf-retry-btn:hover {
  background: rgba(26, 115, 232, 0.18);
  color: #1558B0;
}
.uf-retry-btn:active {
  transform: translateY(0.5px);
}
.uf-retry-btn:disabled {
  background: rgba(160, 164, 171, 0.15);
  color: #A0A4AB;
  cursor: not-allowed;
}

.uf-stopped-notice {
  font-size: 12px;
  color: #A0A4AB;
  margin-top: 6px;
}

.uf-finalizing-notice {
  font-size: 12px;
  color: #1A73E8;
  margin-top: 6px;
}

.uf-error-row--inline {
  border-top: 1px dashed #E5E7EB;
  padding-top: 10px;
  margin-top: 12px;
}

.uf-error-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}

.uf-legacy-banner {
  display: flex;
  align-items: center;
  gap: 14px;
  width: fit-content;
  margin: 0 auto 12px;
  padding: 10px 16px;
  background: #F0F4FF;
  border: 1px solid #DADCEB;
  border-radius: 10px;
  font-family: "Montserrat", sans-serif;
  font-size: 13px;
  color: #6B7280;
  line-height: 1.4;
}

.uf-legacy-new-chat-btn {
  all: unset;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: #FFFFFF;
  color: #1A1A1A;
  border: 1px solid #DADCEB;
  border-radius: 10px;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 2px 2px 4px 0px rgba(238, 238, 238, 0.25);
  transition: background-color 0.15s ease, box-shadow 0.15s ease;
  box-sizing: border-box;
}
.uf-legacy-new-chat-btn:hover {
  background: #E8EAED;
}

.uf-input-area--readonly {
  pointer-events: none;
  opacity: 0.45;
  user-select: none;
}

.user-message-row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
  padding: 0;
  background: transparent;
  border-radius: 0;
}
.user-message-row:hover .um-action-btn, .user-message-row:focus-within .um-action-btn {
  opacity: 1;
  visibility: visible;
}

.um-avatar {
  display: none;
}

.um-bubble {
  max-width: 75%;
  padding: 12px 18px;
  background: #F4F6F7;
  color: #1A1A1A;
  border-radius: 18px;
  font-size: 15px;
  line-height: 1.5;
  word-wrap: break-word;
}
@media (max-width: 575.98px) {
  .um-bubble {
    max-width: 90%;
    font-size: 14px;
    padding: 10px 14px;
  }
}

.um-action-btn {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #A0A4AB;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.15s ease, background-color 0.15s ease, color 0.15s ease;
}
.um-action-btn:hover {
  background: #E8EAED;
  color: #1A1A1A;
}
@media (hover: none) {
  .um-action-btn {
    opacity: 1;
    visibility: visible;
  }
}
.um-action-btn.is-copied {
  opacity: 1;
  visibility: visible;
  color: #1F8A4E;
}
.um-action-btn.is-copied:hover {
  background: rgba(31, 138, 78, 0.08);
  color: #1F8A4E;
}

.user-message-row--editing {
  flex-direction: column;
  align-items: flex-end;
}

.um-edit {
  max-width: 75%;
  background: #F4F6F7;
  color: #1A1A1A;
  border-radius: 18px;
  padding: 12px 18px;
}
@media (max-width: 575.98px) {
  .um-edit {
    max-width: 90%;
    padding: 10px 14px;
  }
}

.um-edit-textarea {
  display: block;
  width: 100%;
  min-width: 220px;
  max-height: 320px;
  resize: none;
  border: none;
  outline: none;
  background: transparent;
  color: #1A1A1A;
  font-family: inherit;
  font-size: 15px;
  line-height: 1.5;
  padding: 0;
}
.um-edit-textarea::placeholder {
  color: #A0A4AB;
}
@media (max-width: 575.98px) {
  .um-edit-textarea {
    font-size: 14px;
  }
}

.um-edit-actions {
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
}

.um-edit-cancel {
  background: transparent;
  border: 1px solid #E5E7EB;
  border-radius: 999px;
  padding: 5px 14px;
  font-size: 13px;
  font-weight: 500;
  color: #1A1A1A;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}
.um-edit-cancel:hover {
  background: #E8EAED;
  border-color: #D1D5DB;
}

.um-edit-send {
  background: #1A73E8;
  border: 1px solid #1A73E8;
  border-radius: 999px;
  padding: 5px 16px;
  font-size: 13px;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}
.um-edit-send:hover {
  background: #1558B0;
  border-color: #1558B0;
}
.um-edit-send:disabled {
  background: rgba(26, 115, 232, 0.45);
  border-color: rgba(26, 115, 232, 0.45);
  cursor: not-allowed;
}

.thought-process {
  background: linear-gradient(179.91deg, #FFFFFF 0.08%, #F4F6F7 105.6%);
  border: 1px solid #EAEAEA;
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 16px;
}

.tp-header {
  width: 100%;
  background: transparent;
  border: none;
  padding: 18px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  font-family: "Montserrat", sans-serif;
  font-size: 15px;
  font-weight: 500;
  color: #1A1A1A;
  text-align: left;
}

.tp-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.tp-lead-icon {
  color: #1A73E8;
  flex-shrink: 0;
}
.is-thinking .tp-lead-icon {
  animation: tp-pulse 1.6s ease-in-out infinite;
}

@keyframes tp-pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.45;
  }
}
.tp-title {
  color: #1A1A1A;
  font-weight: 500;
}
.is-thinking .tp-title {
  background: linear-gradient(90deg, #1A1A1A 0%, #1A1A1A 40%, rgba(26, 115, 232, 0.55) 50%, #1A1A1A 60%, #1A1A1A 100%);
  background-size: 200% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  animation: tp-title-shimmer 2s linear infinite;
}

@keyframes tp-title-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  .is-thinking .tp-title {
    animation: none;
    background: none;
    -webkit-text-fill-color: #1A1A1A;
    color: #1A1A1A;
  }
}
.tp-chevron {
  color: #A0A4AB;
  transition: transform 0.2s ease;
  flex-shrink: 0;
}
.tp-chevron.tp-chevron-up {
  transform: rotate(180deg);
}

.tp-timeline {
  list-style: none;
  margin: 0;
  padding: 4px 24px 22px 28px;
  position: relative;
}
.tp-timeline::before {
  content: "";
  position: absolute;
  left: 32px;
  top: 12px;
  bottom: 12px;
  width: 1px;
  background: rgba(26, 115, 232, 0.18);
}

.tp-phase {
  position: relative;
  padding-left: 18px;
  padding-bottom: 14px;
}
.tp-phase:last-child {
  padding-bottom: 0;
}

.tp-dot {
  position: absolute;
  left: -4px;
  top: 6px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #1A73E8;
  box-shadow: 0 0 0 3px #fff;
  z-index: 1;
}

.tp-phase.is-current .tp-dot {
  background: #1A73E8;
  animation: tp-dot-pulse 1.4s ease-in-out infinite;
}

@keyframes tp-dot-pulse {
  0%, 100% {
    box-shadow: 0 0 0 3px #fff, 0 0 0 0 rgba(26, 115, 232, 0.35);
  }
  50% {
    box-shadow: 0 0 0 3px #fff, 0 0 0 6px rgba(26, 115, 232, 0);
  }
}
.tp-phase-title {
  font-size: 15px;
  font-weight: 500;
  color: #1A1A1A;
  line-height: 1.45;
}

.tp-subs {
  list-style: none;
  margin: 6px 0 0;
  padding: 0;
}

.tp-sub {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 13px;
  font-weight: 400;
  color: #A0A4AB;
  line-height: 1.55;
  padding: 2px 0;
}

.tp-sub.is-done {
  color: #6B7280;
}

.tp-check {
  flex-shrink: 0;
  margin-top: 4px;
  width: 12px;
  height: 12px;
  color: #17D664;
}

.tp-sub-text {
  flex: 1;
  min-width: 0;
}

@media (max-width: 575.98px) {
  .tp-header {
    padding: 14px 18px;
    font-size: 14px;
  }
  .tp-timeline {
    padding: 4px 18px 18px 22px;
  }
  .tp-timeline::before {
    left: 26px;
  }
  .tp-phase-title {
    font-size: 14px;
  }
  .tp-sub {
    font-size: 12px;
  }
}
.ai-response-row {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 4px 0 24px;
}
.ai-response-row:hover .ar-actions, .ai-response-row:focus-within .ar-actions {
  opacity: 1;
  visibility: visible;
}

.ar-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.ar-avatar-img {
  width: 100%;
  height: 100%;
  display: block;
}

.ar-content {
  flex: 1;
  min-width: 0;
  overflow-x: hidden;
  color: #1A1A1A;
  font-size: 15px;
  line-height: 1.65;
}
.ar-content img, .ar-content table, .ar-content pre, .ar-content canvas, .ar-content svg {
  max-width: 100%;
}
.ar-content table {
  display: block;
  overflow-x: auto;
}

.ar-actions {
  display: flex;
  gap: 4px;
  margin-top: 12px;
  padding-top: 0;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.15s ease;
}
@media (hover: none) {
  .ar-actions {
    opacity: 1;
    visibility: visible;
  }
}

.ar-action-btn {
  width: 30px;
  height: 30px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #A0A4AB;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.ar-action-btn:hover {
  background: #E8EAED;
  color: #1A1A1A;
}
.ar-action-btn:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}
.ar-action-btn:disabled:hover {
  background: transparent;
  color: #A0A4AB;
}
.ar-action-btn.is-selected {
  background: #1A73E8;
  color: #fff;
}
.ar-action-btn.is-selected:hover {
  background: #1A73E8;
  color: #fff;
}
.ar-action-btn.is-copied {
  color: #1F8A4E;
}
.ar-action-btn.is-copied:hover {
  background: rgba(31, 138, 78, 0.08);
  color: #1F8A4E;
}

.ar-download-dropdown {
  display: inline-flex;
  align-items: center;
  line-height: 1;
}
.ar-download-dropdown.show ~ * { /* no-op selector to anchor the rule below */ }

.ai-response-row:has(.ar-download-dropdown.show) .ar-actions,
.ai-response-row .ar-download-dropdown.show {
  opacity: 1;
  visibility: visible;
}

.ar-download-menu.dropdown-menu {
  min-width: 160px;
  padding: 6px;
  border: 1px solid #E5E7EB;
  border-radius: 10px;
  background: #FFFFFF;
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.12);
  font-size: 13px;
  z-index: 60;
}
.ar-download-menu.dropdown-menu:not([data-popper-placement]) {
  visibility: hidden;
}

.ar-download-menu-item.dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 6px;
  background: transparent;
  border: none;
  color: #1A1A1A;
  cursor: pointer;
  white-space: nowrap;
}
.ar-download-menu-item.dropdown-item .ar-download-menu-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: #6B7280;
  flex-shrink: 0;
}
.ar-download-menu-item.dropdown-item:hover, .ar-download-menu-item.dropdown-item:focus {
  background: #E8EAED;
  color: #1A1A1A;
}
.ar-download-menu-item.dropdown-item:hover .ar-download-menu-icon, .ar-download-menu-item.dropdown-item:focus .ar-download-menu-icon {
  color: #1A1A1A;
}
.ar-download-menu-item.dropdown-item:active {
  background: #E1E5EA;
}

@media (max-width: 767.98px) {
  .ar-action-btn {
    width: 44px;
    height: 44px;
    border-radius: 8px;
  }
}
@media (max-width: 575.98px) {
  .ai-response-row {
    gap: 10px;
  }
  .ar-avatar {
    width: 32px;
    height: 32px;
  }
  .ar-content {
    font-size: 14px;
  }
}
.ref-chips-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 10px 0;
}

.ref-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid #E5E7EB;
  background: #fafafa;
  font-size: 12px;
  color: #333;
}
.ref-chip--code {
  border-color: #c7d7ff;
  background: #f0f4ff;
}
.ref-chip--doc {
  border-color: #d1f7e0;
  background: #f0fff4;
}

.ref-chip-icon {
  display: flex;
  align-items: center;
  color: #666;
}

.ref-chip-label {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ref-chip-close {
  border: none;
  background: none;
  cursor: pointer;
  color: #999;
  font-size: 14px;
  line-height: 1;
  padding: 0 0 0 2px;
}
.ref-chip-close:hover {
  color: #333;
}

.fdc-strip {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 10px 0 4px;
}

.fdc-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid #E5E7EB;
  background: #fafafa;
  font-size: 13px;
  color: #333;
  text-decoration: none;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.fdc-chip:hover, .fdc-chip:focus-visible {
  background: #f0f4ff;
  border-color: #c7d7ff;
  color: #1a1a1a;
  text-decoration: none;
}

.fdc-chip-icon {
  display: flex;
  align-items: center;
  color: #666;
}

.fdc-chip-label {
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fdc-chip--pptx,
.fdc-chip--ppt {
  background: #fff4ec;
  border-color: #f3c9a8;
  color: #b94a0c;
}
.fdc-chip--pptx:hover, .fdc-chip--pptx:focus-visible,
.fdc-chip--ppt:hover,
.fdc-chip--ppt:focus-visible {
  background: #ffe9d6;
  border-color: #e0a777;
  color: #8e3808;
}
.fdc-chip--pptx .fdc-chip-icon,
.fdc-chip--ppt .fdc-chip-icon {
  color: #c4500d;
}

.fdc-chip--docx,
.fdc-chip--doc {
  background: #eef2fd;
  border-color: #b9c9f0;
  color: #1f3a7a;
}
.fdc-chip--docx:hover, .fdc-chip--docx:focus-visible,
.fdc-chip--doc:hover,
.fdc-chip--doc:focus-visible {
  background: #dde5fb;
  border-color: #9eb3eb;
  color: #14275a;
}
.fdc-chip--docx .fdc-chip-icon,
.fdc-chip--doc .fdc-chip-icon {
  color: #2b579a;
}

.fdc-chip--xlsx,
.fdc-chip--xls,
.fdc-chip--csv {
  background: #effaf3;
  border-color: #b0e0bf;
  color: #155a37;
}
.fdc-chip--xlsx:hover, .fdc-chip--xlsx:focus-visible,
.fdc-chip--xls:hover,
.fdc-chip--xls:focus-visible,
.fdc-chip--csv:hover,
.fdc-chip--csv:focus-visible {
  background: #ddf3e4;
  border-color: #8fcfa1;
  color: #0f4429;
}
.fdc-chip--xlsx .fdc-chip-icon,
.fdc-chip--xls .fdc-chip-icon,
.fdc-chip--csv .fdc-chip-icon {
  color: #217346;
}

.fdc-chip--pdf {
  background: #fdecec;
  border-color: #f0b9b9;
  color: #952d27;
}
.fdc-chip--pdf:hover, .fdc-chip--pdf:focus-visible {
  background: #fad9d9;
  border-color: #e69e9e;
  color: #74211c;
}
.fdc-chip--pdf .fdc-chip-icon {
  color: #c0392b;
}

.fdc-chip--zip {
  background: #fdf6e3;
  border-color: #ebd99c;
  color: #7e5a14;
}
.fdc-chip--zip:hover, .fdc-chip--zip:focus-visible {
  background: #faecc9;
  border-color: #d9c47d;
  color: #614410;
}
.fdc-chip--zip .fdc-chip-icon {
  color: #b7791f;
}

.input-toolbar {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  flex: 1;
  min-width: 0;
}

.it-buttons {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
  min-width: 0;
}

.it-dropdown-wrap {
  position: relative;
  flex-shrink: 0;
}
.it-dropdown-wrap--sources {
  margin-left: auto;
}

.it-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: none;
  color: #1A1A1A;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 500;
  padding: 7px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
  white-space: nowrap;
}
.it-btn:hover {
  background: #E8EAED;
}
.it-btn .it-btn-icon,
.it-btn .it-btn-chevron {
  color: currentColor;
  flex-shrink: 0;
}

.it-group-pill {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  background: #FFFFFF;
  border: 1px solid #E5E7EB;
  border-radius: 999px;
  padding: 2px 4px 2px 10px;
  font-size: 12px;
  max-width: 220px;
  min-width: 0;
  flex-shrink: 1;
}

.it-group-pill-body {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  padding: 2px 0;
  color: #1A1A1A;
  cursor: pointer;
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  min-width: 0;
}
.it-group-pill-body:hover .it-group-pill-label {
  color: #1A73E8;
}

.it-group-pill-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #1A73E8;
  flex-shrink: 0;
}

.it-group-pill-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.it-group-pill-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border: none;
  background: transparent;
  color: #A0A4AB;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  border-radius: 50%;
  flex-shrink: 0;
}
.it-group-pill-close:hover {
  background: #E8EAED;
  color: #1A1A1A;
}

.it-popup {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 0;
  min-width: 260px;
  max-height: min(420px, 65vh);
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  box-shadow: 0 12px 28px rgba(16, 24, 40, 0.14);
  z-index: 50;
  overflow: hidden;
}
.it-popup--right {
  right: 0;
  left: auto;
}

.it-popup-body {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px 16px;
  overflow-y: auto;
  overscroll-behavior-y: none;
  flex: 1;
  min-height: 0;
}

.it-popup-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 4px;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;
  color: #1A1A1A;
  font-family: "Montserrat", sans-serif;
  font-size: 15px;
  border-radius: 6px;
  transition: background-color 0.12s ease;
}
.it-popup-row:hover:not(.disabled) {
  background: #E8EAED;
}
.it-popup-row.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.it-popup-check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 1px solid #D0D5DD;
  background: #F2F4F7;
  flex-shrink: 0;
  transition: background-color 0.12s ease, border-color 0.12s ease;
}
.it-popup-check--checked {
  background: #1A73E8;
  border-color: #1A73E8;
}

.it-popup-label {
  line-height: 1.4;
  flex: 1;
  min-width: 0;
}

.it-popup-coming-soon {
  flex-shrink: 0;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: #A0A4AB;
  background: #E8EAED;
  border: 1px solid #E5E7EB;
  border-radius: 4px;
  padding: 2px 5px;
  line-height: 1.4;
}

.it-popup-divider {
  height: 1px;
  background: rgba(0, 0, 0, 0.1);
  margin: 6px -16px;
  border: 0;
  flex-shrink: 0;
}

.it-popup-footer {
  display: flex;
  border-top: 1px solid #E5E7EB;
}

.it-popup-footer-btn {
  flex: 1;
  background: transparent;
  border: none;
  cursor: pointer;
  font-family: "Montserrat", sans-serif;
  font-size: 15px;
  height: 52px;
  transition: background-color 0.12s ease;
}
.it-popup-footer-btn:hover {
  background: #E8EAED;
}
.it-popup-footer-btn--cancel {
  color: #1A1A1A;
  border-right: 1px solid #E5E7EB;
}
.it-popup-footer-btn--done {
  color: #1A73E8;
  font-weight: 600;
}

.uib-chips-strip {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  padding: 0 4px 8px;
  overflow-x: auto;
  scrollbar-width: none;
}
.uib-chips-strip::-webkit-scrollbar {
  display: none;
}
.uib-chips-strip .it-group-pill {
  max-width: none;
  flex-shrink: 0;
}

@media (max-width: 479.98px) {
  .it-btn {
    padding: 6px 8px;
    font-size: 13px;
  }
  .it-popup {
    min-width: 240px;
    max-height: 250px;
  }
}
@media (max-width: 360px) {
  .it-group-pill-label {
    display: none;
  }
  .it-group-pill {
    max-width: 56px;
    padding: 2px 4px;
  }
  .it-btn {
    gap: 4px;
    font-size: 12px;
    padding: 5px 6px;
  }
}
.unified-input-bar {
  width: 100%;
  font-family: "Montserrat", sans-serif;
}
.unified-input-bar.uib-disabled .uib-card {
  opacity: 0.85;
}

.uib-card {
  background: #FFFFFF;
  border: 1px solid #E5E7EB;
  border-radius: 16px;
  box-shadow: 0 4px 14px rgba(16, 24, 40, 0.08);
  padding: 16px 18px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.uib-textarea {
  width: 100%;
  border: none;
  outline: none;
  resize: none;
  font-size: 15px;
  color: #1A1A1A;
  line-height: 1.5;
  background: transparent;
  padding: 4px 2px;
  font-family: inherit;
}
.uib-textarea::placeholder {
  color: #A0A4AB;
}

.uib-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.uib-controls-left {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  flex: 1;
}

.uib-controls-right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.uib-attach-btn {
  width: 34px;
  height: 34px;
  border: 1px solid #BABABA;
  background: #FFFFFF;
  border-radius: 50%;
  color: #000000;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0;
  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}
.uib-attach-btn:hover:not(:disabled) {
  background: #F9FAFB;
  border-color: #9AA0A6;
}
.uib-attach-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.uib-send-btn {
  width: 34px;
  height: 34px;
  border: none;
  background: #1A1A1A;
  color: #FFFFFF;
  border-radius: 50%;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0;
  transition: background-color 0.15s ease;
}
.uib-send-btn svg {
  transform: translate(1px, -1px);
}
.uib-send-btn:hover:not(:disabled) {
  background: #000;
}
.uib-send-btn:disabled {
  background: #C9CCD1;
  color: #FFFFFF;
  cursor: not-allowed;
}
.uib-send-btn--stop {
  background: #1A1A1A;
  color: #FFFFFF;
  cursor: pointer;
}
.uib-send-btn--stop svg {
  transform: none;
}
.uib-send-btn--stop:hover {
  background: #000;
}

.uib-char-count {
  display: none;
}
.uib-char-count--visible {
  display: inline-block;
  margin-right: 8px;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
  color: #A0A4AB;
}
.uib-char-count--warning {
  color: #B07A00;
}
.uib-char-count--danger {
  color: #C22;
  font-weight: 600;
}

.uib-disclaimer {
  text-align: center;
  font-size: 12px;
  color: #A0A4AB;
  padding: 10px 0 0;
}

.uib-attachment-list {
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
  padding: 2px 0;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;
  scrollbar-color: #E5E7EB transparent;
}
.uib-attachment-list::-webkit-scrollbar {
  height: 6px;
}
.uib-attachment-list::-webkit-scrollbar-track {
  background: transparent;
}
.uib-attachment-list::-webkit-scrollbar-thumb {
  background: #E5E7EB;
  border-radius: 3px;
}

.uib-att-tile {
  position: relative;
  width: 72px;
  height: 72px;
  flex: 0 0 72px;
  border-radius: 12px;
  background: #F3F4F6;
  border: 1px solid #E5E7EB;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.uib-att-tile--image {
  background: #E5E7EB;
}

.uib-att-name {
  display: none;
}

.uib-att-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.uib-att-file-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
}

.uib-att-remove {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: none;
  background: rgba(17, 24, 39, 0.75);
  color: #FFFFFF;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  transition: background-color 0.15s ease;
}
.uib-att-remove:hover {
  background: rgba(17, 24, 39, 0.95);
}
.uib-att-remove:focus-visible {
  outline: 2px solid #2563EB;
  outline-offset: 1px;
}

@media (max-width: 767.98px) {
  .uib-att-tile:not(.uib-att-tile--image) {
    height: 88px;
    flex-direction: column;
    justify-content: center;
    gap: 2px;
    padding: 6px 4px 4px;
  }
  .uib-att-name {
    display: block;
    font-size: 9px;
    line-height: 1.2;
    color: #6B7280;
    text-align: center;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-all;
    max-width: 100%;
    padding: 0 2px;
  }
}
@media (max-width: 575.98px) {
  .uib-card {
    padding: 12px 14px 10px;
    border-radius: 14px;
  }
  .uib-textarea {
    font-size: 14px;
  }
  .uib-attach-btn,
  .uib-send-btn {
    width: 32px;
    height: 32px;
  }
  .uib-att-tile:not(.uib-att-tile--image) {
    width: 64px;
    flex-basis: 64px;
  }
  .uib-att-tile--image {
    width: 64px;
    height: 64px;
    flex-basis: 64px;
  }
  .uib-att-file-icon {
    width: 38px;
    height: 38px;
  }
}
.unified-chat-wrap {
  height: calc(100vh - 64px);
  overflow: hidden;
  background: #F4F6F7;
  position: relative;
}
@media (max-width: 767.98px) {
  .unified-chat-wrap {
    height: calc(100vh - 56px);
  }
}

.unified-chat-layout {
  display: flex;
  flex-direction: row;
  height: 100%;
}

.unified-main-pane {
  flex: 1;
  min-width: 0;
  background: #FFFFFF;
  overflow: hidden;
  display: flex;
}

.unified-chat-hamburger {
  display: none;
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 20;
  width: 40px;
  height: 40px;
  border: none;
  background: #FFFFFF;
  border-radius: 8px;
  color: #1A1A1A;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
  cursor: pointer;
  align-items: center;
  justify-content: center;
}
@media (max-width: 991.98px) {
  .unified-chat-hamburger {
    display: inline-flex;
  }
}

.unified-chat-backdrop {
  display: none;
  position: fixed;
  top: 64px;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 40;
}
@media (max-width: 991.98px) {
  .unified-chat-backdrop.is-open {
    display: block;
  }
}
@media (max-width: 767.98px) {
  .unified-chat-backdrop {
    top: 56px;
  }
}

.chat-section-whole-wrap {
  height: calc(100vh - 122px);
  background: #f3f5f7;
  padding: 22px 0;
}

.chat-sidebar-box {
  padding: 0;
}

.chat-feed {
  padding: 0;
  border-left: 1px solid #E9E9E9;
  flex: 1;
}

.chat-sidebar {
  width: 317px;
  padding: 0 24px 20px;
  background-color: #fff;
  border-radius: 20px 0 0 20px;
}

.chat-results-scroll {
  max-height: 70vh;
}

.chat-results-show-box {
  padding-bottom: 20px;
}

.chat-height-control {
  height: 100%;
}

.newchat-center-fix {
  display: flex;
  align-items: center;
  width: 100%;
}
.newchat-center-fix .chat-textarea-wrap {
  position: inherit;
  padding-top: 80px;
}
@media (max-height: 730px) {
  .newchat-center-fix .chat-textarea-wrap {
    padding-top: 60px;
  }
}
.newchat-center-fix .chat-height-control {
  height: auto;
}

@media (max-width: 1200px) {
  .chat-sidebar {
    width: 270px;
    padding: 0 10px 20px;
  }
}
@media (min-width: 992px) {
  .mobil-header {
    display: none !important;
  }
  .mobile-menu-view-button {
    display: none;
  }
}
@media (max-width: 991px) {
  .chat-sidebar {
    width: auto;
  }
  .mobil-header {
    display: flex;
    padding: 6px 20px;
    background: #1A73E8;
    border-radius: 20px 20px 0 0;
  }
  .mobil-menu-slide {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
    visibility: hidden;
    width: 100%;
    z-index: 99;
    transition: all 0.4s;
  }
  .ai-mobilemenu-active {
    transform: translateX(0);
    visibility: visible;
    background: #fff;
    z-index: 2000;
  }
  .mobil-menu-slide .sidebar-header {
    display: none;
  }
  .mobile-menu-close-button {
    z-index: 2001;
    position: fixed;
    right: 20px;
    top: 14px;
    cursor: pointer;
  }
  .mobile-menu-view-button svg,
  .mobile-menu-close-button svg {
    width: 30px;
    height: 30px;
  }
  .mobile-menu-view-button {
    cursor: pointer;
  }
  .mobile-menu-view-button svg path {
    fill: #fff;
  }
  .mobile-chat-logo h3 {
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    margin: 0;
  }
  .mobile-chat-logo .poweredby-text {
    font-size: 12px;
    color: #fff;
  }
  .chat-sidebar-box {
    padding: 0;
  }
  .mobile-menu-view-button .mob-close-btn {
    display: none;
  }
  .mobile-menu-close-button .mob-open-btn {
    display: none;
  }
  .mobile-menu-close-button .mob-close-btn {
    display: block;
  }
  .mob-close-btn {
    font-size: 44px;
    line-height: 30px;
    color: #000;
    font-weight: 300;
  }
}
@media (max-width: 767px) {
  .chat-feed {
    flex: inherit;
    width: 100%;
    padding-bottom: 0;
    border: none;
  }
  .newchat-center-fix .chat-textarea-wrap {
    position: fixed;
  }
  .chat-section-whole-wrap {
    height: auto;
    padding-bottom: 0;
    min-height: calc(100vh - 150px);
    padding-top: 5px;
  }
  .newchat-center-fix .chat-textarea-wrap {
    padding-top: 50px;
  }
}
.infinite-scroll-component {
  min-height: 200px;
}

.chat-feed-wrap {
  background-color: #fff;
  padding: 25px 10px 34px;
  border-radius: 0 20px 20px 0;
}
@media (max-width: 991px) {
  .chat-feed-wrap {
    border-radius: 0 0 20px 20px;
  }
}

.feed-tiles-wrap {
  max-width: 700px;
  margin: 0 auto;
}

.chat-beta-text {
  color: #1a73e8;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: -0.2px;
  border-radius: 2px;
  background: rgba(26, 115, 232, 0.2);
  display: block;
  margin-left: 8px;
  padding: 1px 3px;
}

.chat-header-inline h4 {
  margin: 0;
  color: #000;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: -0.44px;
}

.chat-header-inline {
  margin-bottom: 9px;
}

.chat-feed-header p {
  color: rgba(37, 37, 37, 0.8);
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  text-transform: capitalize;
  margin-bottom: 0;
}

.chat-feed-header {
  margin-bottom: 50px;
}

.feed-whole-box {
  max-width: 870px;
  margin-left: auto;
  margin-right: auto;
}

@media (max-height: 900px) {
  .chat-feed-header {
    margin-bottom: 35px;
  }
  .chat-feed-wrap {
    padding: 20px 10px;
  }
}
@media (max-height: 760px) {
  .chat-feed-header {
    margin-bottom: 25px;
  }
  .chat-header-inline {
    margin-bottom: 5px;
  }
  .chat-feed-wrap {
    padding: 20px 10px;
  }
}
@media (max-width: 767px) {
  .chat-feed-wrap {
    padding: 10px 0px;
  }
  .cs-message-list__scroll-wrapper {
    padding-right: 0.8em;
  }
  .feed-tiles-wrap {
    padding-bottom: 0px;
    height: 100%;
  }
}
#scrollableDiv {
  height: calc(100vh - 400px);
  overflow-y: auto;
  margin-right: -19px;
  margin-left: -8px;
}
#scrollableDiv .infinite-scroll-component__outerdiv {
  padding-right: 7px;
}
@media (max-width: 767px) {
  #scrollableDiv {
    height: calc(100vh - 280px);
  }
}

.previous-chat-boxes::-webkit-scrollbar {
  width: 8px;
}
.previous-chat-boxes::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px #fff;
}
.previous-chat-boxes::-webkit-scrollbar-thumb {
  background-color: #cfd7e1;
  outline: none;
  border-radius: 10px;
  cursor: all-scroll;
}
.previous-chat-boxes {
  margin-right: 0;
}

.previous-chat-box {
  padding-top: 30px;
  margin-bottom: 20px;
  border-top: 1px solid #d9d9d9;
  padding-right: 0;
  padding-left: 8px;
}
.previous-chat-box h3 {
  color: #5b5b5b;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: -0.3px;
}
.previous-chat-box:first-child {
  border-top: none;
  padding-top: 0;
}
@media (max-height: 900px) {
  .previous-chat-box {
    padding-bottom: 30px;
    margin-bottom: 30px;
  }
}
@media (max-height: 800px) {
  .previous-chat-box {
    padding-bottom: 20px;
    margin-bottom: 20px;
  }
}
@media (max-height: 760px) {
  .previous-chat-box {
    padding-bottom: 15px;
    margin-bottom: 15px;
  }
}

.side-query-row {
  padding: 2px 0 0 8px;
  background-color: transparent;
  border-radius: 6px;
  position: relative;
  left: -8px;
}
.side-query-row:hover {
  background-color: #f3f5f7;
  transition: all ease 0.5s;
}
.side-query-row:hover .side-query-more {
  opacity: 1;
}

.side-query-text {
  display: flex;
  align-items: center;
  flex: 1;
}
@media (max-height: 900px) {
  .side-query-text {
    font-size: 13px;
    line-height: 26px;
  }
}

.side-query-row:hover .side-query-text-content::after {
  display: none;
}

.side-query-text-content {
  color: #828a92;
  font-size: 14px;
  font-weight: 400;
  line-height: 32px;
  white-space: nowrap;
  overflow: hidden;
  position: relative;
  flex: 1;
  max-width: 230px;
}
.side-query-text-content::after {
  position: absolute;
  width: 40px;
  height: 20px;
  content: "";
  position: absolute;
  right: 0;
  top: 7px;
  background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 50%, rgb(255, 255, 255) 100%);
}

.side-query-icon {
  width: 30px;
}

.side-query-more {
  position: absolute;
  right: 3px;
  bottom: 0;
  top: 0;
  display: flex;
  opacity: 0;
  align-items: center;
  padding-left: 8px;
  background-color: #f3f5f7;
  z-index: 100;
}
@media (max-width: 991px) {
  .side-query-more {
    opacity: 1;
    background-color: transparent;
  }
}
.side-query-more .chat-more-dpdn {
  width: 20px;
  min-width: 0;
  padding: 0;
  background: transparent;
  text-align: center;
  height: auto;
}
.side-query-more .chat-more-dpdn:active {
  background-color: transparent;
  border: none;
}
.side-query-more .chat-more-dpdn:hover svg rect {
  fill-opacity: 1;
  transition: all ease 0.5s;
}
.side-query-more .chat-more-dpdn.dropdown-toggle::after {
  display: none;
}
.side-query-more .dropdown-menu {
  border: none;
  box-shadow: 0 0 5px #999;
  min-width: 0;
  margin-right: 8px;
}
.side-query-more a.dropdown-item {
  font-size: 13px;
}

.previous-chat-text {
  color: #5b5b5b;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: -0.26px;
  margin-bottom: 20px;
}

.no-history-box {
  background: #f3f5f7;
  padding: 20px 12px;
  border-radius: 10px;
}
.no-history-box h3 {
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 0.5px;
  text-transform: capitalize;
  margin-bottom: 12px;
}
.no-history-box p {
  font-size: 13px;
  color: #5b5b5b;
  line-height: 22px;
  margin: 0;
}

.chat-side-loader-middle {
  display: flex;
  min-height: 120px;
  align-items: center;
  justify-content: center;
}

.query-edit-input {
  flex: 1;
}
.query-edit-input .side-query-edit-input {
  border: 1px solid #ddd;
  border-radius: 4px;
  height: 28px;
  padding: 0 5px;
  width: 100%;
  margin-bottom: 2px;
}
.query-edit-input .side-query-edit-input:focus, .query-edit-input .side-query-edit-input:focus-visible {
  border: 1px solid #ddd;
  outline: none;
}

.query-edit-action-icon {
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.query-edit-action-icon:hover {
  opacity: 0.8;
}
.query-edit-action-icon path {
  fill: #1A73E8;
}
.query-edit-action-icon svg {
  width: 18px;
  height: 18px;
}

.query-edit-action-icons {
  width: fit-content;
  padding-left: 10px;
}

.side-query-edit-row {
  width: 100%;
}

@media (max-height: 800px) {
  .previous-chat-scroll {
    max-height: calc(100vh - 370px);
  }
}
@media (max-height: 760px) {
  .previous-chat-scroll {
    max-height: calc(100vh - 350px);
  }
}

.chat-sidebar-logo-box {
  background-size: cover;
  margin: 0 -24px 20px;
  background: transparent !important;
  padding: 24px;
  color: #000;
  border-bottom: 1px solid #E9E9E9;
}

.chat-sidebar-logo-box h3 {
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.36px;
  margin-bottom: 5px;
}

.chat-sidebar-search-wrap {
  margin-top: 24px;
  margin-bottom: 30px;
}

@media (max-height: 800px) {
  .chat-sidebar-logo-box {
    margin-bottom: 20px;
  }
  .chat-sidebar-search-wrap {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .chat-sidebar-logo-box {
    padding: 18px 24px;
  }
}
@media (max-height: 760px) {
  .chat-sidebar-logo-box {
    margin-bottom: 12px;
  }
  .chat-sidebar-search-wrap {
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .chat-sidebar-logo-box {
    padding: 10px 24px;
  }
  .chat-sidebar-logo-box h3 {
    margin-bottom: 0;
  }
}
@media (max-width: 1200px) {
  .chat-sidebar-logo-box {
    margin: 0 -10px 20px;
    padding: 10px;
  }
}
.chat-textarea-wrap {
  position: absolute;
  bottom: 25px;
  left: 10px;
  right: 10px;
  padding-top: 50px;
  padding-bottom: 25px;
  z-index: 1000;
  background-color: #fff;
  box-shadow: 0 -14px 13px rgba(255, 255, 255, 0.75);
}
@media (min-width: 991px) and (max-width: 1200px) {
  .chat-textarea-wrap {
    left: 18px;
    right: 23px;
  }
}
@media (max-height: 800px) {
  .chat-textarea-wrap {
    bottom: 6px;
  }
}

.chat-textarea-form {
  background: #FFFFFF;
  border: 1px solid #DADADA;
  box-shadow: 0px 20px 40px 5px #EBEEF1;
  border-radius: 12px;
  padding: 18px 55px 18px 25px;
  position: relative;
}

.chat-textarea-wrap .textarea-item {
  border: none;
  width: 100%;
  resize: none;
  font-size: 15px;
  font-weight: 500;
  line-height: 24px;
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  max-height: 120px;
}
@media (max-height: 768px) {
  .chat-textarea-wrap .textarea-item {
    max-height: 100px;
  }
}
@media (max-height: 750px) {
  .chat-textarea-wrap .textarea-item {
    max-height: 70px;
    font-size: 13px;
    line-height: 18px;
  }
}

.chat-textarea-wrap .textarea-item:focus-visible,
.chat-textarea-wrap .textarea-item:focus {
  outline: none !important;
}

.chat-textarea-wrap .chat-textarea-form-outer {
  margin: 0 auto;
  position: relative;
  max-width: 850px;
}

.chat-textarea-wrap .send-btn {
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  right: 5px;
  top: 0px;
  border: none;
  text-indent: -9999px;
  width: 50px;
  height: 60px;
  padding: 0;
  background-color: transparent;
}

.chat-textarea-wrap .send-btn:disabled {
  opacity: 0.5;
}

.chat-select-box select.form-select {
  height: 24px;
  font-size: 13px;
  padding: 0 8px;
  width: fit-content;
  font-weight: 500;
  border: none;
  background: #fff;
  cursor: pointer;
  padding-right: 30px;
}

.chat-select-box {
  border-radius: 3px;
  background: linear-gradient(180deg, #4991ef 0%, #1a73e8 100%);
  box-shadow: 0px 10px 10px 0px rgba(133, 175, 214, 0.45);
  padding: 8px 10px;
  margin-bottom: 0;
}

.chat-forms-btns-wrap {
  margin-bottom: 8px;
}

.select-label-text {
  margin-right: 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
}

.new-chat-btn {
  font-weight: 600;
  font-size: 13px;
  color: #333;
  text-decoration: none;
  background: #FFFFFF;
  border: 1px solid #DADADA;
  box-shadow: 0px 8px 20px #EAEAEA;
  border-radius: 12px;
  width: 62px;
  white-space: nowrap;
  height: 62px;
  overflow: hidden;
  text-align: center;
  align-items: center;
  padding: 0 10px 0 17px;
  transition: width 0.3s;
  display: flex;
  align-items: center;
  margin-right: 6px;
}
.new-chat-btn .new-chat-btn-text {
  opacity: 0;
}
@media (max-width: 767px) {
  .new-chat-btn {
    width: 52px;
    padding-left: 12px;
    height: 52px;
  }
}

.new-chat-btn:hover {
  width: 136px;
}
@media (max-width: 767px) {
  .new-chat-btn:hover {
    width: 52px;
  }
}
.new-chat-btn:hover {
  transition: width 0.3s;
}
.new-chat-btn:hover .new-chat-btn-text {
  opacity: 1;
}

.new-chat-btn:hover span.new-chat-btn-img {
  rotate: 360deg;
}

span.new-chat-btn-img {
  text-align: center;
  display: inline-block;
  margin-right: 10px;
}

.select-arrow {
  position: absolute;
  right: 6px;
  top: -1px;
  cursor: pointer;
  height: 25px;
  pointer-events: none;
}

.chat-textarea-form .textarea-item::placeholder {
  color: rgba(0, 0, 0, 0.5);
}

.generate-loading span {
  margin-left: 15px;
}

.dot-elastic {
  position: relative;
  width: 4px;
  height: 4px;
  border-radius: 5px;
  background-color: #1A73E8;
  color: #1A73E8;
  animation: dot-elastic 1s infinite linear;
  margin-right: 15px;
}

.dot-elastic::before,
.dot-elastic::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
}

.dot-elastic::before {
  left: -8px;
  width: 4px;
  height: 4px;
  border-radius: 5px;
  background-color: #1A73E8;
  color: #1A73E8;
  animation: dot-elastic-before 1s infinite linear;
}

.dot-elastic::after {
  left: 8px;
  width: 4px;
  height: 4px;
  border-radius: 5px;
  background-color: #1A73E8;
  color: #1A73E8;
  animation: dot-elastic-after 1s infinite linear;
}

@keyframes dot-elastic-before {
  0% {
    transform: scale(1, 1);
  }
  25% {
    transform: scale(1, 1.7);
  }
  50% {
    transform: scale(1, 0.67);
  }
  75% {
    transform: scale(1, 1);
  }
  100% {
    transform: scale(1, 1);
  }
}
@keyframes dot-elastic {
  0% {
    transform: scale(1, 1);
  }
  25% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1, 1.7);
  }
  75% {
    transform: scale(1, 1);
  }
  100% {
    transform: scale(1, 1);
  }
}
@keyframes dot-elastic-after {
  0% {
    transform: scale(1, 1);
  }
  25% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1, 0.67);
  }
  75% {
    transform: scale(1, 1.7);
  }
  100% {
    transform: scale(1, 1);
  }
}
.generate-loading-anim {
  animation-duration: 2.2s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: shimmer;
  animation-timing-function: linear;
  background: #f1f6fc;
  background: linear-gradient(to right, #ecf1f8 8%, #f9fcff 18%, #eff6ff 33%);
  background-size: 1200px 100%;
}

.text-length-show {
  height: auto;
  line-height: 24px;
  padding-left: 10px;
  min-width: 82px;
  text-align: right;
}

.generate-loading.generate-more-btn span {
  margin-left: 0;
}

.generate-more-btn {
  cursor: pointer;
  background-color: #dbe3ea;
  padding-left: 10px;
  padding-right: 10px;
}

.generate-more-btn:hover {
  background-color: #e7eef4;
}

.generate-more-btn svg {
  width: 14px;
  height: 14px;
  position: relative;
  top: -1px;
  margin-right: 7px;
}
.generate-more-btn svg path {
  fill: #1A73E8;
}

@-webkit-keyframes shimmer {
  0% {
    background-position: -100% 0;
  }
  100% {
    background-position: 100% 0;
  }
}
@keyframes shimmer {
  0% {
    background-position: -1200px 0;
  }
  100% {
    background-position: 1200px 0;
  }
}
@media (max-height: 900px) {
  .chat-textarea-wrap {
    padding-bottom: 30px;
    box-shadow: 0 -12px 13px rgba(255, 255, 255, 0.75);
  }
}
@media (max-height: 760px) {
  .chat-textarea-wrap .send-btn {
    top: 0px;
  }
}
@media (max-width: 767px) {
  .chat-textarea-wrap {
    position: fixed;
    left: 0;
    right: 0;
    padding: 5px 10px;
    /* border-top: 1px solid #ddd; */
    box-shadow: 0 0 6px rgba(92, 107, 122, 0.7);
    background-color: #dce2e9;
  }
  .chat-textarea-form {
    padding: 15px 40px 15px 10px;
  }
  .chat-textarea-wrap .textarea-item {
    max-height: 80px;
    line-height: 20px;
  }
  .chat-textarea-wrap .send-btn {
    width: 24px;
    height: 24px;
    top: 12px;
  }
  .generate-loading {
    position: absolute;
    right: 0px;
    bottom: 83px;
    height: 30px;
    top: inherit;
    padding-left: 12px;
    padding-right: 3px;
    border-radius: 7px;
  }
  .generate-loading span {
    font-size: 11px;
  }
  .chat-forms-btns-wrap {
    flex-wrap: wrap;
  }
  .chat-select-box {
    width: 100%;
  }
  .chat-textarea-new-chat-wrap {
    margin-bottom: 5px;
  }
  .chat-select-box {
    padding: 4px 8px;
  }
  .new-chat-btn-text {
    display: none;
  }
  .cht-select-box-form {
    flex: 1;
  }
  .chat-select-box select.form-select {
    width: 100%;
  }
  .text-length-show {
    line-height: 20px;
  }
}
.generate-loading {
  border: 1px solid #1A73E8;
  border-radius: 50px;
  width: max-content;
  text-align: center;
  padding: 6px 15px;
  position: absolute;
  left: 0;
  top: -45px;
  color: rgb(26, 115, 232);
  font-weight: 600;
  font-weight: 13px;
}
.generate-loading.generate-more-btn {
  background: #EFF6FF;
}
.generate-loading.generate-more-seperate {
  background: #fff;
  border: 1px solid #D8D8D8;
  border-radius: 7px;
}
.generate-loading.generate-more-seperate-loading {
  border: 1px solid #D8D8D8;
  border-radius: 7px;
}
.generate-loading span {
  margin: 0;
}

.textarea-form-wrap {
  flex: 1;
}

.upload-clip-btn {
  margin-right: 10px;
}

.info-text-chat-textarea {
  position: absolute;
  left: 0;
  right: 0;
  z-index: 99;
  text-align: center;
  font-size: 13px;
  padding-top: 14px;
  color: #656b73;
}
@media (max-width: 575px) {
  .info-text-chat-textarea {
    padding-top: 9px;
    font-size: 10px;
  }
}
@media (max-height: 800px) {
  .info-text-chat-textarea {
    padding-top: 7px;
  }
}

.personality-slider-wrap {
  width: calc(100vw - 400px);
  max-width: 100%;
  overflow: hidden;
}
@media (max-width: 1200px) {
  .personality-slider-wrap {
    width: calc(100vw - 340px);
  }
}
@media (max-width: 991px) {
  .personality-slider-wrap {
    width: calc(100vw - 70px);
  }
}
@media (max-width: 575px) {
  .personality-slider-wrap {
    width: calc(100vw - 30px);
  }
}
.personality-slider-wrap .slider-item {
  padding: 2px 10px;
}
.personality-slider-wrap .slider-item.active .personality-item-box {
  border: 1px solid rgb(26, 115, 232);
  box-shadow: 0 0 0 2px rgb(26, 115, 232), 0 1px 2px rgba(26, 115, 232, 0.3);
}

.personality-item-box {
  border: 1px solid #D5D8DC;
  border-radius: 15px;
  padding: 20px 15px 15px 15px;
  height: 100%;
}
@media (max-height: 770px) {
  .personality-item-box {
    padding: 12px 10px 10px 12px;
  }
}
.personality-item-box h3 {
  font-size: 15px;
  font-weight: 600;
  letter-spacing: -2%;
  line-height: 19px;
  margin-bottom: 6px;
}
.personality-item-box p {
  color: rgba(37, 37, 37, 0.8);
  line-height: 22px;
  margin: 0;
}
@media (max-height: 770px) {
  .personality-item-box p {
    line-height: 20px;
  }
}
@media (max-height: 730px) {
  .personality-item-box p {
    font-size: 12px;
  }
}

.personality-slider-wrap .slick-list,
.personality-slider-wrap .slick-track,
.personality-slider-wrap .slider-item {
  display: flex;
  align-items: stretch;
}

.personality-slider-wrap .slick-slide > div,
.personality-slider-wrap .slider-item {
  height: 100%;
}

.pers-slider-icon {
  width: 70px;
  height: 70px;
  border: 1px solid #D0D0D0;
  border-radius: 8px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-height: 770px) {
  .pers-slider-icon {
    width: 50px;
    height: 50px;
  }
}

.personality-slider .pers-slick-next-wrap {
  right: -12px;
  width: 36px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  border: transparent;
  box-shadow: 0px 4px 50px 5px rgba(198, 198, 198, 0.32);
  border-radius: 50%;
  background-color: #1A73E8;
  z-index: 9;
}
.personality-slider .pers-slick-next-wrap::before {
  display: none;
}
.personality-slider .pers-slick-next-wrap.slick-disabled {
  opacity: 0;
}
.personality-slider .pers-slick-prev-wrap {
  left: -12px;
  width: 36px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  border: 1px solid transparent;
  box-shadow: 0px 4px 50px 5px rgba(198, 198, 198, 0.32);
  border-radius: 50%;
  background-color: #1A73E8;
  z-index: 9;
}
.personality-slider .pers-slick-prev-wrap::before {
  display: none;
}
.personality-slider .pers-slick-prev-wrap.slick-disabled {
  opacity: 0;
}

.personality-slider-container {
  margin: 0 auto;
  max-width: 1090px;
  padding: 0 17px;
}

.pers-slider-title {
  font-size: 20px;
  margin-bottom: 18px;
  line-height: 24px;
  font-weight: 600;
  padding-left: 10px;
}

.personality-scrollbar {
  max-height: 500px;
}

.chatbot-message-list .cs-message--outgoing {
  justify-content: normal;
}

.chatbot-message-list .cs-message-list__scroll-wrapper > .cs-message,
.cs-message-list__scroll-wrapper > .cs-message-group {
  max-width: 100%;
}

.chatbot-message-list .cs-message__content-wrapper {
  width: 100%;
}

.chatbot-message-list .query-input-wrap {
  border-radius: 5px;
  background: #def;
  padding: 13px;
  margin-bottom: 13px;
}

.chatbot-message-list .cs-message--outgoing .cs-message__content {
  background-color: transparent;
  border-radius: 0;
  padding: 0;
}

.cs-chat-container {
  height: calc(100% - 100px);
  padding-bottom: 0px;
}

.query-input-message p {
  font-size: 13px;
  font-weight: 400;
  line-height: 22px;
}

.chatbot-message-list,
.chatbot-message-list * {
  font-family: "Montserrat", sans-serif;
}

.query-input-message {
  flex: 1;
  padding-left: 15px;
  min-height: 42px;
  display: flex;
  align-items: center;
}

.query-output-message-flex-wrap {
  display: flex;
  align-items: center;
  min-height: 42px;
}

.query-output-box {
  width: 100%;
}

.query-output-box .styledlink a {
  width: 14px;
  height: 14px;
  background: rgb(206, 228, 251);
  border-radius: 2px;
  overflow: hidden;
  text-decoration: none;
  color: #1A73E8;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  font-weight: 600;
  line-height: 11px;
  padding-top: 2px;
  position: relative;
  top: -4px;
  margin-right: 2px;
}
@media (max-width: 575px) {
  .query-output-box .styledlink a {
    top: -3px;
    font-size: 9px;
    width: 12px;
    height: 12px;
  }
}
.query-output-box .styledlink a:hover {
  background-color: #1A73E8;
  color: #fff;
}

.query-output-message p {
  font-size: 13px;
  line-height: 24px;
  margin-bottom: 15px;
}

.query-output-paragraph-wrap {
  min-height: 70px;
}

.query-output-wrap {
  border-radius: 5px;
  background: #fff;
  padding: 28px 22px;
  margin-bottom: 13px;
  border: 1px solid #E9E9E9;
}
@media (max-width: 575px) {
  .query-output-wrap {
    padding: 14px 10px;
  }
}

.query-output-message {
  flex: 1;
  padding-left: 15px;
}

.query-output-action-icons {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 4px 10px 0 20px;
}

.query-action-icon {
  margin-bottom: 14px;
  cursor: pointer;
}

.query-action-icon:hover svg path {
  fill: #1A73E8;
}

.cs-chat-container,
.cs-message-list {
  background-color: transparent;
}

.cs-message-list .cs-message-list__typing-indicator-container {
  background-color: transparent;
  padding: 0;
  font-size: 15px;
  height: 30px;
  line-height: normal;
  left: 0px;
  bottom: 13px;
  position: absolute;
  right: 0;
  z-index: 2000;
}

.cs-message-list .typeindi-wrap {
  margin: 0 auto;
  position: relative;
  max-width: 700px;
  text-align: right;
  display: flex;
  justify-content: end;
  padding: 5px 0;
}

.cs-message-list .cs-typing-indicator {
  background-color: #fff;
  border-radius: 4px;
  position: inherit;
}

.cs-typing-indicator__dot {
  background-color: rgba(26, 115, 232, 0.5);
}

.cs-typing-indicator__text {
  color: rgba(26, 115, 232, 0.5);
  font-weight: 500;
}

.chat-section-whole-wrap .react-tooltip {
  padding: 5px 10px;
  font-size: 12px;
  z-index: 2001;
  background: #1A73E8 !important;
  color: #fff !important;
  border-radius: 6px;
}

.cs-chat-container {
  margin-right: -6px;
}

.cs-message {
  padding-right: 0;
}

@media (max-height: 900px) {
  .chatbot-message-list .query-input-wrap {
    padding: 7px 10px;
    margin-bottom: 10px;
  }
}
@media (max-height: 760px) {
  .query-output-wrap {
    padding: 7px 10px;
    margin-bottom: 10px;
  }
}
@media (max-width: 767px) {
  .cs-chat-container {
    margin-right: 0;
  }
  .cs-message {
    padding-right: 0;
  }
  .query-bot-logo img {
    max-width: 30px;
  }
  .query-output-message {
    padding-left: 10px;
  }
  .cs-chat-container {
    height: calc(100vh - 360px);
  }
  .query-output-message p {
    line-height: 20px;
    min-height: 60px;
  }
  .query-action-icon {
    margin-bottom: 8px;
  }
  .query-input-message {
    padding-left: 0;
    min-height: 30px;
  }
  .cs-message-list__scroll-wrapper > .cs-message:nth-last-child(4) {
    margin-bottom: 0;
  }
  .custom-content-wrap {
    height: calc(100vh - 370px);
    overflow-y: scroll;
  }
  .query-input-message p {
    line-height: 20px;
  }
  .chatbot-message-list .query-input-wrap {
    margin-bottom: 6px;
  }
  .query-output-wrap {
    margin-bottom: 6px;
  }
}
.formatingParagraph {
  white-space: normal;
  font-size: 13px;
  line-height: 22px;
}
.formatingParagraph h3 {
  font-size: 14px;
  margin-bottom: 6px;
  font-weight: bold;
  line-height: 20px;
}
.formatingParagraph h4 {
  font-size: 13px;
  margin-bottom: 6px;
  font-weight: bold;
  line-height: 20px;
}
.formatingParagraph p {
  margin-bottom: 1rem;
  line-height: 22px;
  font-size: 13px;
}
.formatingParagraph ul, .formatingParagraph ol {
  margin-bottom: 1rem;
}
.formatingParagraph ul li, .formatingParagraph ol li {
  font-size: 13px;
  line-height: 22px;
  margin-bottom: 10px;
}

.output-image-show-box {
  margin: 12px -6px 0;
}

.output-img-item {
  padding: 6px;
}

.output-img-item img {
  border-radius: 10px;
  width: 251px;
  height: 200px;
  object-fit: cover;
  height: 200px;
  object-position: center;
}

.download-icon {
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
}

.download-icon:hover {
  opacity: 0.8;
  transition: all ease 0.5s;
}

.download-icon img {
  width: 21px;
  height: 21px;
}

.graph-result-box {
  background-color: #fff;
  padding: 12px;
  border-radius: 6px;
  margin-top: 15px;
}

.csv-link-btn {
  background-color: #1A73E8;
  line-height: 30px;
  padding: 0 10px;
  color: #fff;
  text-decoration: none;
  display: inline-block;
  border-radius: 3px;
  font-weight: 500;
}

.csv-link-btn:hover {
  color: #fff;
  opacity: 0.9;
}

@media (max-width: 767px) {
  .output-img-item {
    width: 50%;
  }
  .output-img-item img {
    border-radius: 10px;
    width: 100%;
    height: auto;
    object-fit: cover;
    object-position: center;
  }
  .output-image-show-boxes {
    margin: 0 -45px 0 -40px;
  }
  .download-icon {
    right: 3px;
    top: inherit;
    bottom: 3px;
    background: #1a73e8;
    border-radius: 50%;
  }
  .download-icon svg rect {
    fill: transparent !important;
  }
  .download-icon svg path {
    fill: #fff;
  }
}
.output-learnmore-wrap {
  margin: 30px -45px 0 -58px;
  display: flex;
  justify-content: center;
  border-top: 1px solid #E9E9E9;
  padding-top: 8px;
  padding-bottom: 1px;
  padding-left: 50px;
  padding-right: 50px;
}

.learnmore-child-labels span,
.learnmore-child-labels a {
  border-radius: 16px;
  background: #f3f5f7;
  padding: 0px 10px;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
  display: inline-flex;
  height: 30px;
  align-items: center;
  cursor: pointer;
  color: #000;
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.learnmore-child-labels {
  padding: 0 5px;
  margin-top: 6px;
}

.learnmore-child {
  height: 30px;
  display: inline-flex;
  align-items: center;
  font-weight: bold;
  font-size: 13px;
  font-style: normal;
  padding-right: 8px;
  margin-top: 3px;
  width: fit-content;
}

.output-learnmore-content-list a,
.view-more-item {
  border-radius: 16px;
  background: #f3f5f7;
  padding: 0px 10px;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
  display: inline-flex;
  height: 30px;
  align-items: center;
  cursor: pointer;
  color: #000;
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.view-more-item {
  border: none;
}

.bold-text {
  font-weight: 600;
}

.items-showing-count {
  position: absolute;
  right: 0;
  top: 19px;
  font-size: 13px;
}

.output-learnmore-content {
  flex: 1;
  padding-right: 30px;
}

.output-learnmore-content ul.output-learnmore-content-list {
  display: inline-flex;
  margin: 0 -5px;
  padding: 0;
  list-style: none;
  flex-wrap: wrap;
}

.output-learnmore-content-list li {
  padding: 0 5px;
  margin: 3px 0;
}

button.view-more-item {
  min-width: 40px;
  text-align: center;
  display: block;
  padding: 0px 10px;
  font-size: 13px;
  line-height: 26px;
  height: 30px;
  align-items: center;
  cursor: pointer;
  color: #000;
  text-decoration: none;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
}

@media (max-width: 767px) {
  .output-learnmore-wrap {
    margin: 30px -46px 0 -39px;
    padding-left: 10px;
    padding-right: 10px;
    flex-direction: column;
  }
  .output-learnmore-content-list a,
  .view-more-item {
    padding: 0px 8px;
    font-size: 11px;
    height: 26px;
  }
  button.view-more-item {
    font-size: 11px;
    height: 26px;
  }
}
.output-relatedarticle-wrap {
  border-radius: 5px;
  background: #f3f5f7;
  padding: 13px;
  margin: 15px 0;
}

.output-relatedarticle-wrap h4,
.output-relatedarticle-wrap h4 a {
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  color: #000;
  text-decoration: none;
  line-height: 32px;
}

.output-relatedarticle-wrap h4 a span {
  font-weight: 600;
}

.rel-article-item {
  width: 33.3333%;
  padding: 0 8px;
  margin-bottom: 20px;
}

.rel-article-text,
.rel-article-text a {
  color: #000;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  text-decoration: none;
}

.rel-article-text {
  flex: 1;
}

.rel-articles-row {
  margin: 0 -8px;
}

.rel-article-img img {
  margin-right: 12px;
}

.more-article {
  border-radius: 16px;
  padding: 0px 10px;
  font-size: 13px;
  line-height: 26px;
  display: inline-flex;
  height: 30px;
  align-items: center;
  cursor: pointer;
  color: #000;
  text-decoration: none;
  border-radius: 16px;
  background: #FFF;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
}

.rel-article-footer {
  margin-top: 10px;
  border-top: 1px solid #bed1ea;
  padding-top: 13px;
  padding-bottom: 2px;
}

.rel-article-img img {
  max-width: 70px;
}

.ai-relatedarticle-label-wrap {
  margin-top: 10px;
}

.ai-related-article-bubble {
  background: #E4E4E4;
  border-radius: 16px;
  padding: 4px 10px;
  color: #5b5b5b;
  font-size: 12px;
  margin-right: 5px;
  margin-top: 5px;
}

.ai-related-article-bubble:first-child {
  margin-left: 0;
}

.rel-article-text {
  min-height: min-content;
}

@media (max-width: 767px) {
  .output-relatedarticle-wrap h4,
  .output-relatedarticle-wrap h4 a {
    line-height: 22px;
  }
  .rel-article-item {
    width: 100%;
    padding: 0;
  }
  .rel-articles-row {
    margin: 0;
    flex-wrap: wrap;
  }
  .rel-article-footer {
    margin-top: 0;
  }
  .output-relatedarticle-wrap {
    margin: 7px 0;
  }
}
.vega-chart-container .chart-analysis .analysis-title {
  font-size: 14px;
  font-weight: 600;
  color: #495057;
  margin-bottom: 8px;
}
.vega-chart-container .chart-analysis .analysis-text {
  font-size: 13px;
  line-height: 1.5;
  color: #6c757d;
  margin: 0;
}
.vega-chart-container .chart-wrapper {
  position: relative;
  margin-top: 20px;
  text-align: center;
}
.vega-chart-container .chart-wrapper .vega-embed {
  width: 100% !important;
}
.vega-chart-container .chart-wrapper canvas {
  max-width: 100% !important;
}
@media (max-width: 768px) {
  .vega-chart-container .chart-wrapper canvas {
    height: auto !important;
  }
}
.vega-chart-container .chart-wrapper .chart-actions {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 10;
}
.vega-chart-container .chart-wrapper .chart-actions .download-chart-btn {
  padding: 6px 8px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #dee2e6;
  color: #495057;
  transition: all 0.2s ease;
}
.vega-chart-container .chart-wrapper .chart-actions .download-chart-btn:hover {
  background: #fff;
  border-color: #1a73e8;
  color: #1a73e8;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.vega-chart-container .chart-wrapper .chart-actions .download-chart-btn svg {
  width: 16px;
  height: 16px;
}
.vega-chart-container .chart-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #6c757d;
}
.vega-chart-container .chart-loading .spinner-border {
  width: 2rem;
  height: 2rem;
}
.vega-chart-container .chart-loading p {
  margin: 0;
  font-size: 14px;
}
.vega-chart-container .chart-error {
  padding: 20px;
}
.vega-chart-container .chart-error .alert {
  margin: 0;
  font-size: 14px;
}

@media (max-width: 768px) {
  .vega-chart-container {
    margin: 15px -20px;
    border-radius: 0;
  }
  .vega-chart-container .chart-wrapper .chart-actions {
    top: 16px;
    right: 16px;
  }
  .vega-chart-container .chart-analysis {
    padding: 12px;
  }
}
@media (max-width: 576px) {
  .vega-chart-container .chart-wrapper .vega-embed svg {
    max-width: 100% !important;
    height: auto !important;
  }
  .vega-chart-container .chart-analysis .analysis-title {
    font-size: 13px;
  }
  .vega-chart-container .chart-analysis .analysis-text {
    font-size: 12px;
  }
}
@media (prefers-color-scheme: dark) {
  .vega-chart-container {
    background: #2d3748;
    color: #e2e8f0;
  }
  .vega-chart-container .chart-analysis {
    background: #4a5568;
    border-bottom-color: #718096;
  }
  .vega-chart-container .chart-analysis .analysis-title {
    color: #e2e8f0;
  }
  .vega-chart-container .chart-analysis .analysis-text {
    color: #cbd5e0;
  }
  .vega-chart-container .chart-wrapper .chart-actions .download-chart-btn {
    background: rgba(45, 55, 72, 0.9);
    border-color: #718096;
    color: #e2e8f0;
  }
  .vega-chart-container .chart-wrapper .chart-actions .download-chart-btn:hover {
    background: #4a5568;
    border-color: #1a73e8;
    color: #1a73e8;
  }
  .vega-chart-container .chart-loading {
    color: #cbd5e0;
  }
}
.dropzone-modal .modal-lg {
  --bs-modal-width: 649px;
}
.dropzone-modal .modal-header {
  border: none;
}

.dropzone-box {
  background: #F3F5F7;
  border: 2px dashed #1A73E8;
  border-radius: 10px;
  padding: 52px;
  text-align: center;
  margin-bottom: 40px;
}
.dropzone-box h3 {
  font-size: 17px;
  font-weight: 600;
}
.dropzone-box h3 span {
  color: #1A73E8;
  text-decoration: underline;
  margin-bottom: 5px;
}
.dropzone-box p {
  font-size: 12px;
  color: rgb(103, 103, 103);
  margin-bottom: 0;
  line-height: 18px;
  margin-top: 5px;
}

.dpzone-title {
  text-align: center;
  padding: 5px 0 15px;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 0;
}

.uploaded-item-name-box {
  background: #FFFFFF;
  border: 1px solid #11AF22;
  border-radius: 4px;
  padding: 9px 11px;
  margin-bottom: 10px;
}
.uploaded-item-name-box .uploaded-item-nameshow {
  flex: 1;
  padding-left: 9px;
  padding-right: 9px;
  font-size: 12px;
  color: rgb(15, 15, 15);
  line-height: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.uploaded-item-name-box .uploaded-item-delete {
  background: #FFF3F3;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
}
.uploaded-item-name-box .uploaded-item-delete img {
  width: 70%;
}

.dpzone-sec-title {
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  color: #676767;
}

.uploaded-item-error {
  border-color: rgb(228, 29, 29);
}

.upload-error-text {
  font-size: 11px;
  font-weight: 500;
  color: rgb(228, 29, 29);
  margin-bottom: 0;
}

.uploading-status-show-outer .uploaded-item-name-box {
  margin-bottom: 0;
  border-color: rgb(227, 227, 227);
}

.dpzone-upload-status-sec {
  margin-bottom: 20px;
}

.dpzn-upload-scroll {
  max-height: 130px;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/scss/_App.scss","webpack://./src/app/assets/scss/utils/_variables.scss","webpack://./src/index.scss","webpack://./src/app/assets/scss/modules/auth/_signin.scss","webpack://./src/app/assets/scss/modules/auth/_signup.scss","webpack://./src/app/assets/scss/shared/modal/_modal.scss","webpack://./src/app/assets/scss/shared/react-select-2/_react-select-2.scss","webpack://./src/app/assets/scss/shared/header/_header.scss","webpack://./src/app/assets/scss/shared/footer/_footer.scss","webpack://./src/app/assets/scss/shared/tabs/_tabs.scss","webpack://./src/app/assets/scss/shared/datatable/_datatable.scss","webpack://./src/app/assets/scss/shared/pagination/_pagination.scss","webpack://./src/app/assets/scss/shared/sharedaccess/_sharedaccess.scss","webpack://./src/app/assets/scss/shared/scrollarea/_scrollarea.scss","webpack://./src/app/assets/scss/shared/errorpages/_pagenotfound.scss","webpack://./src/app/assets/scss/shared/accordian/_accordian.scss","webpack://./src/app/assets/scss/shared/loader/_loader.scss","webpack://./src/app/assets/scss/shared/slickslider/_slickslider.scss","webpack://./src/app/assets/scss/shared/notification/_notification.scss","webpack://./src/app/assets/scss/shared/shimmerloading/_shimmerloading.scss","webpack://./src/app/assets/scss/modules/home/_home.scss","webpack://./src/app/assets/scss/modules/home/components/_banner.scss","webpack://./src/app/assets/scss/modules/home/components/_financing.scss","webpack://./src/app/assets/scss/modules/home/components/_news.scss","webpack://./src/app/assets/scss/modules/home/components/_multimedia.scss","webpack://./src/app/assets/scss/modules/results/_results.scss","webpack://./src/app/assets/scss/modules/results/components/_filter.scss","webpack://./src/app/assets/scss/modules/results/components/_financingresults.scss","webpack://./src/app/assets/scss/modules/results/components/_multimediaresults.scss","webpack://./src/app/assets/scss/modules/results/components/_newsresults.scss","webpack://./src/app/assets/scss/modules/results/components/_expertsresults.scss","webpack://./src/app/assets/scss/modules/results/components/_coutrypopup.scss","webpack://./src/app/assets/scss/modules/results/components/_downloads.scss","webpack://./src/app/assets/scss/modules/savedqueries/_savedqueries.scss","webpack://./src/app/assets/scss/modules/profiles/_profile.scss","webpack://./src/app/assets/scss/modules/profiles/components/_members.scss","webpack://./src/app/assets/scss/modules/profiles/components/_profiledetails.scss","webpack://./src/app/assets/scss/modules/profiles/components/_profilepic.scss","webpack://./src/app/assets/scss/modules/profiles/components/_viewallmembers.scss","webpack://./src/app/assets/scss/modules/recomendations/_recomendations.scss","webpack://./src/app/assets/scss/modules/helpandsupport/_helpandsupport.scss","webpack://./src/app/assets/scss/modules/changepassword/_changepassword.scss","webpack://./src/app/assets/scss/shared/landingheader/_landingheader.scss","webpack://./src/app/assets/scss/shared/landingfooter/_landingfooter.scss","webpack://./src/app/assets/scss/modules/staticpages/landingpage/_landingpage.scss","webpack://./src/app/assets/scss/modules/staticpages/landingpage/components/_landsection1.scss","webpack://./src/app/assets/scss/modules/staticpages/landingpage/components/_landsection2.scss","webpack://./src/app/assets/scss/modules/staticpages/landingpage/components/_landsection3.scss","webpack://./src/app/assets/scss/modules/staticpages/landingpage/components/_landsection4.scss","webpack://./src/app/assets/scss/modules/staticpages/landingpage/components/_landsection5.scss","webpack://./src/app/assets/scss/modules/staticpages/landingpage/components/_landsection6.scss","webpack://./src/app/assets/scss/modules/staticpages/landingpage/components/_landsection7.scss","webpack://./src/app/assets/scss/modules/staticpages/landingpage/components/_landsection8.scss","webpack://./src/app/assets/scss/modules/staticpages/landingpage/components/_landcontactus.scss","webpack://./src/app/assets/scss/modules/staticpages/landingpage/components/_landsectionAi.scss","webpack://./src/app/assets/scss/modules/staticpages/landingpage/components/_landvideoframe.scss","webpack://./src/app/assets/scss/modules/staticpages/aboutus/_aboutus.scss","webpack://./src/app/assets/scss/modules/staticpages/careers/_careers.scss","webpack://./src/app/assets/scss/modules/staticpages/salesenquiry/_salesenquiry.scss","webpack://./src/app/assets/scss/modules/staticpages/termsofuse/_termsofuse.scss","webpack://./src/app/assets/scss/modules/chatai/components/chatsidebar/_unifiedsidebar.scss","webpack://./src/app/assets/scss/modules/chatai/components/chatsidebar/_chatsearchmodal.scss","webpack://./src/app/assets/scss/modules/chatai/components/chatsidebar/_sourcespanel.scss","webpack://./src/app/assets/scss/modules/chatai/components/chatfeed/_unifiedfeed.scss","webpack://./src/app/assets/scss/modules/chatai/components/chatfeed/components/_usermessage.scss","webpack://./src/app/assets/scss/modules/chatai/components/chatfeed/components/_thoughtprocess.scss","webpack://./src/app/assets/scss/modules/chatai/components/chatfeed/components/_airesponse.scss","webpack://./src/app/assets/scss/modules/chatai/components/chatfeed/components/_referencechips.scss","webpack://./src/app/assets/scss/modules/chatai/components/chatfeed/components/_filedownloadchips.scss","webpack://./src/app/assets/scss/modules/chatai/components/chatfeed/components/_inputtoolbar.scss","webpack://./src/app/assets/scss/modules/chatai/components/chatfeed/components/_unifiedinput.scss","webpack://./src/app/assets/scss/modules/chatai/_chatai.scss","webpack://./src/app/assets/scss/modules/chatai/components/chatsidebar/_chatsidebar.scss","webpack://./src/app/assets/scss/modules/chatai/components/chatfeed/_chatfeed.scss","webpack://./src/app/assets/scss/modules/chatai/components/chatsidebar/components/_previouschat.scss","webpack://./src/app/assets/scss/modules/chatai/components/chatsidebar/components/_sidebarheader.scss","webpack://./src/app/assets/scss/modules/chatai/components/chatfeed/components/_chattextarea.scss","webpack://./src/app/assets/scss/modules/chatai/components/chatfeed/components/_feedtiles.scss","webpack://./src/app/assets/scss/modules/chatai/components/chatfeed/components/chatcontent/_chatcontent.scss","webpack://./src/app/assets/scss/modules/chatai/components/chatfeed/components/chatcontent/components/_imageresults.scss","webpack://./src/app/assets/scss/modules/chatai/components/chatfeed/components/chatcontent/components/_learnmore.scss","webpack://./src/app/assets/scss/modules/chatai/components/chatfeed/components/chatcontent/components/_relatedarticles.scss","webpack://./src/app/assets/scss/modules/chatai/components/chatfeed/components/chatcontent/components/_vegachart.scss","webpack://./src/app/assets/scss/modules/chatai/components/chatfeed/components/_fileupload.scss"],"names":[],"mappings":"AACA;EACI,qCCyDU;EDxDV,eC0DY;EDzDZ,cCHoB;EDIpB,gBAAA;EACA,mCAAA;EACA,kCAAA;AEAJ;;AFEA;EACI,gBAAA;EACA,eAAA;EACA,YAAA;EACA,kBCyCI;EDxCJ,YAAA;EACA,WAAA;EACA,mBAAA;EACA,eC4CY;AC3ChB;;AFCA;EACI,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,eCsCmB;ACpCvB;;AFAA;EACI,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,eCgCmB;AC7BvB;;AFDA;EACI,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,eCyBmB;ACrBvB;;AFDA;EACI,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,eCiBmB;ACbvB;;AFDA;EACI,gBAAA;EACA,mBAAA;EACA,mBAAA;AEIJ;;AFFA;EACI,mBAAA;AEKJ;;AFHA;EACI,WAAA;AEMJ;;AFJA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;AEOJ;AFNI;EACI,kBAAA;AEQR;;AFJA;EACI,YAAA;AEOJ;;AFLA;EACG,iBAAA;AEQH;;AFNA;EACI,iBAAA;AESJ;;AFPA;EACI,WAAA;AEUJ;;AFRA;EACI,WAAA;AEWJ;;AFTA;EACI,sBAAA;AEYJ;;AFVA;EACI,sBAAA;AEaJ;;AFXA;EACA,yBAAA;EACA,gBAAA;AEcA;;AFZA;EACI,yBAAA;EACA,WAAA;AEeJ;;AFbA;EACI,yBAAA;EACA,YAAA;AEgBJ;;AFdA;EACI,iBAAA;EACA,kBAAA;EACA,SAAA;AEiBJ;;AFfA;EACI,yBAAA;AEkBJ;;AFhBA;EACI,yBAAA;EACA,WAAA;AEmBJ;;AFjBA;EACI,gBAAA;EACA,WAAA;AEoBJ;;AFlBA;EAAkB,gBAAA;EACd,WAAA;AEsBJ;;AFrBA;EACI,iBAAA;AEwBJ;;AFtBA;EACI,cAAA;AEyBJ;;AFvBA;EACI,gBAAA;AE0BJ;;AFxBA;;EAEI,gBAAA;AE2BJ;;AFzBA;EACI,YAAA;EACA,iBAAA;AE4BJ;;AF1BA;EACI,kBAAA;AE6BJ;;AF3BA;EACI,0BAAA;AE8BJ;;AF5BA;EACI,2BAAA;AE+BJ;;AF7BA;EACI,mBAAA;AEgCJ;;AF9BA;EACI,mBAAA;AEiCJ;;AF/BA;EACI,mBAAA;AEkCJ;;AFhCA;EACI,mBAAA;AEmCJ;;AFjCA;EACI,mBAAA;AEoCJ;;AFlCA;EACI,mBAAA;AEqCJ;;AFnCA;EACI,mBAAA;AEsCJ;;AFpCA;EACI,mBAAA;AEuCJ;;AFrCA;EACI,gBAAA;AEwCJ;;AFtCA;EACI,gBAAA;AEyCJ;;AFvCA;EACI,gBAAA;AE0CJ;;AFxCA;EACI,gBAAA;AE2CJ;;AFzCA;EACI,gBAAA;AE4CJ;;AF1CA;EACI,gBAAA;AE6CJ;;AF3CA;EACI,aAAA;AE8CJ;;AF5CA;EACI,aAAA;AE+CJ;;AF7CA;EACI,aAAA;AEgDJ;;AF9CA;EACI,aAAA;AEiDJ;;AF/CA;EACI,cCrMY;ACuPhB;;AFhDA;EACI,mBCxMY;AC2PhB;;AFjDA;EACI,iBAAA;AEoDJ;;AFlDA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;AEqDJ;;AFnDA;EACI,+BAAA;AEsDJ;;AFpDA;EACI,8BAAA;AEuDJ;;AFrDA;EACI,6BAAA;AEwDJ;;AFtDA;EACI,gCAAA;AEyDJ;;AFvDA;EACI,mBAAA;AE0DJ;;AFxDA;EACI,mBAAA;EACA,4CAAA;EACA,mBCnLS;AC8Ob;;AFzDA;EACI,aAAA;AE4DJ;;AFzDA;EACI,UAAA;EACA,gBAAA;AE4DJ;;AF1DA;EACI,YAAA;AE6DJ;;AF3DA;EACI,gBAAA;AE8DJ;;AF5DA;EACI,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AE+DJ;;AF7DA;EACI,gBAAA;EACA,YAAA;EACA,UAAA;AEgEJ;;AF9DA;EACI,+BAAA;AEiEJ;;AF/DA;EACI,mBAAA;AEkEJ;;AFhEA;EACI,oCAAA;EACA,WAAA;AEmEJ;;AFjEA;EACI,uCAAA;AEoEJ;;AFlEA;EACI,oCAAA;AEqEJ;;AFnEA;EACI,eAAA;AEsEJ;;AFpEA;EACI,YAAA;AEuEJ;;AFrEA;EACI,aAAA;AEwEJ;;AFtEA;EACI,yBAAA;AEyEJ;;AFvEA;EACI,qBAAA;AE0EJ;;AFnEA;EACI,0BAAA;EACA,eAAA;AEsEJ;;AFpEA;EACI;IACI,kBAAA;IAAmB,mBAAA;EEwEzB;EFtEE;IACI,wBAAA;EEwEN;EFtEE;IACI,wBAAA;EEwEN;AACF;AF9CA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AEgDJ;;AF7CA;EACI,OAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AEgDJ;;AC1YA;EACI,iBAAA;AD6YJ;;AC3YA;EACI,YAAA;EACA,yBAAA;EAEA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,4BAAA;AD6YJ;;AC3YA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,MAAA;EACA,mBAAA;EACA,aAAA;AD8YJ;;AC5YA;EACI,gBAAA;EACA,mBF2BS;ACoXb;;AC7YA;EACI,OAAA;EACA,kBAAA;ADgZJ;;AC9YA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;ADiZJ;;AC/YA;EACI,cFvCoB;EEwCpB,gBAAA;EACA,qBAAA;ADkZJ;;AC/YA;EACI,qBAAA;ADkZJ;;AChZA;EACI,kBAAA;EACA,UAAA;EACA,SAAA;ADmZJ;;ACjZA;EACI,eFQmB;AC4YvB;;AClZA;EACI,gBAAA;EACA,qBAAA;EACA,eFEY;ACmZhB;;ACnZA;EACI,gBAAA;ADsZJ;;ACpZA;EACI;IACI,UAAA;EDuZN;AACF;ACrZA;EACI;IACI,aAAA;EDuZN;ECrZE;IACI,aAAA;EDuZN;ECrZE;IACI,kBAAA;EDuZN;ECrZE;IACI,cAAA;EDuZN;ECpZE;IACI,aAAA;IACA,mBAAA;EDsZN;ECpZE;IACI,eAAA;IACA,mBAAA;EDsZN;ECpZE;IACI,WAAA;IACA,UAAA;IACA,aAAA;EDsZN;ECpZE;IACI,aAAA;EDsZN;ECpZE;IACI,WAAA;IACA,4BAAA;IACA,iCAAA;IACA,yBFlGQ;IEmGR,YAAA;IACA,UAAA;EDsZN;ECpZE;IACI,SAAA;IACA,WAAA;IACA,kBAAA;EDsZN;ECpZE;IACI,gBAAA;EDsZN;ECpZE;IACI,kBAAA;EDsZN;ECpZE;IACI,eAAA;IACA,mBAAA;EDsZN;AACF;AE9gBA;EACI,YAAA;EACA,mBHEY;EGDZ,kBAAA;EACA,2BAAA;EACA,4BAAA;AFghBJ;;AE9gBA;EACI,YAAA;AFihBJ;;AE/gBA;EACI,OAAA;EACA,kBAAA;AFkhBJ;;AEhhBA;EACI,mBAAA;AFmhBJ;;AEjhBA;EACI,iBAAA;AFohBJ;;AElhBA;EACI,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBH6BI;EG5BJ,eAAA;EACA,YAAA;AFqhBJ;;AEnhBA;EACI,iBAAA;AFshBJ;;AEphBA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;AFuhBJ;;AErhBA;EACI,iBAAA;AFwhBJ;;AEthBA;EACI,qBAAA;EACA,aAAA;EACA,sBAAA;AFyhBJ;;AEvhBA;EACI,gBAAA;AF0hBJ;;AExhBA;EACI,yBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;AF2hBJ;;AEzhBA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,OAAA;EACA,gBAAA;AF4hBJ;;AE1hBA;EACI,aAAA;AF6hBJ;;AE3hBA;EACI,kBAAA;EACA,WAAA;EACA,cHjEY;EGkEZ,eAAA;AF8hBJ;;AE5hBA;EACI,yBAAA;EACA,mBAAA;EACA,cHvEY;ACsmBhB;;AE7hBA;EACI,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EAEA,YAAA;EACA,gBAAA;AF+hBJ;;AE7hBA;EACI,iBAAA;AFgiBJ;;AE9hBA;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AFiiBJ;;AE7hBA;;EAEI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;AFgiBJ;;AE9hBA;;EAEI,eAAA;AFiiBJ;;AE/hBA;EACI,YAAA;AFkiBJ;;AEhiBA;EACI,mBAAA;AFmiBJ;;AEjiBA;EACI,qBAAA;AFoiBJ;;AEliBA;EACI,aAAA;EACA,WAAA;EACA,YAAA;AFqiBJ;;AEniBA;EACI,gBAAA;AFsiBJ;;AEpiBA;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;AFuiBJ;;AEriBA;EACI,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;AFwiBJ;;AEtiBA;EACI,qBAAA;AFyiBJ;;AEviBA;EACI,aH3IY;ACqrBhB;;AExiBA;EACI,aAAA;AF2iBJ;;AEziBA;EACI,eAAA;EACA,YAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;AF4iBJ;;AEziBA;EACI,eAAA;EACA,WAAA;AF4iBJ;;AE1iBA;EACI,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AF6iBJ;;AE1iBA;EACI,YAAA;AF6iBJ;;AE3iBA;EACI;IACI,WAAA;IACA,4BAAA;IACA,aAAA;EF8iBN;EE5iBE;IACI,kBAAA;EF8iBN;EE5iBE;IACI,kBAAA;EF8iBN;EE5iBE;IACI,gBAAA;EF8iBN;AACF;AE5iBA;EAII;IACI,eAAA;EF2iBN;EExiBE;IACI,WAAA;IACA,UAAA;IACA,iBAAA;IACA,gBAAA;IACA,YAAA;IACA,gBAAA;IACA,iBAAA;EF0iBN;EExiBE;IACI,eAAA;EF0iBN;EExiBE;IACI,WAAA;IACA,gBAAA;EF0iBN;EExiBE;IACI,kBAAA;IACA,SAAA;IACA,gBAAA;IACA,cAAA;IACA,mBAAA;IACA,uBAAA;EF0iBN;AACF;AGxwBA;EACI,YAAA;EACA,mBJoDS;EInDT,UAAA;EACA,6CAAA;AH0wBJ;;AGxwBA;EACI,gBAAA;AH2wBJ;;AGzwBA;EACI,aAAA;AH4wBJ;;AG1wBA;EACI,aAAA;EACA,WAAA;EACA,QAAA;AH6wBJ;;AG3wBA;EACI,YAAA;EACA,kBAAA;EACA,gBAAA;AH8wBJ;;AG5wBA;EACI,YAAA;EACA,kBAAA;AH+wBJ;;AG7wBA;EACI,8BAAA;AHgxBJ;;AG9wBA;EACI,gCAAA;EACA,eAAA;EACA,sBAAA;EACA,8BAAA;AHixBJ;;AG/wBA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;AHkxBJ;;AGhxBA;EACI,UAAA;EACA,UAAA;EACA,SAAA;AHmxBJ;;AGjxBA;EACI,UAAA;AHoxBJ;;AGlxBA;EACI,UAAA;AHqxBJ;;AGnxBA;EACI,gBAAA;AHsxBJ;;AGpxBA;EACA,YAAA;AHuxBA;;AGrxBA;EACI,gBAAA;EACA,eAAA;AHwxBJ;;AGtxBA;EACI,gBAAA;AHyxBJ;;AGvxBA;EACI,gBAAA;AH0xBJ;;AGxxBA;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;AH2xBJ;;AGzxBA;EACI,YAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AH4xBJ;;AG1xBA;EACI,eAAA;AH6xBJ;;AG3xBA;EACI,iBAAA;AH8xBJ;;AG5xBA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;AH+xBJ;;AG7xBA;EACI,gCAAA;EACA,mBAAA;EACA,iBAAA;AHgyBJ;;AG9xBA;EACI;IACI,WAAA;IACA,eAAA;IACA,gBAAA;EHiyBN;EG/xBE;IACI,WAAA;EHiyBN;EG/xBE;IACI,eAAA;EHiyBN;AACF;AI74BA;EACI,wBAAA;EACA,mBAAA;EACA,gCAAA;EACA,2BAAA;EACA,iBAAA;EACA,oBAAA;AJ+4BJ;;AI74BA;EACI,YAAA;AJg5BJ;;AI94BA;EACI,iBAAA;AJi5BJ;;AI94BA;;EAEI,cLbY;AC85BhB;;AK95BA;EACE,mBNDc;EMEd,kBAAA;EACA,aAAA;ALi6BF;;AK95BA;EAAc,UAAA;ALk6Bd;;AKh6BA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,SAAA;ALm6BF;;AKh6BA;EACE,SAAA;EACA,cAAA;ALm6BF;AKj6BE;EACE,cAAA;EACA,gBAAA;EAGA,+BAAA;ALi6BJ;;AK75BA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,yBAAA;ALg6BF;;AK75BA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;ALg6BF;;AK75BA;EACE,kBAAA;EACA,gCAAA;EACA,uBAAA;EACA,YAAA;EACA,qCNMY;EMLZ,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,4BAAA;ALg6BF;AK95BE;EAAU,cAAA;ALi6BZ;AK/5BE;EAEE,cAAA;EACA,gBAAA;EACA,iBAAA;ALg6BJ;AK95BI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;ALg6BN;;AK35BA;EACE,qBAAA;EACA,UAAA;EACA,YAAA;EACA,qCAAA;EACA,aAAA;EACA,cAAA;AL85BF;;AKv5BA;EACE,eAAA;AL05BF;;AKp5BE;EACE,kCAAA;EACA,uBAAA;EACA,uBAAA;EACA,2BAAA;EACA,yBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EAGA,uBAAA;EACA,sBAAA;EACA,uBAAA;ALq5BJ;AKn5BI;EAAW,aAAA;ALs5Bf;AKr5BI;EAAM,eAAA;ALw5BV;AKr5BE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;ALu5BJ;;AKj5BA;EACE,cAAA;ALo5BF;AKl5BE;EACE,kCAAA;EACA,uBAAA;EACA,qBAAA;EACA,2BAAA;EAEA,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;ALm5BJ;AKj5BI;EAAW,aAAA;ALo5Bf;AKl5BI;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,0CAAA;EACA,SAAA;ALo5BN;AKl5BM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;ALo5BR;;AK74BA;;;EAGE,YAAA;EACA,0CAAA;EACA,mBAAA;EACA,YAAA;EACA,0BAAA;ALg5BF;;AK74BA;;EAEE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;ALg5BF;AK94BE;;;EAEE,cNjMY;EMkMZ,mBAAA;ALi5BJ;;AK74BA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;ALg5BF;;AKz4BA;EACE;IAAoB,kBAAA;IAAoB,eAAA;EL84BxC;EK74BA;IAAqB,gBAAA;ELg5BrB;EK/4BA;IAAwB,gBAAA;ELk5BxB;EKh5BA;;IACkC,UAAA;IAAY,WAAA;ELo5B9C;AACF;AKj5BA;EACE;IAAqB,SAAA;ELo5BrB;AACF;AKh5BA;EACE;IAAqB,QAAA;ELm5BrB;EKl5BA;IAAqB,QAAA;ELq5BrB;EKp5BA;IACE,gBAAA;IACA,eAAA;IACA,mBAAA;ELs5BF;EKp5BA;;IACkC,SAAA;IAAW,UAAA;ELw5B7C;EKv5BA;IAAuB,YAAA;IAAc,aAAA;EL25BrC;EK15BA;IAA0C,uBAAA;EL65B1C;EK55BA;IAA+C,WAAA;IAAa,YAAA;ELg6B5D;EK/5BA;IAAwB,gBAAA;ELk6BxB;AACF;AKh6BA;EACE;IAA8B,wBAAA;ELm6B9B;EKl6BA;IAA0C,wBAAA;ELq6B1C;AACF;AKn6BA;EACE;IAAqB,gBAAA;ELs6BrB;EKr6BA;IAAwB,gBAAA;ELw6BxB;EKt6BA;IAAoB,cAAA;ELy6BpB;EKv6BA;IAAqB,aAAA;EL06BrB;EKx6BA;IACE,kBAAA;IACA,SAAA;IACA,OAAA;IACA,QAAA;IACA,WAAA;IACA,mBNnQY;IMoQZ,WAAA;IACA,+CAAA;IACA,0CAAA;IAEA,cAAA;IACA,2BAAA;IACA,cAAA;ELy6BF;EKv6BE;IACE,aAAA;IACA,sBAAA;IACA,oBAAA;IACA,WAAA;IACA,cAAA;IACA,MAAA;ELy6BJ;EKt6BE;IACE,WAAA;IACA,kBAAA;IACA,cAAA;IACA,eAAA;IACA,gBAAA;IACA,gBAAA;ELw6BJ;EKt6BI;IAAqB,aAAA;ELy6BzB;EKx6BI;IACE,qCAAA;IACA,gBAAA;EL06BN;EKv6BI;IACE,qCAAA;ELy6BN;EKr6BE;IACE,cAAA;IACA,WAAA;IACA,WAAA;IACA,gBAAA;IACA,qCAAA;ELu6BJ;EKp6BE;;IACsB,aAAA;ELu6BxB;EKp6BA;IACE,aAAA;ELs6BF;EKp6BE;IACE,kCAAA;IACA,uBAAA;IACA,yBAAA;IACA,2BAAA;ELs6BJ;EKr6BI;IAAW,aAAA;ELw6Bf;EKv6BI;IAAM,eAAA;EL06BV;EKv6BE;IACE,uBAAA;IACA,YAAA;IACA,YAAA;IACA,cAAA;IACA,oBAAA;IACA,mBAAA;IACA,uBAAA;ELy6BJ;EKv6BI;IACE,gBAAA;IACA,+BAAA;ELy6BN;AACF;AKj6BE;EADF;IAC8B,wBAAA;ELq6B5B;AACF;;AKl6BE;EADF;IAC8B,wBAAA;ELu6B5B;AACF;;AKr6BA;EACE,0CAAA;ALw6BF;AKv6BE;EAAU,sBAAA;AL06BZ;;AM5wCA;EACI,6BAAA;EACA,aAAA;EACA,SAAA;AN+wCJ;;AM3wCA;EACI,eAAA;EACA,iBAAA;EACA,cAAA;AN8wCJ;;AOvxCA;EACI,eAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;AP0xCJ;;AOxxCA;EACI,WAAA;EACA,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AP2xCJ;;AOzxCA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;AP4xCJ;;AO1xCA;EACI,YAAA;AP6xCJ;;AO3xCA;;EAEI,YAAA;AP8xCJ;;AO5xCA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,cRtCoB;ACq0CxB;;AO7xCA;EACI,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;APgyCJ;;AO9xCA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;APiyCJ;;AO/xCA;EACI,iBAAA;APkyCJ;;AOhyCA;EAAuC,kBAAA;EAAmB,YAAA;APqyC1D;;AOpyCA;EACA,cR1DgB;ACi2ChB;;AOpyCA;EACI,kBAAA;EACA,aAAA;EACA,WAAA;EACA,mBRjEY;EQkEZ,WAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;APuyCJ;;AOnyCA;EACI,gBAAA;EACA,QAAA;APsyCJ;;AOnyCA;EACI,aAAA;APsyCJ;;AOjyCA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,cR7FoB;ACi4CxB;;AOlyCA;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;APqyCJ;;AOnyCA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;APsyCJ;;AOpyCA;EACI,iBAAA;APuyCJ;;AOryCA;EAAmC,kBAAA;EAAmB,YAAA;AP0yCtD;;AOzyCA;EACA,cRhHgB;AC45ChB;;AOzyCA;EACI,kBAAA;EACA,aAAA;EACA,WAAA;EACA,mBRvHY;EQwHZ,WAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;AP4yCJ;;AOvyCA;EACI;IACI,iBAAA;EP0yCN;AACF;AOxyCA;EACI;IACI,eAAA;EP0yCN;EOxyCE;IACI,UAAA;IACA,WAAA;EP0yCN;EOxyCE;IACI,eAAA;IACA,iBAAA;EP0yCN;AACF;AQ97CA;EACI,gBAAA;EACA,qBAAA;ARg8CJ;;AQ97CA;;EAEI,eAAA;EACA,cAAA;EACA,kBAAA;ARi8CJ;;AQ/7CA;EACI,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;ARk8CJ;;AQh8CA;EACI,eAAA;EACA,WAAA;EACA,eAAA;ARm8CJ;;AQj8CA;EACI,kBAAA;EACA,kBAAA;EACA,SAAA;ARo8CJ;;AQl8CA;EACI,qBAAA;EACA,cTxBY;AC69ChB;;AQn8CA;EACI,OAAA;ARs8CJ;;AQj8CA;EAEI,oBAAA;ARm8CJ;;AQh8CA;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,oBAAA;ARm8CJ;;AQj8CA;EACI,kBAAA;ARo8CJ;;AQl8CA;EACI,sBAAA;EACA,uBAAA;EACA,gBAAA;ARq8CJ;;AQn8CA;EAGI,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;EACA,oBAAA;EACA,gBAAA;ARo8CJ;;AQj8CA;;EAEI,kBAAA;ARo8CJ;;AQj8CA;EAGI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,yBThFY;ESiFZ,kBAAA;ARk8CJ;;AQh8CA;EAGI,WAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,gCAAA;EACA,4BAAA;EACA,wBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,uBAAA;ARi8CJ;;AQ/7CA;EACI,aAAA;ARk8CJ;;AQh8CA;EACI;IACI,mBAAA;ERm8CN;AACF;AQj8CA;EACA;IACI,eAAA;ERm8CF;EQj8CF;IACI,WAAA;IACA,UAAA;ERm8CF;EQj8CF;IACI,cAAA;IACA,kBAAA;ERm8CF;EQj8CF;IACI,mBAAA;IACA,yBAAA;IACA,WAAA;ERm8CF;EQj8CF;IACI,iBAAA;ERm8CF;EQj8CF;IAGI,SAAA;ERi8CF;EQ/7CF;IAGI,SAAA;ER+7CF;AACF;AQx7CA;EACI,iBAAA;AR07CJ;;AQx7CA;;EAEI,aAAA;AR27CJ;;AQz7CA;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AR47CJ;;AS5lDA;EACI,yBVGY;EUFZ,YAAA;EACA,WAAA;AT+lDJ;;AS7lDA;EACI,YAAA;ATgmDJ;;AS9lDA;EACI,YAAA;ATimDJ;;AS/lDA;EACI,UAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,WAAA;ATkmDJ;;AShmDA;EACI,yBAAA;EACA,eAAA;ATmmDJ;;ASjmDA;EACI,yBAAA;EACA,eAAA;ATomDJ;;ASlmDA;;EAEI,kBAAA;EACA,SAAA;ATqmDJ;;ASnmDA;EACI,eAAA;ATsmDJ;;ASpmDA;EACI,oBAAA;ATumDJ;;ASrmDA;;EAEI,eAAA;EACA,iBAAA;EACA,iBAAA;ATwmDJ;;AStmDA;EACI,cAAA;ATymDJ;;ASvmDA;EACI,gBAAA;AT0mDJ;;ASvmDA;EACI,YAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AT0mDJ;;ASvmDA;EACI,cAAA;AT0mDJ;;ASvmDA;EACI,yBVnEY;EUoEZ,YAAA;EACA,sBAAA;EACA,kBAAA;AT0mDJ;;ASxmDA;EACI,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,6BAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;AT2mDJ;;ASzmDA;EACI,WAAA;AT4mDJ;;AS1mDA;EACI,kBAAA;AT6mDJ;;AS1mDA;EACI,cAAA;AT6mDJ;;AS3mDA;EACI,gBAAA;EACA,YAAA;AT8mDJ;;AS5mDA;EACI;IACI,cAAA;ET+mDN;AACF;AU1tDA;EACI,eAAA;AV4tDJ;;AU1tDA;EACI,6BAAA;EACA,WAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;AV6tDJ;;AUxtDA;EACI,SAAA;EACA,YAAA;AV2tDJ;;AUztDA;EACI,SAAA;EACA,mBAAA;AV4tDJ;;AU1tDA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;AV6tDJ;;AU3tDA;EACI,2BAAA;AV8tDJ;;AU5tDA;EACI,aAAA;EACA,mBAAA;AV+tDJ;;AU7tDA;EACI,gBAAA;EACA,cAAA;AVguDJ;;AU7tDA;EACI,YAAA;AVguDJ;;AU3tDA;EACI,iBAAA;AV8tDJ;;AU5tDA;EACI,gBAAA;EACA,mBAAA;AV+tDJ;;AU7tDA;EACA,eAAA;AVguDA;;AU7tDA;EACI;IACI,aAAA;EVguDN;EU9tDE;IACI,gBAAA;EVguDN;AACF;AW7xDA;EACI,UAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;AX+xDJ;;AW7xDA;EACI,YAAA;AXgyDJ;;AW9xDA;;EAEI,gBAAA;EACA,YAAA;AXiyDJ;;AW/xDA;;;EAGI,UAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;AXkyDJ;;AYxzDA;EACI,2BAAA;EACA,iBAAA;AZ2zDJ;;AYzzDA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AZ4zDJ;;AY1zDA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AZ6zDJ;;AY3zDA;EACI,kBAAA;EACA,UAAA;EACA,SAAA;AZ8zDJ;;AY5zDA;EACI,iBAAA;EACA,kBAAA;EACA,iBAAA;AZ+zDJ;;Aav1DA;EACI,YAAA;EACA,gCAAA;EACA,eAAA;Ab01DJ;;Aax1DA;EACI,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;Ab21DJ;;Aaz1DA;EACI,cdRY;EcSZ,uBAAA;EACA,UAAA;EACA,eAAA;Ab41DJ;;Aa11DA;EACI,aAAA;EACA,uBAAA;Ab61DJ;;Aa31DA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;Ab81DJ;;Aa51DA;EACI,eAAA;EACA,iBAAA;EACA,eAAA;Ab+1DJ;;Aa71DA;EACI,gBAAA;Abg2DJ;;Aa91DA;EACI,eAAA;Abi2DJ;;Aa/1DA;EACI,eAAA;EACA,gBAAA;Abk2DJ;;Aa/1DA;EACI,yDAAA;Abk2DJ;;Aah2DA;EACI,gBAAA;Abm2DJ;;Aaj2DA;EACI,UAAA;Abo2DJ;;Aal2DA;EACI;IACI,UAAA;Ebq2DN;Ean2DE;IACI,eAAA;IACA,iBAAA;IACA,kBAAA;Ebq2DN;Eal2DE;IACI,eAAA;Ebo2DN;AACF;Acr6DA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;Adu6DJ;;Acr6DA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;Adw6DJ;;Acr6DA;EACI,SAAA;EACA,wFAAA;EACA,gFAAA;Adw6DJ;;Acr6DA;EACI,UAAA;EACA,6FAAA;EACA,qFAAA;Adw6DJ;;Acr6DA;EACI,UAAA;EACA,6FAAA;EACA,qFAAA;Adw6DJ;;Act6DA;EACI;IACI,gCAAA;IACA,wBAAA;Edy6DN;Ecv6DE;IACI,oCAAA;IACA,4BAAA;Edy6DN;AACF;Act6DA;EACI;IACI,gCAAA;IACA,wBAAA;Edw6DN;Ect6DE;IACI,oCAAA;IACA,4BAAA;Edw6DN;AACF;Ae79DA;;EAEI,mBAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;Af+9DJ;;Ae79DA;EACI,aAAA;EACA,WAAA;Afg+DJ;;Ae99DA;;EAEI,aAAA;Afi+DJ;;Ae/9DA;;EAEC,YAAA;EACA,eAAA;Afk+DD;;Aeh+DA;EACI,oBAAA;Afm+DJ;;Aej+DA;EACI,WAAA;Afo+DJ;;Aej+DA;EACI,UAAA;Afo+DJ;;Ael+DA;EACA;IACI,QAAA;Efq+DF;Eel+DF;IACI,WAAA;Efo+DF;AACF;AgBlhEA;EACI,YAAA;EACA,sBAAA;AhBohEJ;;AgBlhEA;EACI,iBAAA;AhBqhEJ;;AgBnhEA;EACI,kBAAA;AhBshEJ;;AgBphEA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,8BAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;AhBuhEJ;;AgBrhEA;EACI,2CAAA;AhBwhEJ;;AgBrhEA;EACI,UAAA;AhBwhEJ;;AgBrhEA;EACI,gBAAA;EACA,cAAA;AhBwhEJ;;AgBthEA;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AhByhEJ;;AgBvhEA;EACI,gBAAA;AhB0hEJ;;AgBxhEA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;AhB2hEJ;;AgBxhEA;EACI,aAAA;EACA,6BAAA;AhB2hEJ;;AgBzhEA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AhB4hEJ;;AgB1hEA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;AhB6hEJ;;AgB3hEA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gCAAA;EACA,oBAAA;EACA,eAAA;AhB8hEJ;;AgB5hEA;EACI,gBAAA;AhB+hEJ;;AgB7hEA;EACI,gBAAA;EACA,gBAAA;AhBgiEJ;;AgB9hEA;EACI,aAAA;AhBiiEJ;;AgB/hEA;EACI,kBAAA;AhBkiEJ;;AgBhiEA;EACI,yBAAA;AhBmiEJ;;AgBjiEA;EACI,sBAAA;AhBoiEJ;;AgBliEA;EACI,kBAAA;EACA,kBAAA;EACA,WAAA;EACC,iBAAA;AhBqiEL;;AgBniEA;EACI,mBjBnGY;EiBoGZ,YAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;AhBsiEJ;;AgBpiEA;EACI,6BAAA;EACA,cjBlHY;EiBmHZ,eAAA;EACA,YAAA;EACA,gBAAA;AhBuiEJ;;AgBriEA;EACI,YAAA;AhBwiEJ;;AgBtiEA;EACI,mBAAA;EACA,6BAAA;EACA,oBAAA;EACA,iBAAA;AhByiEJ;;AgBviEA;EACI,eAAA;EACA,mBAAA;AhB0iEJ;;AgBxiEA;EACI,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AhB2iEJ;;AgBziEA;EAEI,mBAAA;AhB2iEJ;;AgBziEA;EACI;IACI,UAAA;IACA,mBAAA;EhB4iEN;EgB1iEE;IACI,eAAA;IACA,YAAA;IACA,UAAA;EhB4iEN;EgB1iEE;IACI,cAAA;IACA,0BAAA;IACA,iCAAA;EhB4iEN;EgB1iEE;IACI,iBAAA;IACA,kBAAA;EhB4iEN;EgB1iEE;IACI,UAAA;IACA,UAAA;IACA,gBAAA;EhB4iEN;EgB1iEE;IACI,iBAAA;EhB4iEN;EgB1iEE;IACI,WAAA;IACA,yBAAA;EhB4iEN;EgB1iEE;IACI,oBAAA;EhB4iEN;EgB1iEE;IACG,WAAA;EhB4iEL;EgBziEE;IACI,oBAAA;EhB2iEN;EgBziEE;IACI,cjBzLQ;ECouEd;AACF;AiB1uEA;EACI,kBAAA;EACA,gDAAA;EACA,wCAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AjB4uEJ;AiB1uEI;EACI,wBAAA;EACA,6BAAA;EACA,mCAAA;EACA,uBAAA;EACA,iCAAA;EACA,gBAAA;EACA,2EAAA;EACA,4BAAA;AjB4uER;AiBzuEI;EACI;IACI,4BAAA;EjB2uEV;EiBzuEM;IACI,2BAAA;EjB2uEV;AACF;AiBxuEI;EACI;IACI,8BAAA;EjB0uEV;EiBxuEM;IACI,6BAAA;EjB0uEV;AACF;AiBvuEI;EACI,aAAA;AjByuER;AiBtuEI;EACI,aAAA;AjBwuER;AiBruEI;EACI,YAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;AjBuuER;AiBpuEI;EACI,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AjBsuER;AiBnuEI;EACI,UAAA;AjBquER;;AiBjuEA;EACI,gBAAA;AjBouEJ;;AiBluEA;EACI,eAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AjBquEJ;;AiBnuEA;EACI,YAAA;AjBsuEJ;;AiBpuEA;EACA,eAAA;AjBuuEA;;AiBruEA;EACA,mBAAA;AjBwuEA;;AiBnuEA;EACA,8BAAA;EACA,gBAAA;EACA,gBAAA;EACI,SAAA;EACA,YAAA;AjBsuEJ;;AiBpuEA;EACI,wBAAA;AjBuuEJ;;AiBruEA;EACA,aAAA;EACA,gBAAA;AjBwuEA;;AiBtuEA;EACI,WAAA;AjByuEJ;;AiBvuEA;EACA,mBAAA;AjB0uEA;;AiBxuEA;EACI,YAAA;EACA,oBAAA;AjB2uEJ;;AiBzuEA;EACI,YAAA;AjB4uEJ;;AiB1uEA;EACI;IACI,wBAAA;EjB6uEN;AACF;AiB3uEA;EACI;IACI,aAAA;EjB6uEN;EiB3uEE;IACI,eAAA;EjB6uEN;EiB3uEE;IACI,aAAA;EjB6uEN;EiB3uEE;IACI,aAAA;EjB6uEN;AACF;AiB3uEA;EACI;IACI,aAAA;EjB6uEN;EiB3uEE;IACI,aAAA;EjB6uEN;AACF;AkB13EA;EACI,eAAA;AlB43EJ;;AkB13EA;EACI,mBAAA;AlB63EJ;;AkB33EA;EACI,gBAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,sBAAA;AlB83EJ;;AkB53EA;EACI,YAAA;EACA,sBAAA;AlB+3EJ;;AkB73EA;EACI,sBAAA;AlBg4EJ;;AkB93EA;EACI,gBAAA;AlBi4EJ;;AkB93EA;EACI,WAAA;EACA,gBAAA;AlBi4EJ;;AkB/3EA;EACI,gBAAA;AlBk4EJ;;AkBh4EA;EACI,gBAAA;EACA,gBAAA;AlBm4EJ;;AkBj4EA;EACI,iBAAA;AlBo4EJ;;AkBj4EA;EACI,eAAA;EACA,iBAAA;AlBo4EJ;;AkBl4EA;EACI,eAAA;AlBq4EJ;;AkBn4EA;EACI,cAAA;AlBs4EJ;;AkBp4EA;EACI,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AlBu4EJ;;AkBr4EA;EACI;IACI,WAAA;ElBw4EN;EkBt4EE;IACI,oBAAA;ElBw4EN;AACF;AmB/8EA;EACI,aAAA;EACA,mBAAA;EACA,kBpBkDI;AC+5ER;;AmB/8EA;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AnBk9EJ;;AmBh9EA;EACI,6DAAA;EACA,mDAAA;EACA,aAAA;EACA,mBpBoCS;EoBnCT,kBAAA;AnBm9EJ;;AmBh9EA;EACI,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBpBuBS;AC47Eb;;AmBj9EA;EACI,kBAAA;EACA,cAAA;AnBo9EJ;;AmBj9EA;EACI,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBpBUO;EoBTP,UAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,iBAAA;AnBo9EJ;;AmBl9EA;EACI,gBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AnBq9EJ;;AmBn9EA;EACI,cAAA;EACA,kBAAA;AnBs9EJ;;AmBn9EA;EACI,gBAAA;EACA,aAAA;EACA,mBpBZS;EoBaT,oBAAA;AnBs9EJ;;AmBp9EA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;AnBu9EJ;;AmBr9EA;EACI,wBAAA;AnBw9EJ;;AmBt9EA;EACI,cpB1EY;EoB2EZ,qBAAA;AnBy9EJ;;AmBv9EA;EACI,WAAA;AnB09EJ;;AmBx9EA;EACI,UAAA;AnB29EJ;;AmBz9EA;EACI,UAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;AnB49EJ;;AmB19EA;EACI,eAAA;EACA,UAAA;AnB69EJ;;AmB39EA;EACI;IACI,eAAA;EnB89EN;EmB59EE;IACI,eAAA;IACA,eAAA;EnB89EN;EmB59EE;IACI,UAAA;EnB89EN;EmB59EE;IACI,aAAA;EnB89EN;AACF;AoB7kFA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,oBAAA;EACA,mBAAA;EACA,qBAAA;ApB+kFJ;;AoB7kFA;EACI,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;ApBglFJ;;AoB9kFA;EACI,UAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;ApBilFJ;;AoB/kFA;EACI,eAAA;ApBklFJ;;AoBhlFA;EACI,aAAA;EACA,mBAAA;ApBmlFJ;;AoBjlFA;EACI,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;ApBolFJ;;AoBllFA;EACI,WAAA;ApBqlFJ;;AoBnlFA;EACI,aAAA;ApBslFJ;;AoBplFA;EACI,aAAA;ApBulFJ;;AoBrlFA;EACI,qBAAA;ApBwlFJ;;AoBrlFA;EACI,8BAAA;EACA,kBAAA;EACA,mBAAA;ApBwlFJ;;AoBtlFA;EACI,YAAA;EACA,iBAAA;ApBylFJ;;AoBvlFA;EACI,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;ApB0lFJ;;AoBxlFA;EACI,iBAAA;ApB2lFJ;;AoBzlFA;EACI,cAAA;ApB4lFJ;;AoB1lFA;EACI,OAAA;ApB6lFJ;;AoB3lFA;EACI,yBAAA;EACA,cAAA;ApB8lFJ;;AoB5lFA;EACI,iBAAA;ApB+lFJ;;AoB7lFA;EACI,eAAA;ApBgmFJ;;AoB9lFA;EACI,sBAAA;ApBimFJ;;AoB/lFA;EACI;IACI,YAAA;IACA,gBAAA;IACA,iBAAA;IACA,iBAAA;EpBkmFN;AACF;AoBhmFA;EACI;IACI,kBAAA;EpBkmFN;EoBhmFE;IACI,eAAA;EpBkmFN;EoBhmFE;IACI,iBAAA;IACA,eAAA;IACA,gBAAA;EpBkmFN;AACF;AqB9sFA;EACI,WAAA;EACA,mBtBqDO;AC2pFX;;AqB9sFA;EACI,UAAA;ArBitFJ;;AqB/sFA;EACI,eAAA;EACA,kBtB4CI;ACsqFR;;AqBhtFA;EACI,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ArBmtFJ;;AqBjtFA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;ArBotFJ;;AqBltFA;EACI,mBAAA;ArBqtFJ;;AqBntFA;EACI,eAAA;ArBstFJ;;AqBptFA;EACI,kBAAA;EACA,8BAAA;EACA,YAAA;ArButFJ;;AqBrtFA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;EACA,sBAAA;ArBwtFJ;;AqBrtFA;EACI,cAAA;EACA,mBAAA;ArBwtFJ;;AqBttFA;EACI,SAAA;EACA,UAAA;ArBytFJ;;AqBvtFA;EACI,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,gCAAA;EACA,eAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;ArB0tFJ;;AqBxtFA;EACI,YAAA;EACA,iBAAA;ArB2tFJ;;AqBztFA;EACI,gBAAA;ArB4tFJ;;AqB1tFA;EACI,mBAAA;ArB6tFJ;;AqB3tFA;;EAEI,YAAA;ArB8tFJ;;AqB5tFA;EACI,YAAA;EACA,sBAAA;ArB+tFJ;;AqB7tFA;EAAiB,iBAAA;ArBiuFjB;;AqBhuFA;EACI,mBAAA;ArBmuFJ;;AqBjuFA;EACI,mBAAA;ArBouFJ;;AqBluFA;EACI;IACI,gBAAA;ErBquFN;EqBnuFE;IACI,oBAAA;ErBquFN;AACF;AqB9tFA;EACI;IACI,YAAA;ErBguFN;EqB9tFE;IACI,kBAAA;IACA,mBAAA;IACA,oCAAA;IACA,mBAAA;ErBguFN;EqB9tFE;IACI,eAAA;IACA,YAAA;ErBguFN;EqB9tFE;IACI,eAAA;ErBguFN;EqB9tFE;IACI,cAAA;IACA,6BAAA;ErBguFN;EqB9tFE;IACI,gBAAA;ErBguFN;EqB9tFE;IACI,aAAA;ErBguFN;AACF;AqB9tFA;EACI;IACI,mBAAA;ErBguFN;EqB9tFE;IACI,YAAA;ErBguFN;EqB9tFE;IACI,WAAA;ErBguFN;AACF;AsBv2FA;EACE,aAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBvBkDS;ACuzFX;;AsBt2FA;EACE,OAAA;EACA,gBAAA;EACA,eAAA;EACA,mBvB2CS;AC8zFX;;AsBv2FA;EACE,mBvBwCS;ACk0FX;;AsBx2FA;EACE,eAAA;AtB22FF;;AsBz2FA;EACE,YAAA;EACA,iBAAA;AtB42FF;;AsB12FA;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;AtB62FF;;AsB32FA;EACE,eAAA;AtB82FF;;AsB52FA;EACE,mBAAA;AtB+2FF;;AsB72FA;EACE;IACE,aAAA;EtBg3FF;AACF;AsB92FA;EACE;IACE,aAAA;EtBg3FF;EsB92FA;IACE,gBAAA;EtBg3FF;AACF;AuB/5FA;EACI,eAAA;AvBi6FJ;;AuB/5FA;EACI,gCAAA;EACA,oBAAA;AvBk6FJ;;AuBh6FA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,SAAA;AvBm6FJ;;AuBj6FA;EACI,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AvBo6FJ;;AuBl6FA;EACI,cAAA;AvBq6FJ;;AuBn6FA;EAAqB,aAAA;AvBu6FrB;;AuBt6FA;EACI,gBAAA;EACA,iBAAA;EACA,eAAA;AvBy6FJ;;AuBv6FA;EACI,eAAA;EACA,kBAAA;AvB06FJ;;AuBx6FA;EACI,gBAAA;EACA,gBAAA;AvB26FJ;;AuBz6FA;EAA2C,wBAAA;AvB66F3C;;AuB56FA;EACI,kBAAA;AvB+6FJ;;AuB76FA;EACE,gBAAA;AvBg7FF;;AuB96FA;EACI,kBAAA;EACA,OAAA;EACA,UAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AvBi7FJ;;AuB96FA;EACI,qBAAA;AvBi7FJ;;AuB/6FA;EACI,UAAA;AvBk7FJ;;AuBh7FA;EACI,UAAA;AvBm7FJ;;AuBj7FA;EACI,sBAAA;EACA,UAAA;AvBo7FJ;;AuBl7FA;EACI;IACI,OAAA;IACA,kBAAA;EvBq7FN;AACF;AuBn7FA;EACI;IACI,eAAA;IACA,eAAA;IACA,kBAAA;EvBq7FN;AACF;AuBj7FA;EACI;IACI,2BAAA;EvBm7FN;EuBj7FE;IACI,YAAA;EvBm7FN;EuBj7FE;IACI,eAAA;IACA,mBAAA;EvBm7FN;EuBj7FE;IACI,SAAA;EvBm7FN;AACF;AuB96FA;EACI;IACI,eAAA;EvBg7FN;EuB96FE;IACI,mBAAA;IACA,qBAAA;EvBg7FN;EuB96FE;IACI,cAAA;IACA,eAAA;IACA,kBAAA;EvBg7FN;EuB96FE;IACI,aAAA;IACA,8BAAA;IACA,WAAA;EvBg7FN;EuB96FE;IACI,eAAA;EvBg7FN;EuB96FE;IACI,kBAAA;IACA,cAAA;IACA,aAAA;EvBg7FN;EuB96FE;IACI,4BAAA;EvBg7FN;EuB96FE;IACI,QAAA;IACA,YAAA;EvBg7FN;AACF;AwBnjGA;EACI,mBAAA;EACA,yBAAA;EACA,2CAAA;EACA,mBzBkDS;EyBjDT,sBAAA;AxBqjGJ;;AwBnjGA;EACI,YAAA;AxBsjGJ;;AwBpjGA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,czBdoB;EyBepB,uBAAA;EACA,kBAAA;EACA,mBAAA;AxBujGJ;;AwBrjGA;EACI,czBpBoB;AC4kGxB;;AwBtjGA;EACI,yDAAA;AxByjGJ;;AwBvjGA;EACI,yBAAA;EACA,gBAAA;AxB0jGJ;;AwBxjGA;EACI,gBAAA;EACA,gCAAA;AxB2jGJ;;AwBzjGA;EACI,YAAA;AxB4jGJ;;AwB1jGA;EACI,gBAAA;AxB6jGJ;;AwB3jGA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,gCAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AxB8jGJ;;AwB5jGA;EACI,eAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;AxB+jGJ;;AwB3jGA;EACI,WAAA;EACA,YAAA;EACA,qBAAA;AxB8jGJ;;AwB5jGA;EACI,aAAA;AxB+jGJ;;AwB7jGA;EACI,eAAA;EACA,kBAAA;AxBgkGJ;;AwB9jGA;EACI,kBAAA;AxBikGJ;;AwB/jGA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;AxBkkGJ;;AwBhkGA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,czBjFY;ACopGhB;;AwBhkGA;EACI,mBzBrFY;EyBsFZ,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,oBAAA;AxBmkGJ;;AwBjkGA;EACI,gBAAA;AxBokGJ;;AwBlkGA;EACI,gBAAA;AxBqkGJ;;AwBnkGA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,gCAAA;EACA,mBAAA;EACA,oBAAA;AxBskGJ;;AwBpkGA;EACI,gBAAA;EACA,6BAAA;AxBukGJ;;AwBrkGA;EAEI,gBAAA;EACA,mBAAA;AxBukGJ;;AwBpkGA;EACI,kBAAA;EACA,kBAAA;EACA,mBAAA;AxBukGJ;;AwBpkGA;EACI,gBAAA;AxBukGJ;;AwBpkGA;EACI,kBAAA;EACA,aAAA;AxBukGJ;;AwBpkGA;EACI,eAAA;EACA,iBAAA;AxBukGJ;;AwBpkGA;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AxBukGJ;;AwBpkGA;EACI,mDAAA;EACA,4BAAA;EACA,qBAAA;EACA,2BAAA;AxBukGJ;;AwBlkGA;EACI,yBAAA;EACA,kBzBnHI;EyBoHJ,YAAA;EACA,YAAA;EACA,ezB9GmB;EyB+GnB,WAAA;EACA,kBAAA;AxBqkGJ;;AwBnkGA;EACI,cAAA;AxBskGJ;;AwBpkGA;EACI,WAAA;EACA,iBAAA;AxBukGJ;;AwBpkGA;EACI,YAAA;EACA,wCAAA;EACA,kBAAA;AxBukGJ;;AwBrkGA;EACI,eAAA;EACA,gBAAA;EACA,eAAA;AxBwkGJ;;AwBtkGA;EACI,gBAAA;AxBykGJ;;AwBvkGA;EACI,0BAAA;EACA,iBAAA;EACA,czBnMY;AC6wGhB;;AwBxkGA;EACI,eAAA;EACA,gBAAA;EACA,qCzBlJU;AC6tGd;;AwBzkGA;EACI,mBzB3MY;EyB4MZ,kBzB3JI;ACuuGR;;AwB1kGA;EACI,kBzB9JI;AC2uGR;;AwB3kGA;EACI,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AxB8kGJ;;AwB5kGA;EACI,8BAAA;EACA,0BAAA;EACA,gCAAA;AxB+kGJ;;AwB7kGA;EACI,YAAA;EACA,WAAA;AxBglGJ;;AwB9kGA;EACI,uBAAA;AxBilGJ;;AwB/kGA;EACI,YAAA;EACA,aAAA;AxBklGJ;;AwB/kGA;EACI,aAAA;AxBklGJ;;AwBhlGA;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AxBmlGJ;;AwBjlGA;EACQ,eAAA;EACA,iBAAA;AxBolGR;;AwBjlGA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,2BAAA;AxBolGJ;;AwBllGA;EACI,gBAAA;AxBqlGJ;;AwBnlGA;EACI,sBAAA;EACA,YAAA;EACA,qBAAA;AxBslGJ;;AwBplGA;EACI,gBAAA;AxBulGJ;;AwBrlGA;EACI,kBAAA;AxBwlGJ;;AwBtlGA;EACI,kBAAA;EACA,QAAA;AxBylGJ;;AwBvlGA;EACI,OAAA;AxB0lGJ;;AwBxlGA;EACI,eAAA;AxB2lGJ;;AwBzlGA;EACI,eAAA;AxB4lGJ;;AwB1lGA;EAAqC,mBAAA;AxB8lGrC;;AwB7lGA;EAA8C,WAAA;AxBimG9C;;AwBhmGA;EACI;IACI,eAAA;ExBmmGN;EwBjmGE;IACI,eAAA;IACA,eAAA;IACA,gBAAA;ExBmmGN;AACF;AwBjmGA;EACI;IACI,eAAA;IACA,kBAAA;ExBmmGN;EwBjmGE;IACI,mBAAA;IACA,yBAAA;IACA,kBAAA;ExBmmGN;EwBjmGE;IACI,mBAAA;ExBmmGN;EwBhmGE;IACI,aAAA;ExBkmGN;AACF;AwB/lGA;EACI;IACI,cAAA;ExBimGN;EwB3lGE;IACI,UAAA;ExB6lGN;EwB3lGE;IACI,mBAAA;IACA,eAAA;IACA,YAAA;IACA,YAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;IACA,SAAA;IACA,SAAA;ExB6lGN;EwB1lGE;IACI,aAAA;IACA,8BAAA;IACA,mBzBpVQ;IyBqVR,eAAA;IACA,YAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;IACA,WAAA;IACA,4BAAA;IACA,mBAAA;IACA,iDAAA;ExB4lGN;EwB1lGE;IACI,eAAA;IACA,SAAA;IACA,WAAA;ExB4lGN;EwB1lGE;IAA6B,UAAA;ExB6lG/B;EwB5lGE;IACI,aAAA;ExB8lGN;EwB5lGE;IACI,eAAA;IACA,gBAAA;IACA,WAAA;IACA,MAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;ExB8lGN;EwB5lGE;IACI,kBAAA;IACA,YAAA;ExB8lGN;EwB5lGE;IACI,gBAAA;ExB8lGN;AACF;AyBz9GA;EACI,kBAAA;AzB29GJ;;AyBz9GA;EACI,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;AzB49GJ;;AyB19GA;EACI,mBAAA;AzB69GJ;;AyB39GA;EACI,mBAAA;AzB89GJ;;AyB59GA;EACI,YAAA;EACA,eAAA;EACA,gBAAA;AzB+9GJ;;AyB79GA;EACI,mBAAA;EACA,eAAA;EACA,iBAAA;AzBg+GJ;;AyB99GA;EACI,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,c1B3BY;E0B4BZ,eAAA;AzBi+GJ;;AyB/9GA;EACI,mBAAA;AzBk+GJ;;AyBh+GA;EACI,0BAAA;AzBm+GJ;;AyB79GA;EACI;IACI,eAAA;EzBg+GN;AACF;AyB99GA;EACI;IACI,mBAAA;EzBg+GN;EyB99GE;IACI,eAAA;EzBg+GN;AACF;A0BxhHA;EACI,eAAA;EACA,mBAAA;A1B0hHJ;;A0BxhHA;EACI,gBAAA;EACA,YAAA;A1B2hHJ;;A0BzhHA;EACI,mBAAA;A1B4hHJ;;A0B1hHA;EACI,aAAA;EACA,mBAAA;A1B6hHJ;;A2BziHA;EACI,YAAA;A3B4iHJ;;A2B1iHA;EACI,mBAAA;A3B6iHJ;;A2B3iHA;EACI,WAAA;EACA,mB5B+CO;E4B9CP,gBAAA;EACA,kBAAA;EACA,yBAAA;A3B8iHJ;;A2B5iHA;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;A3B+iHJ;;A2B7iHA;EACI,aAAA;A3BgjHJ;;A2B9iHA;EACI,SAAA;EACA,UAAA;A3BijHJ;;A2B/iHA;EACI,6BAAA;EACA,iBAAA;EACA,mBAAA;A3BkjHJ;;A2BhjHA;;;EAGI,YAAA;EACA,cAAA;A3BmjHJ;;A2BjjHA;EACI,eAAA;A3BojHJ;;A2BjjHA;EACI,kBAAA;EACA,cAAA;A3BojHJ;;A2BljHA;EACI,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;A3BqjHJ;;A2BnjHA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;A3BsjHJ;;A2BpjHA;EACI,gBAAA;A3BujHJ;;A2BrjHA;EACI,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;A3BwjHJ;;A2BtjHA;EACI,aAAA;EACA,8BAAA;EACA,sBAAA;A3ByjHJ;;A2BvjHA;EAEI,gBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;A3ByjHJ;;A2BvjHA;EACI,WAAA;EACA,iBAAA;EACA,eAAA;A3B0jHJ;;A2BxjHA;EACI;IACI,6BAAA;IACA,iBAAA;E3B2jHN;AACF;A2BzjHA;EACI;IACI,6BAAA;IACA,iBAAA;E3B2jHN;E2BzjHE;IACI,mBAAA;E3B2jHN;AACF;A4B9pHA;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,oDAAA;A5BgqHJ;;A4B9pHA;EACI,mBAAA;EACA,2CAAA;EACA,mB7B4CS;E6B3CT,mBAAA;EACA,aAAA;A5BiqHJ;;A4B/pHA;EACI,WAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,4BAAA;A5BkqHJ;;A4BhqHA;EACI,OAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;A5BmqHJ;;A4BjqHA;EACI,WAAA;EACA,mBAAA;A5BoqHJ;;A4BlqHA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;A5BqqHJ;;A4BnqHA;EACI,mBAAA;A5BsqHJ;;A4BpqHA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;A5BuqHJ;;A4BrqHA;EACI,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;A5BwqHJ;;A4BtqHA;EACI;IACI,kBAAA;E5ByqHN;AACF;A6BtuHA;EACI,YAAA;A7BwuHJ;;A6BtuHA;EACI,YAAA;A7ByuHJ;;A6BvuHA;EACI,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;A7B0uHJ;;A6BvuHA;EAAqB,eAAA;A7B2uHrB;;A6BzuHA;EACI,aAAA;EACA,eAAA;EACA,cAAA;A7B4uHJ;;A6B1uHA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,kB9B4BI;E8B3BJ,eAAA;EACA,kBAAA;A7B6uHJ;;A6B3uHA;EACI,iBAAA;EACA,oBAAA;A7B8uHJ;;A6B5uHA;EACI,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,QAAA;EACA,eAAA;A7B+uHJ;;A6B7uHA;EACI,kBAAA;A7BgvHJ;;A6B9uHA;EACI,iBAAA;A7BivHJ;;A6B/uHA;EACI;IACI,gBAAA;IACA,YAAA;E7BkvHN;AACF;A8BtyHA;EACI,gBAAA;A9BwyHJ;;A8BtyHA;EACI,mBAAA;EACA,gBAAA;A9ByyHJ;;A8BtyHA;EACI;IACI,mBAAA;IACA,gBAAA;E9ByyHN;AACF;A+BpzHA;EACI,iBAAA;A/BszHJ;;A+BpzHA;EACI,2BAAA;A/BuzHJ;;A+BrzHA;EACI,oCAAA;A/BwzHJ;;A+BtzHA;EACI,qBAAA;A/ByzHJ;;A+BtzHA;EACI,gCAAA;EACA,yBAAA;A/ByzHJ;;A+BvzHA;;EAEI,oCAAA;A/B0zHJ;;A+BxzHA;EACI,eAAA;EACA,kBAAA;A/B2zHJ;;A+BzzHA;EACI,eAAA;A/B4zHJ;;A+B1zHA;EACI,eAAA;A/B6zHJ;;A+B3zHA;EACI,OAAA;EACA,QAAA;A/B8zHJ;;A+B3zHA;EACI,iBAAA;A/B8zHJ;;A+B5zHA;EACI,+BAAA;A/B+zHJ;;AgCx2HA;EACI,kBAAA;AhC22HJ;;AgCz2HA;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;AhC42HJ;;AgC12HA;EACI,eAAA;EACA,UAAA;AhC62HJ;;AgC32HA;EACI,eAAA;EACA,UAAA;AhC82HJ;;AgC52HA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;AhC+2HJ;;AgC52HA;EACI;IACI,WAAA;IACA,mBAAA;EhC+2HN;EgC72HE;IACI,WAAA;EhC+2HN;AACF;AgC52HA;EACI;IACI,8BAAA;EhC82HN;AACF;AiCx5HA;EACI,OAAA;AjC05HJ;;AiCx5HA;EACI,iBAAA;AjC25HJ;;AiCz5HA;EACI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oDAAA;AjC45HJ;;AiC15HA;EACI,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;AjC65HJ;;AiC35HA;EACI,kBAAA;AjC85HJ;;AiC55HA;EACI,qBAAA;AjC+5HJ;;AiC55HA;EACI;IACI,WAAA;IACA,YAAA;EjC+5HN;EiC75HE;IACI,kBAAA;EjC+5HN;EiC75HE;IACI,kBAAA;EjC+5HN;AACF;AkCt8HA;EACI,yBAAA;EACA,mBnCoDS;ACo5Hb;;AkCt8HA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,SAAA;AlCy8HJ;;AkCv8HA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;AlC08HJ;;AkCx8HA;EACI,SAAA;AlC28HJ;;AkCz8HA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AlC48HJ;;AkC18HA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AlC68HJ;;AkC38HA;EACI,UAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;AlC88HJ;;AkC58HA;EACI,mBAAA;AlC+8HJ;;AkC78HA;EACI,WAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AlCg9HJ;;AkC98HA;EACI,eAAA;AlCi9HJ;;AkC/8HA;EACI,iBAAA;AlCk9HJ;;AkCh9HA;EACI,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBnCVI;AC69HR;;AkCj9HA;EACI,sBAAA;AlCo9HJ;;AkCl9HA;EACI,yBAAA;AlCq9HJ;;AkCn9HA;EACI,cnCpEY;EmCqEZ,eAAA;EACA,kBAAA;EACA,gBAAA;AlCs9HJ;;AkCp9HA;EAAuB,gBAAA;AlCw9HvB;;AkCv9HA;EACA;IACI,mBAAA;ElC09HF;EkCx9HF;IACI,oBAAA;IACA,mBAAA;ElC09HF;AACF;AkCv9HA;EACI;IACI,WAAA;IACA,mBAAA;ElCy9HN;EkCv9HE;IACI,mBAAA;ElCy9HN;EkCv9HE;IACI,aAAA;ElCy9HN;EkCv9HE;IACI,mBAAA;ElCy9HN;EkCv9HE;IACI,aAAA;ElCy9HN;EkCv9HE;IACI,uBAAA;ElCy9HN;AACF;AmCpkIA;EACI,wCAAA;EACA,mBpCoDS;EoCnDT,gBAAA;EACA,oBAAA;EACA,YAAA;AnCskIJ;;AmCpkIA;EACI,aAAA;EACA,yBpCLY;EoCMZ,6BAAA;EACA,4BAAA;AnCukIJ;;AmCrkIA;EACI,iBAAA;AnCwkIJ;;AmCtkIA;EACI,eAAA;EACA,gBAAA;AnCykIJ;;AmCvkIA;EACI;IACI,YAAA;EnC0kIN;AACF;AoClmIA;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,mBAAA;EACA,iBAAA;ApComIJ;;AoClmIA;EACI,cAAA;ApCqmIJ;;AoCnmIA;EACI,cAAA;ApCsmIJ;;AoCpmIA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;EACA,iBAAA;ApCumIJ;;AoCrmIA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;ApCwmIJ;;AoCtmIA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;ApCymIJ;;AoCvmIA;EACI,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;ApC0mIJ;;AoCxmIA;EACI;IACI,cAAA;IACA,gBAAA;EpC2mIN;EoCzmIE;IACI,YAAA;EpC2mIN;EoCzmIE;IACI,WAAA;IACA,YAAA;IACA,yBAAA;EpC2mIN;AACF;AoCzmIA;EACA;IACI,aAAA;EpC2mIF;EoCzmIF;IACI,eAAA;IACA,SAAA;EpC2mIF;AACF;AqC1qIA;EACI,gCAAA;EACA,oBAAA;ArC4qIJ;;AqC1qIA;EACI,iBAAA;ArC6qIJ;;AqC3qIA;EACI;IACI,kCAAA;ErC8qIN;EqC5qIE;IACI,oBAAA;ErC8qIN;AACF;AsC3rIA;EACI,gCAAA;EACA,oBAAA;EACA,mBAAA;AtC6rIJ;;AsC3rIA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;AtC8rIJ;;AsC5rIA;EACI,OAAA;EACA,kBAAA;AtC+rIJ;;AsC7rIA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;AtCgsIJ;;AsC9rIA;EACI,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;AtCisIJ;;AsC/rIA;EACI,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;AtCksIJ;;AsChsIA;EACI,kBAAA;AtCmsIJ;;AsCjsIA;EACI,yBAAA;EACA,qBAAA;EACA,UAAA;EACA,gBAAA;AtCosIJ;;AsClsIA;EACI;IACI,eAAA;EtCqsIN;EsCnsIE;IACI,UAAA;IACA,gBAAA;EtCqsIN;EsCnsIE;IACI,WAAA;EtCqsIN;EsCnsIE;IACI,OAAA;IACA,eAAA;IACA,gBAAA;IACA,WAAA;EtCqsIN;EsCnsIE;IACI,gBAAA;EtCqsIN;EsCnsIE;IACI,eAAA;IACA,iBAAA;EtCqsIN;AACF;AuCzwIA;EACI,gBAAA;AvC2wIJ;;AuCzwIA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AvC4wIJ;;AuC1wIA;EACI,WAAA;EACA,qBAAA;AvC6wIJ;;AuC3wIA;EAEI,eAAA;AvC6wIJ;;AuC1wIA;EACI,kBAAA;AvC6wIJ;;AuC3wIA;EACI,kBAAA;EACA,kBAAA;EACA,SAAA;AvC8wIJ;;AuC5wIA;EACI,cAAA;AvC+wIJ;;AuC7wIA;EACI,oBAAA;AvCgxIJ;;AuC7wIA;EACI;IAAiB,iBAAA;EvCixInB;EuChxIE;IACI,gBAAA;EvCkxIN;EuC/wIE;IACI,eAAA;EvCixIN;AACF;AuC/wIA;EACI;IACI,eAAA;EvCixIN;EuC/wIE;IACI,eAAA;EvCixIN;AACF;AuC/wIA;EACI;IACI,eAAA;EvCixIN;AACF;AuC/wIA;EACI;IACI,aAAA;EvCixIN;EuC/wIE;IACI,UAAA;IACA,gBAAA;EvCixIN;EuC9wIE;IACI,oBAAA;EvCgxIN;AACF;AwCl1IA;EACI,aAAA;AxCo1IJ;;AwCl1IA;EACI,gBAAA;AxCq1IJ;;AwCn1IA;EACI,iBAAA;AxCs1IJ;;AwCp1IA;EACI,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;AxCu1IJ;;AwCr1IA;EACI,gBAAA;AxCw1IJ;;AwCt1IA;EACI,SAAA;AxCy1IJ;;AwCv1IA;EACI,YAAA;EACA,6BAAA;EACA,aAAA;AxC01IJ;;AwCx1IA;EACI,eAAA;EACA,iBAAA;AxC21IJ;;AwCz1IA;EACI,eAAA;EACA,iBAAA;AxC41IJ;;AwC11IA;;EAEI,czCjCY;EyCkCZ,6BAAA;EACA,4BAAA;AxC61IJ;;AwC31IA;EACI,gBAAA;AxC81IJ;;AwC51IA;EACI,YAAA;EACA,WAAA;EACA,YAAA;AxC+1IJ;;AwC71IA;EACI,cAAA;EACA,cAAA;AxCg2IJ;;AwC91IA;EACI;IAAqB,kBAAA;ExCk2IvB;AACF;AwCh2IA;EACI;IACI,eAAA;IACA,aAAA;ExCk2IN;EwC/1IE;IACI,eAAA;ExCi2IN;EwC/1IE;IACI,UAAA;IACA,SAAA;IACA,OAAA;IACA,cAAA;ExCi2IN;EwC91IE;IACI,WAAA;IACA,cAAA;IACA,gBAAA;IACA,uBAAA;IACA,gBAAA;ExCg2IN;EwC71IE;IACI,cAAA;ExC+1IN;EwC71IE;IACI,SAAA;IACA,QAAA;IACA,OAAA;ExC+1IN;EwC71IE;IACI,cAAA;IACA,WAAA;IACA,SAAA;IACA,OAAA;IACA,YAAA;IACA,UAAA;ExC+1IN;EwC51IE;IACI,gBAAA;ExC81IN;EwC51IE;IACI,gBAAA;IACA,4BAAA;IACA,0BAAA;ExC81IN;EwC51IE;IACI,4BAAA;IACA,0BAAA;IACA,uBAAA;IACA,2BAAA;IACA,qBAAA;IACA,4BAAA;ExC81IN;EwC51IE;IACI,eAAA;ExC81IN;EwC51IE;IACE,eAAA;ExC81IJ;AACF;AyCr9IA;EACI,OAAA;AzCu9IJ;;AyCr9IA;EACI,oBAAA;AzCw9IJ;;AyCt9IA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;AzCy9IJ;;AyCv9IA;EACI,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,oCAAA;AzC09IJ;;AyCx9IA;EACI,c1CrBY;E0CsBZ,gCAAA;AzC29IJ;;AyCz9IA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AzC49IJ;;AyC19IA;EACI,0BAAA;AzC69IJ;;AyC39IA;EACI,cAAA;AzC89IJ;;AyC59IA;EACI,iBAAA;AzC+9IJ;;AyC79IA;EACI,cAAA;AzCg+IJ;;AyC79IA;EACI;IACI,eAAA;EzCg+IN;EyC99IE;IACI,aAAA;IACA,WAAA;EzCg+IN;EyC99IE;IACI,eAAA;EzCg+IN;EyC99IE;IACI,kBAAA;IACA,gBAAA;IACA,0BAAA;IACA,WAAA;IACA,oBAAA;IACA,OAAA;IACA,iBAAA;EzCg+IN;EyC99IE;IACI,eAAA;EzCg+IN;EyC99IE;IACI,kBAAA;EzCg+IN;AACF;A0C1iJA;EACI,0BAAA;EACA,QAAA;A1C4iJJ;;A0C1iJA;EACI,sBAAA;EACA,4BAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,oBAAA;EACA,UAAA;EACA,MAAA;A1C6iJJ;;A0C3iJA;EACI,yBAAA;EACA,OAAA;A1C8iJJ;;A0C5iJA;EACI,kBAAA;EACA,UAAA;A1C+iJJ;;A0C7iJA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;A1CgjJJ;;A0C9iJA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;A1CijJJ;;A0C/iJA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;A1CkjJJ;;A0ChjJA;EACI,eAAA;A1CmjJJ;;A0CjjJA;EACI,eAAA;A1CojJJ;;A0CljJA;EACI,eAAA;A1CqjJJ;;A0CnjJA;EACI,eAAA;EACA,yBAAA;A1CsjJJ;;A0CpjJA;EACI,oBAAA;A1CujJJ;;A0CrjJA;EACI,eAAA;A1CwjJJ;;A0CtjJA;EACI,mBAAA;EACA,oBAAA;A1CyjJJ;;A0CvjJA;EACI,gBAAA;A1C0jJJ;;A0CxjJA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;A1C2jJA;;A0CzjJA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;A1C4jJJ;;A0C1jJA;EACA;IACI,2BAAA;E1C6jJF;E0C3jJF;IACI,eAAA;E1C6jJF;E0C3jJF;IACI,eAAA;E1C6jJF;E0C3jJF;IACI,oBAAA;E1C6jJF;E0C1jJF;IACI,eAAA;E1C4jJF;E0C1jJF;IACI,eAAA;E1C4jJF;E0C1jJF;IACI,eAAA;IACA,iBAAA;E1C4jJF;E0C1jJD;IACG,eAAA;IACA,iBAAA;E1C4jJF;E0CzjJF;IACA,eAAA;E1C2jJE;AACF;A0CxjJA;EACI;IACI,iBAAA;IACC,aAAA;IACA,WAAA;E1C0jJP;E0CxjJE;IACI,eAAA;E1C0jJN;E0CxjJE;IACI,eAAA;IACA,iBAAA;IACA,eAAA;IACA,mBAAA;E1C0jJN;E0CxjJE;IACI,oBAAA;E1C0jJN;E0CxjJE;IACI,eAAA;IACA,iBAAA;IACA,kBAAA;E1C0jJN;E0CvjJE;IACI,kBAAA;IACA,eAAA;E1CyjJN;E0CvjJE;IACI,eAAA;E1CyjJN;E0CvjJE;IACI,iBAAA;E1CyjJN;E0CvjJE;IACI,eAAA;E1CyjJN;E0CvjJE;IACI,eAAA;IACA,iBAAA;IACA,cAAA;IACA,mBAAA;E1CyjJN;E0CvjJE;IACI,cAAA;E1CyjJN;AACF;A2C7tJA;EACI,aAAA;A3C+tJJ;;A2C7tJA;EACI,yBAAA;A3CguJJ;;A2C9tJA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;A3CiuJJ;;A2C9tJA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;A3CiuJJ;;A2C/tJA;EAAkC,kBAAA;A3CmuJlC;;A2CluJA;EAAuD,mBAAA;A3CsuJvD;;A2CruJA;EAAsD,gBAAA;A3CyuJtD;;A2CxuJA;EAAmE,aAAA;A3C4uJnE;;A2C1uJA;EACI,eAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;A3C6uJJ;;A2C3uJA;EACI,gBAAA;EACA,kBAAA;EACA,QAAA;A3C8uJJ;;A2C5uJA;EACI,WAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;A3C+uJJ;;A2C7uJA;EACI,mBAAA;A3CgvJJ;;A2C9uJA;EACI;IAAsB,eAAA;IAAgB,mBAAA;E3CmvJxC;E2ClvJE;IAAuB,eAAA;IAAiB,mBAAA;E3CsvJ1C;E2CrvJE;IAAqB,eAAA;E3CwvJvB;AACF;A2CvvJA;EACI;IAAsB,eAAA;E3C0vJxB;E2CzvJE;IACI,eAAA;IACA,iBAAA;E3C2vJN;AACF;A2CzvJA;EACI;IAAsB,eAAA;IAAgB,mBAAA;E3C6vJxC;E2C5vJE;IAAqB,eAAA;IAAgB,mBAAA;E3CgwJvC;E2C/vJE;IAAc,mBAAA;E3CkwJhB;AACF;A2CjwJA;EACA;IACI,eAAA;IACA,iBAAA;IACA,mBAAA;E3CmwJF;E2CjwJF;IACI,aAAA;E3CmwJF;AACF;A2CjwJA;EACI;IACI,YAAA;IACA,eAAA;E3CmwJN;E2CjwJE;IACI,gBAAA;IACA,kBAAA;E3CmwJN;E2CjwJE;IACI,eAAA;IACA,iBAAA;IAAmB,mBAAA;E3CowJzB;AACF;A4C51JA;EACI,aAAA;EACA,gBAAA;EACA,mBAAA;A5C81JJ;A4C51JI;EACI,UAAA;EACA,mBAAA;EACA,YAAA;A5C81JR;A4C51JQ;EACI,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;A5C81JZ;A4C51JY;EACI,sBAAA;EACA,6BAAA;EACA,sBAAA;A5C81JhB;A4C51JgB;EACI,8DAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;A5C81JpB;A4C51JoB;EACI,UAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;A5C81JxB;A4C51JwB;EACI,WAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,OAAA;EACA,yBAAA;A5C81J5B;A4C11JoB;EACI,OAAA;A5C41JxB;A4Cz1JoB;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;A5C21JxB;A4Cx1JoB;EACI,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;A5C01JxB;A4Cr1JoB;EACI,YAAA;EACA,uBAAA;A5Cu1JxB;A4Cp1JoB;EACI,cAAA;A5Cs1JxB;A4Cn1JoB;EACI,eAAA;EACA,gBAAA;EACA,WAAA;A5Cq1JxB;A4Cl1JoB;EACI,qDAAA;A5Co1JxB;A4C70JI;EACI,UAAA;EACA,mBAAA;EACA,mBAAA;A5C+0JR;A4C70JQ;EACI,mBAAA;A5C+0JZ;A4C50JQ;EACI,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;A5C80JZ;A4C50JY;EACI,kBAAA;EACA,WAAA;A5C80JhB;A4C30JY;EACI,kBAAA;EACA,YAAA;A5C60JhB;A4C10JY;EACI,kBAAA;EACA,WAAA;A5C40JhB;A4Cx0JQ;EACI,MAAA;EACA,yBAAA;A5C00JZ;A4Cv0JQ;EACI,OAAA;EACA,yBAAA;A5Cy0JZ;A4Ct0JQ;EACI,QAAA;EACA,yBAAA;A5Cw0JZ;A4Cp0JI;EACI,mBAAA;EACA,qCAAA;A5Cs0JR;A4Cn0JI;EACI,kBAAA;EACA,gBAAA;EACA,qCAAA;EACA,aAAA;EACA,iBAAA;A5Cq0JR;A4Cn0JQ;EACI,eAAA;EACA,eAAA;EACA,iBAAA;A5Cq0JZ;A4Cj0JI;EACI,qCAAA;EACA,kBAAA;A5Cm0JR;A4Ch0JI;EACI,uDAAA;EACA,gBAAA;EACA,WAAA;A5Ck0JR;A4C/zJI;EAEI,kBAAA;EACA,gBAAA;A5Cg0JR;A4C7zJI;EACI,qCAAA;EACA,mBAAA;EACA,mBAAA;A5C+zJR;A4C5zJI;EACI,qCAAA;EACA,kBAAA;A5C8zJR;A4C3zJI;EACI,kBAAA;EACA,gBAAA;EACA,qCAAA;EACA,YAAA;A5C6zJR;A4C3zJQ;EACI,eAAA;EACA,eAAA;EACA,iBAAA;A5C6zJZ;A4CzzJI;EACI,mBAAA;EACA,qCAAA;EACA,uFAAA;EACA,YAAA;A5C2zJR;A4C1zJQ;EACI,WAAA;A5C4zJZ;;A4CtzJA;EACI;IACI,gBAAA;E5CyzJN;AACF;A4CtzJA;EACI;IACI,sBAAA;E5CwzJN;E4CtzJM;IACI,WAAA;E5CwzJV;E4CtzJU;IACI,mBAAA;E5CwzJd;E4CtzJc;IACI,uBAAA;E5CwzJlB;E4CtzJkB;IACI,aAAA;E5CwzJtB;E4ChzJE;IACI,WAAA;E5CkzJN;E4C/yJE;IACI,UAAA;E5CizJN;E4C/yJM;IACI,UAAA;E5CizJV;E4C/yJU;IACI,sBAAA;IACA,aAAA;IACA,kBAAA;E5CizJd;E4C/yJc;IACI,SAAA;E5CizJlB;E4C9yJc;IACI,WAAA;IACA,WAAA;IACA,kBAAA;IACA,MAAA;IACA,OAAA;E5CgzJlB;E4C9yJkB;IACI,QAAA;IACA,WAAA;E5CgzJtB;E4C3yJU;IACI,WAAA;E5C6yJd;AACF;A4CvyJI;EACI,iBAAA;A5CyyJR;A4CtyJI;EACI,WAAA;A5CwyJR;;A4CnyJA;EACI;IACI,eAAA;E5CsyJN;AACF;A4CnyJA;EACI;IACI,kBAAA;E5CqyJN;E4ClyJE;IACI,UAAA;IACA,cAAA;IACA,iBAAA;E5CoyJN;E4CjyJE;IACI,eAAA;E5CmyJN;E4ChyJE;IACI,cAAA;E5CkyJN;E4C/xJE;IACI,kBAAA;E5CiyJN;E4C9xJE;IACI,mBAAA;E5CgyJN;AACF;A6C/lKA;EACI,yBAAA;A7CimKJ;;A6C/lKA;EACI,qBAAA;A7CkmKJ;;A6ChmKA;EACI,sBAAA;A7CmmKJ;;A6CjmKA;EACI,gBAAA;EACA,kBAAA;EACA,iDAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EAAoB,gBAAA;A7CqmKxB;;A6CnmKA;EACI,eAAA;EACA,UAAA;A7CsmKJ;;A6CpmKA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;A7CumKJ;;A6CrmKA;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;A7CwmKJ;;A6CtmKA;EACI,sBAAA;A7CymKJ;;A6CvmKA;EACI,eAAA;A7C0mKJ;;A6CvmKA;EACI,kBAAA;A7C0mKJ;;A6CvmKA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,QAAA;EACA,WAAA;EACA,mB9ChDY;E8CiDZ,WAAA;A7C0mKJ;;A6CxmKA;EACI,mBAAA;A7C2mKJ;;A6CxmKA;EACI;IACI,eAAA;IACA,uBAAA;E7C2mKN;E6CzmKE;IACI,eAAA;IACA,gBAAA;E7C2mKN;E6CzmKE;IACI,SAAA;E7C2mKN;E6CzmKE;IAAyB,aAAA;E7C4mK3B;AACF;A6C3mKA;EACI;IACI,oBAAA;E7C6mKN;AACF;A6C3mKA;EACI;IACI,WAAA;E7C6mKN;E6C3mKE;IACI,WAAA;E7C6mKN;E6C3mKE;IACI,iBAAA;E7C6mKN;E6C3mKE;IACI,aAAA;IACA,+CAAA;E7C6mKN;E6C3mKE;IACI,mBAAA;E7C6mKN;E6C3mKE;IACI,kBAAA;E7C6mKN;E6C3mKE;IACI,eAAA;E7C6mKN;E6C3mKE;IAAoB,eAAA;E7C8mKtB;AACF;A8CrtKA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;A9CutKJ;;A8CrtKA;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;A9CwtKJ;;A8CttKA;EACI,UAAA;EACA,eAAA;A9CytKJ;;A8CvtKA;EACI,gBAAA;EACA,mDAAA;EACA,kBAAA;EACA,YAAA;EAAc,mBAAA;A9C2tKlB;;A8CztKA;EACI,eAAA;EACA,gBAAA;A9C4tKJ;;A8C1tKA;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;A9C6tKJ;;A8C3tKA;EACI,cAAA;A9C8tKJ;;A8C5tKA;EACA;IACI,UAAA;IACA,mBAAA;E9C+tKF;E8C7tKF;IACI,eAAA;E9C+tKF;E8C7tKF;IACI,iDAAA;E9C+tKF;AACF;A8C3tKA;EACA;IACI,WAAA;IACA,mBAAA;E9C6tKF;E8C3tKF;IACI,UAAA;IACA,gBAAA;IACA,eAAA;E9C6tKF;E8C3tKF;IACI,iDAAA;IACA,kBAAA;IACA,YAAA;IACA,yBAAA;E9C6tKF;E8C1tKF;IACI,eAAA;IACA,mBAAA;E9C4tKF;E8C1tKF;IACI,cAAA;E9C4tKF;E8C1tKF;IACI,gBAAA;IACA,mBAAA;E9C4tKF;AACF;A+CzyKA;EACI,kBAAA;A/C2yKJ;;A+CzyKA;;EAEI,gBAAA;EACA,mBAAA;A/C4yKJ;;A+C1yKA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;A/C6yKJ;;A+C3yKA;EACI,kBAAA;A/C8yKJ;;A+C5yKA;EACI,mBAAA;A/C+yKJ;;A+C7yKA;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;A/CgzKJ;;A+C9yKA;EACI,gBAAA;A/CizKJ;;A+C/yKA;EACI;IACI,kCAAA;E/CkzKN;AACF;A+ChzKA;EACI;IACI,eAAA;E/CkzKN;E+ChzKE;IACI,mBAAA;IACA,kBAAA;E/CkzKN;E+ChzKE;IACI,kBAAA;E/CkzKN;E+ChzKE;IACI,OAAA;E/CkzKN;E+ChzKE;IACI,eAAA;IACA,WAAA;IACA,gBAAA;IACA,mBAAA;E/CkzKN;E+ChzKE;IACI,eAAA;E/CkzKN;E+C/yKE;IACI,gBAAA;E/CizKN;E+C9yKE;IACI,eAAA;E/CgzKN;E+C9yKE;;IAEI,gBAAA;IACA,mBAAA;E/CgzKN;AACF;AgDr3KA;EACI,wBAAA;AhDu3KJ;;AgDr3KA;EACI,mBAAA;EACA,iDAAA;EACA,kBAAA;EAAoB,mBAAA;AhDy3KxB;;AgDv3KA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AhD03KJ;;AgDx3KA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AhD23KJ;;AgDx3KA;EACI,eAAA;EACA,iBAAA;EACA,sBAAA;AhD23KJ;;AgDz3KA;EACI,gBAAA;EACA,mBAAA;AhD43KJ;;AgD13KA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;AhD63KJ;;AgD33KA;EACI;IACI,kBAAA;EhD83KN;EgD53KE;IACI,eAAA;IACA,iBAAA;EhD83KN;AACF;AgD33KA;EACA;IACI,cAAA;EhD63KF;AACF;AgD13KA;EACI;IACI,SAAA;EhD43KN;EgD13KE;IACI,eAAA;IACA,iBAAA;IACA,mBAAA;EhD43KN;EgD13KE;IACI,eAAA;IACA,iBAAA;EhD43KN;EgD13KE;IACI,eAAA;EhD43KN;EgD13KE;IACI,gDAAA;IACA,kBAAA;IACA,kBAAA;IACA,gBAAA;EhD43KN;EgD13KE;IACI,gBAAA;IACA,mBAAA;EhD43KN;EgD13KE;IACI,eAAA;IACA,iBAAA;EhD43KN;AACF;AiD78KA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;AjD+8KJ;;AiD78KA;EACI,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mCAAA;EAAoC,mBAAA;AjDi9KxC;;AiD78KA;;EAEI,WAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;AjDg9KJ;;AiD98KA;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,4BAAA;EACA,kCAAA;EACA,YAAA;EACA,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,qBAAA;AjDi9KJ;;AiD/8KA;EACI,kBAAA;EACA,YAAA;EACA,QAAA;EACA,4BAAA;EACA,kCAAA;EACA,YAAA;EACA,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,qBAAA;AjDk9KJ;;AiDh9KA;EACI,gBAAA;AjDm9KJ;AiDh9KI;EAAa,oBAAA;EAAqB,cAAA;AjDo9KtC;AiDn9KI;EAAoB,cAAA;AjDs9KxB;AiDp9KI;EAAgB,mBAAA;AjDu9KpB;;AiDr9KA;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;AjDw9KJ;;AiDt9KA;EACI,kBAAA;EACA,SAAA;AjDy9KJ;;AiDv9KA;EACI;IACI,YAAA;EjD09KN;EiDx9KE;IACI,WAAA;EjD09KN;EiDx9KE;IACI,eAAA;EjD09KN;AACF;AiDv9KA;EACI;IACI,eAAA;EjDy9KN;EiDv9KE;IACI,oBAAA;IACA,iBAAA;EjDy9KN;EiDv9KE;IACI,uBAAA;EjDy9KN;EiDv9KE;IACI,sBAAA;EjDy9KN;EiDv9KE;;IAEI,YAAA;IACA,uBAAA;IACA,uBAAA;IACA,sBAAA;IACA,4BAAA;IACA,0BAAA;IACA,8BAAA;IACA,sBAAA;EjDy9KN;AACF;AkDlkLA;EACI,WAAA;EACA,gBAAA;EACA,eAAA;AlDokLJ;;AkDlkLA;EACI,eAAA;AlDqkLJ;;AkDlkLA;EACI,mBAAA;AlDqkLJ;;AkDnkLA;EACI,eAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,OAAA;EACA,uBAAA;AlDskLJ;;AkDpkLA;EACI,iBAAA;EACA,cAAA;AlDukLJ;;AkDrkLA;EACA;IACI,mBAAA;ElDwkLF;EkDtkLF;IACI,wBAAA;ElDwkLF;AACF;AmDvmLA;EACI,sBAAA;EACA,4BAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,oBAAA;EACA,UAAA;EACA,MAAA;EACA,wBAAA;AnDymLJ;;AmDvmLA;EACI,YAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AnD0mLJ;;AmDxmLA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;AnD2mLJ;;AmDvmLA;EACI,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AnD0mLJ;;AmDxmLA;EACI,aAAA;EACA,WAAA;AnD2mLJ;;AmDzmLA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,MAAA;AnD4mLJ;;AmD1mLA;EACI,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AnD6mLJ;;AmD3mLA;EACI,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;AnD8mLJ;;AmD5mLA;EACI,0BAAA;AnD+mLJ;;AmD7mLA;EACI,YAAA;EAAa,aAAA;AnDinLjB;;AmD/mLA;EACI,mBAAA;AnDknLJ;;AmDhnLA;EACI,eAAA;AnDmnLJ;;AmDjnLA;EACI;IACI,sBAAA;IACA,iBAAA;EnDonLN;EmDlnLE;IACI,UAAA;EnDonLN;EmDlnLE;IACI,WAAA;EnDonLN;AACF;AmDhnLA;EAEI;IACI,UAAA;EnDinLN;AACF;AmD9mLA;EACA;IACI,aAAA;EnDgnLF;EmD9mLF;IACI,aAAA;EnDgnLF;EmD9mLF;IACI,UAAA;EnDgnLF;AACF;AmD9mLA;EACI;IACI,UAAA;EnDgnLN;EmD9mLF;IACI,iBAAA;IACA,aAAA;IACA,WAAA;IACA,wBAAA;EnDgnLF;EmD9mLF;IACI,mBAAA;EnDgnLF;EmD9mLF;IACI,eAAA;EnDgnLF;EmD9mLF;IACI,cAAA;IACA,gBAAA;EnDgnLF;EmD9mLF;IACI,WAAA;EnDgnLF;EmD9mLF;IACI,WAAA;EnDgnLF;EmD9mLF;IACI,kBAAA;EnDgnLF;EmD9mLF;IACI,oBAAA;EnDgnLF;EmD9mLF;IACI,WAAA;EnDgnLF;AACF;AoD7vLA;EAAoB,eAAA;EAAgB,yBAAA;ApDiwLpC;AoDhwLI;EAAsB,cAAA;EAAe,eAAA;ApDowLzC;;AoDlwLA;EAAe,mBAAA;EAAoB,gBAAA;EAAiB,iCAAA;EAAkC,iBAAA;EAAkB,YAAA;EAAa,qDAAA;EAAsD,aAAA;EAAc,aAAA;EAAc,mBAAA;ApD8wLvM;AoD7wLI;EAAU,kBAAA;ApDgxLd;AoD9wLI;EAAQ,6BAAA;ApDixLZ;;AoD7wLA;EACI;IAA0C,kBAAA;EpDixL5C;EoDhxLE;IAAoB,eAAA;EpDmxLtB;AACF;AoDjxLA;EACI;IAAe,gBAAA;EpDoxLjB;AACF;AqDryLA;EACI,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;ArDuyLJ;;AqDpyLA;EACI,WAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;ArDuyLJ;;AqDpyLA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;ArDuyLJ;;AqDpyLA;EACI,oBAAA;EACA,yBAAA;ArDuyLJ;;AqDpyLA;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;ArDuyLJ;AqDryLI;EACI,eAAA;ArDuyLR;;AqDnyLA;EACI;IACI,iBAAA;IACA,aAAA;IACA,4BAAA;ErDsyLN;EqDnyLE;IACI,cAAA;ErDqyLN;AACF;AsDv1LA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;AtDy1LJ;;AsDv1LA;EACI,eAAA;AtD01LJ;;AsDx1LA;EACI,mBAAA;AtD21LJ;;AsDz1LA;EACI,kBAAA;AtD41LJ;;AsD11LA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EAEA,sBAAA;EACA,cAAA;AtD41LJ;;AsD11LA;EACI,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;AtD61LJ;;AsD31LA;EACI,gBAAA;AtD81LJ;;AsD51LA;EACI,kBAAA;AtD+1LJ;;AsD71LA;EACI;IACI,eAAA;IACA,iBAAA;EtDg2LN;EsD91LE;IACI,kBAAA;EtDg2LN;EsD91LE;IACI,eAAA;EtDg2LN;AACF;AsD91LA;EACI;IACI,iBAAA;EtDg2LN;EsD91LE;IACI,oBAAA;IACA,kBAAA;EtDg2LN;EsD91LE;IACI,gBAAA;EtDg2LN;EsD91LE;IACI,eAAA;IACA,iBAAA;EtDg2LN;AACF;AuD95LA;EACI,mBAAA;AvDg6LJ;;AuD95LA;EACI,eAAA;AvDi6LJ;;AuD/5LA;EACI,cAAA;AvDk6LJ;;AuDh6LA;EACI,cAAA;EACA,gBAAA;AvDm6LJ;;AuDj6LA;EACA,cAAA;AvDo6LA;;AuDl6LA;EACI,cAAA;EACA,cAAA;AvDq6LJ;;AuDn6LA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;AvDs6LJ;;AuDp6LA;EACI;IACI,eAAA;EvDu6LN;EuDr6LE;IACI,cAAA;EvDu6LN;AACF;AuDr6LA;EACA;IACI,eAAA;EvDu6LF;EuDr6LF;IACI,eAAA;EvDu6LF;EuDr6LF;IACI,eAAA;EvDu6LF;AACF;AwDn9LA;EACI,yBAAA;EACA,uBAAA;AxDq9LJ;;AwDn9LA;EACI,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBzD4CI;AC06LR;;AwDp9LA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AxDu9LJ;;AwDr9LA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;AxDw9LJ;;AwDt9LA;EACI,czDtBY;AC++LhB;;AwDv9LA;EACI,eAAA;EACA,eAAA;AxD09LJ;;AwDx9LA;EACI,gBAAA;AxD29LJ;;AwDz9LA;EACA;IACI,eAAA;ExD49LF;AACF;AwD19LA;EACI;IACI,kBAAA;ExD49LN;EwD19LE;IACI,eAAA;ExD49LN;EwD19LE;IACI,yBAAA;IACA,uBAAA;ExD49LN;EwD19LE;IACI,iBAAA;ExD49LN;AACF;AyDlhMA;EACI,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;AzDohMJ;;AyDlhMA;EACI,gBAAA;AzDqhMJ;;AyDnhMA;EACI,eAAA;AzDshMJ;;AyDphMA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;AzDuhMJ;;AyDrhMA;EACI,gBAAA;AzDwhMJ;;AyDthMA;EACI,mBAAA;AzDyhMJ;;AyDthMA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;AzDyhMJ;;AyDvhMA;EACI,iBAAA;AzD0hMJ;;AyDxhMA;EACI,iBAAA;EACA,qBAAA;AzD2hMJ;;AyDzhMA;EACI,mBAAA;AzD4hMJ;;AyDzhMA;EACI,SAAA;EACA,kBAAA;AzD4hMJ;;AyD1hMA;EACI,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;AzD6hMJ;;AyD3hMA;EACI,gBAAA;AzD8hMJ;;AyD5hMA;EACI;IACI,mBAAA;IACA,iBAAA;EzD+hMN;EyD7hME;IACI,eAAA;IACA,iBAAA;EzD+hMN;EyD7hME;IACI,eAAA;EzD+hMN;EyD7hME;IACG,iBAAA;EzD+hML;EyD7hME;IACI,eAAA;EzD+hMN;AACF;A0D1mMA;EACE,Y3D6D4B;E2D5D5B,cAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,c3DsE4B;E2DrE5B,qC3D8CY;E2D7CZ,mB3DsD4B;E2DrD5B,gBAAA;EACA,4BAAA;A1D4mMF;A0D1mME;EACE;IAAiB,WAAA;E1D6mMnB;AACF;A0D3mME;EAjBF;IAkBI,eAAA;IACA,SAAA;IACA,OAAA;IACA,SAAA;IACA,YAAA;IACA,eAAA;IACA,4BAAA;IACA,gCAAA;IACA,WAAA;IACA,2CAAA;E1D8mMF;E0D5mME;IAAY,wBAAA;E1D+mMd;AACF;A0D7mME;EAhCF;IAiCI,SAAA;E1DgnMF;AACF;;A0D5mMA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,cAAA;A1D+mMF;A0D5mME;;EACgB,aAAA;A1D+mMlB;;A0D5mMA;EACE,UAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,yDAAA;A1D+mMF;A0D7mME;EAAM,cAAA;EAAgB,gCAAA;A1DinMxB;A0D/mME;EAAU,yB3DoCkB;E2DpCqB,c3DYrB;ACumM9B;A0DlnME;EAAkB,0BAAA;EAAkC,mBAAA;A1DsnMtD;A0DpnME;EAlBF;IAmBI,WAAA;IACA,YAAA;E1DunMF;AACF;;A0DjnMA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,oBAAA;A1DonMF;A0DjnME;EAAoB,SAAA;A1DonMtB;;A0DhnMA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,wBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,c3DxB4B;E2DyB5B,qBAAA;EACA,eAAA;EACA,gBAAA;A1DmnMF;A0DjnME;EAAU,mB3DPkB;E2DOe,c3D/Bf;ACopM9B;;A0DlnMA;EACE,qBAAA;EACA,WAAA;EACA,gCAAA;A1DqnMF;A0DnnME;EAAY,wBAAA;A1DsnMd;;A0DlnMA;EACE,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,c3DlD4B;E2DmD5B,eAAA;A1DqnMF;A0DnnME;EAAU,mB3D9BkB;E2D8Be,c3DtDf;AC6qM9B;;A0DpnMA;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,mB3DzE4B;E2D0E5B,c3DlE4B;E2DmE5B,yBAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,qDAAA;EACA,8DAAA;EACA,sBAAA;EACA,kBAAA;EAEA,YAAA;A1DsnMF;A0DpnME;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;A1DsnMJ;A0DnnME;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;A1DqnMJ;A0DlnME;EACE,mBAAA;EACA,4CAAA;A1DonMJ;;A0D/mMA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,c3DzG4B;E2D0G5B,qBAAA;EACA,oBAAA;A1DknMF;;A0D9mMA;EACE,kBAAA;EACA,eAAA;EACA,c3DnH4B;ACouM9B;;A0D9mMA;EACE,cAAA;EACA,wBAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,c3D/H4B;E2DgI5B,eAAA;EACA,kBAAA;A1DinMF;A0D/mME;EAAU,mB3D5GkB;E2D4Ge,c3DpIf;ACuvM9B;A0DlnME;EAAa,eAAA;EAAiB,YAAA;A1DsnMhC;A0DrnME;EAAmB,uBAAA;EAAyB,c3DrIhB;AC8vM9B;;A0DrnMA;EACE,eAAA;EACA,6BAAA;EACA,gBAAA;A1DwnMF;;A0DrnMA;EACE,UAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;EACA,0BAAA;EACA,eAAA;A1DwnMF;;A0DnnMA;EACE,oBAAA;A1DsnMF;;A0DnnMA;EACE,eAAA;A1DsnMF;A0DpnME;EAAU,uBAAA;A1DunMZ;;A0DpnMA;EACE,cAAA;EACA,YAAA;EACA,kBAAA;EACA,yEAAA;EAMA,0BAAA;EACA,yDAAA;A1DknMF;;A0D/mMA;EACE;IAAO,2BAAA;E1DmnMP;E0DlnMA;IAAO,4BAAA;E1DqnMP;AACF;A0DnnMA;EACE;IAAqB,eAAA;E1DsnMrB;AACF;A0DhnMA;EACE,cAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,oCAAA;A1DknMF;A0DhnME;EAAuB,UAAA;A1DmnMzB;A0DlnME;EAA6B,mBAAA;EAAqB,kBAAA;A1DsnMpD;A0DrnME;EAA6B,uBAAA;A1DwnM/B;;A0DrnMA;EACE,gBAAA;EACA,UAAA;EACA,eAAA;A1DwnMF;;A0DrnMA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,c3D5N4B;E2D6N5B,eAAA;EACA,uCAAA;EACA,QAAA;A1DwnMF;A0DtnME;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,c3DpO0B;E2DqO1B,kBAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,2DAAA;EACA,cAAA;EACA,iBAAA;A1DwnMJ;A0DtnMI;EACE,+BAAA;EACA,c3DrPwB;AC62M9B;A0DrnMI;EAvBF;IAuByB,UAAA;E1DynMzB;AACF;A0DvnME;EACE,mB3DpO0B;AC61M9B;A0DvnMI;EAAqB,UAAA;A1D0nMzB;A0DrnME;EAAwC,UAAA;A1DwnM1C;A0DtnME;EACE,mB3D7O0B;E2D8O1B,c3DvQ0B;E2DwQ1B,gBAAA;A1DwnMJ;A0DpnME;EACE,UAAA;EACA,mB3DtP0B;E2DuP1B,yCAAA;EACA,gBAAA;A1DsnMJ;;A0DjnMA;EAAiB,aAAA;A1DqnMjB;;A0DlnMA;EACE,oBAAA;EACA,cAAA;EACA,c3DxWc;AC69MhB;A0DnnME;EAAM,wBAAA;A1DsnMR;;A0DnnMA;EACE,OAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;A1DsnMF;;A0DnnMA;EACE,OAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,c3D/S4B;E2DgT5B,aAAA;EACA,YAAA;A1DsnMF;A0DpnME;EAAU,qB3DhYI;ACu/MhB;;A0DpnMA;EACE,gBAAA;EACA,eAAA;EACA,kCAAA;EACA,c3DzT4B;E2D0T5B,cAAA;A1DunMF;A0DrnME;EAAe,cAAA;A1DwnMjB;A0DvnME;EAAe,WAAA;EAAa,gBAAA;A1D2nM9B;;A0DxnMA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;A1D2nMF;A0DznME;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,c3D/U0B;E2DgV1B,eAAA;A1D2nMJ;A0DznMI;EAAU,+BAAA;EAAiC,c3DpVjB;ACi9M9B;A0D3nMI;EAEE,YAAA;EACA,mBAAA;A1D4nMN;A0D1nMM;EAAU,uBAAA;EAAyB,c3DzVX;ACu9M9B;;A0DpnMA;EACE;IACE,kBAAA;E1DunMF;E0DrnME;IACE,sBAAA;IACA,uBAAA;IACA,QAAA;IACA,UAAA;IACA,gBAAA;E1DunMJ;E0DnnME;IAAoB,QAAA;E1DsnMtB;E0DrnME;IAAsB,QAAA;E1DwnMxB;E0DrnME;IAAwB,yBAAA;E1DwnM1B;E0DrnME;;;;;IAKE,aAAA;E1DunMJ;E0DnnME;IACE,cAAA;IACA,UAAA;E1DqnMJ;E0DnnMI;IAAW,aAAA;E1DsnMf;E0DlnME;IACE,UAAA;IACA,sBAAA;IACA,WAAA;IACA,YAAA;IACA,oBAAA;IACA,mBAAA;IACA,uBAAA;IACA,eAAA;IACA,kBAAA;IACA,uBAAA;IACA,YAAA;IACA,gBAAA;IACA,UAAA;IACA,SAAA;IACA,uCAAA;E1DonMJ;E0DlnMI;IAAW,aAAA;E1DqnMf;E0DpnMI;IACE,WAAA;IACA,YAAA;IACA,SAAA;E1DsnMN;E0DnnMI;IAAU,yB3D1Yc;ECggN5B;E0DrnMI;IAAkB,0BAAA;IAAkC,mBAAA;E1DynMxD;AACF;A0DpnMA;EACE,cAAA;EACA,iBAAA;EACA,cAAA;A1DsnMF;;A0DnnMA;EACE,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,mB3D5b4B;E2D6b5B,6CAAA;EACA,eAAA;EACA,WAAA;A1DsnMF;;A0DnnMA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,c3Dlc4B;E2Dmc5B,eAAA;EACA,mBAAA;A1DsnMF;A0DpnME;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,c3D1c0B;E2D2c1B,cAAA;A1DsnMJ;A0DnnME;EAEE,mB3D1b0B;E2D2b1B,c3Dnd0B;ACukN9B;A0DnnMI;EAAqB,c3DpdK;AC0kN9B;A0DnnME;EAAW,mB3D9biB;ACojN9B;A0DpnME;EACE,c3D9b0B;ACojN9B;A0DrnMI;EAAqB,c3D/bK;ACujN9B;A0DtnMI;EAEE,mCAAA;EACA,c3DpcwB;AC2jN9B;A0DtnMM;EAAqB,c3DrcG;AC8jN9B;;A0DnnMA;EACE,gBAAA;A1DsnMF;A0DpnME;EACE,YAAA;EACA,mBAAA;EACA,8CAAA;A1DsnMJ;;A0DlnMA;EACE,uBAAA;A1DqnMF;;A0DlnMA;EACE,eAAA;EACA,gBAAA;EACA,c3Dxf4B;E2Dyf5B,eAAA;A1DqnMF;;A0DlnMA;EACE,eAAA;EACA,gBAAA;EACA,c3D7f4B;E2D8f5B,gBAAA;A1DqnMF;A0DnnME;EACE,c3DngB0B;E2DogB1B,gBAAA;EACA,sBAAA;A1DqnMJ;;A0DjnMA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;A1DonMF;;A0DjnMA;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,kFAAA;A1DonMF;A0DlnME;EACE,YAAA;EACA,mBAAA;A1DonMJ;;A0DhnMA;EACE,mB3DxiB4B;E2DyiB5B,qB3DxiB4B;E2DyiB5B,c3DliB4B;ACqpN9B;A0DjnME;EAAyB,mB3D5gBG;ACgoN9B;;A0DjnMA;EACE,mB3D5gB4B;E2D6gB5B,WAAA;EACA,qB3D9gB4B;ACkoN9B;A0DlnME;EAAyB,mBAAA;EAAqB,qBAAA;A1DsnMhD;;A2D9uNE;EACE,gBAAA;EACA,wBAAA;EACA,cAAA;A3DivNJ;A2D9uNE;EACE,YAAA;EACA,mBAAA;EACA,gFAAA;EAEA,gBAAA;EACA,mBAAA;A3D+uNJ;A2D5uNE;EACE,UAAA;A3D8uNJ;;A2D1uNA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;A3D6uNF;;A2D1uNA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;A3D6uNF;A2D3uNE;EACE,WAAA;EACA,YAAA;A3D6uNJ;;A2DzuNA;EACE,OAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,qC5DIY;E4DHZ,eAAA;EACA,gBAAA;EACA,c5DwB4B;E4DvB5B,gBAAA;EACA,UAAA;A3D4uNF;A2D1uNE;EACE,cAAA;A3D4uNJ;;A2DxuNA;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,uCAAA;A3D2uNF;A2DzuNE;EACE,cAAA;A3D2uNJ;A2DxuNE;EACE;IACE,+BAAA;E3D0uNJ;AACF;A2DvuNE;EACE,0BAAA;EACA,mBAAA;A3DyuNJ;;A2DruNA;EACE,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,qC5D3CY;ACmxNd;;A2DruNA;EACE,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,4BAAA;EACA,gBAAA;EACA,qBAAA;EACA,oCAAA;A3DwuNF;A2DtuNE;EAAuB,UAAA;A3DyuNzB;A2DxuNE;EACE,mBAAA;EACA,kBAAA;A3D0uNJ;A2DxuNE;EAA6B,uBAAA;A3D2uN/B;;A2DxuNA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,qC5DpEY;E4DqEZ,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,uCAAA;A3D2uNF;A2DzuNE;EACE;IACE,mB5D9BwB;ECywN5B;AACF;;A2DvuNA;EACE,OAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;A3D0uNF;;A2DvuNA;EACE,oBAAA;EACA,cAAA;EACA,c5DpE4B;AC8yN9B;;A2DvuNA;EACE,cAAA;EACA,c5DzE4B;E4D0E5B,eAAA;EACA,gBAAA;EACA,mBAAA;A3D0uNF;;A2DvuNA;EACE,kBAAA;EACA,c5DlF4B;E4DmF5B,eAAA;EACA,kBAAA;EACA,qC5D7GY;ACu1Nd;;A2DnuNA;EAEI;IACE,eAAA;IACA,wBAAA;IACA,gBAAA;E3DquNJ;E2DluNE;IACE,mBAAA;E3DouNJ;E2DhuNA;IACE,kBAAA;IACA,SAAA;E3DkuNF;E2D/tNA;IACE,eAAA;E3DiuNF;E2D9tNA;IACE,sBAAA;E3DguNF;E2D7tNA;IACE,oCAAA;E3D+tNF;E2D5tNA;IACE,kBAAA;IACA,SAAA;E3D8tNF;E2D3tNA;IACE,kBAAA;E3D6tNF;AACF;A2D1tNA;EAEI;IACE,wBAAA;IACA,gBAAA;E3D2tNJ;AACF;A4Dl7NA;EACE,cAAA;EACA,YAAA;EACA,mB7DgE4B;E6D/D5B,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,qCAAA;EACA,WAAA;A5Do7NF;A4Dl7NE;EAXF;IAYI,YAAA;E5Dq7NF;AACF;A4Dl7NE;EAhBF;IAiBI,kBAAA;IACA,MAAA;IACA,QAAA;IACA,SAAA;IACA,sBAAA;IACA,8CAAA;IACA,WAAA;E5Dq7NF;AACF;A4Dl7NE;EA3BF;IA4BI,eAAA;IACA,MAAA;IACA,QAAA;IACA,SAAA;IACA,YAAA;IACA,gBAAA;IACA,gBAAA;IACA,aAAA;E5Dq7NF;AACF;;A4Dl7NA;EACE;IAAO,2BAAA;IAA6B,UAAA;E5Du7NpC;E4Dt7NA;IAAO,wBAAA;IAA6B,UAAA;E5D07NpC;AACF;A4Dv7NA;EACE,aAAA;A5Dy7NF;A4Dv7NE;EAHF;IAII,cAAA;IACA,kBAAA;IACA,QAAA;IACA,kCAAA;IACA,WAAA;E5D07NF;AACF;A4Dx7NE;EAXF;IAYI,eAAA;IACA,aAAA;IACA,iCAAA;E5D27NF;AACF;;A4Dv7NA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;EACA,cAAA;EAGA,kBAAA;EACA,UAAA;EACA,mB7DR4B;ACg8N9B;;A4Dr7NA;EACE,eAAA;EACA,gBAAA;EACA,c7DJ4B;AC47N9B;;A4Dr7NA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,c7Db4B;E6Dc5B,kBAAA;EACA,eAAA;EACA,UAAA;EACA,yDAAA;A5Dw7NF;A4Dt7NE;EACE,mB7DE0B;E6DD1B,c7DvB0B;AC+8N9B;;A4Dl7NA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;EACA,mB7DV4B;E6DW5B,kBAAA;EACA,cAAA;A5Dq7NF;;A4Dl7NA;EACE,OAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,c7D9C4B;E6D+C5B,eAAA;EACA,yDAAA;A5Dq7NF;A4Dn7NE;EAAU,c7DpDkB;AC0+N9B;A4Dr7NE;EAAkB,0BAAA;EAAkC,mBAAA;A5Dy7NtD;A4Dv7NE;EACE,mB7DhE0B;E6DiE1B,c7DzD0B;E6D0D1B,4CAAA;A5Dy7NJ;;A4Dr7NA;EACE,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;A5Dw7NF;;A4Dr7NA;EACE,cAAA;EACA,qBAAA;EACA,mB7DlF4B;E6DmF5B,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,uGAAA;A5Dw7NF;A4Dt7NE;EACE,qBAAA;EACA,4CAAA;A5Dw7NJ;A4Dr7NE;EACE,0BAAA;EACA,mBAAA;A5Du7NJ;A4Dp7NE;EACE,iCAAA;A5Ds7NJ;;A4Dl7NA;EACE;IAAO,mBAAA;IAAqB,qB7D/Kd;ECsmOd;E4Dt7NA;IAAO,mBAAA;IAAqB,qB7DhLd;EC0mOd;E4Dz7NA;IAAO,mB7D5GqB;I6D4GM,qB7D3GN;ECwiO5B;AACF;A4D37NA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;A5D67NF;;A4D17NA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mB7D1F4B;E6D2F5B,c7DnH4B;E6DoH5B,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;A5D67NF;;A4D17NA;EACE,OAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,c7DlI4B;E6DmI5B,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,sBAAA;A5D67NF;;A4D17NA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,c7D9I4B;AC2kO9B;;A4D17NA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,c7DrJ4B;ACklO9B;;A4D17NA;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,c7D5J4B;E6D6J5B,yBAAA;A5D67NF;;A6DzqOA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,YAAA;EACA,YAAA;EACA,mB9D6D4B;E8D5D5B,c9DsE4B;E8DrE5B,qC9D8CY;E8D7CZ,kBAAA;A7D4qOF;;A6DvqOA;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,YAAA;EACA,YAAA;EACA,mDAAA;A7D0qOF;;A6DtqOA;EAAa,aAAA;A7D0qOb;;A6DxqOA;EACE,eAAA;EACA,gBAAA;EACA,c9DgD4B;E8D/C5B,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;A7D2qOF;;A6DxqOA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,c9DuC4B;E8DtC5B,kBAAA;EACA,gBAAA;A7D2qOF;;A6DxqOA;EACE,eAAA;EACA,c9D+B4B;E8D9B5B,eAAA;A7D2qOF;;A6DvqOA;EACE,OAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,S9DY4B;AC8pO9B;A6DtqOE;EACE,WAAA;EACA,gB9DQ0B;E8DP1B,iBAAA;EACA,kBAAA;EAGA,YAAA;EACA,sBAAA;A7DsqOJ;A6DnqOE;EAtBF;IAuBI,kBAAA;E7DsqOF;AACF;A6DrqOE;EAzBF;IA0BI,kBAAA;E7DwqOF;AACF;A6DvqOE;EA5BF;IA6BI,kBAAA;E7D0qOF;AACF;;A6DtqOA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;A7DyqOF;A6DrqOE;EACE,aAAA;A7DuqOJ;;A6DnqOA;EACE,eAAA;EACA,gBAAA;EACA,c9D7B4B;E8D8B5B,gBAAA;A7DsqOF;A6DpqOE;EACE,c9DhC0B;E8DiC1B,gBAAA;A7DsqOJ;;A6DlqOA;EACE,eAAA;EACA,gBAAA;EACA,c9DzC4B;E8D0C5B,gBAAA;EACA,gBAAA;A7DqqOF;A6DnqOE;EAPF;IAOiC,eAAA;IAAiB,mBAAA;E7DwqOhD;AACF;A6DxqOE;EARF;IAQiC,eAAA;E7D4qO/B;AACF;;A6DxqOA;EACE,cAAA;EACA,oBAAA;EACA,gBAAA;A7D2qOF;A6DzqOE;EACE,WAAA;EACA,gB9D9D0B;E8D+D1B,iBAAA;EACA,kBAAA;A7D2qOJ;A6DxqOE;EAZF;IAYkC,oBAAA;E7D4qOhC;AACF;A6D5qOE;EAbF;IAaiC,oBAAA;E7DgrO/B;AACF;A6DhrOE;EAdF;IAciC,mBAAA;E7DorO/B;AACF;;A6DhrOA;EACE,WAAA;EACA,gBAAA;EACA,UAAA;A7DmrOF;A6DjrOE;EAAM,gBAAA;A7DorOR;;A6DjrOA;EACE,eAAA;EACA,c9DhF4B;E8DiF5B,gBAAA;EACA,aAAA;A7DorOF;;A6DjrOA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;A7DorOF;A6DhrOE;EACE,SAAA;EACA,cAAA;A7DkrOJ;A6D9qOE;EACE,aAAA;EACA,iBAAA;EACA,cAAA;A7DgrOJ;;A6D5qOA;EACE,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mB9DxH4B;E8DyH5B,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,c9DtH4B;E8DuH5B,eAAA;EACA,gEAAA;A7D+qOF;A6D7qOE;EAAM,c9DxHsB;ACwyO9B;A6D9qOE;EACE,mB9DrG0B;E8DsG1B,qBAAA;A7DgrOJ;A6D9qOI;EAAM,c9DhIoB;ACizO9B;A6D7qOE;EACE,mBAAA;EACA,qB9DnNY;E8DoNZ,c9DzH0B;ACwyO9B;A6D7qOI;EAAM,c9DtNM;ACs4OhB;;A6D5qOA;EACE,qBAAA;EACA,c9D9I4B;E8D+I5B,gBAAA;EACA,wCAAA;A7D+qOF;;A6D5qOA;EACE;IAAM,UAAA;E7DgrON;AACF;A6DxqOA;EACE,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,+DAAA;A7D0qOF;A6DxqOE;EACE,cAAA;EACA,YAAA;EACA,kBAAA;EACA,mGAAA;EAQA,0BAAA;EACA,iDAAA;A7DmqOJ;A6DhqOI;EACE,UAAA;EACA,mBAAA;A7DkqON;A6D/pOI;EACE,UAAA;EACA,qBAAA;A7DiqON;;A6D5pOA;EACE;IAAO,2BAAA;E7DgqOP;E6D/pOA;IAAO,4BAAA;E7DkqOP;AACF;A6D9pOA;EACE;IAAW,YAAA;E7DiqOX;E6DhqOA;IAAW,UAAA;E7DmqOX;AACF;A6DjqOA;EACE;;IAC4B,eAAA;E7DoqO5B;AACF;A6DlqOA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;A7DoqOF;;A6DjqOA;EACE,eAAA;EACA,c9DhM4B;ACo2O9B;;A6DjqOA;EACE,sBAAA;EACA,mCAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,c9DpTc;E8DqTd,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yDAAA;A7DoqOF;A6DlqOE;EACE,oCAAA;EACA,c9DlO0B;ACs4O9B;A6DjqOE;EAAW,4BAAA;A7DoqOb;A6DlqOE;EACE,qCAAA;EACA,c9DtP0B;E8DuP1B,mBAAA;A7DoqOJ;;A6DhqOA;EACE,eAAA;EACA,c9D7P4B;E8D8P5B,eAAA;A7DmqOF;;A6DhqOA;EACE,eAAA;EACA,c9DjVc;E8DkVd,eAAA;A7DmqOF;;A6D/pOA;EACE,8BAAA;EACA,iBAAA;EACA,gBAAA;A7DkqOF;;A6D/pOA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;A7DkqOF;;A6D9pOA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,qC9DxTY;E8DyTZ,eAAA;EACA,c9DjS4B;E8DkS5B,gBAAA;A7DiqOF;;A6D9pOA;EACE,UAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mB9DtT4B;E8DuT5B,c9D/S4B;E8DgT5B,yBAAA;EACA,mBAAA;EACA,qC9DzUY;E8D0UZ,eAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,qDAAA;EACA,8DAAA;EACA,sBAAA;A7DiqOF;A6D/pOE;EACE,mB9DpS0B;ACq8O9B;;A6D5pOA;EACE,oBAAA;EACA,aAAA;EACA,iBAAA;A7D+pOF;;A8DhjPA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;EACA,uBAAA;EACA,gBAAA;A9DmjPF;A8DhjPE;EAEE,UAAA;EACA,mBAAA;A9DijPJ;;A8D5iPA;EAAa,aAAA;A9DgjPb;;A8D9iPA;EACE,cAAA;EACA,kBAAA;EACA,mB/D6C4B;E+D5C5B,c/DqD4B;E+DpD5B,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;A9DijPF;A8D/iPE;EAVF;IAWI,cAAA;IACA,eAAA;IACA,kBAAA;E9DkjPF;AACF;;A8D/iPA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,c/DkC4B;E+DjC5B,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;EACA,6EAAA;A9DkjPF;A8DhjPE;EACE,mB/D+C0B;E+D9C1B,c/DsB0B;AC4hP9B;A8D9iPE;EAtBF;IAuBI,UAAA;IACA,mBAAA;E9DijPF;AACF;A8D7iPE;EACE,UAAA;EACA,mBAAA;EACA,cAAA;A9D+iPJ;A8D7iPI;EACE,mCAAA;EACA,cAAA;A9D+iPN;;A8DriPA;EAEE,sBAAA;EACA,qBAAA;A9DuiPF;;A8DpiPA;EACE,cAAA;EACA,mB/DvB4B;E+DwB5B,c/Df4B;E+DgB5B,mBAAA;EACA,kBAAA;A9DuiPF;A8DriPE;EAPF;IAQI,cAAA;IACA,kBAAA;E9DwiPF;AACF;;A8DriPA;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,c/DlC4B;E+DmC5B,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;A9DwiPF;A8DtiPE;EAAiB,c/DvCW;ACglP9B;A8DviPE;EAjBF;IAiBiC,eAAA;E9D2iP/B;AACF;;A8DziPA;EACE,eAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,QAAA;A9D4iPF;;A8DziPA;EACE,uBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,c/D5D4B;E+D6D5B,eAAA;EACA,gEAAA;A9D4iPF;A8D1iPE;EACE,mB/DzC0B;E+D0C1B,qBAAA;A9D4iPJ;;A8DxiPA;EACE,mB/DpJc;E+DqJd,yBAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gEAAA;A9D2iPF;A8DziPE;EACE,mB/DpE0B;E+DqE1B,qB/DrE0B;ACgnP9B;A8DxiPE;EACE,oCAAA;EACA,sCAAA;EACA,mBAAA;A9D0iPJ;;A+DhtPA;EACE,qEAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;A/DmtPF;;A+DhtPA;EACE,WAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,qChEqCY;EgEpCZ,eAAA;EACA,gBAAA;EACA,chEyD4B;EgExD5B,gBAAA;A/DmtPF;;A+DhtPA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;A/DmtPF;;A+DhtPA;EACE,chE/Bc;EgEgCd,cAAA;A/DmtPF;A+DjtPE;EACE,6CAAA;A/DmtPJ;;A+D/sPA;EACE;IAAW,UAAA;E/DmtPX;E+DltPA;IAAW,aAAA;E/DqtPX;AACF;A+DntPA;EACE,chEgC4B;EgE/B5B,gBAAA;A/DqtPF;A+DhtPE;EACE,oHAAA;EAQA,0BAAA;EACA,6BAAA;EACA,qBAAA;EACA,oCAAA;EACA,kBAAA;EACA,8CAAA;A/D2sPJ;;A+DvsPA;EACE;IAAO,2BAAA;E/D2sPP;E+D1sPA;IAAO,4BAAA;E/D6sPP;AACF;A+D3sPA;EACE;IACE,eAAA;IACA,gBAAA;IACA,gChED0B;IgEE1B,chEF0B;EC+sP5B;AACF;A+D1sPA;EACE,chEN4B;EgEO5B,+BAAA;EACA,cAAA;A/D4sPF;A+D1sPE;EAAkB,yBAAA;A/D6sPpB;;A+DzsPA;EACE,gBAAA;EACA,SAAA;EACA,2BAAA;EACA,kBAAA;A/D4sPF;A+DzsPE;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,oCAAA;A/D2sPJ;;A+DvsPA;EACE,kBAAA;EACA,kBAAA;EACA,oBAAA;A/D0sPF;A+DxsPE;EAAe,iBAAA;A/D2sPjB;;A+DxsPA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBhE7Hc;EgE+Hd,0BAAA;EACA,UAAA;A/D0sPF;;A+DtsPA;EACE,mBhErIc;EgEsId,iDAAA;A/DysPF;;A+DtsPA;EACE;IAAW,4DAAA;E/D0sPX;E+DzsPA;IAAW,2DAAA;E/D4sPX;AACF;A+D1sPA;EACE,eAAA;EACA,gBAAA;EACA,chEpE4B;EgEqE5B,iBAAA;A/D4sPF;;A+DxsPA;EACE,gBAAA;EACA,eAAA;EACA,UAAA;A/D2sPF;;A+DxsPA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,chEpF4B;EgEqF5B,iBAAA;EACA,cAAA;A/D2sPF;;A+DxsPA;EACE,chEzF4B;ACoyP9B;;A+DxsPA;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,chEtE4B;ACixP9B;;A+DxsPA;EAAe,OAAA;EAAS,YAAA;A/D6sPxB;;A+D1sPA;EACE;IAAe,kBAAA;IAAoB,eAAA;E/D+sPnC;E+D9sPA;IACE,2BAAA;E/DgtPF;E+D/sPE;IAAY,UAAA;E/DktPd;E+DhtPA;IAAkB,eAAA;E/DmtPlB;E+DltPA;IAAkB,eAAA;E/DqtPlB;AACF;AgEn5PA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AhEq5PF;AgEl5PE;EAEE,UAAA;EACA,mBAAA;AhEm5PJ;;AgE/4PA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;AhEk5PF;;AgE/4PA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AhEk5PF;;AgE/4PA;EACE,OAAA;EACA,YAAA;EACA,kBAAA;EACA,cjE0C4B;EiEzC5B,eAAA;EACA,iBAAA;AhEk5PF;AgE94PE;EAA+B,eAAA;AhEi5PjC;AgEh5PE;EAAQ,cAAA;EAAgB,gBAAA;AhEo5P1B;;AgEj5PA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,8BAAA;AhEo5PF;AgEj5PE;EAVF;IAWI,UAAA;IACA,mBAAA;EhEo5PF;AACF;;AgEj5PA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,cjEW4B;EiEV5B,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yDAAA;AhEo5PF;AgEl5PE;EACE,mBjE0B0B;EiEzB1B,cjEC0B;ACm5P9B;AgEj5PE;EACE,mBAAA;EACA,YAAA;AhEm5PJ;AgEj5PI;EACE,uBAAA;EACA,cjEPwB;AC05P9B;AgE/4PE;EACE,mBAAA;EACA,WAAA;AhEi5PJ;AgE/4PI;EACE,mBAAA;EACA,WAAA;AhEi5PN;AgE74PE;EACE,cAAA;AhE+4PJ;AgE74PI;EACE,mCAAA;EACA,cAAA;AhE+4PN;;AgEz4PA;EACE,oBAAA;EACA,mBAAA;EACA,cAAA;AhE44PF;AgEx4PI,iCAAA,4CAAA,EAAA;;AAMJ;;EAEE,UAAA;EACA,mBAAA;AhEs4PF;;AgEn4PA;EACE,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBjEjE4B;EiEkE5B,6CAAA;EACA,eAAA;EACA,WAAA;AhEs4PF;AgEh4PE;EACE,kBAAA;AhEk4PJ;;AgE93PA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,cjE/E4B;EiEgF5B,eAAA;EACA,mBAAA;AhEi4PF;AgE/3PE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cjEvF0B;EiEwF1B,cAAA;AhEi4PJ;AgE93PE;EAEE,mBjEvE0B;EiEwE1B,cjEhG0B;AC+9P9B;AgE93PI;EAAyB,cjEjGC;ACk+P9B;AgE93PE;EAAW,mBjE3EiB;AC48P9B;;AgE93PA;EAGE;IACE,WAAA;IACA,YAAA;IACA,kBAAA;EhE+3PF;AACF;AgE53PA;EACE;IAAmB,SAAA;EhE+3PnB;EgE93PA;IAAa,WAAA;IAAa,YAAA;EhEk4P1B;EgEj4PA;IAAc,eAAA;EhEo4Pd;AACF;AiE1kQA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,cAAA;AjE4kQF;;AiEzkQA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AjE4kQF;AiE1kQE;EACE,qBAAA;EACA,mBAAA;AjE4kQJ;AiEzkQE;EACE,qBAAA;EACA,mBAAA;AjE2kQJ;;AiErkQA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AjEwkQF;;AiErkQA;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AjEwkQF;;AiErkQA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AjEwkQF;AiEtkQE;EACE,WAAA;AjEwkQJ;;AkE9nQA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,kBAAA;AlEioQF;;AkE9nQA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;EACA,0DAAA;AlEioQF;AkE/nQE;EAEE,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,qBAAA;AlEgoQJ;;AkE5nQA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AlE+nQF;;AkE5nQA;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AlE+nQF;;AkEpnQA;;EAEE,mBAAA;EACA,qBAAA;EACA,cAAA;AlEunQF;AkErnQE;;;EAEE,mBAAA;EACA,qBAAA;EACA,cAAA;AlEwnQJ;AkErnQE;;EAAiB,cAAA;AlEynQnB;;AkErnQA;;EAEE,mBAAA;EACA,qBAAA;EACA,cAAA;AlEwnQF;AkEtnQE;;;EAEE,mBAAA;EACA,qBAAA;EACA,cAAA;AlEynQJ;AkEtnQE;;EAAiB,cAAA;AlE0nQnB;;AkEtnQA;;;EAGE,mBAAA;EACA,qBAAA;EACA,cAAA;AlEynQF;AkEvnQE;;;;;EAEE,mBAAA;EACA,qBAAA;EACA,cAAA;AlE4nQJ;AkEznQE;;;EAAiB,cAAA;AlE8nQnB;;AkE1nQA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AlE6nQF;AkE3nQE;EAEE,mBAAA;EACA,qBAAA;EACA,cAAA;AlE4nQJ;AkEznQE;EAAiB,cAAA;AlE4nQnB;;AkExnQA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AlE2nQF;AkEznQE;EAEE,mBAAA;EACA,qBAAA;EACA,cAAA;AlE0nQJ;AkEvnQE;EAAiB,cAAA;AlE0nQnB;;AmExvQA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;AnE2vQF;;AmExvQA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;AnE2vQF;;AmExvQA;EACE,kBAAA;EACA,cAAA;AnE2vQF;AmEzvQE;EACE,iBAAA;AnE2vQJ;;AmEvvQA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,uBAAA;EACA,YAAA;EACA,cpE6C4B;EoE5C5B,qCpEqBY;EoEpBZ,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,yDAAA;EACA,mBAAA;AnE0vQF;AmExvQE;EACE,mBpE0D0B;ACgsQ9B;AmEvvQE;;EAEE,mBAAA;EACA,cAAA;AnEyvQJ;;AmEpvQA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBpEW4B;EoEV5B,yBAAA;EACA,oBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;AnEuvQF;;AmEpvQA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,cpEE4B;EoED5B,eAAA;EACA,qCpEvBY;EoEwBZ,eAAA;EACA,YAAA;AnEuvQF;AmErvQE;EACE,cpElFY;ACy0QhB;;AmEnvQA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBpE1Fc;EoE2Fd,cAAA;AnEsvQF;;AmEnvQA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;AnEsvQF;;AmEnvQA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,cpE/B4B;EoEgC5B,eAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AnEsvQF;AmEpvQE;EACE,mBpEhB0B;EoEiB1B,cpEzC0B;AC+xQ9B;;AmEjvQA;EACE,kBAAA;EACA,wBAAA;EACA,OAAA;EACA,gBAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBpE9D4B;EoE+D5B,yBAAA;EACA,mBAAA;EACA,8CAAA;EACA,WAAA;EACA,gBAAA;AnEovQF;AmElvQE;EACE,QAAA;EACA,UAAA;AnEovQJ;;AmEhvQA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;EACA,OAAA;EACA,aAAA;AnEmvQF;;AmEhvQA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cpEvF4B;EoEwF5B,qCpE/GY;EoEgHZ,eAAA;EACA,kBAAA;EACA,uCAAA;AnEmvQF;AmEjvQE;EACE,mBpEtE0B;ACyzQ9B;AmEhvQE;EACE,YAAA;EACA,mBAAA;AnEkvQJ;;AmE9uQA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,gEAAA;AnEivQF;AmE/uQE;EACE,mBpEjMY;EoEkMZ,qBpElMY;ACm7QhB;;AmE7uQA;EACE,gBAAA;EACA,OAAA;EACA,YAAA;AnEgvQF;;AmE7uQA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cpEpI4B;EoEqI5B,mBpE9G4B;EoE+G5B,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AnEgvQF;;AmE7uQA;EACE,WAAA;EACA,8BAAA;EACA,iBAAA;EACA,SAAA;EACA,cAAA;AnEgvQF;;AmE7uQA;EACE,aAAA;EACA,6BAAA;AnEgvQF;;AmE7uQA;EACE,OAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,qCpEtLY;EoEuLZ,eAAA;EACA,YAAA;EACA,uCAAA;AnEgvQF;AmE9uQE;EACE,mBpE7I0B;AC63Q9B;AmE7uQE;EACE,cpEzK0B;EoE0K1B,+BAAA;AnE+uQJ;AmE5uQE;EACE,cpE3PY;EoE4PZ,gBAAA;AnE8uQJ;;AmEzuQA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AnE4uQF;AmE1uQE;EAAuB,aAAA;AnE6uQzB;AmE3uQE;EACE,eAAA;EACA,cAAA;AnE6uQJ;;AmEzuQA;EACE;IAAU,gBAAA;IAAkB,eAAA;EnE8uQ5B;EmE7uQA;IAAY,gBAAA;IAAkB,iBAAA;EnEivQ9B;AACF;AmE7uQA;EACE;IAAuB,aAAA;EnEgvQvB;EmE/uQA;IACE,eAAA;IACA,gBAAA;EnEivQF;EmE9uQA;IAAU,QAAA;IAAU,eAAA;IAAiB,gBAAA;EnEmvQrC;AACF;AoEphRA;EACE,WAAA;EACA,qCrEoDY;ACk+Qd;AoEphRE;EACE,aAAA;ApEshRJ;;AoElhRA;EACE,mBrE2D4B;EqE1D5B,yBAAA;EACA,mBrEmF4B;EqElF5B,6CrEmF4B;EqElF5B,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;ApEqhRF;;AoElhRA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,crEmD4B;EqElD5B,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,oBAAA;ApEqhRF;AoEnhRE;EACE,crE6C0B;ACw+Q9B;;AoEhhRA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;ApEmhRF;;AoEhhRA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,OAAA;ApEmhRF;;AoEhhRA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;ApEmhRF;;AoEhhRA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,UAAA;EACA,kFAAA;ApEmhRF;AoEjhRE;EACE,mBAAA;EACA,qBAAA;ApEmhRJ;AoEhhRE;EACE,YAAA;EACA,mBAAA;ApEkhRJ;;AoE9gRA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBrEb4B;EqEc5B,cAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,UAAA;EACA,uCAAA;ApEihRF;AoE/gRE;EAAM,+BAAA;ApEkhRR;AoEhhRE;EAAyB,gBAAA;ApEmhR3B;AoEjhRE;EACE,mBAAA;EACA,cAAA;EACA,mBAAA;ApEmhRJ;AoEhhRE;EACE,mBrEnC0B;EqEoC1B,cAAA;EACA,eAAA;ApEkhRJ;AoEhhRI;EAAM,eAAA;ApEmhRV;AoEjhRI;EAAU,gBAAA;ApEohRd;;AoE7gRA;EACE,aAAA;ApEghRF;AoE9gRE;EACE,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,kCAAA;EACA,crEvD0B;ACukR9B;AoE7gRE;EAAa,cAAA;ApEghRf;AoE/gRE;EAAa,WAAA;EAAa,gBAAA;ApEmhR5B;;AoEhhRA;EACE,kBAAA;EACA,eAAA;EACA,crEjE4B;EqEkE5B,iBAAA;ApEmhRF;;AoE/gRA;EACE,aAAA;EACA,iBAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,oCAAA;ApEkhRF;AoEhhRE;EAAuB,WAAA;ApEmhRzB;AoElhRE;EAA6B,uBAAA;ApEqhR/B;AoEphRE;EACE,mBAAA;EACA,kBAAA;ApEshRJ;;AoElhRA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ApEqhRF;AoEnhRE;EACE,mBAAA;ApEqhRJ;;AoEhhRA;EACE,aAAA;ApEmhRF;;AoEhhRA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;ApEmhRF;;AoEhhRA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;ApEmhRF;;AoEhhRA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,kCAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,uCAAA;ApEmhRF;AoEjhRE;EAAU,kCAAA;ApEohRZ;AoEnhRE;EACE,0BAAA;EACA,mBAAA;ApEqhRJ;;AoEhhRA;EAEE;IACE,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,QAAA;IACA,oBAAA;EpEkhRF;EoE/gRA;IACE,cAAA;IACA,cAAA;IACA,gBAAA;IACA,crEpK0B;IqEqK1B,kBAAA;IACA,gBAAA;IACA,oBAAA;IACA,qBAAA;IACA,4BAAA;IACA,qBAAA;IACA,eAAA;IACA,cAAA;EpEihRF;AACF;AoE9gRA;EACE;IACE,uBAAA;IACA,mBAAA;EpEghRF;EoE9gRA;IAAgB,eAAA;EpEihRhB;EoEhhRA;;IACgB,WAAA;IAAa,YAAA;EpEohR7B;EoEnhRA;IAA0C,WAAA;IAAa,gBAAA;EpEuhRvD;EoEthRA;IAAuB,WAAA;IAAa,YAAA;IAAc,gBAAA;EpE2hRlD;EoE1hRA;IAAqB,WAAA;IAAa,YAAA;EpE8hRlC;AACF;AqE/xRA;EACE,0BAAA;EACA,gBAAA;EACA,mBtEwD4B;EsEvD5B,kBAAA;ArEiyRF;AqE/xRE;EANF;IAOI,0BAAA;ErEkyRF;AACF;;AqE/xRA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;ArEkyRF;;AqE/xRA;EACE,OAAA;EACA,YAAA;EACA,mBtEsC4B;EsErC5B,gBAAA;EACA,aAAA;ArEkyRF;;AqE9xRA;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBtEyB4B;EsExB5B,kBAAA;EACA,ctE+B4B;EsE9B5B,4CAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;ArEiyRF;AqE/xRE;EAjBF;IAkBI,oBAAA;ErEkyRF;AACF;;AqE/xRA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;EACA,WAAA;ArEkyRF;AqEhyRE;EACE;IAAY,cAAA;ErEmyRd;AACF;AqEjyRE;EAdF;IAeI,SAAA;ErEoyRF;AACF;;AqE9xRA;EACI,2BAAA;EACA,mBAAA;EACA,eAAA;ArEiyRJ;;AqE9xRA;EAAoB,UAAA;ArEkyRpB;;AqEhyRA;EACI,UAAA;EACA,8BAAA;EACA,OAAA;ArEmyRJ;;AqEhyRA;EACI,YAAA;EACA,oBAAA;EACA,sBAAA;EACA,4BAAA;ArEmyRJ;;AqEhyRA;EAAuB,gBAAA;ArEoyRvB;;AqEnyRA;EAAyB,oBAAA;ArEuyRzB;;AqEtyRA;EAAuB,YAAA;ArE0yRvB;;AqExyRA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;ArE2yRJ;AqE1yRI;EACI,iBAAA;EACA,iBAAA;ArE4yRR;AqE3yRQ;EAHJ;IAGgC,iBAAA;ErE+yRlC;AACF;AqE9yRI;EAAuB,YAAA;ArEizR3B;;AqE9yRA;EACI;IACI,YAAA;IACA,oBAAA;ErEizRN;AACF;AqE/yRA;EACI;IAAgB,wBAAA;ErEkzRlB;EqEjzRE;IAA2B,aAAA;ErEozR7B;AACF;AqElzRA;EACI;IAAgB,WAAA;ErEqzRlB;EqEpzRE;IACI,aAAA;IACA,iBAAA;IACA,mBtEpIQ;IsEqIR,4BAAA;ErEszRN;EqEpzRE;IACI,YAAA;IACA,OAAA;IACA,eAAA;IACA,MAAA;IACA,mCAAA;IACA,2BAAA;IACA,kBAAA;IACA,WAAA;IACA,WAAA;IACA,oBAAA;ErEszRN;EqEpzRE;IACI,wBAAA;IACA,mBAAA;IACA,gBAAA;IACA,aAAA;ErEszRN;EqEpzRE;IAAoC,aAAA;ErEuzRtC;EqEtzRE;IACI,aAAA;IACA,eAAA;IACA,WAAA;IACA,SAAA;IACA,eAAA;ErEwzRN;EqEtzRE;;IACgC,WAAA;IAAa,YAAA;ErE0zR/C;EqEzzRE;IAA2B,eAAA;ErE4zR7B;EqE3zRE;IAAoC,UAAA;ErE8zRtC;EqE7zRE;IACI,eAAA;IACA,gBAAA;IACA,WAAA;IACA,SAAA;ErE+zRN;EqE7zRE;IAAoC,eAAA;IAAiB,WAAA;ErEi0RvD;EqEh0RE;IAAoB,UAAA;ErEm0RtB;EqEl0RE;IAA0C,aAAA;ErEq0R5C;EqEp0RE;IAA0C,aAAA;ErEu0R5C;EqEt0RE;IAA2C,cAAA;ErEy0R7C;EqEx0RE;IACI,eAAA;IACA,iBAAA;IACA,WAAA;IACA,gBAAA;ErE00RN;AACF;AqEv0RA;EACI;IACI,aAAA;IACA,WAAA;IACA,iBAAA;IACA,YAAA;ErEy0RN;EqEv0RE;IAA0C,eAAA;ErE00R5C;EqEz0RE;IACI,YAAA;IACA,iBAAA;IACA,+BAAA;IACA,gBAAA;ErE20RN;EqEz0RE;IAA0C,iBAAA;ErE40R5C;AACF;AsExhSA;EACI,iBAAA;AtE0hSJ;;AuE3hSA;EACI,sBAAA;EACA,uBAAA;EACA,4BAAA;AvE8hSJ;AuE7hSI;EAJJ;IAKQ,4BAAA;EvEgiSN;AACF;;AuE9hSA;EACI,gBAAA;EACA,cAAA;AvEiiSJ;;AuE/hSA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mCAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AvEkiSJ;;AuEhiSA;EACI,SAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AvEmiSJ;;AuEjiSA;EACI,kBAAA;AvEoiSJ;;AuEliSA;EACI,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,gBAAA;AvEqiSJ;;AuEniSA;EACI,mBAAA;AvEsiSJ;;AuEpiSA;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;AvEuiSJ;;AuEriSA;EACI;IACI,mBAAA;EvEwiSN;EuEtiSE;IACI,kBAAA;EvEwiSN;AACF;AuEtiSA;EACI;IACI,mBAAA;EvEwiSN;EuEtiSE;IACI,kBAAA;EvEwiSN;EuEtiSE;IACI,kBAAA;EvEwiSN;AACF;AuEtiSA;EACI;IACI,iBAAA;EvEwiSN;EuEtiSE;IACI,oBAAA;EvEwiSN;EuEtiSE;IACI,mBAAA;IACA,YAAA;EvEwiSN;AACF;AwErnSA;EACI,2BAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AxEunSJ;AwErnSI;EACI,kBAAA;AxEunSR;AwEpnSI;EAVJ;IAWQ,2BAAA;ExEunSN;AACF;;AwEnnSI;EACI,UAAA;AxEsnSR;AwEnnSI;EACI,sCAAA;AxEqnSR;AwElnSI;EACI,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AxEonSR;AwEjoSA;EAgBI,eAAA;AxEonSJ;;AwEjnSA;EACI,iBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;EACA,iBAAA;AxEonSJ;AwElnSI;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AxEonSR;AwEjnSI;EACI,gBAAA;EACA,cAAA;AxEmnSR;AwEhnSI;EAnBJ;IAoBQ,oBAAA;IACA,mBAAA;ExEmnSN;AACF;AwEjnSI;EAxBJ;IAyBQ,oBAAA;IACA,mBAAA;ExEonSN;AACF;AwElnSI;EA7BJ;IA8BQ,oBAAA;IACA,mBAAA;ExEqnSN;AACF;;AwElnSA;EACI,oBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AxEqnSJ;AwEnnSI;EACI,yBAAA;EACA,yBAAA;AxEqnSR;AwEpnSQ;EACI,UAAA;AxEsnSZ;;AwEjnSA;EACI,aAAA;EACA,mBAAA;EACA,OAAA;AxEonSJ;AwElnSI;EALJ;IAMQ,eAAA;IACA,iBAAA;ExEqnSN;AACF;;AwEjnSQ;EACI,aAAA;AxEonSZ;;AwEhnSA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,OAAA;EACA,gBAAA;AxEmnSJ;AwElnSI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,iHAAA;AxEonSR;;AwE/mSA;EACI,WAAA;AxEknSJ;;AwE/mSA;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,MAAA;EACA,aAAA;EACA,UAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,YAAA;AxEknSJ;AwEjnSI;EAXJ;IAYQ,UAAA;IACA,6BAAA;ExEonSN;AACF;AwEnnSI;EACI,WAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;AxEqnSR;AwEnnSQ;EACI,6BAAA;EACA,YAAA;AxEqnSZ;AwEhnSgB;EACI,eAAA;EACA,yBAAA;AxEknSpB;AwE7mSQ;EACI,aAAA;AxE+mSZ;AwE3mSI;EACI,YAAA;EACA,wBAAA;EACA,YAAA;EACA,iBAAA;AxE6mSR;AwE1mSI;EACI,eAAA;AxE4mSR;;AwExmSA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AxE2mSJ;;AwExmSA;EACI,mBAAA;EACA,kBAAA;EACA,mBAAA;AxE2mSJ;AwEzmSI;EACI,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,0BAAA;EACA,mBAAA;AxE2mSR;AwExmSI;EACI,eAAA;EACA,cAAA;EACA,iBAAA;EACA,SAAA;AxE0mSR;;AwEtmSA;EACI,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;AxEymSJ;;AwEtmSA;EACI,OAAA;AxEymSJ;AwEvmSI;EACI,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AxEymSR;AwEvmSQ;EAEI,sBAAA;EACA,aAAA;AxEwmSZ;;AwEnmSA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AxEsmSJ;AwEpmSI;EACI,YAAA;AxEsmSR;AwEnmSI;EACI,azEvPQ;AC41ShB;AwElmSI;EACI,WAAA;EACA,YAAA;AxEomSR;;AwEhmSA;EACI,kBAAA;EACA,kBAAA;AxEmmSJ;;AwEhmSA;EACI,WAAA;AxEmmSJ;;AwE/lSI;EADJ;IAEQ,+BAAA;ExEmmSN;AACF;AwEjmSI;EALJ;IAMQ,+BAAA;ExEomSN;AACF;;AyEz3SA;EACI,sBAAA;EACA,oBAAA;EACC,kCAAA;EACD,aAAA;EACA,WAAA;EACA,gCAAA;AzE43SJ;;AyE13SA;EACI,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AzE63SJ;;AyE33SA;EACI,gBAAA;EACA,mBAAA;AzE83SJ;;AyE53SA;EACI;IACI,mBAAA;EzE+3SN;EyE73SE;IACI,gBAAA;IACA,mBAAA;EzE+3SN;EyE73SE;IACI,kBAAA;EzE+3SN;AACF;AyE73SA;EACI;IACI,mBAAA;EzE+3SN;EyE73SE;IACI,gBAAA;IACA,mBAAA;EzE+3SN;EyE73SE;IACI,kBAAA;EzE+3SN;EyE73SE;IACI,gBAAA;EzE+3SN;AACF;AyE33SA;EACI;IACI,oBAAA;IACA,aAAA;EzE63SN;AACF;A0E/6SA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;A1Ei7SF;A0E/6SE;EAXF;IAYI,UAAA;IACA,WAAA;E1Ek7SF;AACF;A0E/6SE;EAjBF;IAkBI,WAAA;E1Ek7SF;AACF;;A0E/6SA;EACE,mBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mBAAA;EACA,4BAAA;EACA,kBAAA;A1Ek7SF;;A0E96SA;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;A1Ei7SF;A0E/6SE;EAbF;IAcI,iBAAA;E1Ek7SF;AACF;A0Eh7SE;EAjBF;IAkBI,gBAAA;IACA,eAAA;IACA,iBAAA;E1Em7SF;AACF;;A0Eh7SA;;EAEE,wBAAA;A1Em7SF;;A0Eh7SA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;A1Em7SF;;A0Eh7SA;EACE,4BAAA;EACA,2BAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,6BAAA;A1Em7SF;;A0Eh7SA;EACE,YAAA;A1Em7SF;;A0Eh7SA;EACE,YAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;A1Em7SF;;A0Eh7SA;EACE,kBAAA;EACA,6DAAA;EACA,uDAAA;EACA,iBAAA;EACA,gBAAA;A1Em7SF;;A0Eh7SA;EACE,kBAAA;A1Em7SF;;A0Eh7SA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;A1Em7SF;;A0Eh7SA;EACE,gBAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gCAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;A1Em7SF;A0Ej7SE;EACE,UAAA;A1Em7SJ;A0Eh7SE;EAzBF;IA0BI,WAAA;IACA,kBAAA;IACA,YAAA;E1Em7SF;AACF;;A0E/6SA;EACE,YAAA;A1Ek7SF;A0Eh7SE;EAHF;IAII,WAAA;E1Em7SF;AACF;A0Ex7SA;EAOE,sBAAA;A1Eo7SF;A0El7SE;EACE,UAAA;A1Eo7SJ;;A0Eh7SA;EACE,cAAA;A1Em7SF;;A0Eh7SA;EACE,kBAAA;EACA,qBAAA;EACA,kBAAA;A1Em7SF;;A0Eh7SA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;A1Em7SF;;A0Eh7SA;EACE,yBAAA;A1Em7SF;;A0Eh7SA;EACE,iBAAA;A1Em7SF;;A0Eh7SA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yB3E/Lc;E2EgMd,c3EhMc;E2EiMd,yCAAA;EACA,kBAAA;A1Em7SF;;A0Eh7SA;;EAEE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;A1Em7SF;;A0Eh7SA;EACE,UAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yB3ElNc;E2EmNd,c3EnNc;E2EoNd,gDAAA;A1Em7SF;;A0Eh7SA;EACE,SAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yB3E5Nc;E2E6Nd,c3E7Nc;E2E8Nd,+CAAA;A1Em7SF;;A0Eh7SA;EACE;IACE,sBAAA;E1Em7SF;E0Eh7SA;IACE,wBAAA;E1Ek7SF;E0E/6SA;IACE,yBAAA;E1Ei7SF;E0E96SA;IACE,sBAAA;E1Eg7SF;E0E76SA;IACE,sBAAA;E1E+6SF;AACF;A0E56SA;EACE;IACE,sBAAA;E1E86SF;E0E36SA;IACE,sBAAA;E1E66SF;E0E16SA;IACE,wBAAA;E1E46SF;E0Ez6SA;IACE,sBAAA;E1E26SF;E0Ex6SA;IACE,sBAAA;E1E06SF;AACF;A0Ev6SA;EACE;IACE,sBAAA;E1Ey6SF;E0Et6SA;IACE,sBAAA;E1Ew6SF;E0Er6SA;IACE,yBAAA;E1Eu6SF;E0Ep6SA;IACE,wBAAA;E1Es6SF;E0En6SA;IACE,sBAAA;E1Eq6SF;AACF;A0Er5SA;EACE,wBAAA;EACA,6BAAA;EACA,mCAAA;EACA,uBAAA;EACA,iCAAA;EACA,mBAAA;EACA,2EAAA;EAIA,4BAAA;A1Eo5SF;;A0Ej5SA;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;A1Eo5SF;;A0Ej5SA;EACE,cAAA;A1Eo5SF;;A0Ej5SA;EACE,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;A1Eo5SF;;A0Ej5SA;EACE,yBAAA;A1Eo5SF;;A0Eh5SA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,iBAAA;A1Em5SF;A0Ej5SE;EACE,a3E9VY;ACivThB;;A0E74SA;EACE;IACE,4BAAA;E1Eg5SF;E0E74SA;IACE,2BAAA;E1E+4SF;AACF;A0E54SA;EACE;IACE,8BAAA;E1E84SF;E0E34SA;IACE,6BAAA;E1E64SF;AACF;A0E14SA;EACE;IACE,oBAAA;IACA,kDAAA;E1E44SF;AACF;A0Ex4SA;EACE;IACE,QAAA;E1E04SF;AACF;A0Et4SA;EACE;IACE,eAAA;IACA,OAAA;IACA,QAAA;IACA,iBAAA;IACA,gCAAA;IACA,2CAAA;IACA,yBAAA;E1Ew4SF;E0Er4SA;IACE,4BAAA;E1Eu4SF;E0Ep4SA;IACE,gBAAA;IACA,iBAAA;E1Es4SF;E0En4SA;IACE,WAAA;IACA,YAAA;IACA,SAAA;E1Eq4SF;E0El4SA;IACE,kBAAA;IACA,UAAA;IACA,YAAA;IACA,YAAA;IACA,YAAA;IACA,kBAAA;IACA,kBAAA;IACA,kBAAA;E1Eo4SF;E0Ej4SA;IACE,eAAA;E1Em4SF;E0Eh4SA;IACE,eAAA;E1Ek4SF;E0E/3SA;IACE,WAAA;E1Ei4SF;E0E93SA;IACE,kBAAA;E1Eg4SF;E0E73SA;IACE,gBAAA;E1E+3SF;E0E53SA;IACE,aAAA;E1E83SF;E0E33SA;IACE,OAAA;E1E63SF;E0E13SA;IACE,WAAA;E1E43SF;E0Ez3SA;IACE,iBAAA;E1E23SF;AACF;A0Et3SA;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,wBAAA;EACA,gBAAA;EACA,iBAAA;A1Ew3SF;A0Et3SE;EACE,mBAAA;A1Ew3SJ;A0Er3SE;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;A1Eu3SJ;A0Ep3SE;EACE,yBAAA;EACA,kBAAA;A1Es3SJ;A0En3SE;EACE,SAAA;A1Eq3SJ;;A0Ej3SA;EACE,OAAA;A1Eo3SF;;A0Ej3SA;EACE,kBAAA;A1Eo3SF;;A0Ej3SA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;A1Eo3SF;A0En3SE;EATF;IAUI,gBAAA;IACA,eAAA;E1Es3SF;AACF;A0Er3SE;EAbF;IAcI,gBAAA;E1Ew3SF;AACF;;A2E/yTA;EACI,0BAAA;EACA,eAAA;EACA,gBAAA;A3EkzTJ;A2EjzTI;EAJJ;IAKQ,0BAAA;E3EozTN;AACF;A2EnzTI;EAPJ;IAQQ,yBAAA;E3EszTN;AACF;A2ErzTI;EAVJ;IAWQ,yBAAA;E3EwzTN;AACF;A2EvzTI;EACI,iBAAA;A3EyzTR;A2EvzTY;EACI,mCAAA;EACA,0EAAA;A3EyzThB;;A2EnzTA;EACI,yBAAA;EACA,mBAAA;EACA,4BAAA;EACA,YAAA;A3EszTJ;A2ErzTI;EALJ;IAMQ,4BAAA;E3EwzTN;AACF;A2EvzTI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;A3EyzTR;A2EtzTI;EACI,4BAAA;EACA,iBAAA;EACA,SAAA;A3EwzTR;A2EvzTQ;EAJJ;IAKQ,iBAAA;E3E0zTV;AACF;A2EzzTQ;EAPJ;IAQK,eAAA;E3E4zTP;AACF;;A2ExzTA;;;EAGI,aAAA;EACA,oBAAA;A3E2zTJ;;A2ExzTA;;EAEI,YAAA;A3E2zTJ;;A2ExzTA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A3E2zTJ;A2E1zTI;EATJ;IAUQ,WAAA;IACA,YAAA;E3E6zTN;AACF;;A2ExzTI;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sDAAA;EACA,kBAAA;EACA,yB5E/KQ;E4EgLR,UAAA;A3E2zTR;A2ExzTQ;EACI,aAAA;A3E0zTZ;A2ExzTQ;EACI,UAAA;A3E0zTZ;A2EvzTI;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,6BAAA;EACA,sDAAA;EACA,kBAAA;EACA,yB5EnMQ;E4EoMR,UAAA;A3EyzTR;A2EvzTQ;EACI,aAAA;A3EyzTZ;A2EvzTQ;EACI,UAAA;A3EyzTZ;;A2ErzTA;EACI,cAAA;EACA,iBAAA;EACA,eAAA;A3EwzTJ;;A2EtzTA;EACI,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;A3EyzTJ;;A2EvzTA;EACI,iBAAA;A3E0zTJ;;A4EzhUA;EACI,uBAAA;A5E4hUJ;;A4EzhUA;;EAEI,eAAA;A5E4hUJ;;A4EzhUA;EACI,WAAA;A5E4hUJ;;A4EzhUA;EACI,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;A5E4hUJ;;A4EzhUA;EACI,6BAAA;EACA,gBAAA;EACA,UAAA;A5E4hUJ;;A4EzhUA;EACI,0BAAA;EACA,mBAAA;A5E4hUJ;;A4EzhUA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;A5E4hUJ;;A4EzhUA;;EAEI,qC7EmBU;ACygUd;;A4EzhUA;EACI,OAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;A5E4hUJ;;A4EzhUA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;A5E4hUJ;;A4EzhUA;EACI,WAAA;A5E4hUJ;;A4EzhUA;EACI,WAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,c7E/DY;E6EgEZ,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,iBAAA;A5E4hUJ;A4E1hUI;EAnBJ;IAoBQ,SAAA;IACA,cAAA;IACA,WAAA;IACA,YAAA;E5E6hUN;AACF;A4E3hUI;EACI,yB7EnFQ;E6EoFR,WAAA;A5E6hUR;;A4EzhUA;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;A5E4hUJ;;A4EzhUA;EACI,gBAAA;A5E4hUJ;;A4ExhUA;EACI,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;A5E2hUJ;A4EzhUI;EAPJ;IAQQ,kBAAA;E5E4hUN;AACF;;A4EzhUA;EACI,OAAA;EACA,kBAAA;A5E4hUJ;;A4EzhUA;EACI,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,wBAAA;A5E4hUJ;;A4EzhUA;EACI,mBAAA;EACA,eAAA;A5E4hUJ;;A4ExhUA;EACI,a7EnIY;AC8pUhB;;A4EvhUA;;EAEI,6BAAA;A5E0hUJ;;A4ErhUA;EACI,6BAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,aAAA;A5EwhUJ;;A4ErhUA;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,oBAAA;EACA,cAAA;A5EwhUJ;;A4ErhUA;EACI,sBAAA;EACA,kBAAA;EACA,iBAAA;A5EwhUJ;;A4ErhUA;EACI,yCAAA;A5EwhUJ;;A4ErhUA;EACI,8BAAA;EACA,gBAAA;A5EwhUJ;;A4ErhUA;EACI,iBAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;A5EwhUJ;;A4ErhUA;EACI,kBAAA;A5EwhUJ;;A4ErhUA;EACI,gBAAA;A5EwhUJ;;A4ErhUA;EACI;IACI,iBAAA;IACA,mBAAA;E5EwhUN;AACF;A4ErhUA;EACI;IACI,iBAAA;IACA,mBAAA;E5EuhUN;AACF;A4EphUA;EACI;IACI,eAAA;E5EshUN;E4EnhUE;IACI,gBAAA;E5EqhUN;E4ElhUE;IACI,eAAA;E5EohUN;E4EjhUE;IACI,kBAAA;E5EmhUN;E4EhhUE;IACI,2BAAA;E5EkhUN;E4E/gUE;IACI,iBAAA;IACA,gBAAA;E5EihUN;E4E9gUE;IACI,kBAAA;E5EghUN;E4E7gUE;IACI,eAAA;IACA,gBAAA;E5E+gUN;E4E5gUE;IACI,gBAAA;E5E8gUN;E4E3gUE;IACI,2BAAA;IACA,kBAAA;E5E6gUN;E4E1gUE;IACI,iBAAA;E5E4gUN;E4EzgUE;IACI,kBAAA;E5E2gUN;E4ExgUE;IACI,kBAAA;E5E0gUN;AACF;A4EpgUA;EACI,mBAAA;EACA,eAAA;EACA,iBAAA;A5EsgUJ;A4EpgUI;EACI,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;A5EsgUR;A4EngUI;EACI,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;A5EqgUR;A4EjgUI;EACI,mBAAA;EACA,iBAAA;EACA,eAAA;A5EmgUR;A4EhgUI;EACI,mBAAA;A5EkgUR;A4EhgUQ;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;A5EkgUZ;;A6ErzUA;EACI,mBAAA;A7EwzUJ;;A6EtzUA;EACI,YAAA;A7EyzUJ;;A6EvzUA;EACI,mBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;A7E0zUJ;;A6ExzUA;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;A7E2zUJ;;A6EzzUA;EACI,YAAA;EACA,yBAAA;A7E4zUJ;;A6E1zUA;EACI,WAAA;EACA,YAAA;A7E6zUJ;;A6E3zUA;EACI,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;A7E8zUJ;;A6EtzUA;EACI,yB9ErCY;E8EsCZ,iBAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;A7EyzUJ;;A6EvzUA;EACI,WAAA;EACA,YAAA;A7E0zUJ;;A6ExzUA;EACI;IACI,UAAA;E7E2zUN;E6EzzUE;IACI,mBAAA;IACA,WAAA;IACA,YAAA;IACA,iBAAA;IACA,uBAAA;E7E2zUN;E6EzzUE;IACI,uBAAA;E7E2zUN;E6EzzUE;IACI,UAAA;IACA,YAAA;IACA,WAAA;IACA,mBAAA;IACA,kBAAA;E7E2zUN;E6EzzUE;IACI,4BAAA;E7E2zUN;E6EzzUE;IACI,UAAA;E7E2zUN;AACF;A8E54UA;EACI,0BAAA;EACA,aAAA;EACA,uBAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;A9E84UJ;;A8E54UA;;EAEI,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;A9E+4UJ;;A8E74UA;EACI,cAAA;EACA,eAAA;A9Eg5UJ;;A8E94UA;EACI,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;A9Ei5UJ;;A8E/4UA;;EAEI,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;A9Ek5UJ;;A8Eh5UA;EACI,YAAA;A9Em5UJ;;A8Ej5UA;EACI,gBAAA;A9Eo5UJ;;A8El5UA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;A9Eq5UJ;;A8En5UA;EACI,OAAA;EACA,mBAAA;A9Es5UJ;;A8Ep5UA;EACI,oBAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;A9Eu5UJ;;A8Er5UA;EACI,cAAA;EACA,aAAA;A9Ew5UJ;;A8Et5UA;EACI,eAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,2CAAA;A9Ey5UJ;;A8Ev5UA;EACI;IACI,0BAAA;IACA,kBAAA;IACA,mBAAA;IACA,sBAAA;E9E05UN;E8Ex5UE;;IAEI,gBAAA;IACA,eAAA;IACA,YAAA;E9E05UN;E8Ex5UE;IACI,eAAA;IACA,YAAA;E9E05UN;AACF;A+EphVA;EACI,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;A/EshVJ;;A+EphVA;;EAEI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,qBAAA;EACA,iBAAA;A/EuhVJ;;A+ErhVA;EACI,gBAAA;A/EwhVJ;;A+EthVA;EACI,eAAA;EACA,cAAA;EACA,mBAAA;A/EyhVJ;;A+EvhVA;;EAEI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;A/E0hVJ;;A+ExhVA;EACI,OAAA;A/E2hVJ;;A+EzhVA;EACI,cAAA;A/E4hVJ;;A+E1hVA;EACI,kBAAA;A/E6hVJ;;A+E3hVA;EACI,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,2CAAA;A/E8hVJ;;A+E5hVA;EACI,gBAAA;EACA,6BAAA;EACA,iBAAA;EACA,mBAAA;A/E+hVJ;;A+E7hVA;EACI,eAAA;A/EgiVJ;;A+E9hVA;EACI,gBAAA;A/EiiVJ;;A+E/hVA;EACI,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;A/EkiVJ;;A+EhiVA;EACI,cAAA;A/EmiVJ;;A+EjiVA;EACI,uBAAA;A/EoiVJ;;A+EjiVA;EACI;;IAEI,iBAAA;E/EoiVN;E+EliVE;IACI,WAAA;IACA,UAAA;E/EoiVN;E+EliVE;IACI,SAAA;IACA,eAAA;E/EoiVN;E+EliVE;IACI,aAAA;E/EoiVN;E+EliVE;IACI,aAAA;E/EoiVN;AACF;AgF5nVI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AhF8nVN;AgF3nVI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AhF6nVN;AgFznVE;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;AhF2nVJ;AgFznVI;EACE,sBAAA;AhF2nVN;AgFtnVI;EACE,0BAAA;AhFwnVN;AgFvnVM;EAFF;IAGI,uBAAA;EhF0nVN;AACF;AgFvnVI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AhFynVN;AgFvnVM;EACE,gBAAA;EACA,kBAAA;EACA,oCAAA;EACA,yBAAA;EACA,cAAA;EACA,yBAAA;AhFynVR;AgFvnVQ;EACE,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,2BAAA;EACA,wCAAA;AhFynVV;AgFtnVQ;EACE,WAAA;EACA,YAAA;AhFwnVV;AgFlnVE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;AhFonVJ;AgFlnVI;EACE,WAAA;EACA,YAAA;AhFonVN;AgFjnVI;EACE,SAAA;EACA,eAAA;AhFmnVN;AgF/mVE;EACE,aAAA;AhFinVJ;AgF/mVI;EACE,SAAA;EACA,eAAA;AhFinVN;;AgF3mVA;EACE;IACE,kBAAA;IACA,gBAAA;EhF8mVF;EgF3mVI;IACE,SAAA;IACA,WAAA;EhF6mVN;EgFzmVE;IACE,aAAA;EhF2mVJ;AACF;AgFvmVA;EAIQ;IACE,0BAAA;IACA,uBAAA;EhFsmVR;EgFhmVI;IACE,eAAA;EhFkmVN;EgF/lVI;IACE,eAAA;EhFimVN;AACF;AgF3lVA;EACE;IACE,mBAAA;IACA,cAAA;EhF6lVF;EgF3lVE;IACE,mBAAA;IACA,4BAAA;EhF6lVJ;EgF3lVI;IACE,cAAA;EhF6lVN;EgF1lVI;IACE,cAAA;EhF4lVN;EgFtlVM;IACE,iCAAA;IACA,qBAAA;IACA,cAAA;EhFwlVR;EgFtlVQ;IACE,mBAAA;IACA,qBAAA;IACA,cAAA;EhFwlVV;EgFllVE;IACE,cAAA;EhFolVJ;AACF;AiF3wVI;EACI,uBAAA;AjF6wVR;AiF1wVI;EACI,YAAA;AjF4wVR;;AiFxwVA;EACI,mBAAA;EACA,0BAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;AjF2wVJ;AiFzwVI;EACI,eAAA;EACA,gBAAA;AjF2wVR;AiFzwVQ;EACI,cAAA;EACA,0BAAA;EACA,kBAAA;AjF2wVZ;AiFvwVI;EACI,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AjFywVR;;AiFpwVA;EACI,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AjFuwVJ;;AiFpwVA;EACI,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AjFuwVJ;AiFrwVI;EACI,OAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AjFuwVR;AiFpwVI;EACI,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;AjFswVR;AiFrwVQ;EACI,UAAA;AjFuwVZ;;AiFjwVA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AjFowVJ;;AiFjwVA;EACI,8BAAA;AjFowVJ;;AiFjwVA;EACI,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AjFowVJ;;AiFhwVI;EACI,gBAAA;EACA,gCAAA;AjFmwVR;;AiF/vVA;EACI,mBAAA;AjFkwVJ;;AiF/vVA;EACI,iBAAA;AjFkwVJ","sourcesContent":["@use \"utils/variables\" as *;\nbody {\n    font-family: $primary-font;\n    font-size: $body-font-size;\n    color: $theme-body-font-color;\n    background: #fff;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\nbody .btn-primary {\n    min-width: 125px;\n    padding: 0 20px;\n    height: 38px;\n    border-radius: $radius;\n    border: none;\n    color: #fff;\n    font-weight: normal;\n    font-size: $body-font-size;\n}\n.form-control.input-item {\n    background-color: #F3F5F7;\n    border-radius: 8px;\n    height: 39px;\n    border: none;\n    font-size: $body-font-size-medium;\n}\n.form-control.textarea-item {\n    background-color: #F3F5F7;\n    border-radius: 8px;\n    border: none;\n    font-size: $body-font-size-medium;\n}\n.form-select.select-item {\n    background-color: #F3F5F7;\n    border-radius: 8px;\n    height: 39px;\n    border: none;\n    font-size: $body-font-size-medium;\n}\n// react-select's unfocused control (all selects use classNamePrefix=\"react-select-2-option\").\n.react-multi-select .react-select-2-option__control:not(.react-select-2-option__control--is-focused):not(.react-select-2-option__control--is-disabled) {\n    background-color: #F3F5F7;\n    border-radius: 8px;\n    min-height: 39px;\n    border: none;\n    font-size: $body-font-size-medium;\n}\n\n.form-input-wrap .form-label {\n    font-weight: 600;\n    line-height: 15.5px;\n    margin-bottom: 10px;\n}\n.form-input-wrap {\n    margin-bottom: 15px;\n}\n.form-control.input-item:disabled {\n    color: #000;\n}\nbody .btn {\n    border-radius: 7px;\n    min-width: 110px;\n    padding: 0 20px;\n    font-size: 13px;\n    height: 39px;\n    &.btn-sm {\n        border-radius: 5px;   \n    }\n    \n}\nbody .btn-sm {\n    height: 30px;\n}\n.link-btn {\n   line-height: 39px; \n}\n.link-btn-sm {\n    line-height: 30px; \n }\n.white-border-btn {\n    color: #fff;\n}\n.white-border-btn:hover{\n    color: #fff;\n}\n.border-btn {\n    border: 1px solid #fff;\n}\n.border-btn:hover {\n    border: 1px solid #fff; \n}\n.primary-text {\ncolor: $primary-color !important;\nfont-weight: 600;\n}\n.grey-border-btn {\n    border: 1px solid #cccdce;\n    color: #000;\n}\n.grey-border-btn.btn:disabled {\n    border: 1px solid #cccdce;\n    opacity: 0.5;\n}\n.btn svg {\n    margin-right: 5px;\n    position: relative;\n    top: -2px;\n}\n.grey-border-btn {\n    border: 1px solid #d7e0e9;\n}\n.grey-border-btn:hover {\n    border: 1px solid #d7e0e9; \n    color: #000;\n}\n.white-btn {\n    background: #fff;\n    color: #000;\n}\n.white-btn:hover {background: #fff;\n    color: #000;}\n.double-btn .btn {\n    margin-left: 13px;\n}\n.double-btn .btn:first-child {\n    margin-left: 0;\n}\n.form-control.input-item:focus {\n    box-shadow: none;\n}\n.btn-check:focus + .btn-primary,\n.btn-primary:focus {\n    box-shadow: none;\n}\nlabel.btn {\n    height: 39px;\n    line-height: 39px;\n}\n.p-relative {\n    position: relative;\n}\n.p-l-0 {\n    padding-left: 0 !important;\n}\n.p-r-0 {\n    padding-right: 0 !important;\n}\n.m-b-10 {\n    margin-bottom: 10px;\n}\n.m-b-15 {\n    margin-bottom: 15px;\n}\n.m-b-20 {\n    margin-bottom: 20px;\n}\n.m-b-25 {\n    margin-bottom: 25px;\n}\n.m-b-30 {\n    margin-bottom: 30px;\n}\n.m-b-40 {\n    margin-bottom: 40px;\n}\n.m-b-50 {\n    margin-bottom: 50px;\n}\n.m-b-60 {\n    margin-bottom: 60px;\n}\n.m-t-10 {\n    margin-top: 10px;\n}\n.m-t-15 {\n    margin-top: 15px;\n}\n.m-t-20 {\n    margin-top: 20px;\n}\n.m-t-30 {\n    margin-top: 30px;\n}\n.m-t-40 {\n    margin-top: 40px;\n}\n.m-t-50 {\n    margin-top: 50px;\n}\n.p-15 {\n    padding: 15px;\n}\n.p-20 {\n    padding: 20px;\n}\n.p-25 {\n    padding: 25px;\n}\n.p-30 {\n    padding: 30px;\n}\n.primary-color {\n    color: $primary-color;\n}\n.primary-bg {\n    background: $primary-color;\n}\n.btn-primary img {\n    margin-right: 5px;\n}\n.sec-sub-head {\n    font-weight: 600;\n    font-size: 15px;\n    line-height: 18px;\n    letter-spacing: -0.02em;\n}\n.right-border {\n    border-right: 1px solid #d9d9d9;\n}\n.left-border {\n    border-left: 1px solid #d9d9d9;\n}\n.top-border {\n    border-top: 1px solid #d9d9d9;\n}\n.bottom-border {\n    border-bottom: 1px solid #d9d9d9;\n}\n.m-b-25 {\n    margin-bottom: 25px;\n}\n.whitebox {\n    background: #ffffff;\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.09);\n    border-radius: $curveradius;\n}\n.padding-box {\n    padding: 15px;\n}\n\nbody .btn-check:focus + .btn, body .btn:focus {\n    outline: 0;\n    box-shadow:none;\n}\nbody .btn:hover {\n    opacity: 0.8;\n}\n.text-left {\n    text-align: left;\n}\n.loader-middle-align {\n    display: flex;\n    min-height: 20vh;\n    align-items: center;\n    justify-content: center;\n}\n.common-modal.header-no-text .modal-header {\n    padding: 0 0 7px;\n    border: none;\n    padding: 0;\n}\n.results-tab-wrap .tab-content-wrap  {\n    min-height: calc(100vh - 120px);\n}\n.scrollarea-content {\n    padding-right: 10px;\n}\nbody .tooltip > div.tooltip-inner {\n    background-color: #d2d5db !important;\n    color: #333;\n}\n.bs-tooltip-bottom .tooltip-arrow::before {\n    border-bottom-color: #d2d5db !important;\n}\nbody .bs-tooltip-top .tooltip-arrow::before {\n    border-top-color: #d2d5db !important;\n}\nbody .tippy-box {\n    font-size: 12px;\n}\n.no-fixed-height {\n    height: auto;\n}\n.p-10 {\n    padding: 10px;\n}\n.column-title-link[href]:hover, .column-title:hover {\n    color: $primary-color !important;\n}\n.file-uploaded-text {\n    word-break: break-all;\n}\n// @media (min-width:1200px){\n//     body .container {\n//         max-width: 1140px;\n//     }\n// }\n.full-width-container {\n    max-width: 100% !important;\n    padding: 0 15px;\n}\n@media (max-width:767px){\n    .container {\n        padding-left: 15px;padding-right: 15px;\n    }\n    .tooltip-arrow {\n        display: none !important;\n    }\n    .bs-tooltip-top {\n        display: none !important;\n    }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.page-main-wrapper {\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n    overflow: hidden;\n}\n\n.page-contents {\n    flex: 1;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n}\n","// General variables\n$theme-body-font-color: #000000;\n$body-color: #F6F7F9;\n\n// Theme colors variables\n$primary-color: #1A73E8;\n$secondary-color: #CE002A;\n$auth-primary-color:#F69525;\n$success-color: #17D664;\n$info-color : #a927f9;\n$warning-color: #f8d62b;\n$danger-color: #EC1F1F;\n$light-color : #f4f4f4;\n$light-gray : #ecf3fa;\n$light-semi-gray :#efefef;\n$dark-gray: #898989;\n$dark-color : #2c323f;\n$gray-60 :#cccccc;\n$card-body-color : #f9f9fa;\n$transparent-color: transparent;\n$auth-bg-color:#fafafa;\n$light : #fdfeff;\n$semi-dark :#59667a;\n$light-text: #999999;\n$light-background: #d7e2e9;\n$light-font: rgba(27, 49, 85, 0.4);\n$light-semi-font: $semi-dark;\n$light-chartist-grid-color: #f6f9fd;\n$pitch-color: #fe8a7d;\n$color-scarpa: #4c5667;\n$color-fiord: #455a64;\n$black : #000;\n$white:#fff;\n$table-head-bg:#e8eaec;\n$green-text:#0EC60E;\n$circulargraph-blue : #0d6efd;\n$circulargraph-green : #3DD598;\n$circulargraph-yellow : #FF974A;\n$graph-primary:#3DD598;\n$graph-secondary:#0062FF;\n$graph-c:#6200ff;\n$dbd-primary-graph:#FFE223;\n$dbd-graph-secondary:#11E1A3;\n\n// gradient colors\n$gradient-primary: linear-gradient(26deg, var(--theme-deafult) 0%, #a26cf8 100%);\n\n//social colors\n$fb: #50598e;\n$twitter: #6fa2d8;\n$google-plus: #c64e40;\n$linkedin: #0077B5;\n\n//radius\n$radius:3px;\n$curveradius:15px;\n$radius-md:10px;\n\n//fonts\n$primary-font:'Montserrat', sans-serif;\n$font-serif: sans-serif;\n$body-font-size:13px;\n$body-font-size-medium:12px;\n\n// ── Unified Chat Tokens ────────────────────────────────────────────────────────\n\n// Layout\n$chat-sidebar-width:          285px;\n$chat-sidebar-bg:             #F4F6F7;\n$chat-sidebar-border:         transparent;\n\n// Chat surface\n$chat-bg:                     #FFFFFF;  // main feed area\n$chat-page-bg:                #F4F6F7;  // outer page + sidebar bg\n$chat-surface:                #FFFFFF;\n$chat-border-subtle:          #E5E7EB;\n$chat-message-gap:            20px;\n$chat-feed-padding-h:         60px;\n$chat-content-max-width:      720px;   // chat message column width (design 02/03)\n\n// Typography\n$chat-title-color:            #1A1A1A;\n$chat-text-primary:           #1A1A1A;\n$chat-text-muted:             #A0A4AB;\n$chat-text-secondary:         #6B7280;\n\n// Reading-area typography — used by AI response markdown only.\n// System-UI stack so bolds render naturally (matches ChatGPT/Claude/Gemini).\n$chat-reading-font:           -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Inter\",\n                              Roboto, \"Helvetica Neue\", Arial, sans-serif;\n$chat-reading-size:           16px;\n$chat-reading-leading:        1.7;\n$chat-heading-weight:         500;   // medium — 500 in system-UI optically matches ChatGPT/Claude 600 in their custom faces\n\n// Interactive\n$chat-primary:                $primary-color;   // #1A73E8\n$chat-primary-hover:          #1558B0;\n\n// Input\n$chat-input-border:           #E5E7EB;\n$chat-input-radius:           16px;\n$chat-input-shadow:           0 4px 14px rgba(16, 24, 40, 0.08);\n\n// Borders and surfaces\n$chat-border:                 #E5E7EB;\n$chat-border-light:           #EEF0F2;\n$chat-surface-hover:          #E8EAED;\n$chat-surface-active:         #E1E5EA;\n\n// Status\n$chat-error:                  #D92D20;\n$chat-success:                #17D664;\n$chat-thinking-color:         $primary-color;\n\n// Code blocks\n$chat-code-bg:                #1e1e1e;\n$chat-code-toolbar-bg:        #2d2d2d;\n$chat-code-border:            #3a3a3a;\n$chat-code-text:              #d4d4d4;\n","body {\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 13px;\n  color: #000000;\n  background: #fff;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nbody .btn-primary {\n  min-width: 125px;\n  padding: 0 20px;\n  height: 38px;\n  border-radius: 3px;\n  border: none;\n  color: #fff;\n  font-weight: normal;\n  font-size: 13px;\n}\n\n.form-control.input-item {\n  background-color: #F3F5F7;\n  border-radius: 8px;\n  height: 39px;\n  border: none;\n  font-size: 12px;\n}\n\n.form-control.textarea-item {\n  background-color: #F3F5F7;\n  border-radius: 8px;\n  border: none;\n  font-size: 12px;\n}\n\n.form-select.select-item {\n  background-color: #F3F5F7;\n  border-radius: 8px;\n  height: 39px;\n  border: none;\n  font-size: 12px;\n}\n\n.react-multi-select .react-select-2-option__control:not(.react-select-2-option__control--is-focused):not(.react-select-2-option__control--is-disabled) {\n  background-color: #F3F5F7;\n  border-radius: 8px;\n  min-height: 39px;\n  border: none;\n  font-size: 12px;\n}\n\n.form-input-wrap .form-label {\n  font-weight: 600;\n  line-height: 15.5px;\n  margin-bottom: 10px;\n}\n\n.form-input-wrap {\n  margin-bottom: 15px;\n}\n\n.form-control.input-item:disabled {\n  color: #000;\n}\n\nbody .btn {\n  border-radius: 7px;\n  min-width: 110px;\n  padding: 0 20px;\n  font-size: 13px;\n  height: 39px;\n}\nbody .btn.btn-sm {\n  border-radius: 5px;\n}\n\nbody .btn-sm {\n  height: 30px;\n}\n\n.link-btn {\n  line-height: 39px;\n}\n\n.link-btn-sm {\n  line-height: 30px;\n}\n\n.white-border-btn {\n  color: #fff;\n}\n\n.white-border-btn:hover {\n  color: #fff;\n}\n\n.border-btn {\n  border: 1px solid #fff;\n}\n\n.border-btn:hover {\n  border: 1px solid #fff;\n}\n\n.primary-text {\n  color: #1A73E8 !important;\n  font-weight: 600;\n}\n\n.grey-border-btn {\n  border: 1px solid #cccdce;\n  color: #000;\n}\n\n.grey-border-btn.btn:disabled {\n  border: 1px solid #cccdce;\n  opacity: 0.5;\n}\n\n.btn svg {\n  margin-right: 5px;\n  position: relative;\n  top: -2px;\n}\n\n.grey-border-btn {\n  border: 1px solid #d7e0e9;\n}\n\n.grey-border-btn:hover {\n  border: 1px solid #d7e0e9;\n  color: #000;\n}\n\n.white-btn {\n  background: #fff;\n  color: #000;\n}\n\n.white-btn:hover {\n  background: #fff;\n  color: #000;\n}\n\n.double-btn .btn {\n  margin-left: 13px;\n}\n\n.double-btn .btn:first-child {\n  margin-left: 0;\n}\n\n.form-control.input-item:focus {\n  box-shadow: none;\n}\n\n.btn-check:focus + .btn-primary,\n.btn-primary:focus {\n  box-shadow: none;\n}\n\nlabel.btn {\n  height: 39px;\n  line-height: 39px;\n}\n\n.p-relative {\n  position: relative;\n}\n\n.p-l-0 {\n  padding-left: 0 !important;\n}\n\n.p-r-0 {\n  padding-right: 0 !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px;\n}\n\n.m-b-15 {\n  margin-bottom: 15px;\n}\n\n.m-b-20 {\n  margin-bottom: 20px;\n}\n\n.m-b-25 {\n  margin-bottom: 25px;\n}\n\n.m-b-30 {\n  margin-bottom: 30px;\n}\n\n.m-b-40 {\n  margin-bottom: 40px;\n}\n\n.m-b-50 {\n  margin-bottom: 50px;\n}\n\n.m-b-60 {\n  margin-bottom: 60px;\n}\n\n.m-t-10 {\n  margin-top: 10px;\n}\n\n.m-t-15 {\n  margin-top: 15px;\n}\n\n.m-t-20 {\n  margin-top: 20px;\n}\n\n.m-t-30 {\n  margin-top: 30px;\n}\n\n.m-t-40 {\n  margin-top: 40px;\n}\n\n.m-t-50 {\n  margin-top: 50px;\n}\n\n.p-15 {\n  padding: 15px;\n}\n\n.p-20 {\n  padding: 20px;\n}\n\n.p-25 {\n  padding: 25px;\n}\n\n.p-30 {\n  padding: 30px;\n}\n\n.primary-color {\n  color: #1A73E8;\n}\n\n.primary-bg {\n  background: #1A73E8;\n}\n\n.btn-primary img {\n  margin-right: 5px;\n}\n\n.sec-sub-head {\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 18px;\n  letter-spacing: -0.02em;\n}\n\n.right-border {\n  border-right: 1px solid #d9d9d9;\n}\n\n.left-border {\n  border-left: 1px solid #d9d9d9;\n}\n\n.top-border {\n  border-top: 1px solid #d9d9d9;\n}\n\n.bottom-border {\n  border-bottom: 1px solid #d9d9d9;\n}\n\n.m-b-25 {\n  margin-bottom: 25px;\n}\n\n.whitebox {\n  background: #ffffff;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.09);\n  border-radius: 15px;\n}\n\n.padding-box {\n  padding: 15px;\n}\n\nbody .btn-check:focus + .btn, body .btn:focus {\n  outline: 0;\n  box-shadow: none;\n}\n\nbody .btn:hover {\n  opacity: 0.8;\n}\n\n.text-left {\n  text-align: left;\n}\n\n.loader-middle-align {\n  display: flex;\n  min-height: 20vh;\n  align-items: center;\n  justify-content: center;\n}\n\n.common-modal.header-no-text .modal-header {\n  padding: 0 0 7px;\n  border: none;\n  padding: 0;\n}\n\n.results-tab-wrap .tab-content-wrap {\n  min-height: calc(100vh - 120px);\n}\n\n.scrollarea-content {\n  padding-right: 10px;\n}\n\nbody .tooltip > div.tooltip-inner {\n  background-color: #d2d5db !important;\n  color: #333;\n}\n\n.bs-tooltip-bottom .tooltip-arrow::before {\n  border-bottom-color: #d2d5db !important;\n}\n\nbody .bs-tooltip-top .tooltip-arrow::before {\n  border-top-color: #d2d5db !important;\n}\n\nbody .tippy-box {\n  font-size: 12px;\n}\n\n.no-fixed-height {\n  height: auto;\n}\n\n.p-10 {\n  padding: 10px;\n}\n\n.column-title-link[href]:hover, .column-title:hover {\n  color: #1A73E8 !important;\n}\n\n.file-uploaded-text {\n  word-break: break-all;\n}\n\n.full-width-container {\n  max-width: 100% !important;\n  padding: 0 15px;\n}\n\n@media (max-width: 767px) {\n  .container {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n  .tooltip-arrow {\n    display: none !important;\n  }\n  .bs-tooltip-top {\n    display: none !important;\n  }\n}\n.page-main-wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  overflow: hidden;\n}\n\n.page-contents {\n  flex: 1;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.auth-page-wrap .container {\n  max-width: 1140px;\n}\n\n.auth-left {\n  width: 584px;\n  background-color: #1a73e8;\n  height: 612px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-direction: column;\n  padding-bottom: 76px;\n  position: relative;\n  border-radius: 15px 0 0 15px;\n}\n\n.auth-page-wrap {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  background: #f3f5f7;\n  padding: 38px;\n}\n\n.auth-container {\n  background: #fff;\n  border-radius: 15px;\n}\n\n.auth-right {\n  flex: 1;\n  padding: 50px 62px;\n}\n\n.sec-title {\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 26px;\n}\n\n.forgot-pwd-link a {\n  color: #000000;\n  font-weight: 600;\n  text-decoration: none;\n}\n\na.btn-primary {\n  text-decoration: none;\n}\n\n.auth-logo-wrap {\n  position: absolute;\n  left: 45px;\n  top: 45px;\n}\n\n.already-have-link {\n  font-size: 12px;\n}\n\n.already-have-link a {\n  font-weight: 700;\n  text-decoration: none;\n  font-size: 13px;\n}\n\n.auth-logo-wrap img, .signup-logo-wrap img {\n  max-height: 30px;\n}\n\n@media (max-width: 1200px) {\n  .auth-left {\n    width: 50%;\n  }\n}\n@media (max-width: 991px) {\n  .auth-left {\n    height: 500px;\n  }\n  .auth-right {\n    padding: 20px;\n  }\n  .auth-signin-img {\n    text-align: center;\n  }\n  .auth-signin-img img {\n    max-width: 80%;\n  }\n  .auth-page-wrap {\n    display: flex;\n    align-items: center;\n  }\n  .auth-container {\n    flex-wrap: wrap;\n    border-radius: 20px;\n  }\n  .auth-right {\n    width: 100%;\n    flex: auto;\n    padding: 20px;\n  }\n  .auth-signin-img {\n    display: none;\n  }\n  .auth-left {\n    width: 100%;\n    border-radius: 20px 20px 0 0;\n    background-image: none !important;\n    background-color: #1A73E8;\n    height: 60px;\n    padding: 0;\n  }\n  .auth-logo-wrap {\n    top: 15px;\n    right: 45px;\n    text-align: center;\n  }\n  .auth-logo-wrap img {\n    max-height: 30px;\n  }\n  .auth-page-wrap {\n    padding: 20px 10px;\n  }\n  .sec-title {\n    font-size: 20px;\n    margin-bottom: 20px;\n  }\n}\n.auth-signup-left {\n  width: 358px;\n  background: #1A73E8;\n  padding: 48px 40px;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.auth-signup-left .btn-outline-primary.upload-btn {\n  color: white;\n}\n\n.auth-signup-right {\n  flex: 1;\n  padding: 48px 62px;\n}\n\n.auth-signup-right .form-input-wrap {\n  margin-bottom: 25px;\n}\n\n.signup-page-wrap {\n  position: inherit;\n}\n\n.btn-outline-primary.upload-btn {\n  font-weight: 500;\n  font-size: 12px;\n  border: 2px solid #f3f5f7;\n  border-radius: 3px;\n  padding: 0 15px;\n  height: 39px;\n}\n\n.btn-outline-primary.upload-btn img {\n  margin-right: 8px;\n}\n\n.or-text {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-top: 24px;\n  padding: 15px 10px 0;\n}\n\nlabel.btn.upload-btn {\n  line-height: 34px;\n}\n\n.box {\n  display: inline-block;\n  padding: 10px;\n  box-sizing: border-box;\n}\n\n.img-preview {\n  overflow: hidden;\n}\n\nbutton.btn.btn-white-outline.m-t-20 {\n  border: 2px solid #e3e3e3;\n  font-size: 13px;\n  color: #fff;\n  padding: 0 17px;\n  line-height: 35px;\n}\n\n.profile-img {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n  margin-top: 97px;\n}\n\n#fileUpload::-webkit-file-upload-button {\n  display: none;\n}\n\n.upload-file-input {\n  position: absolute;\n  bottom: 6px;\n  color: #1A73E8;\n  font-size: 11px;\n}\n\n.btn-outline-primary.upload-btn:hover {\n  border: 2px solid #cbcbcb;\n  background: #f3f5f7;\n  color: #1A73E8;\n}\n\n.croped-img-wrap img {\n  width: 140px !important;\n  height: 140px;\n  border-radius: 50%;\n  min-width: 140px;\n  max-height: 140px;\n  padding: 2px;\n  margin-top: 20px;\n}\n\n.image-crop-area {\n  min-height: 200px;\n}\n\n.success-content-wrap h3 {\n  font-size: 18px;\n  font-weight: 600;\n  margin-top: 18px;\n  margin-bottom: 25px;\n}\n\n.eye-show,\n.eye-hidden {\n  position: absolute;\n  right: 13px;\n  top: 35px;\n  cursor: pointer;\n}\n\n.eye-show img,\n.eye-hidden img {\n  max-width: 20px;\n}\n\n.eye-hidden img {\n  opacity: 0.6;\n}\n\n.eye-icon-inputwrap .form-control.input-item {\n  padding-right: 40px;\n}\n\n.agree-checkbox-wrap a {\n  text-decoration: none;\n}\n\n.agree-checkbox-wrap .form-check-input {\n  margin-top: 0;\n  width: 18px;\n  height: 18px;\n}\n\n.agree-checkbox-wrap .form-check-label {\n  margin-left: 8px;\n}\n\nspan.supported-file-text {\n  display: block;\n  position: absolute;\n  /* bottom: 0; */\n  font-size: 12px;\n  color: #555;\n}\n\n.infoicon svg {\n  width: 16px;\n  margin-left: 8px;\n  position: relative;\n  top: -1px;\n}\n\n.infoicon {\n  display: inline-block;\n}\n\n.infoicon svg path {\n  fill: #1A73E8;\n}\n\n.file-uploaded-text:empty {\n  display: none;\n}\n\n.file-uploaded-text {\n  font-size: 11px;\n  color: green;\n  font-weight: 500;\n  margin: 0;\n  position: relative;\n  top: -11px;\n}\n\n.resume-remove-icon svg {\n  margin-right: 0;\n  width: 10px;\n}\n\n.resume-remove-icon {\n  display: inline-block;\n  width: 18px;\n  line-height: 14px;\n  border-radius: 50%;\n  text-align: center;\n  height: 18px;\n  z-index: 100;\n  cursor: pointer;\n}\n\n.resume-remove-icon:hover {\n  opacity: 0.7;\n}\n\n@media (max-width: 991px) {\n  .auth-signup-left {\n    width: 100%;\n    border-radius: 20px 20px 0 0;\n    padding: 20px;\n  }\n  .auth-signup-left .signup-logo-wrap {\n    text-align: center;\n  }\n  .auth-signup-right {\n    padding: 20px 20px;\n  }\n  .profile-img {\n    margin-top: 67px;\n  }\n}\n@media (max-width: 767px) {\n  .auth-signup-right .form-input-wrap {\n    flex-wrap: wrap;\n  }\n  .or-text {\n    width: auto;\n    padding: 0;\n    font-weight: bold;\n    text-align: left;\n    height: 20px;\n    margin-top: 38px;\n    margin-left: 10px;\n  }\n  .file-upload-container .form-input-wrap {\n    flex-wrap: wrap;\n  }\n  .Linkedinurl {\n    width: 100%;\n    margin-top: 15px;\n  }\n  .file-uploaded-text {\n    position: absolute;\n    top: 68px;\n    overflow: hidden;\n    max-width: 80%;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n}\n.common-modal .modal-content {\n  border: none;\n  border-radius: 15px;\n  outline: 0;\n  box-shadow: 0px 50px 50px rgba(0, 0, 0, 0.04);\n}\n\n.common-modal .modal-sm.modal-dialog {\n  max-width: 390px;\n}\n\n.common-modal .modal-dialog .modal-content {\n  padding: 25px;\n}\n\n.modal.side-popup {\n  left: inherit;\n  width: auto;\n  right: 0;\n}\n\n.side-popup .modal-dialog.modal-md {\n  width: 540px;\n  max-width: inherit;\n  margin-top: 20px;\n}\n\n.side-popup .modal-dialog.modal-lg {\n  width: 720px;\n  max-width: inherit;\n}\n\n.side-popup .modal-dialog .modal-content {\n  min-height: calc(100vh - 50px);\n}\n\n.side-popup .modal-header {\n  border-bottom: 1px solid #cccdce;\n  font-size: 14px;\n  padding: 14px 7px 14px;\n  justify-content: space-between;\n}\n\n.side-popup .modal-header .modal-title {\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 22px;\n  text-transform: capitalize;\n}\n\n.side-popup .modal-header .btn-close {\n  padding: 0;\n  opacity: 1;\n  margin: 0;\n}\n\n.common-modal .btn-close {\n  opacity: 1;\n}\n\n.common-modal .modal-body {\n  padding: 0;\n}\n\n.common-modal .modal-header {\n  padding: 0 0 7px;\n}\n\n.common-modal.cropModal .modal-header {\n  border: none;\n}\n\n.common-modal .modal-title {\n  font-weight: 600;\n  font-size: 18px;\n}\n\n.reload-popup.common-modal .modal-sm.modal-dialog {\n  max-width: 480px;\n}\n\n.reload-popup .upgrade-pop-wrap .upgrade-title {\n  max-width: 420px;\n}\n\n.reload-popup .upgrade-pop-wrap.no-results .upgrade-title {\n  font-size: 18px;\n  line-height: 30px;\n  margin-bottom: 20px;\n}\n\n.reload-popup.common-modal .modal-header {\n  border: none;\n  position: absolute;\n  right: 10px;\n  top: 10px;\n}\n\n.country-modal-inotext img {\n  max-width: 16px;\n}\n\n.country-modal-inotext {\n  margin-left: 10px;\n}\n\n.country-pop-with-toolitip .modal-header {\n  position: absolute;\n  top: 31px;\n  right: 25px;\n  z-index: 1000;\n  border: none;\n}\n\n.country-pop-with-toolitip.common-modal .modal-title {\n  border-bottom: 1px solid #cccdce;\n  padding-bottom: 7px;\n  line-height: 22px;\n}\n\n@media (max-width: 767px) {\n  .side-popup .modal-dialog.modal-md {\n    width: auto;\n    max-width: 100%;\n    margin-top: 20px;\n  }\n  .modal.side-popup {\n    width: 100%;\n  }\n  .common-modal .modal-sm.modal-dialog {\n    max-width: 100%;\n  }\n}\n.react-select-2-option__option {\n  display: flex !important;\n  align-items: center;\n  border-bottom: 1px solid #d4d7da;\n  background: none !important;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.react-select-2-option__menu-list div:last-child .react-select-2-option__option {\n  border: none;\n}\n\n.react-select-2-option__option label {\n  margin-left: 10px;\n}\n\n.react-select-2-option__option--is-selected label,\n.react-select-2-option__option:hover label {\n  color: #1A73E8;\n}\n\n.header-wrap {\n  background: #1A73E8;\n  position: relative;\n  z-index: 1000;\n}\n\n.header-bar {\n  padding: 0;\n}\n\n.header-bar__inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 64px;\n  gap: 16px;\n}\n\n.header-bar__logo {\n  margin: 0;\n  flex-shrink: 0;\n}\n.header-bar__logo img {\n  display: block;\n  max-height: 28px;\n  filter: brightness(0) invert(1);\n}\n\n.header-bar__menu {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  justify-content: flex-end;\n}\n\n.header-bar__links {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-wrap: nowrap;\n}\n\n.header-bar__link {\n  position: relative;\n  color: rgba(255, 255, 255, 0.88);\n  background: transparent;\n  border: none;\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 15px;\n  font-weight: 500;\n  text-decoration: none;\n  padding: 10px 12px;\n  margin: 0;\n  cursor: pointer;\n  transition: color 0.15s ease;\n}\n.header-bar__link:hover {\n  color: #FFFFFF;\n}\n.header-bar__link.is-active, .header-bar__link.active {\n  color: #FFFFFF;\n  font-weight: 600;\n  text-shadow: none;\n}\n.header-bar__link.is-active::after, .header-bar__link.active::after {\n  content: \"\";\n  position: absolute;\n  left: 12px;\n  right: 12px;\n  bottom: 6px;\n  height: 2px;\n  background: #FFFFFF;\n  border-radius: 2px;\n}\n\n.header-bar__divider {\n  display: inline-block;\n  width: 1px;\n  height: 24px;\n  background: rgba(255, 255, 255, 0.35);\n  margin: 0 4px;\n  flex-shrink: 0;\n}\n\n.header-bar__notif.notification-dropdown.dropdown {\n  margin-right: 0;\n}\n\n.header-bar__notif .notification-button {\n  background: transparent !important;\n  border: none !important;\n  padding: 6px !important;\n  box-shadow: none !important;\n  color: #FFFFFF !important;\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 0 !important;\n  width: auto !important;\n  height: auto !important;\n}\n.header-bar__notif .notification-button::after {\n  display: none;\n}\n.header-bar__notif .notification-button svg {\n  stroke: #FFFFFF;\n}\n.header-bar__notif .noti-count {\n  position: absolute;\n  top: 0;\n  right: 0;\n  background: #E11D48;\n  color: #FFFFFF;\n  font-size: 10px;\n  font-weight: 600;\n  min-width: 16px;\n  height: 16px;\n  line-height: 16px;\n  text-align: center;\n  border-radius: 10px;\n  padding: 0 4px;\n}\n\n.header-bar__avatar {\n  margin-left: 0;\n}\n.header-bar__avatar .avatar-toggle {\n  background: transparent !important;\n  border: none !important;\n  padding: 0 !important;\n  box-shadow: none !important;\n  min-width: 0 !important;\n  width: auto !important;\n  height: auto !important;\n  line-height: 1 !important;\n}\n.header-bar__avatar .avatar-toggle::after {\n  display: none;\n}\n.header-bar__avatar .avatar-toggle .user-img {\n  display: inline-block;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  overflow: hidden;\n  border: 2px solid rgba(255, 255, 255, 0.6);\n  margin: 0;\n}\n.header-bar__avatar .avatar-toggle .user-img img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.header-bar__links .dropdown-menu,\n.header-bar__avatar .dropdown-menu,\n.header-bar__notif .dropdown-menu {\n  border: none;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  border-radius: 10px;\n  padding: 8px;\n  margin-top: 8px !important;\n}\n\n.header-bar__links .dropdown-item,\n.header-bar__avatar .dropdown-item {\n  font-size: 13px;\n  line-height: 1.6;\n  padding: 8px 12px;\n  border-radius: 6px;\n  color: #1A1A1A;\n}\n.header-bar__links .dropdown-item:hover, .header-bar__links .dropdown-item:focus,\n.header-bar__avatar .dropdown-item:hover,\n.header-bar__avatar .dropdown-item:focus {\n  color: #1A73E8;\n  background: #EEF4FF;\n}\n\n.header-bar__mobile-actions {\n  display: none;\n  align-items: center;\n  gap: 8px;\n}\n\n@media (max-width: 1199.98px) {\n  .header-bar__link {\n    padding: 10px 10px;\n    font-size: 14px;\n  }\n  .header-bar__inner {\n    min-height: 64px;\n  }\n  .header-bar__logo img {\n    max-height: 26px;\n  }\n  .header-bar__link.is-active::after,\n  .header-bar__link.active::after {\n    left: 10px;\n    right: 10px;\n  }\n}\n@media (min-width: 1025px) {\n  .header-bar__links {\n    gap: 10px;\n  }\n}\n@media (max-width: 991.98px) and (min-width: 768px) {\n  .header-bar__inner {\n    gap: 8px;\n  }\n  .header-bar__links {\n    gap: 2px;\n  }\n  .header-bar__link {\n    padding: 8px 8px;\n    font-size: 13px;\n    white-space: nowrap;\n  }\n  .header-bar__link.is-active::after,\n  .header-bar__link.active::after {\n    left: 8px;\n    right: 8px;\n  }\n  .header-bar__divider {\n    height: 20px;\n    margin: 0 2px;\n  }\n  .header-bar__notif .notification-button {\n    padding: 4px !important;\n  }\n  .header-bar__avatar .avatar-toggle .user-img {\n    width: 32px;\n    height: 32px;\n  }\n  .header-bar__logo img {\n    max-height: 22px;\n  }\n}\n@media (min-width: 768px) {\n  .header-bar__mobile-actions {\n    display: none !important;\n  }\n  .mobile-menu, .notification-mobile-only {\n    display: none !important;\n  }\n}\n@media (max-width: 767.98px) {\n  .header-bar__inner {\n    min-height: 56px;\n  }\n  .header-bar__logo img {\n    max-height: 24px;\n  }\n  .header-bar__menu {\n    flex: 0 0 auto;\n  }\n  .mobilemenu-hidden {\n    display: none;\n  }\n  .mobilemenu-active {\n    position: absolute;\n    top: 56px;\n    left: 0;\n    right: 0;\n    width: 100%;\n    background: #1A73E8;\n    z-index: 99;\n    border-top: 1px solid rgba(255, 255, 255, 0.18);\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);\n    display: block;\n    justify-content: flex-start;\n    padding: 6px 0;\n  }\n  .mobilemenu-active .header-bar__links {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    width: 100%;\n    padding: 6px 0;\n    gap: 0;\n  }\n  .mobilemenu-active .header-bar__link {\n    width: 100%;\n    padding: 14px 20px;\n    color: #FFFFFF;\n    font-size: 15px;\n    text-align: left;\n    border-radius: 0;\n  }\n  .mobilemenu-active .header-bar__link.is-active::after {\n    display: none;\n  }\n  .mobilemenu-active .header-bar__link.is-active {\n    background: rgba(255, 255, 255, 0.14);\n    font-weight: 600;\n  }\n  .mobilemenu-active .header-bar__link:hover {\n    background: rgba(255, 255, 255, 0.08);\n  }\n  .mobilemenu-active .header-bar__divider {\n    display: block;\n    width: auto;\n    height: 1px;\n    margin: 6px 20px;\n    background: rgba(255, 255, 255, 0.22);\n  }\n  .mobilemenu-active .header-bar__notif,\n  .mobilemenu-active .header-bar__avatar {\n    display: none;\n  }\n  .header-bar__mobile-actions {\n    display: flex;\n  }\n  .header-bar__mobile-actions .notification-button {\n    background: transparent !important;\n    border: none !important;\n    padding: 0 6px !important;\n    box-shadow: none !important;\n  }\n  .header-bar__mobile-actions .notification-button::after {\n    display: none;\n  }\n  .header-bar__mobile-actions .notification-button svg {\n    stroke: #FFFFFF;\n  }\n  .header-bar__mobile-actions .mobile-menu {\n    background: transparent;\n    border: none;\n    padding: 4px;\n    color: #FFFFFF;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .header-bar__mobile-actions .mobile-menu img {\n    max-height: 22px;\n    filter: brightness(0) invert(1);\n  }\n}\n@media (min-width: 768px) {\n  .header-bar__mobile-profile-link {\n    display: none !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .header-bar__divider--mobile-only {\n    display: none !important;\n  }\n}\n\n.header-bar__mobile-logout {\n  color: rgba(255, 200, 200, 0.9) !important;\n}\n.header-bar__mobile-logout:hover {\n  color: #fff !important;\n}\n\n.footer-content {\n  border-top: 1px solid #e3e3e3;\n  padding: 30px;\n  margin: 0;\n}\n\n.footer-content p {\n  font-size: 11px;\n  line-height: 18px;\n  color: #5b5b5b;\n}\n\n.nav-tabs .nav-link {\n  font-size: 18px;\n  background: transparent;\n  color: #fff;\n  font-weight: 500;\n  padding: 5px 15px;\n  margin-bottom: 10px;\n  border: none;\n}\n\n.nav-tabs .nav-link.active {\n  color: #fff;\n  background-color: transparent;\n  border: none;\n  position: relative;\n  font-weight: 700;\n}\n\n.nav-tabs .nav-link.active::after {\n  position: absolute;\n  left: 0;\n  right: 0;\n  background: #fff;\n  height: 4px;\n  content: \"\";\n  bottom: 0;\n  border-radius: 20px;\n}\n\n.nav-tabs {\n  border: none;\n}\n\n.nav-tabs .nav-link:hover,\n.nav-tabs .nav-link:focus {\n  border: none;\n}\n\n.results-tab-wrap .nav-tabs .nav-link {\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 18px;\n  letter-spacing: -0.02em;\n  color: #000000;\n}\n\n.results-tab-wrap .nav-tabs {\n  justify-content: space-between;\n  margin: 0 -15px;\n  position: relative;\n  background: #fff;\n  z-index: 99;\n  padding-top: 15px;\n}\n\n.results-tab-wrap .nav-tabs::after {\n  position: absolute;\n  bottom: 0;\n  height: 2px;\n  background: #D7E0E9;\n  content: \"\";\n  left: 15px;\n  right: 15px;\n}\n\n.results-tab-wrap .tab-content {\n  padding-top: 25px;\n}\n\n.results-tab-wrap .nav-tabs .nav-link {\n  position: relative;\n  z-index: 100;\n}\n\n.results-tab-wrap .nav-tabs .nav-link.active {\n  color: #1A73E8;\n}\n\n.results-tab-wrap .nav-tabs .nav-link.active::after {\n  position: absolute;\n  bottom: -10px;\n  height: 2px;\n  background: #1A73E8;\n  content: \"\";\n  left: 15px;\n  right: 15px;\n  z-index: 1;\n}\n\n#FixedTab.sticky .nav-tabs {\n  position: sticky;\n  top: 0px;\n}\n\n.nav-tabs .nav-link:focus {\n  outline: none;\n}\n\n.faq-tab-wrap .nav-tabs .nav-link {\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 18px;\n  letter-spacing: -0.02em;\n  color: #000000;\n}\n\n.faq-tab-wrap .nav-tabs {\n  margin: 0 -15px;\n  position: relative;\n  background: #fff;\n  z-index: 99;\n  padding-top: 15px;\n}\n\n.faq-tab-wrap .nav-tabs::after {\n  position: absolute;\n  bottom: 0;\n  height: 2px;\n  background: #D7E0E9;\n  content: \"\";\n  left: 15px;\n  right: 15px;\n}\n\n.faq-tab-wrap .tab-content {\n  padding-top: 25px;\n}\n\n.faq-tab-wrap .nav-tabs .nav-link {\n  position: relative;\n  z-index: 100;\n}\n\n.faq-tab-wrap .nav-tabs .nav-link.active {\n  color: #1A73E8;\n}\n\n.faq-tab-wrap .nav-tabs .nav-link.active::after {\n  position: absolute;\n  bottom: -10px;\n  height: 2px;\n  background: #1A73E8;\n  content: \"\";\n  left: 15px;\n  right: 15px;\n  z-index: 1;\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n  .nav-tabs .nav-link {\n    padding: 5px 11px;\n  }\n}\n@media (max-width: 767px) {\n  .nav-tabs .nav-link {\n    font-size: 16px;\n  }\n  .result-content-area .results-tab-wrap .nav-tabs .nav-link.active::after {\n    left: 10px;\n    right: 10px;\n  }\n  .result-content-area .nav-tabs .nav-link {\n    font-size: 16px;\n    padding: 5px 10px;\n  }\n}\n.datatable-wrap .rdt_TableRow {\n  min-height: 60px;\n  border-color: #e9e9e9;\n}\n\n.checkbox-table.datatable-wrap .rdt_TableRow .rdt_TableCell:first-child,\n.checkbox-table.datatable-wrap .rdt_TableHeadRow .rdt_TableCol:first-child {\n  min-width: 30px;\n  flex: 0 0 30px;\n  position: relative;\n}\n\n.datatable-wrap .rdt_TableHeadRow {\n  background: #e6e9ec;\n  font-weight: 600;\n  font-size: 15px;\n  border: none;\n}\n\n.datatable-wrap .rdt_TableCell {\n  font-size: 13px;\n  color: #000;\n  flex-wrap: wrap;\n}\n\n.share-icon-cell img {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.datatable-wrap .rdt_TableCell a {\n  text-decoration: none;\n  color: #1A73E8;\n}\n\n.datatable-hedaer-right {\n  flex: 1;\n}\n\n.table-buttons-wrap {\n  padding-right: 150px;\n}\n\n.search-svg-wrap {\n  position: absolute;\n  left: 10px;\n  top: 9px;\n  pointer-events: none;\n}\n\n.search-input-wrap .input-item {\n  padding-left: 30px;\n}\n\n.checkbox-table.datatable-wrap .rdt_TableHeadRow .rdt_TableCol:first-child input[type=checkbox] {\n  width: 16px !important;\n  height: 16px !important;\n  margin-left: 3px;\n}\n\n.checkbox-table.datatable-wrap .rdt_TableRow .rdt_TableCell:first-child input[type=checkbox]::after {\n  width: 18px;\n  height: 18px;\n  content: \"\";\n  position: absolute;\n  top: -3px;\n  left: -1px;\n  border: 2px solid #cccdce;\n  pointer-events: none;\n  background: #fff;\n}\n\n.checkbox-table.datatable-wrap .rdt_TableRow .rdt_TableCell:first-child input[type=checkbox],\n.checkbox-table.datatable-wrap .rdt_TableHeadRow .rdt_TableCol:first-child input[type=checkbox] {\n  position: relative;\n}\n\n.checkbox-table.datatable-wrap .rdt_TableRow .rdt_TableCell:first-child input[type=checkbox]:checked:before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  top: -3px;\n  left: -1px;\n  background-color: #1A73E8;\n  border-radius: 1px;\n}\n\n.checkbox-table.datatable-wrap .rdt_TableRow .rdt_TableCell:first-child input[type=checkbox]:checked:after {\n  content: \"\";\n  display: block;\n  width: 7px;\n  height: 11px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n  position: absolute;\n  top: -1px;\n  left: 5px;\n  background: transparent;\n}\n\n.selectall-wrap {\n  display: none;\n}\n\n@media (max-width: 992px) {\n  .table-buttons-wrap {\n    padding-right: 30px;\n  }\n}\n@media (max-width: 767px) {\n  .datatable-header-area {\n    flex-wrap: wrap;\n  }\n  .datatable-hedaer-right {\n    width: 100%;\n    flex: auto;\n  }\n  .table-buttons-wrap {\n    margin-left: 0;\n    padding-right: 0px;\n  }\n  .datatable-hedaer-left {\n    margin-bottom: 15px;\n    justify-content: flex-end;\n    width: 100%;\n  }\n  .results-tab-wrap .tab-content {\n    padding-top: 15px;\n  }\n  .checkbox-table.datatable-wrap .rdt_TableRow .rdt_TableCell:first-child input[type=checkbox]::after {\n    top: -2px;\n  }\n  .checkbox-table.datatable-wrap .rdt_TableRow .rdt_TableCell:first-child input[type=checkbox]:checked:before {\n    top: -2px;\n  }\n}\n.datatable-wrap .rdt_Checkbox {\n  display: contents;\n}\n\n.datatable-wrap .rdt_Checkbox::before,\n.datatable-wrap .rdt_Checkbox::after {\n  content: none;\n}\n\n.datatable-wrap .rdt_Checkbox > input[type=checkbox] {\n  position: relative;\n  inset: auto;\n  width: auto;\n  height: auto;\n  opacity: 1;\n}\n\n.custom-pagination .page-item.active .page-link {\n  background-color: #1A73E8;\n  border: none;\n  color: #fff;\n}\n\n.custom-pagination .page-item .page-link {\n  border: none;\n}\n\n.custom-pagination .paginationStyle {\n  border: none;\n}\n\n.custom-pagination.pagination-sm .page-link {\n  padding: 0;\n  font-size: 13px;\n  line-height: 24px;\n  width: 24px;\n  height: 24px;\n  text-align: center;\n  border-radius: 4px;\n  background-color: transparent;\n  color: #000;\n}\n\n.pagination-sm .page-item:first-child .page-link {\n  background-color: #e9e9e9;\n  font-size: 20px;\n}\n\n.pagination-sm .page-item:last-child .page-link {\n  background-color: #e9e9e9;\n  font-size: 20px;\n}\n\n.pagination-sm .page-item:first-child .page-link span,\n.pagination-sm .page-item:last-child .page-link span {\n  position: relative;\n  top: -1px;\n}\n\n.custom-pagination li.page-item {\n  padding: 0 10px;\n}\n\n.custom-pagination {\n  margin: 30px -10px 0;\n}\n\n.custom-pagination li.page-item.disabled .page-link,\n.custom-pagination .paginationStyle .page-link {\n  font-size: 22px;\n  line-height: 22px;\n  font-weight: bold;\n}\n\n.custom-pagination li.page-item.disabled .page-link {\n  color: #9c9494;\n}\n\n.custom-pagination .page-link:focus {\n  box-shadow: none;\n}\n\n.react-new-pagination .page-item .page-link {\n  border: none;\n  font-weight: 500;\n  color: #878a8d;\n  font-size: 14px;\n  height: 32px;\n  padding: 0 10px;\n  line-height: 30px;\n  min-width: 30px;\n  text-align: center;\n}\n\n.react-new-pagination li.page-item {\n  padding: 0 6px;\n}\n\n.react-new-pagination .page-item.active .page-link {\n  background-color: #1A73E8;\n  border: none;\n  color: #fff !important;\n  border-radius: 4px;\n}\n\n.react-new-pagination .page-item.page-item-arrow .page-link {\n  font-size: 22px;\n  line-height: 30px;\n  padding-top: 0;\n  padding-bottom: 0;\n  background: #f0f0f0;\n  border-radius: 4px !important;\n  height: 32px;\n  width: 32px;\n  padding: 0;\n  text-align: center;\n  color: #333;\n}\n\n.react-new-pagination .page-item.page-item-arrow.disabled .page-link {\n  color: #999;\n}\n\n.react-new-pagination .page-link:hover {\n  border-radius: 4px;\n}\n\n.react-new-pagination .page-item:not(:first-child) .page-link {\n  margin-left: 0;\n}\n\n.page-link:focus {\n  box-shadow: none;\n  opacity: 0.8;\n}\n\n@media (max-width: 767px) {\n  .custom-pagination li.page-item {\n    padding: 0 3px;\n  }\n}\n.shared-name-wrap {\n  flex-wrap: wrap;\n}\n\n.shared-name-box {\n  border-bottom: 1px solid #ddd;\n  width: 100%;\n  margin-bottom: 12px;\n  padding-bottom: 10px;\n  padding-right: 20px;\n}\n\n.shared-name-box:last-child {\n  margin: 0;\n  border: none;\n}\n\n.manage-access-popup .country-header-search {\n  margin: 0;\n  margin-bottom: 20px;\n}\n\n.share-title {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 17px;\n  letter-spacing: -0.02em;\n  color: #5b5b5b;\n}\n\n.b-t-0 {\n  border-top: none !important;\n}\n\n.shared-remove-btn {\n  display: flex;\n  align-items: center;\n}\n\n.shared-remove-btn span {\n  margin-left: 5px;\n  color: #5b5b5b;\n}\n\n.status-searchontop .pop-checkboxscroll {\n  height: 58vh;\n}\n\n.status-searchontop .react-select-2-option__menu-list {\n  max-height: 162px;\n}\n\n.status-searchontop .react-select-2-option__option {\n  padding-top: 6px;\n  padding-bottom: 6px;\n}\n\n.status-searchontop .react-select-2-option__menu {\n  margin-top: 2px;\n}\n\n@media (max-width: 767px) {\n  .shared-remove-btn span {\n    display: none;\n  }\n  .shared-name-box {\n    padding-right: 0;\n  }\n}\n.scrollarea > .ps > .ps__rail-y {\n  width: 4px;\n  right: 0;\n  background: none;\n  opacity: 0.1;\n}\n\n.scrollarea:hover > .ps > .ps__rail-y {\n  opacity: 0.3;\n}\n\n.scrollarea > .ps > .ps__rail-y:hover,\n.scrollarea > .ps > .ps__rail-y.ps--clicking {\n  background: gray;\n  opacity: 0.6;\n}\n\n.scrollarea > .ps > .ps__rail-y > .ps__thumb-y,\n.scrollarea > .ps > .ps__rail-y:hover > .ps__thumb-y,\n.scrollarea > .ps > .ps__rail-y.ps--clicking > .ps__thumb-y {\n  width: 4px;\n  right: 0;\n  background: #000;\n  border-radius: 20px;\n}\n\n.pagenot-found .whitebox {\n  height: calc(100vh - 305px);\n  min-height: 450px;\n}\n\n.error-title {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 25px;\n  margin-bottom: 10px;\n}\n\n.errorpages-content p {\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 16px;\n  text-align: center;\n  color: #5b5b5b;\n}\n\n.positioned-backarrow {\n  position: absolute;\n  left: 30px;\n  top: 30px;\n}\n\n.link-expired p {\n  margin-left: auto;\n  margin-right: auto;\n  line-height: 24px;\n}\n\n.custom-accordian .accordion-item {\n  border: none;\n  border-bottom: 1px solid #d9d9d9;\n  padding: 25px 0;\n}\n\n.custom-accordian .accordion-button {\n  box-shadow: none;\n  background: transparent;\n  font-size: 16px;\n  padding: 0;\n}\n\n.custom-accordian .accordion-button:not(.collapsed) {\n  color: #1A73E8;\n  background: transparent;\n  padding: 0;\n  font-size: 16px;\n}\n\n.custom-accordian .custom-accordian-header {\n  display: flex;\n  align-items: flex-start;\n}\n\n.custom-accordian h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 22px;\n  margin: 0;\n}\n\n.faq-index {\n  margin-right: 0;\n  font-weight: bold;\n  min-width: 25px;\n}\n\n.custom-accordian .accordion-button:focus {\n  box-shadow: none;\n}\n\n.custom-accordian .accordion {\n  padding: 0 25px;\n}\n\n.custom-accordian .accordion-body {\n  padding: 0 25px;\n  margin-top: 15px;\n}\n\n.custom-accordian .accordion-button:not(.collapsed)::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23212529%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e\");\n}\n\n.custom-accordian .accordion-item:last-of-type {\n  border-radius: 0;\n}\n\n.filter-accordian-wrap .accordion-button:hover {\n  z-index: 0;\n}\n\n@media (max-width: 767px) {\n  .custom-accordian .accordion {\n    padding: 0;\n  }\n  .custom-accordian h4 {\n    font-size: 14px;\n    line-height: 20px;\n    padding-right: 5px;\n  }\n  .custom-accordian .accordion-item {\n    padding: 15px 0;\n  }\n}\n.loader {\n  position: relative;\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.loader-3 .dot {\n  width: 10px;\n  height: 10px;\n  background: #1A73E8;\n  border-radius: 50%;\n  position: absolute;\n  top: calc(50% - 5px);\n}\n\n.loader-3 .dot1 {\n  left: 0px;\n  -webkit-animation: dot-jump 0.5s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;\n  animation: dot-jump 0.5s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;\n}\n\n.loader-3 .dot2 {\n  left: 20px;\n  -webkit-animation: dot-jump 0.5s 0.2s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;\n  animation: dot-jump 0.5s 0.2s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;\n}\n\n.loader-3 .dot3 {\n  left: 40px;\n  -webkit-animation: dot-jump 0.5s 0.4s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;\n  animation: dot-jump 0.5s 0.4s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;\n}\n\n@-webkit-keyframes dot-jump {\n  0% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n  }\n  100% {\n    -webkit-transform: translateY(-15px);\n    transform: translateY(-15px);\n  }\n}\n@keyframes dot-jump {\n  0% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n  }\n  100% {\n    -webkit-transform: translateY(-15px);\n    transform: translateY(-15px);\n  }\n}\n.homeslider .slick-prev,\n.homeslider .slick-next {\n  background: #ffffff;\n  border: none;\n  box-shadow: 0 1px 4px #c1c1c1;\n  border-radius: 4px;\n  width: 29px;\n  height: 31px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  bottom: 0px;\n  top: inherit;\n  right: 15px;\n  transform: none;\n}\n\n.homeslider .slick-prev {\n  left: inherit;\n  right: 55px;\n}\n\n.homeslider .slick-prev::before,\n.homeslider .slick-next::before {\n  display: none;\n}\n\n.homeslider .slick-prev.slick-disabled,\n.homeslider .slick-next.slick-disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.homeslider {\n  padding-bottom: 40px;\n}\n\n.hom-secs .multimedia-wrap .homeslider .slick-prev {\n  right: 40px;\n}\n\n.hom-secs .multimedia-wrap .homeslider .slick-next {\n  right: 0px;\n}\n\n@media (max-width: 767px) {\n  .homeslider .slick-next {\n    right: 0;\n  }\n  .homeslider .slick-prev {\n    right: 40px;\n  }\n}\n.notification-dropdown .dropdown-menu {\n  width: 390px;\n  background-color: #fff;\n}\n\n.notification-dropdown .dropdown-menu.show.dropdown-menu-end {\n  padding: 10px 0 0;\n}\n\n.notification-wrap {\n  position: relative;\n}\n\n.notification-dropdown .dropdown-menu .notification-wrap::after {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-left: 15px solid transparent;\n  border-right: 15px solid transparent;\n  border-bottom: 15px solid #fff;\n  top: -24px;\n  right: 20px;\n  content: \"\";\n}\n\n.notification-dropdown .dropdown-menu {\n  transform: translate(30px, 61px) !important;\n}\n\n.notification-dropdown .dropdown-menu .notification-list {\n  padding: 0;\n}\n\n.notification-dropdown .dropdown-menu .dropdown-item {\n  list-style: none;\n  padding: 0 5px;\n}\n\n.notification-list .dropdown-item h3 {\n  font-size: 13px;\n  margin-bottom: 5px;\n  font-weight: 500;\n  color: #212529;\n}\n\n.notification-list h3 .notify-user-name {\n  font-weight: 600;\n}\n\n.notifi-img-left img {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 2px solid #fff;\n  box-shadow: 0 0 5px #aaa;\n}\n\n.notification-content-row {\n  padding: 15px;\n  border-bottom: 1px solid #ddd;\n}\n\n.notifi-content-right {\n  padding-left: 10px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.notification-time span {\n  color: #5b5b5b;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.notification-footer {\n  text-align: center;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 16px;\n  letter-spacing: -0.02em;\n  margin-bottom: 0;\n  padding-top: 10px;\n  box-shadow: 0px -4px 5px #f3f3f3;\n  padding-bottom: 10px;\n  cursor: pointer;\n}\n\n.notification-footer img {\n  margin-left: 5px;\n}\n\n.notification-scroll {\n  max-height: 60vh;\n  min-height: 30vh;\n}\n\n.notification-dropdown .dropdown-toggle::after {\n  display: none;\n}\n\n.notification-dropdown.dropdown {\n  margin-right: 20px;\n}\n\n.unread-notif {\n  background-color: #e9f2ff;\n}\n\n.read-notify {\n  background-color: #fff;\n}\n\n.no-item {\n  padding: 20px 10px;\n  text-align: center;\n  color: #777;\n  margin-top: -10px;\n}\n\n.noti-count {\n  background: #1A73E8;\n  padding: 2px;\n  top: 2px;\n  left: 11px;\n  position: absolute;\n  height: 18px;\n  line-height: 14px;\n  font-weight: bold;\n  color: #fff;\n  border-radius: 3px;\n  z-index: 9;\n  font-size: 12px;\n}\n\n.menu-items .dropdown .notification-btn .btn {\n  background-color: transparent;\n  color: #1A73E8;\n  padding: 0 10px;\n  height: 20px;\n  font-weight: 500;\n}\n\n.notification-dropdown .dropdown-menu ul .dropdown-item:last-child .notification-content-row {\n  border: none;\n}\n\n.notification-btn {\n  padding-right: 20px;\n  border-bottom: 1px solid #ddd;\n  padding-bottom: 10px;\n  text-align: right;\n}\n\n.notification-dropdown .dropdown-menu .dropdown-item:hover {\n  cursor: pointer;\n  background: #e2e8ef;\n}\n\n.view-less-arrow {\n  transform: rotate(180deg);\n  display: inline-block;\n  position: relative;\n  top: 2px;\n  left: 5px;\n}\n\n.notification-dropdown .dropdown-menu .notification-scroll .notification-list {\n  margin-right: -10px;\n}\n\n@media (max-width: 767px) {\n  .notification-dropdown .dropdown-menu {\n    width: 90%;\n    margin: 0 auto 15px;\n  }\n  .notification-dropdown.dropdown {\n    margin-right: 0;\n    border: none;\n    padding: 0;\n  }\n  .notification-dropdown .dropdown-menu {\n    margin: 0 auto;\n    transform: none !important;\n    border: 1px solid #ddd !important;\n  }\n  .notification-dropdown .btn {\n    margin-left: 25px;\n    position: relative;\n  }\n  .noti-count {\n    top: -10px;\n    left: 13px;\n    font-weight: 600;\n  }\n  .notification-mobile-only .notification-dropdown {\n    position: inherit;\n  }\n  .notification-dropdown .dropdown-menu {\n    width: 100%;\n    box-shadow: 0 0 10px #ddd;\n  }\n  .notification-dropdown .dropdown-menu.show.dropdown-menu-end {\n    top: 45px !important;\n  }\n  .notification-dropdown .dropdown-menu .notification-wrap::after {\n    right: 67px;\n  }\n  .notification-list .dropdown-item {\n    white-space: inherit;\n  }\n  .notification-mobile-only .notification-dropdown .notification-btn .btn {\n    color: #1A73E8;\n  }\n}\n.shimmer-card {\n  position: relative;\n  -webkit-box-shadow: 0 6px 8px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0px 8px rgba(0, 0, 0, 0.1);\n  background-color: #fff;\n  border-radius: 6px;\n  height: 240px;\n  overflow: hidden;\n  width: 100%;\n  margin-bottom: 15px;\n}\n.shimmer-card .shimmerBG {\n  animation-duration: 2.2s;\n  animation-fill-mode: forwards;\n  animation-iteration-count: infinite;\n  animation-name: shimmer;\n  animation-timing-function: linear;\n  background: #ddd;\n  background: linear-gradient(to right, #f2f2f2 8%, #fcfcfc 18%, #f2f2f2 33%);\n  background-size: 1200px 100%;\n}\n@-webkit-keyframes shimmer {\n  0% {\n    background-position: -100% 0;\n  }\n  100% {\n    background-position: 100% 0;\n  }\n}\n@keyframes shimmer {\n  0% {\n    background-position: -1200px 0;\n  }\n  100% {\n    background-position: 1200px 0;\n  }\n}\n.shimmer-card .media {\n  height: 200px;\n}\n.shimmer-card .p-32 {\n  padding: 32px;\n}\n.shimmer-card .title-line {\n  height: 24px;\n  width: 100%;\n  margin-bottom: 12px;\n  border-radius: 20px;\n}\n.shimmer-card .content-line {\n  height: 8px;\n  width: 100%;\n  margin-bottom: 16px;\n  border-radius: 8px;\n}\n.shimmer-card .end {\n  width: 40%;\n}\n\n.m-t-24 {\n  margin-top: 24px;\n}\n\n.no-other-reco {\n  font-size: 13px;\n  color: #727780;\n  padding: 0 15px;\n  display: block;\n  line-height: 34px;\n}\n\n.shimmer-card .big-title-line.title-line {\n  height: 34px;\n}\n\n.shimmerloadingtext .shimmerBG {\n  animation: none;\n}\n\n.shimmerloadingtext .shimmer-card .shimmerBG {\n  background: #e4e7ea;\n}\n\n.shimmerloadingtext .shimmer-card {\n  border-left: 1px solid #e4e7ea;\n  box-shadow: none;\n  border-radius: 0;\n  margin: 0;\n  height: auto;\n}\n\n.shimmerloadingtext .shimmer-card .p-32 {\n  padding: 0 0px 32px 20px;\n}\n\n.news-right-shimmer-box .shimmer-card {\n  height: 140px;\n  margin-bottom: 0;\n}\n\n.news-right-shimmer-box .shimmer-loading-box {\n  width: 100%;\n}\n\n.multimedia-shimmer-loading-box .shimmer-card .content-line {\n  margin-bottom: 25px;\n}\n\n.multimedia-shimmer-loading-box {\n  height: 100%;\n  padding-bottom: 40px;\n}\n\n.multimedia-shimmer-loading-box .shimmer-card {\n  height: 100%;\n}\n\n@media (min-width: 992px) and (max-width: 1200px) {\n  .shimmerloadingtext .shimmer-card .p-32 {\n    padding: 0 0px 32px 20px;\n  }\n}\n@media (max-width: 991px) {\n  .rec-shimmer-row .shimmer-col-3 {\n    display: none;\n  }\n  .no-other-reco {\n    font-size: 13px;\n  }\n  .shimmerloadingtext-2 {\n    display: none;\n  }\n  .shimmerloadingtext-single {\n    display: none;\n  }\n}\n@media (max-width: 767px) {\n  .rec-shimmer-row .shimmer-col-2 {\n    display: none;\n  }\n  .shimmerloadingtext {\n    display: none;\n  }\n}\n.home-content-area {\n  padding: 23px 0;\n}\n\n.home-content-area .sub-head-margin {\n  margin-bottom: 30px;\n}\n\n.view-similar-btn {\n  font-weight: 600;\n  font-size: 12px;\n  color: #333;\n  text-decoration: none;\n  border-radius: 30px;\n  border: 1px solid #d9d9d9;\n  width: 36px;\n  white-space: nowrap;\n  height: 36px;\n  overflow: hidden;\n  text-align: center;\n  align-items: center;\n  padding: 0 7px;\n  transition: width 0.5s;\n}\n\n.view-similar-btn:hover {\n  width: 120px;\n  transition: width 0.5s;\n}\n\n.view-similar-btn img {\n  width: 22px !important;\n}\n\n.view-similar-btn span {\n  margin-left: 6px;\n}\n\n.view-similar-btn span {\n  color: #333;\n  font-weight: 600;\n}\n\n.logo img {\n  max-height: 30px;\n}\n\n.home-content-area .slider-item .sourcebox p {\n  max-height: 60px;\n  overflow: hidden;\n}\n\n.home-desc-scroll {\n  max-height: 110px;\n}\n\n.upgrade-pop-wrap.no-results .upgrade-title {\n  font-size: 20px;\n  line-height: 24px;\n}\n\n.upgrade-pop-wrap.no-results .btn-sm {\n  min-width: 60px;\n}\n\n.homeslider .slick-track {\n  margin-left: 0;\n}\n\n.reco-date {\n  line-height: 20px;\n  font-weight: 500;\n  font-size: 12px;\n  color: #8a8b8c;\n  flex-shrink: 0;\n  padding-left: 15px;\n}\n\n@media (max-width: 767px) {\n  .view-similar-btn {\n    width: auto;\n  }\n  .home-content-area.result-content-area {\n    padding: 23px 0 40px;\n  }\n}\n.banner-wrap {\n  padding: 20px;\n  background: #f3f5f7;\n  border-radius: 3px;\n}\n\np.banner-info-text {\n  position: absolute;\n  bottom: 45px;\n  left: 35px;\n  margin: 0;\n  color: #555;\n  font-size: 12px;\n  font-style: italic;\n}\n\n.banner-content-box {\n  background: linear-gradient(180deg, #4991ef 0%, #1a73e8 100%);\n  box-shadow: 0px 10px 10px rgba(133, 175, 214, 0.45);\n  padding: 12px;\n  border-radius: 15px;\n  position: relative;\n}\n\n.banner-textarea-wrap textarea.form-control {\n  min-height: 100px;\n  border: none;\n  background: #f0f0f0;\n  font-size: 14px;\n  color: #5b5b5b;\n  padding: 10px 18px;\n  box-sizing: border-box;\n  max-height: 170px;\n  border-radius: 15px;\n}\n\n.banner-textarea-wrap .form-control::placeholder {\n  font-style: italic;\n  color: #8c8c8c;\n}\n\n.dragand-drop-style {\n  min-height: 99px;\n  background: #f3f5f7;\n  border: 2px dashed #d6d7d8;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 10px;\n  padding: 0;\n  text-align: center;\n  flex-direction: column;\n  padding-bottom: 10px;\n  padding-top: 10px;\n}\n\n.dragand-drop-style p {\n  margin-bottom: 0;\n  font-size: 13px;\n  color: #808080;\n  line-height: 22px;\n}\n\n.drop-upload-icon {\n  display: block;\n  margin-bottom: 7px;\n}\n\n.tab-content .banner-tab {\n  background: #fff;\n  padding: 10px;\n  border-radius: 15px;\n  padding-bottom: 60px;\n}\n\n.banner-btn-wrap .btn {\n  position: absolute;\n  bottom: 20px;\n  right: 20px;\n}\n\n.dragand-drop-style div:empty {\n  display: none !important;\n}\n\n.dragand-drop-style .filename-uploaded {\n  color: #1A73E8;\n  word-break: break-all;\n}\n\n.remove-uploaded-btn svg {\n  width: 10px;\n}\n\n.remove-uploaded-btn svg path {\n  fill: #fff;\n}\n\n.remove-uploaded-btn.btn {\n  padding: 0;\n  position: absolute;\n  right: 20px;\n  top: 7px;\n  z-index: 100;\n}\n\n.length-exceeded {\n  font-size: 10px;\n  color: red;\n}\n\n@media (max-width: 767px) {\n  .banner-wrap {\n    padding: 10px 0;\n  }\n  .remove-uploaded-btn.btn {\n    font-size: 10px;\n    min-width: 80px;\n  }\n  .remove-uploaded-btn svg {\n    width: 8px;\n  }\n  p.banner-info-text {\n    display: none;\n  }\n}\n.sourcebox h3 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 20px;\n  border-bottom: 1px solid #d9d9d9;\n  padding-bottom: 15px;\n  margin-bottom: 15px;\n  letter-spacing: 0.5px;\n}\n\n.sourcebox p {\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.02em;\n  color: #5b5b5b;\n}\n\n.icon-button {\n  padding: 0;\n  border: none;\n  background: transparent;\n  display: inline-flex;\n  align-items: center;\n  margin-right: 25px;\n}\n\n.icon-button:last-child {\n  margin-right: 0;\n}\n\n.source-footer {\n  display: flex;\n  align-items: center;\n}\n\n.like-count {\n  margin-right: 6px;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: normal;\n  margin-top: 2px;\n  min-width: 12px;\n}\n\n.liked svg {\n  width: 22px;\n}\n\n.icon-button .liked-icon {\n  display: none;\n}\n\n.icon-button.liked .normal-icon {\n  display: none;\n}\n\n.icon-button.liked .liked-icon {\n  display: inline-block;\n}\n\n.slick-slide .sourcebox {\n  border-left: 1px solid #d9d9d9;\n  padding-left: 15px;\n  padding-right: 15px;\n}\n\n.slick-slide:first-child .sourcebox {\n  border: none;\n  padding-left: 0px;\n}\n\n.source-label {\n  background: #eff0f2;\n  border-radius: 13px;\n  padding: 4px 10px;\n  color: #5b5b5b;\n  font-size: 12px;\n}\n\n.multi-label-wrap .source-label {\n  margin-left: 10px;\n}\n\n.multi-label-wrap .source-label:first-child {\n  margin-left: 0;\n}\n\n.hom-secs .slider-item .sourcebox {\n  flex: 1;\n}\n\n.hom-secs .sourcebox h3 a:hover {\n  color: #1A73E8 !important;\n  display: block;\n}\n\n.source-content {\n  min-height: 100px;\n}\n\n.showmore-button {\n  font-size: 12px;\n}\n\n.hom-secs .sourcebox h3 {\n  word-break: break-word;\n}\n\n@media (min-width: 768px) {\n  .hom-secs .sourcebox h3 {\n    height: 48px;\n    overflow: hidden;\n    padding-bottom: 0;\n    line-height: 22px;\n  }\n}\n@media (max-width: 767px) {\n  .sourcebox h3 {\n    margin-bottom: 5px;\n  }\n  .sourcebox {\n    margin-right: 0;\n  }\n  .slick-slide .sourcebox {\n    border-left: none;\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n.news-img-sec img {\n  width: 100%;\n  border-radius: 10px;\n}\n\n.news-small-left {\n  width: 40%;\n}\n\n.news-small-left img {\n  max-width: 100%;\n  border-radius: 3px;\n}\n\n.news-small-right {\n  width: 60%;\n  padding-left: 14px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n\n.news-small-right h4 {\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 20px;\n}\n\n.news-small-wrap {\n  margin-bottom: 30px;\n}\n\n.new-big-sec .sourcebox {\n  margin-right: 0;\n}\n\n.news-right {\n  padding-left: 15px;\n  border-left: 1px solid #d9d9d9;\n  height: 100%;\n}\n\n.news-right li h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 20px;\n  margin: 0;\n  word-break: break-word;\n}\n\n.hom-secs .new-big-sec {\n  padding-top: 0;\n  margin-bottom: 40px;\n}\n\n.news-right ul {\n  margin: 0;\n  padding: 0;\n}\n\n.news-right li {\n  list-style: none;\n  min-height: 100px;\n  display: flex;\n  align-items: flex-start;\n  border-bottom: 1px solid #d9d9d9;\n  flex-wrap: wrap;\n  flex-direction: column;\n  justify-content: center;\n  padding: 20px 0;\n}\n\n.news-right li:last-child {\n  border: none;\n  padding-bottom: 0;\n}\n\n.news-right li .authors-name {\n  margin-top: 12px;\n}\n\n.news-small-box-wrap {\n  padding-right: 10px;\n}\n\n.hom-secs .news-wrap .sourcebox h3,\n.hom-secs .new-big-sec {\n  border: none;\n}\n\n.hom-secs .news-wrap .sourcebox h3 {\n  height: auto;\n  word-break: break-word;\n}\n\n.new-right-wrap {\n  margin-left: -4px;\n}\n\n.news-wrap .source-content {\n  min-height: inherit;\n}\n\n.hom-secs .new-big-sec {\n  padding-right: 12px;\n}\n\n@media (min-width: 1200px) {\n  .news-big-repeat:nth-child(5) .new-big-sec, .news-big-repeat:nth-child(6) .new-big-sec {\n    margin-bottom: 0;\n  }\n  .news-wrap {\n    padding-bottom: 40px;\n  }\n}\n@media (max-width: 991px) {\n  .news-small-box-wrap.right-border {\n    border: none;\n  }\n  .news-right li {\n    padding: 20px 10px;\n    min-height: inherit;\n    border: 1px solid #d9d9d9 !important;\n    margin-bottom: -1px;\n  }\n  .news-right {\n    padding-left: 0;\n    border: none;\n  }\n  .news-right li h4 {\n    font-size: 14px;\n  }\n  .new-right-wrap {\n    margin-left: 0;\n    padding-left: 13px !important;\n  }\n  .hom-secs .new-big-sec {\n    padding-right: 0;\n  }\n  li.news-right-shimmer-box {\n    display: none;\n  }\n}\n@media (max-width: 767px) {\n  .new-big-sec {\n    margin-bottom: 30px;\n  }\n  .news-small-left {\n    width: 100px;\n  }\n  .news-small-right {\n    width: auto;\n  }\n}\n.video-frame-wrap {\n  display: flex;\n  height: 222px;\n  background: #555;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n}\n\n.video-frame-wrap iframe {\n  flex: 1;\n  max-height: 100%;\n  max-width: 100%;\n  border-radius: 10px;\n}\n\n.react-player__preview {\n  border-radius: 10px;\n}\n\n.hom-secs .multimedia-wrap .sourcebox {\n  margin-right: 0;\n}\n\n.hom-secs .multimedia-wrap .sourcebox h3 {\n  border: none;\n  padding-bottom: 0;\n}\n\n.multimedia-wrap .slick-slide .sourcebox {\n  border: none;\n  padding-left: 12px;\n  padding-right: 12px;\n}\n\n.multimedia-wrap .slick-list {\n  margin: 0 -12px;\n}\n\n.hom-secs .multimedia-wrap {\n  padding-right: 15px;\n}\n\n@media (max-width: 1400px) {\n  .video-frame-wrap {\n    height: 160px;\n  }\n}\n@media (max-width: 767px) {\n  .video-frame-wrap {\n    height: 200px;\n  }\n  .hom-secs .multimedia-wrap {\n    padding-right: 0;\n  }\n}\n.results-header .btn {\n  padding: 0 10px;\n}\n\n.results-header {\n  border-bottom: 1px solid #d7e0e9;\n  padding-bottom: 15px;\n}\n\n.results-header h4 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 22px;\n  letter-spacing: -0.02em;\n  margin: 0;\n}\n\n.results-text {\n  font-size: 18px;\n  line-height: 22px;\n  color: #252525;\n  margin-bottom: 10px;\n}\n\n.savequery-wrap {\n  margin: 30px 0;\n}\n\n.mobile-fliter-full {\n  display: none;\n}\n\n.results-btns.double-btn {\n  min-width: 372px;\n  margin-left: 10px;\n  margin-top: 3px;\n}\n\n.filter-button .btn {\n  padding: 0 10px;\n  min-width: inherit;\n}\n\n.filter-box-scroll {\n  max-height: 25vh;\n  margin-top: 10px;\n}\n\n.results-tab-wrap .nav-link:focus-visible {\n  outline: none !important;\n}\n\n.result-content-area .results-tab-wrap .nav-item:nth-child(8) {\n  position: relative;\n}\n\n.result-content-area .results-tab-wrap .nav-item:first-child {\n  text-align: left;\n}\n\n.result-content-area .results-tab-wrap .nav-item:nth-child(8)::after {\n  position: absolute;\n  left: 0;\n  width: 2px;\n  background-color: #ddd;\n  top: -6px;\n  bottom: 6px;\n  content: \"\";\n}\n\n.result-content-area .results-tab-wrap .nav-tabs .nav-link {\n  display: inline-block;\n}\n\n.filter-box-scroll .ps__thumb-y {\n  width: 4px;\n}\n\n.filter-box-scroll .ps__rail-y {\n  width: 6px;\n}\n\n.ps__rail-y:hover > .ps__thumb-y {\n  background-color: #999;\n  width: 4px;\n}\n\n@media (min-width: 768px) {\n  .result-content-area .results-tab-wrap .nav-item {\n    flex: 1;\n    text-align: center;\n  }\n}\n@media (min-width: 768px) and (max-width: 1200px) {\n  .filter-button .btn {\n    padding: 0 10px;\n    min-width: 100%;\n    margin: 10px 0 0 0;\n  }\n}\n@media (max-width: 991px) {\n  .results-tab-wrap .nav-tabs {\n    justify-content: flex-start;\n  }\n  .results-tab-wrap .nav-tabs .nav-link.active::after {\n    bottom: -3px;\n  }\n  .results-tab-wrap .nav-tabs .nav-link {\n    font-size: 13px;\n    margin-bottom: 15px;\n  }\n  .results-tab-wrap {\n    margin: 0;\n  }\n}\n@media (max-width: 767px) {\n  .results-header {\n    flex-wrap: wrap;\n  }\n  .results-header h4 {\n    margin-bottom: 15px;\n    word-break: break-all;\n  }\n  .results-header .btn {\n    padding: 0 5px;\n    font-size: 12px;\n    min-width: inherit;\n  }\n  .results-btns.double-btn {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n  }\n  .results-text {\n    font-size: 15px;\n  }\n  .results-btns.double-btn {\n    min-width: inherit;\n    margin-left: 0;\n    margin-top: 0;\n  }\n  .main-container {\n    position: inherit !important;\n  }\n  .result-content-area .results-tab-wrap .nav-item:nth-child(8)::after {\n    top: 0px;\n    bottom: 15px;\n  }\n}\n.result-filter-box {\n  background: #ffffff;\n  border: 1px solid #ffffff;\n  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.1);\n  border-radius: 15px;\n  padding: 18px 18px 5px;\n}\n\n.result-filter-box .accordion-item {\n  border: none;\n}\n\n.result-filter-box .accordion-button {\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 18px;\n  color: #000000;\n  background: transparent;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.result-filter-box .accordion-button:not(.collapsed) {\n  color: #000000;\n}\n\n.result-filter-box .accordion-button:not(.collapsed)::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n\n.result-filter-box .accordion-button:focus {\n  border-color: transparent;\n  box-shadow: none;\n}\n\n.result-filter-box .accordion-header {\n  margin-bottom: 0;\n  border-bottom: 1px solid #d7e0e9;\n}\n\n.result-filter-box .accordion-item:last-child .accordion-header {\n  border: none;\n}\n\n.result-filter-box .accordion-button:not(.collapsed) {\n  box-shadow: none;\n}\n\n.result-filter-box h4 {\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 18px;\n  letter-spacing: -0.02em;\n  color: #5b5b5b;\n  border-bottom: 1px solid #d7e0e9;\n  padding-bottom: 15px;\n  margin-bottom: 5px;\n  padding-left: 10px;\n  text-indent: 2px;\n}\n\n.filter-sub-text {\n  font-size: 11px;\n  font-weight: normal;\n  display: inline-block;\n  margin-left: 2px;\n  text-indent: 0;\n}\n\n.result-filter-box .accordion-button::after {\n  width: 18px;\n  height: 18px;\n  background-size: 18px;\n}\n\n.result-filter-box .accordion-body {\n  padding: 10px;\n}\n\n.country-header-search {\n  margin: 0 -10px;\n  position: relative;\n}\n\n.country-header-search .country-search {\n  padding-left: 30px;\n}\n\nspan.search-icon {\n  position: absolute;\n  left: 7px;\n  top: 9px;\n}\n\n.view-more-check {\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 17px;\n  letter-spacing: -0.02em;\n  color: #1A73E8;\n}\n\n.calendar-icon {\n  background: #1A73E8;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  height: 39px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 39px;\n  cursor: pointer;\n  pointer-events: none;\n}\n\n.calendar-modal .modal-dialog {\n  max-width: 621px;\n}\n\n.calendar-modal .modal-dialog.modal-md {\n  max-width: 500px;\n}\n\n.calendar-pop-header {\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 22px;\n  letter-spacing: -0.02em;\n  border-bottom: 1px solid #cccdce;\n  margin-bottom: 12px;\n  padding-bottom: 10px;\n}\n\n.calendaer-pop-footer {\n  margin-top: 10px;\n  border-top: 1px solid #d7e0e9;\n}\n\n.filter-accordian-wrap .btn-wrap {\n  margin-top: 30px;\n  margin-bottom: 20px;\n}\n\n.checkbox-wrapper {\n  position: relative;\n  padding-left: 30px;\n  margin-bottom: 20px;\n}\n\n.checkbox-wrapper:last-child {\n  margin-bottom: 0;\n}\n\n.checkbox-wrapper input {\n  position: absolute;\n  left: -9999px;\n}\n\n.checkbox-wrapper input + label {\n  cursor: pointer;\n  user-select: none;\n}\n\n.checkbox-wrapper input + label:before {\n  content: \"\";\n  position: absolute;\n  left: 0px;\n  top: 0;\n  width: 18px;\n  height: 18px;\n  border: 2px solid #cccdce;\n  border-radius: 1px;\n}\n\n.checkbox-wrapper input:checked + label:before {\n  background: url(\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAASABIAAD/4QBMRXhpZgAATU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAKqADAAQAAAABAAAAKgAAAAD/7QA4UGhvdG9zaG9wIDMuMAA4QklNBAQAAAAAAAA4QklNBCUAAAAAABDUHYzZjwCyBOmACZjs+EJ+/8AAEQgAKgAqAwEiAAIRAQMRAf/EAB8AAAEFAQEBAQEBAAAAAAAAAAABAgMEBQYHCAkKC//EALUQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+v/EAB8BAAMBAQEBAQEBAQEAAAAAAAABAgMEBQYHCAkKC//EALURAAIBAgQEAwQHBQQEAAECdwABAgMRBAUhMQYSQVEHYXETIjKBCBRCkaGxwQkjM1LwFWJy0QoWJDThJfEXGBkaJicoKSo1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoKDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uLj5OXm5+jp6vLz9PX29/j5+v/bAEMAAQEBAQEBAgEBAgMCAgIDBAMDAwMEBQQEBAQEBQYFBQUFBQUGBgYGBgYGBgcHBwcHBwgICAgICQkJCQkJCQkJCf/bAEMBAQEBAgICBAICBAkGBQYJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCf/dAAQAA//aAAwDAQACEQMRAD8A/v4ooooAKKK8S+Lv7R/wO+A11pVj8XfElroc2ty+TZxzb2aQ5ALERqxSMEgNI+1Fzywruy7LMTjKyw+EpynN7Rim27auyV3otThzLNMNg6LxGMqRhBbyk1FK+iu3ZavQ9tooorhO4//Q/v4r83fi5/wUj8A/Av8Aatj/AGcvifodzpelSQ27/wDCRSygQB7lAyt5OzJt1J8t5hJ8rqwKYUmv0ir5A/bI/Y6+H37X/wAOW8NeIQtjrlirvpOqquZLaUjlW6F4XIAkTPPDDDAGvvfDetkMcyVPiSnKVCaceaLadNu1qiS+Ll/ld1Z3s7JP4HxJoZ/LLHV4aqRjiINS5ZJNVEr3ptv4ebpJWaatdJtqp+2D+2l8NP2S/hqvivVZY9U1nVIz/Y+mxSDddNjiQsM7YFyC8mPZcsQK/KT9jz9kH4m/tsfEz/hsv9sV5LjSbiRZtM06UFFvFQ5iAjP+rsY/4E6zck5Ukve/ZL/4JP8AxLvfiRH4v/bMdbvSfDQS10zTPtYvEvEgJ8rcwZvLs06rCdrMThkVch/6EoIILWBLW1RY4o1CoigBVUDAAA4AA6Cv2bPuKcn4KwVTJ+E66r4qqrVMStowe1Olq7Nq3NJPfre3J+LZBwrnHG+Np5xxbQdDC0nelhnvKa3qVdFdJ35YtbdLN88tFFFfy4f1Of/R/v4ooooAKKKKACiiigD/2Q==\");\n  background-repeat: no-repeat;\n  background-size: 18px;\n  background-position: center;\n}\n\n.custom-date-picker .react-date-picker__wrapper {\n  background-color: #f3f5f7;\n  border-radius: 3px;\n  height: 39px;\n  border: none;\n  font-size: 12px;\n  width: 100%;\n  padding-left: 10px;\n}\n\n.custom-date-picker .react-date-picker {\n  display: block;\n}\n\n.custom-date-picker .react-date-picker__button svg {\n  width: 15px;\n  margin-right: 6px;\n}\n\n.custom-date-picker .react-date-picker__calendar .react-calendar {\n  border: none;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.26);\n  border-radius: 3px;\n}\n\n.custom-date-picker .react-calendar__navigation button {\n  min-width: 44px;\n  background: none;\n  font-size: 20px;\n}\n\n.custom-date-picker .react-calendar__navigation {\n  margin-bottom: 0;\n}\n\n.custom-date-picker .react-calendar__navigation__label {\n  font-size: 14px !important;\n  font-weight: bold;\n  color: #1A73E8;\n}\n\n.custom-date-picker .react-calendar__tile {\n  font-size: 11px;\n  font-weight: 600;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.custom-date-picker .react-calendar__tile--active {\n  background: #1A73E8;\n  border-radius: 3px;\n}\n\n.custom-date-picker .react-calendar button:enabled:hover {\n  border-radius: 3px;\n}\n\n.custom-date-picker .react-calendar__month-view__weekdays {\n  text-align: center;\n  text-transform: uppercase;\n  font-weight: bold;\n  font-size: 0.75em;\n  background: #ebf0f8;\n  padding: 5px 0;\n  margin-bottom: 10px;\n}\n\n.custom-date-picker .react-calendar__month-view__weekdays abbr[title] {\n  border-bottom: none !important;\n  cursor: inherit !important;\n  text-decoration: none !important;\n}\n\n.custom-date-picker .react-date-picker__calendar {\n  width: 300px;\n  z-index: 50;\n}\n\n.custom-date-picker .react-date-picker__inputGroup__input:invalid {\n  background: transparent;\n}\n\n.custom-date-picker .react-date-picker__inputGroup__input:focus {\n  border: none;\n  outline: none;\n}\n\n.mobile-fliter {\n  display: none;\n}\n\n.filter-toggle-button-box h4 {\n  display: flex;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 22px;\n}\n\n.filter-toggle-button-box h4 img {\n  max-width: 16px;\n  margin-left: 10px;\n}\n\n.filter-toggle-button-box {\n  padding: 20px;\n  background: #eff0f2;\n  margin-bottom: 20px;\n  border-radius: 4px;\n  box-shadow: 0 0 5px #c0c0c0;\n}\n\n.filter-toggle-button-box h4 {\n  margin-bottom: 0;\n}\n\n.form-switch .form-check-input {\n  width: 40px !important;\n  height: 20px;\n  border-color: #DFE1E7;\n}\n\n.form-switch .form-check-input:focus {\n  box-shadow: none;\n}\n\n.experts-filter-head {\n  position: relative;\n}\n\n.text-info-head {\n  position: absolute;\n  right: 0;\n}\n\n.experts-filter-head h4 {\n  flex: 1;\n}\n\n.text-info-head img {\n  max-width: 16px;\n}\n\n.react-date-picker__inputGroup__input, .react-date-picker__inputGroup {\n  cursor: pointer;\n}\n\n.country-filter .react-multi-select {\n  margin-bottom: 10px;\n}\n\n.country-filter .react-select-2-option__menu {\n  z-index: 10;\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n  .result-filter-box .accordion-body {\n    padding: 10px 0;\n  }\n  .result-filter-box .accordion-button {\n    font-size: 13px;\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n@media (max-width: 991px) {\n  .multi-label-wrap {\n    flex-wrap: wrap;\n    margin-bottom: 5px;\n  }\n  .source-label {\n    margin-bottom: 10px;\n    margin-left: 0 !important;\n    margin-right: 10px;\n  }\n  .result-filter-box {\n    margin-bottom: 20px;\n  }\n  .source-label:empty {\n    display: none;\n  }\n}\n@media (max-width: 767px) {\n  .filter-active {\n    display: block;\n  }\n  .mobile-fliter svg path {\n    fill: #fff;\n  }\n  .filter-active .result-filter-box {\n    margin-bottom: 20px;\n    position: fixed;\n    bottom: 70px;\n    z-index: 110;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: 0;\n  }\n  .mobile-fliter-full {\n    display: flex;\n    justify-content: space-between;\n    background: #1A73E8;\n    position: fixed;\n    z-index: 130;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    color: #fff;\n    padding: 10px 15px 10px 10px;\n    align-items: center;\n    box-shadow: 1px 0 6px rgba(0, 0, 0, 0.6196078431);\n  }\n  .mobile-fliter-full h4 {\n    font-size: 14px;\n    margin: 0;\n    color: #fff;\n  }\n  .mobile-fliter-full svg path {\n    fill: #fff;\n  }\n  .filter-hidden {\n    display: none;\n  }\n  .econ-fixed-div .filter-active {\n    position: fixed;\n    background: #fff;\n    z-index: 99;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n  }\n  .econ-fixed-div .filter-active .result-filter-box {\n    position: relative;\n    top: inherit;\n  }\n  .filter-toggle-button-box {\n    margin-bottom: 0;\n  }\n}\n.fin-result-contents {\n  padding-left: 15px;\n}\n\n.fin-result-contents .sourcebox h3 {\n  border: none;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 20px;\n  padding-bottom: 10px;\n  word-break: break-word;\n}\n\n.fin-result-contents .sourcebox {\n  margin-bottom: 50px;\n}\n\n.fin-result-contents .sourcebox p {\n  margin-bottom: 25px;\n}\n\n.fin-result-contents .sourcebox {\n  border: none;\n  margin-right: 0;\n  padding-right: 0;\n}\n\n.more-text-wrap {\n  margin-bottom: 25px;\n  font-size: 13px;\n  line-height: 22px;\n}\n\n.showmore-button {\n  white-space: nowrap;\n  font-weight: 500;\n  font-style: italic;\n  color: #1A73E8;\n  cursor: pointer;\n}\n\n.fin-result-contents .source-content {\n  min-height: inherit;\n}\n\n.multi-label-wrap .source-label {\n  cursor: default !important;\n}\n\n@media (max-width: 991px) {\n  .fin-result-contents {\n    padding-left: 0;\n  }\n}\n@media (max-width: 767px) {\n  .more-text-wrap {\n    margin-bottom: 10px;\n  }\n  .fin-result-contents .sourcebox h3 {\n    font-size: 15px;\n  }\n}\n.multi-result-contents .sourcebox h3 {\n  font-size: 14px;\n  border-bottom: none;\n}\n\n.multi-result-contents .sourcebox {\n  margin-bottom: 0;\n  height: 100%;\n}\n\n.mutimedia-results-repeatbox {\n  margin-bottom: 40px;\n}\n\n.sorce-footer-button-container {\n  display: flex;\n  align-items: center;\n}\n\n.news-result-contents .sourcebox h3 {\n  border: none;\n}\n\n.news-result-contents .sourcebox p {\n  margin-bottom: 20px;\n}\n\n.news-img-sec img {\n  width: auto;\n  border-radius: 10px;\n  max-width: 100px;\n  margin-right: 12px;\n  border: 1px solid #f0f0f0;\n}\n\n.new-small-thumb {\n  display: flex;\n  margin-bottom: 10px;\n  min-height: 100px;\n}\n\n.news-snippet:empty {\n  display: none;\n}\n\n.new-small-thumb .sourcebox h3 {\n  margin: 0;\n  padding: 0;\n}\n\n.new-big-sec {\n  border-top: 1px solid #d7e0e9;\n  padding-top: 25px;\n  margin-bottom: 25px;\n}\n\n.news-repeat-indetail:nth-child(1) .new-big-sec,\n.news-repeat-indetail:nth-child(2) .new-big-sec,\n.news-repeat-indetail:nth-child(3) .new-big-sec {\n  border: none;\n  padding-top: 0;\n}\n\n.news-repeat-indetail {\n  padding: 0 18px;\n}\n\n.upgrade-pop-wrap {\n  text-align: center;\n  padding: 5px 0;\n}\n\n.upgrade-pop-wrap .upgrade-title {\n  margin: 19px 0 10px;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 22px;\n  max-width: 280px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.upgrade-pop-wrap p {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 22px;\n  margin-bottom: 15px;\n}\n\n.news-repeat-indetail .source-content {\n  min-height: 64px;\n}\n\n.date-text {\n  line-height: 20px;\n  font-weight: 500;\n  font-size: 12px;\n  color: #8A8B8C;\n  padding-top: 4px;\n}\n\n.sourcebox.news-auther-box {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n}\n\n.authors-name {\n  font-weight: 500;\n  color: #000;\n  font-size: 12px;\n  margin-top: 5px;\n}\n\n.authors-name span {\n  color: #666;\n  margin-right: 5px;\n  font-size: 12px;\n}\n\n@media (max-width: 991px) {\n  .news-repeat-indetail:nth-child(3) .new-big-sec {\n    border-top: 1px solid #d7e0e9;\n    padding-top: 25px;\n  }\n}\n@media (max-width: 767px) {\n  .news-repeat-indetail:nth-child(2) .new-big-sec {\n    border-top: 1px solid #d7e0e9;\n    padding-top: 25px;\n  }\n  .new-small-thumb {\n    min-height: inherit;\n  }\n}\n.expert-left-img img {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  border: 4px solid #ffffff;\n  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));\n}\n\n.experts-box {\n  background: #ffffff;\n  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.14);\n  border-radius: 15px;\n  margin-bottom: 24px;\n  display: flex;\n}\n\n.experts-box-left {\n  width: 84px;\n  background: #f3f5f7;\n  display: flex;\n  align-items: center;\n  padding-left: 17px;\n  border-radius: 15px 0 0 15px;\n}\n\n.experts-right {\n  flex: 1;\n  min-height: 188px;\n  display: flex;\n  align-items: center;\n  padding-left: 50px;\n}\n\n.experts-right-content {\n  width: 100%;\n  padding-right: 20px;\n}\n\n.experts-right-content h3 {\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 18px;\n  letter-spacing: -0.02em;\n  margin-bottom: 12px;\n}\n\n.experts-pers-info-wrap {\n  margin-bottom: 12px;\n}\n\nspan.experts-pers-info-text {\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 18px;\n  margin-left: 10px;\n  color: #5b5b5b;\n}\n\n.experts-footer {\n  display: flex;\n  align-items: center;\n  border-top: 1px solid #ddd;\n  width: 100%;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n@media (max-width: 767px) {\n  .experts-right {\n    padding-left: 50px;\n  }\n}\n.pop-checkboxscroll {\n  height: 40vh;\n}\n\n.pop-selected-items-scroll {\n  height: 20vh;\n}\n\n.selected-view-box {\n  border-top: 1px solid #cccdce;\n  border-left: none;\n  border-right: none;\n  padding-top: 20px;\n}\n\n.react-multi-select {\n  cursor: pointer;\n}\n\n.selected-item-show-wrap {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 -5px;\n}\n\n.selected-item-show {\n  display: flex;\n  background: #f3f5f7;\n  margin: 0 5px 10px;\n  padding: 10px;\n  border-radius: 3px;\n  font-size: 12px;\n  position: relative;\n}\n\n.country-pop-items .checkbox-box {\n  padding-top: 30px;\n  padding-bottom: 20px;\n}\n\n.selected-close {\n  margin-left: 10px;\n  position: absolute;\n  top: -3px;\n  padding: 5px 7px;\n  right: 0;\n  cursor: pointer;\n}\n\n.selected-name {\n  margin-right: 15px;\n}\n\n.country-pop-wraper {\n  padding: 15px 0px;\n}\n\n@media (max-width: 767px) {\n  .pop-checkboxscroll {\n    max-height: 40vh;\n    height: auto;\n  }\n}\n.catogory-popup .modal-dialog {\n  max-width: 616px;\n}\n\n.catogory-checkbox .checkbox-wrapper {\n  margin-bottom: 25px;\n  margin-top: 20px;\n}\n\n@media (max-width: 767px) {\n  .catogory-checkbox .checkbox-wrapper {\n    margin-bottom: 15px;\n    margin-top: 10px;\n  }\n}\n.innerwrapper {\n  padding-top: 35px;\n}\n\n.innerwrapper .results-tab-wrap .nav-tabs {\n  justify-content: flex-start;\n}\n\n.tooltip > div.tooltip-inner {\n  background-color: #1A73E8 !important;\n}\n\n.tooltip.show {\n  opacity: 1 !important;\n}\n\n.tooltip > div.tooltip-inner::before {\n  border-color: #1A73E8 !important;\n  color: #1A73E8 !important;\n}\n\n.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before,\n.bs-tooltip-top .tooltip-arrow::before {\n  border-top-color: #1A73E8 !important;\n}\n\n.tooltip-inner {\n  font-size: 12px;\n  text-align: center;\n}\n\n.action-icon-cell {\n  cursor: pointer;\n}\n\n.delete-confirm-wrap {\n  padding: 10px 0;\n}\n\n.innerwrapper .results-tab-wrap .nav-tabs::after {\n  left: 0;\n  right: 0;\n}\n\n.innerwrapper .results-tab-wrap .nav-tabs .nav-link {\n  padding: 5px 30px;\n}\n\n.savedquery-wrap {\n  min-height: calc(100vh - 120px);\n}\n\n.innerwrapper.profile-wrap {\n  position: relative;\n}\n\n.innerwrapper.profile-wrap::before {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 355px;\n  right: 0;\n  background: #f3f5f7;\n  content: \"\";\n  pointer-events: none;\n  z-index: -1;\n}\n\n.prof-left {\n  padding: 0 15px;\n  width: 28%;\n}\n\n.prof-right {\n  padding: 0 15px;\n  width: 72%;\n}\n\n.profile-quick-details h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 22px;\n  letter-spacing: -0.02em;\n}\n\n@media (max-width: 991px) {\n  .prof-left {\n    width: 100%;\n    margin-bottom: 20px;\n  }\n  .prof-right {\n    width: 100%;\n  }\n}\n@media (max-width: 767px) {\n  .members-wrap .inner-title {\n    margin-bottom: 15px !important;\n  }\n}\n.members-header-right-search {\n  flex: 1;\n}\n\n.m-l-10 {\n  margin-left: 10px;\n}\n\n.no-results-wraper {\n  padding: 30px;\n  color: #555;\n  border-radius: 13px;\n  text-align: center;\n  font-weight: 500;\n  font-size: 16px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1490196078);\n}\n\nspan.transport-text {\n  background: #EFF0F2;\n  padding: 5px 10px;\n  border-radius: 20px;\n  display: inline-block;\n  line-height: normal;\n  color: #474747;\n}\n\n.members-wrap .experts-right {\n  padding-left: 50px;\n}\n\n.members-wrap .experts-pers-info-text {\n  word-break: break-all;\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n  .expert-left-img img {\n    width: 85px;\n    height: 85px;\n  }\n  .experts-box-left {\n    padding-left: 10px;\n  }\n  .members-wrap .experts-right {\n    padding-left: 16px;\n  }\n}\n.signup-content-profile {\n  border: 1px solid #e9e9e9;\n  border-radius: 15px;\n}\n\n.prof-sub-header {\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 16px;\n  color: #5b5b5b;\n  letter-spacing: 0.2px;\n  margin: 0;\n}\n\n.inner-title {\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 22px;\n  letter-spacing: 0.2px;\n}\n\n.my-profile-header .inner-title {\n  margin: 0;\n}\n\n.profile-det-box p {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 16px;\n  color: #5b5b5b;\n  margin-bottom: 5px;\n}\n\n.profile-det-box h4 {\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 16px;\n  margin-bottom: 20px;\n}\n\n.profile-det-box {\n  width: 50%;\n  min-height: 130px;\n  padding: 0 30px 20px;\n  position: relative;\n}\n\n.border-detail {\n  margin-bottom: 50px;\n}\n\n.border-detail::after {\n  content: \"\";\n  left: 30px;\n  right: 30px;\n  bottom: 0;\n  height: 1px;\n  background-color: #d9d9d9;\n  position: absolute;\n}\n\n.profile-det-box-wrap {\n  margin: 0 -30px;\n}\n\n.p-b-0 {\n  padding-bottom: 0;\n}\n\n.box-bg {\n  background: #f3f5f7;\n  padding: 20px 20px 10px;\n  margin-bottom: 20px;\n  border-radius: 3px;\n}\n\n.box-bg .react-multi-select .react-select-2-option__control:not(.react-select-2-option__control--is-focused):not(.react-select-2-option__control--is-disabled) {\n  background-color: #fff;\n}\n\n.box-bg .react-select-2-option__multi-value {\n  background-color: #f3f5f7;\n}\n\n.box-bg-infotext {\n  color: #1A73E8;\n  font-size: 13px;\n  font-style: italic;\n  font-weight: 500;\n}\n\n.subheader-min-height {\n  min-height: 39px;\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n  .profile-det-box-wrap .border-detail {\n    margin-bottom: 20px;\n  }\n  .profile-det-box {\n    padding-bottom: 20px;\n    min-height: inherit;\n  }\n}\n@media (max-width: 767px) {\n  .profile-det-box {\n    width: 100%;\n    min-height: inherit;\n  }\n  .border-detail, .profile-det-box {\n    margin-bottom: 20px;\n  }\n  .border-detail::after {\n    display: none;\n  }\n  .profile-det-box h4 {\n    margin-bottom: 10px;\n  }\n  .profile-wrap .p-30 {\n    padding: 15px;\n  }\n  .innerwrapper.profile-wrap::before {\n    background: transparent;\n  }\n}\n.profile-inner-box {\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.11);\n  border-radius: 15px;\n  background: #fff;\n  padding-bottom: 40px;\n  height: 100%;\n}\n\n.profile-top-bg {\n  height: 169px;\n  background-color: #1A73E8;\n  background-position: center 0;\n  border-radius: 15px 15px 0 0;\n}\n\n.profile-stat-contentbox {\n  margin-top: -80px;\n}\n\n.profile-quick-details {\n  padding: 0 30px;\n  text-align: left;\n}\n\n@media (max-width: 767px) {\n  .profile-top-bg {\n    height: 80px;\n  }\n}\n.viewallmembers-wrap {\n  position: absolute;\n  top: 112px;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: #f3f5f7;\n  padding-top: 30px;\n}\n\n.viewallmembers-header .row {\n  margin: 0 -8px;\n}\n\n.viewallmembers-header .row .col {\n  padding: 0 8px;\n}\n\n.backarrow-wrap h4 {\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 22px;\n  margin: 0;\n  margin-left: 15px;\n}\n\n.user-img img {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 2px solid #ffffff;\n}\n\n.membername-cell h4 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 17px;\n  letter-spacing: -0.02em;\n  margin: 0 0 0 15px;\n}\n\n.sector-item {\n  border: 1px solid #ddd;\n  padding: 2px 5px;\n  margin: 2px;\n  border-radius: 3px;\n  font-size: 12px;\n}\n\n@media (max-width: 991px) {\n  .mebers-select-wrap {\n    padding: 0 8px;\n    margin-top: 10px;\n  }\n  .data-table-responsive .rdt_Table {\n    width: 900px;\n  }\n  .user-img img {\n    width: 30px;\n    height: 30px;\n    border: 1px solid #ffffff;\n  }\n}\n@media (max-width: 767px) {\n  .viewallmembers-wrap .p-30 {\n    padding: 15px;\n  }\n  .membername-cell h4 {\n    font-size: 13px;\n    margin: 0;\n  }\n}\n.recomendation-header {\n  border-bottom: 1px solid #D7E0E9;\n  padding-bottom: 20px;\n}\n\n.recomendation-main-outer {\n  min-height: 100vh;\n}\n\n@media (max-width: 767px) {\n  .recomendation-header .backarrow-wrap {\n    align-items: flex-start !important;\n  }\n  .financerecomendation-wrap {\n    padding-bottom: 40px;\n  }\n}\n.faq-header {\n  border-bottom: 1px solid #d9d9d9;\n  padding-bottom: 24px;\n  margin-bottom: 20px;\n}\n\n.faq-header h4 {\n  font-weight: 600;\n  font-size: 22px;\n  line-height: 27px;\n  letter-spacing: -0.02em;\n  margin-bottom: 0;\n}\n\n.faq-header-right {\n  flex: 1;\n  padding-left: 45px;\n}\n\n.faq-footer-sec h3 {\n  font-weight: 600;\n  font-size: 22px;\n  line-height: 27px;\n  letter-spacing: -0.02em;\n}\n\n.faq-footer-sec p {\n  font-size: 14px;\n  line-height: 19px;\n  letter-spacing: 0.02em;\n  color: #5b5b5b;\n}\n\n.faq-footer-sec textarea.textarea-item {\n  background: #f3f5f7;\n  border: none;\n  min-height: 114px;\n  font-size: 13px;\n  padding: 15px;\n  max-height: 114px;\n}\n\n.faq-footer-sec textarea.textarea-item::placeholder {\n  font-style: italic;\n}\n\n.faq-footer-sec .form-control:focus {\n  background-color: #f3f5f7;\n  border-color: inherit;\n  outline: 0;\n  box-shadow: none;\n}\n\n@media (max-width: 767px) {\n  .faq-header .d-flex {\n    flex-wrap: wrap;\n  }\n  .help-and-support-wrap .p-30 {\n    padding: 0;\n    box-shadow: none;\n  }\n  .faq-header h4 {\n    width: 100%;\n  }\n  .faq-header-right {\n    flex: 1;\n    padding-left: 0;\n    margin-top: 15px;\n    width: 100%;\n  }\n  .faq-header {\n    margin-bottom: 0;\n  }\n  .faq-header h4, .faq-footer-sec h3 {\n    font-size: 20px;\n    line-height: 24px;\n  }\n}\n.change-password-wrap {\n  margin-top: 38px;\n}\n\n.change-password-wrap .section-title {\n  font-weight: 600;\n  font-size: 22px;\n  line-height: 30px;\n  color: #000;\n}\n\n.change-password-wrap .section-title a {\n  color: #000;\n  text-decoration: none;\n}\n\n.changepassword-contents {\n  padding: 0 36px;\n}\n\n.change-psw-img {\n  padding-left: 50px;\n}\n\n.change-password-wrap .section-title span {\n  margin-right: 18px;\n  position: relative;\n  top: -1px;\n}\n\n.changepassword-contents form {\n  max-width: 80%;\n}\n\n.change-password-wrap .whitebox.p-30 {\n  padding-bottom: 70px;\n}\n\n@media (min-width: 991px) {\n  .change-psw-img {\n    min-height: 320px;\n  }\n  .change-password-wrap .change-psw-img {\n    margin-bottom: 0;\n  }\n  .change-psw-img img {\n    max-width: 100%;\n  }\n}\n@media (max-width: 1024px) {\n  .change-psw-img {\n    padding-left: 0;\n  }\n  .change-psw-img img {\n    max-width: 100%;\n  }\n}\n@media (max-width: 992px) {\n  .changepassword-contents form {\n    max-width: 100%;\n  }\n}\n@media (max-width: 767px) {\n  .change-psw-img {\n    display: none;\n  }\n  .changepassword-contents {\n    padding: 0;\n    margin-top: 30px;\n  }\n  .change-password-wrap .whitebox.p-30 {\n    padding-bottom: 40px;\n  }\n}\n.landing-header {\n  padding: 20px;\n}\n\n.user-img-landing img {\n  max-height: 30px;\n}\n\n.landing-header .dropdown {\n  margin-left: 10px;\n}\n\n.landing-menu-items .dropdown .btn {\n  min-width: inherit;\n  padding: 0;\n  background: transparent;\n  border: none;\n  color: #5b5b5b;\n}\n\n.landing-menu-items .dropdown .dropdown-toggle:focus {\n  box-shadow: none;\n}\n\n.landing-menu-items .dropdown a {\n  margin: 0;\n}\n\n.landing-menu-items .dropdown-menu.show.dropdown-menu-end {\n  border: none;\n  box-shadow: 0 1px 4px #c1c1c1;\n  padding: 10px;\n}\n\n.landing-menu-items .dropdown-item {\n  font-size: 13px;\n  line-height: 24px;\n}\n\n.landing-menu-items .dropdown a {\n  font-size: 13px;\n  line-height: 24px;\n}\n\n.landing-menu-items .dropdown-item:focus,\n.landing-menu-items .dropdown-item:hover {\n  color: #1A73E8;\n  background-color: transparent;\n  text-shadow: 0px 0px #1a73e8;\n}\n\n.landing-menu-items .dropdown-menu {\n  min-width: 120px;\n}\n\n.landing-header .user-img img {\n  height: 30px;\n  width: 30px;\n  border: none;\n}\n\n.landing-menu-items .dropdown a {\n  padding: 0 5px;\n  color: #5b5b5b;\n}\n\n@media (min-width: 768px) {\n  .btn-primary.m-r-15 {\n    margin-right: 15px;\n  }\n}\n@media (max-width: 767px) {\n  .landing-header .mobilemenu-active .double-btn {\n    flex-wrap: wrap;\n    padding: 15px;\n  }\n  .landing-header {\n    padding: 10px 0;\n  }\n  .landing-header .double-btn .btn {\n    width: 48%;\n    margin: 0;\n    flex: 1;\n    max-width: 48%;\n  }\n  .landing-header .double-btn .dropdown .btn {\n    width: 100%;\n    max-width: 99%;\n    text-align: left;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n  .landing-header .double-btn .dropdown {\n    max-width: 60%;\n  }\n  .landing-header .mobilemenu-active {\n    top: 50px;\n    right: 0;\n    left: 0;\n  }\n  .landing-header .dropdown {\n    margin-left: 0;\n    width: auto;\n    margin: 0;\n    flex: 1;\n    border: none;\n    padding: 0;\n  }\n  .landing-header .double-btn .btn:first-child {\n    margin-right: 4%;\n  }\n  .landing-menu-items .dropdown-menu {\n    min-width: 120px;\n    position: inherit !important;\n    transform: none !important;\n  }\n  .landing-menu-items .dropdown-menu {\n    position: inherit !important;\n    transform: none !important;\n    border: none !important;\n    box-shadow: none !important;\n    padding: 0 !important;\n    padding-top: 10px !important;\n  }\n  .landing-menu-items .mobilemenu-active .dropdown {\n    padding-left: 0;\n  }\n  .landing-menu-items .dropdown a {\n    padding-left: 0;\n  }\n}\n.footer-left {\n  flex: 1;\n}\n\n.land-footer-wrap {\n  padding: 40px 0 80px;\n}\n\nh4.footer-title {\n  font-weight: 700;\n  font-size: 13px;\n  line-height: 16px;\n  letter-spacing: 0.05em;\n  margin-bottom: 15px;\n}\n\n.footer-menu-list a {\n  text-decoration: none;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 16px;\n  letter-spacing: 0.05em;\n  color: #000;\n  margin-bottom: 10px;\n  display: inline-block;\n  border-bottom: 1px solid transparent;\n}\n\n.footer-menu-list a:hover, .footer-menu-list a.active {\n  color: #1A73E8;\n  border-bottom: 1px solid #1A73E8;\n}\n\n.footer-menu-list {\n  margin-top: 0;\n  margin-bottom: 1rem;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.active-class {\n  text-decoration: underline;\n}\n\np.copyright-text {\n  margin: 12px 0;\n}\n\n.social-icons a {\n  margin-left: 10px;\n}\n\n.social-icons a:first-child {\n  margin-left: 0;\n}\n\n@media (max-width: 767px) {\n  .land-footer-content {\n    flex-wrap: wrap;\n  }\n  .footer-left {\n    flex: inherit;\n    width: 100%;\n  }\n  .land-footer-wrap {\n    padding: 30px 0;\n  }\n  .footer-right {\n    text-align: center;\n    margin-top: 20px;\n    border-top: 1px solid #ddd;\n    width: auto;\n    margin: 20px -15px 0;\n    flex: 1;\n    padding-top: 20px;\n  }\n  .land-footer-wrap .container {\n    padding: 0 15px;\n  }\n  .footer-left {\n    text-align: center;\n  }\n}\n.landing-section-bg-right {\n  background-position: right;\n  right: 0;\n}\n\n.landing-section-bg {\n  background-size: cover;\n  background-repeat: no-repeat;\n  position: absolute;\n  width: 50%;\n  bottom: 0;\n  pointer-events: none;\n  z-index: 1;\n  top: 0;\n}\n\n.landing-section-bg-left {\n  background-position: left;\n  left: 0;\n}\n\n.bg-over-text {\n  position: relative;\n  z-index: 2;\n}\n\n.landing-common-title {\n  font-weight: 800;\n  font-size: 30px;\n  line-height: 37px;\n  letter-spacing: 0.05em;\n  color: #000000;\n  margin-bottom: 26px;\n  max-width: 80%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.getresults-content h3 {\n  font-weight: 800;\n  font-size: 30px;\n  line-height: 34px;\n  letter-spacing: 0.05em;\n  margin-bottom: 25px;\n}\n\n.landing-common-description {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0.05em;\n  color: #000000;\n}\n\n.landing-section-2 {\n  padding: 90px 0;\n}\n\n.landing-section-4 {\n  padding: 90px 0;\n}\n\n.landing-section-5 {\n  padding: 90px 0;\n}\n\n.landing-section-6 {\n  padding: 90px 0;\n  background-color: #DDEAFC;\n}\n\n.landing-section-7 {\n  padding: 90px 0 30px;\n}\n\n.landing-section-8 {\n  padding: 70px 0;\n}\n\n.land-contact-section {\n  background: #DDEAFC;\n  padding: 50px 0 60px;\n}\n\n.contact-success .modal-dialog {\n  max-width: 690px;\n}\n\n.contact-success .success-content-wrap h3 {\n  font-weight: 700;\n  font-size: 26px;\n  line-height: 32px;\n  text-align: center;\n  letter-spacing: 0.05em;\n}\n\n.contact-success .success-content-wrap p {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 20px;\n  margin-top: 30px;\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n  .landing-section-bg {\n    background-position: center;\n  }\n  .landing-section-2 {\n    padding: 50px 0;\n  }\n  .landing-section-4 {\n    padding: 50px 0;\n  }\n  .landing-section-5 {\n    padding: 50px 0 30px;\n  }\n  .landing-section-7 {\n    padding: 50px 0;\n  }\n  .landing-section-8 {\n    padding: 50px 0;\n  }\n  .landing-common-title {\n    font-size: 20px;\n    line-height: 26px;\n  }\n  .getresults-content h3 {\n    font-size: 20px;\n    line-height: 26px;\n  }\n  .landing-common-title {\n    max-width: 100%;\n  }\n}\n@media (max-width: 767px) {\n  .landing-section-bg {\n    position: inherit;\n    height: 260px;\n    width: 100%;\n  }\n  .landing-section-2 {\n    padding: 30px 0;\n  }\n  .landing-common-title {\n    font-size: 20px;\n    line-height: 28px;\n    max-width: 100%;\n    margin-bottom: 10px;\n  }\n  .landing-section-4 {\n    padding: 30px 0 15px;\n  }\n  .getresults-content h3 {\n    font-size: 20px;\n    line-height: 28px;\n    text-align: center;\n  }\n  .landing-common-description {\n    text-align: center;\n    font-size: 15px;\n  }\n  .landing-section-5 {\n    padding: 30px 0;\n  }\n  .landing-section-6 {\n    padding: 0 0 30px;\n  }\n  .landing-section-7 {\n    padding: 30px 0;\n  }\n  .contact-success .success-content-wrap h3 {\n    font-size: 21px;\n    line-height: 24px;\n    max-width: 75%;\n    margin: 0 auto 20px;\n  }\n  .contact-success-img img {\n    max-width: 70%;\n  }\n}\n.land-section-1-row {\n  height: 478px;\n}\n\n.landing-section-1 {\n  background-color: #1A73E8;\n}\n\n.landing-section-1 h4 {\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 29px;\n  letter-spacing: 0.05em;\n  color: #ffffff;\n  margin-bottom: 30px;\n}\n\n.landing-section-1 h2 {\n  font-weight: 600;\n  font-size: 40px;\n  line-height: 48px;\n  letter-spacing: 0.05em;\n  color: #ffffff;\n  margin-bottom: 30px;\n}\n\n.landing-section-1 h2 .Typewriter {\n  margin-right: 10px;\n}\n\n.landing-section-1 h2 .Typewriter .Typewriter__wrapper {\n  padding-right: 10px;\n}\n\n.landing-section-1 h2 .Typewriter .Typewriter__cursor {\n  font-weight: 400;\n}\n\n.landing-section-1 h2 .Typewriter:last-of-type .Typewriter__cursor {\n  display: none;\n}\n\n.landing-section-1 p {\n  font-size: 15px;\n  line-height: 22px;\n  color: #fff;\n  margin-bottom: 30px;\n}\n\nspan.svg-down-arrow {\n  margin-left: 6px;\n  position: relative;\n  top: 3px;\n}\n\n.sec1-content .btn {\n  color: #fff;\n  font-weight: 500;\n  font-size: 13px;\n  letter-spacing: -0.02em;\n}\n\n.sec1-content {\n  padding-right: 50px;\n}\n\n@media (max-width: 1400px) {\n  .landing-section-1 h4 {\n    font-size: 20px;\n    margin-bottom: 25px;\n  }\n  .landing-section-1 h2 {\n    font-size: 30px;\n    margin-bottom: 25px;\n  }\n  .landing-section-1 p {\n    font-size: 13px;\n  }\n}\n@media (max-width: 1200px) {\n  .landing-section-1 h4 {\n    font-size: 17px;\n  }\n  .landing-section-1 h2 {\n    font-size: 26px;\n    line-height: 30px;\n  }\n}\n@media (max-width: 991px) {\n  .landing-section-1 h4 {\n    font-size: 15px;\n    margin-bottom: 15px;\n  }\n  .landing-section-1 p {\n    font-size: 12px;\n    margin-bottom: 20px;\n  }\n  .sec1-content {\n    padding-right: 10px;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .landing-section-1 h2 {\n    font-size: 20px;\n    line-height: 26px;\n    margin-bottom: 15px;\n  }\n  .land-section-1-row {\n    height: 290px;\n  }\n}\n@media (max-width: 767px) {\n  .land-section-1-row {\n    height: auto;\n    padding: 30px 0;\n  }\n  .sec1-content {\n    padding-right: 0;\n    text-align: center;\n  }\n  .landing-section-1 h2 {\n    font-size: 22px;\n    line-height: 28px;\n    margin-bottom: 15px;\n  }\n}\n.thumb-slider-with-animation {\n  display: flex;\n  text-align: left;\n  align-items: center;\n}\n.thumb-slider-with-animation .mySwiper {\n  width: 45%;\n  padding-right: 45px;\n  margin: auto;\n}\n.thumb-slider-with-animation .mySwiper .swiper-wrapper {\n  flex-direction: column;\n  height: auto;\n  padding-left: 5px;\n  padding-top: 25px;\n}\n.thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide {\n  width: 100% !important;\n  margin: 0 0 25px 0 !important;\n  padding: 0 10px 0 10px;\n}\n.thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide .thumb-content-area {\n  box-shadow: 0px 5px 10px 0px rgba(159, 171, 182, 0.2509803922);\n  cursor: pointer;\n  padding: 25px 15px;\n  border-radius: 7px;\n  display: flex;\n  position: relative;\n  overflow: hidden;\n}\n.thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide .thumb-content-area .thumb-line {\n  width: 4px;\n  background-color: #DEE3EA;\n  display: block;\n  margin-right: 24px;\n  position: relative;\n}\n.thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide .thumb-content-area .thumb-line::after {\n  content: \"\";\n  width: 4px;\n  height: 0;\n  position: absolute;\n  left: 0;\n  background-color: #1A73E8;\n}\n.thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide .thumb-content-area .thumb-cont {\n  flex: 1;\n}\n.thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide .thumb-content-area label {\n  color: #5B5B5B;\n  font-size: 15px;\n  font-weight: 600;\n  letter-spacing: 0.75px;\n  margin: 0 0 16px;\n}\n.thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide .thumb-content-area p {\n  color: #5B5B5B;\n  font-weight: 300;\n  line-height: 20px;\n  letter-spacing: 0.65px;\n}\n.thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide.swiper-slide-thumb-active .thumb-line::after {\n  height: 100%;\n  transition: all 6s ease;\n}\n.thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide.swiper-slide-thumb-active label {\n  color: #0338C0;\n}\n.thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide.swiper-slide-thumb-active p {\n  font-size: 14px;\n  font-weight: 400;\n  color: #000;\n}\n.thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide.swiper-slide-thumb-active .thumb-content-area {\n  box-shadow: 0px 10px 20px 0px rgba(85, 98, 111, 0.25);\n}\n.thumb-slider-with-animation .mySwiper2 {\n  width: 55%;\n  border-radius: 20px;\n  background: #D5E4F9;\n}\n.thumb-slider-with-animation .mySwiper2 .swiper-wrapper {\n  align-items: center;\n}\n.thumb-slider-with-animation .mySwiper2 .swiper-slide {\n  padding: 30px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.thumb-slider-with-animation .mySwiper2 .swiper-slide .left-slide {\n  position: relative;\n  left: -105%;\n}\n.thumb-slider-with-animation .mySwiper2 .swiper-slide .right-slide {\n  position: relative;\n  right: -105%;\n}\n.thumb-slider-with-animation .mySwiper2 .swiper-slide .top-slide {\n  position: relative;\n  top: -270px;\n}\n.thumb-slider-with-animation .mySwiper2 .swiper-slide.swiper-slide-active .top-slide {\n  top: 0;\n  transition: all 1.5s ease;\n}\n.thumb-slider-with-animation .mySwiper2 .swiper-slide.swiper-slide-active .left-slide {\n  left: 0;\n  transition: all 1.5s ease;\n}\n.thumb-slider-with-animation .mySwiper2 .swiper-slide.swiper-slide-active .right-slide {\n  right: 0;\n  transition: all 1.5s ease;\n}\n.thumb-slider-with-animation .chat-slide-left-img {\n  border-radius: 10px;\n  box-shadow: 0px 20px 30px 0px #A5C2EB;\n}\n.thumb-slider-with-animation .chat-slide-typer-area {\n  border-radius: 7px;\n  background: #FFF;\n  box-shadow: 0px 20px 30px 0px #A5C2EB;\n  padding: 15px;\n  min-height: 200px;\n}\n.thumb-slider-with-animation .chat-slide-typer-area .Typewriter {\n  padding: 0 15px;\n  font-size: 12px;\n  line-height: 20px;\n}\n.thumb-slider-with-animation .chat-slide-right-img1 {\n  box-shadow: 0px 20px 30px 0px #A5C2EB;\n  border-radius: 7px;\n}\n.thumb-slider-with-animation .chat-slide-right-img2 {\n  box-shadow: 0px 10px 10px 0px rgba(182, 211, 239, 0.45);\n  max-width: 350px;\n  width: 100%;\n}\n.thumb-slider-with-animation .chat-slide-right-img3 {\n  border-radius: 7px;\n  margin-top: 32px;\n}\n.thumb-slider-with-animation .search-slide-top-img {\n  box-shadow: 0px 10px 10px 0px #A3C0E8;\n  border-radius: 11px;\n  margin-bottom: 20px;\n}\n.thumb-slider-with-animation .search-slide-left-img {\n  box-shadow: 0px 20px 30px 0px #A5C2EB;\n  border-radius: 7px;\n}\n.thumb-slider-with-animation .search-slide-typer-area {\n  border-radius: 7px;\n  background: #FFF;\n  box-shadow: 0px 20px 30px 0px #A5C2EB;\n  height: 100%;\n}\n.thumb-slider-with-animation .search-slide-typer-area .Typewriter {\n  padding: 15px 0;\n  font-size: 12px;\n  line-height: 20px;\n}\n.thumb-slider-with-animation .general-slide-left-area {\n  border-radius: 10px;\n  box-shadow: 0px 20px 30px 0px #A5C2EB;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 100%);\n  height: 100%;\n}\n.thumb-slider-with-animation .general-slide-left-area img {\n  width: 100%;\n}\n\n@media (max-width: 1199px) {\n  .thumb-slider-with-animation .chat-slide-typer-area {\n    min-height: auto;\n  }\n}\n@media (max-width: 991px) {\n  .thumb-slider-with-animation {\n    flex-direction: column;\n  }\n  .thumb-slider-with-animation .mySwiper {\n    width: 100%;\n  }\n  .thumb-slider-with-animation .mySwiper .swiper-wrapper {\n    flex-direction: row;\n  }\n  .thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide {\n    width: 33.3% !important;\n  }\n  .thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide .thumb-content-area p {\n    display: none;\n  }\n  .thumb-slider-with-animation .mySwiper2 {\n    width: 100%;\n  }\n  .thumb-slider-with-animation .mySwiper {\n    padding: 0;\n  }\n  .thumb-slider-with-animation .mySwiper .swiper-wrapper {\n    padding: 0;\n  }\n  .thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide .thumb-content-area {\n    flex-direction: column;\n    padding: 10px;\n    text-align: center;\n  }\n  .thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide .thumb-content-area label {\n    margin: 0;\n  }\n  .thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide .thumb-content-area .thumb-line {\n    width: 100%;\n    height: 4px;\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n  .thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide .thumb-content-area .thumb-line::after {\n    width: 0;\n    height: 4px;\n  }\n  .thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide.swiper-slide-thumb-active .thumb-line::after {\n    width: 100%;\n  }\n}\n.landing-animation-section .container {\n  max-width: 1179px;\n}\n.landing-animation-section .chat-slide-left-img {\n  width: 100%;\n}\n\n@media (max-width: 767px) {\n  .thumb-slider-with-animation .chat-slide-typer-area .Typewriter {\n    font-size: 10px;\n  }\n}\n@media (max-width: 575px) {\n  .thumb-slider-with-animation .mySwiper2 .swiper-slide {\n    padding: 20px 10px;\n  }\n  .thumb-slider-with-animation .chat-slide-typer-area .Typewriter {\n    padding: 0;\n    font-size: 8px;\n    line-height: 14px;\n  }\n  .thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide .thumb-content-area label {\n    font-size: 12px;\n  }\n  .thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide {\n    padding: 0 5px;\n  }\n  .thumb-slider-with-animation .general-slide-left-area {\n    border-radius: 7px;\n  }\n  .thumb-slider-with-animation .search-slide-top-img {\n    margin-bottom: 15px;\n  }\n}\n.landing-section-3 {\n  background-color: #ddeafc;\n}\n\n.landing-section-3 {\n  padding: 80px 0 110px;\n}\n\n.getresults-content {\n  padding: 0 15px 0 45px;\n}\n\n.animation-box-content {\n  background: #fff;\n  padding: 30px 10px;\n  box-shadow: 0px 20px 20px rgba(59, 89, 134, 0.25);\n  border-radius: 10px;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n}\n\n.animation-box {\n  padding: 0 11px;\n  width: 20%;\n}\n\n.animation-box h4 {\n  font-weight: 800;\n  font-size: 18px;\n  line-height: 22px;\n  letter-spacing: 0.05em;\n  margin-bottom: 20px;\n}\n\n.animation-box p {\n  font-size: 13px;\n  line-height: 20px;\n  text-align: center;\n  letter-spacing: 0.05em;\n  margin: 0;\n}\n\n.animation-box-row {\n  margin: 40px -11px 0px;\n}\n\n.animation-section-big-row {\n  margin: 0 -50px;\n}\n\n.landing-section-3 {\n  overflow-x: hidden;\n}\n\n.animation-box:hover .animation-box-content::after {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0px;\n  height: 7px;\n  background: #1A73E8;\n  content: \"\";\n}\n\n.transforming-animation-wrap .landing-section-bg {\n  width: 41.66666667%;\n}\n\n@media (max-width: 1200px) {\n  .animation-box-row {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n  .animation-box {\n    width: 33.3333%;\n    margin-top: 20px;\n  }\n  .animation-section-big-row {\n    margin: 0;\n  }\n  .getresults-content p br {\n    display: none;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .landing-section-3 {\n    padding: 50px 0 60px;\n  }\n}\n@media (max-width: 767px) {\n  .animation-box {\n    width: 100%;\n  }\n  .transforming-animation-wrap .landing-section-bg {\n    width: 100%;\n  }\n  .landing-section-3 {\n    padding: 0 0 30px;\n  }\n  .animation-box-content {\n    padding: 20px;\n    box-shadow: 0px 0px 7px rgba(59, 89, 134, 0.25);\n  }\n  .animation-box h4 {\n    margin-bottom: 12px;\n  }\n  .animation-box-row {\n    margin: 10px 0 0px;\n  }\n  .animation-box {\n    padding: 0 20px;\n  }\n  .getresults-content {\n    padding: 0 15px;\n  }\n}\n.relevent-box h4 {\n  font-weight: 800;\n  font-size: 18px;\n  line-height: 22px;\n  letter-spacing: 0.05em;\n  margin-bottom: 20px;\n}\n\n.relevent-box p {\n  font-size: 13px;\n  line-height: 20px;\n  text-align: center;\n  letter-spacing: 0.05em;\n  margin: 0;\n}\n\n.relevent-box {\n  width: 25%;\n  padding: 0 11px;\n}\n\n.relevent-box-content {\n  background: #fff;\n  box-shadow: 0px 10px 20px rgba(155, 163, 171, 0.25);\n  padding: 40px 20px;\n  height: 100%;\n  border-radius: 10px;\n}\n\n.find-relevent-rwo {\n  padding: 0 50px;\n  margin-top: 55px;\n}\n\n.landing-section-4 .landing-common-description {\n  max-width: 65%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.landing-section-4 .landing-common-title {\n  max-width: 85%;\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n  .relevent-box {\n    width: 50%;\n    margin-bottom: 20px;\n  }\n  .find-relevent-rwo {\n    flex-wrap: wrap;\n  }\n  .relevent-box-content {\n    box-shadow: 0px 0px 5px rgba(155, 163, 171, 0.25);\n  }\n}\n@media (max-width: 767px) {\n  .relevent-box {\n    width: 100%;\n    margin-bottom: 20px;\n  }\n  .find-relevent-rwo {\n    padding: 0;\n    margin-top: 30px;\n    flex-wrap: wrap;\n  }\n  .relevent-box-content {\n    box-shadow: 0px 0px 5px rgba(155, 163, 171, 0.25);\n    padding: 20px 30px;\n    height: auto;\n    background-color: #eaeff7;\n  }\n  .relevent-box h4 {\n    font-size: 16px;\n    margin-bottom: 15px;\n  }\n  .landing-section-4 .landing-common-description {\n    max-width: 90%;\n  }\n  .technology-show-box-left, .technology-show-box-right {\n    margin-top: 10px;\n    margin-bottom: 10px;\n  }\n}\n.technology-cont-icon {\n  margin-right: 28px;\n}\n\n.technology-show-box-left,\n.technology-show-box-right {\n  margin-top: 30px;\n  margin-bottom: 30px;\n}\n\n.technology-cont-text h4 {\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 24px;\n  letter-spacing: 0.05em;\n  margin-bottom: 15px;\n}\n\n.technology-show-box-right {\n  padding-left: 50px;\n}\n\n.technology-show-box-left {\n  padding-right: 20px;\n}\n\n.landing-section-5 .landing-common-description {\n  max-width: 75%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.technology-show-row {\n  margin-top: 40px;\n}\n\n@media (max-width: 991px) {\n  .technology-show-row .technology-show-box {\n    align-items: flex-start !important;\n  }\n}\n@media (max-width: 767px) {\n  .landing-section-5 .landing-common-description {\n    max-width: 100%;\n  }\n  .technology-show-box-left {\n    padding-right: 15px;\n    padding-left: 15px;\n  }\n  .technology-show-box-right {\n    padding-left: 15px;\n  }\n  .technology-cont-text {\n    flex: 1;\n  }\n  .technology-cont-icon {\n    margin-right: 0;\n    width: 80px;\n    padding-top: 3px;\n    padding-right: 10px;\n  }\n  .technology-cont-icon img {\n    max-width: 100%;\n  }\n  .technology-show-row {\n    margin-top: 20px;\n  }\n  .technology-cont-text h4 {\n    font-size: 16px;\n  }\n  .technology-show-box-left,\n  .technology-show-box-right {\n    margin-top: 10px;\n    margin-bottom: 10px;\n  }\n}\n.discoversec-content-box-wrap {\n  margin: 0 -160px 0 -50px;\n}\n\n.discoversec-content-box {\n  background: #ffffff;\n  box-shadow: 0px 20px 20px rgba(59, 89, 134, 0.25);\n  padding: 45px 30px;\n  border-radius: 10px;\n}\n\n.discover-count-box h4 {\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 29px;\n  letter-spacing: 0.05em;\n}\n\n.discover-count-box h6 {\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 18px;\n  letter-spacing: 0.05em;\n}\n\n.discover-count-box label {\n  font-size: 11px;\n  line-height: 20px;\n  letter-spacing: 0.05em;\n}\n\n.discover-count-box {\n  margin-top: 30px;\n  margin-bottom: 30px;\n}\n\n.discoversec-content-box h3 {\n  font-weight: 800;\n  font-size: 30px;\n  line-height: 34px;\n  letter-spacing: 0.05em;\n  margin-bottom: 25px;\n}\n\n@media (min-width: 992px) and (max-width: 1024px) {\n  .discoversec-content-box-wrap {\n    margin-left: -20px;\n  }\n  .discoversec-content-box h3 {\n    font-size: 20px;\n    line-height: 26px;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .discoversec-content-box-wrap {\n    margin-left: 0;\n  }\n}\n@media (max-width: 767px) {\n  .discoversec-content-box-wrap {\n    margin: 0;\n  }\n  .discoversec-content-box h3 {\n    font-size: 20px;\n    line-height: 28px;\n    margin-bottom: 15px;\n  }\n  .discover-count-box h4 {\n    font-size: 20px;\n    line-height: 24px;\n  }\n  .discover-count-box h6 {\n    font-size: 13px;\n  }\n  .discoversec-content-box {\n    box-shadow: 0px 0px 10px rgba(59, 89, 134, 0.25);\n    padding: 20px 20px;\n    text-align: center;\n    margin-top: 20px;\n  }\n  .discover-count-box {\n    margin-top: 20px;\n    margin-bottom: 20px;\n  }\n  .discover-count-box label {\n    font-size: 11px;\n    line-height: 12px;\n  }\n}\n.experience-slider-box h4 {\n  font-weight: 800;\n  font-size: 18px;\n  line-height: 22px;\n  letter-spacing: 0.05em;\n  margin-bottom: 16px;\n}\n\n.experience-slider-box {\n  padding: 40px 20px;\n  background: #DDEAFC;\n  min-height: 191px;\n  box-shadow: 0px 2px 5px 0px #D5DFED;\n  border-radius: 10px;\n}\n\n.land-owl-prev,\n.land-owl-next {\n  margin: 5px;\n  border-radius: 3px;\n  cursor: pointer;\n  z-index: 1;\n}\n\n.land-owl-prev {\n  position: absolute;\n  left: -50px;\n  top: 50%;\n  margin-top: -35px !important;\n  background: transparent !important;\n  border: none;\n  color: #1A73E8 !important;\n  font-size: 50px !important;\n  width: auto !important;\n  height: auto !important;\n  line-height: 50px !important;\n  padding: 0 !important;\n}\n\n.land-owl-next {\n  position: absolute;\n  right: -50px;\n  top: 50%;\n  margin-top: -35px !important;\n  background: transparent !important;\n  border: none;\n  color: #1A73E8 !important;\n  font-size: 50px !important;\n  width: auto !important;\n  height: auto !important;\n  line-height: 50px !important;\n  padding: 0 !important;\n}\n\n.land-experience-slider-wrapper {\n  margin-top: 50px;\n}\n.land-experience-slider-wrapper .slick-list {\n  padding: 10px 0 30px;\n  margin: 0 -5px;\n}\n.land-experience-slider-wrapper .slick-slide > div {\n  padding: 0 5px;\n}\n.land-experience-slider-wrapper .land-carousel {\n  margin-bottom: 10px;\n}\n\n.landing-section-7 .landing-common-description {\n  max-width: 80%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.land-owl-next span, .land-owl-prev span {\n  position: relative;\n  top: -1px;\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n  .land-owl-next {\n    right: -30px;\n  }\n  .land-owl-prev {\n    left: -30px;\n  }\n  .experience-slider-box h4 {\n    font-size: 16px;\n  }\n}\n@media (max-width: 767px) {\n  .landing-section-7 .landing-common-description {\n    max-width: 100%;\n  }\n  .experience-slider-box {\n    padding-bottom: 60px;\n    min-height: 232px;\n  }\n  .land-owl-next {\n    right: calc(50% - 40px);\n  }\n  .land-owl-prev {\n    left: calc(50% - 40px);\n  }\n  .land-carousel .land-owl-next,\n  .land-carousel .land-owl-prev {\n    top: inherit;\n    bottom: 15px !important;\n    height: 30px !important;\n    width: 30px !important;\n    line-height: 20px !important;\n    font-size: 22px !important;\n    background: #ddeafc !important;\n    color: #000 !important;\n  }\n}\n.client-slider-section .slick-slide img {\n  width: auto;\n  max-height: 100%;\n  max-width: 100%;\n}\n\n.client-logo-wrap {\n  padding: 0 15px;\n}\n\n.landing-section-8 .land-carousel {\n  padding-bottom: 5px;\n}\n\n.client-logo-wrap {\n  padding: 0 15px;\n  height: 100px;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  flex: 1;\n  justify-content: center;\n}\n\n.client-logo-text {\n  font-weight: bold;\n  color: #A4A4A4;\n}\n\n@media (max-width: 767px) {\n  .landing-section-8 .landing-common-title {\n    margin-bottom: 10px;\n  }\n  .landing-section-8 .land-carousel .land-owl-next, .landing-section-8 .land-carousel .land-owl-prev {\n    bottom: -20px !important;\n  }\n}\n.land-contact-section-bg {\n  background-size: cover;\n  background-repeat: no-repeat;\n  position: absolute;\n  width: 50%;\n  bottom: 0;\n  pointer-events: none;\n  z-index: 1;\n  top: 0;\n  background-position: top;\n}\n\n.land-contact-section .textarea-item {\n  height: 70px;\n  border: none;\n  max-height: 70px;\n  min-height: 70px;\n}\n\n.contact-header label {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 22px;\n  text-align: center;\n  letter-spacing: 0.05em;\n  margin-bottom: 15px;\n}\n\n.PhoneInputCountry {\n  width: auto;\n  position: relative;\n  font-size: 12px;\n  padding-left: 58px;\n}\n\n.input-item.PhoneInput {\n  display: flex;\n  width: 100%;\n}\n\n.PhoneInputCountryIcon.PhoneInputCountryIcon--border {\n  position: absolute;\n  width: 58px;\n  height: auto;\n  left: 0px;\n  top: 0;\n}\n\nselect.PhoneInputCountrySelect {\n  background-color: #f3f5f7;\n  border-radius: 8px;\n  height: 39px;\n  border: none;\n  font-size: 12px;\n  width: 200px;\n  padding-left: 7px;\n}\n\n.PhoneInputInput {\n  background-color: #f3f5f7;\n  border-radius: 8px;\n  height: 39px;\n  border: none;\n  font-size: 12px;\n  width: 100%;\n  margin-left: 15px;\n  padding: 0 10px;\n}\n\nimg.PhoneInputCountryIconImg {\n  border-radius: 3px 0 0 3px;\n}\n\ninput.PhoneInputInput:focus, select.PhoneInputCountrySelect:focus {\n  border: none;\n  outline: none;\n}\n\n.land-contact-formwrap {\n  padding: 0 0 0 40px;\n}\n\n.land-contact-formwrap .landing-common-title {\n  max-width: 100%;\n}\n\n@media (min-width: 768px) {\n  .PhoneInputInput {\n    width: calc(50% + 1px);\n    margin-left: 24px;\n  }\n  .PhoneInputCountry {\n    width: 50%;\n  }\n  select.PhoneInputCountrySelect {\n    width: 100%;\n  }\n}\n@media (min-width: 1400px) {\n  .land-contact-section-bg {\n    width: 46%;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .land-contact-section-bg {\n    display: none;\n  }\n  .land-contact-space {\n    display: none;\n  }\n  .land-contact-formwrap {\n    padding: 0;\n  }\n}\n@media (max-width: 767px) {\n  .land-contact-formwrap {\n    padding: 0;\n  }\n  .land-contact-section-bg {\n    position: inherit;\n    height: 300px;\n    width: 100%;\n    background-position: top;\n  }\n  .land-contact-section {\n    padding: 0px 0 30px;\n  }\n  .input-item.PhoneInput {\n    flex-wrap: wrap;\n  }\n  .PhoneInputInput {\n    margin-left: 0;\n    margin-top: 10px;\n  }\n  .PhoneInputCountry {\n    width: 100%;\n  }\n  select.PhoneInputCountrySelect {\n    width: 100%;\n  }\n  .contact-header {\n    text-align: center;\n  }\n  .landing-section-8 {\n    padding: 30px 0 40px;\n  }\n  .land-contact-section form .btn {\n    width: 100%;\n  }\n}\n.landing-section-ai {\n  padding: 90px 0;\n  background-color: #DDEAFC;\n}\n.landing-section-ai .landing-common-title {\n  margin-left: 0;\n  max-width: 100%;\n}\n\n.icon-cont-box {\n  border-radius: 10px;\n  background: #FFF;\n  border-top: 7px solid transparent;\n  min-height: 150px;\n  height: 100%;\n  box-shadow: 0px 20px 20px 0px rgba(35, 66, 112, 0.24);\n  padding: 25px;\n  display: flex;\n  align-items: center;\n}\n.icon-cont-box .img-area {\n  margin: 0 24px 0 0;\n}\n.icon-cont-box:hover {\n  border-top: 7px solid #1A73E8;\n}\n\n@media (max-width: 767px) {\n  .landing-section-ai .landing-common-title {\n    text-align: center;\n  }\n  .landing-section-ai {\n    padding: 30px 0;\n  }\n}\n@media (max-width: 575px) {\n  .icon-cont-box {\n    min-height: 100%;\n  }\n}\n.land-video-box {\n  position: relative;\n  width: 100%;\n  max-width: 1000px;\n  margin: auto;\n  overflow: hidden;\n}\n\n.land-video-box::before {\n  content: \"\";\n  display: block;\n  padding-top: 56.25%;\n  /* 16:9 Aspect Ratio */\n}\n\n.land-video-box iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: none;\n  border-radius: 15px;\n}\n\n.video-frame-section {\n  padding: 71px 0 79px;\n  background-color: #DDEAFC;\n}\n\n.land-videoframe-header-box {\n  max-width: 687px;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 40px;\n}\n.land-videoframe-header-box .landing-common-title {\n  max-width: 100%;\n}\n\n@media (min-aspect-ratio: 16/9) {\n  .land-video-box {\n    max-height: 600px;\n    height: 100vw;\n    max-width: 1066.6666666667px;\n  }\n  .land-video-box::before {\n    padding-top: 0;\n  }\n}\n.banner-desc {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  letter-spacing: 0.05em;\n  color: #ffffff;\n}\n\n.about-content-sec {\n  padding: 80px 0;\n}\n\n.about-content-sec-2 {\n  background: #ddeafc;\n}\n\n.aboutus-head-wrap {\n  padding-left: 50px;\n}\n\n.aboutus-title {\n  font-weight: 800;\n  font-size: 28px;\n  line-height: 34px;\n  letter-spacing: 0.05em;\n  color: #000000;\n}\n\n.aboutus-desc-wrap p {\n  font-size: 13px;\n  line-height: 22px;\n  letter-spacing: 0.05em;\n  margin-bottom: 20px;\n}\n\n.aboutus-desc-wrap p:last-child {\n  margin-bottom: 0;\n}\n\n.aboutus-desc-wrap {\n  padding-right: 10%;\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n  .aboutus-title {\n    font-size: 20px;\n    line-height: 26px;\n  }\n  .aboutus-head-wrap {\n    padding-left: 30px;\n  }\n  .about-content-sec {\n    padding: 40px 0;\n  }\n}\n@media (max-width: 767px) {\n  .aboutus-head-wrap {\n    padding-left: 0px;\n  }\n  .about-content-sec {\n    padding: 30px 0 34px;\n    text-align: center;\n  }\n  .aboutus-desc-wrap {\n    padding-right: 0;\n  }\n  .aboutus-title {\n    font-size: 20px;\n    line-height: 26px;\n  }\n}\n.career-content-sec-2 {\n  background: #ddeafc;\n}\n\n.career-content-sec {\n  padding: 80px 0;\n}\n\n.career-content-sec-1 .landing-common-description {\n  max-width: 82%;\n}\n\n.career-content-sec .technology-cont-text p {\n  max-width: 80%;\n  margin-bottom: 0;\n}\n\n.careers-show-box-left, .careers-show-box-right {\n  margin: 30px 0;\n}\n\n.career-main-content {\n  margin: 0 auto;\n  max-width: 65%;\n}\n\n.career-main-content h6 {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 22px;\n  letter-spacing: 0.05em;\n  color: #000000;\n  margin-top: 34px;\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n  .career-content-sec {\n    padding: 50px 0;\n  }\n  .career-main-content {\n    max-width: 90%;\n  }\n}\n@media (max-width: 767px) {\n  .career-content-sec {\n    padding: 30px 0;\n  }\n  .career-content-sec .technology-cont-text p {\n    max-width: 100%;\n  }\n  .career-main-content {\n    max-width: 100%;\n  }\n}\n.sales-content-section-wrap {\n  background-color: #ddeafc;\n  padding: 77px 20px 60px;\n}\n\n.sales-enquiry-box {\n  max-width: 690px;\n  margin: 0 auto;\n  background: #fff;\n  padding: 50px 77px;\n  border-radius: 3px;\n}\n\n.sales-mail-text {\n  max-width: 690px;\n  margin: 0 auto;\n  text-align: center;\n  padding-top: 50px;\n}\n\n.sales-mail-text p {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 22px;\n  text-align: center;\n  letter-spacing: 0.05em;\n  color: #000000;\n}\n\n.sales-mail-text p a {\n  color: #1A73E8;\n}\n\n.sales-content-section-wrap .landing-common-title {\n  font-size: 28px;\n  max-width: 100%;\n}\n\n.sales-enquiry-box .form-control.textarea-item {\n  max-height: 66px;\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n  .sales-content-section-wrap .landing-common-title {\n    font-size: 20px;\n  }\n}\n@media (max-width: 767px) {\n  .sales-enquiry-box {\n    padding: 30px 20px;\n  }\n  .sales-content-section-wrap .landing-common-title {\n    font-size: 20px;\n  }\n  .sales-content-section-wrap {\n    background-color: #ddeafc;\n    padding: 30px 20px 20px;\n  }\n  .sales-mail-text {\n    padding-top: 30px;\n  }\n}\n.termsofuse-content p {\n  font-size: 13px;\n  line-height: 25px;\n  letter-spacing: 0.05em;\n  color: #000000;\n  margin-bottom: 25px;\n}\n\n.terms-sections p:last-child {\n  margin-bottom: 0;\n}\n\n.terms-sections {\n  padding: 35px 0;\n}\n\n.terms-title {\n  font-weight: 700;\n  font-size: 25px;\n  line-height: 30px;\n  letter-spacing: 0.05em;\n  margin-bottom: 0;\n}\n\n.terms-header p {\n  font-weight: 400;\n}\n\n.terms-gray-sec {\n  background: #ddeafc;\n}\n\n.terms-sub-header .terms-title {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 25px;\n  letter-spacing: 0.05em;\n  color: #000000;\n  margin-bottom: 20px;\n}\n\nspan.terms-content-sticking {\n  font-weight: bold;\n}\n\n.terms-title span {\n  margin-right: 5px;\n  display: inline-block;\n}\n\n.terms-header {\n  margin-bottom: 30px;\n}\n\n.terms-contents ol {\n  margin: 0;\n  padding-left: 15px;\n}\n\n.terms-contents ol li {\n  line-height: 24px;\n  margin-bottom: 20px;\n  padding-left: 15px;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 25px;\n  letter-spacing: 0.05em;\n  color: #000000;\n}\n\n.terms-contents ol li:last-child {\n  margin-bottom: 0;\n}\n\n@media (max-width: 767px) {\n  .terms-contents ol li {\n    margin-bottom: 10px;\n    line-height: 22px;\n  }\n  .terms-sub-header .terms-title {\n    font-size: 16px;\n    line-height: 22px;\n  }\n  .terms-title {\n    font-size: 20px;\n  }\n  .termsofuse-content p {\n    line-height: 22px;\n  }\n  .terms-sections {\n    padding: 30px 0;\n  }\n}\n.unified-sidebar {\n  width: 285px;\n  flex-shrink: 0;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 20px 12px 16px;\n  color: #1A1A1A;\n  font-family: \"Montserrat\", sans-serif;\n  background: #F4F6F7;\n  overflow: hidden;\n  transition: width 0.22s ease;\n}\n@media (min-width: 992px) {\n  .unified-sidebar.is-collapsed {\n    width: 64px;\n  }\n}\n@media (max-width: 991.98px) {\n  .unified-sidebar {\n    position: fixed;\n    top: 64px;\n    left: 0;\n    bottom: 0;\n    width: 300px;\n    max-width: 85vw;\n    transform: translateX(-100%);\n    transition: transform 0.25s ease;\n    z-index: 50;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n  }\n  .unified-sidebar.is-open {\n    transform: translateX(0);\n  }\n}\n@media (max-width: 767.98px) {\n  .unified-sidebar {\n    top: 56px;\n  }\n}\n\n.usb-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 0 14px;\n  padding: 0 6px;\n}\n.usb-header .usb-logo-title,\n.usb-header .usb-subtitle {\n  display: none;\n}\n\n.usb-icon-btn {\n  all: unset;\n  box-sizing: border-box;\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 8px;\n  color: #24252D;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n.usb-icon-btn svg {\n  display: block;\n  transition: transform 0.22s ease;\n}\n.usb-icon-btn:hover {\n  background-color: #E8EAED;\n  color: #1A1A1A;\n}\n.usb-icon-btn:focus-visible {\n  outline: 2px solid #1A73E8;\n  outline-offset: 2px;\n}\n@media (max-width: 991.98px) {\n  .usb-icon-btn {\n    width: 44px;\n    height: 44px;\n  }\n}\n\n.usb-section-label.usb-history-label {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0;\n  padding: 0;\n  font-size: 0;\n  text-transform: none;\n}\n.usb-section-label.usb-history-label .usb-new-chat-btn {\n  order: -1;\n}\n\n.usb-section-toggle {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: calc(100% - 16px);\n  margin: 4px 8px 2px;\n  padding: 6px 4px;\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #6B7280;\n  letter-spacing: 0.1px;\n  cursor: pointer;\n  text-align: left;\n}\n.usb-section-toggle:hover {\n  background: #E8EAED;\n  color: #1A1A1A;\n}\n\n.usb-section-chevron {\n  display: inline-block;\n  width: 10px;\n  transition: transform 0.15s ease;\n}\n.usb-section-chevron.is-open {\n  transform: rotate(90deg);\n}\n\n.usb-show-more-btn {\n  display: block;\n  margin: 0 8px 4px;\n  padding: 4px 12px;\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  font-size: 12px;\n  color: #A0A4AB;\n  cursor: pointer;\n}\n.usb-show-more-btn:hover {\n  background: #E8EAED;\n  color: #1A1A1A;\n}\n\n.usb-new-chat-btn {\n  all: unset;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  padding: 14px 16px;\n  background: #FFFFFF;\n  color: #1A1A1A;\n  border: 1px solid #DADCEB;\n  border-radius: 10px;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  box-shadow: 2px 2px 4px 0px rgba(238, 238, 238, 0.25);\n  transition: background-color 0.15s ease, box-shadow 0.15s ease;\n  box-sizing: border-box;\n  text-align: center;\n  font-size: 0;\n}\n.usb-new-chat-btn::before {\n  content: \"\";\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'><path d='M8 2.00004H3.33333C2.97971 2.00004 2.64057 2.14052 2.39052 2.39056C2.14048 2.64061 2 2.97975 2 3.33337V12.6667C2 13.0203 2.14048 13.3595 2.39052 13.6095C2.64057 13.8596 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8596 13.6095 13.6095C13.8595 13.3595 14 13.0203 14 12.6667V8.00004M12.2501 1.75003C12.5153 1.48481 12.875 1.33582 13.2501 1.33582C13.6251 1.33582 13.9848 1.48481 14.2501 1.75003C14.5153 2.01525 14.6643 2.37496 14.6643 2.75003C14.6643 3.1251 14.5153 3.48481 14.2501 3.75003L8.2414 9.75936C8.0831 9.91753 7.88753 10.0333 7.67273 10.096L5.7574 10.656C5.70003 10.6728 5.63922 10.6738 5.58134 10.6589C5.52345 10.6441 5.47061 10.614 5.42836 10.5717C5.38611 10.5295 5.35599 10.4766 5.34116 10.4188C5.32633 10.3609 5.32733 10.3001 5.34406 10.2427L5.90406 8.32736C5.96708 8.11273 6.08309 7.9174 6.2414 7.75936L12.2501 1.75003Z' stroke='%2324252D' stroke-width='1.2' stroke-linecap='round' stroke-linejoin='round'/></svg>\");\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n.usb-new-chat-btn::after {\n  content: \"New Chat\";\n  font-size: 14px;\n  font-weight: 500;\n}\n.usb-new-chat-btn:hover {\n  background: #FAFBFC;\n  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.08);\n}\n\n.usb-section-label {\n  padding: 8px 12px 4px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #6B7280;\n  letter-spacing: 0.1px;\n  text-transform: none;\n}\n\n.usb-empty {\n  padding: 12px 16px;\n  font-size: 13px;\n  color: #A0A4AB;\n}\n\n.usb-load-more-btn {\n  display: block;\n  width: calc(100% - 16px);\n  margin: 4px 8px 8px;\n  padding: 6px 12px;\n  background: transparent;\n  border: 1px solid #E5E7EB;\n  border-radius: 6px;\n  font-size: 12px;\n  color: #A0A4AB;\n  cursor: pointer;\n  text-align: center;\n}\n.usb-load-more-btn:hover {\n  background: #E8EAED;\n  color: #1A1A1A;\n}\n.usb-load-more-btn:disabled {\n  cursor: default;\n  opacity: 0.7;\n}\n.usb-load-more-btn:disabled:hover {\n  background: transparent;\n  color: #A0A4AB;\n}\n\n.usb-older {\n  margin-top: 8px;\n  border-top: 1px solid #E5E7EB;\n  padding-top: 4px;\n}\n\n.usb-retry-btn {\n  padding: 0;\n  background: transparent;\n  border: 0;\n  color: inherit;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.usb-loading {\n  pointer-events: none;\n}\n\n.usb-skeleton-item {\n  cursor: default;\n}\n.usb-skeleton-item:hover {\n  background: transparent;\n}\n\n.usb-skeleton-line {\n  display: block;\n  height: 10px;\n  border-radius: 5px;\n  background: linear-gradient(90deg, #E8EAED 0%, #f4f5f7 50%, #E8EAED 100%);\n  background-size: 200% 100%;\n  animation: usb-skeleton-shimmer 1.4s ease-in-out infinite;\n}\n\n@keyframes usb-skeleton-shimmer {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  .usb-skeleton-line {\n    animation: none;\n  }\n}\n.usb-history-scroll {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-width: thin;\n  scrollbar-color: #D5D8DC transparent;\n}\n.usb-history-scroll::-webkit-scrollbar {\n  width: 6px;\n}\n.usb-history-scroll::-webkit-scrollbar-thumb {\n  background: #D5D8DC;\n  border-radius: 3px;\n}\n.usb-history-scroll::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.usb-chat-list {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 4px;\n}\n\n.usb-chat-item {\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 10px 12px;\n  margin: 2px 0;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 400;\n  color: #1A1A1A;\n  cursor: pointer;\n  transition: background-color 0.12s ease;\n  gap: 8px;\n}\n.usb-chat-item .usb-item-menu-btn {\n  width: 26px;\n  height: 26px;\n  border: none;\n  background: transparent;\n  color: #6B7280;\n  border-radius: 6px;\n  opacity: 0;\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: opacity 0.15s ease, background-color 0.15s ease;\n  flex-shrink: 0;\n  margin-left: auto;\n}\n.usb-chat-item .usb-item-menu-btn:hover {\n  background: rgba(0, 0, 0, 0.06);\n  color: #1A1A1A;\n}\n@media (hover: none) {\n  .usb-chat-item .usb-item-menu-btn {\n    opacity: 1;\n  }\n}\n.usb-chat-item:hover {\n  background: #E8EAED;\n}\n.usb-chat-item:hover .usb-item-menu-btn {\n  opacity: 1;\n}\n.usb-chat-item .usb-row-menu.show .usb-item-menu-btn {\n  opacity: 1;\n}\n.usb-chat-item.active {\n  background: #E1E5EA;\n  color: #1A1A1A;\n  font-weight: 500;\n}\n.usb-chat-item.is-dragging {\n  z-index: 1;\n  background: #E8EAED;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n  cursor: grabbing;\n}\n\n.usb-chat-icon {\n  display: none;\n}\n\n.usb-pin-mark {\n  display: inline-flex;\n  flex-shrink: 0;\n  color: #1A73E8;\n}\n.usb-pin-mark svg {\n  transform: rotate(45deg);\n}\n\n.usb-chat-title {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.usb-rename-input {\n  flex: 1;\n  border: 1px solid #E5E7EB;\n  border-radius: 6px;\n  padding: 4px 8px;\n  font-family: inherit;\n  font-size: 13px;\n  color: #1A1A1A;\n  outline: none;\n  min-width: 0;\n}\n.usb-rename-input:focus {\n  border-color: #1A73E8;\n}\n\n.usb-rename-counter {\n  margin-left: 6px;\n  font-size: 11px;\n  font-variant-numeric: tabular-nums;\n  color: #A0A4AB;\n  flex-shrink: 0;\n}\n.usb-rename-counter.is-warning {\n  color: #B07A00;\n}\n.usb-rename-counter.is-danger {\n  color: #C22;\n  font-weight: 600;\n}\n\n.usb-rename-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin-left: 6px;\n  flex-shrink: 0;\n}\n.usb-rename-actions button {\n  all: unset;\n  width: 22px;\n  height: 22px;\n  border-radius: 4px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  color: #6B7280;\n  cursor: pointer;\n}\n.usb-rename-actions button:hover {\n  background: rgba(0, 0, 0, 0.06);\n  color: #1A1A1A;\n}\n.usb-rename-actions button:disabled, .usb-rename-actions button[disabled] {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n.usb-rename-actions button:disabled:hover, .usb-rename-actions button[disabled]:hover {\n  background: transparent;\n  color: #6B7280;\n}\n\n@media (min-width: 992px) {\n  .unified-sidebar.is-collapsed {\n    padding: 16px 10px;\n  }\n  .unified-sidebar.is-collapsed .usb-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n    padding: 0;\n    margin: 0 0 12px;\n  }\n  .unified-sidebar.is-collapsed .usb-panel-toggle {\n    order: 0;\n  }\n  .unified-sidebar.is-collapsed .usb-search-trigger {\n    order: 1;\n  }\n  .unified-sidebar.is-collapsed .usb-panel-toggle svg {\n    transform: rotate(180deg);\n  }\n  .unified-sidebar.is-collapsed .usb-section-label,\n  .unified-sidebar.is-collapsed .usb-chat-list,\n  .unified-sidebar.is-collapsed .usb-history-scroll,\n  .unified-sidebar.is-collapsed .usb-loading,\n  .unified-sidebar.is-collapsed .usb-empty {\n    display: none;\n  }\n  .unified-sidebar.is-collapsed .usb-section-label.usb-history-label {\n    display: block;\n    padding: 0;\n  }\n  .unified-sidebar.is-collapsed .usb-section-label.usb-history-label::after {\n    display: none;\n  }\n  .unified-sidebar.is-collapsed .usb-new-chat-btn {\n    all: unset;\n    box-sizing: border-box;\n    width: 32px;\n    height: 32px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    border-radius: 8px;\n    background: transparent;\n    border: none;\n    box-shadow: none;\n    padding: 0;\n    margin: 0;\n    transition: background-color 0.15s ease;\n  }\n  .unified-sidebar.is-collapsed .usb-new-chat-btn::after {\n    display: none;\n  }\n  .unified-sidebar.is-collapsed .usb-new-chat-btn::before {\n    width: 18px;\n    height: 18px;\n    margin: 0;\n  }\n  .unified-sidebar.is-collapsed .usb-new-chat-btn:hover {\n    background-color: #E8EAED;\n  }\n  .unified-sidebar.is-collapsed .usb-new-chat-btn:focus-visible {\n    outline: 2px solid #1A73E8;\n    outline-offset: 2px;\n  }\n}\n.usb-row-menu {\n  flex-shrink: 0;\n  margin-left: auto;\n  line-height: 1;\n}\n\n.usb-row-menu-list.dropdown-menu {\n  min-width: 160px;\n  padding: 6px;\n  border: 1px solid #E5E7EB;\n  border-radius: 10px;\n  background: #FFFFFF;\n  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.12);\n  font-size: 13px;\n  z-index: 60;\n}\n\n.usb-row-menu-item.dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  border-radius: 6px;\n  background: transparent;\n  border: none;\n  color: #1A1A1A;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.usb-row-menu-item.dropdown-item .usb-row-menu-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  color: #6B7280;\n  flex-shrink: 0;\n}\n.usb-row-menu-item.dropdown-item:hover, .usb-row-menu-item.dropdown-item:focus {\n  background: #E8EAED;\n  color: #1A1A1A;\n}\n.usb-row-menu-item.dropdown-item:hover .usb-row-menu-icon, .usb-row-menu-item.dropdown-item:focus .usb-row-menu-icon {\n  color: #1A1A1A;\n}\n.usb-row-menu-item.dropdown-item:active {\n  background: #E1E5EA;\n}\n.usb-row-menu-item.dropdown-item.usb-row-menu-item--danger {\n  color: #D92D20;\n}\n.usb-row-menu-item.dropdown-item.usb-row-menu-item--danger .usb-row-menu-icon {\n  color: #D92D20;\n}\n.usb-row-menu-item.dropdown-item.usb-row-menu-item--danger:hover, .usb-row-menu-item.dropdown-item.usb-row-menu-item--danger:focus {\n  background: rgba(217, 45, 32, 0.08);\n  color: #D92D20;\n}\n.usb-row-menu-item.dropdown-item.usb-row-menu-item--danger:hover .usb-row-menu-icon, .usb-row-menu-item.dropdown-item.usb-row-menu-item--danger:focus .usb-row-menu-icon {\n  color: #D92D20;\n}\n\n.dcm-dialog {\n  max-width: 380px;\n}\n.dcm-dialog .modal-content {\n  border: none;\n  border-radius: 12px;\n  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.18);\n}\n\n.dcm-body {\n  padding: 22px 22px 18px;\n}\n\n.dcm-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1A1A1A;\n  margin: 0 0 8px;\n}\n\n.dcm-text {\n  font-size: 14px;\n  line-height: 1.5;\n  color: #6B7280;\n  margin: 0 0 18px;\n}\n.dcm-text strong {\n  color: #1A1A1A;\n  font-weight: 600;\n  word-break: break-word;\n}\n\n.dcm-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.dcm-btn {\n  appearance: none;\n  border-radius: 8px;\n  padding: 8px 16px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  border: 1px solid transparent;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n.dcm-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.dcm-btn--cancel {\n  background: #FFFFFF;\n  border-color: #E5E7EB;\n  color: #1A1A1A;\n}\n.dcm-btn--cancel:hover:not(:disabled) {\n  background: #E8EAED;\n}\n\n.dcm-btn--danger {\n  background: #D92D20;\n  color: #fff;\n  border-color: #D92D20;\n}\n.dcm-btn--danger:hover:not(:disabled) {\n  background: #B42318;\n  border-color: #B42318;\n}\n\n.chat-search-modal .chat-search-modal-dialog {\n  max-width: 580px;\n  width: calc(100% - 32px);\n  margin: 0 auto;\n}\n.chat-search-modal .modal-content {\n  border: none;\n  border-radius: 14px;\n  box-shadow: 0 24px 48px rgba(16, 24, 40, 0.14), 0 2px 6px rgba(16, 24, 40, 0.06);\n  overflow: hidden;\n  background: #FFFFFF;\n}\n.chat-search-modal .modal-body {\n  padding: 0;\n}\n\n.csm-search {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 20px 24px;\n  border-bottom: 1px solid #EEF0F2;\n}\n\n.csm-search-icon {\n  width: 20px;\n  height: 20px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #1A1A1A;\n  flex-shrink: 0;\n}\n.csm-search-icon svg {\n  width: 20px;\n  height: 20px;\n}\n\n.csm-search-input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 15px;\n  font-weight: 400;\n  color: #1A1A1A;\n  line-height: 1.4;\n  padding: 0;\n}\n.csm-search-input::placeholder {\n  color: #9CA3AF;\n}\n\n.csm-close {\n  all: unset;\n  width: 24px;\n  height: 24px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #1A1A1A;\n  cursor: pointer;\n  border-radius: 6px;\n  flex-shrink: 0;\n  transition: background-color 0.15s ease;\n}\n.csm-close svg {\n  display: block;\n}\n@media (hover: hover) {\n  .csm-close:hover {\n    background: rgba(0, 0, 0, 0.04);\n  }\n}\n.csm-close:focus-visible {\n  outline: 2px solid #1A73E8;\n  outline-offset: 2px;\n}\n\n.csm-section-label {\n  padding: 18px 24px 10px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #1A1A1A;\n  letter-spacing: 0;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.csm-list {\n  list-style: none;\n  margin: 0;\n  padding: 0 0 12px;\n  max-height: min(420px, 60vh);\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: #D5D8DC transparent;\n}\n.csm-list::-webkit-scrollbar {\n  width: 6px;\n}\n.csm-list::-webkit-scrollbar-thumb {\n  background: #D5D8DC;\n  border-radius: 3px;\n}\n.csm-list::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.csm-row {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 11px 24px;\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: #1A1A1A;\n  cursor: pointer;\n  transition: background-color 0.12s ease;\n}\n@media (hover: hover) {\n  .csm-row:hover {\n    background: #E8EAED;\n  }\n}\n\n.csm-row-title {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.csm-row-pin {\n  display: inline-flex;\n  flex-shrink: 0;\n  color: #6B7280;\n}\n\n.csm-row-date {\n  flex-shrink: 0;\n  color: #6B7280;\n  font-size: 13px;\n  font-weight: 400;\n  white-space: nowrap;\n}\n\n.csm-empty {\n  padding: 20px 24px;\n  color: #A0A4AB;\n  font-size: 14px;\n  text-align: center;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n@media (max-width: 767px) {\n  .chat-search-modal .chat-search-modal-dialog {\n    max-width: 100%;\n    width: calc(100% - 16px);\n    margin: 8px auto;\n  }\n  .chat-search-modal .modal-content {\n    border-radius: 12px;\n  }\n  .csm-search {\n    padding: 16px 18px;\n    gap: 12px;\n  }\n  .csm-search-input {\n    font-size: 16px;\n  }\n  .csm-section-label {\n    padding: 14px 18px 8px;\n  }\n  .csm-list {\n    max-height: min(60vh, 100vh - 180px);\n  }\n  .csm-row {\n    padding: 12px 18px;\n    gap: 12px;\n  }\n  .csm-empty {\n    padding: 18px 18px;\n  }\n}\n@media (max-width: 480px) {\n  .chat-search-modal .chat-search-modal-dialog {\n    width: calc(100% - 12px);\n    margin: 6px auto;\n  }\n}\n.sources-panel {\n  flex-shrink: 0;\n  width: 360px;\n  background: #FFFFFF;\n  border-left: 1px solid #E5E7EB;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  animation: sp-slide-in 180ms ease-out;\n  z-index: 40;\n}\n@media (max-width: 1199.98px) {\n  .sources-panel {\n    width: 320px;\n  }\n}\n@media (max-width: 991.98px) {\n  .sources-panel {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    width: min(380px, 90%);\n    box-shadow: -4px 0 20px rgba(16, 24, 40, 0.08);\n    z-index: 60;\n  }\n}\n@media (max-width: 767.98px) {\n  .sources-panel {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    width: 100vw;\n    max-width: 100vw;\n    box-shadow: none;\n    z-index: 1080;\n  }\n}\n\n@keyframes sp-slide-in {\n  from {\n    transform: translateX(12px);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n.sources-panel-backdrop {\n  display: none;\n}\n@media (max-width: 991.98px) {\n  .sources-panel-backdrop {\n    display: block;\n    position: absolute;\n    inset: 0;\n    background: rgba(16, 24, 40, 0.25);\n    z-index: 55;\n  }\n}\n@media (max-width: 767.98px) {\n  .sources-panel-backdrop {\n    position: fixed;\n    z-index: 1079;\n    background: rgba(16, 24, 40, 0.4);\n  }\n}\n\n.sp-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 18px 20px;\n  border-bottom: 1px solid #E5E7EB;\n  flex-shrink: 0;\n  position: relative;\n  z-index: 1;\n  background: #FFFFFF;\n}\n\n.sp-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1A1A1A;\n}\n\n.sp-close-btn {\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: transparent;\n  color: #6B7280;\n  border-radius: 8px;\n  cursor: pointer;\n  padding: 0;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n.sp-close-btn:hover {\n  background: #E8EAED;\n  color: #1A1A1A;\n}\n\n.sp-view-switch {\n  display: flex;\n  gap: 4px;\n  margin: 12px 16px 0;\n  padding: 3px;\n  background: #E8EAED;\n  border-radius: 8px;\n  flex-shrink: 0;\n}\n\n.sp-view-btn {\n  flex: 1;\n  padding: 6px 10px;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  color: #6B7280;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n.sp-view-btn:hover {\n  color: #1A1A1A;\n}\n.sp-view-btn:focus-visible {\n  outline: 2px solid #1A73E8;\n  outline-offset: 1px;\n}\n.sp-view-btn.is-active {\n  background: #FFFFFF;\n  color: #1A1A1A;\n  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.08);\n}\n\n.sp-cards {\n  flex: 1;\n  overflow-y: auto;\n  padding: 12px 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.sp-card {\n  display: block;\n  text-decoration: none;\n  background: #FFFFFF;\n  border: 1px solid #E5E7EB;\n  border-radius: 10px;\n  padding: 12px 14px;\n  color: inherit;\n  cursor: pointer;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease, transform 0.15s ease;\n}\n.sp-card:hover {\n  border-color: #D1D5DB;\n  box-shadow: 0 2px 8px rgba(16, 24, 40, 0.06);\n}\n.sp-card:focus-visible {\n  outline: 2px solid #1A73E8;\n  outline-offset: 2px;\n}\n.sp-card--highlight {\n  animation: sp-flash 1.5s ease-out;\n}\n\n@keyframes sp-flash {\n  0% {\n    background: #E8F0FE;\n    border-color: #1A73E8;\n  }\n  60% {\n    background: #E8F0FE;\n    border-color: #1A73E8;\n  }\n  100% {\n    background: #FFFFFF;\n    border-color: #E5E7EB;\n  }\n}\n.sp-card-head {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.sp-card-index {\n  flex-shrink: 0;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #E8EAED;\n  color: #1A1A1A;\n  font-size: 11px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n  margin-top: 1px;\n}\n\n.sp-card-title {\n  flex: 1;\n  min-width: 0;\n  font-size: 13px;\n  font-weight: 500;\n  color: #1A1A1A;\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: break-word;\n}\n\n.sp-card-type {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 10px;\n  color: #6B7280;\n}\n\n.sp-card-type-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #6B7280;\n}\n\n.sp-card-type-label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.6px;\n  color: #6B7280;\n  text-transform: uppercase;\n}\n\n.unified-feed {\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  min-width: 0;\n  height: 100%;\n  background: #FFFFFF;\n  color: #1A1A1A;\n  font-family: \"Montserrat\", sans-serif;\n  position: relative;\n}\n\n.uf-main {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n  height: 100%;\n  transition: width 180ms ease, flex-basis 180ms ease;\n}\n\n.uf-header {\n  display: none;\n}\n\n.uf-title {\n  font-size: 26px;\n  font-weight: 700;\n  color: #1A1A1A;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  margin: 0;\n}\n\n.uf-beta-badge {\n  font-size: 11px;\n  font-weight: 600;\n  background: #e8e8e8;\n  color: #6B7280;\n  border-radius: 4px;\n  padding: 2px 7px;\n}\n\n.uf-subtitle {\n  font-size: 13px;\n  color: #A0A4AB;\n  margin: 6px 0 0;\n}\n\n.uf-messages {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 24px 60px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n.uf-messages > * {\n  width: 100%;\n  max-width: 720px;\n  margin-left: auto;\n  margin-right: auto;\n  min-width: 0;\n  box-sizing: border-box;\n}\n@media (max-width: 1199.98px) {\n  .uf-messages {\n    padding: 24px 32px;\n  }\n}\n@media (max-width: 991.98px) {\n  .uf-messages {\n    padding: 20px 24px;\n  }\n}\n@media (max-width: 575.98px) {\n  .uf-messages {\n    padding: 16px 12px;\n  }\n}\n\n.uf-empty-state {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  gap: 12px;\n  text-align: center;\n}\n.uf-empty-state p {\n  display: none;\n}\n\n.uf-empty-greeting {\n  font-size: 18px;\n  font-weight: 400;\n  color: #1A1A1A;\n  line-height: 1.4;\n}\n.uf-empty-greeting .uf-empty-name {\n  color: #A0A4AB;\n  font-weight: 400;\n}\n\n.uf-empty-heading {\n  font-size: 36px;\n  font-weight: 500;\n  color: #1A1A1A;\n  margin: 0 0 28px;\n  line-height: 1.2;\n}\n@media (max-width: 767.98px) {\n  .uf-empty-heading {\n    font-size: 26px;\n    margin-bottom: 20px;\n  }\n}\n@media (max-width: 575.98px) {\n  .uf-empty-heading {\n    font-size: 22px;\n  }\n}\n\n.uf-input-area {\n  flex-shrink: 0;\n  padding: 0 60px 16px;\n  border-top: none;\n}\n.uf-input-area > * {\n  width: 100%;\n  max-width: 720px;\n  margin-left: auto;\n  margin-right: auto;\n}\n@media (max-width: 1199.98px) {\n  .uf-input-area {\n    padding: 0 32px 16px;\n  }\n}\n@media (max-width: 991.98px) {\n  .uf-input-area {\n    padding: 0 24px 12px;\n  }\n}\n@media (max-width: 575.98px) {\n  .uf-input-area {\n    padding: 0 12px 8px;\n  }\n}\n\n.uf-empty-state .uf-input-area {\n  width: 100%;\n  max-width: 820px;\n  padding: 0;\n}\n.uf-empty-state .uf-input-area > * {\n  max-width: 820px;\n}\n\n.uf-mock-answer {\n  font-size: 14px;\n  color: #1A1A1A;\n  line-height: 1.6;\n  margin: 8px 0;\n}\n\n.uf-response-footer {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 10px;\n}\n.uf-response-footer .fdc-strip {\n  margin: 0;\n  flex: 1 1 auto;\n}\n.uf-response-footer .uf-show-refs-btn {\n  margin-top: 0;\n  margin-left: auto;\n  flex-shrink: 0;\n}\n\n.uf-show-refs-btn {\n  margin-top: 10px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: #FFFFFF;\n  border: 1px solid #E5E7EB;\n  border-radius: 20px;\n  padding: 6px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #1A1A1A;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n.uf-show-refs-btn svg {\n  color: #6B7280;\n}\n.uf-show-refs-btn:hover {\n  background: #E8EAED;\n  border-color: #D1D5DB;\n}\n.uf-show-refs-btn:hover svg {\n  color: #1A1A1A;\n}\n.uf-show-refs-btn.is-active {\n  background: #E8F0FC;\n  border-color: #1A73E8;\n  color: #1558B0;\n}\n.uf-show-refs-btn.is-active svg {\n  color: #1A73E8;\n}\n\n.uf-streaming-cursor {\n  display: inline-block;\n  color: #A0A4AB;\n  font-weight: 600;\n  animation: uf-blink 1s steps(1) infinite;\n}\n\n@keyframes uf-blink {\n  50% {\n    opacity: 0;\n  }\n}\n.uf-stream-skeleton {\n  align-self: stretch;\n  margin-top: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  animation: uf-stream-skeleton-breathe 3.6s ease-in-out infinite;\n}\n.uf-stream-skeleton__line {\n  display: block;\n  height: 12px;\n  border-radius: 6px;\n  background: linear-gradient(90deg, #E8EAED 0%, #F8F9FA 45%, #FFFFFF 50%, #F8F9FA 55%, #E8EAED 100%);\n  background-size: 220% 100%;\n  animation: uf-stream-shimmer 2.4s linear infinite;\n}\n.uf-stream-skeleton__line:nth-child(1) {\n  width: 92%;\n  animation-delay: 0s;\n}\n.uf-stream-skeleton__line:nth-child(2) {\n  width: 58%;\n  animation-delay: 0.3s;\n}\n\n@keyframes uf-stream-shimmer {\n  0% {\n    background-position: 220% 0;\n  }\n  100% {\n    background-position: -120% 0;\n  }\n}\n@keyframes uf-stream-skeleton-breathe {\n  0%, 100% {\n    opacity: 0.7;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  .uf-stream-skeleton,\n  .uf-stream-skeleton__line {\n    animation: none;\n  }\n}\n.uf-error-row {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 6px;\n}\n\n.uf-error-text {\n  font-size: 13px;\n  color: #D92D20;\n}\n\n.uf-retry-btn {\n  align-self: flex-start;\n  background: rgba(26, 115, 232, 0.1);\n  border: none;\n  border-radius: 8px;\n  padding: 7px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #1A73E8;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n.uf-retry-btn:hover {\n  background: rgba(26, 115, 232, 0.18);\n  color: #1558B0;\n}\n.uf-retry-btn:active {\n  transform: translateY(0.5px);\n}\n.uf-retry-btn:disabled {\n  background: rgba(160, 164, 171, 0.15);\n  color: #A0A4AB;\n  cursor: not-allowed;\n}\n\n.uf-stopped-notice {\n  font-size: 12px;\n  color: #A0A4AB;\n  margin-top: 6px;\n}\n\n.uf-finalizing-notice {\n  font-size: 12px;\n  color: #1A73E8;\n  margin-top: 6px;\n}\n\n.uf-error-row--inline {\n  border-top: 1px dashed #E5E7EB;\n  padding-top: 10px;\n  margin-top: 12px;\n}\n\n.uf-error-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: center;\n}\n\n.uf-legacy-banner {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  width: fit-content;\n  margin: 0 auto 12px;\n  padding: 10px 16px;\n  background: #F0F4FF;\n  border: 1px solid #DADCEB;\n  border-radius: 10px;\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 13px;\n  color: #6B7280;\n  line-height: 1.4;\n}\n\n.uf-legacy-new-chat-btn {\n  all: unset;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background: #FFFFFF;\n  color: #1A1A1A;\n  border: 1px solid #DADCEB;\n  border-radius: 10px;\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n  box-shadow: 2px 2px 4px 0px rgba(238, 238, 238, 0.25);\n  transition: background-color 0.15s ease, box-shadow 0.15s ease;\n  box-sizing: border-box;\n}\n.uf-legacy-new-chat-btn:hover {\n  background: #E8EAED;\n}\n\n.uf-input-area--readonly {\n  pointer-events: none;\n  opacity: 0.45;\n  user-select: none;\n}\n\n.user-message-row {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 4px;\n  padding: 0;\n  background: transparent;\n  border-radius: 0;\n}\n.user-message-row:hover .um-action-btn, .user-message-row:focus-within .um-action-btn {\n  opacity: 1;\n  visibility: visible;\n}\n\n.um-avatar {\n  display: none;\n}\n\n.um-bubble {\n  max-width: 75%;\n  padding: 12px 18px;\n  background: #F4F6F7;\n  color: #1A1A1A;\n  border-radius: 18px;\n  font-size: 15px;\n  line-height: 1.5;\n  word-wrap: break-word;\n}\n@media (max-width: 575.98px) {\n  .um-bubble {\n    max-width: 90%;\n    font-size: 14px;\n    padding: 10px 14px;\n  }\n}\n\n.um-action-btn {\n  width: 30px;\n  height: 30px;\n  flex-shrink: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: #A0A4AB;\n  border-radius: 6px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease, background-color 0.15s ease, color 0.15s ease;\n}\n.um-action-btn:hover {\n  background: #E8EAED;\n  color: #1A1A1A;\n}\n@media (hover: none) {\n  .um-action-btn {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n.um-action-btn.is-copied {\n  opacity: 1;\n  visibility: visible;\n  color: #1F8A4E;\n}\n.um-action-btn.is-copied:hover {\n  background: rgba(31, 138, 78, 0.08);\n  color: #1F8A4E;\n}\n\n.user-message-row--editing {\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.um-edit {\n  max-width: 75%;\n  background: #F4F6F7;\n  color: #1A1A1A;\n  border-radius: 18px;\n  padding: 12px 18px;\n}\n@media (max-width: 575.98px) {\n  .um-edit {\n    max-width: 90%;\n    padding: 10px 14px;\n  }\n}\n\n.um-edit-textarea {\n  display: block;\n  width: 100%;\n  min-width: 220px;\n  max-height: 320px;\n  resize: none;\n  border: none;\n  outline: none;\n  background: transparent;\n  color: #1A1A1A;\n  font-family: inherit;\n  font-size: 15px;\n  line-height: 1.5;\n  padding: 0;\n}\n.um-edit-textarea::placeholder {\n  color: #A0A4AB;\n}\n@media (max-width: 575.98px) {\n  .um-edit-textarea {\n    font-size: 14px;\n  }\n}\n\n.um-edit-actions {\n  margin-top: 8px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 8px;\n}\n\n.um-edit-cancel {\n  background: transparent;\n  border: 1px solid #E5E7EB;\n  border-radius: 999px;\n  padding: 5px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #1A1A1A;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n.um-edit-cancel:hover {\n  background: #E8EAED;\n  border-color: #D1D5DB;\n}\n\n.um-edit-send {\n  background: #1A73E8;\n  border: 1px solid #1A73E8;\n  border-radius: 999px;\n  padding: 5px 16px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #fff;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n.um-edit-send:hover {\n  background: #1558B0;\n  border-color: #1558B0;\n}\n.um-edit-send:disabled {\n  background: rgba(26, 115, 232, 0.45);\n  border-color: rgba(26, 115, 232, 0.45);\n  cursor: not-allowed;\n}\n\n.thought-process {\n  background: linear-gradient(179.91deg, #FFFFFF 0.08%, #F4F6F7 105.6%);\n  border: 1px solid #EAEAEA;\n  border-radius: 16px;\n  overflow: hidden;\n  margin-bottom: 16px;\n}\n\n.tp-header {\n  width: 100%;\n  background: transparent;\n  border: none;\n  padding: 18px 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 15px;\n  font-weight: 500;\n  color: #1A1A1A;\n  text-align: left;\n}\n\n.tp-header-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.tp-lead-icon {\n  color: #1A73E8;\n  flex-shrink: 0;\n}\n.is-thinking .tp-lead-icon {\n  animation: tp-pulse 1.6s ease-in-out infinite;\n}\n\n@keyframes tp-pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.45;\n  }\n}\n.tp-title {\n  color: #1A1A1A;\n  font-weight: 500;\n}\n.is-thinking .tp-title {\n  background: linear-gradient(90deg, #1A1A1A 0%, #1A1A1A 40%, rgba(26, 115, 232, 0.55) 50%, #1A1A1A 60%, #1A1A1A 100%);\n  background-size: 200% 100%;\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  color: transparent;\n  animation: tp-title-shimmer 2s linear infinite;\n}\n\n@keyframes tp-title-shimmer {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  .is-thinking .tp-title {\n    animation: none;\n    background: none;\n    -webkit-text-fill-color: #1A1A1A;\n    color: #1A1A1A;\n  }\n}\n.tp-chevron {\n  color: #A0A4AB;\n  transition: transform 0.2s ease;\n  flex-shrink: 0;\n}\n.tp-chevron.tp-chevron-up {\n  transform: rotate(180deg);\n}\n\n.tp-timeline {\n  list-style: none;\n  margin: 0;\n  padding: 4px 24px 22px 28px;\n  position: relative;\n}\n.tp-timeline::before {\n  content: \"\";\n  position: absolute;\n  left: 32px;\n  top: 12px;\n  bottom: 12px;\n  width: 1px;\n  background: rgba(26, 115, 232, 0.18);\n}\n\n.tp-phase {\n  position: relative;\n  padding-left: 18px;\n  padding-bottom: 14px;\n}\n.tp-phase:last-child {\n  padding-bottom: 0;\n}\n\n.tp-dot {\n  position: absolute;\n  left: -4px;\n  top: 6px;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #1A73E8;\n  box-shadow: 0 0 0 3px #fff;\n  z-index: 1;\n}\n\n.tp-phase.is-current .tp-dot {\n  background: #1A73E8;\n  animation: tp-dot-pulse 1.4s ease-in-out infinite;\n}\n\n@keyframes tp-dot-pulse {\n  0%, 100% {\n    box-shadow: 0 0 0 3px #fff, 0 0 0 0 rgba(26, 115, 232, 0.35);\n  }\n  50% {\n    box-shadow: 0 0 0 3px #fff, 0 0 0 6px rgba(26, 115, 232, 0);\n  }\n}\n.tp-phase-title {\n  font-size: 15px;\n  font-weight: 500;\n  color: #1A1A1A;\n  line-height: 1.45;\n}\n\n.tp-subs {\n  list-style: none;\n  margin: 6px 0 0;\n  padding: 0;\n}\n\n.tp-sub {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: 400;\n  color: #A0A4AB;\n  line-height: 1.55;\n  padding: 2px 0;\n}\n\n.tp-sub.is-done {\n  color: #6B7280;\n}\n\n.tp-check {\n  flex-shrink: 0;\n  margin-top: 4px;\n  width: 12px;\n  height: 12px;\n  color: #17D664;\n}\n\n.tp-sub-text {\n  flex: 1;\n  min-width: 0;\n}\n\n@media (max-width: 575.98px) {\n  .tp-header {\n    padding: 14px 18px;\n    font-size: 14px;\n  }\n  .tp-timeline {\n    padding: 4px 18px 18px 22px;\n  }\n  .tp-timeline::before {\n    left: 26px;\n  }\n  .tp-phase-title {\n    font-size: 14px;\n  }\n  .tp-sub {\n    font-size: 12px;\n  }\n}\n.ai-response-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 4px 0 24px;\n}\n.ai-response-row:hover .ar-actions, .ai-response-row:focus-within .ar-actions {\n  opacity: 1;\n  visibility: visible;\n}\n\n.ar-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.ar-avatar-img {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.ar-content {\n  flex: 1;\n  min-width: 0;\n  overflow-x: hidden;\n  color: #1A1A1A;\n  font-size: 15px;\n  line-height: 1.65;\n}\n.ar-content img, .ar-content table, .ar-content pre, .ar-content canvas, .ar-content svg {\n  max-width: 100%;\n}\n.ar-content table {\n  display: block;\n  overflow-x: auto;\n}\n\n.ar-actions {\n  display: flex;\n  gap: 4px;\n  margin-top: 12px;\n  padding-top: 0;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease;\n}\n@media (hover: none) {\n  .ar-actions {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n.ar-action-btn {\n  width: 30px;\n  height: 30px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: #A0A4AB;\n  border-radius: 6px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n.ar-action-btn:hover {\n  background: #E8EAED;\n  color: #1A1A1A;\n}\n.ar-action-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.4;\n}\n.ar-action-btn:disabled:hover {\n  background: transparent;\n  color: #A0A4AB;\n}\n.ar-action-btn.is-selected {\n  background: #1A73E8;\n  color: #fff;\n}\n.ar-action-btn.is-selected:hover {\n  background: #1A73E8;\n  color: #fff;\n}\n.ar-action-btn.is-copied {\n  color: #1F8A4E;\n}\n.ar-action-btn.is-copied:hover {\n  background: rgba(31, 138, 78, 0.08);\n  color: #1F8A4E;\n}\n\n.ar-download-dropdown {\n  display: inline-flex;\n  align-items: center;\n  line-height: 1;\n}\n.ar-download-dropdown.show ~ * { /* no-op selector to anchor the rule below */ }\n\n.ai-response-row:has(.ar-download-dropdown.show) .ar-actions,\n.ai-response-row .ar-download-dropdown.show {\n  opacity: 1;\n  visibility: visible;\n}\n\n.ar-download-menu.dropdown-menu {\n  min-width: 160px;\n  padding: 6px;\n  border: 1px solid #E5E7EB;\n  border-radius: 10px;\n  background: #FFFFFF;\n  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.12);\n  font-size: 13px;\n  z-index: 60;\n}\n.ar-download-menu.dropdown-menu:not([data-popper-placement]) {\n  visibility: hidden;\n}\n\n.ar-download-menu-item.dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  border-radius: 6px;\n  background: transparent;\n  border: none;\n  color: #1A1A1A;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.ar-download-menu-item.dropdown-item .ar-download-menu-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  color: #6B7280;\n  flex-shrink: 0;\n}\n.ar-download-menu-item.dropdown-item:hover, .ar-download-menu-item.dropdown-item:focus {\n  background: #E8EAED;\n  color: #1A1A1A;\n}\n.ar-download-menu-item.dropdown-item:hover .ar-download-menu-icon, .ar-download-menu-item.dropdown-item:focus .ar-download-menu-icon {\n  color: #1A1A1A;\n}\n.ar-download-menu-item.dropdown-item:active {\n  background: #E1E5EA;\n}\n\n@media (max-width: 767.98px) {\n  .ar-action-btn {\n    width: 44px;\n    height: 44px;\n    border-radius: 8px;\n  }\n}\n@media (max-width: 575.98px) {\n  .ai-response-row {\n    gap: 10px;\n  }\n  .ar-avatar {\n    width: 32px;\n    height: 32px;\n  }\n  .ar-content {\n    font-size: 14px;\n  }\n}\n.ref-chips-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin: 10px 0;\n}\n\n.ref-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 10px;\n  border-radius: 6px;\n  border: 1px solid #E5E7EB;\n  background: #fafafa;\n  font-size: 12px;\n  color: #333;\n}\n.ref-chip--code {\n  border-color: #c7d7ff;\n  background: #f0f4ff;\n}\n.ref-chip--doc {\n  border-color: #d1f7e0;\n  background: #f0fff4;\n}\n\n.ref-chip-icon {\n  display: flex;\n  align-items: center;\n  color: #666;\n}\n\n.ref-chip-label {\n  max-width: 120px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ref-chip-close {\n  border: none;\n  background: none;\n  cursor: pointer;\n  color: #999;\n  font-size: 14px;\n  line-height: 1;\n  padding: 0 0 0 2px;\n}\n.ref-chip-close:hover {\n  color: #333;\n}\n\n.fdc-strip {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 10px 0 4px;\n}\n\n.fdc-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 999px;\n  border: 1px solid #E5E7EB;\n  background: #fafafa;\n  font-size: 13px;\n  color: #333;\n  text-decoration: none;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n.fdc-chip:hover, .fdc-chip:focus-visible {\n  background: #f0f4ff;\n  border-color: #c7d7ff;\n  color: #1a1a1a;\n  text-decoration: none;\n}\n\n.fdc-chip-icon {\n  display: flex;\n  align-items: center;\n  color: #666;\n}\n\n.fdc-chip-label {\n  max-width: 220px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.fdc-chip--pptx,\n.fdc-chip--ppt {\n  background: #fff4ec;\n  border-color: #f3c9a8;\n  color: #b94a0c;\n}\n.fdc-chip--pptx:hover, .fdc-chip--pptx:focus-visible,\n.fdc-chip--ppt:hover,\n.fdc-chip--ppt:focus-visible {\n  background: #ffe9d6;\n  border-color: #e0a777;\n  color: #8e3808;\n}\n.fdc-chip--pptx .fdc-chip-icon,\n.fdc-chip--ppt .fdc-chip-icon {\n  color: #c4500d;\n}\n\n.fdc-chip--docx,\n.fdc-chip--doc {\n  background: #eef2fd;\n  border-color: #b9c9f0;\n  color: #1f3a7a;\n}\n.fdc-chip--docx:hover, .fdc-chip--docx:focus-visible,\n.fdc-chip--doc:hover,\n.fdc-chip--doc:focus-visible {\n  background: #dde5fb;\n  border-color: #9eb3eb;\n  color: #14275a;\n}\n.fdc-chip--docx .fdc-chip-icon,\n.fdc-chip--doc .fdc-chip-icon {\n  color: #2b579a;\n}\n\n.fdc-chip--xlsx,\n.fdc-chip--xls,\n.fdc-chip--csv {\n  background: #effaf3;\n  border-color: #b0e0bf;\n  color: #155a37;\n}\n.fdc-chip--xlsx:hover, .fdc-chip--xlsx:focus-visible,\n.fdc-chip--xls:hover,\n.fdc-chip--xls:focus-visible,\n.fdc-chip--csv:hover,\n.fdc-chip--csv:focus-visible {\n  background: #ddf3e4;\n  border-color: #8fcfa1;\n  color: #0f4429;\n}\n.fdc-chip--xlsx .fdc-chip-icon,\n.fdc-chip--xls .fdc-chip-icon,\n.fdc-chip--csv .fdc-chip-icon {\n  color: #217346;\n}\n\n.fdc-chip--pdf {\n  background: #fdecec;\n  border-color: #f0b9b9;\n  color: #952d27;\n}\n.fdc-chip--pdf:hover, .fdc-chip--pdf:focus-visible {\n  background: #fad9d9;\n  border-color: #e69e9e;\n  color: #74211c;\n}\n.fdc-chip--pdf .fdc-chip-icon {\n  color: #c0392b;\n}\n\n.fdc-chip--zip {\n  background: #fdf6e3;\n  border-color: #ebd99c;\n  color: #7e5a14;\n}\n.fdc-chip--zip:hover, .fdc-chip--zip:focus-visible {\n  background: #faecc9;\n  border-color: #d9c47d;\n  color: #614410;\n}\n.fdc-chip--zip .fdc-chip-icon {\n  color: #b7791f;\n}\n\n.input-toolbar {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 6px;\n  flex: 1;\n  min-width: 0;\n}\n\n.it-buttons {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex: 1;\n  min-width: 0;\n}\n\n.it-dropdown-wrap {\n  position: relative;\n  flex-shrink: 0;\n}\n.it-dropdown-wrap--sources {\n  margin-left: auto;\n}\n\n.it-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: transparent;\n  border: none;\n  color: #1A1A1A;\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 7px 10px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n  white-space: nowrap;\n}\n.it-btn:hover {\n  background: #E8EAED;\n}\n.it-btn .it-btn-icon,\n.it-btn .it-btn-chevron {\n  color: currentColor;\n  flex-shrink: 0;\n}\n\n.it-group-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  background: #FFFFFF;\n  border: 1px solid #E5E7EB;\n  border-radius: 999px;\n  padding: 2px 4px 2px 10px;\n  font-size: 12px;\n  max-width: 220px;\n  min-width: 0;\n  flex-shrink: 1;\n}\n\n.it-group-pill-body {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: transparent;\n  border: none;\n  padding: 2px 0;\n  color: #1A1A1A;\n  cursor: pointer;\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 12px;\n  min-width: 0;\n}\n.it-group-pill-body:hover .it-group-pill-label {\n  color: #1A73E8;\n}\n\n.it-group-pill-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #1A73E8;\n  flex-shrink: 0;\n}\n\n.it-group-pill-label {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n.it-group-pill-close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border: none;\n  background: transparent;\n  color: #A0A4AB;\n  font-size: 16px;\n  line-height: 1;\n  cursor: pointer;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n.it-group-pill-close:hover {\n  background: #E8EAED;\n  color: #1A1A1A;\n}\n\n.it-popup {\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 0;\n  min-width: 260px;\n  max-height: min(420px, 65vh);\n  display: flex;\n  flex-direction: column;\n  background: #FFFFFF;\n  border: 1px solid #E5E7EB;\n  border-radius: 12px;\n  box-shadow: 0 12px 28px rgba(16, 24, 40, 0.14);\n  z-index: 50;\n  overflow: hidden;\n}\n.it-popup--right {\n  right: 0;\n  left: auto;\n}\n\n.it-popup-body {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 14px 16px;\n  overflow-y: auto;\n  overscroll-behavior-y: none;\n  flex: 1;\n  min-height: 0;\n}\n\n.it-popup-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 6px 4px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n  color: #1A1A1A;\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 15px;\n  border-radius: 6px;\n  transition: background-color 0.12s ease;\n}\n.it-popup-row:hover:not(.disabled) {\n  background: #E8EAED;\n}\n.it-popup-row.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.it-popup-check {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 4px;\n  border: 1px solid #D0D5DD;\n  background: #F2F4F7;\n  flex-shrink: 0;\n  transition: background-color 0.12s ease, border-color 0.12s ease;\n}\n.it-popup-check--checked {\n  background: #1A73E8;\n  border-color: #1A73E8;\n}\n\n.it-popup-label {\n  line-height: 1.4;\n  flex: 1;\n  min-width: 0;\n}\n\n.it-popup-coming-soon {\n  flex-shrink: 0;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n  color: #A0A4AB;\n  background: #E8EAED;\n  border: 1px solid #E5E7EB;\n  border-radius: 4px;\n  padding: 2px 5px;\n  line-height: 1.4;\n}\n\n.it-popup-divider {\n  height: 1px;\n  background: rgba(0, 0, 0, 0.1);\n  margin: 6px -16px;\n  border: 0;\n  flex-shrink: 0;\n}\n\n.it-popup-footer {\n  display: flex;\n  border-top: 1px solid #E5E7EB;\n}\n\n.it-popup-footer-btn {\n  flex: 1;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 15px;\n  height: 52px;\n  transition: background-color 0.12s ease;\n}\n.it-popup-footer-btn:hover {\n  background: #E8EAED;\n}\n.it-popup-footer-btn--cancel {\n  color: #1A1A1A;\n  border-right: 1px solid #E5E7EB;\n}\n.it-popup-footer-btn--done {\n  color: #1A73E8;\n  font-weight: 600;\n}\n\n.uib-chips-strip {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 6px;\n  padding: 0 4px 8px;\n  overflow-x: auto;\n  scrollbar-width: none;\n}\n.uib-chips-strip::-webkit-scrollbar {\n  display: none;\n}\n.uib-chips-strip .it-group-pill {\n  max-width: none;\n  flex-shrink: 0;\n}\n\n@media (max-width: 479.98px) {\n  .it-btn {\n    padding: 6px 8px;\n    font-size: 13px;\n  }\n  .it-popup {\n    min-width: 240px;\n    max-height: 250px;\n  }\n}\n@media (max-width: 360px) {\n  .it-group-pill-label {\n    display: none;\n  }\n  .it-group-pill {\n    max-width: 56px;\n    padding: 2px 4px;\n  }\n  .it-btn {\n    gap: 4px;\n    font-size: 12px;\n    padding: 5px 6px;\n  }\n}\n.unified-input-bar {\n  width: 100%;\n  font-family: \"Montserrat\", sans-serif;\n}\n.unified-input-bar.uib-disabled .uib-card {\n  opacity: 0.85;\n}\n\n.uib-card {\n  background: #FFFFFF;\n  border: 1px solid #E5E7EB;\n  border-radius: 16px;\n  box-shadow: 0 4px 14px rgba(16, 24, 40, 0.08);\n  padding: 16px 18px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.uib-textarea {\n  width: 100%;\n  border: none;\n  outline: none;\n  resize: none;\n  font-size: 15px;\n  color: #1A1A1A;\n  line-height: 1.5;\n  background: transparent;\n  padding: 4px 2px;\n  font-family: inherit;\n}\n.uib-textarea::placeholder {\n  color: #A0A4AB;\n}\n\n.uib-controls {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.uib-controls-left {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  flex: 1;\n}\n\n.uib-controls-right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.uib-attach-btn {\n  width: 34px;\n  height: 34px;\n  border: 1px solid #BABABA;\n  background: #FFFFFF;\n  border-radius: 50%;\n  color: #000000;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  padding: 0;\n  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n.uib-attach-btn:hover:not(:disabled) {\n  background: #F9FAFB;\n  border-color: #9AA0A6;\n}\n.uib-attach-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.uib-send-btn {\n  width: 34px;\n  height: 34px;\n  border: none;\n  background: #1A1A1A;\n  color: #FFFFFF;\n  border-radius: 50%;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  padding: 0;\n  transition: background-color 0.15s ease;\n}\n.uib-send-btn svg {\n  transform: translate(1px, -1px);\n}\n.uib-send-btn:hover:not(:disabled) {\n  background: #000;\n}\n.uib-send-btn:disabled {\n  background: #C9CCD1;\n  color: #FFFFFF;\n  cursor: not-allowed;\n}\n.uib-send-btn--stop {\n  background: #1A1A1A;\n  color: #FFFFFF;\n  cursor: pointer;\n}\n.uib-send-btn--stop svg {\n  transform: none;\n}\n.uib-send-btn--stop:hover {\n  background: #000;\n}\n\n.uib-char-count {\n  display: none;\n}\n.uib-char-count--visible {\n  display: inline-block;\n  margin-right: 8px;\n  font-size: 12px;\n  font-variant-numeric: tabular-nums;\n  color: #A0A4AB;\n}\n.uib-char-count--warning {\n  color: #B07A00;\n}\n.uib-char-count--danger {\n  color: #C22;\n  font-weight: 600;\n}\n\n.uib-disclaimer {\n  text-align: center;\n  font-size: 12px;\n  color: #A0A4AB;\n  padding: 10px 0 0;\n}\n\n.uib-attachment-list {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 10px;\n  padding: 2px 0;\n  overflow-x: auto;\n  overflow-y: hidden;\n  scrollbar-width: thin;\n  scrollbar-color: #E5E7EB transparent;\n}\n.uib-attachment-list::-webkit-scrollbar {\n  height: 6px;\n}\n.uib-attachment-list::-webkit-scrollbar-track {\n  background: transparent;\n}\n.uib-attachment-list::-webkit-scrollbar-thumb {\n  background: #E5E7EB;\n  border-radius: 3px;\n}\n\n.uib-att-tile {\n  position: relative;\n  width: 72px;\n  height: 72px;\n  flex: 0 0 72px;\n  border-radius: 12px;\n  background: #F3F4F6;\n  border: 1px solid #E5E7EB;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.uib-att-tile--image {\n  background: #E5E7EB;\n}\n\n.uib-att-name {\n  display: none;\n}\n\n.uib-att-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.uib-att-file-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n}\n\n.uib-att-remove {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(17, 24, 39, 0.75);\n  color: #FFFFFF;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n  transition: background-color 0.15s ease;\n}\n.uib-att-remove:hover {\n  background: rgba(17, 24, 39, 0.95);\n}\n.uib-att-remove:focus-visible {\n  outline: 2px solid #2563EB;\n  outline-offset: 1px;\n}\n\n@media (max-width: 767.98px) {\n  .uib-att-tile:not(.uib-att-tile--image) {\n    height: 88px;\n    flex-direction: column;\n    justify-content: center;\n    gap: 2px;\n    padding: 6px 4px 4px;\n  }\n  .uib-att-name {\n    display: block;\n    font-size: 9px;\n    line-height: 1.2;\n    color: #6B7280;\n    text-align: center;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    word-break: break-all;\n    max-width: 100%;\n    padding: 0 2px;\n  }\n}\n@media (max-width: 575.98px) {\n  .uib-card {\n    padding: 12px 14px 10px;\n    border-radius: 14px;\n  }\n  .uib-textarea {\n    font-size: 14px;\n  }\n  .uib-attach-btn,\n  .uib-send-btn {\n    width: 32px;\n    height: 32px;\n  }\n  .uib-att-tile:not(.uib-att-tile--image) {\n    width: 64px;\n    flex-basis: 64px;\n  }\n  .uib-att-tile--image {\n    width: 64px;\n    height: 64px;\n    flex-basis: 64px;\n  }\n  .uib-att-file-icon {\n    width: 38px;\n    height: 38px;\n  }\n}\n.unified-chat-wrap {\n  height: calc(100vh - 64px);\n  overflow: hidden;\n  background: #F4F6F7;\n  position: relative;\n}\n@media (max-width: 767.98px) {\n  .unified-chat-wrap {\n    height: calc(100vh - 56px);\n  }\n}\n\n.unified-chat-layout {\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n}\n\n.unified-main-pane {\n  flex: 1;\n  min-width: 0;\n  background: #FFFFFF;\n  overflow: hidden;\n  display: flex;\n}\n\n.unified-chat-hamburger {\n  display: none;\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  z-index: 20;\n  width: 40px;\n  height: 40px;\n  border: none;\n  background: #FFFFFF;\n  border-radius: 8px;\n  color: #1A1A1A;\n  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);\n  cursor: pointer;\n  align-items: center;\n  justify-content: center;\n}\n@media (max-width: 991.98px) {\n  .unified-chat-hamburger {\n    display: inline-flex;\n  }\n}\n\n.unified-chat-backdrop {\n  display: none;\n  position: fixed;\n  top: 64px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.35);\n  z-index: 40;\n}\n@media (max-width: 991.98px) {\n  .unified-chat-backdrop.is-open {\n    display: block;\n  }\n}\n@media (max-width: 767.98px) {\n  .unified-chat-backdrop {\n    top: 56px;\n  }\n}\n\n.chat-section-whole-wrap {\n  height: calc(100vh - 122px);\n  background: #f3f5f7;\n  padding: 22px 0;\n}\n\n.chat-sidebar-box {\n  padding: 0;\n}\n\n.chat-feed {\n  padding: 0;\n  border-left: 1px solid #E9E9E9;\n  flex: 1;\n}\n\n.chat-sidebar {\n  width: 317px;\n  padding: 0 24px 20px;\n  background-color: #fff;\n  border-radius: 20px 0 0 20px;\n}\n\n.chat-results-scroll {\n  max-height: 70vh;\n}\n\n.chat-results-show-box {\n  padding-bottom: 20px;\n}\n\n.chat-height-control {\n  height: 100%;\n}\n\n.newchat-center-fix {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n.newchat-center-fix .chat-textarea-wrap {\n  position: inherit;\n  padding-top: 80px;\n}\n@media (max-height: 730px) {\n  .newchat-center-fix .chat-textarea-wrap {\n    padding-top: 60px;\n  }\n}\n.newchat-center-fix .chat-height-control {\n  height: auto;\n}\n\n@media (max-width: 1200px) {\n  .chat-sidebar {\n    width: 270px;\n    padding: 0 10px 20px;\n  }\n}\n@media (min-width: 992px) {\n  .mobil-header {\n    display: none !important;\n  }\n  .mobile-menu-view-button {\n    display: none;\n  }\n}\n@media (max-width: 991px) {\n  .chat-sidebar {\n    width: auto;\n  }\n  .mobil-header {\n    display: flex;\n    padding: 6px 20px;\n    background: #1A73E8;\n    border-radius: 20px 20px 0 0;\n  }\n  .mobil-menu-slide {\n    height: 100%;\n    left: 0;\n    position: fixed;\n    top: 0;\n    -webkit-transform: translateX(100%);\n    transform: translateX(100%);\n    visibility: hidden;\n    width: 100%;\n    z-index: 99;\n    transition: all 0.4s;\n  }\n  .ai-mobilemenu-active {\n    transform: translateX(0);\n    visibility: visible;\n    background: #fff;\n    z-index: 2000;\n  }\n  .mobil-menu-slide .sidebar-header {\n    display: none;\n  }\n  .mobile-menu-close-button {\n    z-index: 2001;\n    position: fixed;\n    right: 20px;\n    top: 14px;\n    cursor: pointer;\n  }\n  .mobile-menu-view-button svg,\n  .mobile-menu-close-button svg {\n    width: 30px;\n    height: 30px;\n  }\n  .mobile-menu-view-button {\n    cursor: pointer;\n  }\n  .mobile-menu-view-button svg path {\n    fill: #fff;\n  }\n  .mobile-chat-logo h3 {\n    font-size: 16px;\n    font-weight: 500;\n    color: #fff;\n    margin: 0;\n  }\n  .mobile-chat-logo .poweredby-text {\n    font-size: 12px;\n    color: #fff;\n  }\n  .chat-sidebar-box {\n    padding: 0;\n  }\n  .mobile-menu-view-button .mob-close-btn {\n    display: none;\n  }\n  .mobile-menu-close-button .mob-open-btn {\n    display: none;\n  }\n  .mobile-menu-close-button .mob-close-btn {\n    display: block;\n  }\n  .mob-close-btn {\n    font-size: 44px;\n    line-height: 30px;\n    color: #000;\n    font-weight: 300;\n  }\n}\n@media (max-width: 767px) {\n  .chat-feed {\n    flex: inherit;\n    width: 100%;\n    padding-bottom: 0;\n    border: none;\n  }\n  .newchat-center-fix .chat-textarea-wrap {\n    position: fixed;\n  }\n  .chat-section-whole-wrap {\n    height: auto;\n    padding-bottom: 0;\n    min-height: calc(100vh - 150px);\n    padding-top: 5px;\n  }\n  .newchat-center-fix .chat-textarea-wrap {\n    padding-top: 50px;\n  }\n}\n.infinite-scroll-component {\n  min-height: 200px;\n}\n\n.chat-feed-wrap {\n  background-color: #fff;\n  padding: 25px 10px 34px;\n  border-radius: 0 20px 20px 0;\n}\n@media (max-width: 991px) {\n  .chat-feed-wrap {\n    border-radius: 0 0 20px 20px;\n  }\n}\n\n.feed-tiles-wrap {\n  max-width: 700px;\n  margin: 0 auto;\n}\n\n.chat-beta-text {\n  color: #1a73e8;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: -0.2px;\n  border-radius: 2px;\n  background: rgba(26, 115, 232, 0.2);\n  display: block;\n  margin-left: 8px;\n  padding: 1px 3px;\n}\n\n.chat-header-inline h4 {\n  margin: 0;\n  color: #000;\n  font-size: 22px;\n  font-weight: 600;\n  letter-spacing: -0.44px;\n}\n\n.chat-header-inline {\n  margin-bottom: 9px;\n}\n\n.chat-feed-header p {\n  color: rgba(37, 37, 37, 0.8);\n  font-size: 14px;\n  font-weight: 400;\n  line-height: normal;\n  text-transform: capitalize;\n  margin-bottom: 0;\n}\n\n.chat-feed-header {\n  margin-bottom: 50px;\n}\n\n.feed-whole-box {\n  max-width: 870px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n@media (max-height: 900px) {\n  .chat-feed-header {\n    margin-bottom: 35px;\n  }\n  .chat-feed-wrap {\n    padding: 20px 10px;\n  }\n}\n@media (max-height: 760px) {\n  .chat-feed-header {\n    margin-bottom: 25px;\n  }\n  .chat-header-inline {\n    margin-bottom: 5px;\n  }\n  .chat-feed-wrap {\n    padding: 20px 10px;\n  }\n}\n@media (max-width: 767px) {\n  .chat-feed-wrap {\n    padding: 10px 0px;\n  }\n  .cs-message-list__scroll-wrapper {\n    padding-right: 0.8em;\n  }\n  .feed-tiles-wrap {\n    padding-bottom: 0px;\n    height: 100%;\n  }\n}\n#scrollableDiv {\n  height: calc(100vh - 400px);\n  overflow-y: auto;\n  margin-right: -19px;\n  margin-left: -8px;\n}\n#scrollableDiv .infinite-scroll-component__outerdiv {\n  padding-right: 7px;\n}\n@media (max-width: 767px) {\n  #scrollableDiv {\n    height: calc(100vh - 280px);\n  }\n}\n\n.previous-chat-boxes::-webkit-scrollbar {\n  width: 8px;\n}\n.previous-chat-boxes::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px #fff;\n}\n.previous-chat-boxes::-webkit-scrollbar-thumb {\n  background-color: #cfd7e1;\n  outline: none;\n  border-radius: 10px;\n  cursor: all-scroll;\n}\n.previous-chat-boxes {\n  margin-right: 0;\n}\n\n.previous-chat-box {\n  padding-top: 30px;\n  margin-bottom: 20px;\n  border-top: 1px solid #d9d9d9;\n  padding-right: 0;\n  padding-left: 8px;\n}\n.previous-chat-box h3 {\n  color: #5b5b5b;\n  font-size: 15px;\n  font-weight: 600;\n  letter-spacing: -0.3px;\n}\n.previous-chat-box:first-child {\n  border-top: none;\n  padding-top: 0;\n}\n@media (max-height: 900px) {\n  .previous-chat-box {\n    padding-bottom: 30px;\n    margin-bottom: 30px;\n  }\n}\n@media (max-height: 800px) {\n  .previous-chat-box {\n    padding-bottom: 20px;\n    margin-bottom: 20px;\n  }\n}\n@media (max-height: 760px) {\n  .previous-chat-box {\n    padding-bottom: 15px;\n    margin-bottom: 15px;\n  }\n}\n\n.side-query-row {\n  padding: 2px 0 0 8px;\n  background-color: transparent;\n  border-radius: 6px;\n  position: relative;\n  left: -8px;\n}\n.side-query-row:hover {\n  background-color: #f3f5f7;\n  transition: all ease 0.5s;\n}\n.side-query-row:hover .side-query-more {\n  opacity: 1;\n}\n\n.side-query-text {\n  display: flex;\n  align-items: center;\n  flex: 1;\n}\n@media (max-height: 900px) {\n  .side-query-text {\n    font-size: 13px;\n    line-height: 26px;\n  }\n}\n\n.side-query-row:hover .side-query-text-content::after {\n  display: none;\n}\n\n.side-query-text-content {\n  color: #828a92;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 32px;\n  white-space: nowrap;\n  overflow: hidden;\n  position: relative;\n  flex: 1;\n  max-width: 230px;\n}\n.side-query-text-content::after {\n  position: absolute;\n  width: 40px;\n  height: 20px;\n  content: \"\";\n  position: absolute;\n  right: 0;\n  top: 7px;\n  background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 50%, rgb(255, 255, 255) 100%);\n}\n\n.side-query-icon {\n  width: 30px;\n}\n\n.side-query-more {\n  position: absolute;\n  right: 3px;\n  bottom: 0;\n  top: 0;\n  display: flex;\n  opacity: 0;\n  align-items: center;\n  padding-left: 8px;\n  background-color: #f3f5f7;\n  z-index: 100;\n}\n@media (max-width: 991px) {\n  .side-query-more {\n    opacity: 1;\n    background-color: transparent;\n  }\n}\n.side-query-more .chat-more-dpdn {\n  width: 20px;\n  min-width: 0;\n  padding: 0;\n  background: transparent;\n  text-align: center;\n  height: auto;\n}\n.side-query-more .chat-more-dpdn:active {\n  background-color: transparent;\n  border: none;\n}\n.side-query-more .chat-more-dpdn:hover svg rect {\n  fill-opacity: 1;\n  transition: all ease 0.5s;\n}\n.side-query-more .chat-more-dpdn.dropdown-toggle::after {\n  display: none;\n}\n.side-query-more .dropdown-menu {\n  border: none;\n  box-shadow: 0 0 5px #999;\n  min-width: 0;\n  margin-right: 8px;\n}\n.side-query-more a.dropdown-item {\n  font-size: 13px;\n}\n\n.previous-chat-text {\n  color: #5b5b5b;\n  font-size: 13px;\n  font-weight: 400;\n  letter-spacing: -0.26px;\n  margin-bottom: 20px;\n}\n\n.no-history-box {\n  background: #f3f5f7;\n  padding: 20px 12px;\n  border-radius: 10px;\n}\n.no-history-box h3 {\n  font-weight: 600;\n  font-size: 16px;\n  letter-spacing: 0.5px;\n  text-transform: capitalize;\n  margin-bottom: 12px;\n}\n.no-history-box p {\n  font-size: 13px;\n  color: #5b5b5b;\n  line-height: 22px;\n  margin: 0;\n}\n\n.chat-side-loader-middle {\n  display: flex;\n  min-height: 120px;\n  align-items: center;\n  justify-content: center;\n}\n\n.query-edit-input {\n  flex: 1;\n}\n.query-edit-input .side-query-edit-input {\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  height: 28px;\n  padding: 0 5px;\n  width: 100%;\n  margin-bottom: 2px;\n}\n.query-edit-input .side-query-edit-input:focus, .query-edit-input .side-query-edit-input:focus-visible {\n  border: 1px solid #ddd;\n  outline: none;\n}\n\n.query-edit-action-icon {\n  width: 26px;\n  height: 26px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n.query-edit-action-icon:hover {\n  opacity: 0.8;\n}\n.query-edit-action-icon path {\n  fill: #1A73E8;\n}\n.query-edit-action-icon svg {\n  width: 18px;\n  height: 18px;\n}\n\n.query-edit-action-icons {\n  width: fit-content;\n  padding-left: 10px;\n}\n\n.side-query-edit-row {\n  width: 100%;\n}\n\n@media (max-height: 800px) {\n  .previous-chat-scroll {\n    max-height: calc(100vh - 370px);\n  }\n}\n@media (max-height: 760px) {\n  .previous-chat-scroll {\n    max-height: calc(100vh - 350px);\n  }\n}\n\n.chat-sidebar-logo-box {\n  background-size: cover;\n  margin: 0 -24px 20px;\n  background: transparent !important;\n  padding: 24px;\n  color: #000;\n  border-bottom: 1px solid #E9E9E9;\n}\n\n.chat-sidebar-logo-box h3 {\n  font-size: 18px;\n  font-weight: 600;\n  letter-spacing: -0.36px;\n  margin-bottom: 5px;\n}\n\n.chat-sidebar-search-wrap {\n  margin-top: 24px;\n  margin-bottom: 30px;\n}\n\n@media (max-height: 800px) {\n  .chat-sidebar-logo-box {\n    margin-bottom: 20px;\n  }\n  .chat-sidebar-search-wrap {\n    margin-top: 20px;\n    margin-bottom: 20px;\n  }\n  .chat-sidebar-logo-box {\n    padding: 18px 24px;\n  }\n}\n@media (max-height: 760px) {\n  .chat-sidebar-logo-box {\n    margin-bottom: 12px;\n  }\n  .chat-sidebar-search-wrap {\n    margin-top: 15px;\n    margin-bottom: 15px;\n  }\n  .chat-sidebar-logo-box {\n    padding: 10px 24px;\n  }\n  .chat-sidebar-logo-box h3 {\n    margin-bottom: 0;\n  }\n}\n@media (max-width: 1200px) {\n  .chat-sidebar-logo-box {\n    margin: 0 -10px 20px;\n    padding: 10px;\n  }\n}\n.chat-textarea-wrap {\n  position: absolute;\n  bottom: 25px;\n  left: 10px;\n  right: 10px;\n  padding-top: 50px;\n  padding-bottom: 25px;\n  z-index: 1000;\n  background-color: #fff;\n  box-shadow: 0 -14px 13px rgba(255, 255, 255, 0.75);\n}\n@media (min-width: 991px) and (max-width: 1200px) {\n  .chat-textarea-wrap {\n    left: 18px;\n    right: 23px;\n  }\n}\n@media (max-height: 800px) {\n  .chat-textarea-wrap {\n    bottom: 6px;\n  }\n}\n\n.chat-textarea-form {\n  background: #FFFFFF;\n  border: 1px solid #DADADA;\n  box-shadow: 0px 20px 40px 5px #EBEEF1;\n  border-radius: 12px;\n  padding: 18px 55px 18px 25px;\n  position: relative;\n}\n\n.chat-textarea-wrap .textarea-item {\n  border: none;\n  width: 100%;\n  resize: none;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 24px;\n  background-color: transparent;\n  border: none;\n  margin: 0;\n  padding: 0;\n  max-height: 120px;\n}\n@media (max-height: 768px) {\n  .chat-textarea-wrap .textarea-item {\n    max-height: 100px;\n  }\n}\n@media (max-height: 750px) {\n  .chat-textarea-wrap .textarea-item {\n    max-height: 70px;\n    font-size: 13px;\n    line-height: 18px;\n  }\n}\n\n.chat-textarea-wrap .textarea-item:focus-visible,\n.chat-textarea-wrap .textarea-item:focus {\n  outline: none !important;\n}\n\n.chat-textarea-wrap .chat-textarea-form-outer {\n  margin: 0 auto;\n  position: relative;\n  max-width: 850px;\n}\n\n.chat-textarea-wrap .send-btn {\n  background-repeat: no-repeat;\n  background-position: center;\n  position: absolute;\n  right: 5px;\n  top: 0px;\n  border: none;\n  text-indent: -9999px;\n  width: 50px;\n  height: 60px;\n  padding: 0;\n  background-color: transparent;\n}\n\n.chat-textarea-wrap .send-btn:disabled {\n  opacity: 0.5;\n}\n\n.chat-select-box select.form-select {\n  height: 24px;\n  font-size: 13px;\n  padding: 0 8px;\n  width: fit-content;\n  font-weight: 500;\n  border: none;\n  background: #fff;\n  cursor: pointer;\n  padding-right: 30px;\n}\n\n.chat-select-box {\n  border-radius: 3px;\n  background: linear-gradient(180deg, #4991ef 0%, #1a73e8 100%);\n  box-shadow: 0px 10px 10px 0px rgba(133, 175, 214, 0.45);\n  padding: 8px 10px;\n  margin-bottom: 0;\n}\n\n.chat-forms-btns-wrap {\n  margin-bottom: 8px;\n}\n\n.select-label-text {\n  margin-right: 10px;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.new-chat-btn {\n  font-weight: 600;\n  font-size: 13px;\n  color: #333;\n  text-decoration: none;\n  background: #FFFFFF;\n  border: 1px solid #DADADA;\n  box-shadow: 0px 8px 20px #EAEAEA;\n  border-radius: 12px;\n  width: 62px;\n  white-space: nowrap;\n  height: 62px;\n  overflow: hidden;\n  text-align: center;\n  align-items: center;\n  padding: 0 10px 0 17px;\n  transition: width 0.3s;\n  display: flex;\n  align-items: center;\n  margin-right: 6px;\n}\n.new-chat-btn .new-chat-btn-text {\n  opacity: 0;\n}\n@media (max-width: 767px) {\n  .new-chat-btn {\n    width: 52px;\n    padding-left: 12px;\n    height: 52px;\n  }\n}\n\n.new-chat-btn:hover {\n  width: 136px;\n}\n@media (max-width: 767px) {\n  .new-chat-btn:hover {\n    width: 52px;\n  }\n}\n.new-chat-btn:hover {\n  transition: width 0.3s;\n}\n.new-chat-btn:hover .new-chat-btn-text {\n  opacity: 1;\n}\n\n.new-chat-btn:hover span.new-chat-btn-img {\n  rotate: 360deg;\n}\n\nspan.new-chat-btn-img {\n  text-align: center;\n  display: inline-block;\n  margin-right: 10px;\n}\n\n.select-arrow {\n  position: absolute;\n  right: 6px;\n  top: -1px;\n  cursor: pointer;\n  height: 25px;\n  pointer-events: none;\n}\n\n.chat-textarea-form .textarea-item::placeholder {\n  color: rgba(0, 0, 0, 0.5);\n}\n\n.generate-loading span {\n  margin-left: 15px;\n}\n\n.dot-elastic {\n  position: relative;\n  width: 4px;\n  height: 4px;\n  border-radius: 5px;\n  background-color: #1A73E8;\n  color: #1A73E8;\n  animation: dot-elastic 1s infinite linear;\n  margin-right: 15px;\n}\n\n.dot-elastic::before,\n.dot-elastic::after {\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  top: 0;\n}\n\n.dot-elastic::before {\n  left: -8px;\n  width: 4px;\n  height: 4px;\n  border-radius: 5px;\n  background-color: #1A73E8;\n  color: #1A73E8;\n  animation: dot-elastic-before 1s infinite linear;\n}\n\n.dot-elastic::after {\n  left: 8px;\n  width: 4px;\n  height: 4px;\n  border-radius: 5px;\n  background-color: #1A73E8;\n  color: #1A73E8;\n  animation: dot-elastic-after 1s infinite linear;\n}\n\n@keyframes dot-elastic-before {\n  0% {\n    transform: scale(1, 1);\n  }\n  25% {\n    transform: scale(1, 1.7);\n  }\n  50% {\n    transform: scale(1, 0.67);\n  }\n  75% {\n    transform: scale(1, 1);\n  }\n  100% {\n    transform: scale(1, 1);\n  }\n}\n@keyframes dot-elastic {\n  0% {\n    transform: scale(1, 1);\n  }\n  25% {\n    transform: scale(1, 1);\n  }\n  50% {\n    transform: scale(1, 1.7);\n  }\n  75% {\n    transform: scale(1, 1);\n  }\n  100% {\n    transform: scale(1, 1);\n  }\n}\n@keyframes dot-elastic-after {\n  0% {\n    transform: scale(1, 1);\n  }\n  25% {\n    transform: scale(1, 1);\n  }\n  50% {\n    transform: scale(1, 0.67);\n  }\n  75% {\n    transform: scale(1, 1.7);\n  }\n  100% {\n    transform: scale(1, 1);\n  }\n}\n.generate-loading-anim {\n  animation-duration: 2.2s;\n  animation-fill-mode: forwards;\n  animation-iteration-count: infinite;\n  animation-name: shimmer;\n  animation-timing-function: linear;\n  background: #f1f6fc;\n  background: linear-gradient(to right, #ecf1f8 8%, #f9fcff 18%, #eff6ff 33%);\n  background-size: 1200px 100%;\n}\n\n.text-length-show {\n  height: auto;\n  line-height: 24px;\n  padding-left: 10px;\n  min-width: 82px;\n  text-align: right;\n}\n\n.generate-loading.generate-more-btn span {\n  margin-left: 0;\n}\n\n.generate-more-btn {\n  cursor: pointer;\n  background-color: #dbe3ea;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.generate-more-btn:hover {\n  background-color: #e7eef4;\n}\n\n.generate-more-btn svg {\n  width: 14px;\n  height: 14px;\n  position: relative;\n  top: -1px;\n  margin-right: 7px;\n}\n.generate-more-btn svg path {\n  fill: #1A73E8;\n}\n\n@-webkit-keyframes shimmer {\n  0% {\n    background-position: -100% 0;\n  }\n  100% {\n    background-position: 100% 0;\n  }\n}\n@keyframes shimmer {\n  0% {\n    background-position: -1200px 0;\n  }\n  100% {\n    background-position: 1200px 0;\n  }\n}\n@media (max-height: 900px) {\n  .chat-textarea-wrap {\n    padding-bottom: 30px;\n    box-shadow: 0 -12px 13px rgba(255, 255, 255, 0.75);\n  }\n}\n@media (max-height: 760px) {\n  .chat-textarea-wrap .send-btn {\n    top: 0px;\n  }\n}\n@media (max-width: 767px) {\n  .chat-textarea-wrap {\n    position: fixed;\n    left: 0;\n    right: 0;\n    padding: 5px 10px;\n    /* border-top: 1px solid #ddd; */\n    box-shadow: 0 0 6px rgba(92, 107, 122, 0.7);\n    background-color: #dce2e9;\n  }\n  .chat-textarea-form {\n    padding: 15px 40px 15px 10px;\n  }\n  .chat-textarea-wrap .textarea-item {\n    max-height: 80px;\n    line-height: 20px;\n  }\n  .chat-textarea-wrap .send-btn {\n    width: 24px;\n    height: 24px;\n    top: 12px;\n  }\n  .generate-loading {\n    position: absolute;\n    right: 0px;\n    bottom: 83px;\n    height: 30px;\n    top: inherit;\n    padding-left: 12px;\n    padding-right: 3px;\n    border-radius: 7px;\n  }\n  .generate-loading span {\n    font-size: 11px;\n  }\n  .chat-forms-btns-wrap {\n    flex-wrap: wrap;\n  }\n  .chat-select-box {\n    width: 100%;\n  }\n  .chat-textarea-new-chat-wrap {\n    margin-bottom: 5px;\n  }\n  .chat-select-box {\n    padding: 4px 8px;\n  }\n  .new-chat-btn-text {\n    display: none;\n  }\n  .cht-select-box-form {\n    flex: 1;\n  }\n  .chat-select-box select.form-select {\n    width: 100%;\n  }\n  .text-length-show {\n    line-height: 20px;\n  }\n}\n.generate-loading {\n  border: 1px solid #1A73E8;\n  border-radius: 50px;\n  width: max-content;\n  text-align: center;\n  padding: 6px 15px;\n  position: absolute;\n  left: 0;\n  top: -45px;\n  color: rgb(26, 115, 232);\n  font-weight: 600;\n  font-weight: 13px;\n}\n.generate-loading.generate-more-btn {\n  background: #EFF6FF;\n}\n.generate-loading.generate-more-seperate {\n  background: #fff;\n  border: 1px solid #D8D8D8;\n  border-radius: 7px;\n}\n.generate-loading.generate-more-seperate-loading {\n  border: 1px solid #D8D8D8;\n  border-radius: 7px;\n}\n.generate-loading span {\n  margin: 0;\n}\n\n.textarea-form-wrap {\n  flex: 1;\n}\n\n.upload-clip-btn {\n  margin-right: 10px;\n}\n\n.info-text-chat-textarea {\n  position: absolute;\n  left: 0;\n  right: 0;\n  z-index: 99;\n  text-align: center;\n  font-size: 13px;\n  padding-top: 14px;\n  color: #656b73;\n}\n@media (max-width: 575px) {\n  .info-text-chat-textarea {\n    padding-top: 9px;\n    font-size: 10px;\n  }\n}\n@media (max-height: 800px) {\n  .info-text-chat-textarea {\n    padding-top: 7px;\n  }\n}\n\n.personality-slider-wrap {\n  width: calc(100vw - 400px);\n  max-width: 100%;\n  overflow: hidden;\n}\n@media (max-width: 1200px) {\n  .personality-slider-wrap {\n    width: calc(100vw - 340px);\n  }\n}\n@media (max-width: 991px) {\n  .personality-slider-wrap {\n    width: calc(100vw - 70px);\n  }\n}\n@media (max-width: 575px) {\n  .personality-slider-wrap {\n    width: calc(100vw - 30px);\n  }\n}\n.personality-slider-wrap .slider-item {\n  padding: 2px 10px;\n}\n.personality-slider-wrap .slider-item.active .personality-item-box {\n  border: 1px solid rgb(26, 115, 232);\n  box-shadow: 0 0 0 2px rgb(26, 115, 232), 0 1px 2px rgba(26, 115, 232, 0.3);\n}\n\n.personality-item-box {\n  border: 1px solid #D5D8DC;\n  border-radius: 15px;\n  padding: 20px 15px 15px 15px;\n  height: 100%;\n}\n@media (max-height: 770px) {\n  .personality-item-box {\n    padding: 12px 10px 10px 12px;\n  }\n}\n.personality-item-box h3 {\n  font-size: 15px;\n  font-weight: 600;\n  letter-spacing: -2%;\n  line-height: 19px;\n  margin-bottom: 6px;\n}\n.personality-item-box p {\n  color: rgba(37, 37, 37, 0.8);\n  line-height: 22px;\n  margin: 0;\n}\n@media (max-height: 770px) {\n  .personality-item-box p {\n    line-height: 20px;\n  }\n}\n@media (max-height: 730px) {\n  .personality-item-box p {\n    font-size: 12px;\n  }\n}\n\n.personality-slider-wrap .slick-list,\n.personality-slider-wrap .slick-track,\n.personality-slider-wrap .slider-item {\n  display: flex;\n  align-items: stretch;\n}\n\n.personality-slider-wrap .slick-slide > div,\n.personality-slider-wrap .slider-item {\n  height: 100%;\n}\n\n.pers-slider-icon {\n  width: 70px;\n  height: 70px;\n  border: 1px solid #D0D0D0;\n  border-radius: 8px;\n  margin-bottom: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n@media (max-height: 770px) {\n  .pers-slider-icon {\n    width: 50px;\n    height: 50px;\n  }\n}\n\n.personality-slider .pers-slick-next-wrap {\n  right: -12px;\n  width: 36px;\n  height: 36px;\n  line-height: 36px;\n  text-align: center;\n  border: transparent;\n  box-shadow: 0px 4px 50px 5px rgba(198, 198, 198, 0.32);\n  border-radius: 50%;\n  background-color: #1A73E8;\n  z-index: 9;\n}\n.personality-slider .pers-slick-next-wrap::before {\n  display: none;\n}\n.personality-slider .pers-slick-next-wrap.slick-disabled {\n  opacity: 0;\n}\n.personality-slider .pers-slick-prev-wrap {\n  left: -12px;\n  width: 36px;\n  height: 36px;\n  line-height: 36px;\n  text-align: center;\n  border: 1px solid transparent;\n  box-shadow: 0px 4px 50px 5px rgba(198, 198, 198, 0.32);\n  border-radius: 50%;\n  background-color: #1A73E8;\n  z-index: 9;\n}\n.personality-slider .pers-slick-prev-wrap::before {\n  display: none;\n}\n.personality-slider .pers-slick-prev-wrap.slick-disabled {\n  opacity: 0;\n}\n\n.personality-slider-container {\n  margin: 0 auto;\n  max-width: 1090px;\n  padding: 0 17px;\n}\n\n.pers-slider-title {\n  font-size: 20px;\n  margin-bottom: 18px;\n  line-height: 24px;\n  font-weight: 600;\n  padding-left: 10px;\n}\n\n.personality-scrollbar {\n  max-height: 500px;\n}\n\n.chatbot-message-list .cs-message--outgoing {\n  justify-content: normal;\n}\n\n.chatbot-message-list .cs-message-list__scroll-wrapper > .cs-message,\n.cs-message-list__scroll-wrapper > .cs-message-group {\n  max-width: 100%;\n}\n\n.chatbot-message-list .cs-message__content-wrapper {\n  width: 100%;\n}\n\n.chatbot-message-list .query-input-wrap {\n  border-radius: 5px;\n  background: #def;\n  padding: 13px;\n  margin-bottom: 13px;\n}\n\n.chatbot-message-list .cs-message--outgoing .cs-message__content {\n  background-color: transparent;\n  border-radius: 0;\n  padding: 0;\n}\n\n.cs-chat-container {\n  height: calc(100% - 100px);\n  padding-bottom: 0px;\n}\n\n.query-input-message p {\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 22px;\n}\n\n.chatbot-message-list,\n.chatbot-message-list * {\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.query-input-message {\n  flex: 1;\n  padding-left: 15px;\n  min-height: 42px;\n  display: flex;\n  align-items: center;\n}\n\n.query-output-message-flex-wrap {\n  display: flex;\n  align-items: center;\n  min-height: 42px;\n}\n\n.query-output-box {\n  width: 100%;\n}\n\n.query-output-box .styledlink a {\n  width: 14px;\n  height: 14px;\n  background: rgb(206, 228, 251);\n  border-radius: 2px;\n  overflow: hidden;\n  text-decoration: none;\n  color: #1A73E8;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 11px;\n  padding-top: 2px;\n  position: relative;\n  top: -4px;\n  margin-right: 2px;\n}\n@media (max-width: 575px) {\n  .query-output-box .styledlink a {\n    top: -3px;\n    font-size: 9px;\n    width: 12px;\n    height: 12px;\n  }\n}\n.query-output-box .styledlink a:hover {\n  background-color: #1A73E8;\n  color: #fff;\n}\n\n.query-output-message p {\n  font-size: 13px;\n  line-height: 24px;\n  margin-bottom: 15px;\n}\n\n.query-output-paragraph-wrap {\n  min-height: 70px;\n}\n\n.query-output-wrap {\n  border-radius: 5px;\n  background: #fff;\n  padding: 28px 22px;\n  margin-bottom: 13px;\n  border: 1px solid #E9E9E9;\n}\n@media (max-width: 575px) {\n  .query-output-wrap {\n    padding: 14px 10px;\n  }\n}\n\n.query-output-message {\n  flex: 1;\n  padding-left: 15px;\n}\n\n.query-output-action-icons {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 4px 10px 0 20px;\n}\n\n.query-action-icon {\n  margin-bottom: 14px;\n  cursor: pointer;\n}\n\n.query-action-icon:hover svg path {\n  fill: #1A73E8;\n}\n\n.cs-chat-container,\n.cs-message-list {\n  background-color: transparent;\n}\n\n.cs-message-list .cs-message-list__typing-indicator-container {\n  background-color: transparent;\n  padding: 0;\n  font-size: 15px;\n  height: 30px;\n  line-height: normal;\n  left: 0px;\n  bottom: 13px;\n  position: absolute;\n  right: 0;\n  z-index: 2000;\n}\n\n.cs-message-list .typeindi-wrap {\n  margin: 0 auto;\n  position: relative;\n  max-width: 700px;\n  text-align: right;\n  display: flex;\n  justify-content: end;\n  padding: 5px 0;\n}\n\n.cs-message-list .cs-typing-indicator {\n  background-color: #fff;\n  border-radius: 4px;\n  position: inherit;\n}\n\n.cs-typing-indicator__dot {\n  background-color: rgba(26, 115, 232, 0.5);\n}\n\n.cs-typing-indicator__text {\n  color: rgba(26, 115, 232, 0.5);\n  font-weight: 500;\n}\n\n.chat-section-whole-wrap .react-tooltip {\n  padding: 5px 10px;\n  font-size: 12px;\n  z-index: 2001;\n  background: #1A73E8 !important;\n  color: #fff !important;\n  border-radius: 6px;\n}\n\n.cs-chat-container {\n  margin-right: -6px;\n}\n\n.cs-message {\n  padding-right: 0;\n}\n\n@media (max-height: 900px) {\n  .chatbot-message-list .query-input-wrap {\n    padding: 7px 10px;\n    margin-bottom: 10px;\n  }\n}\n@media (max-height: 760px) {\n  .query-output-wrap {\n    padding: 7px 10px;\n    margin-bottom: 10px;\n  }\n}\n@media (max-width: 767px) {\n  .cs-chat-container {\n    margin-right: 0;\n  }\n  .cs-message {\n    padding-right: 0;\n  }\n  .query-bot-logo img {\n    max-width: 30px;\n  }\n  .query-output-message {\n    padding-left: 10px;\n  }\n  .cs-chat-container {\n    height: calc(100vh - 360px);\n  }\n  .query-output-message p {\n    line-height: 20px;\n    min-height: 60px;\n  }\n  .query-action-icon {\n    margin-bottom: 8px;\n  }\n  .query-input-message {\n    padding-left: 0;\n    min-height: 30px;\n  }\n  .cs-message-list__scroll-wrapper > .cs-message:nth-last-child(4) {\n    margin-bottom: 0;\n  }\n  .custom-content-wrap {\n    height: calc(100vh - 370px);\n    overflow-y: scroll;\n  }\n  .query-input-message p {\n    line-height: 20px;\n  }\n  .chatbot-message-list .query-input-wrap {\n    margin-bottom: 6px;\n  }\n  .query-output-wrap {\n    margin-bottom: 6px;\n  }\n}\n.formatingParagraph {\n  white-space: normal;\n  font-size: 13px;\n  line-height: 22px;\n}\n.formatingParagraph h3 {\n  font-size: 14px;\n  margin-bottom: 6px;\n  font-weight: bold;\n  line-height: 20px;\n}\n.formatingParagraph h4 {\n  font-size: 13px;\n  margin-bottom: 6px;\n  font-weight: bold;\n  line-height: 20px;\n}\n.formatingParagraph p {\n  margin-bottom: 1rem;\n  line-height: 22px;\n  font-size: 13px;\n}\n.formatingParagraph ul, .formatingParagraph ol {\n  margin-bottom: 1rem;\n}\n.formatingParagraph ul li, .formatingParagraph ol li {\n  font-size: 13px;\n  line-height: 22px;\n  margin-bottom: 10px;\n}\n\n.output-image-show-box {\n  margin: 12px -6px 0;\n}\n\n.output-img-item {\n  padding: 6px;\n}\n\n.output-img-item img {\n  border-radius: 10px;\n  width: 251px;\n  height: 200px;\n  object-fit: cover;\n  height: 200px;\n  object-position: center;\n}\n\n.download-icon {\n  position: absolute;\n  right: 20px;\n  top: 20px;\n  cursor: pointer;\n}\n\n.download-icon:hover {\n  opacity: 0.8;\n  transition: all ease 0.5s;\n}\n\n.download-icon img {\n  width: 21px;\n  height: 21px;\n}\n\n.graph-result-box {\n  background-color: #fff;\n  padding: 12px;\n  border-radius: 6px;\n  margin-top: 15px;\n}\n\n.csv-link-btn {\n  background-color: #1A73E8;\n  line-height: 30px;\n  padding: 0 10px;\n  color: #fff;\n  text-decoration: none;\n  display: inline-block;\n  border-radius: 3px;\n  font-weight: 500;\n}\n\n.csv-link-btn:hover {\n  color: #fff;\n  opacity: 0.9;\n}\n\n@media (max-width: 767px) {\n  .output-img-item {\n    width: 50%;\n  }\n  .output-img-item img {\n    border-radius: 10px;\n    width: 100%;\n    height: auto;\n    object-fit: cover;\n    object-position: center;\n  }\n  .output-image-show-boxes {\n    margin: 0 -45px 0 -40px;\n  }\n  .download-icon {\n    right: 3px;\n    top: inherit;\n    bottom: 3px;\n    background: #1a73e8;\n    border-radius: 50%;\n  }\n  .download-icon svg rect {\n    fill: transparent !important;\n  }\n  .download-icon svg path {\n    fill: #fff;\n  }\n}\n.output-learnmore-wrap {\n  margin: 30px -45px 0 -58px;\n  display: flex;\n  justify-content: center;\n  border-top: 1px solid #E9E9E9;\n  padding-top: 8px;\n  padding-bottom: 1px;\n  padding-left: 50px;\n  padding-right: 50px;\n}\n\n.learnmore-child-labels span,\n.learnmore-child-labels a {\n  border-radius: 16px;\n  background: #f3f5f7;\n  padding: 0px 10px;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 26px;\n  display: inline-flex;\n  height: 30px;\n  align-items: center;\n  cursor: pointer;\n  color: #000;\n  text-decoration: none;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.learnmore-child-labels {\n  padding: 0 5px;\n  margin-top: 6px;\n}\n\n.learnmore-child {\n  height: 30px;\n  display: inline-flex;\n  align-items: center;\n  font-weight: bold;\n  font-size: 13px;\n  font-style: normal;\n  padding-right: 8px;\n  margin-top: 3px;\n  width: fit-content;\n}\n\n.output-learnmore-content-list a,\n.view-more-item {\n  border-radius: 16px;\n  background: #f3f5f7;\n  padding: 0px 10px;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 26px;\n  display: inline-flex;\n  height: 30px;\n  align-items: center;\n  cursor: pointer;\n  color: #000;\n  text-decoration: none;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.view-more-item {\n  border: none;\n}\n\n.bold-text {\n  font-weight: 600;\n}\n\n.items-showing-count {\n  position: absolute;\n  right: 0;\n  top: 19px;\n  font-size: 13px;\n}\n\n.output-learnmore-content {\n  flex: 1;\n  padding-right: 30px;\n}\n\n.output-learnmore-content ul.output-learnmore-content-list {\n  display: inline-flex;\n  margin: 0 -5px;\n  padding: 0;\n  list-style: none;\n  flex-wrap: wrap;\n}\n\n.output-learnmore-content-list li {\n  padding: 0 5px;\n  margin: 3px 0;\n}\n\nbutton.view-more-item {\n  min-width: 40px;\n  text-align: center;\n  display: block;\n  padding: 0px 10px;\n  font-size: 13px;\n  line-height: 26px;\n  height: 30px;\n  align-items: center;\n  cursor: pointer;\n  color: #000;\n  text-decoration: none;\n  border-radius: 16px;\n  background: #fff;\n  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);\n}\n\n@media (max-width: 767px) {\n  .output-learnmore-wrap {\n    margin: 30px -46px 0 -39px;\n    padding-left: 10px;\n    padding-right: 10px;\n    flex-direction: column;\n  }\n  .output-learnmore-content-list a,\n  .view-more-item {\n    padding: 0px 8px;\n    font-size: 11px;\n    height: 26px;\n  }\n  button.view-more-item {\n    font-size: 11px;\n    height: 26px;\n  }\n}\n.output-relatedarticle-wrap {\n  border-radius: 5px;\n  background: #f3f5f7;\n  padding: 13px;\n  margin: 15px 0;\n}\n\n.output-relatedarticle-wrap h4,\n.output-relatedarticle-wrap h4 a {\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 400;\n  color: #000;\n  text-decoration: none;\n  line-height: 32px;\n}\n\n.output-relatedarticle-wrap h4 a span {\n  font-weight: 600;\n}\n\n.rel-article-item {\n  width: 33.3333%;\n  padding: 0 8px;\n  margin-bottom: 20px;\n}\n\n.rel-article-text,\n.rel-article-text a {\n  color: #000;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 20px;\n  text-decoration: none;\n}\n\n.rel-article-text {\n  flex: 1;\n}\n\n.rel-articles-row {\n  margin: 0 -8px;\n}\n\n.rel-article-img img {\n  margin-right: 12px;\n}\n\n.more-article {\n  border-radius: 16px;\n  padding: 0px 10px;\n  font-size: 13px;\n  line-height: 26px;\n  display: inline-flex;\n  height: 30px;\n  align-items: center;\n  cursor: pointer;\n  color: #000;\n  text-decoration: none;\n  border-radius: 16px;\n  background: #FFF;\n  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);\n}\n\n.rel-article-footer {\n  margin-top: 10px;\n  border-top: 1px solid #bed1ea;\n  padding-top: 13px;\n  padding-bottom: 2px;\n}\n\n.rel-article-img img {\n  max-width: 70px;\n}\n\n.ai-relatedarticle-label-wrap {\n  margin-top: 10px;\n}\n\n.ai-related-article-bubble {\n  background: #E4E4E4;\n  border-radius: 16px;\n  padding: 4px 10px;\n  color: #5b5b5b;\n  font-size: 12px;\n  margin-right: 5px;\n  margin-top: 5px;\n}\n\n.ai-related-article-bubble:first-child {\n  margin-left: 0;\n}\n\n.rel-article-text {\n  min-height: min-content;\n}\n\n@media (max-width: 767px) {\n  .output-relatedarticle-wrap h4,\n  .output-relatedarticle-wrap h4 a {\n    line-height: 22px;\n  }\n  .rel-article-item {\n    width: 100%;\n    padding: 0;\n  }\n  .rel-articles-row {\n    margin: 0;\n    flex-wrap: wrap;\n  }\n  .rel-article-footer {\n    margin-top: 0;\n  }\n  .output-relatedarticle-wrap {\n    margin: 7px 0;\n  }\n}\n.vega-chart-container .chart-analysis .analysis-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #495057;\n  margin-bottom: 8px;\n}\n.vega-chart-container .chart-analysis .analysis-text {\n  font-size: 13px;\n  line-height: 1.5;\n  color: #6c757d;\n  margin: 0;\n}\n.vega-chart-container .chart-wrapper {\n  position: relative;\n  margin-top: 20px;\n  text-align: center;\n}\n.vega-chart-container .chart-wrapper .vega-embed {\n  width: 100% !important;\n}\n.vega-chart-container .chart-wrapper canvas {\n  max-width: 100% !important;\n}\n@media (max-width: 768px) {\n  .vega-chart-container .chart-wrapper canvas {\n    height: auto !important;\n  }\n}\n.vega-chart-container .chart-wrapper .chart-actions {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  z-index: 10;\n}\n.vega-chart-container .chart-wrapper .chart-actions .download-chart-btn {\n  padding: 6px 8px;\n  border-radius: 4px;\n  background: rgba(255, 255, 255, 0.9);\n  border: 1px solid #dee2e6;\n  color: #495057;\n  transition: all 0.2s ease;\n}\n.vega-chart-container .chart-wrapper .chart-actions .download-chart-btn:hover {\n  background: #fff;\n  border-color: #1a73e8;\n  color: #1a73e8;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n.vega-chart-container .chart-wrapper .chart-actions .download-chart-btn svg {\n  width: 16px;\n  height: 16px;\n}\n.vega-chart-container .chart-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n  color: #6c757d;\n}\n.vega-chart-container .chart-loading .spinner-border {\n  width: 2rem;\n  height: 2rem;\n}\n.vega-chart-container .chart-loading p {\n  margin: 0;\n  font-size: 14px;\n}\n.vega-chart-container .chart-error {\n  padding: 20px;\n}\n.vega-chart-container .chart-error .alert {\n  margin: 0;\n  font-size: 14px;\n}\n\n@media (max-width: 768px) {\n  .vega-chart-container {\n    margin: 15px -20px;\n    border-radius: 0;\n  }\n  .vega-chart-container .chart-wrapper .chart-actions {\n    top: 16px;\n    right: 16px;\n  }\n  .vega-chart-container .chart-analysis {\n    padding: 12px;\n  }\n}\n@media (max-width: 576px) {\n  .vega-chart-container .chart-wrapper .vega-embed svg {\n    max-width: 100% !important;\n    height: auto !important;\n  }\n  .vega-chart-container .chart-analysis .analysis-title {\n    font-size: 13px;\n  }\n  .vega-chart-container .chart-analysis .analysis-text {\n    font-size: 12px;\n  }\n}\n@media (prefers-color-scheme: dark) {\n  .vega-chart-container {\n    background: #2d3748;\n    color: #e2e8f0;\n  }\n  .vega-chart-container .chart-analysis {\n    background: #4a5568;\n    border-bottom-color: #718096;\n  }\n  .vega-chart-container .chart-analysis .analysis-title {\n    color: #e2e8f0;\n  }\n  .vega-chart-container .chart-analysis .analysis-text {\n    color: #cbd5e0;\n  }\n  .vega-chart-container .chart-wrapper .chart-actions .download-chart-btn {\n    background: rgba(45, 55, 72, 0.9);\n    border-color: #718096;\n    color: #e2e8f0;\n  }\n  .vega-chart-container .chart-wrapper .chart-actions .download-chart-btn:hover {\n    background: #4a5568;\n    border-color: #1a73e8;\n    color: #1a73e8;\n  }\n  .vega-chart-container .chart-loading {\n    color: #cbd5e0;\n  }\n}\n.dropzone-modal .modal-lg {\n  --bs-modal-width: 649px;\n}\n.dropzone-modal .modal-header {\n  border: none;\n}\n\n.dropzone-box {\n  background: #F3F5F7;\n  border: 2px dashed #1A73E8;\n  border-radius: 10px;\n  padding: 52px;\n  text-align: center;\n  margin-bottom: 40px;\n}\n.dropzone-box h3 {\n  font-size: 17px;\n  font-weight: 600;\n}\n.dropzone-box h3 span {\n  color: #1A73E8;\n  text-decoration: underline;\n  margin-bottom: 5px;\n}\n.dropzone-box p {\n  font-size: 12px;\n  color: rgb(103, 103, 103);\n  margin-bottom: 0;\n  line-height: 18px;\n  margin-top: 5px;\n}\n\n.dpzone-title {\n  text-align: center;\n  padding: 5px 0 15px;\n  font-size: 16px;\n  font-weight: bold;\n  margin-bottom: 0;\n}\n\n.uploaded-item-name-box {\n  background: #FFFFFF;\n  border: 1px solid #11AF22;\n  border-radius: 4px;\n  padding: 9px 11px;\n  margin-bottom: 10px;\n}\n.uploaded-item-name-box .uploaded-item-nameshow {\n  flex: 1;\n  padding-left: 9px;\n  padding-right: 9px;\n  font-size: 12px;\n  color: rgb(15, 15, 15);\n  line-height: 18px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.uploaded-item-name-box .uploaded-item-delete {\n  background: #FFF3F3;\n  width: 16px;\n  height: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  cursor: pointer;\n}\n.uploaded-item-name-box .uploaded-item-delete img {\n  width: 70%;\n}\n\n.dpzone-sec-title {\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 17px;\n  color: #676767;\n}\n\n.uploaded-item-error {\n  border-color: rgb(228, 29, 29);\n}\n\n.upload-error-text {\n  font-size: 11px;\n  font-weight: 500;\n  color: rgb(228, 29, 29);\n  margin-bottom: 0;\n}\n\n.uploading-status-show-outer .uploaded-item-name-box {\n  margin-bottom: 0;\n  border-color: rgb(227, 227, 227);\n}\n\n.dpzone-upload-status-sec {\n  margin-bottom: 20px;\n}\n\n.dpzn-upload-scroll {\n  max-height: 130px;\n}","@use \"../../utils/variables\" as *;\n.auth-page-wrap .container {\n    max-width: 1140px;\n}\n.auth-left {\n    width: 584px;\n    background-color: #1a73e8;\n    // background-image: url(./app/assets/images/signin-left-bg.png);\n    height: 612px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    flex-direction: column;\n    padding-bottom: 76px;\n    position: relative;\n    border-radius: $curveradius 0 0 $curveradius;\n}\n.auth-page-wrap {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    background: #f3f5f7;\n    padding: 38px;\n}\n.auth-container {\n    background: #fff;\n    border-radius: $curveradius;\n}\n.auth-right {\n    flex: 1;\n    padding: 50px 62px;\n}\n.sec-title {\n    font-size: 28px;\n    font-weight: 600;\n    line-height: 26px;\n}\n.forgot-pwd-link a {\n    color: $theme-body-font-color;\n    font-weight: 600;\n    text-decoration: none;\n}\n\na.btn-primary {\n    text-decoration: none;\n}\n.auth-logo-wrap {\n    position: absolute;\n    left: 45px;\n    top: 45px;\n}\n.already-have-link {\n    font-size: $body-font-size-medium;\n}\n.already-have-link a {\n    font-weight: 700;\n    text-decoration: none;\n    font-size: $body-font-size;\n}\n.auth-logo-wrap img, .signup-logo-wrap img {\n    max-height: 30px;\n}\n@media (max-width: 1200px) {\n    .auth-left {\n        width: 50%;\n    }\n}\n@media (max-width: 991px) {\n    .auth-left {\n        height: 500px;\n    }\n    .auth-right {\n        padding: 20px;\n    }\n    .auth-signin-img {\n        text-align: center;\n    }\n    .auth-signin-img img {\n        max-width: 80%;\n    }\n\n    .auth-page-wrap {\n        display: flex;\n        align-items: center;\n    }\n    .auth-container {\n        flex-wrap: wrap;\n        border-radius: 20px;\n    }\n    .auth-right {\n        width: 100%;\n        flex: auto;\n        padding: 20px;\n    }\n    .auth-signin-img {\n        display: none;\n    }\n    .auth-left {\n        width: 100%;\n        border-radius: 20px 20px 0 0;\n        background-image: none !important;\n        background-color: $primary-color;\n        height: 60px;\n        padding: 0;\n    }\n    .auth-logo-wrap {\n        top: 15px;\n        right: 45px;\n        text-align: center;\n    }\n    .auth-logo-wrap img {\n        max-height: 30px;\n    }\n    .auth-page-wrap {\n        padding: 20px 10px;\n    }\n    .sec-title {\n        font-size: 20px;\n        margin-bottom: 20px;\n    }\n}\n","@use \"../../utils/variables\" as *;\n.auth-signup-left {\n    width: 358px;\n    background: $primary-color;\n    padding: 48px 40px;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n.auth-signup-left .btn-outline-primary.upload-btn{\n    color: white;\n} \n.auth-signup-right {\n    flex: 1;\n    padding: 48px 62px;\n}\n.auth-signup-right .form-input-wrap {\n    margin-bottom: 25px;\n}\n.signup-page-wrap {\n    position: inherit;\n}\n.btn-outline-primary.upload-btn {\n    font-weight: 500;\n    font-size: 12px;\n    border: 2px solid #f3f5f7;\n    border-radius: $radius;\n    padding: 0 15px;\n    height: 39px;\n}\n.btn-outline-primary.upload-btn img {\n    margin-right: 8px;\n}\n.or-text {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding-top: 24px;\n    padding: 15px 10px 0;\n}\nlabel.btn.upload-btn {\n    line-height: 34px;\n}\n.box {\n    display: inline-block;\n    padding: 10px;\n    box-sizing: border-box;\n}\n.img-preview {\n    overflow: hidden;\n}\nbutton.btn.btn-white-outline.m-t-20 {\n    border: 2px solid #e3e3e3;\n    font-size: 13px;\n    color: #fff;\n    padding: 0 17px;\n    line-height: 35px;\n}\n.profile-img {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex: 1;\n    margin-top: 97px;\n}\n#fileUpload::-webkit-file-upload-button {\n    display: none;\n}\n.upload-file-input {\n    position: absolute;\n    bottom: 6px;\n    color: $primary-color;\n    font-size: 11px;\n}\n.btn-outline-primary.upload-btn:hover {\n    border: 2px solid #cbcbcb;\n    background: #f3f5f7;\n    color: $primary-color;\n}\n.croped-img-wrap img {\n    width: 140px !important;\n    height: 140px;\n    border-radius: 50%;\n    min-width: 140px;\n    max-height: 140px;\n    // background: #f0f0f0;\n    padding: 2px;\n    margin-top: 20px;\n}\n.image-crop-area {\n    min-height: 200px;\n}\n.success-content-wrap h3 {\n    font-size: 18px;\n    font-weight: 600;\n    margin-top: 18px;\n    margin-bottom: 25px;\n}\n// .cropper-container {max-height: 400px;width: auto !important;height: auto !important;}\n\n.eye-show,\n.eye-hidden {\n    position: absolute;\n    right: 13px;\n    top: 35px;\n    cursor: pointer;\n}\n.eye-show img,\n.eye-hidden img {\n    max-width: 20px;\n}\n.eye-hidden img {\n    opacity: 0.6;\n}\n.eye-icon-inputwrap .form-control.input-item {\n    padding-right: 40px;\n}\n.agree-checkbox-wrap a {\n    text-decoration: none;\n}\n.agree-checkbox-wrap .form-check-input {\n    margin-top: 0;\n    width: 18px;\n    height: 18px;\n}\n.agree-checkbox-wrap .form-check-label {\n    margin-left: 8px;\n}\nspan.supported-file-text {\n    display: block;\n    position: absolute;\n    /* bottom: 0; */\n    font-size: 12px;\n    color: #555;\n}\n.infoicon svg {\n    width: 16px;\n    margin-left: 8px;\n    position: relative;\n    top: -1px;\n}\n.infoicon {\n    display: inline-block;\n}\n.infoicon svg path {\n    fill: $primary-color;\n}\n.file-uploaded-text:empty {\n    display: none;\n}\n.file-uploaded-text {\n    font-size: 11px;\n    color: green;\n    font-weight: 500;\n    margin: 0;\n    position: relative;\n    top: -11px;\n\n}\n.resume-remove-icon svg {\n    margin-right: 0;\n    width: 10px;\n}\n.resume-remove-icon {\n    display: inline-block;\n    width: 18px;\n    line-height: 14px;\n    border-radius: 50%;\n    text-align: center;\n    height: 18px;\n    z-index: 100;\n    cursor: pointer;\n\n}\n.resume-remove-icon:hover{\n    opacity: 0.7;\n}\n@media (max-width: 991px) {\n    .auth-signup-left {\n        width: 100%;\n        border-radius: 20px 20px 0 0;\n        padding: 20px;\n    }\n    .auth-signup-left .signup-logo-wrap {\n        text-align: center;\n    }\n    .auth-signup-right {\n        padding: 20px 20px;\n    }\n    .profile-img {\n        margin-top: 67px;\n    }\n}\n@media (max-width: 767px) {\n    // .auth-right-content .upload-btn-wrap {\n    //     width: calc(100% - 100px);\n    // }\n    .auth-signup-right .form-input-wrap {\n        flex-wrap: wrap;\n    }\n\n    .or-text {\n        width: auto;\n        padding: 0;\n        font-weight: bold;\n        text-align: left;\n        height: 20px;\n        margin-top: 38px;\n        margin-left: 10px;\n    }\n    .file-upload-container .form-input-wrap {\n        flex-wrap: wrap;\n    }\n    .Linkedinurl {\n        width: 100%;\n        margin-top: 15px;\n    }\n    .file-uploaded-text {\n        position: absolute;\n        top: 68px;\n        overflow: hidden;\n        max-width: 80%;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n    }\n}\n","@use \"../../utils/variables\" as *;\n.common-modal .modal-content {\n    border: none;\n    border-radius: $curveradius;\n    outline: 0;\n    box-shadow: 0px 50px 50px rgb(0 0 0 / 4%);\n}\n.common-modal .modal-sm.modal-dialog {\n    max-width: 390px;\n}\n.common-modal .modal-dialog .modal-content {\n    padding: 25px;\n}\n.modal.side-popup {\n    left: inherit;\n    width: auto;\n    right: 0;\n}\n.side-popup .modal-dialog.modal-md {\n    width: 540px;\n    max-width: inherit;\n    margin-top: 20px;\n}\n.side-popup .modal-dialog.modal-lg {\n    width: 720px;\n    max-width: inherit;\n}\n.side-popup .modal-dialog .modal-content {\n    min-height: calc(100vh - 50px);\n}\n.side-popup .modal-header {\n    border-bottom: 1px solid #cccdce;\n    font-size: 14px;\n    padding: 14px 7px 14px;\n    justify-content: space-between;\n}\n.side-popup .modal-header .modal-title {\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 22px;\n    text-transform: capitalize;\n}\n.side-popup .modal-header .btn-close {\n    padding: 0;\n    opacity: 1;\n    margin: 0;\n}\n.common-modal .btn-close {\n    opacity: 1;\n}\n.common-modal .modal-body {\n    padding: 0;\n}\n.common-modal .modal-header {\n    padding: 0 0 7px;\n}\n.common-modal.cropModal .modal-header {\nborder: none;\n}\n.common-modal .modal-title {\n    font-weight: 600;\n    font-size: 18px;\n}\n.reload-popup.common-modal .modal-sm.modal-dialog {\n    max-width: 480px;\n}\n.reload-popup .upgrade-pop-wrap .upgrade-title {\n    max-width: 420px;\n}\n.reload-popup .upgrade-pop-wrap.no-results .upgrade-title {\n    font-size: 18px;\n    line-height: 30px;\n    margin-bottom: 20px;\n}\n.reload-popup.common-modal .modal-header {\n    border: none;\n    position: absolute;\n    right: 10px;\n    top: 10px;\n}\n.country-modal-inotext img {\n    max-width: 16px;\n}\n.country-modal-inotext {\n    margin-left: 10px;\n}\n.country-pop-with-toolitip .modal-header {\n    position: absolute;\n    top: 31px;\n    right: 25px;\n    z-index: 1000;\n    border: none;\n}\n.country-pop-with-toolitip.common-modal .modal-title {\n    border-bottom: 1px solid #cccdce;\n    padding-bottom: 7px;\n    line-height: 22px;\n}\n@media(max-width:767px){\n    .side-popup .modal-dialog.modal-md {\n        width: auto;\n        max-width: 100%;\n        margin-top: 20px;\n    }\n    .modal.side-popup {\n        width: 100%;\n    }\n    .common-modal .modal-sm.modal-dialog {\n        max-width: 100%;\n    }\n}\n","@use \"../../utils/variables\" as *;\n.react-select-2-option__option {\n    display: flex !important;\n    align-items: center;\n    border-bottom: 1px solid #d4d7da;\n    background: none !important;\n    padding-top: 10px;\n    padding-bottom: 10px;\n}\n.react-select-2-option__menu-list div:last-child .react-select-2-option__option {\n    border: none;\n}\n.react-select-2-option__option label {\n    margin-left: 10px;\n}\n\n.react-select-2-option__option--is-selected label,\n.react-select-2-option__option:hover label {\n    color: $primary-color;\n}\n","@use \"../../utils/variables\" as *;\n// ============================================================================\n// Header — single blue bar (unified design)\n// ============================================================================\n\n.header-wrap {\n  background: $primary-color;\n  position: relative;\n  z-index: 1000;\n}\n\n.header-bar { padding: 0; }\n\n.header-bar__inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 64px;\n  gap: 16px;\n}\n\n.header-bar__logo {\n  margin: 0;\n  flex-shrink: 0;\n\n  img {\n    display: block;\n    max-height: 28px;\n    // Source logo uses dark text + blue icon — unreadable on blue nav.\n    // Invert to white so it renders legibly.\n    filter: brightness(0) invert(1);\n  }\n}\n\n.header-bar__menu {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  justify-content: flex-end;\n}\n\n.header-bar__links {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-wrap: nowrap;\n}\n\n.header-bar__link {\n  position: relative;\n  color: rgba(255, 255, 255, 0.88);\n  background: transparent;\n  border: none;\n  font-family: $primary-font;\n  font-size: 15px;\n  font-weight: 500;\n  text-decoration: none;\n  padding: 10px 12px;\n  margin: 0;\n  cursor: pointer;\n  transition: color 0.15s ease;\n\n  &:hover { color: #FFFFFF; }\n\n  &.is-active,\n  &.active {\n    color: #FFFFFF;\n    font-weight: 600;\n    text-shadow: none;\n\n    &::after {\n      content: \"\";\n      position: absolute;\n      left: 12px;\n      right: 12px;\n      bottom: 6px;\n      height: 2px;\n      background: #FFFFFF;\n      border-radius: 2px;\n    }\n  }\n}\n\n.header-bar__divider {\n  display: inline-block;\n  width: 1px;\n  height: 24px;\n  background: rgba(255, 255, 255, 0.35);\n  margin: 0 4px;\n  flex-shrink: 0;\n}\n\n// Override the legacy `.notification-dropdown.dropdown { margin-right: 20px }`\n// rule from `_notification.scss`, which otherwise injects a 20px gap between\n// the bell and the avatar in the new header. Match its specificity so the\n// override wins regardless of load order.\n.header-bar__notif.notification-dropdown.dropdown {\n  margin-right: 0;\n}\n\n// Notification bell — sized to match the avatar's visual weight so the flex\n// `gap` produces an even rhythm across links, bell, and avatar.\n.header-bar__notif {\n  .notification-button {\n    background: transparent !important;\n    border: none !important;\n    padding: 6px !important;   // symmetric hit area, matches avatar footprint\n    box-shadow: none !important;\n    color: #FFFFFF !important;\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    // Global `body .btn { min-width: 110px; height: 39px; }` in _App.scss\n    // otherwise balloons this toggle into a 110×39 box — reset to hug content.\n    min-width: 0 !important;\n    width: auto !important;\n    height: auto !important;\n\n    &::after { display: none; }\n    svg { stroke: #FFFFFF; }\n  }\n\n  .noti-count {\n    position: absolute;\n    top: 0;\n    right: 0;\n    background: #E11D48;\n    color: #FFFFFF;\n    font-size: 10px;\n    font-weight: 600;\n    min-width: 16px;\n    height: 16px;\n    line-height: 16px;\n    text-align: center;\n    border-radius: 10px;\n    padding: 0 4px;\n  }\n}\n\n// Avatar — no extra margin; rely on the flex container's `gap` for spacing\n// so bell↔avatar matches the cadence between other nav items.\n.header-bar__avatar {\n  margin-left: 0;\n\n  .avatar-toggle {\n    background: transparent !important;\n    border: none !important;\n    padding: 0 !important;\n    box-shadow: none !important;\n    // Same reset as .notification-button — escape the global .btn sizing.\n    min-width: 0 !important;\n    width: auto !important;\n    height: auto !important;\n    line-height: 1 !important;\n\n    &::after { display: none; }\n\n    .user-img {\n      display: inline-block;\n      width: 36px;\n      height: 36px;\n      border-radius: 50%;\n      overflow: hidden;\n      border: 2px solid rgba(255, 255, 255, 0.6);\n      margin: 0;\n\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n        display: block;\n      }\n    }\n  }\n}\n\n// Dropdown menus\n.header-bar__links .dropdown-menu,\n.header-bar__avatar .dropdown-menu,\n.header-bar__notif .dropdown-menu {\n  border: none;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  border-radius: 10px;\n  padding: 8px;\n  margin-top: 8px !important;\n}\n\n.header-bar__links .dropdown-item,\n.header-bar__avatar .dropdown-item {\n  font-size: 13px;\n  line-height: 1.6;\n  padding: 8px 12px;\n  border-radius: 6px;\n  color: #1A1A1A;\n\n  &:hover,\n  &:focus {\n    color: $primary-color;\n    background: #EEF4FF;\n  }\n}\n\n.header-bar__mobile-actions {\n  display: none;\n  align-items: center;\n  gap: 8px;\n}\n\n// ----------------------------------------------------------------------------\n// Responsive\n// ----------------------------------------------------------------------------\n\n@media (max-width: 1199.98px) {\n  .header-bar__link { padding: 10px 10px; font-size: 14px; }\n  .header-bar__inner { min-height: 64px; }\n  .header-bar__logo img { max-height: 26px; }\n\n  .header-bar__link.is-active::after,\n  .header-bar__link.active::after { left: 10px; right: 10px; }\n}\n\n// Desktop — slightly roomier spacing between nav items on larger screens.\n@media (min-width: 1025px) {\n  .header-bar__links { gap: 10px; }\n}\n\n// Tablet — shrink paddings and font so all nav items remain visible inline\n// between 768px and 991px (no hamburger at this size).\n@media (max-width: 991.98px) and (min-width: 768px) {\n  .header-bar__inner { gap: 8px; }\n  .header-bar__links { gap: 2px; }\n  .header-bar__link {\n    padding: 8px 8px;\n    font-size: 13px;\n    white-space: nowrap;\n  }\n  .header-bar__link.is-active::after,\n  .header-bar__link.active::after { left: 8px; right: 8px; }\n  .header-bar__divider { height: 20px; margin: 0 2px; }\n  .header-bar__notif .notification-button { padding: 4px !important; }\n  .header-bar__avatar .avatar-toggle .user-img { width: 32px; height: 32px; }\n  .header-bar__logo img { max-height: 22px; }\n}\n\n@media (min-width: 768px) {\n  .header-bar__mobile-actions { display: none !important; }\n  .mobile-menu, .notification-mobile-only { display: none !important; }\n}\n\n@media (max-width: 767.98px) {\n  .header-bar__inner { min-height: 56px; }\n  .header-bar__logo img { max-height: 24px; }\n\n  .header-bar__menu { flex: 0 0 auto; }\n\n  .mobilemenu-hidden { display: none; }\n\n  .mobilemenu-active {\n    position: absolute;\n    top: 56px;\n    left: 0;\n    right: 0;\n    width: 100%;\n    background: $primary-color;\n    z-index: 99;\n    border-top: 1px solid rgba(255, 255, 255, 0.18);\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);\n    // Cancel the desktop flex-end alignment so the links span the full panel.\n    display: block;\n    justify-content: flex-start;\n    padding: 6px 0;\n\n    .header-bar__links {\n      display: flex;\n      flex-direction: column;\n      align-items: stretch;\n      width: 100%;\n      padding: 6px 0;\n      gap: 0;\n    }\n\n    .header-bar__link {\n      width: 100%;\n      padding: 14px 20px;\n      color: #FFFFFF;\n      font-size: 15px;\n      text-align: left;\n      border-radius: 0;\n\n      &.is-active::after { display: none; }\n      &.is-active {\n        background: rgba(255, 255, 255, 0.14);\n        font-weight: 600;\n      }\n\n      &:hover {\n        background: rgba(255, 255, 255, 0.08);\n      }\n    }\n\n    .header-bar__divider {\n      display: block;\n      width: auto;\n      height: 1px;\n      margin: 6px 20px;\n      background: rgba(255, 255, 255, 0.22);\n    }\n\n    .header-bar__notif,\n    .header-bar__avatar { display: none; }\n  }\n\n  .header-bar__mobile-actions {\n    display: flex;\n\n    .notification-button {\n      background: transparent !important;\n      border: none !important;\n      padding: 0 6px !important;\n      box-shadow: none !important;\n      &::after { display: none; }\n      svg { stroke: #FFFFFF; }\n    }\n\n    .mobile-menu {\n      background: transparent;\n      border: none;\n      padding: 4px;\n      color: #FFFFFF;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n\n      img {\n        max-height: 22px;\n        filter: brightness(0) invert(1);\n      }\n    }\n  }\n}\n\n// Mobile-only profile/logout links — hidden on desktop, shown inside the\n// slide-down mobile menu panel.\n.header-bar__mobile-profile-link {\n  @media (min-width: 768px) { display: none !important; }\n}\n\n.header-bar__divider--mobile-only {\n  @media (min-width: 768px) { display: none !important; }\n}\n\n.header-bar__mobile-logout {\n  color: rgba(255, 200, 200, 0.9) !important;\n  &:hover { color: #fff !important; }\n}\n",".footer-content {\n    border-top: 1px solid #e3e3e3;\n    padding: 30px;\n    margin: 0;\n    \n\n}\n.footer-content p {\n    font-size: 11px;\n    line-height: 18px;\n    color: #5b5b5b;\n}\n","@use \"../../utils/variables\" as *;\n.nav-tabs .nav-link {\n    font-size: 18px;\n    background: transparent;\n    color: #fff;\n    font-weight: 500;\n    padding: 5px 15px;\n    margin-bottom: 10px;\n    border: none;\n}\n.nav-tabs .nav-link.active {\n    color: #fff;\n    background-color: transparent;\n    border: none;\n    position: relative;\n    font-weight: 700;\n}\n.nav-tabs .nav-link.active::after {\n    position: absolute;\n    left: 0;\n    right: 0;\n    background: #fff;\n    height: 4px;\n    content: \"\";\n    bottom: 0;\n    border-radius: 20px;\n}\n.nav-tabs {\n    border: none;\n}\n.nav-tabs .nav-link:hover,\n.nav-tabs .nav-link:focus {\n    border: none;\n}\n.results-tab-wrap .nav-tabs .nav-link {\n    font-weight: 600;\n    font-size: 15px;\n    line-height: 18px;\n    letter-spacing: -0.02em;\n    color: $theme-body-font-color;\n}\n.results-tab-wrap .nav-tabs {\n    justify-content: space-between;\n    margin: 0 -15px;\n    position: relative;\n    background:#fff ;\n    z-index: 99;\n    padding-top: 15px;\n}\n.results-tab-wrap .nav-tabs::after {\n    position: absolute;\n    bottom: 0;\n    height: 2px;\n    background: #D7E0E9;\n    content: \"\";\n    left: 15px;\n    right: 15px;\n}\n.results-tab-wrap .tab-content {\n    padding-top: 25px;\n}\n.results-tab-wrap .nav-tabs .nav-link {position: relative;z-index: 100;}\n.results-tab-wrap .nav-tabs .nav-link.active{\ncolor: $primary-color;\n\n}\n.results-tab-wrap .nav-tabs .nav-link.active::after {\n    position: absolute;\n    bottom: -10px;\n    height: 2px;\n    background: $primary-color;\n    content: \"\";\n    left: 15px;\n    right: 15px;\n    z-index: 1;\n    \n}\n\n#FixedTab.sticky .nav-tabs{\n    position: sticky;\n    top: 0px;\n\n}\n.nav-tabs .nav-link:focus {\n    outline: none;\n}\n\n\n\n.faq-tab-wrap .nav-tabs .nav-link {\n    font-weight: 600;\n    font-size: 15px;\n    line-height: 18px;\n    letter-spacing: -0.02em;\n    color: $theme-body-font-color;\n}\n.faq-tab-wrap .nav-tabs {\n    margin: 0 -15px;\n    position: relative;\n    background:#fff ;\n    z-index: 99;\n    padding-top: 15px;\n}\n.faq-tab-wrap .nav-tabs::after {\n    position: absolute;\n    bottom: 0;\n    height: 2px;\n    background: #D7E0E9;\n    content: \"\";\n    left: 15px;\n    right: 15px;\n}\n.faq-tab-wrap .tab-content {\n    padding-top: 25px;\n}\n.faq-tab-wrap .nav-tabs .nav-link {position: relative;z-index: 100;}\n.faq-tab-wrap .nav-tabs .nav-link.active{\ncolor: $primary-color;\n\n}\n.faq-tab-wrap .nav-tabs .nav-link.active::after {\n    position: absolute;\n    bottom: -10px;\n    height: 2px;\n    background: $primary-color;\n    content: \"\";\n    left: 15px;\n    right: 15px;\n    z-index: 1;\n    \n}\n\n\n@media (min-width: 768px) and (max-width: 991px) { \n    .nav-tabs .nav-link {\n        padding: 5px 11px;\n    } \n}\n@media (max-width: 767px) { \n    .nav-tabs .nav-link {\n        font-size: 16px;\n    }\n    .result-content-area .results-tab-wrap .nav-tabs .nav-link.active::after {\n        left: 10px;\n        right: 10px;\n    }\n    .result-content-area .nav-tabs .nav-link {\n        font-size: 16px;\n        padding: 5px 10px;\n\n    }\n   \n}","@use \"../../utils/variables\" as *;\n.datatable-wrap .rdt_TableRow {\n    min-height: 60px;\n    border-color: #e9e9e9;\n}\n.checkbox-table.datatable-wrap .rdt_TableRow .rdt_TableCell:first-child,\n.checkbox-table.datatable-wrap .rdt_TableHeadRow .rdt_TableCol:first-child {\n    min-width: 30px;\n    flex: 0 0 30px;\n    position: relative;\n}\n.datatable-wrap .rdt_TableHeadRow {\n    background: #e6e9ec;\n    font-weight: 600;\n    font-size: 15px;\n    border: none;\n}\n.datatable-wrap .rdt_TableCell {\n    font-size: 13px;\n    color: #000;\n    flex-wrap: wrap;\n}\n.share-icon-cell img {\n    margin-right: 10px;\n    position: relative;\n    top: -2px;\n}\n.datatable-wrap .rdt_TableCell a {\n    text-decoration: none;\n    color: $primary-color;\n}\n.datatable-hedaer-right {\n    flex: 1;\n}\n// .datatable-hedaer-left.d-flex {\n//     width: 45%;\n// }\n.table-buttons-wrap {\n    // margin-left: 100px;\n    padding-right: 150px;\n}\n\n.search-svg-wrap {\n    position: absolute;\n    left: 10px;\n    top: 9px;\n    pointer-events: none;\n}\n.search-input-wrap .input-item {\n    padding-left: 30px;\n}\n.checkbox-table.datatable-wrap .rdt_TableHeadRow .rdt_TableCol:first-child input[type=\"checkbox\"] {\n    width: 16px !important;\n    height: 16px !important;\n    margin-left: 3px;\n}\n.checkbox-table.datatable-wrap .rdt_TableRow .rdt_TableCell:first-child input[type=\"checkbox\"]::after\n// .checkbox-table.datatable-wrap .rdt_TableHeadRow .rdt_TableCol:first-child input[type=\"checkbox\"]::after \n{\n    width: 18px;\n    height: 18px;\n    content: \"\";\n    position: absolute;\n    top: -3px;\n    left: -1px;\n    border: 2px solid #cccdce;\n    pointer-events: none;\n    background: #fff;\n}\n\n.checkbox-table.datatable-wrap .rdt_TableRow .rdt_TableCell:first-child input[type=\"checkbox\"], \n.checkbox-table.datatable-wrap .rdt_TableHeadRow .rdt_TableCol:first-child input[type=\"checkbox\"] {\n    position: relative;\n}\n\n.checkbox-table.datatable-wrap .rdt_TableRow .rdt_TableCell:first-child input[type=\"checkbox\"]:checked:before\n// .checkbox-table.datatable-wrap .rdt_TableHeadRow .rdt_TableCol:first-child input[type=\"checkbox\"]:checked:before\n{\n    content: \"\";\n    display: block;\n    position: absolute;\n    width: 18px;\n    height: 18px;\n    top: -3px;\n    left: -1px;\n    background-color: $primary-color;\n    border-radius: 1px;\n}\n.checkbox-table.datatable-wrap .rdt_TableRow .rdt_TableCell:first-child input[type=\"checkbox\"]:checked:after\n// .checkbox-table.datatable-wrap .rdt_TableHeadRow .rdt_TableCol:first-child input[type=\"checkbox\"]:checked:after\n {\n    content: \"\";\n    display: block;\n    width: 7px;\n    height: 11px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    -webkit-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    transform: rotate(45deg);\n    position: absolute;\n    top: -1px;\n    left: 5px;\n    background: transparent;\n}\n.selectall-wrap {\n    display: none;\n}\n@media(max-width:992px){\n    .table-buttons-wrap {\n        padding-right: 30px;\n    }\n}\n@media(max-width:767px){\n.datatable-header-area{\n    flex-wrap: wrap;\n}\n.datatable-hedaer-right {\n    width: 100%;\n    flex: auto;\n}\n.table-buttons-wrap {\n    margin-left: 0;\n    padding-right: 0px;\n}\n.datatable-hedaer-left {\n    margin-bottom: 15px;\n    justify-content: flex-end;\n    width: 100%;\n}\n.results-tab-wrap .tab-content {\n    padding-top: 15px;\n}\n.checkbox-table.datatable-wrap .rdt_TableRow .rdt_TableCell:first-child input[type=\"checkbox\"]::after\n// .checkbox-table.datatable-wrap .rdt_TableHeadRow .rdt_TableCol:first-child input[type=\"checkbox\"]::after \n{\n    top: -2px;\n}\n.checkbox-table.datatable-wrap .rdt_TableRow .rdt_TableCell:first-child input[type=\"checkbox\"]:checked:before\n// .checkbox-table.datatable-wrap .rdt_TableHeadRow .rdt_TableCol:first-child input[type=\"checkbox\"]:checked:before\n{\n    top: -2px;\n\n}\n\n}\n// react-data-table-component 8 hides the checkbox input and draws its own box\n// on a .rdt_Checkbox wrapper. Drop the wrapper's box and show the input again,\n// so it sits in the cell as in v7 and the checkbox styles above apply.\n.datatable-wrap .rdt_Checkbox {\n    display: contents;\n}\n.datatable-wrap .rdt_Checkbox::before,\n.datatable-wrap .rdt_Checkbox::after {\n    content: none;\n}\n.datatable-wrap .rdt_Checkbox > input[type=\"checkbox\"] {\n    position: relative;\n    inset: auto;\n    width: auto;\n    height: auto;\n    opacity: 1;\n}\n","@use \"../../utils/variables\" as *;\n.custom-pagination .page-item.active .page-link {\n    background-color: $primary-color;\n    border: none;\n    color: #fff;\n}\n.custom-pagination .page-item .page-link {\n    border: none;\n}\n.custom-pagination .paginationStyle {\n    border: none;\n}\n.custom-pagination.pagination-sm .page-link {\n    padding: 0;\n    font-size: 13px;\n    line-height: 24px;\n    width: 24px;\n    height: 24px;\n    text-align: center;\n    border-radius: 4px;\n    background-color: transparent;\n    color: #000;\n}\n.pagination-sm .page-item:first-child .page-link {\n    background-color: #e9e9e9;\n    font-size: 20px;\n}\n.pagination-sm .page-item:last-child .page-link {\n    background-color: #e9e9e9;\n    font-size: 20px;\n}\n.pagination-sm .page-item:first-child .page-link span,\n.pagination-sm .page-item:last-child .page-link span {\n    position: relative;\n    top: -1px;\n}\n.custom-pagination li.page-item {\n    padding: 0 10px;\n}\n.custom-pagination {\n    margin: 30px -10px 0;\n}\n.custom-pagination li.page-item.disabled .page-link,\n.custom-pagination .paginationStyle .page-link {\n    font-size: 22px;\n    line-height: 22px;\n    font-weight: bold;\n}\n.custom-pagination li.page-item.disabled .page-link {\n    color: #9c9494;\n}\n.custom-pagination .page-link:focus {\n    box-shadow: none;\n}\n\n.react-new-pagination .page-item .page-link {\n    border: none;\n    font-weight: 500;\n    color: #878a8d;\n    font-size: 14px;\n    height: 32px;\n    padding: 0 10px;\n    line-height: 30px;\n    min-width: 30px;\n    text-align: center;\n}\n\n.react-new-pagination li.page-item {\n    padding: 0 6px;\n}\n\n.react-new-pagination .page-item.active .page-link {\n    background-color: $primary-color;\n    border: none;\n    color: #fff !important;\n    border-radius: 4px;\n}\n.react-new-pagination .page-item.page-item-arrow .page-link {\n    font-size: 22px;\n    line-height: 30px;\n    padding-top: 0;\n    padding-bottom: 0;\n    background: #f0f0f0;\n    border-radius: 4px !important;\n    height: 32px;\n    width: 32px;\n    padding: 0;\n    text-align: center;\n    color: #333;\n}\n.react-new-pagination .page-item.page-item-arrow.disabled .page-link {\n    color: #999;\n}\n.react-new-pagination .page-link:hover {\n    border-radius: 4px;\n}\n\n.react-new-pagination .page-item:not(:first-child) .page-link {\n    margin-left: 0;\n}\n.page-link:focus {\n    box-shadow: none;\n    opacity: 0.8;\n}\n@media (max-width: 767px) {\n    .custom-pagination li.page-item {\n        padding: 0 3px;\n    }\n}\n",".shared-name-wrap {\n    flex-wrap: wrap;\n}\n.shared-name-box {\n    border-bottom: 1px solid #ddd;\n    width: 100%;\n    margin-bottom: 12px;\n    padding-bottom: 10px;\n    padding-right: 20px;\n}\n// .shared-name-box:nth-child(2) {\n//     border: none;\n// }\n.shared-name-box:last-child {\n    margin: 0;\n    border: none;\n}\n.manage-access-popup .country-header-search {\n    margin: 0;\n    margin-bottom: 20px;\n}\n.share-title {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 17px;\n    letter-spacing: -0.02em;\n    color: #5b5b5b;\n}\n.b-t-0 {\n    border-top: none !important;\n}\n.shared-remove-btn {\n    display: flex;\n    align-items: center;\n}\n.shared-remove-btn span {\n    margin-left: 5px;\n    color: #5b5b5b;\n}\n\n.status-searchontop .pop-checkboxscroll {\n    height: 58vh;\n}\n// .status-searchontop .access-box {\n//     margin-top: 100px;\n// }\n.status-searchontop .react-select-2-option__menu-list {\n    max-height: 162px;\n}\n.status-searchontop .react-select-2-option__option {\n    padding-top: 6px;\n    padding-bottom: 6px;\n}\n.status-searchontop .react-select-2-option__menu {\nmargin-top: 2px;\n}\n\n@media(max-width:767px){\n    .shared-remove-btn span {\n        display: none;\n    }\n    .shared-name-box {\n        padding-right: 0;\n    }\n}","// Thin scrollbar for shared/components/scrollarea, matching the old\n// react-scrollbar look: a 4px black bar, faint until the box is hovered.\n.scrollarea > .ps > .ps__rail-y {\n    width: 4px;\n    right: 0;\n    background: none;\n    opacity: .1;\n}\n.scrollarea:hover > .ps > .ps__rail-y {\n    opacity: .3;\n}\n.scrollarea > .ps > .ps__rail-y:hover,\n.scrollarea > .ps > .ps__rail-y.ps--clicking {\n    background: gray;\n    opacity: .6;\n}\n.scrollarea > .ps > .ps__rail-y > .ps__thumb-y,\n.scrollarea > .ps > .ps__rail-y:hover > .ps__thumb-y,\n.scrollarea > .ps > .ps__rail-y.ps--clicking > .ps__thumb-y {\n    width: 4px;\n    right: 0;\n    background: #000;\n    border-radius: 20px;\n}\n",".pagenot-found .whitebox {\n    height: calc(100vh - 305px);\n    min-height: 450px;\n}\n.error-title {\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 25px;\n    margin-bottom: 10px;\n}\n.errorpages-content p {\n    font-weight: 500;\n    font-size: 13px;\n    line-height: 16px;\n    text-align: center;\n    color: #5b5b5b;\n}\n.positioned-backarrow {\n    position: absolute;\n    left: 30px;\n    top: 30px;\n}\n.link-expired p {\n    margin-left: auto;\n    margin-right: auto;\n    line-height: 24px;\n}\n","@use \"../../utils/variables\" as *;\n.custom-accordian .accordion-item {\n    border: none;\n    border-bottom: 1px solid #d9d9d9;\n    padding: 25px 0;\n}\n.custom-accordian .accordion-button {\n    box-shadow: none;\n    background: transparent;\n    font-size: 16px;\n    padding: 0;\n}\n.custom-accordian .accordion-button:not(.collapsed) {\n    color: $primary-color;\n    background: transparent;\n    padding: 0;\n    font-size: 16px;\n}\n.custom-accordian .custom-accordian-header {\n    display: flex;\n    align-items: flex-start;\n}\n.custom-accordian h4 {\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 22px;\n    margin: 0;\n}\n.faq-index {\n    margin-right: 0;\n    font-weight: bold;\n    min-width: 25px;\n}\n.custom-accordian .accordion-button:focus {\n    box-shadow: none;\n}\n.custom-accordian .accordion {\n    padding: 0 25px;\n}\n.custom-accordian .accordion-body {\n    padding: 0 25px;\n    margin-top: 15px;\n}\n\n.custom-accordian .accordion-button:not(.collapsed)::after {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23212529%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e\");\n}\n.custom-accordian .accordion-item:last-of-type {\n    border-radius: 0;\n}\n.filter-accordian-wrap .accordion-button:hover {\n    z-index: 0;\n}\n@media (max-width: 767px) {\n    .custom-accordian .accordion {\n        padding: 0;\n    }\n    .custom-accordian h4 {\n        font-size: 14px;\n        line-height: 20px;\n        padding-right: 5px;\n    }\n  \n    .custom-accordian .accordion-item {\n        padding: 15px 0;\n    }\n  \n}\n",".loader {\n    position: relative;\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    display: inline-block;\n    vertical-align: middle;\n}\n.loader-3 .dot {\n    width: 10px;\n    height: 10px;\n    background: #1A73E8;\n    border-radius: 50%;\n    position: absolute;\n    top: calc(50% - 5px);\n}\n\n.loader-3 .dot1 {\n    left: 0px;\n    -webkit-animation: dot-jump 0.5s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;\n    animation: dot-jump 0.5s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;\n}\n\n.loader-3 .dot2 {\n    left: 20px;\n    -webkit-animation: dot-jump 0.5s 0.2s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;\n    animation: dot-jump 0.5s 0.2s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;\n}\n\n.loader-3 .dot3 {\n    left: 40px;\n    -webkit-animation: dot-jump 0.5s 0.4s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;\n    animation: dot-jump 0.5s 0.4s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;\n}\n@-webkit-keyframes dot-jump {\n    0% {\n        -webkit-transform: translateY(0);\n        transform: translateY(0);\n    }\n    100% {\n        -webkit-transform: translateY(-15px);\n        transform: translateY(-15px);\n    }\n}\n\n@keyframes dot-jump {\n    0% {\n        -webkit-transform: translateY(0);\n        transform: translateY(0);\n    }\n    100% {\n        -webkit-transform: translateY(-15px);\n        transform: translateY(-15px);\n    }\n}",".homeslider .slick-prev,\n.homeslider .slick-next {\n    background: #ffffff;\n    border: none;\n    box-shadow: 0 1px 4px #c1c1c1;\n    border-radius: 4px;\n    width: 29px;\n    height: 31px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    bottom:0px;\n    top: inherit;\n    right: 15px;\n    transform:none;\n}\n.homeslider .slick-prev {\n    left: inherit;\n    right: 55px;\n}\n.homeslider .slick-prev::before,\n.homeslider .slick-next::before{\n    display: none;\n}\n.homeslider .slick-prev.slick-disabled,\n.homeslider .slick-next.slick-disabled{\n opacity: 0.5;\n cursor: default;\n}\n.homeslider {\n    padding-bottom: 40px;\n}\n.hom-secs .multimedia-wrap .homeslider .slick-prev {\n    right: 40px;\n\n}\n.hom-secs .multimedia-wrap .homeslider .slick-next {\n    right: 0px;\n}\n@media (max-width: 767px) {\n.homeslider .slick-next {\n    right:0;\n\n}\n.homeslider .slick-prev {\n    right: 40px;\n}\n}\n\n// /* the parent */\n// .homeslider .slick-list {\n//     margin: 0 -10px;\n// }\n\n","@use \"../../utils/variables\" as *;\n.notification-dropdown .dropdown-menu {\n    width: 390px;\n    background-color: #fff;\n}\n.notification-dropdown .dropdown-menu.show.dropdown-menu-end {\n    padding: 10px 0 0;\n}\n.notification-wrap {\n    position: relative;\n}\n.notification-dropdown .dropdown-menu .notification-wrap::after {\n    position: absolute;\n    width: 0;\n    height: 0;\n    border-left: 15px solid transparent;\n    border-right: 15px solid transparent;\n    border-bottom: 15px solid #fff;\n    top: -24px;\n    right: 20px;\n    content: \"\";\n}\n.notification-dropdown .dropdown-menu {\n    transform: translate(30px, 61px) !important;\n}\n\n.notification-dropdown .dropdown-menu .notification-list {\n    padding: 0;\n    // margin-right: -10px;\n}\n.notification-dropdown .dropdown-menu .dropdown-item {\n    list-style: none;\n    padding: 0 5px;\n}\n.notification-list .dropdown-item h3 {\n    font-size: 13px;\n    margin-bottom: 5px;\n    font-weight: 500;\n    color: #212529;\n}\n.notification-list h3 .notify-user-name {\n    font-weight: 600;\n}\n.notifi-img-left img {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    border: 2px solid #fff;\n    box-shadow: 0 0 5px #aaa;\n}\n\n.notification-content-row {\n    padding: 15px;\n    border-bottom: 1px solid #ddd;\n}\n.notifi-content-right {\n    padding-left: 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n.notification-time span {\n    color: #5b5b5b;\n    font-size: 13px;\n    font-weight: 500;\n}\n.notification-footer {\n    text-align: center;\n    font-weight: 500;\n    font-size: 13px;\n    line-height: 16px;\n    letter-spacing: -0.02em;\n    margin-bottom: 0;\n    padding-top: 10px;\n    box-shadow: 0px -4px 5px #f3f3f3;\n    padding-bottom: 10px;\n    cursor: pointer;\n}\n.notification-footer img {\n    margin-left: 5px;\n}\n.notification-scroll {\n    max-height: 60vh;\n    min-height: 30vh;\n}\n.notification-dropdown .dropdown-toggle::after {\n    display: none;\n}\n.notification-dropdown.dropdown {\n    margin-right: 20px;\n}\n.unread-notif {\n    background-color: #e9f2ff;\n}\n.read-notify {\n    background-color: #fff;\n}\n.no-item {\n    padding: 20px 10px;\n    text-align: center;\n    color: #777;\n     margin-top: -10px;\n}\n.noti-count {\n    background: $primary-color;\n    padding: 2px;\n    top: 2px;\n    left: 11px;\n    position: absolute;\n    height: 18px;\n    line-height: 14px;\n    font-weight: bold;\n    color: #fff;\n    border-radius: 3px;\n    z-index: 9;\n    font-size: 12px;\n}\n.menu-items .dropdown .notification-btn .btn {\n    background-color: transparent;\n    color: $primary-color;\n    padding: 0 10px;\n    height: 20px;\n    font-weight: 500;\n}\n.notification-dropdown .dropdown-menu ul .dropdown-item:last-child .notification-content-row {\n    border: none;\n}\n.notification-btn {\n    padding-right: 20px;\n    border-bottom: 1px solid #ddd;\n    padding-bottom: 10px;\n    text-align: right;\n}\n.notification-dropdown .dropdown-menu .dropdown-item:hover {\n    cursor: pointer;\n    background: #e2e8ef;\n}\n.view-less-arrow {\n    transform: rotate(180deg);\n    display: inline-block;\n    position: relative;\n    top: 2px;\n    left: 5px;\n}\n.notification-dropdown .dropdown-menu .notification-scroll .notification-list {\n\n    margin-right: -10px;\n}\n@media (max-width: 767px) {\n    .notification-dropdown .dropdown-menu {\n        width: 90%;\n        margin: 0 auto 15px;\n    }\n    .notification-dropdown.dropdown {\n        margin-right: 0;\n        border: none;\n        padding: 0;\n    }\n    .notification-dropdown .dropdown-menu {\n        margin: 0 auto;\n        transform: none !important;\n        border: 1px solid #ddd !important;\n    }\n    .notification-dropdown .btn {\n        margin-left: 25px;\n        position: relative;\n    }\n    .noti-count {\n        top: -10px;\n        left: 13px;\n        font-weight: 600;\n    }\n    .notification-mobile-only .notification-dropdown {\n        position: inherit;\n    }\n    .notification-dropdown .dropdown-menu {\n        width: 100%;\n        box-shadow: 0 0 10px #ddd;\n    }\n    .notification-dropdown .dropdown-menu.show.dropdown-menu-end {\n        top: 45px !important;\n    }\n    .notification-dropdown .dropdown-menu .notification-wrap::after {\n       right: 67px;\n       \n    }\n    .notification-list .dropdown-item {\n        white-space: inherit;\n    }\n    .notification-mobile-only .notification-dropdown .notification-btn .btn {\n        color: $primary-color;\n    }\n}\n",".shimmer-card {\n    position: relative;\n    -webkit-box-shadow: 0 6px 8px rgba(0, 0, 0, 0.1);\n    box-shadow: 0 0px 8px rgba(0, 0, 0, 0.1);\n    background-color: #fff;\n    border-radius: 6px;\n    height: 240px;\n    overflow: hidden;\n    width: 100%;\n    margin-bottom: 15px;\n\n    .shimmerBG {\n        animation-duration: 2.2s;\n        animation-fill-mode: forwards;\n        animation-iteration-count: infinite;\n        animation-name: shimmer;\n        animation-timing-function: linear;\n        background: #ddd;\n        background: linear-gradient(to right, #f2f2f2 8%, #fcfcfc 18%, #f2f2f2 33%);\n        background-size: 1200px 100%;\n    }\n\n    @-webkit-keyframes shimmer {\n        0% {\n            background-position: -100% 0;\n        }\n        100% {\n            background-position: 100% 0;\n        }\n    }\n\n    @keyframes shimmer {\n        0% {\n            background-position: -1200px 0;\n        }\n        100% {\n            background-position: 1200px 0;\n        }\n    }\n\n    .media {\n        height: 200px;\n    }\n\n    .p-32 {\n        padding: 32px;\n    }\n\n    .title-line {\n        height: 24px;\n        width: 100%;\n        margin-bottom: 12px;\n        border-radius: 20px;\n    }\n\n    .content-line {\n        height: 8px;\n        width: 100%;\n        margin-bottom: 16px;\n        border-radius: 8px;\n    }\n\n    .end {\n        width: 40%;\n    }\n}\n\n.m-t-24 {\n    margin-top: 24px;\n}\n.no-other-reco {\n    font-size: 13px;\n    color: #727780;\n    padding: 0 15px;\n    display: block;\n    line-height: 34px;\n}\n.shimmer-card .big-title-line.title-line {\n    height: 34px;\n}\n.shimmerloadingtext .shimmerBG {\nanimation: none;\n}\n.shimmerloadingtext .shimmer-card .shimmerBG {\nbackground: #e4e7ea;\n}\n// .multimedia-wrap .shimmerloadingtext .shimmer-card {\n//     border: none;\n// }\n.shimmerloadingtext .shimmer-card {\nborder-left: 1px solid #e4e7ea;\nbox-shadow: none;\nborder-radius: 0;\n    margin: 0;\n    height: auto;\n}\n.shimmerloadingtext .shimmer-card .p-32 {\n    padding:0 0px 32px 20px;\n}\n.news-right-shimmer-box .shimmer-card {\nheight: 140px;\nmargin-bottom: 0;\n}\n.news-right-shimmer-box .shimmer-loading-box {\n    width: 100%;\n}\n.multimedia-shimmer-loading-box .shimmer-card .content-line{\nmargin-bottom: 25px;\n}\n.multimedia-shimmer-loading-box {\n    height: 100%;\n    padding-bottom: 40px;\n}\n.multimedia-shimmer-loading-box .shimmer-card {\n    height: 100%;\n}\n@media (min-width: 992px) and (max-width: 1200px) {\n    .shimmerloadingtext .shimmer-card .p-32 {\n        padding:0 0px 32px 20px;\n    }\n}\n@media (max-width: 991px) {\n    .rec-shimmer-row .shimmer-col-3 {\n        display: none;\n    }\n    .no-other-reco {\n        font-size: 13px;\n    }\n    .shimmerloadingtext-2 {\n        display: none;\n    }\n    .shimmerloadingtext-single {\n        display: none;\n    }\n}\n@media (max-width: 767px) {\n    .rec-shimmer-row .shimmer-col-2 {\n        display: none;\n    }\n    .shimmerloadingtext {\n        display: none;\n    }\n}\n",".home-content-area {\n    padding: 23px 0;\n}\n.home-content-area .sub-head-margin {\n    margin-bottom: 30px;\n}\n.view-similar-btn {\n    font-weight: 600;\n    font-size: 12px;\n    color: #333;\n    text-decoration: none;\n    border-radius: 30px;\n    border: 1px solid #d9d9d9;\n    width: 36px;\n    white-space: nowrap;\n    height: 36px;\n    overflow: hidden;\n    text-align: center;\n    align-items: center;\n    padding: 0 7px;\n    transition: width 0.5s;\n}\n.view-similar-btn:hover {\n    width: 120px;\n    transition: width 0.5s;\n}\n.view-similar-btn img {\n    width: 22px !important;\n}\n.view-similar-btn span {\n    margin-left: 6px;\n}\n\n.view-similar-btn span {\n    color: #333;\n    font-weight: 600;\n}\n.logo img {\n    max-height: 30px;\n}\n.home-content-area .slider-item .sourcebox p {\n    max-height: 60px;\n    overflow: hidden;\n}\n.home-desc-scroll {\n    max-height: 110px;\n}\n\n.upgrade-pop-wrap.no-results .upgrade-title {\n    font-size: 20px;\n    line-height: 24px;\n}\n.upgrade-pop-wrap.no-results .btn-sm {\n    min-width: 60px;\n}\n.homeslider .slick-track {\n    margin-left: 0;\n}\n.reco-date {\n    line-height: 20px;\n    font-weight: 500;\n    font-size: 12px;\n    color: #8a8b8c;\n    flex-shrink: 0;\n    padding-left: 15px;\n}\n@media(max-width:767px){\n    .view-similar-btn {\n        width: auto;\n    }\n    .home-content-area.result-content-area {\n        padding: 23px 0 40px; \n    }\n}","@use \"../../../utils/variables\" as *;\n.banner-wrap {\n    padding: 20px;\n    background: #f3f5f7;\n    border-radius: $radius;\n}\np.banner-info-text {\n    position: absolute;\n    bottom: 45px;\n    left: 35px;\n    margin: 0;\n    color: #555;\n    font-size: 12px;\n    font-style:italic;\n}\n.banner-content-box {\n    background: linear-gradient(180deg, #4991ef 0%, #1a73e8 100%);\n    box-shadow: 0px 10px 10px rgba(133, 175, 214, 0.45);\n    padding: 12px;\n    border-radius: $curveradius;\n    position: relative;\n}\n\n.banner-textarea-wrap textarea.form-control {\n    min-height: 100px;\n    border: none;\n    background: #f0f0f0;\n    font-size: 14px;\n    color: #5b5b5b;\n    padding: 10px 18px;\n    box-sizing: border-box;\n    max-height: 170px;\n    border-radius: $curveradius;\n}\n.banner-textarea-wrap .form-control::placeholder {\n    font-style: italic;\n    color: #8c8c8c;\n}\n\n.dragand-drop-style {\n    min-height: 99px;\n    background: #f3f5f7;\n    border: 2px dashed #d6d7d8;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: $radius-md;\n    padding: 0;\n    text-align: center;\n    flex-direction: column;\n    padding-bottom: 10px;\n    padding-top: 10px;\n}\n.dragand-drop-style p {\n    margin-bottom: 0;\n    font-size: 13px;\n    color: #808080;\n    line-height: 22px;\n}\n.drop-upload-icon {\n    display: block;\n    margin-bottom: 7px;\n}\n\n.tab-content .banner-tab {\n    background: #fff;\n    padding: 10px;\n    border-radius: $curveradius;\n    padding-bottom: 60px;\n}\n.banner-btn-wrap .btn {\n    position: absolute;\n    bottom: 20px;\n    right: 20px;\n}\n.dragand-drop-style div:empty {\n    display: none !important;\n}\n.dragand-drop-style .filename-uploaded {\n    color: $primary-color;\n    word-break: break-all;\n}\n.remove-uploaded-btn svg {\n    width: 10px;\n}\n.remove-uploaded-btn svg path {\n    fill: #fff;\n}\n.remove-uploaded-btn.btn{\n    padding: 0;\n    position: absolute;\n    right: 20px;\n    top: 7px;\n    z-index: 100;\n}\n.length-exceeded {\n    font-size: 10px;\n    color: red;\n}\n@media (max-width: 767px) {\n    .banner-wrap {\n        padding: 10px 0;\n    }\n    .remove-uploaded-btn.btn {\n        font-size: 10px;\n        min-width: 80px;\n    }\n    .remove-uploaded-btn svg {\n        width: 8px;\n    }\n    p.banner-info-text{\n        display: none;\n    }\n}\n","@use \"../../../utils/variables\" as *;\n.sourcebox h3 {\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 20px;\n    border-bottom: 1px solid #d9d9d9;\n    padding-bottom: 15px;\n    margin-bottom: 15px;\n    letter-spacing: 0.5px;\n}\n.sourcebox p {\n    font-size: 14px;\n    line-height: 20px;\n    letter-spacing: 0.02em;\n    color: #5b5b5b;\n}\n.icon-button {\n    padding: 0;\n    border: none;\n    background: transparent;\n    display: inline-flex;\n    align-items: center;\n    margin-right: 25px;\n}\n.icon-button:last-child {\n    margin-right: 0;\n}\n.source-footer {\n    display: flex;\n    align-items: center;\n}\n.like-count {\n    margin-right: 6px;\n    font-size: 15px;\n    font-weight: 500;\n    line-height: normal;\n    margin-top: 2px;\n    min-width: 12px;\n}\n.liked svg {\n    width: 22px;\n}\n.icon-button .liked-icon {\n    display: none;\n}\n.icon-button.liked .normal-icon {\n    display: none;\n}\n.icon-button.liked .liked-icon {\n    display: inline-block;\n}\n\n.slick-slide .sourcebox {\n    border-left: 1px solid #d9d9d9;\n    padding-left: 15px;\n    padding-right: 15px;\n}\n.slick-slide:first-child .sourcebox{\n    border: none;\n    padding-left: 0px;\n}\n.source-label {\n    background: #eff0f2;\n    border-radius: 13px;\n    padding: 4px 10px;\n    color: #5b5b5b;\n    font-size: 12px;\n}\n.multi-label-wrap .source-label {\n    margin-left: 10px;\n}\n.multi-label-wrap .source-label:first-child {\n    margin-left: 0;\n}\n.hom-secs .slider-item .sourcebox {\n    flex: 1;\n}\n.hom-secs .sourcebox h3 a:hover{\n    color: $primary-color !important;\n    display: block;\n}\n.source-content {\n    min-height: 100px;\n}\n.showmore-button {\n    font-size: 12px;\n}\n.hom-secs .sourcebox h3 {\n    word-break: break-word;\n}\n@media (min-width: 768px) {\n    .hom-secs .sourcebox h3 {\n        height: 48px;\n        overflow: hidden;\n        padding-bottom: 0;\n        line-height: 22px;\n    }\n}\n@media (max-width: 767px) {\n    .sourcebox h3 {\n        margin-bottom: 5px;\n    }\n    .sourcebox {\n        margin-right: 0;\n    }\n    .slick-slide .sourcebox {\n        border-left: none;\n        padding-left: 0;\n        padding-right:0;\n    }\n}\n","@use \"../../../utils/variables\" as *;\n.news-img-sec img {\n    width: 100%;\n    border-radius: $radius-md;\n}\n.news-small-left {\n    width: 40%;\n}\n.news-small-left img {\n    max-width: 100%;\n    border-radius: $radius;\n}\n.news-small-right {\n    width: 60%;\n    padding-left: 14px;\n    padding-top: 5px;\n    padding-bottom: 5px;\n}\n.news-small-right h4 {\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 20px;\n}\n.news-small-wrap {\n    margin-bottom: 30px;\n}\n.new-big-sec .sourcebox {\n    margin-right: 0;\n}\n.news-right {\n    padding-left: 15px;\n    border-left: 1px solid #d9d9d9;\n    height: 100%;\n}\n.news-right li h4 {\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 20px;\n    margin: 0;\n    word-break: break-word;\n    \n}\n.hom-secs .new-big-sec {\n    padding-top: 0;\n    margin-bottom: 40px;\n}\n.news-right ul {\n    margin: 0;\n    padding: 0;\n}\n.news-right li {\n    list-style: none;\n    min-height: 100px;\n    display: flex;\n    align-items: flex-start;\n    border-bottom: 1px solid #d9d9d9;\n    flex-wrap: wrap;\n    flex-direction: column;\n    justify-content: center;\n    padding: 20px 0;\n}\n.news-right li:last-child {\n    border: none;\n    padding-bottom: 0;\n}\n.news-right li .authors-name {\n    margin-top: 12px;\n}\n.news-small-box-wrap {\n    padding-right: 10px;\n}\n.hom-secs .news-wrap .sourcebox h3,\n.hom-secs .new-big-sec {\n    border: none;\n}\n.hom-secs .news-wrap .sourcebox h3 {\n    height: auto;\n    word-break: break-word;\n}\n.new-right-wrap {margin-left: -4px;}\n.news-wrap .source-content {\n    min-height: inherit;\n}\n.hom-secs .new-big-sec {\n    padding-right: 12px;\n}\n@media (min-width: 1200px) {\n    .news-big-repeat:nth-child(5) .new-big-sec, .news-big-repeat:nth-child(6) .new-big-sec {\n        margin-bottom: 0;\n    }\n    .news-wrap {\n        padding-bottom: 40px;\n    }\n}\n@media (max-width: 1400px) {\n    // .news-small-wrap {\n    //     // margin-bottom: 25px;\n    // }\n}\n@media (max-width: 991px) {\n    .news-small-box-wrap.right-border {\n        border: none;\n    }\n    .news-right li {\n        padding: 20px 10px;\n        min-height: inherit;\n        border: 1px solid #d9d9d9 !important;\n        margin-bottom: -1px;\n    }\n    .news-right {\n        padding-left: 0;\n        border: none;\n    }\n    .news-right li h4 {\n        font-size: 14px;\n    } \n    .new-right-wrap {\n        margin-left: 0;\n        padding-left: 13px !important;\n    }\n    .hom-secs .new-big-sec {\n        padding-right: 0;\n    }\n    li.news-right-shimmer-box {\n        display: none;\n    } \n}\n@media (max-width: 767px) {\n    .new-big-sec {\n        margin-bottom: 30px;\n    }\n    .news-small-left {\n        width: 100px;\n    }\n    .news-small-right {\n        width: auto;\n    }\n  \n   \n}\n","@use \"../../../utils/variables\" as *;\n.video-frame-wrap {\n  display: flex;\n  height: 222px;\n  background: #555;\n  border: 1px solid #ddd;\n  border-radius: $radius-md;\n}\n\n.video-frame-wrap iframe {\n  flex: 1;\n  max-height: 100%;\n  max-width: 100%;\n  border-radius: $radius-md;\n}\n.react-player__preview {\n  border-radius: $radius-md;\n}\n.hom-secs .multimedia-wrap .sourcebox {\n  margin-right: 0;\n}\n.hom-secs .multimedia-wrap .sourcebox h3 {\n  border: none;\n  padding-bottom: 0;\n}\n.multimedia-wrap .slick-slide .sourcebox {\n  border: none;\n  padding-left: 12px;\n  padding-right: 12px;\n}\n.multimedia-wrap .slick-list {\n  margin: 0 -12px;\n}\n.hom-secs .multimedia-wrap {\n  padding-right: 15px;\n}\n@media (max-width: 1400px) {\n  .video-frame-wrap {\n    height: 160px;\n  }\n}\n@media (max-width: 767px) {\n  .video-frame-wrap {\n    height: 200px;\n  }\n  .hom-secs .multimedia-wrap {\n    padding-right: 0;\n  }\n}\n",".results-header .btn {\n    padding: 0 10px;\n}\n.results-header {\n    border-bottom: 1px solid #d7e0e9;\n    padding-bottom: 15px;\n}\n.results-header h4 {\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 22px;\n    letter-spacing: -0.02em;\n    margin: 0;\n}\n.results-text {\n    font-size: 18px;\n    line-height: 22px;\n    color: #252525;\n    margin-bottom: 10px;\n}\n.savequery-wrap {\n    margin: 30px 0;\n}\n.mobile-fliter-full {display: none;}\n.results-btns.double-btn {\n    min-width: 372px;\n    margin-left: 10px;\n    margin-top: 3px;\n}\n.filter-button .btn {\n    padding: 0 10px;\n    min-width: inherit;\n}\n.filter-box-scroll {\n    max-height: 25vh;\n    margin-top: 10px;\n}\n.results-tab-wrap .nav-link:focus-visible {outline: none !important;}\n.result-content-area .results-tab-wrap .nav-item:nth-child(8) {\n    position: relative;\n}\n.result-content-area .results-tab-wrap .nav-item:first-child {\n  text-align: left;\n}\n.result-content-area .results-tab-wrap .nav-item:nth-child(8)::after {\n    position: absolute;\n    left: 0;\n    width: 2px;\n    background-color: #ddd;\n    top: -6px;\n    bottom: 6px;\n    content: \"\";\n}\n\n.result-content-area .results-tab-wrap .nav-tabs .nav-link {\n    display: inline-block;\n}\n.filter-box-scroll .ps__thumb-y {\n    width: 4px;\n}\n.filter-box-scroll .ps__rail-y {\n    width:6px;\n}\n.ps__rail-y:hover > .ps__thumb-y {\n    background-color: #999;\n    width: 4px;\n}\n@media (min-width: 768px) {\n    .result-content-area .results-tab-wrap .nav-item {\n        flex:1;\n        text-align: center;\n    }\n}\n@media (min-width: 768px) and (max-width: 1200px) {\n    .filter-button .btn {\n        padding: 0 10px;\n        min-width: 100%;\n        margin: 10px 0 0 0;\n    }   \n \n}\n\n@media (max-width: 991px) {\n    .results-tab-wrap .nav-tabs{\n        justify-content: flex-start;\n    }\n    .results-tab-wrap .nav-tabs .nav-link.active::after {\n        bottom: -3px;\n    }\n    .results-tab-wrap .nav-tabs .nav-link {\n        font-size: 13px;\n        margin-bottom: 15px;\n    }\n    .results-tab-wrap {\n        margin: 0;\n    }\n  \n}\n\n\n@media (max-width: 767px) {\n    .results-header {\n        flex-wrap: wrap;\n    }\n    .results-header h4 {\n        margin-bottom: 15px;\n        word-break: break-all;\n    }\n    .results-header .btn {\n        padding: 0 5px;\n        font-size: 12px;\n        min-width: inherit;\n    }\n    .results-btns.double-btn {\n        display: flex;\n        justify-content: space-between;\n        width: 100%;\n    }\n    .results-text {\n        font-size: 15px;\n    }\n    .results-btns.double-btn {\n        min-width:inherit;\n        margin-left:0;\n        margin-top: 0;\n    }\n    .main-container {\n        position: inherit !important;\n    }\n    .result-content-area .results-tab-wrap .nav-item:nth-child(8)::after {\n        top: 0px;\n        bottom: 15px;\n    }\n  \n\n}\n","@use \"../../../utils/variables\" as *;\n.result-filter-box {\n    background: #ffffff;\n    border: 1px solid #ffffff;\n    box-shadow: 0px 1px 10px rgb(0 0 0 / 10%);\n    border-radius:$curveradius;\n    padding: 18px 18px 5px;\n}\n.result-filter-box .accordion-item {\n    border: none;\n}\n.result-filter-box .accordion-button {\n    font-weight: 700;\n    font-size: 15px;\n    line-height: 18px;\n    color: $theme-body-font-color;\n    background: transparent;\n    padding-left: 10px;\n    padding-right: 10px;\n}\n.result-filter-box .accordion-button:not(.collapsed) {\n    color: $theme-body-font-color;\n}\n.result-filter-box .accordion-button:not(.collapsed)::after {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n.result-filter-box .accordion-button:focus {\n    border-color: transparent;\n    box-shadow: none;\n}\n.result-filter-box .accordion-header {\n    margin-bottom: 0;\n    border-bottom: 1px solid #d7e0e9;\n}\n.result-filter-box .accordion-item:last-child .accordion-header {\n    border: none;\n}\n.result-filter-box .accordion-button:not(.collapsed) {\n    box-shadow: none;\n}\n.result-filter-box h4 {\n    font-weight: 600;\n    font-size: 15px;\n    line-height: 18px;\n    letter-spacing: -0.02em;\n    color: #5b5b5b;\n    border-bottom: 1px solid #d7e0e9;\n    padding-bottom: 15px;\n    margin-bottom: 5px;\n    padding-left: 10px;\n    text-indent: 2px;\n}\n.filter-sub-text {\n    font-size: 11px;\n    font-weight: normal;\n    display: inline-block;\n    margin-left: 2px;\n    text-indent: 0;\n\n}\n\n.result-filter-box .accordion-button::after {\n    width: 18px;\n    height: 18px;\n    background-size: 18px;\n}\n.result-filter-box .accordion-body {\n    padding: 10px;\n}\n.country-header-search {\n    margin: 0 -10px;\n    position: relative;\n}\n.country-header-search .country-search {\n    padding-left: 30px;\n}\nspan.search-icon {\n    position: absolute;\n    left: 7px;\n    top: 9px;\n}\n.view-more-check {\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 17px;\n    letter-spacing: -0.02em;\n    color: $primary-color;\n}\n\n.calendar-icon {\n    background: $primary-color;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    height: 39px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 39px;\n    cursor: pointer;\n    pointer-events: none;\n}\n.calendar-modal .modal-dialog {\n    max-width: 621px;\n}\n.calendar-modal .modal-dialog.modal-md {\n    max-width: 500px;\n}\n.calendar-pop-header {\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 22px;\n    letter-spacing: -0.02em;\n    border-bottom: 1px solid #cccdce;\n    margin-bottom: 12px;\n    padding-bottom: 10px;\n}\n.calendaer-pop-footer {\n    margin-top: 10px;\n    border-top: 1px solid #d7e0e9;\n}\n.filter-accordian-wrap .btn-wrap {\n    // padding-left: 10px;\n    margin-top: 30px;\n    margin-bottom: 20px;\n}\n// ****checkbox-style start****\n.checkbox-wrapper {\n    position: relative;\n    padding-left: 30px;\n    margin-bottom: 20px;\n}\n\n.checkbox-wrapper:last-child {\n    margin-bottom: 0;\n}\n\n.checkbox-wrapper input {\n    position: absolute;\n    left: -9999px;\n}\n\n.checkbox-wrapper input + label {\n    cursor: pointer;\n    user-select: none;\n}\n\n.checkbox-wrapper input + label:before {\n    content: \"\";\n    position: absolute;\n    left: 0px;\n    top: 0;\n    width: 18px;\n    height: 18px;\n    border: 2px solid #cccdce;\n    border-radius: 1px;\n}\n\n.checkbox-wrapper input:checked + label:before {\n    background: url(\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAASABIAAD/4QBMRXhpZgAATU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAKqADAAQAAAABAAAAKgAAAAD/7QA4UGhvdG9zaG9wIDMuMAA4QklNBAQAAAAAAAA4QklNBCUAAAAAABDUHYzZjwCyBOmACZjs+EJ+/8AAEQgAKgAqAwEiAAIRAQMRAf/EAB8AAAEFAQEBAQEBAAAAAAAAAAABAgMEBQYHCAkKC//EALUQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+v/EAB8BAAMBAQEBAQEBAQEAAAAAAAABAgMEBQYHCAkKC//EALURAAIBAgQEAwQHBQQEAAECdwABAgMRBAUhMQYSQVEHYXETIjKBCBRCkaGxwQkjM1LwFWJy0QoWJDThJfEXGBkaJicoKSo1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoKDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uLj5OXm5+jp6vLz9PX29/j5+v/bAEMAAQEBAQEBAgEBAgMCAgIDBAMDAwMEBQQEBAQEBQYFBQUFBQUGBgYGBgYGBgcHBwcHBwgICAgICQkJCQkJCQkJCf/bAEMBAQEBAgICBAICBAkGBQYJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCf/dAAQAA//aAAwDAQACEQMRAD8A/v4ooooAKKK8S+Lv7R/wO+A11pVj8XfElroc2ty+TZxzb2aQ5ALERqxSMEgNI+1Fzywruy7LMTjKyw+EpynN7Rim27auyV3otThzLNMNg6LxGMqRhBbyk1FK+iu3ZavQ9tooorhO4//Q/v4r83fi5/wUj8A/Av8Aatj/AGcvifodzpelSQ27/wDCRSygQB7lAyt5OzJt1J8t5hJ8rqwKYUmv0ir5A/bI/Y6+H37X/wAOW8NeIQtjrlirvpOqquZLaUjlW6F4XIAkTPPDDDAGvvfDetkMcyVPiSnKVCaceaLadNu1qiS+Ll/ld1Z3s7JP4HxJoZ/LLHV4aqRjiINS5ZJNVEr3ptv4ebpJWaatdJtqp+2D+2l8NP2S/hqvivVZY9U1nVIz/Y+mxSDddNjiQsM7YFyC8mPZcsQK/KT9jz9kH4m/tsfEz/hsv9sV5LjSbiRZtM06UFFvFQ5iAjP+rsY/4E6zck5Ukve/ZL/4JP8AxLvfiRH4v/bMdbvSfDQS10zTPtYvEvEgJ8rcwZvLs06rCdrMThkVch/6EoIILWBLW1RY4o1CoigBVUDAAA4AA6Cv2bPuKcn4KwVTJ+E66r4qqrVMStowe1Olq7Nq3NJPfre3J+LZBwrnHG+Np5xxbQdDC0nelhnvKa3qVdFdJ35YtbdLN88tFFFfy4f1Of/R/v4ooooAKKKKACiiigD/2Q==\");\n    background-repeat: no-repeat;\n    background-size: 18px;\n    background-position: center;\n}\n// ****checkbox-style end****\n\n// ***calendar-style***\n.custom-date-picker .react-date-picker__wrapper {\n    background-color: #f3f5f7;\n    border-radius: $radius;\n    height: 39px;\n    border: none;\n    font-size: $body-font-size-medium;\n    width: 100%;\n    padding-left: 10px;\n}\n.custom-date-picker .react-date-picker {\n    display: block;\n}\n.custom-date-picker .react-date-picker__button svg {\n    width: 15px;\n    margin-right: 6px;\n}\n\n.custom-date-picker .react-date-picker__calendar .react-calendar {\n    border: none;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.26);\n    border-radius: 3px;\n}\n.custom-date-picker .react-calendar__navigation button {\n    min-width: 44px;\n    background: none;\n    font-size: 20px;\n}\n.custom-date-picker .react-calendar__navigation {\n    margin-bottom: 0;\n}\n.custom-date-picker .react-calendar__navigation__label {\n    font-size: 14px !important;\n    font-weight: bold;\n    color: $primary-color;\n}\n.custom-date-picker .react-calendar__tile {\n    font-size: 11px;\n    font-weight: 600;\n    font-family: $primary-font;\n}\n.custom-date-picker .react-calendar__tile--active {\n    background: $primary-color;\n    border-radius: $radius;\n}\n.custom-date-picker .react-calendar button:enabled:hover {\n    border-radius: $radius;\n}\n.custom-date-picker .react-calendar__month-view__weekdays {\n    text-align: center;\n    text-transform: uppercase;\n    font-weight: bold;\n    font-size: 0.75em;\n    background: #ebf0f8;\n    padding: 5px 0;\n    margin-bottom: 10px;\n}\n.custom-date-picker .react-calendar__month-view__weekdays abbr[title] {\n    border-bottom: none !important;\n    cursor: inherit !important;\n    text-decoration: none !important;\n}\n.custom-date-picker .react-date-picker__calendar {\n    width: 300px;\n    z-index: 50;\n}\n.custom-date-picker .react-date-picker__inputGroup__input:invalid {\n    background: transparent;\n}\n.custom-date-picker .react-date-picker__inputGroup__input:focus {\n    border: none;\n    outline: none;\n}\n// ***calendar-style end***\n.mobile-fliter {\n    display: none;\n}\n.filter-toggle-button-box h4 {\n    display: flex;\n    font-size: 14px;\n    font-weight: normal;\n    line-height: 22px;\n}\n.filter-toggle-button-box h4 img {\n        max-width: 16px;\n        margin-left: 10px;\n\n}\n.filter-toggle-button-box {\n    padding: 20px;\n    background: #eff0f2;\n    margin-bottom: 20px;\n    border-radius: 4px;\n    box-shadow: 0 0 5px #c0c0c0;\n}\n.filter-toggle-button-box h4 {\n    margin-bottom: 0;\n}\n.form-switch .form-check-input {\n    width: 40px !important;\n    height: 20px;\n    border-color: #DFE1E7;\n}\n.form-switch  .form-check-input:focus {\n    box-shadow: none;\n}\n.experts-filter-head {\n    position: relative;\n}\n.text-info-head {\n    position: absolute;\n    right: 0;\n}\n.experts-filter-head h4 {\n    flex: 1;\n}\n.text-info-head img {\n    max-width: 16px;\n}\n.react-date-picker__inputGroup__input, .react-date-picker__inputGroup {\n    cursor: pointer;\n}\n.country-filter .react-multi-select {margin-bottom: 10px;}\n.country-filter .react-select-2-option__menu {z-index: 10;}\n@media (min-width: 768px) and (max-width: 991px) {\n    .result-filter-box .accordion-body {\n        padding: 10px 0;\n    }\n    .result-filter-box .accordion-button {\n        font-size: 13px;\n        padding-left: 0;\n        padding-right: 0;\n    }\n}\n@media (max-width: 991px) {\n    .multi-label-wrap {\n        flex-wrap: wrap;\n        margin-bottom: 5px;\n    }\n    .source-label {\n        margin-bottom: 10px;\n        margin-left: 0 !important;\n        margin-right: 10px;\n    }\n    .result-filter-box {\n        margin-bottom: 20px;\n    }\n   \n    .source-label:empty {\n        display: none;\n    }\n    \n}\n@media (max-width: 767px) {\n    .filter-active {\n        display: block;\n    }\n    // .mobile-fliter {\n    //     display: flex;\n    // }\n   \n    .mobile-fliter svg path {\n        fill: #fff;\n    }\n    .filter-active .result-filter-box {\n        margin-bottom: 20px;\n        position: fixed;\n        bottom: 70px;\n        z-index: 110;\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        margin: 0;\n    }\n\n    .mobile-fliter-full {\n        display: flex;\n        justify-content: space-between;\n        background: $primary-color;\n        position: fixed;\n        z-index: 130;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        color: #fff;\n        padding:10px 15px 10px 10px;\n        align-items: center;\n        box-shadow: 1px 0 6px #0000009e;\n    }\n    .mobile-fliter-full h4 {\n        font-size: 14px;\n        margin: 0;\n        color: #fff;\n    }\n    .mobile-fliter-full svg path{fill: #fff;}\n    .filter-hidden {\n        display: none;\n    }\n    .econ-fixed-div .filter-active {\n        position: fixed;\n        background: #fff;\n        z-index: 99;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n    }\n    .econ-fixed-div .filter-active .result-filter-box {\n        position: relative;\n        top: inherit;\n    }\n    .filter-toggle-button-box {\n        margin-bottom: 0;\n    }\n}","@use \"../../../utils/variables\" as *;\n.fin-result-contents {\n    padding-left: 15px;\n}\n.fin-result-contents .sourcebox h3 {\n    border: none;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 20px;\n    padding-bottom: 10px;\n    word-break: break-word;\n}\n.fin-result-contents .sourcebox {\n    margin-bottom: 50px;\n}\n.fin-result-contents .sourcebox p {\n    margin-bottom: 25px;\n}\n.fin-result-contents .sourcebox {\n    border: none;\n    margin-right: 0;\n    padding-right: 0;\n}\n.more-text-wrap {\n    margin-bottom: 25px;\n    font-size: 13px;\n    line-height: 22px;\n}\n.showmore-button {\n    white-space: nowrap;\n    font-weight: 500;\n    font-style: italic;\n    color:$primary-color;\n    cursor: pointer;\n}\n.fin-result-contents .source-content {\n    min-height: inherit;\n}\n.multi-label-wrap .source-label {\n    cursor: default !important;\n}\n\n// .source-label:empty {\n//     display: none;\n// }\n@media (max-width:991px){\n    .fin-result-contents {\n        padding-left: 0;\n    }\n}\n@media (max-width:767px){\n    .more-text-wrap {\n        margin-bottom: 10px;\n    }\n    .fin-result-contents .sourcebox h3 {\n        font-size: 15px;\n    }\n  \n \n}",".multi-result-contents .sourcebox h3 {\n    font-size: 14px;\n    border-bottom: none;\n}\n.multi-result-contents .sourcebox {\n    margin-bottom: 0;\n    height: 100%;\n}\n.mutimedia-results-repeatbox {\n    margin-bottom: 40px;\n}\n.sorce-footer-button-container {\n    display: flex;\n    align-items: center;\n}","@use \"../../../utils/variables\" as *;\n.news-result-contents .sourcebox h3 {\n    border: none;\n}\n.news-result-contents .sourcebox p {\n    margin-bottom: 20px;\n}\n.news-img-sec img {\n    width: auto;\n    border-radius: $radius-md;\n    max-width: 100px;\n    margin-right: 12px;\n    border: 1px solid #f0f0f0;\n}\n.new-small-thumb {\n    display: flex;\n    margin-bottom: 10px;\n    min-height: 100px;\n}\n.news-snippet:empty {\n    display: none;\n}\n.new-small-thumb .sourcebox h3 {\n    margin: 0;\n    padding: 0;\n}\n.new-big-sec {\n    border-top: 1px solid #d7e0e9;\n    padding-top: 25px;\n    margin-bottom: 25px;\n}\n.news-repeat-indetail:nth-child(1) .new-big-sec,\n.news-repeat-indetail:nth-child(2) .new-big-sec,\n.news-repeat-indetail:nth-child(3) .new-big-sec {\n    border: none;\n    padding-top: 0;\n}\n.news-repeat-indetail {\n    padding: 0 18px;\n}\n\n.upgrade-pop-wrap {\n    text-align: center;\n    padding: 5px 0;\n}\n.upgrade-pop-wrap .upgrade-title {\n    margin: 19px 0 10px;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 22px;\n    max-width: 280px;\n    margin-left: auto;\n    margin-right: auto;\n}\n.upgrade-pop-wrap p {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 22px;\n    margin-bottom: 15px;\n}\n.news-repeat-indetail .source-content {\n    min-height: 64px;\n}\n.date-text {\n    line-height: 20px;\n    font-weight: 500;\n    font-size: 12px;\n    color: #8A8B8C;\n    padding-top: 4px;\n}\n.sourcebox.news-auther-box {\n    display: flex;\n    justify-content: space-between;\n    flex-direction: column;\n}\n.authors-name {\n//   font-style: italic;\n    font-weight: 500;\n    color: #000;\n    font-size: 12px;\n    margin-top: 5px;\n}\n.authors-name span {\n    color: #666;\n    margin-right: 5px;\n    font-size: 12px;\n}\n@media (max-width: 991px) {\n    .news-repeat-indetail:nth-child(3) .new-big-sec {\n        border-top: 1px solid #d7e0e9;\n        padding-top: 25px;\n    }\n}\n@media (max-width: 767px) {\n    .news-repeat-indetail:nth-child(2) .new-big-sec {\n        border-top: 1px solid #d7e0e9;\n        padding-top: 25px;\n    }\n    .new-small-thumb {\n        min-height: inherit;\n    }\n}\n","@use \"../../../utils/variables\" as *;\n.expert-left-img img {\n    width: 100px;\n    height: 100px;\n    border-radius: 50%;\n    border: 4px solid #ffffff;\n    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));\n}\n.experts-box {\n    background: #ffffff;\n    box-shadow: 0px 1px 7px rgb(0 0 0 / 14%);\n    border-radius: $curveradius;\n    margin-bottom: 24px;\n    display: flex;\n}\n.experts-box-left {\n    width: 84px;\n    background: #f3f5f7;\n    display: flex;\n    align-items: center;\n    padding-left: 17px;\n    border-radius: $curveradius 0 0 $curveradius;;\n}\n.experts-right {\n    flex: 1;\n    min-height: 188px;\n    display: flex;\n    align-items: center;\n    padding-left: 50px;\n}\n.experts-right-content {\n    width: 100%;\n    padding-right: 20px;\n}\n.experts-right-content h3 {\n    font-weight: 600;\n    font-size: 15px;\n    line-height: 18px;\n    letter-spacing: -0.02em;\n    margin-bottom: 12px;\n}\n.experts-pers-info-wrap {\n    margin-bottom: 12px;\n}\nspan.experts-pers-info-text {\n    font-weight: 400;\n    font-size: 13px;\n    line-height: 18px;\n    margin-left: 10px;\n    color: #5b5b5b;\n}\n.experts-footer {\n    display: flex;\n    align-items: center;\n    border-top: 1px solid #ddd;\n    width: 100%;\n    padding-top: 10px;\n    padding-bottom: 10px;\n}\n@media (max-width:767px){\n    .experts-right {\n        padding-left: 50px;\n    }\n}","@use \"../../../utils/variables\" as *;\n.pop-checkboxscroll {\n    height: 40vh;\n}\n.pop-selected-items-scroll {\n    height: 20vh;\n}\n.selected-view-box {\n    border-top: 1px solid #cccdce;\n    border-left: none;\n    border-right: none;\n    padding-top: 20px;\n\n}\n.react-multi-select {cursor: pointer;}\n\n.selected-item-show-wrap {\n    display: flex;\n    flex-wrap: wrap;\n    margin: 0 -5px;\n}\n.selected-item-show {\n    display: flex;\n    background: #f3f5f7;\n    margin: 0 5px 10px;\n    padding: 10px;\n    border-radius: $radius;\n    font-size: 12px;\n    position: relative;\n}\n.country-pop-items .checkbox-box {\n    padding-top: 30px;\n    padding-bottom: 20px;\n}\n.selected-close {\n    margin-left: 10px;\n    position: absolute;\n    top: -3px;\n    padding: 5px 7px;\n    right: 0;\n    cursor: pointer;\n}\n.selected-name {\n    margin-right: 15px;\n}\n.country-pop-wraper {\n    padding: 15px 0px;\n}   \n@media(max-width:767px){\n    .pop-checkboxscroll {\n        max-height: 40vh;\n        height: auto;\n    }\n}\n\n",".catogory-popup .modal-dialog {\n    max-width: 616px;\n}\n.catogory-checkbox .checkbox-wrapper {\n    margin-bottom: 25px;\n    margin-top: 20px;\n}\n\n@media (max-width: 767px) {\n    .catogory-checkbox .checkbox-wrapper {\n        margin-bottom: 15px;\n        margin-top: 10px;\n    }\n }","@use \"../../utils/variables\" as *;\n.innerwrapper {\n    padding-top: 35px;\n}\n.innerwrapper .results-tab-wrap .nav-tabs {\n    justify-content: flex-start;\n}\n.tooltip > div.tooltip-inner {\n    background-color: $primary-color !important;\n}\n.tooltip.show {\n    opacity: 1 !important;\n}\n\n.tooltip > div.tooltip-inner::before {\n    border-color: $primary-color !important;\n    color: $primary-color !important;\n}\n.bs-tooltip-auto[data-popper-placement^=\"top\"] .tooltip-arrow::before,\n.bs-tooltip-top .tooltip-arrow::before {\n    border-top-color: $primary-color !important;\n}\n.tooltip-inner {\n    font-size: 12px;\n    text-align: center;\n}\n.action-icon-cell {\n    cursor: pointer;\n}\n.delete-confirm-wrap {\n    padding: 10px 0;\n}\n.innerwrapper .results-tab-wrap .nav-tabs::after {\n    left: 0;\n    right: 0;\n}\n\n.innerwrapper .results-tab-wrap .nav-tabs .nav-link {\n    padding: 5px 30px;\n}\n.savedquery-wrap {\n    min-height: calc(100vh - 120px);\n}",".innerwrapper.profile-wrap {\n    position: relative;\n}\n.innerwrapper.profile-wrap::before {\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 355px;\n    right: 0;\n    background: #f3f5f7;\n    content: \"\";\n    pointer-events: none;\n    z-index: -1;\n}\n.prof-left {\n    padding: 0 15px;\n    width: 28%;\n}\n.prof-right {\n    padding: 0 15px;\n    width: 72%;\n}\n.profile-quick-details h3 {\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 22px;\n    letter-spacing: -0.02em;\n}\n\n@media(max-width:991px){\n    .prof-left {\n        width: 100%;\n        margin-bottom: 20px;\n    }\n    .prof-right {\n        width: 100%;\n    } \n   \n}\n@media(max-width:767px){\n    .members-wrap .inner-title {\n        margin-bottom: 15px !important;\n    }\n}",".members-header-right-search {\n    flex: 1;\n}\n.m-l-10 {\n    margin-left: 10px;\n}\n.no-results-wraper {\n    padding: 30px;\n    color: #555;\n    border-radius: 13px;\n    text-align: center;\n    font-weight: 500;\n    font-size: 16px;\n    box-shadow: 0px 0px 10px #00000026;\n}\nspan.transport-text {\n    background: #EFF0F2;\n    padding: 5px 10px;\n    border-radius: 20px;\n    display: inline-block;\n    line-height: normal;\n    color: #474747;\n}\n.members-wrap .experts-right {\n    padding-left: 50px;\n}\n.members-wrap .experts-pers-info-text {\n    word-break: break-all;\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n    .expert-left-img img {\n        width: 85px;\n        height: 85px;\n    }\n    .experts-box-left {\n        padding-left: 10px;\n    }\n    .members-wrap .experts-right {\n        padding-left: 16px;\n    }\n}","@use \"../../../utils/variables\" as *;\n.signup-content-profile {\n    border: 1px solid #e9e9e9;\n    border-radius: $curveradius;\n}\n.prof-sub-header {\n    font-weight: 600;\n    font-size: 13px;\n    line-height: 16px;\n    color: #5b5b5b;\n    letter-spacing:0.2px;\n    margin: 0;\n}\n.inner-title {\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 22px;\n    letter-spacing: 0.2px;\n}\n.my-profile-header .inner-title {\n    margin: 0;\n}\n.profile-det-box p {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 13px;\n    line-height: 16px;\n    color: #5b5b5b;\n    margin-bottom: 5px;\n}\n.profile-det-box h4 {\n    font-weight: 600;\n    font-size: 13px;\n    line-height: 16px;\n    margin-bottom: 20px;\n}\n.profile-det-box {\n    width: 50%;\n    min-height: 130px;\n    padding: 0 30px 20px;\n    position: relative;\n}\n.border-detail {\n    margin-bottom: 50px;\n}\n.border-detail::after {\n    content: \"\";\n    left: 30px;\n    right: 30px;\n    bottom: 0;\n    height: 1px;\n    background-color: #d9d9d9;\n    position: absolute;\n}\n.profile-det-box-wrap {\n    margin: 0 -30px;\n}\n.p-b-0 {\n    padding-bottom: 0;\n}\n.box-bg {\n    background: #f3f5f7;\n    padding: 20px 20px 10px;\n    margin-bottom: 20px;\n    border-radius: $radius;\n}\n.box-bg  .react-multi-select .react-select-2-option__control:not(.react-select-2-option__control--is-focused):not(.react-select-2-option__control--is-disabled) {\n    background-color: #fff;\n}\n.box-bg .react-select-2-option__multi-value {\n    background-color: #f3f5f7;\n}\n.box-bg-infotext {\n    color:$primary-color;\n    font-size: 13px;\n    font-style: italic;\n    font-weight: 500;\n}\n.subheader-min-height {min-height: 39px;}\n@media (min-width: 768px) and (max-width: 991px) {\n.profile-det-box-wrap .border-detail {\n    margin-bottom: 20px;\n}\n.profile-det-box {\n    padding-bottom: 20px;\n    min-height: inherit;\n}\n}\n\n@media (max-width: 767px) {\n    .profile-det-box {\n        width: 100%;\n        min-height: inherit;\n    }\n    .border-detail, .profile-det-box {\n        margin-bottom: 20px;\n    }\n    .border-detail::after {\n        display: none;\n    }\n    .profile-det-box h4 {\n        margin-bottom: 10px;\n    }\n    .profile-wrap .p-30 {\n        padding: 15px;\n    }\n    .innerwrapper.profile-wrap::before {\n        background: transparent;\n    }\n}\n","@use \"../../../utils/variables\" as *;\n.profile-inner-box {\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.11);\n    border-radius:  $curveradius;\n    background: #fff;\n    padding-bottom: 40px;\n    height: 100%;\n}\n.profile-top-bg {\n    height: 169px;\n    background-color: $primary-color;\n    background-position: center 0;\n    border-radius:  $curveradius $curveradius 0 0 ;\n}\n.profile-stat-contentbox {\n    margin-top: -80px;\n}\n.profile-quick-details {\n    padding: 0 30px;\n    text-align: left;\n}\n@media (max-width: 767px) {\n    .profile-top-bg {\n        height: 80px;\n    }\n}\n",".viewallmembers-wrap {\n    position: absolute;\n    top: 112px;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: #f3f5f7;\n    padding-top: 30px;\n}\n.viewallmembers-header .row {\n    margin: 0 -8px;\n}\n.viewallmembers-header .row .col {\n    padding: 0 8px;\n}\n.backarrow-wrap h4 {\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 22px;\n    margin: 0;\n    margin-left: 15px;\n}\n.user-img img {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    border: 2px solid #ffffff;\n}\n.membername-cell h4 {\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 17px;\n    letter-spacing: -0.02em;\n    margin: 0 0 0 15px;\n}\n.sector-item {\n    border: 1px solid #ddd;\n    padding: 2px 5px;\n    margin: 2px;\n    border-radius: 3px;\n    font-size: 12px;\n}\n@media (max-width: 991px) {\n    .mebers-select-wrap{\n        padding: 0 8px;\n        margin-top: 10px;\n    }\n    .data-table-responsive .rdt_Table {\n        width: 900px;\n    }\n    .user-img img {\n        width: 30px;\n        height: 30px;\n        border: 1px solid #ffffff;\n    }\n}\n@media (max-width: 767px) {\n.viewallmembers-wrap .p-30 {\n    padding: 15px;\n}\n.membername-cell h4 {\n    font-size: 13px;\n    margin: 0;\n}\n}\n",".recomendation-header{\n    border-bottom: 1px solid #D7E0E9;\n    padding-bottom: 20px;\n}\n.recomendation-main-outer {\n    min-height: 100vh;\n}\n@media(max-width:767px) {\n    .recomendation-header .backarrow-wrap{\n        align-items: flex-start !important;\n    }\n    .financerecomendation-wrap {\n        padding-bottom: 40px;\n    }\n}",".faq-header {\n    border-bottom: 1px solid #d9d9d9;\n    padding-bottom: 24px;\n    margin-bottom: 20px;\n}\n.faq-header h4 {\n    font-weight: 600;\n    font-size: 22px;\n    line-height: 27px;\n    letter-spacing: -0.02em;\n    margin-bottom: 0;\n}\n.faq-header-right {\n    flex: 1;\n    padding-left: 45px;\n}\n.faq-footer-sec h3 {\n    font-weight: 600;\n    font-size: 22px;\n    line-height: 27px;\n    letter-spacing: -0.02em;\n}\n.faq-footer-sec p {\n    font-size: 14px;\n    line-height: 19px;\n    letter-spacing: 0.02em;\n    color: #5b5b5b;\n}\n.faq-footer-sec textarea.textarea-item {\n    background: #f3f5f7;\n    border: none;\n    min-height: 114px;\n    font-size: 13px;\n    padding: 15px;\n    max-height: 114px;\n}\n.faq-footer-sec textarea.textarea-item::placeholder {\n    font-style: italic;\n}\n.faq-footer-sec .form-control:focus {\n    background-color: #f3f5f7;\n    border-color: inherit;\n    outline: 0;\n    box-shadow: none;\n}\n@media (max-width: 767px) {\n    .faq-header .d-flex {\n        flex-wrap: wrap;\n    }\n    .help-and-support-wrap .p-30{\n        padding: 0;\n        box-shadow: none;\n    }\n    .faq-header h4 {\n        width: 100%;\n    }\n    .faq-header-right {\n        flex: 1;\n        padding-left: 0;\n        margin-top: 15px;\n        width: 100%;\n    }\n    .faq-header {\n        margin-bottom: 0;\n    }\n    .faq-header h4, .faq-footer-sec h3 {\n        font-size: 20px;\n        line-height: 24px;\n    }\n\n}\n",".change-password-wrap {\n    margin-top: 38px;\n}\n.change-password-wrap .section-title {\n    font-weight: 600;\n    font-size: 22px;\n    line-height: 30px;\n    color: #000;\n}\n.change-password-wrap .section-title a {\n    color: #000;\n    text-decoration: none;\n}\n.changepassword-contents {\n    // margin-top: 30px;\n    padding: 0 36px;\n}\n\n.change-psw-img {\n    padding-left: 50px;\n}\n.change-password-wrap .section-title span {\n    margin-right: 18px;\n    position: relative;\n    top: -1px;\n}\n.changepassword-contents form {\n    max-width: 80%;\n}\n.change-password-wrap .whitebox.p-30 {\n    padding-bottom: 70px;\n\n}\n@media(min-width:991px){\n    .change-psw-img {min-height: 320px;}\n    .change-password-wrap .change-psw-img {\n        margin-bottom: 0;\n    }\n   \n    .change-psw-img img {\n        max-width: 100%;\n    }\n}\n@media(max-width:1024px){\n    .change-psw-img {\n        padding-left: 0;\n    }\n    .change-psw-img img {\n        max-width: 100%;\n    }\n}\n@media(max-width:992px){ \n    .changepassword-contents form {\n        max-width: 100%;\n    }   \n}\n@media(max-width:767px){\n    .change-psw-img {\n        display: none;\n    }\n    .changepassword-contents {\n        padding: 0;\n        margin-top: 30px;\n\n    }\n    .change-password-wrap .whitebox.p-30 {\n        padding-bottom: 40px;\n    \n    }\n }","@use \"../../utils/variables\" as *;\n.landing-header {\n    padding: 20px;\n}\n.user-img-landing img {\n    max-height: 30px;\n}\n.landing-header .dropdown {\n    margin-left: 10px;\n}\n.landing-menu-items .dropdown .btn {\n    min-width: inherit;\n    padding: 0;\n    background: transparent;\n    border: none;\n    color: #5b5b5b;\n}\n.landing-menu-items .dropdown .dropdown-toggle:focus {\n    box-shadow: none;\n}\n.landing-menu-items .dropdown a {\n    margin: 0;\n}\n.landing-menu-items .dropdown-menu.show.dropdown-menu-end {\n    border: none;\n    box-shadow: 0 1px 4px #c1c1c1;\n    padding: 10px;\n}\n.landing-menu-items .dropdown-item {\n    font-size: 13px;\n    line-height: 24px;\n}\n.landing-menu-items .dropdown a {\n    font-size: 13px;\n    line-height: 24px;\n}\n.landing-menu-items .dropdown-item:focus,\n.landing-menu-items .dropdown-item:hover {\n    color: $primary-color;\n    background-color: transparent;\n    text-shadow: 0px 0px #1a73e8;\n}\n.landing-menu-items .dropdown-menu {\n    min-width: 120px;\n}\n.landing-header .user-img img {\n    height: 30px;\n    width: 30px;\n    border: none;\n}\n.landing-menu-items .dropdown a {\n    padding: 0 5px;\n    color: #5b5b5b;\n} \n@media (min-width: 768px) {\n    .btn-primary.m-r-15 {margin-right: 15px;}\n}\n\n@media (max-width: 767px) {\n    .landing-header .mobilemenu-active .double-btn {\n        flex-wrap: wrap;\n        padding: 15px;\n\n    }\n    .landing-header {\n        padding: 10px 0;\n    }\n    .landing-header .double-btn .btn {\n        width: 48%;\n        margin: 0;\n        flex: 1;\n        max-width: 48%;\n\n    }\n    .landing-header .double-btn .dropdown  .btn {\n        width: 100%;\n        max-width:99%;\n        text-align: left;\n        text-overflow: ellipsis;\n        overflow: hidden;\n\n    }\n    .landing-header .double-btn .dropdown  {\n        max-width: 60%;\n    }\n    .landing-header .mobilemenu-active {\n        top: 50px;\n        right: 0;\n        left: 0;\n    }\n    .landing-header .dropdown {\n        margin-left: 0;\n        width: auto;\n        margin:0;\n        flex: 1;\n        border: none;\n        padding: 0;\n\n    }\n    .landing-header .double-btn .btn:first-child {\n        margin-right: 4%;\n    }\n    .landing-menu-items .dropdown-menu {\n        min-width: 120px;\n        position: inherit !important;\n        transform: none !important;\n    }\n    .landing-menu-items .dropdown-menu {\n        position: inherit !important;\n        transform: none !important;\n        border: none !important;\n        box-shadow: none !important;\n        padding: 0 !important;\n        padding-top: 10px !important;\n    }\n    .landing-menu-items .mobilemenu-active .dropdown {\n        padding-left: 0;\n    }\n    .landing-menu-items .dropdown a {\n      padding-left: 0;\n    }\n}\n","@use \"../../utils/variables\" as *;\n.footer-left {\n    flex: 1;\n}\n.land-footer-wrap {\n    padding: 40px 0 80px;\n}\nh4.footer-title {\n    font-weight: 700;\n    font-size: 13px;\n    line-height: 16px;\n    letter-spacing: 0.05em;\n    margin-bottom: 15px;\n}\n.footer-menu-list a {\n    text-decoration: none;\n    font-weight: 400;\n    font-size: 13px;\n    line-height: 16px;\n    letter-spacing: 0.05em;\n    color: #000;\n    margin-bottom: 10px;\n    display: inline-block;\n    border-bottom: 1px solid transparent;\n}\n.footer-menu-list a:hover, .footer-menu-list a.active {\n    color: $primary-color;\n    border-bottom: 1px solid $primary-color;\n}\n.footer-menu-list {\n    margin-top: 0;\n    margin-bottom: 1rem;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n}\n.active-class {\n    text-decoration: underline;\n}\np.copyright-text {\n    margin: 12px 0;\n}\n.social-icons a {\n    margin-left: 10px;\n}\n.social-icons a:first-child {\n    margin-left: 0;\n}\n\n@media (max-width: 767px) {\n    .land-footer-content {\n        flex-wrap: wrap;\n    }\n    .footer-left {\n        flex: inherit;\n        width: 100%;\n    }\n    .land-footer-wrap {\n        padding: 30px 0;\n    }\n    .footer-right {\n        text-align: center;\n        margin-top: 20px;\n        border-top: 1px solid #ddd;\n        width: auto;\n        margin: 20px -15px 0;\n        flex: 1;\n        padding-top: 20px;\n    }\n    .land-footer-wrap .container {\n        padding: 0 15px;\n    }\n    .footer-left {\n        text-align: center;\n    }\n}\n",".landing-section-bg-right {\n    background-position: right;\n    right: 0;\n}\n.landing-section-bg {\n    background-size: cover;\n    background-repeat: no-repeat;\n    position: absolute;\n    width: 50%;\n    bottom: 0;\n    pointer-events: none;\n    z-index: 1;\n    top: 0;\n}\n.landing-section-bg-left {\n    background-position: left;\n    left: 0;\n}\n.bg-over-text {\n    position: relative;\n    z-index: 2;\n}\n.landing-common-title {\n    font-weight: 800;\n    font-size: 30px;\n    line-height: 37px;\n    letter-spacing: 0.05em;\n    color: #000000;\n    margin-bottom: 26px;\n    max-width: 80%;\n    margin-left: auto;\n    margin-right: auto;\n}\n.getresults-content h3 {\n    font-weight: 800;\n    font-size: 30px;\n    line-height: 34px;\n    letter-spacing: 0.05em;\n    margin-bottom: 25px;\n}\n.landing-common-description {\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: 0.05em;\n    color: #000000;\n}\n.landing-section-2 {\n    padding: 90px 0;\n}\n.landing-section-4 {\n    padding: 90px 0;   \n}\n.landing-section-5 {\n    padding: 90px 0;  \n}\n.landing-section-6 {\n    padding:90px 0;\n    background-color: #DDEAFC; \n}\n.landing-section-7 {\n    padding: 90px 0 30px;    \n}\n.landing-section-8 {\n    padding: 70px 0;  \n}\n.land-contact-section {\n    background: #DDEAFC;\n    padding: 50px 0 60px;\n}\n.contact-success .modal-dialog{\n    max-width: 690px;\n}\n.contact-success .success-content-wrap h3{\nfont-weight: 700;\nfont-size: 26px;\nline-height: 32px;\ntext-align: center;\nletter-spacing: 0.05em;\n}\n.contact-success .success-content-wrap p {\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 20px;\n    margin-top: 30px;\n}\n@media (min-width: 768px) and (max-width: 991px) {\n.landing-section-bg {\n    background-position: center;\n}\n.landing-section-2 {\n    padding: 50px 0;\n}\n.landing-section-4 {\n    padding: 50px 0;\n}\n.landing-section-5 {\n    padding: 50px 0 30px;\n\n}\n.landing-section-7 {\n    padding: 50px 0;\n}\n.landing-section-8 {\n    padding: 50px 0;\n}\n.landing-common-title {\n    font-size: 20px;\n    line-height: 26px;\n }\n .getresults-content h3 {\n    font-size: 20px;\n    line-height: 26px;\n\n}\n.landing-common-title {\nmax-width: 100%;\n}\n}\n\n@media (max-width: 767px) {\n    .landing-section-bg {\n        position: inherit;\n         height: 260px;\n         width: 100%;\n    }\n    .landing-section-2 {\n        padding: 30px 0;\n    }\n    .landing-common-title {\n        font-size: 20px;\n        line-height: 28px;\n        max-width: 100%;\n        margin-bottom: 10px;\n    }\n    .landing-section-4 {\n        padding: 30px 0 15px;\n    }\n    .getresults-content h3 {\n        font-size: 20px;\n        line-height: 28px;\n        text-align: center;\n\n    }\n    .landing-common-description {\n        text-align: center;\n        font-size: 15px;\n    }\n    .landing-section-5 {\n        padding: 30px 0;\n    }\n    .landing-section-6 {\n        padding: 0 0 30px;\n    }\n    .landing-section-7 {\n        padding: 30px 0;\n    }\n    .contact-success .success-content-wrap h3 {\n        font-size: 21px;\n        line-height: 24px;\n        max-width: 75%;\n        margin: 0 auto 20px;\n    }\n    .contact-success-img img {\n        max-width: 70%;\n    }\n}\n","@use \"../../../../utils/variables\" as *;\n.land-section-1-row {\n    height: 478px;\n}\n.landing-section-1 {\n    background-color: $primary-color;\n}\n.landing-section-1 h4{\n    font-weight: 400;\n    font-size: 24px;\n    line-height: 29px;\n    letter-spacing: 0.05em;\n    color: #ffffff;\n    margin-bottom: 30px;\n}\n\n.landing-section-1 h2 {\n    font-weight: 600;\n    font-size: 40px;\n    line-height: 48px;\n    letter-spacing: 0.05em;\n    color: #ffffff;\n    margin-bottom: 30px;\n}\n.landing-section-1 h2 .Typewriter{margin-right:10px;}\n.landing-section-1 h2 .Typewriter .Typewriter__wrapper{padding-right:10px;}\n.landing-section-1 h2 .Typewriter .Typewriter__cursor{font-weight:400;}\n.landing-section-1 h2 .Typewriter:last-of-type .Typewriter__cursor{display:none;}\n\n.landing-section-1 p {\n    font-size:15px;\n    line-height: 22px;\n    color:#fff;\n    margin-bottom: 30px;\n}\nspan.svg-down-arrow {\n    margin-left: 6px;\n    position: relative;\n    top: 3px;\n}\n.sec1-content .btn {\n    color: #fff;\n    font-weight: 500;\n    font-size: 13px;\n    letter-spacing: -0.02em;\n}\n.sec1-content {\n    padding-right: 50px;\n}\n@media (max-width: 1400px) {\n    .landing-section-1 h4{font-size:20px; margin-bottom:25px;}\n    .landing-section-1 h2 {font-size: 30px; margin-bottom:25px;}\n    .landing-section-1 p{font-size:13px;}\n}\n@media (max-width: 1200px) { \n    .landing-section-1 h4{font-size:17px;}\n    .landing-section-1 h2 {\n        font-size: 26px;\n        line-height: 30px;\n    }\n}\n@media (max-width: 991px) { \n    .landing-section-1 h4{font-size:15px; margin-bottom:15px;}\n    .landing-section-1 p{font-size:12px; margin-bottom:20px;}\n    .sec1-content{padding-right:10px;}\n}\n@media (min-width: 768px) and (max-width: 991px) {\n.landing-section-1 h2 {\n    font-size: 20px;\n    line-height:26px;\n    margin-bottom: 15px;\n}\n.land-section-1-row {\n    height: 290px;\n}\n}\n@media (max-width: 767px) {\n    .land-section-1-row {\n        height: auto;\n        padding: 30px 0;\n    }\n    .sec1-content {\n        padding-right: 0;\n        text-align: center;\n    }\n    .landing-section-1 h2 {\n        font-size: 22px;\n        line-height: 28px; margin-bottom:15px;\n    }\n }",".thumb-slider-with-animation {\n    display: flex;\n    text-align: left;\n    align-items: center;\n\n    .mySwiper {\n        width: 45%;\n        padding-right: 45px;\n        margin: auto;\n\n        .swiper-wrapper {\n            flex-direction: column;\n            height: auto;\n            padding-left: 5px;\n            padding-top: 25px;\n\n            .swiper-slide {\n                width: 100% !important;\n                margin: 0 0 25px 0 !important;\n                padding: 0 10px 0 10px;\n\n                .thumb-content-area {\n                    box-shadow: 0px 5px 10px 0px #9FABB640;\n                    cursor: pointer;\n                    padding: 25px 15px;\n                    border-radius: 7px;\n                    display: flex;\n                    position: relative;\n                    overflow: hidden;\n\n                    .thumb-line {\n                        width: 4px;\n                        background-color: #DEE3EA;\n                        display: block;\n                        margin-right: 24px;\n                        position: relative;\n\n                        &::after {\n                            content: \"\";\n                            width: 4px;\n                            height: 0;\n                            position: absolute;\n                            left: 0;\n                            background-color: #1A73E8;\n                        }\n                    }\n\n                    .thumb-cont {\n                        flex: 1\n                    }\n\n                    label {\n                        color: #5B5B5B;\n                        font-size: 15px;\n                        font-weight: 600;\n                        letter-spacing: 0.75px;\n                        margin: 0 0 16px;\n                    }\n\n                    p {\n                        color: #5B5B5B;\n                        font-weight: 300;\n                        line-height: 20px;\n                        letter-spacing: 0.65px;\n                    }\n                }\n\n                &.swiper-slide-thumb-active {\n                    .thumb-line::after {\n                        height: 100%;\n                        transition: all 6s ease;\n                    }\n\n                    label {\n                        color: #0338C0;\n                    }\n\n                    p {\n                        font-size: 14px;\n                        font-weight: 400;\n                        color: #000;\n                    }\n\n                    .thumb-content-area {\n                        box-shadow: 0px 10px 20px 0px rgba(85, 98, 111, 0.25);\n                    }\n                }\n            }\n        }\n    }\n\n    .mySwiper2 {\n        width: 55%;\n        border-radius: 20px;\n        background: #D5E4F9;\n\n        .swiper-wrapper {\n            align-items: center;\n        }\n\n        .swiper-slide {\n            padding: 30px;\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n\n            .left-slide {\n                position: relative;\n                left: -105%;\n            }\n\n            .right-slide {\n                position: relative;\n                right: -105%;\n            }\n\n            .top-slide {\n                position: relative;\n                top: -270px;\n            }\n        }\n\n        .swiper-slide.swiper-slide-active .top-slide {\n            top: 0;\n            transition: all 1.5s ease;\n        }\n\n        .swiper-slide.swiper-slide-active .left-slide {\n            left: 0;\n            transition: all 1.5s ease;\n        }\n\n        .swiper-slide.swiper-slide-active .right-slide {\n            right: 0;\n            transition: all 1.5s ease;\n        }\n    }\n\n    .chat-slide-left-img {\n        border-radius: 10px;\n        box-shadow: 0px 20px 30px 0px #A5C2EB;\n    }\n\n    .chat-slide-typer-area {\n        border-radius: 7px;\n        background: #FFF;\n        box-shadow: 0px 20px 30px 0px #A5C2EB;\n        padding: 15px;\n        min-height: 200px;\n\n        .Typewriter {\n            padding: 0 15px;\n            font-size: 12px;\n            line-height: 20px;\n        }\n    }\n\n    .chat-slide-right-img1 {\n        box-shadow: 0px 20px 30px 0px #A5C2EB;\n        border-radius: 7px;\n    }\n\n    .chat-slide-right-img2 {\n        box-shadow: 0px 10px 10px 0px rgb(182 211 239 / 45%);\n        max-width: 350px;\n        width: 100%;\n    }\n\n    .chat-slide-right-img3 {\n        // box-shadow:0px 20px 30px 0px #A5C2EB;\n        border-radius: 7px;\n        margin-top: 32px;\n    }\n\n    .search-slide-top-img {\n        box-shadow: 0px 10px 10px 0px #A3C0E8;\n        border-radius: 11px;\n        margin-bottom: 20px;\n    }\n\n    .search-slide-left-img {\n        box-shadow: 0px 20px 30px 0px #A5C2EB;\n        border-radius: 7px;\n    }\n\n    .search-slide-typer-area {\n        border-radius: 7px;\n        background: #FFF;\n        box-shadow: 0px 20px 30px 0px #A5C2EB;\n        height: 100%;\n\n        .Typewriter {\n            padding: 15px 0;\n            font-size: 12px;\n            line-height: 20px;\n        }\n    }\n\n    .general-slide-left-area {\n        border-radius: 10px;\n        box-shadow: 0px 20px 30px 0px #A5C2EB;\n        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);\n        height: 100%;\n        img {\n            width: 100%;\n        }\n    }\n}\n\n\n@media (max-width:1199px) {\n    .thumb-slider-with-animation .chat-slide-typer-area {\n        min-height: auto;\n    }\n}\n\n@media (max-width:991px) {\n    .thumb-slider-with-animation {\n        flex-direction: column;\n\n        .mySwiper {\n            width: 100%;\n\n            .swiper-wrapper {\n                flex-direction: row;\n\n                .swiper-slide {\n                    width: 33.3% !important;\n\n                    .thumb-content-area p {\n                        display: none;\n                    }\n                }\n            }\n\n        }\n    }\n\n    .thumb-slider-with-animation .mySwiper2 {\n        width: 100%;\n    }\n\n    .thumb-slider-with-animation .mySwiper {\n        padding: 0;\n\n        .swiper-wrapper {\n            padding: 0;\n\n            .swiper-slide .thumb-content-area {\n                flex-direction: column;\n                padding: 10px;\n                text-align: center;\n\n                label {\n                    margin: 0;\n                }\n\n                .thumb-line {\n                    width: 100%;\n                    height: 4px;\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n\n                    &::after {\n                        width: 0;\n                        height: 4px;\n                    }\n                }\n            }\n\n            .swiper-slide.swiper-slide-thumb-active .thumb-line::after {\n                width: 100%;\n            }\n        }\n    }\n}\n\n.landing-animation-section {\n    .container {\n        max-width: 1179px;\n    }\n\n    .chat-slide-left-img {\n        width: 100%;\n    }\n}\n\n\n@media (max-width:767px) {\n    .thumb-slider-with-animation .chat-slide-typer-area .Typewriter {\n        font-size: 10px;\n    }\n}\n\n@media (max-width:575px) {\n    .thumb-slider-with-animation .mySwiper2 .swiper-slide {\n        padding: 20px 10px;\n    }\n\n    .thumb-slider-with-animation .chat-slide-typer-area .Typewriter {\n        padding: 0;\n        font-size: 8px;\n        line-height: 14px;\n    }\n\n    .thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide .thumb-content-area label {\n        font-size: 12px;\n    }\n\n    .thumb-slider-with-animation .mySwiper .swiper-wrapper .swiper-slide {\n        padding: 0 5px;\n    }\n\n    .thumb-slider-with-animation .general-slide-left-area {\n        border-radius: 7px;\n    }\n\n    .thumb-slider-with-animation .search-slide-top-img {\n        margin-bottom: 15px;\n    }\n}","@use \"../../../../utils/variables\" as *;\n.landing-section-3 {\n    background-color: #ddeafc;\n}\n.landing-section-3 {\n    padding: 80px 0 110px;\n}\n.getresults-content {\n    padding: 0 15px 0 45px;\n}\n.animation-box-content {\n    background: #fff;\n    padding: 30px 10px;\n    box-shadow: 0px 20px 20px rgb(59 89 134 / 25%);\n    border-radius: 10px;\n    height: 100%;\n    position: relative; overflow:hidden;\n}\n.animation-box {\n    padding: 0 11px;\n    width: 20%;\n}\n.animation-box h4 {\n    font-weight: 800;\n    font-size: 18px;\n    line-height: 22px;\n    letter-spacing: 0.05em;\n    margin-bottom: 20px;\n}\n.animation-box p {\n    font-size: 13px;\n    line-height: 20px;\n    text-align: center;\n    letter-spacing: 0.05em;\n    margin: 0;\n}\n.animation-box-row {\n    margin: 40px -11px 0px;\n}\n.animation-section-big-row {\n    margin: 0 -50px;\n}\n\n.landing-section-3 {\n    overflow-x: hidden;\n}\n\n.animation-box:hover .animation-box-content::after {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0px;\n    height: 7px;\n    background: $primary-color;\n    content: \"\";\n}\n.transforming-animation-wrap .landing-section-bg {\n    width: 41.66666667%;\n}\n\n@media (max-width: 1200px) {\n    .animation-box-row {\n        flex-wrap: wrap;\n        justify-content: center;\n    }\n    .animation-box {\n        width: 33.3333%;\n        margin-top: 20px;\n    }\n    .animation-section-big-row {\n        margin: 0;\n    }\n    .getresults-content p br{display:none;}\n}\n@media (min-width: 768px) and (max-width: 991px) {\n    .landing-section-3 {\n        padding: 50px 0 60px;\n    }   \n}\n@media (max-width: 767px) {\n    .animation-box {\n        width: 100%;\n    }\n    .transforming-animation-wrap .landing-section-bg {\n        width: 100%;\n    }\n    .landing-section-3 {\n        padding: 0 0 30px;\n    }\n    .animation-box-content {\n        padding: 20px;\n        box-shadow: 0px 0px 7px rgb(59 89 134 / 25%);\n    }\n    .animation-box h4 {\n        margin-bottom: 12px;\n    }\n    .animation-box-row {\n        margin: 10px 0 0px;\n    }\n    .animation-box {\n        padding: 0 20px;\n    }\n    .getresults-content{padding:0 15px;}\n}\n",".relevent-box h4 {\n    font-weight: 800;\n    font-size: 18px;\n    line-height: 22px;\n    letter-spacing: 0.05em;\n    margin-bottom: 20px;\n}\n.relevent-box p {\n    font-size: 13px;\n    line-height: 20px;\n    text-align: center;\n    letter-spacing: 0.05em;\n    margin: 0;\n}\n.relevent-box {\n    width: 25%;\n    padding: 0 11px;\n}\n.relevent-box-content {\n    background: #fff;\n    box-shadow: 0px 10px 20px rgb(155 163 171 / 25%);\n    padding: 40px 20px;\n    height: 100%; border-radius:10px;\n}\n.find-relevent-rwo{\n    padding: 0 50px;\n    margin-top: 55px;\n}\n.landing-section-4 .landing-common-description {\n    max-width: 65%;\n    margin-left: auto;\n    margin-right: auto;\n}\n.landing-section-4 .landing-common-title {\n    max-width: 85%;\n}\n@media (min-width: 768px) and (max-width: 991px) {\n.relevent-box {\n    width: 50%;\n    margin-bottom: 20px;\n}\n.find-relevent-rwo {\n    flex-wrap: wrap;\n}\n.relevent-box-content {\n    box-shadow: 0px 0px 5px rgb(155 163 171 / 25%);\n\n}\n}\n\n@media (max-width: 767px) {\n.relevent-box {\n    width: 100%;\n    margin-bottom: 20px;\n}\n.find-relevent-rwo {\n    padding: 0;\n    margin-top: 30px;\n    flex-wrap: wrap;\n}\n.relevent-box-content {\n    box-shadow: 0px 0px 5px rgb(155 163 171 / 25%);\n    padding:20px 30px;\n    height: auto;\n    background-color: #eaeff7;\n\n}\n.relevent-box h4 {\n    font-size: 16px;\n    margin-bottom: 15px;\n}\n.landing-section-4 .landing-common-description {\n    max-width: 90%;\n}\n.technology-show-box-left, .technology-show-box-right {\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n}",".technology-cont-icon {\n    margin-right: 28px;\n}\n.technology-show-box-left,\n.technology-show-box-right {\n    margin-top: 30px;\n    margin-bottom: 30px;\n}\n.technology-cont-text h4 {\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 24px;\n    letter-spacing: 0.05em;\n    margin-bottom: 15px;\n}\n.technology-show-box-right {\n    padding-left: 50px;\n}\n.technology-show-box-left {\n    padding-right: 20px;\n}\n.landing-section-5 .landing-common-description {\n    max-width: 75%;\n    margin-left: auto;\n    margin-right: auto;\n}\n.technology-show-row {\n    margin-top: 40px;\n}\n@media (max-width: 991px) {\n    .technology-show-row .technology-show-box {\n        align-items: flex-start !important;\n    }\n}\n@media (max-width: 767px) {\n    .landing-section-5 .landing-common-description {\n        max-width: 100%;\n    }\n    .technology-show-box-left {\n        padding-right: 15px;\n        padding-left: 15px;\n    }\n    .technology-show-box-right {\n        padding-left: 15px;\n    }\n    .technology-cont-text {\n        flex: 1;\n    }\n    .technology-cont-icon {\n        margin-right: 0;\n        width: 80px;\n        padding-top: 3px;\n        padding-right: 10px;\n    }\n    .technology-cont-icon img {\n        max-width: 100%;\n    }\n\n    .technology-show-row {\n        margin-top: 20px;\n    }\n\n    .technology-cont-text h4 {\n        font-size: 16px;\n    }\n    .technology-show-box-left,\n    .technology-show-box-right {\n        margin-top: 10px;\n        margin-bottom: 10px;\n    }\n}\n",".discoversec-content-box-wrap {\n    margin: 0 -160px 0 -50px;\n}\n.discoversec-content-box {\n    background: #ffffff;\n    box-shadow: 0px 20px 20px rgba(59, 89, 134, 0.25);\n    padding: 45px 30px; border-radius:10px;\n}\n.discover-count-box h4 {\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 29px;\n    letter-spacing: 0.05em;\n}\n.discover-count-box h6 {\n    font-weight: 700;\n    font-size: 15px;\n    line-height: 18px;\n    letter-spacing: 0.05em;\n}\n\n.discover-count-box label {\n    font-size: 11px;\n    line-height: 20px;\n    letter-spacing: 0.05em;\n}\n.discover-count-box {\n    margin-top: 30px;\n    margin-bottom: 30px;\n}\n.discoversec-content-box h3 {\n    font-weight: 800;\n    font-size: 30px;\n    line-height: 34px;\n    letter-spacing: 0.05em;\n    margin-bottom: 25px;\n}\n@media (min-width: 992px) and (max-width: 1024px) {\n    .discoversec-content-box-wrap{\n        margin-left: -20px;\n    }\n    .discoversec-content-box h3 {\n        font-size: 20px;\n        line-height: 26px;\n    }\n    \n    }\n@media (min-width: 768px) and (max-width: 991px) {\n.discoversec-content-box-wrap{\n    margin-left: 0;\n}\n\n}\n@media (max-width: 767px) {\n    .discoversec-content-box-wrap {\n        margin: 0;\n    }\n    .discoversec-content-box h3 {\n        font-size: 20px;\n        line-height: 28px;\n        margin-bottom: 15px;\n    }\n    .discover-count-box h4 {\n        font-size: 20px;\n        line-height: 24px;\n    }\n    .discover-count-box h6 {\n        font-size: 13px;\n    }\n    .discoversec-content-box {\n        box-shadow: 0px 0px 10px rgb(59 89 134 / 25%);\n        padding: 20px 20px;\n        text-align: center;\n        margin-top: 20px\n    }\n    .discover-count-box {\n        margin-top: 20px;\n        margin-bottom: 20px;\n    }\n    .discover-count-box label {\n        font-size: 11px;\n        line-height: 12px;\n    }\n    \n}\n","@use \"../../../../utils/variables\" as *;\n.experience-slider-box h4 {\n    font-weight: 800;\n    font-size: 18px;\n    line-height: 22px;\n    letter-spacing: 0.05em;\n    margin-bottom: 16px;\n}\n.experience-slider-box {\n    padding: 40px 20px;\n    background:#DDEAFC;\n    min-height: 191px;\n    box-shadow:0px 2px 5px 0px #D5DFED; border-radius:10px;\n}\n// The landing carousels' arrows (landcarouselarrow). margin, border-radius and\n// cursor come from the Owl theme these carousels used before.\n.land-owl-prev,\n.land-owl-next {\n    margin: 5px;\n    border-radius: 3px;\n    cursor: pointer;\n    z-index: 1;\n}\n.land-owl-prev {\n    position: absolute;\n    left: -50px;\n    top: 50%;\n    margin-top: -35px !important;\n    background: transparent !important;\n    border: none;\n    color: $primary-color !important;\n    font-size: 50px !important;\n    width: auto !important;\n    height: auto !important;\n    line-height: 50px !important;\n    padding: 0 !important;\n}\n.land-owl-next {\n    position: absolute;\n    right: -50px;\n    top: 50%;\n    margin-top: -35px !important;\n    background: transparent !important;\n    border: none;\n    color: $primary-color !important;\n    font-size: 50px !important;\n    width: auto !important;\n    height: auto !important;\n    line-height: 50px !important;\n    padding: 0 !important;\n}\n.land-experience-slider-wrapper {\n    margin-top: 50px;\n\n    // 10px between cards.\n    .slick-list {padding:10px 0 30px; margin: 0 -5px;}\n    .slick-slide > div {padding: 0 5px;}\n    // Space the Owl nav bar used to take.\n    .land-carousel {margin-bottom: 10px;}\n}\n.landing-section-7 .landing-common-description {\n    max-width: 80%;\n    margin-left: auto;\n    margin-right: auto;\n}\n.land-owl-next span, .land-owl-prev span {\n    position: relative;\n    top: -1px;\n}\n@media (min-width: 768px) and (max-width: 991px) {\n    .land-owl-next {\n        right: -30px\n    }\n    .land-owl-prev {\n        left: -30px;\n    }\n    .experience-slider-box h4 {\n        font-size: 16px;\n     \n    }\n}\n@media (max-width: 767px) {\n    .landing-section-7 .landing-common-description {\n        max-width: 100%;\n    }\n    .experience-slider-box {\n        padding-bottom: 60px;\n        min-height: 232px;\n    }\n    .land-owl-next {\n        right: calc(50% - 40px);\n    }\n    .land-owl-prev {\n        left: calc(50% - 40px);\n    }\n    .land-carousel .land-owl-next,\n    .land-carousel .land-owl-prev {\n        top: inherit;\n        bottom: 15px !important;\n        height: 30px !important;\n        width: 30px !important;\n        line-height: 20px !important;\n        font-size: 22px !important;\n        background: #ddeafc !important;\n        color: #000 !important;\n    }\n}\n",".client-slider-section .slick-slide img {\n    width: auto;\n    max-height: 100%;\n    max-width: 100%;\n}\n.client-logo-wrap {\n    padding: 0 15px;\n}\n// Space the Owl nav bar used to take.\n.landing-section-8 .land-carousel {\n    padding-bottom: 5px;\n}\n.client-logo-wrap {\n    padding: 0 15px;\n    height: 100px;\n    display: flex;\n    align-items: center;\n    width: 100%;\n    flex: 1;\n    justify-content: center;\n}\n.client-logo-text {\n    font-weight: bold;\n    color: #A4A4A4;\n}\n@media (max-width: 767px) {\n.landing-section-8 .landing-common-title {\n    margin-bottom: 10px;\n}\n.landing-section-8 .land-carousel .land-owl-next, .landing-section-8 .land-carousel .land-owl-prev {\n    bottom: -20px !important;\n}\n}",".land-contact-section-bg {\n    background-size: cover;\n    background-repeat: no-repeat;\n    position: absolute;\n    width:50%;\n    bottom: 0;\n    pointer-events: none;\n    z-index: 1;\n    top: 0;\n    background-position: top;\n}\n.land-contact-section .textarea-item {\n    height: 70px;\n    border: none;\n    max-height: 70px;\n    min-height: 70px;\n}\n.contact-header label {\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 22px;\n    text-align: center;\n    letter-spacing: 0.05em;\n    margin-bottom: 15px;\n}\n\n\n.PhoneInputCountry {\n    width: auto;\n    position: relative;\n    font-size: 12px;\n    padding-left: 58px;\n}\n.input-item.PhoneInput {\n    display: flex;\n    width: 100%;\n}\n.PhoneInputCountryIcon.PhoneInputCountryIcon--border {\n    position: absolute;\n    width: 58px;\n    height: auto;\n    left:0px;\n    top: 0;\n}\nselect.PhoneInputCountrySelect{\n    background-color: #f3f5f7;\n    border-radius: 8px;\n    height: 39px;\n    border: none;\n    font-size: 12px;\n    width: 200px;\n    padding-left: 7px;\n}\n.PhoneInputInput {\n    background-color: #f3f5f7;\n    border-radius: 8px;\n    height: 39px;\n    border: none;\n    font-size: 12px;\n    width: 100%;\n    margin-left: 15px;\n    padding: 0 10px;\n}\nimg.PhoneInputCountryIconImg {\n    border-radius: 3px 0 0 3px;\n}\ninput.PhoneInputInput:focus, select.PhoneInputCountrySelect:focus {\n    border: none;outline: none;\n}\n.land-contact-formwrap {\n    padding: 0 0 0 40px;\n}\n.land-contact-formwrap .landing-common-title {\n    max-width: 100%;\n}\n@media (min-width: 768px){\n    .PhoneInputInput {\n        width: calc(50% + 1px);\n        margin-left: 24px;\n    }\n    .PhoneInputCountry {\n        width: 50%;\n    }\n    select.PhoneInputCountrySelect {\n        width: 100%;\n\n    }\n}\n\n@media (min-width: 1400px){\n\n    .land-contact-section-bg {\n        width: 46%;\n    }\n\n}\n@media (min-width: 768px) and (max-width: 991px) {\n.land-contact-section-bg {\n    display: none;\n}\n.land-contact-space{\n    display: none;\n}\n.land-contact-formwrap {\n    padding: 0;\n}\n}\n@media (max-width: 767px) {\n    .land-contact-formwrap {\n        padding: 0;\n    }\n.land-contact-section-bg {\n    position: inherit;\n    height: 300px;\n    width: 100%;\n    background-position: top;\n}\n.land-contact-section {\n    padding: 0px 0 30px;\n}\n.input-item.PhoneInput {\n    flex-wrap: wrap;\n}\n.PhoneInputInput {\n    margin-left: 0;\n    margin-top: 10px;\n}\n.PhoneInputCountry {\n    width: 100%;\n}\nselect.PhoneInputCountrySelect {\n    width: 100%;\n}\n.contact-header {\n    text-align: center;\n}\n.landing-section-8 {\n    padding: 30px 0 40px;\n}\n.land-contact-section form .btn {\n    width: 100%;\n}\n}",".landing-section-ai{padding:90px 0; background-color:#DDEAFC;\n    .landing-common-title{margin-left:0; max-width:100%;}\n}\n.icon-cont-box{border-radius:10px; background:#FFF; border-top:7px solid transparent; min-height:150px; height:100%; box-shadow:0px 20px 20px 0px rgba(35, 66, 112, 0.24); padding:25px; display:flex; align-items:center;\n    .img-area{margin:0 24px 0 0;\n    }\n    &:hover{border-top:7px solid #1A73E8;}\n}\n\n\n@media (max-width:767px){\n    .landing-section-ai .landing-common-title{text-align:center;}\n    .landing-section-ai{padding:30px 0;}\n}\n\n@media (max-width:575px){\n    .icon-cont-box{min-height:100%;}\n}",".land-video-box {\n    position: relative;\n    width: 100%;\n    max-width: 1000px;\n    margin: auto;\n    overflow: hidden;\n}\n\n.land-video-box::before {\n    content: \"\";\n    display: block;\n    padding-top: 56.25%;\n    /* 16:9 Aspect Ratio */\n}\n\n.land-video-box iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: none;\n    border-radius: 15px;\n}\n\n.video-frame-section {\n    padding: 71px 0 79px;\n    background-color: #DDEAFC;\n}\n\n.land-videoframe-header-box {\n    max-width: 687px;\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 40px;\n\n    .landing-common-title {\n        max-width: 100%;\n    }\n}\n\n@media (min-aspect-ratio: 16/9) {\n    .land-video-box {\n        max-height: 600px;\n        height: 100vw;\n        max-width: calc(600px * 16 / 9);\n    }\n\n    .land-video-box::before {\n        padding-top: 0;\n    }\n}",".banner-desc {\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 22px;\n    letter-spacing: 0.05em;\n    color: #ffffff;\n}\n.about-content-sec {\n    padding: 80px 0;\n}\n.about-content-sec-2 {\n    background: #ddeafc;\n}\n.aboutus-head-wrap {\n    padding-left: 50px;\n}\n.aboutus-title {\n    font-weight: 800;\n    font-size: 28px;\n    line-height: 34px;\n    // text-align: center;\n    letter-spacing: 0.05em;\n    color: #000000;\n}\n.aboutus-desc-wrap p {\n    font-size: 13px;\n    line-height: 22px;\n    letter-spacing: 0.05em;\n    margin-bottom: 20px;\n}\n.aboutus-desc-wrap p:last-child {\n    margin-bottom: 0;\n}\n.aboutus-desc-wrap {\n    padding-right: 10%;\n}\n@media (min-width: 768px) and (max-width: 991px) {\n    .aboutus-title {\n        font-size: 20px;\n        line-height: 26px;\n    }\n    .aboutus-head-wrap {\n        padding-left: 30px;\n    }\n    .about-content-sec {\n        padding: 40px 0;\n    }\n}\n@media(max-width:767px){\n    .aboutus-head-wrap {\n        padding-left: 0px;\n    }\n    .about-content-sec {\n        padding: 30px 0 34px;\n        text-align: center;\n    }\n    .aboutus-desc-wrap {\n        padding-right: 0;\n    }\n    .aboutus-title {\n        font-size: 20px;\n        line-height: 26px;\n\n    }\n}\n",".career-content-sec-2 {\n    background: #ddeafc;\n}\n.career-content-sec {\n    padding: 80px 0;\n}\n.career-content-sec-1 .landing-common-description {\n    max-width: 82%;\n}\n.career-content-sec .technology-cont-text p {\n    max-width: 80%;\n    margin-bottom: 0;\n}\n.careers-show-box-left, .careers-show-box-right {\nmargin: 30px 0;\n}\n.career-main-content{\n    margin: 0 auto;\n    max-width: 65%;\n}\n.career-main-content h6 {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 22px;\n    letter-spacing: 0.05em;\n    color: #000000;\n    margin-top: 34px;\n}\n@media (min-width: 768px) and (max-width: 991px) {\n    .career-content-sec {\n        padding: 50px 0;\n    }\n    .career-main-content {\n        max-width: 90%;\n    }\n}\n@media(max-width:767px){\n.career-content-sec {\n    padding: 30px 0;\n}\n.career-content-sec .technology-cont-text p {\n    max-width: 100%;\n}\n.career-main-content {\n    max-width: 100%;\n}\n}","@use \"../../../utils/variables\" as *;\n.sales-content-section-wrap {\n    background-color: #ddeafc;\n    padding: 77px 20px 60px;\n}\n.sales-enquiry-box {\n    max-width: 690px;\n    margin: 0 auto;\n    background: #fff;\n    padding: 50px 77px;\n    border-radius: $radius;\n}\n.sales-mail-text {\n    max-width: 690px;\n    margin: 0 auto;\n    text-align: center;\n    padding-top: 50px;\n}\n.sales-mail-text p {\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 22px;\n    text-align: center;\n    letter-spacing: 0.05em;\n    color: #000000;\n}\n.sales-mail-text p a {\n    color: $primary-color;\n}\n.sales-content-section-wrap .landing-common-title {\n    font-size: 28px;\n    max-width: 100%;\n}\n.sales-enquiry-box .form-control.textarea-item {\n    max-height:66px;\n}\n@media (min-width: 768px) and (max-width: 991px) {\n.sales-content-section-wrap .landing-common-title {\n    font-size: 20px;\n}\n}\n@media (max-width: 767px) { \n    .sales-enquiry-box {\n        padding: 30px 20px;\n    }\n    .sales-content-section-wrap .landing-common-title {\n        font-size: 20px;\n    }\n    .sales-content-section-wrap {\n        background-color: #ddeafc;\n        padding: 30px 20px 20px;\n    }\n    .sales-mail-text {\n        padding-top: 30px;\n    }\n}\n",".termsofuse-content p {\n    font-size: 13px;\n    line-height: 25px;\n    letter-spacing: 0.05em;\n    color: #000000;\n    margin-bottom: 25px;\n}\n.terms-sections p:last-child {\n    margin-bottom: 0;\n}\n.terms-sections {\n    padding: 35px 0;\n}\n.terms-title {\n    font-weight: 700;\n    font-size: 25px;\n    line-height: 30px;\n    letter-spacing: 0.05em;\n    margin-bottom: 0;\n}\n.terms-header p {\n    font-weight: 400;\n}\n.terms-gray-sec {\n    background: #ddeafc;\n}\n\n.terms-sub-header .terms-title {\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 25px;\n    letter-spacing: 0.05em;\n    color: #000000;\n    margin-bottom: 20px;\n}\nspan.terms-content-sticking {\n    font-weight: bold;\n}\n.terms-title span {\n    margin-right: 5px;\n    display: inline-block;\n}\n.terms-header {\n    margin-bottom: 30px;\n}\n\n.terms-contents ol {\n    margin: 0;\n    padding-left: 15px;\n}\n.terms-contents ol li {\n    line-height: 24px;\n    margin-bottom: 20px;\n    padding-left: 15px;\n    font-weight: 500;\n    font-size: 13px;\n    line-height: 25px;\n    letter-spacing: 0.05em;\n    color: #000000;\n}\n.terms-contents ol li:last-child {\n    margin-bottom: 0;\n}\n@media (max-width:767px){\n    .terms-contents ol li {\n        margin-bottom: 10px;\n        line-height: 22px;\n    }\n    .terms-sub-header .terms-title {\n        font-size: 16px;\n        line-height: 22px;\n    }\n    .terms-title {\n        font-size: 20px;\n    }\n    .termsofuse-content p {\n       line-height: 22px;\n    }\n    .terms-sections {\n        padding: 30px 0;\n    }\n}","@use \"../../../../utils/variables\" as *;\n// ============================================================================\n// Unified chat — sidebar\n// ============================================================================\n\n.unified-sidebar {\n  width: $chat-sidebar-width;\n  flex-shrink: 0;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 20px 12px 16px;\n  color: $chat-text-primary;\n  font-family: $primary-font;\n  background: $chat-sidebar-bg;\n  overflow: hidden;\n  transition: width 0.22s ease;\n\n  @media (min-width: 992px) {\n    &.is-collapsed { width: 64px; }\n  }\n\n  @media (max-width: 991.98px) {\n    position: fixed;\n    top: 64px; // sit below the 64px header at tablet width\n    left: 0;\n    bottom: 0;\n    width: 300px;\n    max-width: 85vw;\n    transform: translateX(-100%);\n    transition: transform 0.25s ease;\n    z-index: 50;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n\n    &.is-open { transform: translateX(0); }\n  }\n\n  @media (max-width: 767.98px) {\n    top: 56px; // header collapses to 56px at mobile width\n  }\n}\n\n// Top icon row (replaces \"Chat / By DevDiscovery\" header)\n.usb-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 0 14px;\n  padding: 0 6px;\n\n  // Hide the legacy logo + subtitle text; we render real icon buttons instead\n  .usb-logo-title,\n  .usb-subtitle { display: none; }\n}\n\n.usb-icon-btn {\n  all: unset;\n  box-sizing: border-box;\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 8px;\n  color: #24252D;\n  transition: background-color 0.15s ease, color 0.15s ease;\n\n  svg { display: block; transition: transform 0.22s ease; }\n\n  &:hover { background-color: $chat-surface-hover; color: $chat-text-primary; }\n  &:focus-visible { outline: 2px solid $chat-primary; outline-offset: 2px; }\n\n  @media (max-width: 991.98px) {\n    width: 44px;\n    height: 44px;\n  }\n}\n\n// \"PAST CHATS + (+)\" row — convert it so the \"+\" becomes a full-width\n// \"New Chat\" card. The \"Pinned\" and \"Chats\" labels live in the list itself\n// (.usb-section-toggle) so they scroll with it.\n.usb-section-label.usb-history-label {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0;\n  padding: 0;\n  font-size: 0;             // hide the \"PAST CHATS\" text\n  text-transform: none;\n\n  // Pull the New Chat button out to the top via flex order\n  .usb-new-chat-btn { order: -1; }\n}\n\n// Collapsible section headings in the list: \"Pinned\", \"Chats\", \"Older chats\"\n.usb-section-toggle {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: calc(100% - 16px);\n  margin: 4px 8px 2px;\n  padding: 6px 4px;\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  color: $chat-text-secondary;\n  letter-spacing: 0.1px;\n  cursor: pointer;\n  text-align: left;\n\n  &:hover { background: $chat-surface-hover; color: $chat-text-primary; }\n}\n\n.usb-section-chevron {\n  display: inline-block;\n  width: 10px;\n  transition: transform 0.15s ease;\n\n  &.is-open { transform: rotate(90deg); }\n}\n\n// \"Show N more\" / \"Show less\" under the pinned chats\n.usb-show-more-btn {\n  display: block;\n  margin: 0 8px 4px;\n  padding: 4px 12px;\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  font-size: 12px;\n  color: $chat-text-muted;\n  cursor: pointer;\n\n  &:hover { background: $chat-surface-hover; color: $chat-text-primary; }\n}\n\n.usb-new-chat-btn {\n  all: unset;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  padding: 14px 16px;\n  background: $chat-surface;\n  color: $chat-text-primary;\n  border: 1px solid #DADCEB;\n  border-radius: 10px;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  box-shadow: 2px 2px 4px 0px rgba(238, 238, 238, 0.25);\n  transition: background-color 0.15s ease, box-shadow 0.15s ease;\n  box-sizing: border-box;\n  text-align: center;\n  // Hide the bare \"+\" text node that lives inside the button\n  font-size: 0;\n\n  &::before {\n    content: \"\";\n    width: 16px;\n    height: 16px;\n    flex-shrink: 0;\n    background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'><path d='M8 2.00004H3.33333C2.97971 2.00004 2.64057 2.14052 2.39052 2.39056C2.14048 2.64061 2 2.97975 2 3.33337V12.6667C2 13.0203 2.14048 13.3595 2.39052 13.6095C2.64057 13.8596 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8596 13.6095 13.6095C13.8595 13.3595 14 13.0203 14 12.6667V8.00004M12.2501 1.75003C12.5153 1.48481 12.875 1.33582 13.2501 1.33582C13.6251 1.33582 13.9848 1.48481 14.2501 1.75003C14.5153 2.01525 14.6643 2.37496 14.6643 2.75003C14.6643 3.1251 14.5153 3.48481 14.2501 3.75003L8.2414 9.75936C8.0831 9.91753 7.88753 10.0333 7.67273 10.096L5.7574 10.656C5.70003 10.6728 5.63922 10.6738 5.58134 10.6589C5.52345 10.6441 5.47061 10.614 5.42836 10.5717C5.38611 10.5295 5.35599 10.4766 5.34116 10.4188C5.32633 10.3609 5.32733 10.3001 5.34406 10.2427L5.90406 8.32736C5.96708 8.11273 6.08309 7.9174 6.2414 7.75936L12.2501 1.75003Z' stroke='%2324252D' stroke-width='1.2' stroke-linecap='round' stroke-linejoin='round'/></svg>\");\n    background-size: contain;\n    background-repeat: no-repeat;\n  }\n\n  &::after {\n    content: \"New Chat\";\n    font-size: 14px;\n    font-weight: 500;\n  }\n\n  &:hover {\n    background: #FAFBFC;\n    box-shadow: 0 1px 3px rgba(16, 24, 40, 0.08);\n  }\n}\n\n// Section label (also used for group labels). Muted small.\n.usb-section-label {\n  padding: 8px 12px 4px;\n  font-size: 13px;\n  font-weight: 500;\n  color: $chat-text-secondary;\n  letter-spacing: 0.1px;\n  text-transform: none;\n}\n\n\n.usb-empty {\n  padding: 12px 16px;\n  font-size: 13px;\n  color: $chat-text-muted;\n}\n\n.usb-load-more-btn {\n  display: block;\n  width: calc(100% - 16px);\n  margin: 4px 8px 8px;\n  padding: 6px 12px;\n  background: transparent;\n  border: 1px solid $chat-border;\n  border-radius: 6px;\n  font-size: 12px;\n  color: $chat-text-muted;\n  cursor: pointer;\n  text-align: center;\n\n  &:hover { background: $chat-surface-hover; color: $chat-text-primary; }\n  &:disabled { cursor: default; opacity: 0.7; }\n  &:disabled:hover { background: transparent; color: $chat-text-muted; }\n}\n\n// \"Older chats\": the legacy (pre-streaming) chats, collapsed under the list\n.usb-older {\n  margin-top: 8px;\n  border-top: 1px solid $chat-border;\n  padding-top: 4px;\n}\n\n.usb-retry-btn {\n  padding: 0;\n  background: transparent;\n  border: 0;\n  color: inherit;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n// Skeleton loader for the history list — matches chat-item geometry so the\n// switch to the real list doesn't shift layout.\n.usb-loading {\n  pointer-events: none;\n}\n\n.usb-skeleton-item {\n  cursor: default;\n\n  &:hover { background: transparent; }\n}\n\n.usb-skeleton-line {\n  display: block;\n  height: 10px;\n  border-radius: 5px;\n  background: linear-gradient(\n    90deg,\n    $chat-surface-hover 0%,\n    rgba(#F4F5F7, 1) 50%,\n    $chat-surface-hover 100%\n  );\n  background-size: 200% 100%;\n  animation: usb-skeleton-shimmer 1.4s ease-in-out infinite;\n}\n\n@keyframes usb-skeleton-shimmer {\n  0%   { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .usb-skeleton-line { animation: none; }\n}\n\n// Wraps the entire history region (loading / empty / grouped lists) and owns\n// the scroll. Flex-grows to claim leftover space below the New Chat card;\n// min-height: 0 is required so a flex child can shrink below its content size\n// and actually scroll instead of pushing the sidebar past 100% height.\n.usb-history-scroll {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-width: thin;\n  scrollbar-color: #D5D8DC transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: #D5D8DC; border-radius: 3px; }\n  &::-webkit-scrollbar-track { background: transparent; }\n}\n\n.usb-chat-list {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 4px;\n}\n\n.usb-chat-item {\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 10px 12px;\n  margin: 2px 0;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 400;\n  color: $chat-text-primary;\n  cursor: pointer;\n  transition: background-color 0.12s ease;\n  gap: 8px;\n\n  .usb-item-menu-btn {\n    width: 26px;\n    height: 26px;\n    border: none;\n    background: transparent;\n    color: $chat-text-secondary;\n    border-radius: 6px;\n    opacity: 0;\n    cursor: pointer;\n    font-size: 16px;\n    line-height: 1;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    transition: opacity 0.15s ease, background-color 0.15s ease;\n    flex-shrink: 0;\n    margin-left: auto;\n\n    &:hover {\n      background: rgba(0, 0, 0, 0.06);\n      color: $chat-text-primary;\n    }\n\n    @media (hover: none) { opacity: 1; }\n  }\n\n  &:hover {\n    background: $chat-surface-hover;\n\n    .usb-item-menu-btn { opacity: 1; }\n  }\n\n  // Keep the menu button visible while its dropdown is open, even when the\n  // user's cursor moves off the row.\n  .usb-row-menu.show .usb-item-menu-btn { opacity: 1; }\n\n  &.active {\n    background: $chat-surface-active;\n    color: $chat-text-primary;\n    font-weight: 500;\n  }\n\n  // A pinned row being dragged: lifted above the others\n  &.is-dragging {\n    z-index: 1;\n    background: $chat-surface-hover;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n    cursor: grabbing;\n  }\n}\n\n// Design shows no per-item icon — hide the emoji span\n.usb-chat-icon { display: none; }\n\n// Pinned chats get a small tilted pin before the title\n.usb-pin-mark {\n  display: inline-flex;\n  flex-shrink: 0;\n  color: $chat-primary;\n\n  svg { transform: rotate(45deg); }\n}\n\n.usb-chat-title {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.usb-rename-input {\n  flex: 1;\n  border: 1px solid $chat-border-subtle;\n  border-radius: 6px;\n  padding: 4px 8px;\n  font-family: inherit;\n  font-size: 13px;\n  color: $chat-text-primary;\n  outline: none;\n  min-width: 0;\n\n  &:focus { border-color: $chat-primary; }\n}\n\n.usb-rename-counter {\n  margin-left: 6px;\n  font-size: 11px;\n  font-variant-numeric: tabular-nums;\n  color: $chat-text-muted;\n  flex-shrink: 0;\n\n  &.is-warning { color: #B07A00; }\n  &.is-danger  { color: #C22; font-weight: 600; }\n}\n\n.usb-rename-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin-left: 6px;\n  flex-shrink: 0;\n\n  button {\n    all: unset;\n    width: 22px;\n    height: 22px;\n    border-radius: 4px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 13px;\n    color: $chat-text-secondary;\n    cursor: pointer;\n\n    &:hover { background: rgba(0, 0, 0, 0.06); color: $chat-text-primary; }\n\n    &:disabled,\n    &[disabled] {\n      opacity: 0.4;\n      cursor: not-allowed;\n\n      &:hover { background: transparent; color: $chat-text-secondary; }\n    }\n  }\n}\n\n// ============================================================================\n// Collapsed state (Gemini-style rail) — desktop only (pane is ~64px)\n// On mobile the sidebar is a full-height drawer; is-collapsed is ignored so\n// the chat list is always visible when the drawer is open.\n// ============================================================================\n@media (min-width: 992px) {\n  .unified-sidebar.is-collapsed {\n    padding: 16px 10px;\n\n    .usb-header {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 8px;\n      padding: 0;\n      margin: 0 0 12px;\n    }\n\n    // Stack the rail icons: panel-toggle on top, then search trigger\n    .usb-panel-toggle { order: 0; }\n    .usb-search-trigger { order: 1; }\n\n    // Flip the panel-toggle chevron so it points \"expand\"\n    .usb-panel-toggle svg { transform: rotate(180deg); }\n\n    // Hide everything that isn't the two icons\n    .usb-section-label,\n    .usb-chat-list,\n    .usb-history-scroll,\n    .usb-loading,\n    .usb-empty {\n      display: none;\n    }\n\n    // Keep the new-chat wrapper visible but strip layout padding\n    .usb-section-label.usb-history-label {\n      display: block;\n      padding: 0;\n\n      &::after { display: none; }\n    }\n\n    // New-chat button becomes a flat stroke-icon button matching .usb-icon-btn\n    .usb-new-chat-btn {\n      all: unset;\n      box-sizing: border-box;\n      width: 32px;\n      height: 32px;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      border-radius: 8px;\n      background: transparent;\n      border: none;\n      box-shadow: none;\n      padding: 0;\n      margin: 0;\n      transition: background-color 0.15s ease;\n\n      &::after { display: none; }\n      &::before {\n        width: 18px;\n        height: 18px;\n        margin: 0;\n      }\n\n      &:hover { background-color: $chat-surface-hover; }\n      &:focus-visible { outline: 2px solid $chat-primary; outline-offset: 2px; }\n    }\n  }\n}\n\n// ── Row menu (Rename / Delete) ──────────────────────────────────────────────\n.usb-row-menu {\n  flex-shrink: 0;\n  margin-left: auto;\n  line-height: 1;\n}\n\n.usb-row-menu-list.dropdown-menu {\n  min-width: 160px;\n  padding: 6px;\n  border: 1px solid $chat-border-subtle;\n  border-radius: 10px;\n  background: $chat-surface;\n  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.12);\n  font-size: 13px;\n  z-index: 60;\n}\n\n.usb-row-menu-item.dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  border-radius: 6px;\n  background: transparent;\n  border: none;\n  color: $chat-text-primary;\n  cursor: pointer;\n  white-space: nowrap;\n\n  .usb-row-menu-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 16px;\n    height: 16px;\n    color: $chat-text-secondary;\n    flex-shrink: 0;\n  }\n\n  &:hover,\n  &:focus {\n    background: $chat-surface-hover;\n    color: $chat-text-primary;\n    .usb-row-menu-icon { color: $chat-text-primary; }\n  }\n\n  &:active { background: $chat-surface-active; }\n\n  &.usb-row-menu-item--danger {\n    color: $chat-error;\n    .usb-row-menu-icon { color: $chat-error; }\n\n    &:hover,\n    &:focus {\n      background: rgba(217, 45, 32, 0.08);\n      color: $chat-error;\n      .usb-row-menu-icon { color: $chat-error; }\n    }\n  }\n}\n\n// ── Delete confirmation modal ────────────────────────────────────────────────\n.dcm-dialog {\n  max-width: 380px;\n\n  .modal-content {\n    border: none;\n    border-radius: 12px;\n    box-shadow: 0 12px 32px rgba(16, 24, 40, 0.18);\n  }\n}\n\n.dcm-body {\n  padding: 22px 22px 18px;\n}\n\n.dcm-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: $chat-text-primary;\n  margin: 0 0 8px;\n}\n\n.dcm-text {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $chat-text-secondary;\n  margin: 0 0 18px;\n\n  strong {\n    color: $chat-text-primary;\n    font-weight: 600;\n    word-break: break-word;\n  }\n}\n\n.dcm-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.dcm-btn {\n  appearance: none;\n  border-radius: 8px;\n  padding: 8px 16px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  border: 1px solid transparent;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n.dcm-btn--cancel {\n  background: $chat-surface;\n  border-color: $chat-border-subtle;\n  color: $chat-text-primary;\n\n  &:hover:not(:disabled) { background: $chat-surface-hover; }\n}\n\n.dcm-btn--danger {\n  background: $chat-error;\n  color: #fff;\n  border-color: $chat-error;\n\n  &:hover:not(:disabled) { background: #B42318; border-color: #B42318; }\n}\n","@use \"../../../../utils/variables\" as *;\n// ============================================================================\n// Unified chat — search modal\n// ============================================================================\n\n.chat-search-modal {\n  .chat-search-modal-dialog {\n    max-width: 580px;\n    width: calc(100% - 32px);\n    margin: 0 auto;\n  }\n\n  .modal-content {\n    border: none;\n    border-radius: 14px;\n    box-shadow: 0 24px 48px rgba(16, 24, 40, 0.14),\n                0 2px 6px rgba(16, 24, 40, 0.06);\n    overflow: hidden;\n    background: #FFFFFF;\n  }\n\n  .modal-body {\n    padding: 0;\n  }\n}\n\n.csm-search {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 20px 24px;\n  border-bottom: 1px solid #EEF0F2;\n}\n\n.csm-search-icon {\n  width: 20px;\n  height: 20px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #1A1A1A;\n  flex-shrink: 0;\n\n  svg {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.csm-search-input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-family: $primary-font;\n  font-size: 15px;\n  font-weight: 400;\n  color: $chat-text-primary;\n  line-height: 1.4;\n  padding: 0;\n\n  &::placeholder {\n    color: #9CA3AF;\n  }\n}\n\n.csm-close {\n  all: unset;\n  width: 24px;\n  height: 24px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #1A1A1A;\n  cursor: pointer;\n  border-radius: 6px;\n  flex-shrink: 0;\n  transition: background-color 0.15s ease;\n\n  svg {\n    display: block;\n  }\n\n  @media (hover: hover) {\n    &:hover {\n      background: rgba(0, 0, 0, 0.04);\n    }\n  }\n\n  &:focus-visible {\n    outline: 2px solid $chat-primary;\n    outline-offset: 2px;\n  }\n}\n\n.csm-section-label {\n  padding: 18px 24px 10px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #1A1A1A;\n  letter-spacing: 0;\n  font-family: $primary-font;\n}\n\n.csm-list {\n  list-style: none;\n  margin: 0;\n  padding: 0 0 12px;\n  max-height: min(420px, 60vh);\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: #D5D8DC transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb {\n    background: #D5D8DC;\n    border-radius: 3px;\n  }\n  &::-webkit-scrollbar-track { background: transparent; }\n}\n\n.csm-row {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 11px 24px;\n  font-family: $primary-font;\n  font-size: 14px;\n  font-weight: 400;\n  color: #1A1A1A;\n  cursor: pointer;\n  transition: background-color 0.12s ease;\n\n  @media (hover: hover) {\n    &:hover {\n      background: $chat-surface-hover;\n    }\n  }\n}\n\n.csm-row-title {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.csm-row-pin {\n  display: inline-flex;\n  flex-shrink: 0;\n  color: $chat-text-secondary;\n}\n\n.csm-row-date {\n  flex-shrink: 0;\n  color: $chat-text-secondary;\n  font-size: 13px;\n  font-weight: 400;\n  white-space: nowrap;\n}\n\n.csm-empty {\n  padding: 20px 24px;\n  color: $chat-text-muted;\n  font-size: 14px;\n  text-align: center;\n  font-family: $primary-font;\n}\n\n// ============================================================================\n// Responsive\n// ============================================================================\n\n@media (max-width: 767px) {\n  .chat-search-modal {\n    .chat-search-modal-dialog {\n      max-width: 100%;\n      width: calc(100% - 16px);\n      margin: 8px auto;\n    }\n\n    .modal-content {\n      border-radius: 12px;\n    }\n  }\n\n  .csm-search {\n    padding: 16px 18px;\n    gap: 12px;\n  }\n\n  .csm-search-input {\n    font-size: 16px; // prevent iOS zoom-on-focus\n  }\n\n  .csm-section-label {\n    padding: 14px 18px 8px;\n  }\n\n  .csm-list {\n    max-height: min(60vh, calc(100vh - 180px));\n  }\n\n  .csm-row {\n    padding: 12px 18px;\n    gap: 12px;\n  }\n\n  .csm-empty {\n    padding: 18px 18px;\n  }\n}\n\n@media (max-width: 480px) {\n  .chat-search-modal {\n    .chat-search-modal-dialog {\n      width: calc(100% - 12px);\n      margin: 6px auto;\n    }\n  }\n}\n","@use \"../../../../utils/variables\" as *;\n// ============================================================================\n// Unified chat — references side panel (Image #7 design)\n// ============================================================================\n\n.sources-panel {\n  flex-shrink: 0;\n  width: 360px;\n  background: $chat-bg;\n  border-left: 1px solid $chat-border-subtle;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  animation: sp-slide-in 180ms ease-out;\n  z-index: 40;\n\n  @media (max-width: 1199.98px) {\n    width: 320px;\n  }\n\n  // Tablet — overlay inside .unified-feed, backdrop shown\n  @media (max-width: 991.98px) {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    width: min(380px, 90%);\n    box-shadow: -4px 0 20px rgba(16, 24, 40, 0.08);\n    z-index: 60;\n  }\n\n  // Mobile — full-width fixed drawer\n  @media (max-width: 767.98px) {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    width: 100vw;\n    max-width: 100vw;\n    box-shadow: none;\n    z-index: 1080;\n  }\n}\n\n@keyframes sp-slide-in {\n  from { transform: translateX(12px); opacity: 0; }\n  to   { transform: translateX(0);    opacity: 1; }\n}\n\n// Backdrop — only visible on md and below\n.sources-panel-backdrop {\n  display: none;\n\n  @media (max-width: 991.98px) {\n    display: block;\n    position: absolute;\n    inset: 0;\n    background: rgba(16, 24, 40, 0.25);\n    z-index: 55;\n  }\n\n  @media (max-width: 767.98px) {\n    position: fixed;\n    z-index: 1079;\n    background: rgba(16, 24, 40, 0.4);\n  }\n}\n\n// Header ---------------------------------------------------------------------\n.sp-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 18px 20px;\n  border-bottom: 1px solid $chat-border-subtle;\n  flex-shrink: 0;\n  // Ensure header always sits above scrolled card content so the close\n  // button is never obscured or pointer-intercepted by a card below.\n  position: relative;\n  z-index: 1;\n  background: $chat-bg;\n}\n\n.sp-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: $chat-text-primary;\n}\n\n.sp-close-btn {\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: transparent;\n  color: $chat-text-secondary;\n  border-radius: 8px;\n  cursor: pointer;\n  padding: 0;\n  transition: background-color 0.15s ease, color 0.15s ease;\n\n  &:hover {\n    background: $chat-surface-hover;\n    color: $chat-text-primary;\n  }\n}\n\n// Cards ----------------------------------------------------------------------\n// \"This answer | All\" switch, under the header\n.sp-view-switch {\n  display: flex;\n  gap: 4px;\n  margin: 12px 16px 0;\n  padding: 3px;\n  background: $chat-surface-hover;\n  border-radius: 8px;\n  flex-shrink: 0;\n}\n\n.sp-view-btn {\n  flex: 1;\n  padding: 6px 10px;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  color: $chat-text-secondary;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n\n  &:hover { color: $chat-text-primary; }\n  &:focus-visible { outline: 2px solid $chat-primary; outline-offset: 1px; }\n\n  &.is-active {\n    background: $chat-surface;\n    color: $chat-text-primary;\n    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.08);\n  }\n}\n\n.sp-cards {\n  flex: 1;\n  overflow-y: auto;\n  padding: 12px 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.sp-card {\n  display: block;\n  text-decoration: none;\n  background: $chat-surface;\n  border: 1px solid $chat-border-subtle;\n  border-radius: 10px;\n  padding: 12px 14px;\n  color: inherit;\n  cursor: pointer;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease, transform 0.15s ease;\n\n  &:hover {\n    border-color: #D1D5DB;\n    box-shadow: 0 2px 8px rgba(16, 24, 40, 0.06);\n  }\n\n  &:focus-visible {\n    outline: 2px solid $chat-primary;\n    outline-offset: 2px;\n  }\n\n  &--highlight {\n    animation: sp-flash 1.5s ease-out;\n  }\n}\n\n@keyframes sp-flash {\n  0%   { background: #E8F0FE; border-color: $chat-primary; }\n  60%  { background: #E8F0FE; border-color: $chat-primary; }\n  100% { background: $chat-surface; border-color: $chat-border-subtle; }\n}\n\n.sp-card-head {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.sp-card-index {\n  flex-shrink: 0;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: $chat-surface-hover;\n  color: $chat-text-primary;\n  font-size: 11px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n  margin-top: 1px;\n}\n\n.sp-card-title {\n  flex: 1;\n  min-width: 0;\n  font-size: 13px;\n  font-weight: 500;\n  color: $chat-text-primary;\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: break-word;\n}\n\n.sp-card-type {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 10px;\n  color: $chat-text-secondary;\n}\n\n.sp-card-type-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: $chat-text-secondary;\n}\n\n.sp-card-type-label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.6px;\n  color: $chat-text-secondary;\n  text-transform: uppercase;\n}\n","@use \"../../../../utils/variables\" as *;\n// ============================================================================\n// Unified chat — feed / main pane\n// ============================================================================\n\n.unified-feed {\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  min-width: 0;\n  height: 100%;\n  background: $chat-bg;\n  color: $chat-text-primary;\n  font-family: $primary-font;\n  position: relative;\n}\n\n// Main column — holds header, messages, and input area.\n// Sits side-by-side with .sources-panel on >=lg; shrinks when panel is open.\n.uf-main {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n  height: 100%;\n  transition: width 180ms ease, flex-basis 180ms ease;\n}\n\n// Header (\"Chat | Generate BETA + subtitle\") — hidden in the new design\n.uf-header { display: none; }\n\n.uf-title {\n  font-size: 26px;\n  font-weight: 700;\n  color: $chat-text-primary;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  margin: 0;\n}\n\n.uf-beta-badge {\n  font-size: 11px;\n  font-weight: 600;\n  background: #e8e8e8;\n  color: $chat-text-secondary;\n  border-radius: 4px;\n  padding: 2px 7px;\n}\n\n.uf-subtitle {\n  font-size: 13px;\n  color: $chat-text-muted;\n  margin: 6px 0 0;\n}\n\n// Messages scroll area\n.uf-messages {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 24px $chat-feed-padding-h;\n  display: flex;\n  flex-direction: column;\n  gap: $chat-message-gap;\n\n  // Constrain each message to a centered content column so the feed doesn't\n  // stretch edge-to-edge on wide screens (matches design 02/03).\n  > * {\n    width: 100%;\n    max-width: $chat-content-max-width;\n    margin-left: auto;\n    margin-right: auto;\n    // Prevent any child element (tables, charts, code blocks) from punching\n    // past the message column and triggering horizontal scroll on narrow viewports.\n    min-width: 0;\n    box-sizing: border-box;\n  }\n\n  @media (max-width: 1199.98px) {\n    padding: 24px 32px;\n  }\n  @media (max-width: 991.98px) {\n    padding: 20px 24px;\n  }\n  @media (max-width: 575.98px) {\n    padding: 16px 12px;\n  }\n}\n\n// Empty state — wired in React to render \"Hi X / How can I help you?\"\n.uf-empty-state {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  gap: 12px;\n  text-align: center;\n\n  // The original \"Ask me anything...\" <p> renders here — style it while\n  // leaving room for the greeting blocks that will be injected above it.\n  p {\n    display: none; // not in new design; replaced by greeting + heading\n  }\n}\n\n.uf-empty-greeting {\n  font-size: 18px;\n  font-weight: 400;\n  color: $chat-text-primary;\n  line-height: 1.4;\n\n  .uf-empty-name {\n    color: $chat-text-muted;\n    font-weight: 400;\n  }\n}\n\n.uf-empty-heading {\n  font-size: 36px;\n  font-weight: 500;\n  color: $chat-text-primary;\n  margin: 0 0 28px;\n  line-height: 1.2;\n\n  @media (max-width: 767.98px) { font-size: 26px; margin-bottom: 20px; }\n  @media (max-width: 575.98px) { font-size: 22px; }\n}\n\n// Input area (bottom) — inner container is constrained to the same content\n// column as the messages feed and centered horizontally.\n.uf-input-area {\n  flex-shrink: 0;\n  padding: 0 $chat-feed-padding-h 16px;\n  border-top: none;\n\n  > * {\n    width: 100%;\n    max-width: $chat-content-max-width;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  @media (max-width: 1199.98px) { padding: 0 32px 16px; }\n  @media (max-width: 991.98px) { padding: 0 24px 12px; }\n  @media (max-width: 575.98px) { padding: 0 12px 8px; }\n}\n\n// When empty-state renders, place the input inside it (centered).\n// Empty state uses a wider 820px column (design 01), unlike the in-conversation feed.\n.uf-empty-state .uf-input-area {\n  width: 100%;\n  max-width: 820px;\n  padding: 0;\n\n  > * { max-width: 820px; }\n}\n\n.uf-mock-answer {\n  font-size: 14px;\n  color: $chat-text-primary;\n  line-height: 1.6;\n  margin: 8px 0;\n}\n\n.uf-response-footer {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 10px;\n\n  // fdc-strip renders its own margin normally; inside the footer row we let\n  // the parent gap handle spacing instead.\n  .fdc-strip {\n    margin: 0;\n    flex: 1 1 auto;\n  }\n\n  // References pill pinned to the right edge of the row\n  .uf-show-refs-btn {\n    margin-top: 0;\n    margin-left: auto;\n    flex-shrink: 0;\n  }\n}\n\n.uf-show-refs-btn {\n  margin-top: 10px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: $chat-surface;\n  border: 1px solid $chat-border-subtle;\n  border-radius: 20px;\n  padding: 6px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  color: $chat-text-primary;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n\n  svg { color: $chat-text-secondary; }\n\n  &:hover {\n    background: $chat-surface-hover;\n    border-color: #D1D5DB;\n\n    svg { color: $chat-text-primary; }\n  }\n\n  // The panel is showing this answer's references\n  &.is-active {\n    background: #E8F0FC;\n    border-color: $chat-primary;\n    color: $chat-primary-hover;\n\n    svg { color: $chat-primary; }\n  }\n}\n\n.uf-streaming-cursor {\n  display: inline-block;\n  color: $chat-text-muted;\n  font-weight: 600;\n  animation: uf-blink 1s steps(1) infinite;\n}\n\n@keyframes uf-blink {\n  50% { opacity: 0; }\n}\n\n// Streaming \"more coming\" skeleton — preview-shape paragraph lines that\n// share the gradient-sweep animation with the sidebar history loader so\n// the loading language is consistent across surfaces. Lines are staggered,\n// have varied widths, and ride a subtle breathing rhythm to feel alive\n// rather than a frozen placeholder. Muted greys only — the ThoughtProcess\n// card above owns the brand-blue accents.\n.uf-stream-skeleton {\n  align-self: stretch;\n  margin-top: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  animation: uf-stream-skeleton-breathe 3.6s ease-in-out infinite;\n\n  &__line {\n    display: block;\n    height: 12px;\n    border-radius: 6px;\n    background: linear-gradient(\n      90deg,\n      $chat-surface-hover 0%,\n      #F8F9FA 45%,\n      #FFFFFF 50%,\n      #F8F9FA 55%,\n      $chat-surface-hover 100%\n    );\n    background-size: 220% 100%;\n    animation: uf-stream-shimmer 2.4s linear infinite;\n\n    // Vary widths so the two lines read like the tail of a real paragraph\n    &:nth-child(1) {\n      width: 92%;\n      animation-delay: 0s;\n    }\n\n    &:nth-child(2) {\n      width: 58%;\n      animation-delay: 0.3s;\n    }\n  }\n}\n\n@keyframes uf-stream-shimmer {\n  0%   { background-position: 220% 0; }\n  100% { background-position: -120% 0; }\n}\n\n// Soft 0.6–1.0 opacity breath — the whole skeleton pulses gently while the\n// per-line shimmer sweeps. Adds a \"live\" rhythm without being noisy.\n@keyframes uf-stream-skeleton-breathe {\n  0%, 100% { opacity: 0.7; }\n  50%      { opacity: 1; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .uf-stream-skeleton,\n  .uf-stream-skeleton__line { animation: none; }\n}\n\n.uf-error-row {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 6px;\n}\n\n.uf-error-text {\n  font-size: 13px;\n  color: $chat-error;\n}\n\n.uf-retry-btn {\n  align-self: flex-start;\n  background: rgba($chat-primary, 0.10);\n  border: none;\n  border-radius: 8px;\n  padding: 7px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  color: $chat-primary;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: background-color 0.15s ease, color 0.15s ease;\n\n  &:hover {\n    background: rgba($chat-primary, 0.18);\n    color: $chat-primary-hover;\n  }\n\n  &:active { transform: translateY(0.5px); }\n\n  &:disabled {\n    background: rgba($chat-text-muted, 0.15);\n    color: $chat-text-muted;\n    cursor: not-allowed;\n  }\n}\n\n.uf-stopped-notice {\n  font-size: 12px;\n  color: $chat-text-muted;\n  margin-top: 6px;\n}\n\n.uf-finalizing-notice {\n  font-size: 12px;\n  color: $chat-primary;\n  margin-top: 6px;\n}\n\n// When a partial answer precedes the error, separate the two visually.\n.uf-error-row--inline {\n  border-top: 1px dashed $chat-border-subtle;\n  padding-top: 10px;\n  margin-top: 12px;\n}\n\n.uf-error-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: center;\n}\n\n// Legacy chat read-only banner — centered, fits content\n.uf-legacy-banner {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  width: fit-content;\n  margin: 0 auto 12px;\n  padding: 10px 16px;\n  background: #F0F4FF;\n  border: 1px solid #DADCEB;\n  border-radius: 10px;\n  font-family: $primary-font;\n  font-size: 13px;\n  color: $chat-text-secondary;\n  line-height: 1.4;\n}\n\n.uf-legacy-new-chat-btn {\n  all: unset;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background: $chat-surface;\n  color: $chat-text-primary;\n  border: 1px solid #DADCEB;\n  border-radius: 10px;\n  font-family: $primary-font;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n  box-shadow: 2px 2px 4px 0px rgba(238, 238, 238, 0.25);\n  transition: background-color 0.15s ease, box-shadow 0.15s ease;\n  box-sizing: border-box;\n\n  &:hover {\n    background: $chat-surface-hover;\n  }\n}\n\n// Block all interaction with the input area when viewing a legacy (read-only) chat\n.uf-input-area--readonly {\n  pointer-events: none;\n  opacity: 0.45;\n  user-select: none;\n}\n","@use \"../../../../../utils/variables\" as *;\n// ============================================================================\n// Chat — user message (right-aligned pill, copy button to its left)\n// ============================================================================\n\n.user-message-row {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 4px;\n  padding: 0;\n  background: transparent;\n  border-radius: 0;\n\n  // Reveal copy button on hover or focus-within\n  &:hover .um-action-btn,\n  &:focus-within .um-action-btn {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n// Avatar not shown in new design\n.um-avatar { display: none; }\n\n.um-bubble {\n  max-width: 75%;\n  padding: 12px 18px;\n  background: $chat-page-bg;\n  color: $chat-text-primary;\n  border-radius: 18px;\n  font-size: 15px;\n  line-height: 1.5;\n  word-wrap: break-word;\n\n  @media (max-width: 575.98px) {\n    max-width: 90%;\n    font-size: 14px;\n    padding: 10px 14px;\n  }\n}\n\n.um-action-btn {\n  width: 30px;\n  height: 30px;\n  flex-shrink: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: $chat-text-muted;\n  border-radius: 6px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease, background-color 0.15s ease, color 0.15s ease;\n\n  &:hover {\n    background: $chat-surface-hover;\n    color: $chat-text-primary;\n  }\n\n  // Always visible on touch / no-hover devices\n  @media (hover: none) {\n    opacity: 1;\n    visibility: visible;\n  }\n\n  // Keep the button on-screen while the \"Copied!\" feedback is showing so\n  // the user actually sees the checkmark before the row de-hovers.\n  &.is-copied {\n    opacity: 1;\n    visibility: visible;\n    color: #1F8A4E;\n\n    &:hover {\n      background: rgba(31, 138, 78, 0.08);\n      color: #1F8A4E;\n    }\n  }\n}\n\n// ── Edit mode ────────────────────────────────────────────────────────────────\n// Edit container mirrors the bubble visually: same gray background, same\n// rounded shape, same right-alignment. Width hugs content up to the bubble's\n// max-width. Cancel + Send sit just below, also right-aligned, so the editor\n// reads as \"the bubble itself, but typeable\".\n.user-message-row--editing {\n  // Stack the editor + actions vertically against the right edge.\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.um-edit {\n  max-width: 75%;\n  background: $chat-page-bg;\n  color: $chat-text-primary;\n  border-radius: 18px;\n  padding: 12px 18px;\n\n  @media (max-width: 575.98px) {\n    max-width: 90%;\n    padding: 10px 14px;\n  }\n}\n\n.um-edit-textarea {\n  display: block;\n  width: 100%;\n  min-width: 220px;\n  max-height: 320px;\n  resize: none;\n  border: none;\n  outline: none;\n  background: transparent;\n  color: $chat-text-primary;\n  font-family: inherit;\n  font-size: 15px;\n  line-height: 1.5;\n  padding: 0;\n\n  &::placeholder { color: $chat-text-muted; }\n\n  @media (max-width: 575.98px) { font-size: 14px; }\n}\n\n.um-edit-actions {\n  margin-top: 8px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 8px;\n}\n\n.um-edit-cancel {\n  background: transparent;\n  border: 1px solid $chat-border;\n  border-radius: 999px;\n  padding: 5px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  color: $chat-text-primary;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n\n  &:hover {\n    background: $chat-surface-hover;\n    border-color: #D1D5DB;\n  }\n}\n\n.um-edit-send {\n  background: $chat-primary;\n  border: 1px solid $chat-primary;\n  border-radius: 999px;\n  padding: 5px 16px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #fff;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n\n  &:hover {\n    background: $chat-primary-hover;\n    border-color: $chat-primary-hover;\n  }\n\n  &:disabled {\n    background: rgba($chat-primary, 0.45);\n    border-color: rgba($chat-primary, 0.45);\n    cursor: not-allowed;\n  }\n}\n","@use \"../../../../../utils/variables\" as *;\n// ============================================================================\n// Thought-process / Researching accordion (timeline layout)\n// ============================================================================\n\n.thought-process {\n  background: linear-gradient(179.91deg, #FFFFFF 0.08%, #F4F6F7 105.6%);\n  border: 1px solid #EAEAEA;\n  border-radius: 16px;\n  overflow: hidden;\n  margin-bottom: 16px;\n}\n\n.tp-header {\n  width: 100%;\n  background: transparent;\n  border: none;\n  padding: 18px 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  font-family: $primary-font;\n  font-size: 15px;\n  font-weight: 500;\n  color: $chat-text-primary;\n  text-align: left;\n}\n\n.tp-header-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.tp-lead-icon {\n  color: $chat-primary;\n  flex-shrink: 0;\n\n  .is-thinking & {\n    animation: tp-pulse 1.6s ease-in-out infinite;\n  }\n}\n\n@keyframes tp-pulse {\n  0%, 100% { opacity: 1; }\n  50%      { opacity: 0.45; }\n}\n\n.tp-title {\n  color: $chat-text-primary;\n  font-weight: 500;\n\n  // While the agent is actively researching, run a shimmer sweep across the\n  // label so the loading signal lives on the status text itself instead of a\n  // separate dot widget. Matches the Perplexity/Claude pattern.\n  .is-thinking & {\n    background: linear-gradient(\n      90deg,\n      $chat-text-primary 0%,\n      $chat-text-primary 40%,\n      rgba($chat-primary, 0.55) 50%,\n      $chat-text-primary 60%,\n      $chat-text-primary 100%\n    );\n    background-size: 200% 100%;\n    -webkit-background-clip: text;\n    background-clip: text;\n    -webkit-text-fill-color: transparent;\n    color: transparent;\n    animation: tp-title-shimmer 2s linear infinite;\n  }\n}\n\n@keyframes tp-title-shimmer {\n  0%   { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .is-thinking .tp-title {\n    animation: none;\n    background: none;\n    -webkit-text-fill-color: $chat-text-primary;\n    color: $chat-text-primary;\n  }\n}\n\n.tp-chevron {\n  color: $chat-text-muted;\n  transition: transform 0.2s ease;\n  flex-shrink: 0;\n\n  &.tp-chevron-up { transform: rotate(180deg); }\n}\n\n// ── Timeline ────────────────────────────────────────────────────────────────\n.tp-timeline {\n  list-style: none;\n  margin: 0;\n  padding: 4px 24px 22px 28px;\n  position: relative;\n\n  // Vertical rail behind the dots\n  &::before {\n    content: '';\n    position: absolute;\n    left: 32px;            // = padding-left (28) + dot-half (4)\n    top: 12px;\n    bottom: 12px;\n    width: 1px;\n    background: rgba($chat-primary, 0.18);\n  }\n}\n\n.tp-phase {\n  position: relative;\n  padding-left: 18px;\n  padding-bottom: 14px;\n\n  &:last-child { padding-bottom: 0; }\n}\n\n.tp-dot {\n  position: absolute;\n  left: -4px;\n  top: 6px;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: $chat-primary;\n  // White halo so the rail line breaks cleanly behind the dot\n  box-shadow: 0 0 0 3px #fff;\n  z-index: 1;\n}\n\n// In-progress (the most recent phase while thinking) — pulsing ring\n.tp-phase.is-current .tp-dot {\n  background: $chat-primary;\n  animation: tp-dot-pulse 1.4s ease-in-out infinite;\n}\n\n@keyframes tp-dot-pulse {\n  0%, 100% { box-shadow: 0 0 0 3px #fff, 0 0 0 0   rgba($chat-primary, 0.35); }\n  50%      { box-shadow: 0 0 0 3px #fff, 0 0 0 6px rgba($chat-primary, 0); }\n}\n\n.tp-phase-title {\n  font-size: 15px;\n  font-weight: 500;\n  color: $chat-text-primary;\n  line-height: 1.45;\n}\n\n// ── Sub-results (nested under each phase) ───────────────────────────────────\n.tp-subs {\n  list-style: none;\n  margin: 6px 0 0;\n  padding: 0;\n}\n\n.tp-sub {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: 400;\n  color: $chat-text-muted;\n  line-height: 1.55;\n  padding: 2px 0;\n}\n\n.tp-sub.is-done {\n  color: $chat-text-secondary;\n}\n\n.tp-check {\n  flex-shrink: 0;\n  margin-top: 4px;\n  width: 12px;\n  height: 12px;\n  color: $chat-success;\n}\n\n.tp-sub-text { flex: 1; min-width: 0; }\n\n// ── Mobile ──────────────────────────────────────────────────────────────────\n@media (max-width: 575.98px) {\n  .tp-header   { padding: 14px 18px; font-size: 14px; }\n  .tp-timeline {\n    padding: 4px 18px 18px 22px;\n    &::before { left: 26px; }\n  }\n  .tp-phase-title { font-size: 14px; }\n  .tp-sub         { font-size: 12px; }\n}\n","@use \"../../../../../utils/variables\" as *;\n// ============================================================================\n// Chat — AI response (no bubble, free-flowing text with circular avatar)\n// ============================================================================\n\n.ai-response-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 4px 0 24px;\n\n  // Reveal action buttons on hover or focus-within\n  &:hover .ar-actions,\n  &:focus-within .ar-actions {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n.ar-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.ar-avatar-img {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.ar-content {\n  flex: 1;\n  min-width: 0;\n  overflow-x: hidden;\n  color: $chat-text-primary;\n  font-size: 15px;\n  line-height: 1.65;\n\n  // Prevent wide fixed-width elements (tables, charts, code blocks) from\n  // overflowing the message column on narrow mobile viewports.\n  img, table, pre, canvas, svg { max-width: 100%; }\n  table { display: block; overflow-x: auto; }\n}\n\n.ar-actions {\n  display: flex;\n  gap: 4px;\n  margin-top: 12px;\n  padding-top: 0;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease;\n\n  // Always visible on touch / no-hover devices\n  @media (hover: none) {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n.ar-action-btn {\n  width: 30px;\n  height: 30px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: $chat-text-muted;\n  border-radius: 6px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.15s ease, color 0.15s ease;\n\n  &:hover {\n    background: $chat-surface-hover;\n    color: $chat-text-primary;\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.4;\n\n    &:hover {\n      background: transparent;\n      color: $chat-text-muted;\n    }\n  }\n\n  &.is-selected {\n    background: #1A73E8;\n    color: #fff;\n\n    &:hover {\n      background: #1A73E8;\n      color: #fff;\n    }\n  }\n\n  &.is-copied {\n    color: #1F8A4E;\n\n    &:hover {\n      background: rgba(31, 138, 78, 0.08);\n      color: #1F8A4E;\n    }\n  }\n}\n\n// ── Download format-picker dropdown ─────────────────────────────────────────\n.ar-download-dropdown {\n  display: inline-flex;\n  align-items: center;\n  line-height: 1;\n\n  // Keep the action bar visible while the menu is open.\n  &.show {\n    ~ * { /* no-op selector to anchor the rule below */ }\n  }\n}\n\n// When the dropdown is open, force the action bar to stay visible — the menu\n// pops out beyond the row, so hover can break otherwise.\n.ai-response-row:has(.ar-download-dropdown.show) .ar-actions,\n.ai-response-row .ar-download-dropdown.show {\n  opacity: 1;\n  visibility: visible;\n}\n\n.ar-download-menu.dropdown-menu {\n  min-width: 160px;\n  padding: 6px;\n  border: 1px solid $chat-border-subtle;\n  border-radius: 10px;\n  background: $chat-surface;\n  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.12);\n  font-size: 13px;\n  z-index: 60;\n\n  // Popper sets `data-popper-placement` once it has measured the trigger.\n  // Until then, Bootstrap's default `inset: 0 0 auto auto` would flash the\n  // menu at the right edge of its positioned ancestor on first open. Hide\n  // it until popper has placed it so users don't see the flash.\n  &:not([data-popper-placement]) {\n    visibility: hidden;\n  }\n}\n\n.ar-download-menu-item.dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  border-radius: 6px;\n  background: transparent;\n  border: none;\n  color: $chat-text-primary;\n  cursor: pointer;\n  white-space: nowrap;\n\n  .ar-download-menu-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 16px;\n    height: 16px;\n    color: $chat-text-secondary;\n    flex-shrink: 0;\n  }\n\n  &:hover,\n  &:focus {\n    background: $chat-surface-hover;\n    color: $chat-text-primary;\n    .ar-download-menu-icon { color: $chat-text-primary; }\n  }\n\n  &:active { background: $chat-surface-active; }\n}\n\n@media (max-width: 767.98px) {\n  // Increase touch targets to the 44×44px minimum recommended by Apple HIG\n  // and WCAG 2.5.5 on touch devices.\n  .ar-action-btn {\n    width: 44px;\n    height: 44px;\n    border-radius: 8px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .ai-response-row { gap: 10px; }\n  .ar-avatar { width: 32px; height: 32px; }\n  .ar-content { font-size: 14px; }\n}\n","@use \"../../../../../utils/variables\" as *;\n.ref-chips-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin: 10px 0;\n}\n\n.ref-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 10px;\n  border-radius: 6px;\n  border: 1px solid $chat-border;\n  background: #fafafa;\n  font-size: 12px;\n  color: #333;\n\n  &--code {\n    border-color: #c7d7ff;\n    background: #f0f4ff;\n  }\n\n  &--doc {\n    border-color: #d1f7e0;\n    background: #f0fff4;\n  }\n\n\n}\n\n.ref-chip-icon {\n  display: flex;\n  align-items: center;\n  color: #666;\n}\n\n.ref-chip-label {\n  max-width: 120px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ref-chip-close {\n  border: none;\n  background: none;\n  cursor: pointer;\n  color: #999;\n  font-size: 14px;\n  line-height: 1;\n  padding: 0 0 0 2px;\n\n  &:hover {\n    color: #333;\n  }\n}\n","@use \"../../../../../utils/variables\" as *;\n.fdc-strip {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 10px 0 4px;\n}\n\n.fdc-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 999px;\n  border: 1px solid $chat-border;\n  background: #fafafa;\n  font-size: 13px;\n  color: #333;\n  text-decoration: none;\n  transition: background 0.15s ease, border-color 0.15s ease;\n\n  &:hover,\n  &:focus-visible {\n    background: #f0f4ff;\n    border-color: #c7d7ff;\n    color: #1a1a1a;\n    text-decoration: none;\n  }\n}\n\n.fdc-chip-icon {\n  display: flex;\n  align-items: center;\n  color: #666;\n}\n\n.fdc-chip-label {\n  max-width: 220px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n// ── Per-file-type colors ─────────────────────────────────────────────────\n// Each modifier class is keyed on the lowercase extension parsed off\n// item.filename in FileDownloadChips.js. Colors follow each format's\n// conventional brand palette so chips are recognisable at a glance.\n// Tones are deliberately muted: pale tinted background + soft border +\n// saturated accent color on the icon.\n\n// PowerPoint — orange/red\n.fdc-chip--pptx,\n.fdc-chip--ppt {\n  background: #fff4ec;\n  border-color: #f3c9a8;\n  color: #b94a0c;\n\n  &:hover,\n  &:focus-visible {\n    background: #ffe9d6;\n    border-color: #e0a777;\n    color: #8e3808;\n  }\n\n  .fdc-chip-icon { color: #c4500d; }\n}\n\n// Word — blue\n.fdc-chip--docx,\n.fdc-chip--doc {\n  background: #eef2fd;\n  border-color: #b9c9f0;\n  color: #1f3a7a;\n\n  &:hover,\n  &:focus-visible {\n    background: #dde5fb;\n    border-color: #9eb3eb;\n    color: #14275a;\n  }\n\n  .fdc-chip-icon { color: #2b579a; }\n}\n\n// Excel / CSV — green\n.fdc-chip--xlsx,\n.fdc-chip--xls,\n.fdc-chip--csv {\n  background: #effaf3;\n  border-color: #b0e0bf;\n  color: #155a37;\n\n  &:hover,\n  &:focus-visible {\n    background: #ddf3e4;\n    border-color: #8fcfa1;\n    color: #0f4429;\n  }\n\n  .fdc-chip-icon { color: #217346; }\n}\n\n// PDF — red\n.fdc-chip--pdf {\n  background: #fdecec;\n  border-color: #f0b9b9;\n  color: #952d27;\n\n  &:hover,\n  &:focus-visible {\n    background: #fad9d9;\n    border-color: #e69e9e;\n    color: #74211c;\n  }\n\n  .fdc-chip-icon { color: #c0392b; }\n}\n\n// Archive — amber\n.fdc-chip--zip {\n  background: #fdf6e3;\n  border-color: #ebd99c;\n  color: #7e5a14;\n\n  &:hover,\n  &:focus-visible {\n    background: #faecc9;\n    border-color: #d9c47d;\n    color: #614410;\n  }\n\n  .fdc-chip-icon { color: #b7791f; }\n}\n","@use \"../../../../../utils/variables\" as *;\n// ============================================================================\n// Unified chat — inline toolbar inside input bar\n// ============================================================================\n\n.input-toolbar {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 6px;\n  flex: 1;\n  min-width: 0;\n}\n\n.it-buttons {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex: 1;\n  min-width: 0;\n}\n\n.it-dropdown-wrap {\n  position: relative;\n  flex-shrink: 0;\n\n  &--sources {\n    margin-left: auto;\n  }\n}\n\n.it-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: transparent;\n  border: none;\n  color: $chat-text-primary;\n  font-family: $primary-font;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 7px 10px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n  white-space: nowrap;\n\n  &:hover {\n    background: $chat-surface-hover;\n  }\n\n  .it-btn-icon,\n  .it-btn-chevron {\n    color: currentColor;\n    flex-shrink: 0;\n  }\n}\n\n// ── Consolidated \"• <label> & N more\" pill ──────────────────────────────────\n.it-group-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  background: $chat-surface;\n  border: 1px solid $chat-border-subtle;\n  border-radius: 999px;\n  padding: 2px 4px 2px 10px;\n  font-size: 12px;\n  max-width: 220px;\n  min-width: 0;\n  flex-shrink: 1;\n}\n\n.it-group-pill-body {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: transparent;\n  border: none;\n  padding: 2px 0;\n  color: $chat-text-primary;\n  cursor: pointer;\n  font-family: $primary-font;\n  font-size: 12px;\n  min-width: 0;\n\n  &:hover .it-group-pill-label {\n    color: $chat-primary;\n  }\n}\n\n.it-group-pill-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: $chat-primary;\n  flex-shrink: 0;\n}\n\n.it-group-pill-label {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n.it-group-pill-close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border: none;\n  background: transparent;\n  color: $chat-text-muted;\n  font-size: 16px;\n  line-height: 1;\n  cursor: pointer;\n  border-radius: 50%;\n  flex-shrink: 0;\n\n  &:hover {\n    background: $chat-surface-hover;\n    color: $chat-text-primary;\n  }\n}\n\n// ── Multi-select popup (checkbox list with Select All + Cancel/Done) ────────\n.it-popup {\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 0;\n  min-width: 260px;\n  max-height: min(420px, 65vh);\n  display: flex;\n  flex-direction: column;\n  background: $chat-surface;\n  border: 1px solid $chat-border-subtle;\n  border-radius: 12px;\n  box-shadow: 0 12px 28px rgba(16, 24, 40, 0.14);\n  z-index: 50;\n  overflow: hidden;\n\n  &--right {\n    right: 0;\n    left: auto;\n  }\n}\n\n.it-popup-body {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 14px 16px;\n  overflow-y: auto;\n  overscroll-behavior-y: none;\n  flex: 1;\n  min-height: 0;\n}\n\n.it-popup-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 6px 4px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n  color: $chat-text-primary;\n  font-family: $primary-font;\n  font-size: 15px;\n  border-radius: 6px;\n  transition: background-color 0.12s ease;\n\n  &:hover:not(.disabled) {\n    background: $chat-surface-hover;\n  }\n\n  &.disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n\n.it-popup-check {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 4px;\n  border: 1px solid #D0D5DD;\n  background: #F2F4F7;\n  flex-shrink: 0;\n  transition: background-color 0.12s ease, border-color 0.12s ease;\n\n  &--checked {\n    background: $chat-primary;\n    border-color: $chat-primary;\n  }\n}\n\n.it-popup-label {\n  line-height: 1.4;\n  flex: 1;\n  min-width: 0;\n}\n\n.it-popup-coming-soon {\n  flex-shrink: 0;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n  color: $chat-text-muted;\n  background: $chat-surface-hover;\n  border: 1px solid $chat-border-subtle;\n  border-radius: 4px;\n  padding: 2px 5px;\n  line-height: 1.4;\n}\n\n.it-popup-divider {\n  height: 1px;\n  background: rgba(0, 0, 0, 0.1);\n  margin: 6px -16px;\n  border: 0;\n  flex-shrink: 0;\n}\n\n.it-popup-footer {\n  display: flex;\n  border-top: 1px solid $chat-border-subtle;\n}\n\n.it-popup-footer-btn {\n  flex: 1;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  font-family: $primary-font;\n  font-size: 15px;\n  height: 52px;\n  transition: background-color 0.12s ease;\n\n  &:hover {\n    background: $chat-surface-hover;\n  }\n\n  &--cancel {\n    color: $chat-text-primary;\n    border-right: 1px solid $chat-border-subtle;\n  }\n\n  &--done {\n    color: $chat-primary;\n    font-weight: 600;\n  }\n}\n\n// ── Chips strip (appears above controls row when selections are active) ────────\n.uib-chips-strip {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 6px;\n  padding: 0 4px 8px;\n  overflow-x: auto;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar { display: none; }\n\n  .it-group-pill {\n    max-width: none;\n    flex-shrink: 0;\n  }\n}\n\n@media (max-width: 479.98px) {\n  .it-btn { padding: 6px 8px; font-size: 13px; }\n  .it-popup { min-width: 240px; max-height: 250px; }\n}\n\n// At very small viewports (≤360px) the \"Auto (All sources)\" pill label\n// collapses to just the dot indicator so the toolbar doesn't overflow.\n@media (max-width: 360px) {\n  .it-group-pill-label { display: none; }\n  .it-group-pill {\n    max-width: 56px;\n    padding: 2px 4px;\n  }\n  // Shorten button text labels too\n  .it-btn { gap: 4px; font-size: 12px; padding: 5px 6px; }\n}\n","@use \"../../../../../utils/variables\" as *;\n// ============================================================================\n// Unified chat — input bar\n// ============================================================================\n\n.unified-input-bar {\n  width: 100%;\n  font-family: $primary-font;\n\n  &.uib-disabled .uib-card {\n    opacity: 0.85;\n  }\n}\n\n.uib-card {\n  background: $chat-surface;\n  border: 1px solid $chat-border-subtle;\n  border-radius: $chat-input-radius;\n  box-shadow: $chat-input-shadow;\n  padding: 16px 18px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.uib-textarea {\n  width: 100%;\n  border: none;\n  outline: none;\n  resize: none;\n  font-size: 15px;\n  color: $chat-text-primary;\n  line-height: 1.5;\n  background: transparent;\n  padding: 4px 2px;\n  font-family: inherit;\n\n  &::placeholder {\n    color: $chat-text-muted;\n  }\n}\n\n// ── Controls row (below textarea) ─────────────────────────────────────────────\n.uib-controls {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.uib-controls-left {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  flex: 1;\n}\n\n.uib-controls-right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.uib-attach-btn {\n  width: 34px;\n  height: 34px;\n  border: 1px solid #BABABA;\n  background: #FFFFFF;\n  border-radius: 50%;\n  color: #000000;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  padding: 0;\n  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n\n  &:hover:not(:disabled) {\n    background: #F9FAFB;\n    border-color: #9AA0A6;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n\n.uib-send-btn {\n  width: 34px;\n  height: 34px;\n  border: none;\n  background: $chat-text-primary;\n  color: #FFFFFF;\n  border-radius: 50%;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  padding: 0;\n  transition: background-color 0.15s ease;\n\n  svg { transform: translate(1px, -1px); }\n\n  &:hover:not(:disabled) { background: #000; }\n\n  &:disabled {\n    background: #C9CCD1;\n    color: #FFFFFF;\n    cursor: not-allowed;\n  }\n\n  &--stop {\n    background: $chat-text-primary;\n    color: #FFFFFF;\n    cursor: pointer;\n\n    svg { transform: none; }\n\n    &:hover { background: #000; }\n  }\n}\n\n// Char count — hidden by default; the component opts in by setting the\n// `--visible` modifier once the user crosses the soft threshold (~80 % of\n// MAX_CHARS). Two-stage colouring escalates as they approach the hard cap.\n.uib-char-count {\n  display: none;\n\n  &--visible {\n    display: inline-block;\n    margin-right: 8px;\n    font-size: 12px;\n    font-variant-numeric: tabular-nums;\n    color: $chat-text-muted;\n  }\n\n  &--warning { color: #B07A00; }\n  &--danger  { color: #C22; font-weight: 600; }\n}\n\n.uib-disclaimer {\n  text-align: center;\n  font-size: 12px;\n  color: $chat-text-muted;\n  padding: 10px 0 0;\n}\n\n// ── Attachment tiles ──────────────────────────────────────────────────────────\n.uib-attachment-list {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 10px;\n  padding: 2px 0;\n  overflow-x: auto;\n  overflow-y: hidden;\n  scrollbar-width: thin;\n  scrollbar-color: #E5E7EB transparent;\n\n  &::-webkit-scrollbar { height: 6px; }\n  &::-webkit-scrollbar-track { background: transparent; }\n  &::-webkit-scrollbar-thumb {\n    background: #E5E7EB;\n    border-radius: 3px;\n  }\n}\n\n.uib-att-tile {\n  position: relative;\n  width: 72px;\n  height: 72px;\n  flex: 0 0 72px;\n  border-radius: 12px;\n  background: #F3F4F6;\n  border: 1px solid $chat-border-subtle;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &--image {\n    background: #E5E7EB;\n  }\n}\n\n// Filename label — hidden on desktop (title tooltip is enough), visible on touch\n.uib-att-name {\n  display: none;\n}\n\n.uib-att-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.uib-att-file-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n}\n\n.uib-att-remove {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(17, 24, 39, 0.75);\n  color: #FFFFFF;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n  transition: background-color 0.15s ease;\n\n  &:hover { background: rgba(17, 24, 39, 0.95); }\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: 1px;\n  }\n}\n\n// Responsive\n@media (max-width: 767.98px) {\n  // Show filename below file icon on touch devices where title tooltips don't work\n  .uib-att-tile:not(.uib-att-tile--image) {\n    height: 88px;\n    flex-direction: column;\n    justify-content: center;\n    gap: 2px;\n    padding: 6px 4px 4px;\n  }\n\n  .uib-att-name {\n    display: block;\n    font-size: 9px;\n    line-height: 1.2;\n    color: $chat-text-secondary;\n    text-align: center;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    word-break: break-all;\n    max-width: 100%;\n    padding: 0 2px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .uib-card {\n    padding: 12px 14px 10px;\n    border-radius: 14px;\n  }\n  .uib-textarea { font-size: 14px; }\n  .uib-attach-btn,\n  .uib-send-btn { width: 32px; height: 32px; }\n  .uib-att-tile:not(.uib-att-tile--image) { width: 64px; flex-basis: 64px; }\n  .uib-att-tile--image { width: 64px; height: 64px; flex-basis: 64px; }\n  .uib-att-file-icon { width: 38px; height: 38px; }\n}\n","@use './components/chatsidebar/unifiedsidebar';\n@use './components/chatsidebar/chatsearchmodal';\n@use './components/chatsidebar/sourcespanel';\n@use './components/chatfeed/unifiedfeed';\n@use './components/chatfeed/components/usermessage';\n@use './components/chatfeed/components/thoughtprocess';\n@use './components/chatfeed/components/airesponse';\n@use './components/chatfeed/components/referencechips';\n@use './components/chatfeed/components/filedownloadchips';\n@use './components/chatfeed/components/inputtoolbar';\n@use './components/chatfeed/components/unifiedinput';\n@use \"../../utils/variables\" as *;\n\n// ── Unified chat layout ──────────────────────────────────────────────────────\n.unified-chat-wrap {\n  height: calc(100vh - 64px); // below the top nav\n  overflow: hidden;\n  background: $chat-page-bg;\n  position: relative;\n\n  @media (max-width: 767.98px) {\n    height: calc(100vh - 56px);\n  }\n}\n\n.unified-chat-layout {\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n}\n\n.unified-main-pane {\n  flex: 1;\n  min-width: 0;\n  background: $chat-bg;   // white — main feed area\n  overflow: hidden;\n  display: flex;\n}\n\n// Mobile hamburger (rendered inside unified-main-pane on small screens)\n.unified-chat-hamburger {\n  display: none;\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  z-index: 20;\n  width: 40px;\n  height: 40px;\n  border: none;\n  background: $chat-surface;\n  border-radius: 8px;\n  color: $chat-text-primary;\n  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);\n  cursor: pointer;\n  align-items: center;\n  justify-content: center;\n\n  @media (max-width: 991.98px) {\n    display: inline-flex;\n  }\n}\n\n.unified-chat-backdrop {\n  display: none;\n  position: fixed;\n  top: 64px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.35);\n  z-index: 40;\n\n  @media (max-width: 991.98px) {\n    &.is-open { display: block; }\n  }\n\n  @media (max-width: 767.98px) {\n    top: 56px;\n  }\n}\n\n// ============================================================================\n// Legacy /chatai styles — untouched below\n// ============================================================================\n.chat-section-whole-wrap {\n    height: calc(100vh - 122px);\n    background: #f3f5f7;\n    padding: 22px 0;\n}\n\n.chat-sidebar-box { padding: 0; }\n\n.chat-feed {\n    padding: 0;\n    border-left: 1px solid #E9E9E9;\n    flex: 1;\n}\n\n.chat-sidebar {\n    width: 317px;\n    padding: 0 24px 20px;\n    background-color: #fff;\n    border-radius: 20px 0 0 20px;\n}\n\n.chat-results-scroll { max-height: 70vh; }\n.chat-results-show-box { padding-bottom: 20px; }\n.chat-height-control { height: 100%; }\n\n.newchat-center-fix {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    .chat-textarea-wrap {\n        position: inherit;\n        padding-top: 80px;\n        @media (max-height:730px) { padding-top: 60px; }\n    }\n    .chat-height-control { height: auto; }\n}\n\n@media (max-width: 1200px) {\n    .chat-sidebar {\n        width: 270px;\n        padding: 0 10px 20px;\n    }\n}\n@media (min-width: 992px) {\n    .mobil-header { display: none !important; }\n    .mobile-menu-view-button { display: none; }\n}\n\n@media (max-width: 991px) {\n    .chat-sidebar { width: auto; }\n    .mobil-header {\n        display: flex;\n        padding: 6px 20px;\n        background: $primary-color;\n        border-radius: 20px 20px 0 0;\n    }\n    .mobil-menu-slide {\n        height: 100%;\n        left: 0;\n        position: fixed;\n        top: 0;\n        -webkit-transform: translateX(100%);\n        transform: translateX(100%);\n        visibility: hidden;\n        width: 100%;\n        z-index: 99;\n        transition: all 0.4s;\n    }\n    .ai-mobilemenu-active {\n        transform: translateX(0);\n        visibility: visible;\n        background: #fff;\n        z-index: 2000;\n    }\n    .mobil-menu-slide .sidebar-header { display: none; }\n    .mobile-menu-close-button {\n        z-index: 2001;\n        position: fixed;\n        right: 20px;\n        top: 14px;\n        cursor: pointer;\n    }\n    .mobile-menu-view-button svg,\n    .mobile-menu-close-button svg { width: 30px; height: 30px; }\n    .mobile-menu-view-button { cursor: pointer; }\n    .mobile-menu-view-button svg path { fill: #fff; }\n    .mobile-chat-logo h3 {\n        font-size: 16px;\n        font-weight: 500;\n        color: #fff;\n        margin: 0;\n    }\n    .mobile-chat-logo .poweredby-text { font-size: 12px; color: #fff; }\n    .chat-sidebar-box { padding: 0; }\n    .mobile-menu-view-button .mob-close-btn { display: none; }\n    .mobile-menu-close-button .mob-open-btn { display: none; }\n    .mobile-menu-close-button .mob-close-btn { display: block; }\n    .mob-close-btn {\n        font-size: 44px;\n        line-height: 30px;\n        color: #000;\n        font-weight: 300;\n    }\n}\n\n@media (max-width: 767px) {\n    .chat-feed {\n        flex: inherit;\n        width: 100%;\n        padding-bottom: 0;\n        border: none;\n    }\n    .newchat-center-fix .chat-textarea-wrap { position: fixed; }\n    .chat-section-whole-wrap {\n        height: auto;\n        padding-bottom: 0;\n        min-height: calc(100vh - 150px);\n        padding-top: 5px;\n    }\n    .newchat-center-fix .chat-textarea-wrap { padding-top: 50px; }\n}\n",".infinite-scroll-component  {\n    min-height:200px;\n}",".chat-feed-wrap {\n    background-color: #fff;\n    padding: 25px 10px 34px;\n    border-radius:0 20px 20px 0;\n    @media(max-width:991px){\n        border-radius:0 0 20px 20px; \n    }\n}\n.feed-tiles-wrap {\n    max-width: 700px;\n    margin: 0 auto;\n}\n.chat-beta-text {\n    color: #1a73e8;\n    font-size: 10px;\n    font-weight: 600;\n    letter-spacing: -0.2px;\n    border-radius: 2px;\n    background: rgba(26, 115, 232, 0.2);\n    display: block;\n    margin-left: 8px;\n    padding: 1px 3px;\n}\n.chat-header-inline h4 {\n    margin: 0;\n    color: #000;\n    font-size: 22px;\n    font-weight: 600;\n    letter-spacing: -0.44px;\n}\n.chat-header-inline {\n    margin-bottom: 9px;\n}\n.chat-feed-header p {\n    color: rgba(37, 37, 37, 0.80);\n    font-size: 14px;\n    font-weight: 400;\n    line-height: normal;\n    text-transform: capitalize;\n    margin-bottom: 0;\n}\n.chat-feed-header {\n    margin-bottom: 50px;\n}\n.feed-whole-box{\n    max-width: 870px;\n    margin-left: auto;\n    margin-right: auto;\n}\n@media(max-height: 900px){\n    .chat-feed-header {\n        margin-bottom: 35px;\n    }\n    .chat-feed-wrap {\n        padding: 20px 10px;\n    }\n}\n@media(max-height: 760px){ \n    .chat-feed-header {\n        margin-bottom: 25px;\n    }\n    .chat-header-inline {\n        margin-bottom: 5px;\n    }\n    .chat-feed-wrap {\n        padding: 20px 10px;\n    }\n}\n@media (max-width:767px){\n    .chat-feed-wrap {\n        padding: 10px 0px;\n    }\n    .cs-message-list__scroll-wrapper {\n        padding-right: 0.8em;\n    }\n    .feed-tiles-wrap {\n        padding-bottom: 0px;\n        height: 100%;\n    }\n}","@use \"../../../../../utils/variables\" as *;\n#scrollableDiv {\n    height: calc(100vh - 400px);\n    overflow-y: auto;\n    margin-right: -19px;\n    margin-left: -8px;\n\n    .infinite-scroll-component__outerdiv {\n        padding-right: 7px;\n    }\n\n    @media(max-width: 767px) {\n        height: calc(100vh - 280px);\n    }\n}\n\n.previous-chat-boxes {\n    &::-webkit-scrollbar {\n        width: 8px;\n    }\n\n    &::-webkit-scrollbar-track {\n        -webkit-box-shadow: inset 0 0 6px #fff;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background-color: #cfd7e1;\n        outline: none;\n        border-radius: 10px;\n        cursor: all-scroll;\n    }\n\n    margin-right: 0;\n}\n\n.previous-chat-box {\n    padding-top: 30px;\n    margin-bottom: 20px;\n    border-top: 1px solid #d9d9d9;\n    padding-right: 0;\n    padding-left: 8px;\n\n    h3 {\n        color: #5b5b5b;\n        font-size: 15px;\n        font-weight: 600;\n        letter-spacing: -0.3px;\n    }\n\n    &:first-child {\n        border-top: none;\n        padding-top: 0;\n    }\n\n    @media(max-height: 900px) {\n        padding-bottom: 30px;\n        margin-bottom: 30px;\n    }\n\n    @media(max-height: 800px) {\n        padding-bottom: 20px;\n        margin-bottom: 20px;\n    }\n\n    @media(max-height: 760px) {\n        padding-bottom: 15px;\n        margin-bottom: 15px;\n    }\n}\n\n.side-query-row {\n    padding: 2px 0 0 8px;\n    background-color: transparent;\n    border-radius: 6px;\n    position: relative;\n    left: -8px;\n\n    &:hover {\n        background-color: #f3f5f7;\n        transition: all ease 0.5s;\n        .side-query-more {\n            opacity: 1;\n        }\n    }\n}\n\n.side-query-text {\n    display: flex;\n    align-items: center;\n    flex: 1;\n\n    @media(max-height: 900px) {\n        font-size: 13px;\n        line-height: 26px;\n    }\n}\n.side-query-row:hover {\n    .side-query-text-content {\n        &::after {\n            display: none;\n        }\n    }\n}\n.side-query-text-content {\n    color: #828a92;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 32px;\n    white-space: nowrap;\n    overflow: hidden;\n    position: relative;\n    flex: 1;\n    max-width: 230px;\n    &::after {\n        position: absolute;\n        width: 40px;\n        height: 20px;\n        content: \"\";\n        position: absolute;\n        right: 0;\n        top: 7px;\n        background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 50%, rgba(255, 255, 255, 1) 100%);\n        \n    }\n}\n\n.side-query-icon {\n    width: 30px;\n}\n\n.side-query-more {\n    position: absolute;\n    right:3px;\n    bottom: 0;\n    top: 0;\n    display: flex;\n    opacity: 0;\n    align-items: center;\n    padding-left: 8px;\n    background-color: #f3f5f7;\n    z-index: 100;\n    @media(max-width:991px){\n        opacity: 1;\n        background-color: transparent;\n    }\n    .chat-more-dpdn {\n        width: 20px;\n        min-width: 0;\n        padding: 0;\n        background: transparent;\n        text-align: center;\n        height: auto;\n\n        &:active {\n            background-color: transparent;\n            border: none;\n        }\n\n        &:hover {\n            svg {\n                rect {\n                    fill-opacity: 1;\n                    transition: all ease 0.5s;\n                }\n            }\n        }\n\n        &.dropdown-toggle::after {\n            display: none;\n        }\n    }\n\n    .dropdown-menu {\n        border: none;\n        box-shadow: 0 0 5px #999;\n        min-width: 0;\n        margin-right: 8px;\n    }\n\n    a.dropdown-item {\n        font-size: 13px;\n    }\n}\n\n.previous-chat-text {\n    color: #5b5b5b;\n    font-size: 13px;\n    font-weight: 400;\n    letter-spacing: -0.26px;\n    margin-bottom: 20px;\n}\n\n.no-history-box {\n    background: #f3f5f7;\n    padding: 20px 12px;\n    border-radius: 10px;\n\n    h3 {\n        font-weight: 600;\n        font-size: 16px;\n        letter-spacing: 0.5px;\n        text-transform: capitalize;\n        margin-bottom: 12px;\n    }\n\n    p {\n        font-size: 13px;\n        color: #5b5b5b;\n        line-height: 22px;\n        margin: 0;\n    }\n}\n\n.chat-side-loader-middle {\n    display: flex;\n    min-height: 120px;\n    align-items: center;\n    justify-content: center;\n}\n\n.query-edit-input {\n    flex: 1;\n\n    .side-query-edit-input {\n        border: 1px solid #ddd;\n        border-radius: 4px;\n        height: 28px;\n        padding: 0 5px;\n        width: 100%;\n        margin-bottom: 2px;\n\n        &:focus,\n        &:focus-visible {\n            border: 1px solid #ddd;\n            outline: none;\n        }\n    }\n}\n\n.query-edit-action-icon {\n    width: 26px;\n    height: 26px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n\n    &:hover {\n        opacity: 0.8;\n    }\n\n    path {\n        fill: $primary-color;\n    }\n\n    svg {\n        width: 18px;\n        height: 18px;\n    }\n}\n\n.query-edit-action-icons {\n    width: fit-content;\n    padding-left: 10px;\n}\n\n.side-query-edit-row {\n    width: 100%;\n}\n\n.previous-chat-scroll {\n    @media(max-height: 800px) {\n        max-height: calc(100vh - 370px);\n    }\n\n    @media(max-height: 760px) {\n        max-height: calc(100vh - 350px);\n    }\n}",".chat-sidebar-logo-box {\n    background-size: cover;\n    margin: 0 -24px 20px;\n     background: transparent !important;\n    padding: 24px;\n    color: #000;\n    border-bottom:1px solid #E9E9E9\n}\n.chat-sidebar-logo-box h3 {\n    font-size: 18px;\n    font-weight: 600;\n    letter-spacing: -0.36px;\n    margin-bottom: 5px;\n}\n.chat-sidebar-search-wrap {\n    margin-top: 24px;\n    margin-bottom: 30px;\n}\n@media (max-height: 800px) {\n    .chat-sidebar-logo-box {\n        margin-bottom: 20px;\n    }\n    .chat-sidebar-search-wrap {\n        margin-top: 20px;\n        margin-bottom: 20px;\n    }\n    .chat-sidebar-logo-box {\n        padding: 18px 24px;\n    }\n}\n@media (max-height: 760px) {\n    .chat-sidebar-logo-box {\n        margin-bottom: 12px;\n    }\n    .chat-sidebar-search-wrap {\n        margin-top: 15px;\n        margin-bottom:15px;\n    }\n    .chat-sidebar-logo-box {\n        padding: 10px 24px;\n    }\n    .chat-sidebar-logo-box h3 {\n        margin-bottom: 0;\n    }\n  \n}\n\n@media (max-width:1200px){\n    .chat-sidebar-logo-box {\n        margin: 0 -10px 20px;\n        padding: 10px;\n    }\n    \n}\n@media (max-width:991px){\n    \n}","@use \"../../../../../utils/variables\" as *;\n.chat-textarea-wrap {\n  position: absolute;\n  bottom: 25px;\n  left: 10px;\n  right: 10px;\n  padding-top: 50px;\n  padding-bottom: 25px;\n  z-index: 1000;\n  background-color: #fff;\n  box-shadow: 0 -14px 13px rgba(255, 255, 255, 0.75);\n\n  @media (min-width:991px) and (max-width:1200px) {\n    left: 18px;\n    right: 23px;\n\n  }\n\n  @media (max-height:800px)  {\n    bottom:6px;\n  }\n}\n\n.chat-textarea-form {\n  background: #FFFFFF;\n  border: 1px solid #DADADA;\n  box-shadow: 0px 20px 40px 5px #EBEEF1;\n  border-radius: 12px;\n  padding: 18px 55px 18px 25px;\n  position: relative;\n\n}\n\n.chat-textarea-wrap .textarea-item {\n  border: none;\n  width: 100%;\n  resize: none;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 24px;\n  background-color: transparent;\n  border: none;\n  margin: 0;\n  padding: 0;\n  max-height: 120px;\n\n  @media(max-height:768px) {\n    max-height: 100px;\n  }\n\n  @media(max-height:750px) {\n    max-height: 70px;\n    font-size: 13px;\n    line-height: 18px;\n  }\n}\n\n.chat-textarea-wrap .textarea-item:focus-visible,\n.chat-textarea-wrap .textarea-item:focus {\n  outline: none !important;\n}\n\n.chat-textarea-wrap .chat-textarea-form-outer {\n  margin: 0 auto;\n  position: relative;\n  max-width: 850px;\n}\n\n.chat-textarea-wrap .send-btn {\n  background-repeat: no-repeat;\n  background-position: center;\n  position: absolute;\n  right: 5px;\n  top: 0px;\n  border: none;\n  text-indent: -9999px;\n  width: 50px;\n  height: 60px;\n  padding: 0;\n  background-color: transparent;\n}\n\n.chat-textarea-wrap .send-btn:disabled {\n  opacity: 0.5;\n}\n\n.chat-select-box select.form-select {\n  height: 24px;\n  font-size: 13px;\n  padding: 0 8px;\n  width: fit-content;\n  font-weight: 500;\n  border: none;\n  background: #fff;\n  cursor: pointer;\n  padding-right: 30px;\n}\n\n.chat-select-box {\n  border-radius: 3px;\n  background: linear-gradient(180deg, #4991ef 0%, #1a73e8 100%);\n  box-shadow: 0px 10px 10px 0px rgba(133, 175, 214, 0.45);\n  padding: 8px 10px;\n  margin-bottom: 0;\n}\n\n.chat-forms-btns-wrap {\n  margin-bottom: 8px;\n}\n\n.select-label-text {\n  margin-right: 10px;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.new-chat-btn {\n  font-weight: 600;\n  font-size: 13px;\n  color: #333;\n  text-decoration: none;\n  background: #FFFFFF;\n  border: 1px solid #DADADA;\n  box-shadow: 0px 8px 20px #EAEAEA;\n  border-radius: 12px;\n  width: 62px;\n  white-space: nowrap;\n  height: 62px;\n  overflow: hidden;\n  text-align: center;\n  align-items: center;\n  padding: 0 10px 0 17px;\n  transition: width 0.3s;\n  display: flex;\n  align-items: center;\n  margin-right: 6px;\n\n  .new-chat-btn-text {\n    opacity: 0;\n  }\n\n  @media (max-width:767px) {\n    width: 52px;\n    padding-left: 12px;\n    height: 52px;\n  }\n\n}\n\n.new-chat-btn:hover {\n  width: 136px;\n\n  @media (max-width:767px) {\n    width: 52px;\n  }\n\n  transition: width 0.3s;\n\n  .new-chat-btn-text {\n    opacity: 1;\n  }\n}\n\n.new-chat-btn:hover span.new-chat-btn-img {\n  rotate: 360deg;\n}\n\nspan.new-chat-btn-img {\n  text-align: center;\n  display: inline-block;\n  margin-right: 10px;\n}\n\n.select-arrow {\n  position: absolute;\n  right: 6px;\n  top: -1px;\n  cursor: pointer;\n  height: 25px;\n  pointer-events: none;\n}\n\n.chat-textarea-form .textarea-item::placeholder {\n  color: rgba(0, 0, 0, 0.5);\n}\n\n.generate-loading span {\n  margin-left: 15px;\n}\n\n.dot-elastic {\n  position: relative;\n  width: 4px;\n  height: 4px;\n  border-radius: 5px;\n  background-color: $primary-color;\n  color: $primary-color;\n  animation: dot-elastic 1s infinite linear;\n  margin-right: 15px;\n}\n\n.dot-elastic::before,\n.dot-elastic::after {\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  top: 0;\n}\n\n.dot-elastic::before {\n  left: -8px;\n  width: 4px;\n  height: 4px;\n  border-radius: 5px;\n  background-color: $primary-color;\n  color: $primary-color;\n  animation: dot-elastic-before 1s infinite linear;\n}\n\n.dot-elastic::after {\n  left: 8px;\n  width: 4px;\n  height: 4px;\n  border-radius: 5px;\n  background-color: $primary-color;\n  color: $primary-color;\n  animation: dot-elastic-after 1s infinite linear;\n}\n\n@keyframes dot-elastic-before {\n  0% {\n    transform: scale(1, 1);\n  }\n\n  25% {\n    transform: scale(1, 1.7);\n  }\n\n  50% {\n    transform: scale(1, 0.67);\n  }\n\n  75% {\n    transform: scale(1, 1);\n  }\n\n  100% {\n    transform: scale(1, 1);\n  }\n}\n\n@keyframes dot-elastic {\n  0% {\n    transform: scale(1, 1);\n  }\n\n  25% {\n    transform: scale(1, 1);\n  }\n\n  50% {\n    transform: scale(1, 1.7);\n  }\n\n  75% {\n    transform: scale(1, 1);\n  }\n\n  100% {\n    transform: scale(1, 1);\n  }\n}\n\n@keyframes dot-elastic-after {\n  0% {\n    transform: scale(1, 1);\n  }\n\n  25% {\n    transform: scale(1, 1);\n  }\n\n  50% {\n    transform: scale(1, 0.67);\n  }\n\n  75% {\n    transform: scale(1, 1.7);\n  }\n\n  100% {\n    transform: scale(1, 1);\n  }\n}\n\n// .generate-loading {\n//   position: absolute;\n//   right: 0px;\n//   top: -40px;\n//   color: #000;\n//   font-weight: 500;\n//   margin-right: 0px;\n//   background: #def;\n//   padding: 5px 20px;\n//   border-radius: 6px;\n//   border: 1px solid #9cbcdc;\n// }\n\n.generate-loading-anim {\n  animation-duration: 2.2s;\n  animation-fill-mode: forwards;\n  animation-iteration-count: infinite;\n  animation-name: shimmer;\n  animation-timing-function: linear;\n  background: #f1f6fc;\n  background: linear-gradient(to right,\n      #ecf1f8 8%,\n      #f9fcff 18%,\n      #eff6ff 33%);\n  background-size: 1200px 100%;\n}\n\n.text-length-show {\n  height: auto;\n  line-height: 24px;\n  padding-left: 10px;\n  min-width: 82px;\n  text-align: right;\n}\n\n.generate-loading.generate-more-btn span {\n  margin-left: 0;\n}\n\n.generate-more-btn {\n  cursor: pointer;\n  background-color: #dbe3ea;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.generate-more-btn:hover {\n  background-color: #e7eef4;\n\n}\n\n.generate-more-btn svg {\n  width: 14px;\n  height: 14px;\n  position: relative;\n  top: -1px;\n  margin-right: 7px;\n\n  path {\n    fill: $primary-color;\n  }\n}\n\n\n\n@-webkit-keyframes shimmer {\n  0% {\n    background-position: -100% 0;\n  }\n\n  100% {\n    background-position: 100% 0;\n  }\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: -1200px 0;\n  }\n\n  100% {\n    background-position: 1200px 0;\n  }\n}\n\n@media (max-height: 900px) {\n  .chat-textarea-wrap {\n    padding-bottom: 30px;\n    box-shadow: 0 -12px 13px rgba(255, 255, 255, 0.75);\n  }\n\n}\n\n@media (max-height: 760px) {\n  .chat-textarea-wrap .send-btn {\n    top: 0px;\n  }\n\n}\n\n@media (max-width: 767px) {\n  .chat-textarea-wrap {\n    position: fixed;\n    left: 0;\n    right: 0;\n    padding: 5px 10px;\n    /* border-top: 1px solid #ddd; */\n    box-shadow: 0 0 6px rgba(92, 107, 122, 0.7);\n    background-color: #dce2e9;\n  }\n\n  .chat-textarea-form {\n    padding: 15px 40px 15px 10px;\n  }\n\n  .chat-textarea-wrap .textarea-item {\n    max-height: 80px;\n    line-height: 20px;\n  }\n\n  .chat-textarea-wrap .send-btn {\n    width: 24px;\n    height: 24px;\n    top: 12px;\n  }\n\n  .generate-loading {\n    position: absolute;\n    right: 0px;\n    bottom: 83px;\n    height: 30px;\n    top: inherit;\n    padding-left: 12px;\n    padding-right: 3px;\n    border-radius: 7px;\n  }\n\n  .generate-loading span {\n    font-size: 11px;\n  }\n\n  .chat-forms-btns-wrap {\n    flex-wrap: wrap;\n  }\n\n  .chat-select-box {\n    width: 100%;\n  }\n\n  .chat-textarea-new-chat-wrap {\n    margin-bottom: 5px;\n  }\n\n  .chat-select-box {\n    padding: 4px 8px;\n  }\n\n  .new-chat-btn-text {\n    display: none;\n  }\n\n  .cht-select-box-form {\n    flex: 1;\n  }\n\n  .chat-select-box select.form-select {\n    width: 100%;\n  }\n\n  .text-length-show {\n    line-height: 20px;\n  }\n}\n\n\n\n.generate-loading {\n  border: 1px solid #1A73E8;\n  border-radius: 50px;\n  width: max-content;\n  text-align: center;\n  padding: 6px 15px;\n  position: absolute;\n  left: 0;\n  top: -45px;\n  color: rgba(26, 115, 232, 1);\n  font-weight: 600;\n  font-weight: 13px;\n\n  &.generate-more-btn {\n    background: #EFF6FF;\n  }\n\n  &.generate-more-seperate {\n    background: #fff;\n    border: 1px solid #D8D8D8;\n    border-radius: 7px;\n  }\n\n  &.generate-more-seperate-loading {\n    border: 1px solid #D8D8D8;\n    border-radius: 7px;\n  }\n\n  span {\n    margin: 0;\n  }\n}\n\n.textarea-form-wrap {\n  flex: 1;\n}\n\n.upload-clip-btn {\n  margin-right: 10px;\n}\n\n.info-text-chat-textarea {\n  position: absolute;\n  left: 0;\n  right: 0;\n  z-index: 99;\n  text-align: center;\n  font-size: 13px;\n  padding-top: 14px;\n  color: #656b73;\n  @media(max-width:575px) {\n    padding-top: 9px; \n    font-size: 10px;\n  }\n  @media(max-height:800px) {\n    padding-top: 7px; \n   }\n}","@use \"../../../../../utils/variables\" as *;\n// .feed-tiles-row {\n//     margin: 0 -10px;\n// }\n// .feed-tiles-box {\n//     padding: 0 10px;\n//     width: 50%;\n// }\n// .tile-sample-item {\n//     background: #f3f5f7;\n//     padding: 15px 20px;\n//     margin-top: 13px;\n//     text-align: center;\n//     height: 98px;\n//     display: flex;\n//     align-items: center;\n//     justify-content: center;\n// }\n// .feed-tile-box-header {\n//     text-align: center;\n// }\n// .feed-tile-box-header h4 {\n//     color: #000;\n//     font-size: 15px;\n//     font-weight: 500;\n//     letter-spacing: -0.3px;\n//     margin: 0;\n//     margin-top: 5px;\n// }\n// .tile-sample-item p {\n//     margin: 0;\n//     max-width: 220px;\n// }\n// .feed-tiles-infobox {\n//     margin-top: 37px;\n// }\n// .feed-tiles-infobox p {\n//     margin: 0 auto;\n//     line-height: 20px;\n//     max-width: 77%;\n// }\n// .feed-tiles-infobox p a {\n//     font-weight: 600;\n//     text-decoration: none;\n// }\n// .feedback-link {\n//     color: $primary-color;\n//     cursor: pointer;\n// }\n// @media (max-width: 1366px) {\n//     .tile-sample-item p {\n//        font-size: 13px;\n//     }\n// }\n// @media (max-height: 900px) {\n//     .tile-sample-item {\n//         padding: 12px 15px;\n//         height: 90px;\n//     }\n//     .tile-sample-item p {\n//         max-width: 250px;\n//     }\n//     .feed-tiles-infobox {\n//         margin-top: 20px;\n//     }\n// }\n// @media (max-height: 760px) {\n//     .tile-sample-item {\n//         padding: 6px 12px;\n//         height: 70px;\n//         margin-top: 8px;\n//     }\n// }\n// @media (max-width: 767px) {\n//     .feed-tiles-row {\n//         flex-wrap: wrap;\n//         width: 100%;\n//         flex: 1;\n//         margin: 10px 0;\n//         display: block !important;\n//     }\n//     .feed-tiles-box {\n//         margin-bottom: 30px;\n//     }\n//     .feed-tiles-box {\n//         width: 100%;\n//     }\n// }\n\n.personality-slider-wrap {\n    width: calc(100vw - 400px);\n    max-width: 100%;\n    overflow: hidden;\n    @media (max-width:1200px) {\n        width: calc(100vw - 340px);\n    }\n    @media (max-width:991px) {\n        width: calc(100vw - 70px);\n    }\n    @media (max-width:575px) {\n        width: calc(100vw - 30px);\n    }\n    .slider-item {\n        padding: 2px 10px;\n        &.active {\n            .personality-item-box {\n                border: 1px solid rgba(26, 115, 232, 1);\n                box-shadow: 0 0 0 2px rgba(26, 115, 232, 1), 0 1px 2px rgba(26, 115, 232, 0.3);;\n            }    \n        }\n    }\n}\n\n.personality-item-box {\n    border: 1px solid #D5D8DC;\n    border-radius: 15px;\n    padding: 20px 15px 15px 15px;\n    height: 100%;\n    @media (max-height:770px) {\n        padding: 12px 10px 10px 12px;\n    }\n    h3 {\n        font-size: 15px;\n        font-weight: 600;\n        letter-spacing: -2%;\n        line-height: 19px;\n        margin-bottom: 6px;\n    }\n\n    p {\n        color: rgba(37, 37, 37, 0.8);\n        line-height: 22px;\n        margin: 0;\n        @media (max-height:770px) {\n            line-height: 20px;\n        }\n        @media (max-height:730px) {\n         font-size: 12px;\n        }\n    }\n}\n\n.personality-slider-wrap .slick-list,\n.personality-slider-wrap .slick-track,\n.personality-slider-wrap .slider-item {\n    display: flex;\n    align-items: stretch;\n}\n\n.personality-slider-wrap .slick-slide>div,\n.personality-slider-wrap .slider-item {\n    height: 100%;\n}\n\n.pers-slider-icon {\n    width: 70px;\n    height: 70px;\n    border: 1px solid #D0D0D0;\n    border-radius: 8px;\n    margin-bottom: 15px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    @media (max-height:770px) {\n        width: 50px;\n        height: 50px;\n    }\n    \n}\n\n.personality-slider {\n    .pers-slick-next-wrap {\n        right: -12px;\n        width: 36px;\n        height: 36px;\n        line-height: 36px;\n        text-align: center;\n        border: transparent;\n        box-shadow: 0px 4px 50px 5px rgba(198, 198, 198, 0.32);\n        border-radius: 50%;\n        background-color: $primary-color;\n        z-index: 9;\n        \n\n        &::before {\n            display: none;\n        }\n        &.slick-disabled {\n            opacity: 0;\n        }\n    }\n    .pers-slick-prev-wrap {\n        left: -12px;\n        width: 36px;\n        height: 36px;\n        line-height:36px;\n        text-align: center;\n        border: 1px solid transparent;\n        box-shadow: 0px 4px 50px 5px rgba(198, 198, 198, 0.32);\n        border-radius: 50%;\n        background-color: $primary-color;\n        z-index: 9;\n\n        &::before {\n            display: none;\n        }\n        &.slick-disabled {\n            opacity: 0;\n        }\n    }\n}\n.personality-slider-container {\n    margin: 0 auto;\n    max-width: 1090px;\n    padding: 0 17px;\n}\n.pers-slider-title {\n    font-size: 20px;\n    margin-bottom: 18px;\n    line-height: 24px;\n    font-weight: 600;\n    padding-left: 10px;\n}\n.personality-scrollbar {\n    max-height:500px;\n    \n}","@use \"../../../../../../utils/variables\" as *;\n.chatbot-message-list .cs-message--outgoing {\n    justify-content: normal;\n}\n\n.chatbot-message-list .cs-message-list__scroll-wrapper>.cs-message,\n.cs-message-list__scroll-wrapper>.cs-message-group {\n    max-width: 100%;\n}\n\n.chatbot-message-list .cs-message__content-wrapper {\n    width: 100%;\n}\n\n.chatbot-message-list .query-input-wrap {\n    border-radius: 5px;\n    background: #def;\n    padding: 13px;\n    margin-bottom: 13px;\n}\n\n.chatbot-message-list .cs-message--outgoing .cs-message__content {\n    background-color: transparent;\n    border-radius: 0;\n    padding: 0;\n}\n\n.cs-chat-container {\n    height: calc(100% - 100px);\n    padding-bottom: 0px;\n}\n\n.query-input-message p {\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 22px;\n}\n\n.chatbot-message-list,\n.chatbot-message-list * {\n    font-family: $primary-font;\n}\n\n.query-input-message {\n    flex: 1;\n    padding-left: 15px;\n    min-height: 42px;\n    display: flex;\n    align-items: center;\n}\n\n.query-output-message-flex-wrap {\n    display: flex;\n    align-items: center;\n    min-height: 42px;\n}\n\n.query-output-box {\n    width: 100%;\n}\n\n.query-output-box .styledlink a {\n    width: 14px;\n    height: 14px;\n    background: rgb(206, 228, 251);\n    border-radius: 2px;\n    overflow: hidden;\n    text-decoration: none;\n    color: $primary-color;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 10px;\n    font-weight: 600;\n    line-height: 11px;\n    padding-top: 2px;\n    position: relative;\n    top: -4px;\n    margin-right: 2px;\n\n    @media(max-width:575px) {\n        top: -3px;\n        font-size: 9px;\n        width: 12px;\n        height: 12px;\n    }\n\n    &:hover {\n        background-color: $primary-color;\n        color: #fff;\n    }\n}\n\n.query-output-message p {\n    font-size: 13px;\n    line-height: 24px;\n    margin-bottom: 15px;\n}\n\n.query-output-paragraph-wrap {\n    min-height: 70px;\n\n}\n\n.query-output-wrap {\n    border-radius: 5px;\n    background: #fff;\n    padding: 28px 22px;\n    margin-bottom: 13px;\n    border: 1px solid #E9E9E9;\n\n    @media(max-width:575px) {\n        padding: 14px 10px;\n    }\n}\n\n.query-output-message {\n    flex: 1;\n    padding-left: 15px;\n}\n\n.query-output-action-icons {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    padding: 4px 10px 0 20px;\n}\n\n.query-action-icon {\n    margin-bottom: 14px;\n    cursor: pointer;\n    // transition: all ease 0.5s;\n}\n\n.query-action-icon:hover svg path {\n    fill: $primary-color;\n}\n\n// *****chat scrollbar move to outside whitebox*****\n.cs-chat-container,\n.cs-message-list {\n    background-color: transparent;\n}\n\n// *****chat scrollbar move to outside whitebox*****\n\n.cs-message-list .cs-message-list__typing-indicator-container {\n    background-color: transparent;\n    padding: 0;\n    font-size: 15px;\n    height: 30px;\n    line-height: normal;\n    left: 0px;\n    bottom: 13px;\n    position: absolute;\n    right: 0;\n    z-index: 2000;\n}\n\n.cs-message-list .typeindi-wrap {\n    margin: 0 auto;\n    position: relative;\n    max-width: 700px;\n    text-align: right;\n    display: flex;\n    justify-content: end;\n    padding: 5px 0;\n}\n\n.cs-message-list .cs-typing-indicator {\n    background-color: #fff;\n    border-radius: 4px;\n    position: inherit;\n}\n\n.cs-typing-indicator__dot {\n    background-color: rgba(26, 115, 232, 0.5);\n}\n\n.cs-typing-indicator__text {\n    color: rgba(26, 115, 232, 0.5);\n    font-weight: 500;\n}\n\n.chat-section-whole-wrap .react-tooltip {\n    padding: 5px 10px;\n    font-size: 12px;\n    z-index: 2001;\n    background: $primary-color !important;\n    color: #fff !important;\n    border-radius: 6px;\n}\n\n.cs-chat-container {\n    margin-right: -6px;\n}\n\n.cs-message {\n    padding-right: 0;\n}\n\n@media (max-height: 900px) {\n    .chatbot-message-list .query-input-wrap {\n        padding: 7px 10px;\n        margin-bottom: 10px;\n    }\n}\n\n@media (max-height: 760px) {\n    .query-output-wrap {\n        padding: 7px 10px;\n        margin-bottom: 10px;\n    }\n}\n\n@media (max-width: 767px) {\n    .cs-chat-container {\n        margin-right: 0;\n    }\n\n    .cs-message {\n        padding-right: 0;\n    }\n\n    .query-bot-logo img {\n        max-width: 30px;\n    }\n\n    .query-output-message {\n        padding-left: 10px;\n    }\n\n    .cs-chat-container {\n        height: calc(100vh - 360px);\n    }\n\n    .query-output-message p {\n        line-height: 20px;\n        min-height: 60px;\n    }\n\n    .query-action-icon {\n        margin-bottom: 8px;\n    }\n\n    .query-input-message {\n        padding-left: 0;\n        min-height: 30px;\n    }\n\n    .cs-message-list__scroll-wrapper>.cs-message:nth-last-child(4) {\n        margin-bottom: 0;\n    }\n\n    .custom-content-wrap {\n        height: calc(100vh - 370px);\n        overflow-y: scroll;\n    }\n\n    .query-input-message p {\n        line-height: 20px;\n    }\n\n    .chatbot-message-list .query-input-wrap {\n        margin-bottom: 6px;\n    }\n\n    .query-output-wrap {\n        margin-bottom: 6px;\n    }\n}\n\n\n\n\n.formatingParagraph {\n    white-space: normal;\n    font-size: 13px;\n    line-height: 22px;\n\n    h3 {\n        font-size: 14px;\n        margin-bottom: 6px;\n        font-weight: bold;\n        line-height: 20px;\n\n    }\n    h4 {\n        font-size: 13px;\n        margin-bottom: 6px;\n        font-weight: bold;\n        line-height: 20px;\n\n    }\n\n    p {\n        margin-bottom: 1rem;\n        line-height: 22px;\n        font-size: 13px;\n    }\n\n    ul, ol {\n        margin-bottom: 1rem;\n\n        li {\n            font-size: 13px;\n            line-height: 22px;\n            margin-bottom: 10px;\n        }\n    }\n}","@use \"../../../../../../../utils/variables\" as *;\n.output-image-show-box {\n    margin: 12px -6px 0;\n}\n.output-img-item {\n    padding: 6px;\n}\n.output-img-item img {\n    border-radius: 10px;\n    width: 251px;\n    height: 200px;\n    object-fit: cover;\n    height: 200px;\n    object-position: center;\n}\n.download-icon {\n    position: absolute;\n    right: 20px;\n    top: 20px;\n    cursor: pointer;\n}\n.download-icon:hover {\n    opacity: 0.8;\n    transition: all ease 0.5s;\n}\n.download-icon img {\n    width: 21px;\n    height: 21px;\n}\n.graph-result-box {\n    background-color: #fff;\n    padding: 12px;\n    border-radius: 6px;\n    margin-top: 15px;\n}\n// .graph-result-box canvas {\n//     max-width: 100% !important;\n//     max-height: 400px !important;\n//     width: 100% !important;\n//     height: 100% !important;\n// }\n.csv-link-btn {\n    background-color: $primary-color;\n    line-height: 30px;\n    padding: 0 10px;\n    color: #fff;\n    text-decoration: none;\n    display: inline-block;\n    border-radius: 3px;\n    font-weight: 500;\n}\n.csv-link-btn:hover {\n    color: #fff;\n    opacity: 0.9;\n}\n@media (max-width: 767px) {\n    .output-img-item {\n        width: 50%;\n    }\n    .output-img-item img {\n        border-radius: 10px;\n        width: 100%;\n        height: auto;\n        object-fit: cover;\n        object-position: center;\n    }\n    .output-image-show-boxes {\n        margin: 0 -45px 0 -40px;\n    }\n    .download-icon {\n        right: 3px;\n        top: inherit;\n        bottom: 3px;\n        background: #1a73e8;\n        border-radius: 50%;\n    }\n    .download-icon svg rect {\n        fill: transparent !important;\n    }\n    .download-icon svg path {\n        fill: #fff;\n    }\n}\n",".output-learnmore-wrap {\n    margin: 30px -45px 0 -58px;\n    display: flex;\n    justify-content: center;\n    border-top: 1px solid #E9E9E9;\n    padding-top: 8px;\n    padding-bottom: 1px;\n    padding-left: 50px;\n    padding-right: 50px;\n}\n.learnmore-child-labels span,\n.learnmore-child-labels a {\n    border-radius: 16px;\n    background: #f3f5f7;\n    padding: 0px 10px;\n    font-size: 13px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 26px;\n    display: inline-flex;\n    height: 30px;\n    align-items: center;\n    cursor: pointer;\n    color: #000;\n    text-decoration: none;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.learnmore-child-labels {\n    padding: 0 5px;\n    margin-top: 6px;\n}\n.learnmore-child {\n    height: 30px;\n    display: inline-flex;\n    align-items: center;\n    font-weight: bold;\n    font-size: 13px;\n    font-style: normal;\n    padding-right: 8px;\n    margin-top: 3px;\n    width: fit-content;\n}\n.output-learnmore-content-list a,\n.view-more-item {\n    border-radius: 16px;\n    background: #f3f5f7;\n    padding: 0px 10px;\n    font-size: 13px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 26px;\n    display: inline-flex;\n    height: 30px;\n    align-items: center;\n    cursor: pointer;\n    color: #000;\n    text-decoration: none;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.view-more-item {\n    border: none;\n}\n.bold-text {\n    font-weight: 600;\n}\n.items-showing-count {\n    position: absolute;\n    right: 0;\n    top: 19px;\n    font-size: 13px;\n}\n.output-learnmore-content {\n    flex: 1;\n    padding-right: 30px;\n}\n.output-learnmore-content ul.output-learnmore-content-list {\n    display: inline-flex;\n    margin: 0 -5px;\n    padding: 0;\n    list-style: none;\n    flex-wrap: wrap;\n}\n.output-learnmore-content-list li {\n    padding: 0 5px;\n    margin: 3px 0;\n}\nbutton.view-more-item {\n    min-width: 40px;\n    text-align: center;\n    display: block;\n    padding: 0px 10px;\n    font-size: 13px;\n    line-height: 26px;\n    height: 30px;\n    align-items: center;\n    cursor: pointer;\n    color: #000;\n    text-decoration: none;\n    border-radius: 16px;\n    background: #fff;\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);\n}\n@media (max-width: 767px) {\n    .output-learnmore-wrap {\n        margin: 30px -46px 0 -39px;\n        padding-left: 10px;\n        padding-right: 10px;\n        flex-direction: column;\n    }\n    .output-learnmore-content-list a,\n    .view-more-item {\n        padding: 0px 8px;\n        font-size: 11px;\n        height: 26px;\n    }\n    button.view-more-item {\n        font-size: 11px;\n        height: 26px;\n    }\n}\n",".output-relatedarticle-wrap {\n    border-radius: 5px;\n    background: #f3f5f7;\n    padding: 13px;\n    margin: 15px 0;\n}\n.output-relatedarticle-wrap h4,\n.output-relatedarticle-wrap h4 a {\n    font-size: 13px;\n    font-style: normal;\n    font-weight: 400;\n    color: #000;\n    text-decoration: none;\n    line-height: 32px;\n}\n.output-relatedarticle-wrap h4 a span {\n    font-weight: 600;\n}\n.rel-article-item {\n    width: 33.3333%;\n    padding: 0 8px;\n    margin-bottom: 20px;\n}\n.rel-article-text,\n.rel-article-text a {\n    color: #000;\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 20px;\n    text-decoration: none;\n}\n.rel-article-text {\n    flex: 1;\n}\n.rel-articles-row {\n    margin: 0 -8px;\n}\n.rel-article-img img {\n    margin-right: 12px;\n}\n.more-article {\n    border-radius: 16px;\n    padding: 0px 10px;\n    font-size: 13px;\n    line-height: 26px;\n    display: inline-flex;\n    height: 30px;\n    align-items: center;\n    cursor: pointer;\n    color: #000;\n    text-decoration: none;\n    border-radius: 16px;\n    background: #FFF;\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);\n}\n.rel-article-footer {\n    margin-top: 10px;\n    border-top: 1px solid #bed1ea;\n    padding-top: 13px;\n    padding-bottom: 2px;\n}\n.rel-article-img img {\n    max-width: 70px;\n}\n.ai-relatedarticle-label-wrap {\n    margin-top: 10px;\n}\n.ai-related-article-bubble {\n    background: #E4E4E4;\n    border-radius: 16px;\n    padding: 4px 10px;\n    color: #5b5b5b;\n    font-size: 12px;\n    margin-right: 5px;\n    margin-top: 5px;\n}\n.ai-related-article-bubble:first-child {\n    margin-left: 0;\n}\n.rel-article-text {\n    min-height: min-content;\n}\n\n@media (max-width: 767px) {\n    .output-relatedarticle-wrap h4,\n    .output-relatedarticle-wrap h4 a {\n        line-height: 22px;\n    }\n    .rel-article-item {\n        width: 100%;\n        padding: 0;\n    }\n    .rel-articles-row {\n        margin: 0;\n        flex-wrap: wrap;\n    }\n    .rel-article-footer {\n        margin-top: 0;\n    }\n    .output-relatedarticle-wrap {\n        margin: 7px 0;\n    }\n}\n","// Vega-Lite Chart Component Styles\n.vega-chart-container {\n  // margin: 20px 0;\n  // background: #fff;\n  // border-radius: 8px;\n  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  // overflow: hidden;\n\n  .chart-analysis {\n    // padding: 16px;\n    // background: #f8f9fa;\n    // border-bottom: 1px solid #e9ecef;\n\n    .analysis-title {\n      font-size: 14px;\n      font-weight: 600;\n      color: #495057;\n      margin-bottom: 8px;\n    }\n\n    .analysis-text {\n      font-size: 13px;\n      line-height: 1.5;\n      color: #6c757d;\n      margin: 0;\n    }\n  }\n\n  .chart-wrapper {\n    position: relative;\n    margin-top: 20px;\n    text-align: center;\n\n    .vega-embed {\n      width: 100% !important;\n\n\n    }\n\n    canvas {\n      max-width: 100% !important;\n      @media(max-width:768px){\n        height: auto !important;\n      }\n    }\n\n    .chart-actions {\n      position: absolute;\n      top: 20px;\n      right: 20px;\n      z-index: 10;\n\n      .download-chart-btn {\n        padding: 6px 8px;\n        border-radius: 4px;\n        background: rgba(255, 255, 255, 0.9);\n        border: 1px solid #dee2e6;\n        color: #495057;\n        transition: all 0.2s ease;\n\n        &:hover {\n          background: #fff;\n          border-color: #1a73e8;\n          color: #1a73e8;\n          transform: translateY(-1px);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n        }\n\n        svg {\n          width: 16px;\n          height: 16px;\n        }\n      }\n    }\n  }\n\n  .chart-loading {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 40px 20px;\n    color: #6c757d;\n\n    .spinner-border {\n      width: 2rem;\n      height: 2rem;\n    }\n\n    p {\n      margin: 0;\n      font-size: 14px;\n    }\n  }\n\n  .chart-error {\n    padding: 20px;\n\n    .alert {\n      margin: 0;\n      font-size: 14px;\n    }\n  }\n}\n\n// Responsive adjustments\n@media (max-width: 768px) {\n  .vega-chart-container {\n    margin: 15px -20px;\n    border-radius: 0;\n\n    .chart-wrapper {\n      .chart-actions {\n        top: 16px;\n        right: 16px;\n      }\n    }\n\n    .chart-analysis {\n      padding: 12px;\n    }\n  }\n}\n\n@media (max-width: 576px) {\n  .vega-chart-container {\n    .chart-wrapper {\n      .vega-embed {\n        svg {\n          max-width: 100% !important;\n          height: auto !important;\n        }\n      }\n    }\n\n    .chart-analysis {\n      .analysis-title {\n        font-size: 13px;\n      }\n\n      .analysis-text {\n        font-size: 12px;\n      }\n    }\n  }\n}\n\n// Dark mode support (if needed)\n@media (prefers-color-scheme: dark) {\n  .vega-chart-container {\n    background: #2d3748;\n    color: #e2e8f0;\n\n    .chart-analysis {\n      background: #4a5568;\n      border-bottom-color: #718096;\n\n      .analysis-title {\n        color: #e2e8f0;\n      }\n\n      .analysis-text {\n        color: #cbd5e0;\n      }\n    }\n\n    .chart-wrapper {\n      .chart-actions {\n        .download-chart-btn {\n          background: rgba(45, 55, 72, 0.9);\n          border-color: #718096;\n          color: #e2e8f0;\n\n          &:hover {\n            background: #4a5568;\n            border-color: #1a73e8;\n            color: #1a73e8;\n          }\n        }\n      }\n    }\n\n    .chart-loading {\n      color: #cbd5e0;\n    }\n  }\n}",".dropzone-modal {\n    .modal-lg {\n        --bs-modal-width: 649px;\n    }\n\n    .modal-header {\n        border: none;\n    }\n}\n\n.dropzone-box {\n    background: #F3F5F7;\n    border: 2px dashed #1A73E8;\n    border-radius: 10px;\n    padding: 52px;\n    text-align: center;\n    margin-bottom: 40px;\n\n    h3 {\n        font-size: 17px;\n        font-weight: 600;\n\n        span {\n            color: #1A73E8;\n            text-decoration: underline;\n            margin-bottom: 5px;\n        }\n    }\n\n    p {\n        font-size: 12px;\n        color: rgba(103, 103, 103, 1);\n        margin-bottom: 0;\n        line-height: 18px;\n        margin-top: 5px;\n    }\n\n}\n\n.dpzone-title {\n    text-align: center;\n    padding: 5px 0 15px;\n    font-size: 16px;\n    font-weight: bold;\n    margin-bottom: 0;\n}\n\n.uploaded-item-name-box {\n    background: #FFFFFF;\n    border: 1px solid #11AF22;\n    border-radius: 4px;\n    padding: 9px 11px;\n    margin-bottom: 10px;\n\n    .uploaded-item-nameshow {\n        flex: 1;\n        padding-left: 9px;\n        padding-right: 9px;\n        font-size: 12px;\n        color: rgba(15, 15, 15, 1);\n        line-height: 18px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    .uploaded-item-delete {\n        background: #FFF3F3;\n        width: 16px;\n        height: 16px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 50%;\n        cursor: pointer;\n        img{\n            width: 70%;\n        }\n    }\n\n}\n\n.dpzone-sec-title {\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 17px;\n    color: #676767;\n}\n\n.uploaded-item-error {\n    border-color: rgba(228, 29, 29, 1);\n}\n\n.upload-error-text {\n    font-size: 11px;\n    font-weight: 500;\n    color: rgba(228, 29, 29, 1);\n    margin-bottom: 0;\n}\n\n.uploading-status-show-outer {\n    .uploaded-item-name-box {\n        margin-bottom: 0;\n        border-color: rgba(227, 227, 227, 1);\n    }\n}\n\n.dpzone-upload-status-sec {\n    margin-bottom: 20px;\n}\n\n.dpzn-upload-scroll {\n    max-height: 130px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
